export default {
  cleanupReport: {
    title: "Esito della pulizia",
    intro: "Registra quanto è stato raccolto e chi ha partecipato.",
    wasteKg: "Rifiuti raccolti (kg)",
    itemsCount: "Oggetti raccolti",
    volunteersCount: "Volontari",
    diversCount: "Subacquei",
    disposalNotes: "Smaltimento",
    authorityNotified: "Autorità informata",
    notes: "Note",
    save: "Salva esito",
    saved: "Esito salvato",
    error: "Operazione non riuscita.",
  },
  customerNotes: {
    title: "Note sui clienti",
    intro: "Annotazioni riservate sul comportamento di un cliente, utili alla sicurezza delle uscite. Le vedono solo titolare, proprietario e responsabile.",
    warning: "Sono dati personali delicati: scrivi solo fatti, indica la base giuridica e la finalità. Ogni nota si cancella da sola alla scadenza e il cliente può chiederne copia o cancellazione.",
    disabled: "Questa funzione non è ancora attiva: richiede la valutazione d’impatto e l’informativa aggiornata.",
    loading: "Caricamento…",
    customer: "Cliente",
    chooseCustomer: "Scegli un cliente",
    forbidden: "Solo titolare, proprietario e responsabile possono consultare le note.",
    empty: "Nessuna nota per questo cliente.",
    expires: "scade il {{date}}",
    delete: "Elimina",
    add: "Nuova nota",
    note: "Nota",
    purpose: "Finalità",
    legalBasis: "Base giuridica",
    retentionDays: "Conservazione (giorni)",
    retentionHint: "Massimo 365 giorni; alla scadenza la nota viene cancellata.",
    save: "Salva nota",
    saved: "Nota salvata",
    error: "Operazione non riuscita.",
    basis_LEGITIMATE_INTEREST: "Legittimo interesse",
    basis_CONTRACT: "Esecuzione del contratto",
    basis_LEGAL_OBLIGATION: "Obbligo di legge",
  },
  careerEdu: {
    thDepth: "profondità ≥ {{value}} m",
    thVisibility: "visibilità ≤ {{value}} m",
    thTemp: "acqua ≤ {{value}} °C",
    thNight: "notturna",
    thWreck: "relitto",
    spTitle: "Immersioni in condizioni particolari",
    spThresholds: "Soglie dello standard",
    spNoThresholds: "Lo standard richiede {{required}} immersioni in condizioni particolari ma non ne definisce le soglie: il confronto non è possibile.",
    spProgress: "{{count}} di {{required}}",
    spStatus_MET: "Requisito raggiunto",
    spStatus_NOT_MET: "Requisito non ancora raggiunto",
    spStatus_UNKNOWN: "Non verificabile",
    ceTitle: "Formazione continua",
    ceIntro: "Registra corsi di aggiornamento e crediti. Se indichi la data del prossimo aggiornamento, riceverai gli avvisi di scadenza.",
    ceEmpty: "Nessun aggiornamento registrato.",
    ceTotalCredits: "Crediti registrati: {{count}}",
    ceCreditsShort: "{{count}} crediti",
    ceDue: "prossimo aggiornamento entro il {{date}}",
    ceDelete: "Elimina",
    ceName: "Corso o aggiornamento",
    ceProvider: "Ente o istruttore",
    ceCredits: "Crediti",
    ceCompletedAt: "Completato il",
    ceDueAt: "Prossimo aggiornamento entro",
    ceDueHint: "La data del prossimo aggiornamento entra nel registro delle scadenze.",
    ceAdd: "Aggiungi",
    ceSaved: "Aggiornamento registrato",
    ceError: "Operazione non riuscita.",
    ceOverdue: "scaduto",
    ceCvSummary: "{{count}} aggiornamenti · {{credits}} crediti",
    ceNextDue: "Prossima scadenza: {{date}}",
    ceOverdueCount: "{{count}} scaduti",
    ceCvTitle: "Formazione continua",
  },
  jurisdiction: {
    tab: "Giurisdizione",
    centerTitle: "Giurisdizione del centro",
    centerIntro: "Scegli la giurisdizione che regola il tuo centro. Le regole (liberatoria, certificato medico, maggiore età, segnasub, PLB, collaudo bombole, analisi nitrox) sono dati inseriti dall’amministratore della piattaforma.",
    choose: "Giurisdizione",
    activeRules: "Regole in vigore",
    noRulesYet: "Per questa giurisdizione non è ancora stata inserita nessuna regola.",
    shadowNote: "Le regole avvisano ma non bloccano: il blocco si attiva solo dopo la verifica.",
    notSet: "Non impostato",
    yes: "Sì",
    no: "No",
    saved: "Salvato",
    saveError: "Impossibile salvare",
    forbidden: "Solo titolare, proprietario e responsabile possono gestire la giurisdizione.",
    loading: "Caricamento…",
    loadError: "Impossibile caricare le giurisdizioni.",
    adminTitle: "Regole per giurisdizione",
    adminSubtitle: "Valori di legge per Paese, usati come dati dai controlli di conformità dei centri.",
    adminWarning: "Inserisci solo valori verificati da chi ha la competenza giuridica. Un campo vuoto significa nessuna regola.",
    edit: "Modifica",
    addJurisdiction: "Aggiungi giurisdizione",
    code: "Codice",
    label: "Nome",
    notes: "Note",
    save: "Salva",
    cancel: "Annulla",
    waiverValidityDays: "Validità liberatoria (giorni)",
    medicalCertValidityMonths: "Validità certificato medico (mesi)",
    adultAgeYears: "Maggiore età (anni)",
    diverFlagRequired: "Segnasub obbligatorio",
    plbRequired: "PLB obbligatorio",
    cylinderInspectionMonths: "Collaudo bombole (mesi)",
    nitroxAnalysisRequired: "Analisi nitrox obbligatoria",
  },
  auto: {
    componentsBiologycenterBioCenterOnboarding: {
      centroDiBiologiaMarina: "Centro di Biologia Marina",
      benvenutoNel: "Benvenuto nel",
      saltaIntroduzione: "Salta introduzione",
    },
    componentsBiologycenterContributionProgressBar: {
      prossimoTraguardo: "Prossimo traguardo",
      iniziaIlTuoPercorsoDaNaturalista: "Inizia il tuo percorso da naturalista!",
      identificaUnaSpecieOGeneraUn: "Identifica una specie o genera un report per sbloccare la tua prima attività.",
    },
    componentsCookieBanner: {
      privacyPolicy: "Privacy policy",
    },
    componentsDashboardDiverGrowthSection: {
      allenatiOggi: "Allenati oggi",
      scopriQuantoSeiProntoPerLa: "Scopri quanto sei pronto per la prossima immersione e cresci come subacqueo con eDive.",
      ilTuoProssimoPasso: "Il tuo prossimo passo",
      traUnImmersioneELAltra: "Tra un'immersione e l'altra, tieni pronti respiro, skill e sicurezza — un po' alla volta.",
      sempreProntoPerIlMare: "Sempre pronto per il mare",
    },
    componentsDashboardFreediverGrowthSection: {
      allenatiOggi: "Allenati oggi",
      haiUnBrevettoFreedivingAggiungiloAl: "Hai un brevetto freediving? Aggiungilo al tuo profilo",
      ilTuoProssimoPasso: "Il tuo prossimo passo",
      unRespiroAllaVoltaAllenaTecnica: "Un respiro alla volta: allena tecnica, calma e controllo, ogni giorno.",
      ilTuoPercorsoDaApneista: "Il tuo percorso da Apneista",
    },
    componentsDashboardGrowthPathSection: {
      ilTuoProssimoPasso: "Il tuo prossimo passo",
      unPassoAllaVoltaNuoviBrevetti: "Un passo alla volta: nuovi brevetti, nuove abilità, nuove esperienze da vivere.",
      ilTuoPercorsoDiCrescita: "Il tuo percorso di crescita",
    },
    componentsDashboardProGrowthSection: {
      cosaPuoiCostruireConIlTuo: "Cosa puoi costruire con il tuo ruolo — un passo alla volta, insieme alla community.",
      ilTuoPercorsoSuEdive: "Il tuo percorso su eDive",
    },
    componentsEmergencyPanel: {
      nascondiBanner: "Nascondi banner",
      checkInAttivo: "Check-in attivo",
    },
    componentsErrorBoundary: {
      nonEColpaTuaRiprovaOppure: "Non è colpa tua. Riprova, oppure torna alla dashboard: i tuoi dati sono al sicuro.",
      ciScusiamoQuiQualcosaSiE: "Ci scusiamo, qui qualcosa si è inceppato",
    },
    componentsFaunaReportFAB: {
      comportamentoColoreDimensioniNumeroDiEsemplari: "Comportamento, colore, dimensioni, numero di esemplari…",
      note: "Note",
      esTorreGuacetoIsolaDElba: "es. Torre Guaceto, Isola d'Elba, Capo Caccia…",
      sitoLocalita: "Sito / Località",
      es12: "es. 12",
      profonditaM: "Profondità (m)",
      data: "Data",
      esCerniaBrunaOppurePesceRosso: "es. \"Cernia bruna\" oppure \"pesce rosso con pinne lunghe\"",
      seSconosciutaDescriviLAspetto: "· se sconosciuta, descrivi l'aspetto",
      caricamentoInCorso: "Caricamento in corso…",
      anteprima: "Anteprima",
      jpegPngWebpMax50Mb: "JPEG / PNG / WEBP · max 50 MB",
      scattaOCaricaUnaFoto: "Scatta o carica una foto",
      consigliataPerLaClassificazione: "(consigliata per la classificazione)",
      segnalaAvvistamento: "Segnala avvistamento",
      segnalaAvvistamentoFauna: "Segnala avvistamento fauna",
      fotoTroppoGrandeMax50Mb: "Foto troppo grande (max 50 MB)",
      avvistamentoRegistratoSaraRevisionatoDalCentro: "Avvistamento registrato! Sarà revisionato dal centro di biologia marina.",
      leSpecieNonIdentificateVengonoInviate: "Le specie non identificate vengono inviate al centro di biologia marina per classificazione.",
    },
    componentsFeaturedDivesCarousel: {
      successivo: "Successivo",
      precedente: "Precedente",
      divingInEvidenza: "Diving in evidenza",
      prossimeImmersioni: "Prossime immersioni",
      inEvidenza: "🤿 In evidenza",
    },
    componentsMediaContributeWizard: {
      inviataAllaRevisione: "Inviata alla revisione!",
      inviaAllEnciclopedia: "Invia all'enciclopedia",
      invio: "Invio…",
      nonPotraEssereEliminata: "non potrà essere eliminata",
      contributoPermanente: "Contributo permanente",
      comportamentoOsservatoCondizioniVisibilitaTemperatura: "Comportamento osservato, condizioni visibilità, temperatura…",
      noteAggiuntive: "Note aggiuntive",
      esPortofinoSeccaDiDaino: "es. Portofino, Secca di Daino",
      luogoSitoDiImmersione: "Luogo / Sito di immersione",
      profonditaM: "Profondità (m)",
      specieIdentificata: "Specie identificata",
      asset: "asset",
      contribuisciAllEnciclopedia: "Contribuisci all'Enciclopedia",
      ilTeamDelCentroDiBiologia: "Il team del centro di biologia marina esaminerà la tua immagine.",
      confermoDiEssereIlTitolareDel: "Confermo di essere il titolare del copyright di questa immagine e autorizzo eDive a pubblicarla",
      iDatiMostratiSopraSarannoInclusi: "I dati mostrati sopra saranno inclusi nella scheda enciclopedica.",
    },
    componentsMediaGoProImportModal: {
      annulla: "Annulla",
      nessunMediaTrovatoNelCloudGopro: "Nessun media trovato nel cloud GoPro.",
      connettiAccountGopro: "Connetti account GoPro",
      env: ".env",
      configurazioneRichiesta: "Configurazione richiesta",
      importaDaGopro: "Importa da GoPro",
      caricamentoMediaGopro: "Caricamento media GoPro…",
      accediAlTuoGoproPlusPer: "Accedi al tuo GoPro Plus per importare foto e video direttamente nel logbook.",
    },
    componentsMediaUploadIdentifyWizard: {
      salvataNellaLibreria: "Salvata nella libreria!",
      preview: "preview",
      analisiInCorsoConInaturalist: "Analisi in corso con iNaturalist…",
      jpgPngWebpMax50Mb: "JPG, PNG, WEBP · max 50 MB",
      trascinaQuiOCliccaPerScegliere: "Trascina qui o clicca per scegliere",
      caricaIdentifica: "Carica & Identifica",
      soloImmagini: "Solo immagini",
      identificazioneNonDisponibilePuoiProcedereManualmente: "Identificazione non disponibile. Puoi procedere manualmente.",
      caricamentoFallitoRiprova: "Caricamento fallito. Riprova.",
      score: "score",
      lImmagineENellaTuaLibreria: "L'immagine è nella tua libreria privata. Potrai contribuirla all'enciclopedia quando vuoi.",
      ilSistemaDiComputerVisionAnalizza: "Il sistema di computer vision analizza la morfologia della specie",
      caricaUnaFotoSubacqueaInaturalistLa: "Carica una foto subacquea — iNaturalist la identificherà automaticamente",
    },
    componentsMedicalParticipantEmergencyCard: {
      farmaci: "Farmaci",
      allergie: "Allergie",
      certificatoScaduto: "certificato scaduto",
      schedaNonDisponibile: "Scheda non disponibile",
      caricamentoScheda: "Caricamento scheda…",
      schedaEmergenza: "Scheda emergenza",
    },
    componentsOffersOffersForYou: {
      offertePerTe: "Offerte per te",
      riservataATe: "Riservata a te",
    },
    componentsOfflineBanner: {
      seiOfflineLeModificheVerrannoSincronizzate: "Sei offline — le modifiche verranno sincronizzate alla riconnessione",
    },
    componentsOnboardingReconciliationPrompt: {
      nonEStatoPossibileCollegareLa: "Non è stato possibile collegare la scheda. Riprova più tardi.",
      siSonoIo: "Sì, sono io",
      risultaGiaUnaSchedaAQuesto: "Risulta già una scheda a questo nome nella nostra anagrafica. Se sei tu, la colleghiamo",
    },
    componentsSignaturePad: {
      firmaNelloSpazioSopra: "Firma nello spazio sopra",
      confermaFirma: "Conferma firma",
      cancella: "Cancella",
    },
    componentsUiAddToCalendarButton: {
      scaricaFileIcsAppleCalendarOutlook: "Scarica file .ics (Apple Calendar, Outlook)",
      aggiungiAGoogleCalendar: "Aggiungi a Google Calendar",
      googleCal: "Google Cal",
    },
    componentsUiBadgeCard: {
      nascostoAgliUtenti: "Nascosto agli utenti",
    },
    componentsUiCatalogPicker: {
      annulla: "Annulla",
      modello: "Modello *",
      marca: "Marca *",
      proponiUnProdottoMancanteSaraRevisionato: "Proponi un prodotto mancante (sarà revisionato da un admin; puoi già usarlo nella tua attrezzatura).",
      proponiQuestoProdotto: "Proponi questo prodotto",
      ricerca: "Ricerca…",
      cercaMarcaOModelloEsScubapro: "Cerca marca o modello (es. Scubapro MK25)…",
      scegliDalCatalogo: "Scegli dal catalogo",
      erroreNellInvioDellaProposta: "Errore nell'invio della proposta",
      grazieLaVoceEStataProposta: "Grazie! La voce è stata proposta e sarà revisionata da un amministratore.",
      nonLoTroviProponiUnProdotto: "Non lo trovi? Proponi un prodotto",
    },
    componentsUiMultiSelectDropdown: {
      fatto: "Fatto",
      nessunRisultato: "Nessun risultato",
      cerca: "Cerca…",
      azzera: "Azzera",
    },
    componentsUiPayButton: {
      configurazionePagamentoMancante: "Configurazione pagamento mancante",
      iPagamentiOnlineNonSonoAttivi: "I pagamenti online non sono attivi per questo centro",
      pagamentiNonAttivi: "Pagamenti non attivi",
    },
    componentsUiSerialScanButton: {
      numeroSerialeNonRilevatoProvaCon: "Numero seriale non rilevato. Prova con una foto più nitida.",
      analisiAiInCorso: "Analisi AI in corso…",
      scansionaNumeroSerialeConFotocamera: "Scansiona numero seriale con fotocamera",
    },
    componentsUiSignatureCanvas: {
      firmaQui: "Firma qui",
      cancella: "Cancella",
      annulla: "Annulla",
    },
    componentsUiSuitPicker: {
      modelloSpessore: "Modello / spessore",
      marca: "Marca",
      tipiStandard: "Tipi standard",
      laMiaAttrezzatura: "La mia attrezzatura",
      seleziona: "— seleziona —",
      erroreNelSalvataggioDellaMuta: "Errore nel salvataggio della muta",
      mutaAggiuntaAllAttrezzatura: "Muta aggiunta all'attrezzatura",
      aggiungiUnaMuta: "Aggiungi una muta",
    },
    componentsWaiverDiveWaiverModal: {
      confermaEFirmaDigitale: "Conferma e firma digitale",
      esoneroDiResponsabilita: "Esonero di responsabilità",
      specificareAllergie: "Specificare allergie...",
      specificareFarmaci: "Specificare farmaci...",
      dichiarazioneMedica: "Dichiarazione medica",
      datiDelSubacqueo: "Dati del subacqueo",
      moduloDiAutorizzazionePreImmersione: "Modulo di Autorizzazione Pre-Immersione",
      anteprimaPdf: "Anteprima PDF",
      laFirmaDigitaleVerraRegistrataCon: "La firma digitale verrà registrata con data, ora e indirizzo IP del dispositivo.",
      leggiEAccettaLeDichiarazioniSeguenti: "Leggi e accetta le dichiarazioni seguenti per completare l'autorizzazione.",
    },
    componentsWaiverPDF: {
      trattamentoDatiPersonaliGdpr: "Trattamento Dati Personali (GDPR)",
      firmaDelPartecipante: "Firma del partecipante",
      firmaDigitale: "Firma Digitale",
      datiPartecipante: "Dati Partecipante",
      dichiarazioneELiberatoria: "Dichiarazione e Liberatoria",
      liberatoriaDiResponsabilita: "Liberatoria di Responsabilità",
      ilPartecipanteRiconosceCheLImmersione: "Il partecipante riconosce che l'immersione subacquea è un'attività che comporta rischi intrinseci",
      ilPartecipanteDichiaraDiEssereIn: "Il partecipante dichiara di essere in buona salute e di non soffrire di patologie che potrebbero",
    },
    embedBookingWidget: {
      email: "Email",
      ediveBooking: "eDive Booking",
    },
    layoutsAuthLayout: {
      tech: ".tech",
      ediveBanner: "eDive banner",
      ediveLogo: "eDive logo",
      chiUsaEdiveTech: "Chi usa eDive.tech",
      technologyForTheOcean: "Technology for the Ocean",
    },
    layoutsPublicLayout: {
      madeWithInItaly: "Made with 🤿 in Italy",
      tech: ".tech",
      app: "App",
      tornaAllApp: "Torna all'app",
      laPiattaformaAllInOnePer: "La piattaforma all-in-one per la community subacquea italiana e internazionale.",
      tornaAllAreaPrivata: "Torna all'area privata",
    },
    pagesAdminAdminCertificationsPage: {
      brevettoNomeOCodice: "Brevetto (nome o codice)",
      didatticaEnteEsPadi: "Didattica / Ente (es. PADI)",
      cognome: "Cognome",
      nome: "Nome",
      erroreEliminazione: "Errore eliminazione",
      richiestaEliminata: "Richiesta eliminata",
      erroreDuranteIlCambioStato: "Errore durante il cambio stato",
      statoBrevettoAggiornato: "Stato brevetto aggiornato",
      noDoc: "No doc",
      azioni: "Azioni",
      documento: "Documento",
      inviataIl: "Inviata il",
      statoPolizza: "Stato polizza",
      scadenza: "Scadenza",
      nPolizza: "N° polizza",
      istruttore: "Istruttore",
      l702026Art11: "L.70/2026 Art. 11",
      tuttiGliIstruttoriConRcCaricata: "Tutti gli istruttori con RC caricata sono già verificati.",
      nessunaRcAssicurazioneInAttesaDi: "Nessuna RC assicurazione in attesa di verifica",
      caricamento: "Caricamento…",
      erroreDuranteLaVerifica: "Errore durante la verifica",
      minimo10Caratteri: "Minimo 10 caratteri",
      inserisciIlMotivoDelRifiutoMin: "Inserisci il motivo del rifiuto (min. 10 caratteri)",
      motivoDelRifiuto: "Motivo del rifiuto *",
      corrente: "corrente",
      cambiaStatoBrevetto: "Cambia stato brevetto",
      minimo10CaratteriRichiesti: "Minimo 10 caratteri richiesti",
      wizardVerifica: "Wizard verifica",
      apriDoc: "Apri doc",
    },
    pagesAdminAdminDoctorVerificationPage: {
      medico: "Medico",
      nessunMedicoInQuestoStato: "Nessun medico in questo stato.",
      controllaIlDocumentoDiAbilitazioneE: "Controlla il documento di abilitazione e approva o rifiuta le credenziali. Solo i medici verificati possono rendere pubblico il profilo.",
      verificaMediciSubacquei: "Verifica medici subacquei",
      nessunDocumentoDisponibile: "Nessun documento disponibile",
      errore: "Errore",
      richiestaRifiutata: "Richiesta rifiutata",
      medicoVerificato: "Medico verificato",
      verifica: "Verifica",
      rifiuta: "Rifiuta",
      vediDocumento: "Vedi documento",
    },
    pagesAdminAdminEquipmentCataloguePage: {
      azioni: "Azioni",
      obbligatorio: "Obbligatorio",
      intervallo: "Intervallo",
      tipoManutenzione: "Tipo manutenzione",
      categoria: "Categoria",
      nessunTemplate: "Nessun template",
      caricamento: "Caricamento…",
      scheda: "Scheda",
      peso: "Peso",
      proposto: "Proposto",
      oraCatalogo: "Ora (catalogo)",
      nessunArricchimentoInAttesaDiRevisione: "Nessun arricchimento in attesa di revisione",
      fontiAperte: "fonti aperte",
      codice: "Codice",
      marcaModelloProposto: "Marca / Modello proposto",
      nessunaPropostaInAttesaDiRevisione: "Nessuna proposta in attesa di revisione",
      stato: "Stato",
      fasciaPrezzo: "Fascia prezzo",
      marcaModello: "Marca / Modello",
      nessunProdottoTrovato: "Nessun prodotto trovato",
      tutteLeCategorie: "Tutte le categorie",
      cercaMarcaOModello: "Cerca marca o modello…",
      gestisciIlCatalogoProdottiLeProposte: "Gestisci il catalogo prodotti, le proposte degli utenti e i template di manutenzione",
      catalogoAttrezzatura: "Catalogo Attrezzatura",
      erroreNellaRevisione: "Errore nella revisione",
      errore: "Errore",
      templateEliminato: "Template eliminato",
      erroreEliminazione: "Errore eliminazione",
      eliminato: "Eliminato",
      erroreSalvataggio: "Errore salvataggio",
      prodottoSalvato: "Prodotto salvato",
      salva: "Salva",
      annulla: "Annulla",
      noteManutenzione: "Note manutenzione",
      prezzoMax: "Prezzo max (€)",
      prezzoMin: "Prezzo min (€)",
      esSp001: "Es. SP001",
      esMk25Evo: "Es. MK25 EVO",
      modello: "Modello",
      esScubapro: "Es. Scubapro",
      produttore: "Produttore",
      scarta: "Scarta",
      applica: "Applica",
      rifiuta: "Rifiuta",
      approva: "Approva",
      aggiungiProdotto: "Aggiungi prodotto",
    },
    pagesAdminAdminEquipmentOverduePage: {
      dettaglio: "Dettaglio",
      primaScadenza: "Prima scadenza",
      inScadenza: "In scadenza",
      scadute: "Scadute",
      utente: "Utente",
      nessunaAttrezzaturaScadutaOInScadenza: "Nessuna attrezzatura scaduta o in scadenza",
      utentiCoinvolti: "Utenti coinvolti",
      caricamento: "Caricamento…",
      panoramicaCrossUtenteDelleAttrezzatureCon: "Panoramica cross-utente delle attrezzature con manutenzione scaduta o in scadenza",
      attrezzaturaManutenzioniScadute: "Attrezzatura — Manutenzioni Scadute",
      erroreNelCaricamentoDelReportVerifica: "Errore nel caricamento del report. Verifica di essere autenticato come admin.",
    },
    pagesAdminAdminGdprProcessingRecordsPage: {
      paesiTerzi: "⚠ Paesi Terzi",
      dpia: "DPIA ✓",
      ilRegistroArt30EObbligatorio: "Il registro Art.30 è obbligatorio — aggiungere almeno le attività principali",
      nessunaAttivitaDiTrattamentoRegistrata: "Nessuna attività di trattamento registrata",
      caricamento: "Caricamento…",
      annulla: "Annulla",
      encryptionPseudonymizationAccessControl: "ENCRYPTION, PSEUDONYMIZATION, ACCESS_CONTROL",
      misureTecnicheSeparatiDaVirgola: "Misure tecniche (separati da virgola)",
      esServizioMedicoAutoritaCompetenti: "es. Servizio medico, Autorità competenti",
      destinatariSeparatiDaVirgola: "Destinatari (separati da virgola)",
      subacqueiIstruttoriSoci: "SUBACQUEI, ISTRUTTORI, SOCI",
      interessatiSeparatiDaVirgola: "Interessati (separati da virgola)",
      identificativiSanitariFinanziari: "IDENTIFICATIVI, SANITARI, FINANZIARI",
      categorieDiDatiSeparatiDaVirgola: "Categorie di dati (separati da virgola)",
      esGestioneIscrizioniCorsiSubacqueiE: "es. Gestione iscrizioni corsi subacquei e verifica requisiti tecnici",
      finalitaDelTrattamento: "Finalità del trattamento *",
      es3650: "es. 3650",
      retentionGiorni: "Retention (giorni)",
      baseGiuridica: "Base giuridica *",
      esAwsSendgrid: "es. AWS, Sendgrid...",
      responsabileEsternoSePresente: "Responsabile esterno (se presente)",
      titolareDelTrattamento: "Titolare del trattamento",
      esGestionePrenotazioniImmersioni: "es. Gestione prenotazioni immersioni",
      nomeAttivita: "Nome attività *",
      gdprArt30: "GDPR Art. 30",
      obbligatorioPerOrganizzazioniCheTrattanoDati: "Obbligatorio per organizzazioni che trattano dati sanitari",
      registroTrattamentiGdprArt30: "Registro Trattamenti — GDPR Art.30",
      errore: "Errore",
      attivitaDisattivata: "Attività disattivata",
      erroreNelSalvataggio: "Errore nel salvataggio",
      attivitaAggiornata: "Attività aggiornata",
      attivitaDiTrattamentoAggiunta: "Attività di trattamento aggiunta",
      disattivata: "Disattivata",
      attiva: "Attiva",
      nuovaAttivita: "Nuova attività",
    },
    pagesAdminAdminGdprRetentionPage: {
      perLeModificheUrgentiUsaEsegui: "Per le modifiche urgenti usa \"Esegui Job Manuale\".",
      getV1GdprRetentionPolicies: "GET /v1/gdpr/retention-policies",
      lePolicySonoConsultabiliDaTutti: "Le policy sono consultabili da tutti i servizi tramite",
      laCancellazioneCrossServiceLogbookKyc: "La cancellazione cross-service (logbook, KYC, chat) è gestita dal consumer GDPR di ciascun servizio tramite i topic Kafka.",
      autoDeleteAbilitato: "AUTO-DELETE abilitato",
      ilJobNotturnoEsegueAutomaticamenteOgni: "Il job notturno esegue automaticamente ogni 24 ore solo per le categorie con",
      noteOperative: "ℹ️ Note operative",
      usaCaricaPolicyDefaultPerIniziare: "Usa \"Carica Policy Default\" per iniziare con i valori consigliati.",
      nessunaPolicyConfigurata: "Nessuna policy configurata.",
      caricamento: "Caricamento...",
      annulla: "Annulla",
      descrizioneDelTipoDiDati: "Descrizione del tipo di dati...",
      descrizione: "Descrizione",
      esObbligoLegaleDLgs81: "es. Obbligo legale — D.Lgs.81/2008 Art.53",
      baseGiuridicaArt6Gdpr: "Base Giuridica (Art.6 GDPR) *",
      durataConservazioneGiorni: "Durata Conservazione (giorni) *",
      esLogbookDives: "es. LOGBOOK_DIVES",
      categoriaDati: "Categoria Dati *",
      politicheDiConservazioneDati: "Politiche di Conservazione Dati",
      compilaTuttiICampiObbligatori: "Compila tutti i campi obbligatori",
      erroreDuranteLaDisattivazione: "Errore durante la disattivazione",
      policyDisattivata: "Policy disattivata",
      erroreDuranteLAggiornamento: "Errore durante l'aggiornamento",
      policyAggiornata: "Policy aggiornata",
      erroreDuranteLaCreazione: "Errore durante la creazione",
      policyCreata: "Policy creata",
      erroreDuranteIlJobDiRetention: "Errore durante il job di retention",
      erroreDuranteIlSeed: "Errore durante il seed",
      laCancellazioneAutomaticaElimineraODisattivera: "La cancellazione automatica eliminerà o disattiverà i record scaduti durante il job notturno.",
      cancellazioneAutomaticaAbilitata: "Cancellazione automatica abilitata",
    },
    pagesAdminAdminHubPage: {
      tutteLeFunzioniAmministrativeOrganizzatePer: "Tutte le funzioni amministrative, organizzate per area.",
    },
    pagesAdminAdminInatStagingPage: {
      nessunElementoTrovato: "Nessun elemento trovato.",
      dettagli: "Dettagli",
      importa: "Importa",
      rifiuta: "Rifiuta",
      approva: "Approva",
      azioni: "Azioni",
      arricchimento: "Arricchimento",
      tipo: "Tipo",
      osserv: "Osserv.",
      qualita: "Qualità",
      stato: "Stato",
      specie: "Specie",
      foto: "Foto",
      soloCorrispondenze: "Solo corrispondenze",
      soloNuoveSpecie: "Solo nuove specie",
      tutteLeSpecie: "Tutte le specie",
      falliti: "Falliti",
      arricchiti: "Arricchiti",
      daArricchire: "Da arricchire",
      tuttiGliArricchimenti: "Tutti gli arricchimenti",
      scaduti: "Scaduti",
      importati: "Importati",
      rifiutati: "Rifiutati",
      approvati: "Approvati",
      inAttesa: "In attesa",
      tuttiGliStati: "Tutti gli stati",
      syncFallito: "Sync fallito",
      syncInCorso: "Sync in corso...",
      erroreApprovazioneMassiva: "Errore approvazione massiva",
      erroreImportazione: "Errore importazione",
      erroreRifiuto: "Errore rifiuto",
      rifiutato: "Rifiutato",
      erroreApprovazione: "Errore approvazione",
      approvato: "Approvato",
      erroreAvvioSincronizzazione: "Errore avvio sincronizzazione",
      sincronizzazioneAvviata: "Sincronizzazione avviata",
      noteDiRifiutoOpzionale: "Note di rifiuto (opzionale)...",
      statoIucn: "Stato IUCN",
      datiFishbase: "Dati FishBase",
      statisticheInaturalist: "Statistiche iNaturalist",
      nessunaModificaDaApplicare: "Nessuna modifica da applicare",
      campiDaAggiornare: "Campi da aggiornare",
      campiDaAggiungere: "Campi da aggiungere",
      avviaUnaSincronizzazionePerImportareSpecie: "Avvia una sincronizzazione per importare specie da iNaturalist.",
      revisioneEImportazioneDelleSpecieMarine: "Revisione e importazione delle specie marine da iNaturalist nell'enciclopedia eDive",
      importStagingInaturalist: "Import Staging iNaturalist",
      modificheAllEnciclopedia: "Modifiche all'enciclopedia",
      nuovaSpecie: "Nuova specie",
    },
    pagesAdminAdminInatTokenPage: {
      incollaQuiIlTokenJwtEyjhbgci: "Incolla qui il token JWT (eyJhbGci...)",
      incollaloNelCampoQuiSottoE: "Incollalo nel campo qui sotto e salva",
      dalJsonRestituito: "dal JSON restituito",
      apiToken: "api_token",
      copiaIlValore: "Copia il valore",
      faiLoginConLeCredenzialiEdive: "Fai login con le credenziali eDive",
      inUnaFinestraInIncognito: "in una finestra in incognito",
      apri: "Apri",
      aggiornaToken: "Aggiorna token",
      sorgente: "Sorgente",
      scadeIl: "Scade il",
      stato: "Stato",
      impossibileRecuperareLoStatoDelToken: "Impossibile recuperare lo stato del token.",
      statoAttuale: "Stato attuale",
      tokenInaturalist: "Token iNaturalist",
      ilTokenVieneSalvatoInRedis: "Il token viene salvato in Redis con TTL automatico pari alla sua scadenza naturale.",
      tokenAggiornatoConSuccessoIlServizio: "Token aggiornato con successo. Il servizio di riconoscimento specie userà il nuovo token immediatamente.",
      caricamento: "Caricamento…",
      scaduto: "Scaduto",
    },
    pagesAdminAdminIntegrationsPage: {
      impossibileRecuperareLElencoDelleIntegrazioni: "Impossibile recuperare l'elenco delle integrazioni.",
      ultime100ChiamateConservate30Giorni: "Ultime 100 chiamate, conservate 30 giorni. Nessuna chiave compare nel log.",
      dettaglio: "Dettaglio",
      tempo: "Tempo",
      esito: "Esito",
      operazione: "Operazione",
      servizio: "Servizio",
      provider: "Provider",
      quando: "Quando",
      impossibileCaricareIlLog: "Impossibile caricare il log.",
      caricamento: "Caricamento…",
      tuttiIProvider: "Tutti i provider",
      filtraPerProvider: "Filtra per provider",
      logDiUtilizzo: "Log di utilizzo",
      modifica: "Modifica",
      gestisciToken: "Gestisci token",
      annulla: "Annulla",
      ultimaChiamata: "Ultima chiamata",
      uso24Ore: "Uso 24 ore",
      ultimoTest: "Ultimo test",
      valore: "Valore",
      daAmbienteSiRiferisceAllAmbiente: "«Da ambiente» si riferisce all'ambiente del servizio di identità: una chiave presente solo nell'ambiente di un altro",
      leChiaviDeiServiziEsterniChe: "Le chiavi dei servizi esterni che eDive chiama da solo: stato, test, modifica e registro d'uso.",
      integrazioniChiaviApi: "Integrazioni / Chiavi API",
      aggiorna: "Aggiorna",
    },
    pagesAdminAdminMerchPage: {
      segnaComeSpedito: "Segna come spedito",
      modificaStato: "Modifica stato",
      nessunOrdineTrovato: "Nessun ordine trovato",
      caricamento: "Caricamento…",
      gestisciOrdiniSpedizioniEPagamenti: "Gestisci ordini, spedizioni e pagamenti",
      ordiniShop: "Ordini Shop",
      erroreAggiornamento: "Errore aggiornamento",
      ordineAggiornato: "Ordine aggiornato",
      annulla: "Annulla",
      esIt123456789: "Es. IT123456789",
      trackingNumber: "Tracking number",
      stato: "Stato",
      salva: "Salva",
    },
    pagesAdminAdminMpaPage: {
      descrizione: "Descrizione",
      zonaProtetta: "Zona protetta",
      autorita: "Autorità",
      elimina: "Elimina",
      modifica: "Modifica",
      nessunaZonaTrovata: "Nessuna zona trovata",
      raggio: "Raggio",
      tipo: "Tipo",
      sito: "Sito",
      caricamentoZone: "Caricamento zone…",
      riferimentoEsterno: "Riferimento esterno",
      raggioM: "Raggio (m) *",
      longitudine: "Longitudine *",
      latitudine: "Latitudine *",
      tipoRestrizione: "Tipo Restrizione *",
      ispraMinisteroDellaCultura: "ISPRA, Ministero della Cultura…",
      autorita2: "Autorità *",
      nomeSito: "Nome Sito *",
      tuttiITipi: "Tutti i tipi",
      cercaPerNomeZonaOEnte: "Cerca per nome zona o ente gestore…",
      legge702026Art1314: "Legge 70/2026 art.13-14 — Gestione zone tutelate ISPRA / MiC",
      zoneMarineProtette: "Zone Marine Protette",
      coordinate: "Coordinate",
      nuovaZona: "+ Nuova Zona",
    },
    pagesAdminAdminPage: {
      manutenzioniScadute: "Manutenzioni scadute",
    },
    pagesAdminAdminPartyPage: {
      registroCentralizzatoDiPersoneEOrganizzazioni: "Registro centralizzato di persone e organizzazioni cross-servizio",
      partyAnagraficaUnica: "Party — Anagrafica Unica",
      catalogo: "Catalogo",
      gestito: "Gestito",
      creato: "Creato",
      stato: "Stato",
      fonte: "Fonte",
      paese: "Paese",
      tipo: "Tipo",
      nome: "Nome",
      aggiornamento: "aggiornamento…",
      nessunaOrganizzazioneTrovata: "Nessuna organizzazione trovata",
      caricamento: "Caricamento…",
      esNapoli: "es. Napoli",
      cittaArea: "Città / Area",
      nomeOrganizzazione: "Nome organizzazione…",
      iamUser: "IAM user",
      naz: "Naz.",
      ruoli: "Ruoli",
      nessunaPersonaTrovata: "Nessuna persona trovata",
      esRoma: "es. Roma",
      paeseIndirizzo: "Paese (indirizzo)",
      nazionalita: "Nazionalità",
      ruolo: "Ruolo",
      nomeCognome: "Nome, cognome…",
      cittaIndirizzoOLuogo: "Città, indirizzo o luogo…",
      entroRaggioDaUnPunto: "Entro raggio da un punto",
      rimuoviPunto: "Rimuovi punto",
      aziendeGestione: "Aziende — gestione",
      personeGestione: "Persone — gestione",
    },
    pagesAdminAdminReferralTreePage: {
      nonCiSonoAncoraCollegamentiDi: "Non ci sono ancora collegamenti di invito.",
      esploraLInteraStrutturaDiInvito: "Esplora l'intera struttura di invito generata sulla piattaforma",
      nomeMancante: "nome mancante",
      alberoReferral: "Albero referral",
      caricamentoAlbero: "Caricamento albero…",
      cercaPerNomeCodiceOId: "Cerca per nome, codice o ID",
      collegamenti: "Collegamenti",
      nessunaReteReferral: "Nessuna rete referral",
      radici: "Radici",
      utentiInRete: "Utenti in rete",
    },
    pagesAdminAdminServicesPage: {
      riprova: "Riprova",
      data: "Data",
      messaggio: "Messaggio",
      tipo: "Tipo",
      scheda: "Scheda",
      impossibileCaricareLeSegnalazioni: "Impossibile caricare le segnalazioni.",
      caricamento: "Caricamento…",
      segnalazioniUtenti: "Segnalazioni utenti",
      successiva: "Successiva",
      precedente: "Precedente",
      azioni: "Azioni",
      esiti: "Esiti",
      motivo: "Motivo",
      impossibileCaricareLaCodaDiRevisione: "Impossibile caricare la coda di revisione.",
      tutteLeCategorie: "Tutte le categorie",
      filtraPerCategoria: "Filtra per categoria",
      ignora: "Ignora",
      confermaAttiva: "Conferma attiva",
      presuntaChiusa: "· presunta chiusa",
      nessunLavoroAvviatoDallUltimoRiavvio: "Nessun lavoro avviato dall'ultimo riavvio del servizio.",
      lavoriRecenti: "Lavori recenti",
      giriManuali: "Giri manuali",
      ilLimiteDeveEssereUnIntero: "Il limite deve essere un intero tra 1 e 50.000.",
      nessunLimite: "nessun limite",
      codicePaese: "Codice paese",
      tutte: "Tutte",
      importaDaOpenstreetmap: "Importa da OpenStreetMap",
      importazioneAvviata: "Importazione avviata",
      risultato: "Risultato",
      nessunaSchedaAncora: "Nessuna scheda ancora.",
      verificaDelleSchedeNonArchiviate: "Verifica delle schede non archiviate",
      totale: "Totale",
      archiviate: "Archiviate",
      presunteChiuse: "Presunte chiuse",
      attive: "Attive",
      categoria: "Categoria",
      schedePerCategoria: "Schede per categoria",
      controlliGoogleDegliUltimi30Giorni: "(controlli Google degli ultimi 30 giorni)",
      nessunControlloAncora: "(nessun controllo ancora)",
      affidabilitaDeiDati: "Affidabilità dei dati",
      questoMese: "Questo mese",
      oggi: "Oggi",
      usoDiGoogle: "Uso di Google",
      nonConfigurata: "NON configurata",
      configurata: "Configurata",
      chiaveGooglePlaces: "Chiave Google Places",
      impossibileRecuperareLoStatoDeiServizi: "Impossibile recuperare lo stato dei servizi.",
      ospedaliCamereIperbaricheEGliAltri: "Ospedali, camere iperbariche e gli altri servizi utili ai subacquei: importazione da OpenStreetMap, verifica periodica",
      serviziGestioneAnagrafiche: "Servizi — gestione anagrafiche",
      unaSegnalazioneSiChiudeDecidendoSulla: "Una segnalazione si chiude decidendo sulla scheda nella coda «Da rivedere»: confermando o archiviando risulta risolta, ignorando risulta ignorata.",
      aggiorna: "Aggiorna",
      ilTettoGiornalieroMantieneLeChiamate: "Il tetto giornaliero mantiene le chiamate sotto la soglia gratuita: superato il tetto la verifica si ferma da sola.",
      senzaLaChiaveLaVerificaCon: "Senza la chiave la verifica con Google resta ferma. La piattaforma funziona lo stesso, con i dati di OpenStreetMap",
      gestisciLaChiave: "Gestisci la chiave",
    },
    pagesAdminAdminUsersPage: {
      ilServizioRichiedeConfigurazioneDelleCredenziali: "Il servizio richiede configurazione delle credenziali",
      whatsappNonConfigurato: "WhatsApp non configurato",
      scriviIlMessaggio: "Scrivi il messaggio...",
      tuttiISuoiContenuti: "tutti i suoi contenuti",
      definitivamente: "definitivamente",
      eliminaUtente: "Elimina utente",
      eliminaUtenteETuttiIContenuti: "Elimina utente e tutti i contenuti",
      reimpostaOnboardingWizard: "Reimposta onboarding wizard",
      impersonaUtente: "Impersona utente",
      gestisciRuoli: "Gestisci ruoli",
      modificaProfilo: "Modifica profilo",
      schedaAnagraficaCompleta: "Scheda anagrafica completa",
      senzaConsenso: "senza consenso",
      registrato: "Registrato",
      ruoli: "Ruoli",
      stato: "Stato",
      telefono: "Telefono",
      email: "Email",
      nome: "Nome",
      nessunUtenteTrovato: "Nessun utente trovato.",
      caricamento: "Caricamento...",
      sospesi: "Sospesi",
      inAttesaVerificaEmail: "In attesa verifica email",
      attivi: "Attivi",
      tuttiGliStati: "Tutti gli stati",
      nomeCognomeEmailTelefono: "Nome, cognome, email, telefono…",
      gestioneUtenti: "Gestione Utenti",
      erroreDuranteIlReset: "Errore durante il reset",
      onboardingReimpostatoImpersonaLUtenteE: "Onboarding reimpostato — impersona l'utente e naviga su /app/dashboard?reset-onboarding=1",
      eliminazioneGiaInCodaPerQuesto: "Eliminazione già in coda per questo utente.",
      eliminazioneAvviataIContenutiVerrannoRimossi: "Eliminazione avviata — i contenuti verranno rimossi entro pochi minuti.",
      assegnaRuoliInBlocco: "Assegna ruoli in blocco",
      selezionaAlmenoUnRuolo: "Seleziona almeno un ruolo",
      annulla: "Annulla",
      esDocumentazioneInsufficiente: "Es. Documentazione insufficiente...",
      motivazioneDelRifiutoOpzionale: "Motivazione del rifiuto (opzionale)",
      richiesteDiRuoloInAttesa: "Richieste di ruolo in attesa",
      vaiAllaPaginaDiConfigurazionePer: "Vai alla pagina di configurazione per inserire le credenziali e abilitare l'invio di messaggi.",
      inviaWhatsapp: "Invia WhatsApp",
      iRuoliEsistentiDegliUtentiSelezionati: "I ruoli esistenti degli utenti selezionati verranno sostituiti con quelli scelti.",
    },
    pagesAdminApproveCertificationWizard: {
      esDocumentoNonLeggibileBrevettoScaduto: "Es. Documento non leggibile, brevetto scaduto, dati non corrispondenti…",
      motivoDelRifiuto: "Motivo del rifiuto",
      rifiuta: "Rifiuta",
      approva: "Approva",
      scegliLEsitoDellaVerificaPer: "Scegli l'esito della verifica per",
      documentoBrevetto: "Documento brevetto",
      documentoCaricato: "Documento caricato",
      tutteLeRichiesteSonoStateElaborate: "Tutte le richieste sono state elaborate.",
      nessunaRichiestaInAttesa: "Nessuna richiesta in attesa",
      esaminaEApprovaLeRichiesteDi: "Esamina e approva le richieste di verifica",
      verificaBrevetto: "Verifica brevetto",
      lUtenteRiceveraUnaNotificaCon: "L'utente riceverà una notifica con l'esito della verifica.",
    },
    pagesAdminBadgeVisibilityPage: {
      apriLaPaginaInUnaNuova: "Apri la pagina in una nuova scheda",
      nessunBadgeCorrispondeAllaRicerca: "Nessun badge corrisponde alla ricerca.",
      cercaPerNomeFunzionalitaOIndirizzo: "Cerca per nome, funzionalità o indirizzo…",
      nascondiAgliUtentiLeFunzionalitaNon: "Nascondi agli utenti le funzionalità non ancora mature; riabilitale quando sono pronte. Tu (amministratore) vedi sempre tutti i badge, con l'etichetta «Nascosto» su quelli non visibili agli utenti.",
      visibilitaDeiBadge: "Visibilità dei badge",
      operazioneNonRiuscita: "Operazione non riuscita",
      ilControlloAgisceSullaRottaDel: "Il controllo agisce sulla rotta del badge: nasconderlo qui lo rimuove per gli utenti in",
    },
    pagesAdminCrmAttivitaSquadra: {
      statisticheNonDisponibili: "Statistiche non disponibili.",
      caricamento: "Caricamento…",
      chiHaFattoCosa: "Chi ha fatto cosa",
      nessunaAttivitaRegistrataNelPeriodo: "nessuna attività registrata nel periodo",
      automatismiNonELavoroDiUna: "Automatismi — non è lavoro di una persona",
      nessunaPersonaHaRegistratoAttivitaIn: "Nessuna persona ha registrato attività in questo periodo.",
    },
    pagesAdminCrmCrmContactDetailPage: {
      userIdEdive: "User ID eDive...",
      inserisciIdManualmente: "Inserisci ID manualmente",
      questoContattoEUnCandidatoPer: "Questo contatto è un candidato per un invito di registrazione.",
      cercaUnUtenteEdiveRegistratoDa: "Cerca un utente eDive registrato da associare a questo contatto, oppure inserisci manualmente l'ID.",
      completaIDati: "Completa i dati →",
      nazione: "Nazione",
      citta: "Città",
      ragioneSociale: "Ragione sociale",
      erroreDuranteLaPubblicazioneNellaDirectory: "Errore durante la pubblicazione nella directory",
      rimuoviAssociazione: "Rimuovi associazione",
      apriContatto: "Apri contatto",
      whatsapp: "WhatsApp",
      ruoloEsDirettoreReferenteCommerciale: "Ruolo (es. Direttore, Referente commerciale)…",
      associazioneAggiunta: "Associazione aggiunta",
      nessunUtenteTrovato: "Nessun utente trovato",
      cercaUtenteEdive: "Cerca utente eDive...",
      utenteAssociato: "Utente associato",
      descrizioneContenutoDellInterazione: "Descrizione / contenuto dell'interazione...",
      annullaRicerca: "Annulla ricerca",
      inviaInvitoEmail: "Invia invito email",
      pubblicaQuestoDivingNellaDirectoryPubblica: "Pubblica questo diving nella directory pubblica di eDive. Sarà visibile a tutti gli utenti anche prima che diventi cliente. Quando si registra potrà reclamare il profilo.",
      directoryPubblica: "Directory pubblica",
    },
    pagesAdminCrmCrmEnrichPage: {
      velocita40ContattiMinutoLimiteDuckduckgo: "Velocità: ~40 contatti/minuto (limite DuckDuckGo)",
      ogniContattoVieneRiarricchitoAutomaticamenteOgni: "Ogni contatto viene riarricchito automaticamente ogni 30 giorni",
      mostraInTempoRealeOgniContatto: "Mostra in tempo reale ogni contatto arricchito e i campi aggiunti",
      siFermaQuandoRaggiungeLObiettivo: "Si ferma quando raggiunge l'obiettivo di arricchimento, oppure quando non ci sono più contatti da valutare",
      valutaIContattiUnoPerUno: "Valuta i contatti uno per uno tramite ricerca DuckDuckGo",
      punteggio: "Punteggio",
      arricchiti: "Arricchiti",
      obiettivoArricchimento: "Obiettivo arricchimento",
    },
    pagesAdminCrmCrmOsmImportPage: {
      avvio: "Avvio…",
      importaPortogalloTutteLeCategorie: "🇵🇹 Importa Portogallo — tutte le categorie",
      importaMercatoItalianoMondiale: "🌍 Importa mercato italiano mondiale",
      erroreDuranteLAvvioDellImportazione: "Errore durante l'avvio dell'importazione",
      web: "Web",
      tel: "Tel",
      email: "Email",
      dati: "Dati",
      citta: "Città",
      nome: "Nome",
      aggiornamentoOgni3sRateLimitOverpass: "Aggiornamento ogni 3s · rate-limit Overpass API",
      aggiornamentoOgni3sVelocita5sPer: "Aggiornamento ogni 3s · velocità ~5s per paese (rate-limit Overpass)",
      paeseCitta: "Paese / Città",
      cliccaPerAssegnareAutomaticamenteLaSorgente: "Clicca per assegnare automaticamente la sorgente \"OSM / Directory\" ai contatti già importati.",
      sitiDiImmersioniDivingCenterOspedali: "Siti di immersioni, diving center, ospedali, istruttori, piscine — dati da OpenStreetMap",
      recuperoStatoImportazione: "Recupero stato importazione…",
      jobScadutoRilanciaLImportazionePer: "Job scaduto — rilancia l'importazione per un nuovo aggiornamento.",
    },
    pagesAdminCrmCrmOutreachPage: {
      senzaRecapito: "Senza recapito",
      daSollecitare: "Da sollecitare",
      daContattare: "Da contattare",
      messaggio: "Messaggio",
      comeTiPresentiAlTelefono: "come ti presenti al telefono",
      ilTuoNome: "Il tuo nome",
      campagna: "Campagna",
      ilMessaggioLoMandiTuCon: "Il messaggio lo mandi tu con un click: qui trovi il testo pronto e chi resta da contattare",
      outreachWhatsapp: "Outreach WhatsApp",
      nonSonoRiuscitoARegistrareL: "Non sono riuscito a registrare l'invio",
      segnatoComeInviato: "Segnato come inviato",
      davveroInviato: "davvero inviato",
      testoCopiato: "Testo copiato",
      haChiestoDiNonEssereContattato: "· ha chiesto di non essere contattato",
      nessunRecapitoInAnagraficaVaTrovato: "Nessun recapito in anagrafica — va trovato, non è \"fatto\"",
      nonSonoContattiChiusiMancaIl: "Non sono contatti chiusi: manca il numero. Vanno cercati, altrimenti la campagna sembra",
      pocheAllaVoltaEAUn: "Poche alla volta e a un orario decente: sono messaggi a persone, non un invio di massa.",
      senzaIlTuoNomeIlMessaggio: "Senza il tuo nome il messaggio si presenta con dei puntini: mettilo prima di iniziare.",
      copia: "Copia",
    },
    pagesAdminCrmCrmTodosPage: {
      elimina: "Elimina",
      annotaComEAndataConO: "Annota com'è andata, con o senza chiudere l'attività",
      riportaLAttivitaInDaFare: "Riporta l'attività in Da fare",
      annulla: "Annulla",
      segnaLRsquoAttivitaComeCompletata: "Segna l&rsquo;attività come completata",
      indicaDataEOraAltrimentiNon: "Indica data e ora, altrimenti non finisce in agenda.",
      indirizzoDelCentro: "Indirizzo del centro",
      dove: "Dove",
      durata: "Durata",
      quando: "Quando",
      finisceInAgendaEFraLe: "— finisce in agenda e fra le cose da fare",
      pianificaLaProssimaAttivita: "Pianifica la prossima attività",
      spostaLaScadenzaA: "Sposta la scadenza a",
      esIlRegistroLoTeniamoSu: "Es. «Il registro lo teniamo su un quaderno, ma a fine stagione non ritroviamo niente»",
      laFraseEsattaValePiuDel: "— la frase esatta vale più del riassunto",
      registrazioneNonRiuscita: "Registrazione non riuscita",
      dashboardCrm: "Dashboard CRM",
      registraEsito: "Registra esito",
    },
    pagesAdminDirectoryDirectoryPage: {
      nessunOperatoreCharterRegistrato: "Nessun operatore charter registrato",
      nonVerificati: "Non verificati",
      verificati: "Verificati",
      tutti: "Tutti",
      operatoriRegistratiSullaPiattaforma: "Operatori registrati sulla piattaforma",
      erroreAggiornamento: "Errore aggiornamento",
      statoAggiornato: "Stato aggiornato",
      annulla: "Annulla",
      note: "Note",
      indirizzo: "Indirizzo",
      email: "Email",
      telefono: "Telefono",
      paese: "Paese",
      citta: "Città",
      medicinaSubacquea: "Medicina subacquea",
      specializzazione: "Specializzazione",
      strutturaClinica: "Struttura / clinica",
      rossi: "Rossi",
      cognome: "Cognome",
      mario: "Mario",
      nome: "Nome",
      sitoWeb: "Sito web",
      nomeStrutturaSocieta: "Nome struttura / società",
      geocodificaInversaRecuperaIndirizziMancantiDalle: "Geocodifica inversa: recupera indirizzi mancanti dalle coordinate GPS",
      voceAggiuntaAllaDirectory: "Voce aggiunta alla directory",
      importAvviatoInBackgroundLaDirectory: "Import avviato in background — la directory si aggiornerà a breve",
      gestioneAvanzata: "Gestione avanzata",
      arricchimentoAutomatico: "Arricchimento automatico",
      longitudine: "Longitudine",
      latitudine: "Latitudine",
      posizione: "Posizione",
      descrizioneDellaStrutturaCaratteristicheSpecializzazioniProfondita: "Descrizione della struttura, caratteristiche, specializzazioni, profondità, visibilità, tipo di immersione…",
      descrizione: "Descrizione",
      via: "Via …",
      infoCentroIt: "info@centro.it",
      nomeStruttura: "Nome struttura",
      divingCenterCreatoOraPuoiGestire: "Diving Center creato: ora puoi gestire staff, soci e dettagli",
      erroreArricchimento: "Errore arricchimento",
      erroreSalvataggio: "Errore salvataggio",
      strutturaAggiornata: "Struttura aggiornata",
      disabilitaStruttura: "Disabilita struttura",
      modificaRapida: "Modifica rapida",
      schedaAnagraficaUnicaParty: "Scheda anagrafica unica (Party)",
      censito: "Censito",
      gestito: "Gestito",
      strutturaDisabilitata: "Struttura disabilitata",
      motivoTroppoCortoMin5Caratteri: "Motivo troppo corto (min 5 caratteri)",
      impossibileCreareLaSchedaParty: "Impossibile creare la scheda Party",
      impossibileAprireLaSchedaParty: "Impossibile aprire la scheda Party",
      inAttesa: "In attesa",
      verificato: "Verificato",
      aggiungiManualmente: "+ Aggiungi manualmente",
      mappa: "Mappa",
      lista: "Lista",
      creaUnCentroConStaffSoci: "Crea un centro con staff, soci e dettagli completi",
      trovaAutomaticamenteLeCoordinateEI: "Trova automaticamente le coordinate e i dati mancanti",
      cliccaSullaMappaPerImpostareLa: "Clicca sulla mappa per impostare la posizione",
    },
    pagesAdminDiveCentersAdminPage: {
      listaUnificataDiDivingCenterResort: "Lista unificata di Diving Center, Resort e Associazioni",
      registroCentriAssociazioni: "Registro Centri & Associazioni",
      anagraficaAziende: "Anagrafica aziende",
    },
    pagesAdminMailMailPage: {
      cerca: "Cerca…",
      eliminazioneNonRiuscita: "Eliminazione non riuscita",
      emailBody: "email-body",
      annulla: "Annulla",
      durata: "Durata",
      titolo: "Titolo",
      mittenteNonAncoraInCrm: "mittente non ancora in CRM",
      registrazioneNonRiuscita: "Registrazione non riuscita",
      richiestaRegistrataIlContattoEEscluso: "Richiesta registrata: il contatto è escluso dagli invii",
      creazioneNonRiuscita: "Creazione non riuscita",
      emailRegistrataNelloStoricoDelContatto: "Email registrata nello storico del contatto",
      impossibileAprireLaScheda: "Impossibile aprire la scheda",
      apriRubricaContattiCrm: "Apri rubrica contatti CRM",
      nessunContattoTrovato: "Nessun contatto trovato",
      cercaNomeEmailAzienda: "Cerca nome, email, azienda…",
      rubricaContatti: "Rubrica contatti",
      fissaAppuntamento: "Fissa appuntamento",
      creaAttivita: "Crea attività",
      consensoRevocatoEsclusoDagliInvii: "consenso revocato — escluso dagli invii",
    },
    pagesAdminMarketingPage: {
      ancheLAnagrafica: "anche l'anagrafica",
      minimo10CaratteriRichiesti: "Minimo 10 caratteri richiesti",
      esAttivitaCessataDuplicatoContattoNon: "Es: attività cessata, duplicato, contatto non più valido...",
      saraNascostoMaRimaneTracciabilePer: "sarà nascosto ma rimane tracciabile per audit e conformità GDPR.",
      ilContatto: "Il contatto",
      cancellazioneLogicaIlContattoNonVerra: "Cancellazione logica — il contatto non verrà eliminato fisicamente",
      cancellazioneLogicaContatto: "Cancellazione logica contatto",
      esitoRispostaWhatsapp: "Esito risposta WhatsApp",
      ilConsensoNonRisultaRevocatoNon: "Il consenso non risulta revocato: non l'ha revocato nessuno, è l'indirizzo che non c'è più.",
      esceDagliInviiFincheNonGli: "Esce dagli invii finché non gli dai un recapito nuovo.",
      nonVieneCancellato: "non viene cancellato",
      eLaPiattaformaDigitalePerTutto: "è la piattaforma digitale per tutto il mondo subacqueo.",
      whatsappQr: "WhatsApp QR",
      tutteLeAnagraficheContattabiliHannoNome: "Tutte le anagrafiche contattabili hanno nome, indirizzo e telefono.",
      nessunaSchedaDaCompletare: "Nessuna scheda da completare",
      daCompletare: "da completare",
      eliminaDallaRubrica: "Elimina dalla rubrica",
      apriLaScheda: "Apri la scheda",
      indirizzoRimosso: "indirizzo rimosso",
      origine: "Origine",
      revocatoIl: "Revocato il",
      nessunoHaRevocatoIlConsensoNon: "Nessuno ha revocato il consenso: non c'è niente da ripulire.",
      nessunDisiscritto: "Nessun disiscritto",
      eliminaIlContattoESeVuoi: "Elimina il contatto, e se vuoi anche la scheda in anagrafica",
      lIndirizzoNonEsistePiuToglilo: "L'indirizzo non esiste più: toglilo dall'anagrafica",
      aggiornaNomeTelefonoEDatiDella: "Aggiorna nome, telefono e dati della persona",
      percheSuccede: "perché succede",
      quando: "Quando",
      convertiInClienteAnagraficaParty: "Converti in cliente (anagrafica Party)",
      giaInAnagraficaPartyCliente: "Già in anagrafica Party (cliente)",
      segnaComeIscrittoB2bArt130: "Segna come iscritto (B2B — art. 130 Codice Privacy)",
      whatsappNonVuoleEssereDisturbatoStop: "WhatsApp: non vuole essere disturbato (STOP)",
      whatsappHaAccettatoOk: "WhatsApp: ha accettato (OK)",
      registraEsitoRispostaWhatsapp: "Registra esito risposta WhatsApp",
      okNbspNbspStopNbspNbsp: "✓ ok&nbsp;&nbsp;✕ stop&nbsp;·&nbsp;azioni",
      esito: "esito",
      whatsapp: "WhatsApp",
      registraLEsitoDiUnaRisposta: "Registra l'esito di una risposta WhatsApp (OK = consenso / STOP = cancellazione). Crea l'anagrafica anche senza email.",
      importaSoloGliUtentiEdiveRegistrati: "Importa solo gli utenti eDive registrati con consenso marketing, raggruppati per ruolo",
      unioneAnagraficheImportaLInteroCatalogo: "UNIONE ANAGRAFICHE: importa l'INTERO catalogo (persone + aziende) dall'Anagrafica Unica nel marketing, così puoi fare campagne su TUTTE le anagrafiche. Rispetta consensi e disiscrizioni.",
      statoDegliInviiMessaggioPerMessaggio: "Stato degli invii, messaggio per messaggio",
      erroreSincronizzazioneCatalogo: "Errore sincronizzazione catalogo",
      erroreSincronizzazioneUtenti: "Errore sincronizzazione utenti",
      contattoEAnagraficaEliminati: "Contatto e anagrafica eliminati",
      annulla: "Annulla",
      esito2: "Esito",
      marioRossi: "Mario Rossi",
      nomeOpzionale: "Nome (opzionale)",
      senzaPrefissoSiAssume39Italia: "Senza prefisso si assume +39 (Italia).",
      telefono: "Telefono",
      marketingBrochure: "marketing-brochure",
      onsaveDPartial: "; onSave: (d: Partial",
      newsletterPromoVip: "newsletter, promo, vip",
      nomeDellAziendaOppureNomeE: "Nome dell'azienda, oppure nome e cognome della persona.",
      uuid110Uuid2: "uuid-1&#10;uuid-2",
      newsletterPromoClienti2025: "newsletter, promo, clienti_2025",
      nomeTemplateApprovato: "nome_template_approvato",
      emailWhatsapp: "Email + WhatsApp",
      email: "Email",
      lingua: "Lingua",
      pubblico: "Pubblico",
      templateEdivePredefiniti: "Template eDive predefiniti",
      templateCaricatoPersonalizzaLeVariabili: "Template caricato — personalizza le variabili {{firstName}}, {{company}}, {{city}}",
      daUsareQuandoLaSchedaE: "Da usare quando la scheda è sbagliata o non è una persona né un'azienda",
      caricaIlBloccoSuccessivo: "Carica il blocco successivo",
      elimina: "Elimina",
      anagrafica: "Anagrafica",
      hannoRevocatoIlConsensoNessunaCampagna: "Hanno revocato il consenso: nessuna campagna li raggiunge più. Da qui si eliminano",
      rimuoviIndirizzo: "Rimuovi indirizzo",
      esitoWhatsapp: "Esito WhatsApp",
      monitoraggio: "Monitoraggio",
      stopNonDisturbare: "STOP — Non disturbare",
      okAcconsente: "OK — Acconsente",
      registraLaRispostaRicevutaViaWhatsapp: "Registra la risposta ricevuta via WhatsApp. Se il numero non è ancora in rubrica, viene creato un nuovo contatto. L'email non è richiesta.",
    },
    pagesAdminMonitoraggioCampagna: {
      click: "click",
      aperta: "aperta",
      inviiUnoPerUno: "Invii, uno per uno",
      totale: "Totale",
      conferme: "Conferme",
      click2: "Click",
      aperti: "Aperti",
      respinti: "Respinti",
      accettati: "Accettati",
      partiti: "Partiti",
      ora: "Ora",
      oraPerOra: "Ora per ora",
      nessunInvioRegistratoPerOra: "Nessun invio registrato per ora.",
      senzaNomeNeIndirizzoDelDestinatario: "Senza nome né indirizzo del destinatario: questa pagina non li mostra per scelta.",
    },
    pagesAdminSpeciesAdminShared: {
      annulla: "Annulla",
      noteDiRifiutoOpzionale: "Note di rifiuto (opzionale)...",
      rifiuta: "Rifiuta",
      modificheAllEnciclopedia: "Modifiche all'enciclopedia",
      statoIucn: "Stato IUCN",
      datiFishbase: "Dati FishBase",
      statisticheInaturalist: "Statistiche iNaturalist",
      nuovaSpecie: "Nuova specie",
      nessunaModificaDaApplicare: "Nessuna modifica da applicare",
      campiDaAggiornare: "Campi da aggiornare",
      campiDaAggiungere: "Campi da aggiungere",
      statoCodaRiconoscimento: "Stato coda riconoscimento",
      nessunaSpecieTrovata: "Nessuna specie trovata",
      soloConFotoInAttesa: "Solo con foto in attesa",
      cercaSpecie: "Cerca specie…",
      impostaComePrincipale: "Imposta come principale",
      escludi: "✕ Escludi",
      includi: "✓ Includi",
      rimuoviFiltro: "Rimuovi filtro",
    },
    pagesAdminTabsClaimRequestsTab: {
      notaPerLUtenteOpzionaleVerra: "Nota per l'utente (opzionale, verrà notificata via email)…",
      vediSchedaRivendicante: "Vedi scheda rivendicante",
      caricamento: "Caricamento…",
      claimRifiutato: "Claim rifiutato",
      claimApprovatoIlCentroEOra: "Claim approvato — il centro è ora attivo",
      schedaRivendicante: "Scheda rivendicante",
      caricamentoProfiloRivendicante: "Caricamento profilo rivendicante…",
      approvaRivendicazione: "Approva rivendicazione",
      rifiutaRivendicazione: "Rifiuta rivendicazione",
      telefonoVerificato: "Telefono verificato",
      emailVerificata: "Email verificata",
      kycVerificato: "KYC verificato",
    },
    pagesAdminTabsContentTabs: {
      annulla: "Annulla",
      conferma: "Conferma",
      motivoOpzionale: "Motivo (opzionale)",
      motivazione: "Motivazione",
      dataRichiesta: "Data richiesta",
      dataAttuale: "Data attuale",
      sitoSubacqueo: "Sito / Subacqueo",
      leRichiesteDiModificaDataApprovabili: "Le richieste di modifica data approvabili appariranno qui.",
      nessunaRichiestaInAttesa: "Nessuna richiesta in attesa",
      caricamento: "Caricamento…",
      richiesteCambioDataImmersione: "Richieste cambio data immersione",
      erroreRifiuto: "Errore rifiuto",
      richiestaRifiutata: "Richiesta rifiutata",
      erroreApprovazione: "Errore approvazione",
      richiestaApprovataDataAggiornata: "Richiesta approvata: data aggiornata",
      rifiuta: "Rifiuta",
      approva: "Approva",
    },
    pagesAdminTabsProposalsTab: {
      propostaEliminata: "Proposta eliminata",
      elimina: "Elimina",
    },
    pagesAdminTabsRegistryTab: {
      tipoDiAssociazione: "Tipo di associazione",
      cambiaTipoEntita: "Cambia tipo entità",
      modificaDatiEPersonale: "Modifica dati e personale",
      disattivo: "Disattivo",
      nessunCentroRegistratoSuEdive: "Nessun centro registrato su eDive",
      caricamento: "Caricamento…",
      cercaPerNome: "Cerca per nome…",
      tipoAggiornato: "Tipo aggiornato",
      rivendicazioneRevocata: "Rivendicazione revocata",
      centroEliminato: "Centro eliminato",
      centroRivendicato: "Centro rivendicato",
      chiudi: "Chiudi",
      es151792: "es. 15.1792",
      longitudine: "Longitudine",
      es378267: "es. 37.8267",
      latitudine: "Latitudine",
      esItCamp001: "es. IT-CAMP-001",
      numeroLicenza: "Numero licenza",
      sitoWeb: "Sito web",
      emailSecondaria: "Email secondaria",
      emailPrincipale: "Email principale",
      telefono: "Telefono",
      indirizzo: "Indirizzo",
      citta: "Città",
      paese: "Paese",
      descrizione: "Descrizione",
      nome: "Nome",
      centroAggiornato: "Centro aggiornato",
      rimuoviDalPersonale: "Rimuovi dal personale",
      gestisciRuoliAggiuntivi: "Gestisci ruoli aggiuntivi",
      inattivo: "inattivo",
      nessunMembroDelPersonale: "Nessun membro del personale",
      seleziona: "— seleziona —",
      trasferisciLaProprietaDelCentroA: "Trasferisci la proprietà del centro a un altro membro",
      personaleAttuale: "Personale attuale",
      lUtentePotraCambiarlaAlPrimo: "L'utente potrà cambiarla al primo accesso da Impostazioni → Sicurezza.",
      utenteCreatoECollegatoAlCentro: "Utente creato e collegato al centro",
      ruoloNelCentro: "Ruolo nel centro",
      cellulare: "Cellulare",
      email: "Email",
      almenoUnoTraEmailECellulare: "Almeno uno tra email e cellulare è obbligatorio",
      rossi: "Rossi",
      cognome: "Cognome *",
      mario: "Mario",
      nome2: "Nome *",
      cercaPerNomeOEmail: "Cerca per nome o email…",
      utenteRiconciliatoECollegatoAlCentro: "Utente riconciliato e collegato al centro",
      proprietaTrasferita: "Proprietà trasferita",
      ruoliAggiornati: "Ruoli aggiornati",
      rimosso: "Rimosso",
      personaleCollegato: "Personale collegato",
      annulla: "Annulla",
      info: "info@…",
      viaDelMare1: "Via del Mare 1",
      citta2: "Città *",
      paese2: "Paese *",
      coralReefDivingCenter: "Coral Reef Diving Center",
      aggiuntoAlRegistroComeNonRivendicato: "Aggiunto al registro come \"Non rivendicato\" finché un proprietario non ne rivendica la gestione.",
      nuovoCentroDiImmersione: "Nuovo centro di immersione",
      centroCreato: "Centro creato",
      questaOperazioneCambiaSoloIlTipo: "Questa operazione cambia solo il tipo dell'entità nel registro. I dati, lo staff e i documenti rimangono invariati.",
      apriDirectoryMediterranea: "Apri Directory Mediterranea",
      nuovoCentro: "Nuovo centro",
      arricchisciSchedaCentro: "Arricchisci scheda centro",
      aggiungiUnAltroMembro: "Aggiungi un altro membro",
      registraMembroStaff: "Registra membro staff",
      collegaPersonaleEsistente: "Collega personale esistente",
    },
    pagesAgencyAgencyOnboardingWizard: {
      esLiveaboard: "Es. Liveaboard…",
      serviziOfferti: "Servizi offerti",
      esMaldive: "Es. Maldive…",
      leDestinazioniSubDoveOperate: "Le destinazioni sub dove operate.",
      destinazioniPrincipali: "Destinazioni principali",
      sitoWeb: "Sito web",
      infoAgenziaIt: "info@agenzia.it",
      email: "Email",
      telefono: "Telefono *",
      roma: "Roma",
      citta: "Città *",
      paese: "Paese *",
      presentateLaVostraAgenziaSpecializzazioniAnni: "Presentate la vostra agenzia: specializzazioni, anni di esperienza, destinazioni forte…",
      descrizione: "Descrizione",
      esAquatravelSrl: "Es. AquaTravel Srl",
      nomeAgenzia: "Nome agenzia *",
      raggiungiMigliaiaDiSubacqueiSuEdive: "Raggiungi migliaia di subacquei su eDive",
      configuraLaTuaAgenziaViaggi: "Configura la tua agenzia viaggi",
      agenziaCreata: "Agenzia creata!",
      destinazioniEServiziVengonoUsatiPer: "Destinazioni e servizi vengono usati per i filtri di ricerca. Più ne aggiungi, più subacquei vi trovano.",
    },
    pagesAiAdvisorPage: {
      scriviUnMessaggioInvioPerInviare: "Scrivi un messaggio... (Invio per inviare, Shift+Invio per andare a capo)",
      elimina: "Elimina",
      preparazione: "Preparazione",
      sicurezza: "Sicurezza",
      pianoSuggerito: "Piano suggerito",
      risposteAiAScopoInformativoConsulta: "Risposte AI a scopo informativo — consulta sempre un istruttore certificato per decisioni di sicurezza.",
      iniziaChiedendoAlTuoAssistente: "Inizia chiedendo al tuo assistente!",
      nuovaConversazione: "Nuova conversazione",
    },
    pagesAnalyticsAnalyticsPage: {
      eventiPerOraDelGiorno: "eventi per ora del giorno",
      nuoviUtenti: "Nuovi utenti",
      pageviewTotali: "Pageview totali",
      utentiUnici: "Utenti unici",
      sessioniTotali: "Sessioni totali",
      caricamento: "Caricamento...",
      cerca: "Cerca",
      userIdUuid: "User ID (UUID)",
      attribuzioneIscrizioni: "Attribuzione iscrizioni",
      campagneUtm: "Campagne UTM",
      sorgentiDiTraffico: "Sorgenti di traffico",
    },
    pagesAssociationsAssociationShopPage: {
      ilTuoCarrello: "Il tuo carrello",
      nonHaiAncoraEffettuatoOrdiniIn: "Non hai ancora effettuato ordini in questa associazione.",
      nessunOrdine: "Nessun ordine",
      loShopDiQuestaAssociazioneNon: "Lo shop di questa associazione non ha ancora prodotti.",
      nessunProdottoDisponibile: "Nessun prodotto disponibile",
      prodottiEServiziDellAssociazione: "Prodotti e servizi dell'associazione",
      shop: "Shop",
      annullaOrdine: "Annulla ordine",
      paese: "Paese",
      citta: "Città",
      indirizzo: "Indirizzo",
      nomeECognome: "Nome e cognome",
      indirizzoDiSpedizione: "Indirizzo di spedizione",
      importoDalWallet: "Importo dal wallet (€)",
      metodoDiPagamento: "Metodo di pagamento",
      totale: "Totale",
      riepilogoOrdine: "Riepilogo ordine",
      checkout: "Checkout",
      ilCarrelloEVuoto: "Il carrello è vuoto",
      carrello: "Carrello",
      nonDisponibile: "Non disponibile",
      tornaAllAssociazione: "Torna all'associazione",
    },
    pagesAuthOAuthCallbackPage: {
      accessoNonRiuscito: "Accesso non riuscito",
      usatoPerComunicazioniUrgentiESicurezza: "Usato per comunicazioni urgenti e sicurezza dell'account",
      emailEsempioCom: "email@esempio.com",
      dalTuoAccountGoogle: "(dal tuo account Google)",
      creaIlTuoAccount: "Crea il tuo account",
      completamentoAccessoInCorso: "Completamento accesso in corso…",
      privacyPolicy: "Privacy Policy",
      terminiDiServizio: "Termini di Servizio",
      staiAccedendoPerLaPrimaVolta: "Stai accedendo per la prima volta. Completa i tuoi dati di contatto e accetta i Termini per creare il tuo profilo eDive.",
    },
    pagesAuthVerifyEmailPage: {
      verificaNonRiuscita: "Verifica non riuscita",
      ignora: "Ignora",
      associazioneSuggerita: "🏢 Associazione suggerita",
      emailVerificata: "Email verificata!",
      stiamoAttivandoIlTuoAccount: "Stiamo attivando il tuo account.",
      verificaInCorso: "Verifica in corso...",
      dalLoginPuoiRichiedereUnNuovo: "Dal login puoi richiedere un nuovo link di verifica.",
      ilTuoAccountEStatoAttivato: "Il tuo account è stato attivato con successo. Ora puoi accedere a eDive.",
    },
    pagesBiologycenterBioCenterHubPage: {
      nascostoAgliUtenti: "Nascosto agli utenti",
    },
    pagesBiologycenterFieldJournalPage: {
      nessunaOsservazioneRegistrata: "Nessuna osservazione registrata",
      condizioniMeteomarineSubstratoOsservazioniParticolariAnomalie: "Condizioni meteomarine, substrato, osservazioni particolari, anomalie ambientali…",
      noteGenerali: "Note generali",
      specieOsservate: "Specie osservate",
      corrente: "Corrente",
      lng: "Lng °",
      lat: "Lat °",
      esPuntaDelCorvoPortofino: "Es. Punta del Corvo, Portofino",
      nuovaOsservazioneDiCampo: "Nuova osservazione di campo",
      exportCsvAvviato: "Export CSV avviato",
      nessunaOsservazioneDaEsportare: "Nessuna osservazione da esportare",
      exportDarwinCoreAvviato: "Export Darwin Core avviato",
      erroreNellaCancellazione: "Errore nella cancellazione",
      osservazioneEliminata: "Osservazione eliminata",
      erroreNelSalvataggio: "Errore nel salvataggio",
      osservazioneSalvata: "Osservazione salvata",
      inserisciAlmenoIlLuogoOUna: "Inserisci almeno il luogo o una specie osservata",
      esportaDarwinCore: "Esporta Darwin Core",
      note: "Note",
      comportamento: "Comportamento",
      identificazioneAutomatica: "identificazione automatica",
      nomeComune: "Nome comune",
      nomeScientifico: "Nome scientifico *",
      fotografaEIdentificaSpecie: "Fotografa e identifica specie",
      ediveFieldJournalExport: "eDive Field Journal Export",
      ediveFieldJournal: "eDive Field Journal",
      humanobservation: "HumanObservation",
      registraLaPrimaOsservazione: "Registra la prima osservazione",
      aggiungiSpecie: "Aggiungi specie",
      data: "Data",
      luogo: "Luogo",
      nuovaOsservazione: "Nuova osservazione",
    },
    pagesBiologycenterMarineBioAssistantPage: {
      assistenteBiologiaMarina: "Assistente Biologia Marina",
      esMarTirrenoCentrale: "Es. Mar Tirreno centrale",
      areaGeografica: "Area geografica",
      esCarettaCaretta: "Es. Caretta caretta",
      specieDiRiferimento: "Specie di riferimento",
      erroreNellaRispostaDellAssistenteRiprova: "Errore nella risposta dell'assistente. Riprova.",
      iniziaAFareDomandeLAssistente: "Inizia a fare domande — l'assistente risponderà usando questa specie come riferimento.",
      ilContestoVieneInclusoInOgni: "Il contesto viene incluso in ogni messaggio per risposte più precise e pertinenti.",
      contestoDiRicerca: "Contesto di ricerca",
    },
    pagesBiologycenterMissionDetailPage: {
      aggiornamentoMissioneFallito: "Aggiornamento missione fallito",
      gestisciStato: "Gestisci stato",
      nessunaCandidaturaRicevuta: "Nessuna candidatura ricevuta.",
      erroreNelCaricamentoDelleCandidature: "Errore nel caricamento delle candidature.",
      caricamento: "Caricamento...",
      osservazioneRegistrataPuoiInviarneUnAltra: "Osservazione registrata. Puoi inviarne un'altra.",
      erroreOCandidaturaGiaInviata: "Errore o candidatura già inviata.",
      candidaturaInviata: "Candidatura inviata.",
      partecipaAllaMissione: "Partecipa alla missione",
      protocolloDiRaccoltaDati: "Protocollo di raccolta dati",
      missioneNonTrovata: "Missione non trovata.",
      erroreDuranteLInvio: "Errore durante l'invio.",
      osservazioneRegistrataConSuccesso: "Osservazione registrata con successo.",
      nessunCampoProtocolloDefinitoPerQuesta: "Nessun campo protocollo definito per questa missione.",
      no: "No",
      si: "Sì",
      inviaOsservazione: "Invia osservazione",
      vediRisultati: "Vedi risultati →",
    },
    pagesBiologycenterMissionResultsPage: {
      completamentoCampiProtocollo: "Completamento campi protocollo",
      timelineMensile: "Timeline mensile",
      speciePiuAvvistate: "Specie più avvistate",
      periodiConDati: "Periodi con dati",
      specieDocumentate: "Specie documentate",
      osservazioniTotali: "Osservazioni totali",
      nessunDatoDisponibile: "Nessun dato disponibile.",
      accessoNegatoOMissioneNonTrovata: "Accesso negato o missione non trovata.",
      caricamentoRisultati: "Caricamento risultati...",
      nessunaOsservazioneAncoraRegistrataPerQuesta: "Nessuna osservazione ancora registrata per questa missione.",
      numeroDiOsservazioniCheHannoCompilato: "Numero di osservazioni che hanno compilato ciascun campo.",
      tornaAllaMissione: "← Torna alla missione",
    },
    pagesBiologycenterResearchAnalyticsPage: {
      gliIndiciSonoCalcolatiSullaDistribuzione: "• Gli indici sono calcolati sulla distribuzione temporale degli avvistamenti, non sulla diversità tassonomica interspecie",
      aumentaConIlNumeroDiPeriodi: "aumenta con il numero di periodi attivi rispetto al totale avvistamenti",
      dMg: "D_Mg",
      vicinoA1AltaEquitabilitaAvvistamenti: "vicino a 1 → alta equitabilità (avvistamenti distribuiti uniformemente)",
      noteDiInterpretazione: "Note di interpretazione",
      totalePeriodo: "Totale periodo",
      simpsonD: "Simpson D",
      shannonH: "Shannon H'",
      periodoPicco: "Periodo picco",
      avvistamentiTotali: "Avvistamenti totali",
      cercaPerNomeComuneOScientifico: "Cerca per nome comune o scientifico…",
      erroreExportDarwinCore: "Errore export Darwin Core",
      exportDarwinCoreAvviato: "Export Darwin Core avviato",
      erroreExportCsv: "Errore export CSV",
      exportCsvAvviato: "Export CSV avviato",
      nessunDatoDisponibile: "Nessun dato disponibile",
      distribuzioneAvvistamentiPerPeriodo: "Distribuzione avvistamenti per periodo",
      coordinateAlCentroDiOgniCella: "Coordinate al centro di ogni cella della griglia · intensità proporzionale al numero di avvistamenti",
      nessunDatoDiDistribuzioneDisponibile: "Nessun dato di distribuzione disponibile",
      nessunDatoDisponibilePerQuestoIntervallo: "Nessun dato disponibile per questo intervallo",
      trendAvvistamentiNelTempo: "Trend avvistamenti nel tempo",
      selezionaUnaSpeciePerVisualizzareAnalisi: "Seleziona una specie per visualizzare analisi e statistiche",
      darwinCore: "Darwin Core",
      selezionaSpecieDaAnalizzare: "Seleziona specie da analizzare",
    },
    pagesBiologycenterResearchCenterOnboardingWizard: {
      "2448OreLavorative": "24-48 ore lavorative",
      spiegaComeIntendiUsareLeFunzionalita: "Spiega come intendi usare le funzionalità avanzate (database specie, citizen science, missioni di monitoraggio) nell'ambito delle attività della tua istituzione…",
      motivazionePerLAccesso: "Motivazione per l'accesso *",
      telefono: "Telefono",
      ricercaIstitutoIt: "ricerca@istituto.it",
      emailReferente: "Email referente",
      descriviIProgettiInCorsoMetodologie: "Descrivi i progetti in corso, metodologie, collaborazioni internazionali…",
      descrizioneAttivitaDiRicerca: "Descrizione attività di ricerca",
      esBiologiaMarina: "Es. Biologia marina…",
      selezionaLeAreeDiInteresseScientifico: "Seleziona le aree di interesse scientifico della tua istituzione.",
      ambitiDiRicerca: "Ambiti di ricerca",
      sitoWebIstituzione: "Sito web istituzione",
      napoli: "Napoli",
      citta: "Città",
      paese: "Paese *",
      esStazioneZoologicaAntonDohrn: "Es. Stazione Zoologica Anton Dohrn",
      nomeIstituzione: "Nome istituzione *",
      attivaLeFunzionalitaAvanzatePerRicercatori: "Attiva le funzionalità avanzate per ricercatori e biologi marini",
      accessoCentroDiRicerca: "Accesso Centro di Ricerca",
      riceveraiUnaNotificaViaEmailAll: "Riceverai una notifica via email all'indirizzo registrato.",
      richiestaInviata: "Richiesta inviata!",
      erroreNelSalvataggio: "Errore nel salvataggio",
      riceveraiUnaEmailDiConfermaAll: ". Riceverai una email di conferma all'attivazione dell'accesso.",
      lAccessoAlCentroDiRicerca: "L'accesso al Centro di Ricerca è riservato a istituti scientifici, università e organizzazioni di conservazione verificate.",
      ilTeamEdiveVerificheraLeCredenziali: "Il team eDive verificherà le credenziali della tua istituzione e attiverà l'accesso al pannello ricercatori entro 24-48 ore.",
    },
    pagesBiologycenterSpeciesEditorPage: {
      caricamentoImmagini: "Caricamento immagini…",
      corsivo: "corsivo",
      perIl: "per il",
      testo: "_testo_",
      grassetto: "grassetto",
      testo2: "**testo**",
      nessunTestoDaVisualizzare: "Nessun testo da visualizzare.",
      ricerca: "Ricerca…",
      cercaSpeciePerNomeScientificoO: "Cerca specie per nome scientifico o comune…",
      editorSchedeSpecie: "Editor Schede Specie",
      noteOpzionali: "Note opzionali…",
      caricamento: "Caricamento…",
      codaDiRevisioneImmagini: "Coda di revisione immagini",
      rimuoviImmagine: "Rimuovi immagine",
      impostaComePrincipale: "Imposta come principale",
      nessunaImmagineAggiungineUnaQuiSotto: "Nessuna immagine — aggiungine una qui sotto",
      fileCaricatoNelRepositoryProntoPer: "File caricato nel repository — pronto per l'aggiunta alla specie.",
      allRightsReserved: "All Rights Reserved",
      publicDomain: "Public Domain",
      ccBySa: "CC-BY-SA",
      ccBy: "CC-BY",
      autoreCredits: "Autore / credits",
      urlImmagineEsHttpsUploadWikimedia: "URL immagine (es. https://upload.wikimedia.org/...)",
      autorizzazioneAllaPubblicazione: "Autorizzazione alla pubblicazione",
      cercaESelezionaUnaSpeciePer: "Cerca e seleziona una specie per modificarne la scheda",
      erroreNelSalvataggio: "Errore nel salvataggio",
      salvato: "Salvato",
      erroreDuranteLaRicercaControllaLa: "Errore durante la ricerca. Controlla la connessione e riprova.",
      revisioneImmaginiCommunity: "Revisione immagini community",
      modificaDescrizioneEImmaginiDelleSpecie: "Modifica descrizione e immagini delle specie marine, e revisiona le immagini inviate dalla community.",
      leImmaginiCaricateDagliUtentiDurante: "Le immagini caricate dagli utenti durante il riconoscimento specie attendono la tua approvazione prima di essere",
      principale: "Principale",
      caricaFile: "Carica file",
      urlEsterno: "URL esterno",
      aggiungiImmagine: "Aggiungi immagine",
    },
    pagesBiologycenterSpeciesReportPage: {
      copiaTesto: "Copia testo",
      copiato: "Copiato!",
      poweredByOllama: "Powered by Ollama",
      cercaPerNomeScientificoOComune: "Cerca per nome scientifico o comune…",
      reportScaricato: "Report scaricato",
      erroreCopia: "Errore copia",
      erroreNellaGenerazioneDelReportRiprova: "Errore nella generazione del report. Riprova.",
      reportGeneratoConSuccesso: "Report generato con successo",
      fontiScientifiche: "Fonti Scientifiche",
      selezionaUnaSpecieEPremiGenera: "Seleziona una specie e premi \"Genera report\" per ottenere un'analisi scientifica completa con stato di conservazione, trend di popolazione e raccomandazioni di ricerca.",
      questoReportEGeneratoDaIa: "Questo report è generato da IA e deve essere verificato da un esperto prima di essere utilizzato in pubblicazioni scientifiche.",
      stampa: "Stampa",
      scaricaMd: "Scarica .md",
      reportDiConservazioneEdiveMarineBiology: "Report di Conservazione — eDive Marine Biology Center",
      caricamentoDatiDiAvvistamento: "Caricamento dati di avvistamento…",
      selezionaSpecie: "Seleziona specie",
    },
    pagesBiologycenterTaxonomyExplorerPage: {
      cercaNomeComuneItEnO: "Cerca nome comune (IT/EN) o nome scientifico…",
      minacciata: "minacciata",
      statoIucn: "Stato IUCN",
      nomeScientifico: "Nome scientifico",
      nomeIt: "Nome (IT)",
      nomeEn: "Nome (EN)",
      apriNellEnciclopedia: "Apri nell'enciclopedia",
    },
    pagesBookingsBookingsPage: {
      attrezzaturaInclusaNelPrezzo: "Attrezzatura inclusa nel prezzo",
      "0Gratuita": "0 = gratuita",
      prezzo: "Prezzo (€)",
      maxPartecipanti: "Max partecipanti",
      durataMinuti: "Durata (minuti) *",
      dataEOra: "Data e ora *",
      esOwd: "Es. OWD",
      livelloMinimoCertificazione: "Livello minimo certificazione",
      nomeDelSito: "Nome del sito",
      sitoDiImmersione: "Sito di immersione",
      esImmersioneNotturnaAPortofino: "Es. Immersione notturna a Portofino",
      titolo: "Titolo *",
      nuovaSessioneGuidata: "Nuova sessione guidata",
      nessunCentroTrovato: "Nessun centro trovato",
      cercaDiveCenterPerNomeO: "Cerca dive center per nome o città…",
      autorizzazionePreImmersione: "Autorizzazione pre-immersione",
      scaricaPdf: "Scarica PDF",
      cercaSessioneOSito: "Cerca sessione o sito…",
      esploraSessioniGuidateEImmersioniOrganizzate: "Esplora sessioni guidate e immersioni organizzate da istruttori e divemaster. Prenota direttamente in app.",
      datiDelModuloNonDisponibili: "Dati del modulo non disponibili",
      durataMin: "Durata (min) *",
      modificaSessione: "Modifica sessione",
      sessioneAggiornata: "Sessione aggiornata",
      livelloCertificazione: "Livello certificazione",
      attrezzatura: "Attrezzatura",
      max: "Max",
      min: "Min",
      durataMinuti2: "Durata (minuti)",
      nessunLimite: "Nessun limite",
      prezzoMassimo: "Prezzo massimo",
      al: "Al",
      dal: "Dal",
      periodo: "Periodo",
      nessunSitoConCoordinateDisponibili: "Nessun sito con coordinate disponibili",
      autorizzazioniFirmate: "Autorizzazioni firmate",
      reset: "Reset",
      filtri: "Filtri",
    },
    pagesContactsContactsPage: {
      whatsapp: "WhatsApp",
    },
    pagesContentContentPage: {
      subacqueaTecnicaDecompressione: "subacquea, tecnica, decompressione",
      nessunMediaNellaLibreria: "Nessun media nella libreria",
      rimuovi: "Rimuovi",
      modifica: "Modifica",
      copertina: "Copertina",
      immagineDiCopertina: "Immagine di copertina",
      english: "English",
      italiano: "Italiano",
      scegliDallaLibreria: "Scegli dalla libreria",
      erroreNelCaricamentoDelleNotizieRiprova: "Errore nel caricamento delle notizie. Riprova tra qualche secondo.",
    },
    pagesCoursesCourseLessonsPage: {
      caricamentoLezione: "Caricamento lezione...",
      selezionaUnaLezionePerIniziare: "Seleziona una lezione per iniziare",
      nessunaLezioneDisponibile: "Nessuna lezione disponibile",
      caricamentoLezioni: "Caricamento lezioni...",
      liberatoriaFirmata: "Liberatoria firmata",
      contenutoNonAncoraDisponibile: "Contenuto non ancora disponibile",
      completata: "Completata",
      erroreNelSegnareLaLezioneCome: "Errore nel segnare la lezione come completata",
      lezioneCompletata: "Lezione completata!",
      lezioneVideo: "Lezione video",
      catalogoCorsi: "Catalogo corsi",
      contenuto: "Contenuto",
      video: "Video",
    },
    pagesCoursesCoursesPage: {
      divemaster: "Divemaster",
      rescue: "Rescue",
      advanced: "Advanced",
      discover: "Discover",
      useridDaInvitare: "userId da invitare",
      riservato: "Riservato",
      pubblico: "Pubblico",
      visibilitaDelCorso: "Visibilità del corso",
      agenziePerCuiSeiCertificatoCome: "✓ = agenzie per cui sei certificato come istruttore",
      agenziaDiCertificazione: "Agenzia di certificazione",
      soloAgliInvitati: "— solo agli invitati",
      nelCatalogoPerTutti: "— nel catalogo per tutti",
    },
    pagesCrmmarketingCrmMarketingHubPage: {
      sales: "Sales",
      contattiCampagneEContenutiTuttoIl: "Contatti, campagne e contenuti: tutto il lavoro commerciale in un posto solo.",
    },
    pagesDashboardDashboardPage: {
      nonMostrarePiu: "Non mostrare più",
      completaQuesti4PassiPerConfigurare: "Completa questi 4 passi per configurare il tuo profilo eDive",
      daDoveIniziare: "Da dove iniziare",
      contribuisciOra: "Contribuisci ora →",
      haiFotoSubacqueeArricchisciLaBanca: "Hai foto subacquee? Arricchisci la banca dati marina",
    },
    pagesDatalabDataLabPage: {
      dataEdiveTech: "data@edive.tech",
      riceviIlDatasetViaEmailCon: "— ricevi il dataset via email con istruzioni di accesso sicuro.",
      "4Consegna": "4. Consegna",
      ilTeamEdiveEsaminaLaRichiesta: "— il team eDive esamina la richiesta entro 2–3 giorni lavorativi.",
      "3Revisione": "3. Revisione",
      descriviLaTuaOrganizzazioneELo: "— descrivi la tua organizzazione e lo scopo d'uso.",
      "2RichiediLaLicenza": "2. Richiedi la licenza",
      selezionaIlProdottoPiuAdattoAl: "— seleziona il prodotto più adatto al tuo caso d'uso.",
      "1ScegliIlDataset": "1. Scegli il dataset",
      comeFunziona: "Come funziona",
      licenzaAnnuale: "✅ Licenza annuale",
      aggiornamentoMensile: "✅ Aggiornamento mensile",
      datiGdprCompliant: "✅ Dati GDPR-compliant",
      richiestaInviataTiRisponderemoEntro2: "Richiesta inviata! Ti risponderemo entro 2–3 giorni lavorativi.",
      errore: "Errore",
      richiestaExportInviataControllaLEmail: "Richiesta export inviata — controlla l'email",
      leTueLicenzeERichieste: "Le tue licenze e richieste",
      licenzaAnno: "licenza/anno",
      formato: "formato",
      record: "record",
      annulla: "Annulla",
      descriviComeIntendiUtilizzareIDati: "Descrivi come intendi utilizzare i dati: ricerca scientifica, analisi commerciale, sviluppo software, ecc.",
      universitaAziendaIstituto: "Università / Azienda / Istituto",
      organizzazione: "Organizzazione *",
      richiediLicenzaDati: "Richiedi licenza dati",
      inRevisione: "In revisione",
      laRichiestaSaraEsaminataDalTeam: "La richiesta sarà esaminata dal team eDive entro 2–3 giorni lavorativi. Ti contatteremo via email per confermare i dettagli di consegna.",
    },
    pagesDeveloperDeveloperPage: {
      ilSigningSecret: "Il signing secret",
      salvaIlWebhookSecret: "Salva il Webhook Secret",
      questaChiave: "Questa chiave",
      salvaLaTuaApiKey: "Salva la tua API Key",
      rispostaDiversVerify: "Risposta /divers/verify",
      rispostaKpi: "Risposta KPI",
      kpiCentroDivingScopeAnalyticsRead: "KPI centro diving (scope: analytics:read)",
      creareUnaPrenotazioneScopeBookingsWrite: "Creare una prenotazione (scope: bookings:write)",
      verificaCertificazioniDiUnSubacqueo: "Verifica certificazioni di un subacqueo",
      ogniWebhookIncludeLHeader: "Ogni webhook include l'header",
      verificaDellaFirma: "Verifica della firma",
      registraUnEndpointPerRicevereEventi: "Registra un endpoint per ricevere eventi in tempo reale",
      nessunWebhookConfigurato: "Nessun webhook configurato",
      chiaviRevocateScadute: "Chiavi revocate / scadute",
      creaLaTuaPrimaChiavePer: "Crea la tua prima chiave per iniziare l'integrazione",
      nessunaApiKeyAttiva: "Nessuna API key attiva",
      applicationJson: "application/json",
      formato: "Formato",
      xApiKeyEkLive: "X-API-Key: ek_live_…",
      authHeader: "Auth header",
      baseUrl: "Base URL",
      webhookDisattivato: "Webhook disattivato",
      erroreNellaRegistrazioneDelWebhook: "Errore nella registrazione del webhook",
      chiaveRevocata: "Chiave revocata",
      erroreNellaCreazioneDellaChiave: "Errore nella creazione della chiave",
      annulla: "Annulla",
      eventiDaRicevere: "Eventi da ricevere *",
      opzionale: "opzionale",
      descrizione: "Descrizione",
      urlEndpoint: "URL endpoint *",
      registraWebhook: "Registra webhook",
      mai: "∞ mai",
      scadenzaGiorni: "Scadenza (giorni)",
      rateLimitReqMin: "Rate limit (req/min)",
      permessiScope: "Permessi (scope) *",
      nomeAziendaOpzionale: "Nome azienda (opzionale)",
      organizzazione: "Organizzazione",
      esBookingSystemIntegration: "es. Booking System Integration",
      nomeChiave: "Nome chiave *",
      creaNuovaApiKey: "Crea nuova API Key",
      copia: "Copia",
      xEdiveSignature: "X-eDive-Signature",
      aggiungiWebhook: "Aggiungi webhook",
      creaNuovaKey: "Crea nuova key",
      integraEdiveNeiTuoiSistemiSiti: "Integra eDive nei tuoi sistemi: siti web, app mobile, sistemi di prenotazione e piattaforme",
      apiEdiveIntegrazioneB2b: "API eDive — Integrazione B2B",
    },
    pagesDiariesDiaryAlbumPanel: {
      erroreNelCaricamentoDellaFoto: "Errore nel caricamento della foto",
      fotoAggiuntaAllAlbum: "Foto aggiunta all'album",
      creaPrimaUnaPaginaDelDiario: "Crea prima una pagina del diario",
      scriviUnCommento: "Scrivi un commento…",
      nessunCommentoAncora: "Nessun commento ancora",
      fotoEliminata: "Foto eliminata",
      erroreNelSalvataggioDelCommento: "Errore nel salvataggio del commento",
      caricataDa: "Caricata da",
      nessunaFotoNellAlbum: "Nessuna foto nell'album",
      commenti: "Commenti",
    },
    pagesDiariesDiaryDetailPage: {
      annulla: "Annulla",
      messaggioOpzionaleEsChiSeiPerche: "Messaggio opzionale (es. chi sei, perché vuoi unirti)",
      inviaUnaRichiestaAlCreatoreDel: "Invia una richiesta al creatore del diario per partecipare come lettore o co-autore.",
      richiediAccesso: "Richiedi accesso",
      richiestaInviata: "Richiesta inviata",
      cambiaCopertina: "Cambia copertina",
      erroreNellInvioDellaRichiesta: "Errore nell'invio della richiesta",
      seiGiaMembroDiQuestoDiario: "Sei già membro di questo diario",
      richiestaInviataAlCreatoreDelDiario: "Richiesta inviata al creatore del diario",
      erroreNelCaricamentoDellImmagine: "Errore nel caricamento dell'immagine",
      erroreNellAggiornamentoDellaCopertina: "Errore nell'aggiornamento della copertina",
      copertinaAggiornata: "Copertina aggiornata",
      paginaEliminata: "Pagina eliminata",
      diarioEliminato: "Diario eliminato",
      rispostaA: "Risposta a",
      caricamento: "Caricamento…",
      erroreNelSalvataggioDelCommento: "Errore nel salvataggio del commento",
      whatsapp: "WhatsApp",
      copiaLink: "Copia link",
      viaggioVirtuale: "Viaggio virtuale",
      rispondi: "Rispondi",
    },
    pagesDiariesDiaryDocumentsPanel: {
      annulla: "Annulla",
      noteOpzionali: "Note opzionali",
      note: "Note",
      esBigliettoAereoAndata: "Es. Biglietto aereo andata",
      titolo: "Titolo *",
      apriScarica: "Apri/scarica",
      erroreNelCaricamentoDelFile: "Errore nel caricamento del file",
      daiUnTitoloAlDocumentoPrima: "Dai un titolo al documento prima di caricarlo",
      erroreNelSalvataggioDelDocumento: "Errore nel salvataggio del documento",
      documentoSalvato: "Documento salvato",
      aggiungiDocumento: "Aggiungi documento",
      nessunDocumentoCaricato: "Nessun documento caricato",
    },
    pagesDiariesDiaryEntryEditor: {
      immersioneCollegata: "Immersione collegata",
      tipoDiEsperienza: "Tipo di esperienza",
      collegaUnImmersioneDalLogbook: "Collega un'immersione dal logbook",
      emoji: "Emoji",
    },
    pagesDiariesDiaryInvitePage: {
      lAposInvitoEScadutoO: "L&apos;invito è scaduto o è già stato utilizzato.",
      erroreNellAccettazioneDellInvito: "Errore nell'accettazione dell'invito",
      seiGiaIlProprietarioDiQuesto: "Sei già il proprietario di questo diario",
      haiRicevutoUnInvitoPerIl: "Hai ricevuto un invito per il diario di viaggio",
    },
    pagesDiariesDiaryItineraryPanel: {
      pernottamentiGenerali: "Pernottamenti generali",
      erroreNellaRimozioneDelPernottamento: "Errore nella rimozione del pernottamento",
      erroreNellAggiornamentoDelPernottamento: "Errore nell'aggiornamento del pernottamento",
      erroreNelSalvataggioDelPernottamento: "Errore nel salvataggio del pernottamento",
      erroreNellaRimozioneDellaTappa: "Errore nella rimozione della tappa",
      erroreNellAggiornamentoDellaTappa: "Errore nell'aggiornamento della tappa",
      erroreNelSalvataggioDellaTappa: "Errore nel salvataggio della tappa",
      annulla: "Annulla",
      notePersonaliSuQuestoAlloggio: "Note personali su questo alloggio",
      note: "Note",
      incollaLIndirizzoUrlDiUn: "Incolla l'indirizzo (URL) di un'immagine…",
      cosaOffreLaStruttura: "Cosa offre la struttura",
      breveDescrizione: "Breve descrizione",
      infoStrutturaIt: "info@struttura.it",
      email: "Email",
      es39061234567: "Es. +39 06 1234567",
      telefono: "Telefono",
      apriIlSito: "Apri il sito",
      sitoWeb: "Sito web",
      rimuoviSegnaposto: "Rimuovi segnaposto",
      posizionePrecisaSullaMappa: "Posizione precisa sulla mappa",
      viaCittaPaese: "Via, città, paese",
      indirizzo: "Indirizzo",
      oraDiCheckOutFacoltativaDefault: "Ora di check-out (facoltativa, default 11:00)",
      checkOut: "Check-out",
      oraDiCheckInFacoltativaDefault: "Ora di check-in (facoltativa, default 14:00)",
      checkIn: "Check-in",
      esCodiceConferma: "Es. codice conferma",
      rifPrenotazione: "Rif. prenotazione",
      esSiladenIndonesia: "Es. Siladen, Indonesia",
      luogo: "Luogo",
      cercaSitoDescrizioneEIndirizzoSul: "Cerca sito, descrizione e indirizzo sul web",
      campoObbligatorio: "Campo obbligatorio",
      esBobochaSiladen: "Es. Bobocha Siladen",
      nomeStruttura: "Nome struttura *",
      posizioneDellaStrutturaImpostataDalGeotag: "Posizione della struttura impostata dal geotag della foto",
      ricercaNonRiuscita: "Ricerca non riuscita",
      informazioniTrovateEPrecompilate: "Informazioni trovate e precompilate",
      noteOpzionale: "Note (opzionale)",
      dataPrevista: "Data prevista",
      cittaPaese: "Città, paese",
      esSharmElSheikh: "Es. Sharm el-Sheikh",
      nomeTappa: "Nome tappa *",
      haUnGeotagGps: "Ha un geotag GPS",
      nessunaFotoAncoraNellAlbumDel: "Nessuna foto ancora nell'album del diario",
      caricamento: "Caricamento…",
      scegliDallAlbumDelDiario: "Scegli dall'album del diario",
      aggiungiPernottamento: "Aggiungi pernottamento",
      aggiungiTappa: "Aggiungi tappa",
      salva: "Salva",
      dallAlbum: "Dall'album",
      aggiungi: "Aggiungi",
      vediSullaMappa: "Vedi sulla mappa",
      salvaTappa: "Salva tappa",
    },
    pagesDiariesDiaryMapModal: {
      trasferimenti: "Trasferimenti",
      alloggi: "Alloggi",
      tappe: "Tappe",
      voci: "Voci",
      caricamentoMappa: "Caricamento mappa…",
      mappaDelViaggio: "Mappa del viaggio",
      nessunaLocalitaConCoordinateAncoraRegistrata: "Nessuna località con coordinate ancora registrata: aggiungi luoghi alle voci, alle tappe, agli alloggi o ai trasferimenti.",
    },
    pagesDiariesDiaryMembersPanel: {
      nessunaRichiestaDiAccessoInAttesa: "Nessuna richiesta di accesso in attesa",
      revocaInvito: "Revoca invito",
      copiaLink: "Copia link",
      linkCopiato: "Link copiato!",
      ilLinkSaraValidoPer7: "Il link sarà valido per 7 giorni e copiato automaticamente",
      emailDestinatarioOpzionale: "Email destinatario (opzionale)",
      creaUnLinkDInvito: "Crea un link d'invito",
      giaMembro: "Già membro",
      nessunUtenteTrovato: "Nessun utente trovato",
      trovatoPerEmail: "Trovato per email",
      cercaPerNomeOCognome: "Cerca per nome o cognome…",
      cercaUtenteEdive: "Cerca utente eDive",
      livelliDiAccesso: "Livelli di accesso",
      nessunMembroAncora: "Nessun membro ancora",
      collaboratori: "Collaboratori",
      membroRimosso: "Membro rimosso",
      invitoRevocato: "Invito revocato",
      erroreNelReinvioDellEmail: "Errore nel reinvio dell'email",
      lEmailNonEPartitaCondividi: "L'email non è partita: condividi il link a mano (pulsante \"Copia link\").",
      erroreNellaCreazioneDellInvito: "Errore nella creazione dell'invito",
      erroreNellElaborazioneDellaRichiesta: "Errore nell'elaborazione della richiesta",
      rimuoviMembro: "Rimuovi membro",
      tu: "(tu)",
      invitaQualcuno: "Invita qualcuno",
      coAutore: "Co-autore",
      lettore: "Lettore",
      rifiuta: "Rifiuta",
    },
    pagesDiariesDiaryPublicPage: {
      nessunaEntryInQuestoDiario: "Nessuna entry in questo diario.",
      diariDiViaggio: "Diari di Viaggio",
      ilLinkPotrebbeEssereScadutoO: "Il link potrebbe essere scaduto o il diario non è più pubblico.",
      diarioNonTrovato: "Diario non trovato",
      caricamentoDiario: "Caricamento diario...",
      laPiattaformaPerISubacquei: "— La piattaforma per i subacquei",
      vaiAiMieiDiari: "Vai ai miei diari",
      registratiGratis: "Registrati gratis",
      registratiGratuitamenteSuEdivePerLeggere: "Registrati gratuitamente su eDive per leggere tutto il diario, aggiungere like e commenti.",
      scopriEdive: "Scopri eDive",
    },
    pagesDiariesDiaryTransfersPanel: {
      erroreNellaRimozione: "Errore nella rimozione",
      erroreNellAggiornamentoDelTrasferimento: "Errore nell'aggiornamento del trasferimento",
      erroreNelSalvataggioDelTrasferimento: "Errore nel salvataggio del trasferimento",
      annulla: "Annulla",
      indicaPartenzaEArrivo: "Indica partenza e arrivo",
      noteOpzionale: "Note (opzionale)",
      note: "Note",
      compagnia: "Compagnia…",
      vettore: "Vettore",
      arrPrevista: "Arr. prevista",
      part: "Part.",
      destinazione: "Destinazione",
      esStaziFcoFiumicino: "Es. Stazi… , FCO, Fiumicino…",
      aggiungiTrasferimento: "Aggiungi trasferimento",
      nessunTrasferimentoAggiunto: "Nessun trasferimento aggiunto",
    },
    pagesDiariesDiveLinkCard: {
      annulla: "Annulla",
      caricamento: "Caricamento…",
      cercaPerSitoOCitta: "Cerca per sito o città…",
      nonVisibile: "(non visibile)",
      caricamentoImmersione: "Caricamento immersione…",
      registraUnaNuovaImmersione: "Registra una nuova immersione",
    },
    pagesDiariesTravelDiariesPage: {
      siiIlPrimoACondividereLa: "Sii il primo a condividere la tua avventura!",
      nessunDiarioPubblicoDisponibile: "Nessun diario pubblico disponibile",
      leggiLeAvventureDiAltriSubacquei: "Leggi le avventure di altri subacquei, lascia un like e trova ispirazione per il prossimo viaggio",
      diariPubbliciDellaCommunity: "Diari pubblici della community",
      raccontaLaTuaProssimaAvventuraSubacquea: "Racconta la tua prossima avventura subacquea",
      nessunDiario: "Nessun diario",
      raccontaLeTueAvventureCondividiI: "Racconta le tue avventure, condividi i momenti migliori e scopri i viaggi della community",
      privato: "Privato",
      pubblico: "Pubblico",
      esploraCommunity: "Esplora community",
    },
    pagesDirectoryAddressManager: {
      annulla: "Annulla",
      indirizzoPrincipale: "Indirizzo principale",
      paese: "Paese",
      prov: "Prov.",
      citta: "Città",
      via: "Via",
      impostaComePrincipale: "Imposta come principale",
      principale: "principale",
      nessunIndirizzo: "Nessun indirizzo.",
      caricamento: "Caricamento…",
      errore: "Errore",
      indirizzoAggiunto: "Indirizzo aggiunto",
      aggiungiIndirizzo: "Aggiungi indirizzo",
    },
    pagesDirectoryAnagraficaWorkspacePage: {
      catalogoUnicoPersoneEAziendeCrm: "Catalogo unico: Persone e Aziende. CRM, Marketing e Gestione centri sono viste su questo registro.",
      anagrafica: "Anagrafica",
      nessunCampoPersonalizzatoSonoAttiviSolo: "Nessun campo personalizzato (sono attivi solo quelli di dominio predefiniti).",
      caricamento: "Caricamento…",
      faccettabileInRicerca: "Faccettabile in ricerca",
      opzioniSeparateDaVirgola: "opzioni, separate da virgola",
      unitaEsM: "unità (es. m)",
      etichetta: "Etichetta",
      chiaveEsMaxdepth: "chiave (es. maxDepth)",
      elenco: "Elenco",
      siNo: "Sì/No",
      numero: "Numero",
      testo: "Testo",
      personaPerQualita: "Persona (per qualità)",
      aziendaPerTipo: "Azienda (per tipo)",
      nuovoCampo: "Nuovo campo",
      campiPersonalizzatiCheEstendonoIlRegistro: "Campi personalizzati che estendono il registro per tipo azienda (ORG) o qualità persona (PERSON). Compaiono nei form, nella validazione e — se faccettabili — nella ricerca.",
      campoCreato: "Campo creato",
      nessunAltroRecordDelloStessoTipo: "Nessun altro record dello stesso tipo in questo gruppo",
      assorbiIn: "Assorbi in",
      tieniQuestoUnisci: "Tieni questo, unisci…",
      accountEdive: "account eDive",
      nessunDuplicatoRilevatoNessunaEmailCondivisa: "Nessun duplicato rilevato (nessuna email condivisa fra record distinti). ✅",
      ricercaDuplicati: "Ricerca duplicati…",
      consensiCanaleStato: "Consensi (canale/stato)",
      topQualitaRuoli: "Top qualità/ruoli",
      perFonte: "Per fonte",
      perStadioFunnel: "Per stadio (funnel)",
      tagDedupReview: "tag dedup:review",
      irraggiungibiliNoContattiNeRuoli: "irraggiungibili (no contatti né ruoli)",
      senzaAlcunContatto: "senza alcun contatto",
      gruppiEmailDuplicate: "gruppi email duplicate",
      qualitaDati: "Qualità dati",
      daDeduplicare: "Da deduplicare",
      coperturaEmail: "Copertura email",
      aziende: "Aziende",
      persone: "Persone",
      caricamentoStatistiche: "Caricamento statistiche…",
      importaCsv: "Importa CSV",
    },
    pagesDirectoryCommunicationPanel: {
      messaggio: "Messaggio…",
      oggetto: "Oggetto",
      inviaUnEmailA: "Invia un'email a",
      invioNonRiuscito: "Invio non riuscito",
      emailInviata: "Email inviata",
      comunicazione: "Comunicazione",
    },
    pagesDirectoryPartyOrganizationDetailPage: {
      annulla: "Annulla",
      confermiLAziendaSpariraDalRegistro: "Confermi? L'azienda sparirà dal registro (soft-delete).",
      zonaPericolosa: "Zona pericolosa",
      organizzazioneACatalogoNonAncoraGestita: "Organizzazione a catalogo (non ancora gestita sulla piattaforma).",
      gestioneCentro: "Gestione centro",
      strumentiCollegati: "Strumenti collegati",
      aggiungiNota: "Aggiungi nota…",
      attivita: "Attività",
      nuovoDeal: "Nuovo deal…",
      opportunitaDeal: "Opportunità / Deal",
      consensi: "Consensi",
      nonImpostato: "— non impostato —",
      stadioFunnel: "Stadio (funnel)",
      crmMarketing: "CRM & Marketing",
      nessunaNota: "Nessuna nota.",
      aggiungiUnaNotaCondivisa: "Aggiungi una nota condivisa…",
      indirizzoNonDisponibile: "Indirizzo non disponibile.",
      sede: "Sede",
      nessunContattoRegistrato: "Nessun contatto registrato.",
      contatti: "Contatti",
      leModificheScrivonoSulRegistroUnico: "Le modifiche scrivono sul registro unico Party e si propagano ai sistemi collegati (es. gestione centro).",
      citta: "Città",
      sitoWeb: "Sito web",
      telefono: "Telefono",
      email: "Email",
      descrizione: "Descrizione…",
      paeseIt: "Paese (IT)",
      annoFondazione: "Anno fondazione",
      denominazioneLegale: "Denominazione legale",
      censito: "Censito",
      gestito: "Gestito",
      anagraficaNonTrovata: "Anagrafica non trovata.",
      caricamento: "Caricamento…",
      aziendaDisabilitataDalRegistro: "Azienda disabilitata dal registro",
      erroreNelSalvataggio: "Errore nel salvataggio",
      anagraficaAggiornataPropagataAiSistemiCollegati: "Anagrafica aggiornata (propagata ai sistemi collegati)",
      erroreNelSalvataggioDellaNota: "Errore nel salvataggio della nota",
      notaAggiunta: "Nota aggiunta",
      disabilitaAzienda: "Disabilita azienda",
      ricercaAnagrafica: "Ricerca anagrafica",
      note: "Note",
      tag: "Tag",
      indietro: "Indietro",
    },
    pagesDirectoryPartyPersonDetailPage: {
      perProfiloEPrivacyDatiDell: "Per profilo e privacy (dati dell'utente): impersona e modifica come lui",
      nessunaAttivitaRegistrata: "Nessuna attività registrata.",
      nota: "+ Nota",
      aggiungiUnaNota: "Aggiungi una nota…",
      attivitaTimeline: "Attività / Timeline",
      deal: "+ Deal",
      nuovoDeal: "Nuovo deal…",
      nessunDeal: "Nessun deal.",
      opportunitaDeal: "Opportunità / Deal",
      consensiGdpr: "Consensi (GDPR)",
      salva: "Salva",
      useridResponsabile: "userId responsabile…",
      responsabileOwner: "Responsabile (owner)",
      nonImpostato: "— non impostato —",
      stadioFunnel: "Stadio (funnel)",
      iDatiSonoAssociatiAlleQualita: "I dati sono associati alle qualità della persona e scritti sul registro unico Party.",
      annulla: "Annulla",
      modifica: "Modifica",
      valore: "valore…",
      rimuovi: "Rimuovi",
      nessunContatto: "Nessun contatto.",
      dallAccountEdiveCollegato: "Dall'account eDive collegato",
      contatti: "Contatti",
      leQualitaAbilitanoLeFunzionalitaDella: "Le qualità abilitano le funzionalità della piattaforma. Assegnale solo a fronte di titoli verificati.",
      assegnaQualita: "+ assegna qualità…",
      revocaQualita: "Revoca qualità",
      utenteStandardNessunaQualitaProfessionaleRegistrata: "Utente standard (nessuna qualità professionale registrata).",
      nessunaAziendaCollegata: "— (nessuna azienda collegata)",
      ruoloInAzienda: "Ruolo in azienda",
      nessunAccount: "— (nessun account)",
      ruoloNelProgettoEdive: "Ruolo nel progetto eDive",
      registratoSuEdive: "Registrato su eDive",
      accediComeQuestoUtente: "Accedi come questo utente",
      scaricaLaSchedaUtenteInPdf: "Scarica la scheda utente in PDF",
      iscrittoIl: "Iscritto il",
      anagraficaSenzaAccountNonRegistrato: "Anagrafica senza account (non registrato)",
      accountEdiveCollegato: "Account eDive collegato",
      modificaNomePropagaAiSilos: "Modifica nome (propaga ai silos)",
      cognome: "Cognome",
      nome: "Nome",
      eliminaQuestaAnagrafica: "Elimina questa anagrafica",
      erroreEliminazioneAnagrafica: "Errore eliminazione anagrafica",
      anagraficaEliminata: "Anagrafica eliminata",
      questoRecordNonHaIDati: "Questo record non ha i dati identificativi (nome e cognome), per questo la scheda completa non si apre.",
      anagraficaSenzaNome: "Anagrafica senza nome",
      personaNonTrovata: "Persona non trovata.",
      caricamento: "Caricamento…",
      erroreGenerazionePdf: "Errore generazione PDF",
      errore: "Errore",
      qualitaRevocata: "Qualità revocata",
      qualitaAssegnata: "Qualità assegnata",
      contattoRimosso: "Contatto rimosso",
      contattoAggiunto: "Contatto aggiunto",
      dealCreato: "Deal creato",
      notaAggiunta: "Nota aggiunta",
      consensoAggiornato: "Consenso aggiornato",
      responsabileAggiornato: "Responsabile aggiornato",
      stadioAggiornato: "Stadio aggiornato",
      erroreNelSalvataggioDelNome: "Errore nel salvataggio del nome",
      nomeAggiornato: "Nome aggiornato",
      erroreNelSalvataggio: "Errore nel salvataggio",
      datiProfessionaliAggiornati: "Dati professionali aggiornati",
      erroreImpersonificazione: "Errore impersonificazione",
      impersonificazioneAvviata: "Impersonificazione avviata",
      eliminazioneGiaInCodaPerQuesto: "Eliminazione già in coda per questo utente.",
      eliminazioneAvviataIContenutiVerrannoRimossi: "Eliminazione avviata — i contenuti verranno rimossi entro pochi minuti.",
      account: "account",
      ricercaPersone: "Ricerca persone",
      ruoliAccount: "Ruoli account",
      certificazioni: "Certificazioni",
      gestioneAvanzata: "Gestione avanzata",
      crmMarketing: "CRM & Marketing",
      datiProfessionali: "Dati professionali",
      inizio: "Inizio",
      qualitaECapacita: "Qualità e capacità",
      no: "No",
      si: "Sì",
      statoEdiveRuoli: "Stato eDive & ruoli",
      impersona: "Impersona",
      indietro: "Indietro",
    },
    pagesDirectoryPersonIdentityEditor: {
      lingue: "Lingue",
      nazionalita: "Nazionalità",
      genere: "Genere",
      dataDiNascita: "Data di nascita",
      nomeVisualizzato: "Nome visualizzato",
      cognome: "Cognome",
      nome: "Nome",
      annulla: "Annulla",
      itEn: "it, en",
      lingueIso2Virgola: "Lingue (ISO2, virgola)",
      nazionalitaIso2: "Nazionalità (ISO2)",
      opzionale: "(opzionale)",
      modifica: "Modifica",
      datiAnagrafici: "Dati anagrafici",
      erroreNelSalvataggio: "Errore nel salvataggio",
      anagraficaAggiornata: "Anagrafica aggiornata",
    },
    pagesDirectoryPersonSearchPage: {
      successivo: "Successivo →",
      precedente: "← Precedente",
      bloccaAccount: "Blocca account",
      sbloccaAccount: "Sblocca account",
      consensiGdpr: "Consensi GDPR",
      modificaDatiScheda: "Modifica dati (scheda)",
      assegnaAdAzienda: "Assegna ad azienda",
      assegnaRuolo: "Assegna ruolo",
      scriviEmailDaSupportEdiveTech: "Scrivi email (da support@edive.tech)",
      impersona: "Impersona",
      apriScheda: "Apri scheda",
      stadioFunnel: "Stadio funnel",
      emailRimbalzataBounced: "Email rimbalzata (bounced)",
      bounced: "Bounced",
      contattoMarketing: "Contatto marketing",
      marketing: "Marketing",
      presenteNelCrm: "Presente nel CRM",
      utente: "Utente",
      azioni: "Azioni",
      tipo: "Tipo",
      citta: "Città",
      contatti: "Contatti",
      qualitaCapacita: "Qualità / capacità",
      nome: "Nome",
      nessunaPersonaTrovata: "Nessuna persona trovata.",
      erroreNelCaricamento: "Errore nel caricamento.",
      deseleziona: "deseleziona",
      eliminaLeAnagraficheSelezionateGliAccount: "Elimina le anagrafiche selezionate (gli account registrati vengono saltati)",
      impostaStadio: "imposta stadio…",
      unisci: "Unisci",
      possibiliDuplicati: "Possibili duplicati",
      salvaIlFiltroCorrenteComeSegmento: "Salva il filtro corrente come segmento",
      salva: "★ Salva",
      mostraSoloIPossibiliDuplicatiRecord: "Mostra solo i possibili duplicati: record con lo stesso nome+cognome segnalati dall'import per revisione. Sono ordinati per nome, così le coppie sono vicine.",
      filtraPerEmailRimbalzataClickPer: "Filtra per email rimbalzata: click per ciclare Tutti → solo Rimbalzate → solo Non rimbalzate",
      mostraSoloIContattiAssegnatiA: "Mostra solo i contatti assegnati a me",
      contattiSenzaAccountESenzaRuolo: "Contatti senza account e senza ruolo lead",
      contattiSenzaAccountConUnRuolo: "Contatti senza account con un ruolo lead/marketing",
      chiunqueAbbiaUnAccountEdiveStaff: "Chiunque abbia un account eDive, staff compreso",
      soloUtentiConRuoliProfessionaliIstruttore: "Solo utenti con ruoli professionali (istruttore, divemaster, ricercatore, staff centro…)",
      tutti: "Tutti",
      registratoChiunqueAbbiaUnAccountEdive: "Registrato = chiunque abbia un account eDive (staff compreso). Staff = solo chi ha ruoli professionali. Lead/Contatto = senza account.",
      qualita: "Qualità",
      nome2: "Nome…",
      annulla: "Annulla",
      opz: "(opz.)",
      dataFine: "Data fine",
      dataInizio: "Data inizio",
      ruoloNellAzienda: "Ruolo nell'azienda",
      cambia: "cambia",
      nessunaAziendaTrovata: "Nessuna azienda trovata.",
      ricerca: "Ricerca…",
      cercaAzienda: "Cerca azienda…",
      azienda: "Azienda",
      collegaLaPersonaAUnOrganizzazione: "Collega la persona a un'organizzazione con un ruolo e un periodo di validità.",
      lasciaVuotaLaFinePerUn: "Lascia vuota la fine per un ruolo a tempo indeterminato (in corso).",
      scegliUnRuolo: "— scegli un ruolo —",
      dellUtenteNeDeterminaLaDashboard: "dell'utente: ne determina la dashboard e le funzioni disponibili.",
      ruoloPrimario: "ruolo primario",
      impostaIl: "Imposta il",
      messaggio: "Messaggio…",
      oggetto: "Oggetto",
      nonEConfigurataTraGliAccount: "non è configurata tra gli account di posta.",
      supportEdiveTech: "support@edive.tech",
      laCasella: "La casella",
      da: "Da",
      chiudi: "Chiudi",
      obbligatorio: "obbligatorio",
      nessunBundleConsensiRegistratoPerQuesto: "Nessun bundle consensi registrato per questo utente.",
      caricamento: "Caricamento…",
      eTracciateIConsensiObbligatoriContrattuali: "e tracciate. I consensi obbligatori (contrattuali/di legge) non sono revocabili.",
      appendOnly: "append-only",
      gestioneGdprLeModificheSono: "Gestione GDPR. Le modifiche sono",
      comunicalaAllUtenteLaCambieraAl: "— comunicala all'utente (la cambierà al primo accesso).",
      cognome: "Cognome",
      email: "Email *",
      creaUnAccountAttivoConPassword: "Crea un account attivo (con password temporanea) e l'anagrafica Party. Se l'email esiste già, viene collegata.",
      registraNuovoUtente: "Registra nuovo utente",
      gestireLAccount: "gestire l'account",
      cliccaUnaPersonaPerLaScheda: ". Clicca una persona per la scheda e",
      qualitaCapacita2: "qualità/capacità",
      unSoloRegistroFaccettatoPer: "Un solo registro, faccettato per",
      erroreSalvataggioSegmento: "Errore salvataggio segmento",
      segmentoSalvato: "Segmento salvato",
      erroreAzioneBulk: "Errore azione bulk",
      personaAssegnataAllAzienda: "Persona assegnata all'azienda",
      ruoloAssegnato: "Ruolo assegnato",
      erroreInvioEmail: "Errore invio email",
      emailInviata: "Email inviata",
      consensiAggiornati: "Consensi aggiornati",
      erroreCambioStatoAccount: "Errore cambio stato account",
      anagraficaEliminata: "Anagrafica eliminata",
      eliminazioneGiaInCoda: "Eliminazione già in coda",
      eliminazioneAvviataGdpr: "Eliminazione avviata (GDPR)",
      erroreImpersonificazione: "Errore impersonificazione",
      impersonificazioneAvviata: "Impersonificazione avviata",
      eliminaImpersona: "(elimina, impersona).",
      eliminaSelezionati: "Elimina selezionati",
      personeRicercaEGestione: "Persone — Ricerca e gestione",
    },
    pagesDirectoryPresenceManager: {
      annulla: "annulla",
      handleOppureUrlProfilo: "@handle oppure URL profilo",
      ufficiale: "ufficiale",
      nessunProfiloSocial: "Nessun profilo social.",
      caricamento: "Caricamento…",
      errore: "Errore",
      profiloSocialSalvato: "Profilo social salvato",
      aggiungiProfiloSocial: "Aggiungi profilo social",
    },
    pagesDirectoryUnifiedDirectorySearchPage: {
      seleziona: "Seleziona",
      nessunCentroTrovatoConQuestiFiltri: "Nessun centro trovato con questi filtri.",
      erroreNelCaricamentoDeiRisultati: "Errore nel caricamento dei risultati.",
      deseleziona: "deseleziona",
      soloCensiti: "Solo censiti",
      soloGestiti: "Solo gestiti",
      tutti: "Tutti",
      paeseEsIt: "Paese (es. IT)",
      citta: "Città…",
      nomeDelCentro: "Nome del centro…",
      dopoLaCreazioneSiApreLa: "Dopo la creazione si apre la scheda per aggiungere contatti, sede e dati di dominio.",
      annulla: "Annulla",
      nomeAzienda: "Nome azienda *",
      nuovaAzienda: "Nuova azienda",
      importaDalMediterraneoOpenstreetmapGiraIn: "Importa dal Mediterraneo (OpenStreetMap). Gira in background; i risultati confluiscono in Party e appaiono al prossimo refresh.",
      importCatalogoOsm: "Import catalogo OSM",
      mappaGeocodeEnrichPerRiga: "Mappa, geocode, enrich per-riga",
      censiti: "censiti",
      gestiti: "gestiti",
      erroreNellAvvioDellImport: "Errore nell'avvio dell'import",
      importOsmAvviatoInBackgroundI: "Import OSM avviato in background — i risultati appariranno tra qualche minuto",
      erroreNellaCreazione: "Errore nella creazione",
      esisteGiaUnAziendaSimile: "Esiste già un'azienda simile",
      aziendaCreataCompletaLaScheda: "Azienda creata — completa la scheda",
      eliminaSelezionate: "Elimina selezionate",
      maxPerPaese: "Max per paese",
      importOsm: "Import OSM",
      catalogoAvanzato: "Catalogo avanzato",
      anagraficaAziende: "Anagrafica aziende",
    },
    pagesDivecenterBriefingCreatorPage: {
      correnteAscensionaleNellaZonaNord10: "- Corrente ascensionale nella zona nord&#10;- Scarsa visibilità nella zona sabbiosa&#10;- Presenza di ricci nei fondali bassi",
      pareteANordConGorgonieA: "- Parete a nord con gorgonie a -18m&#10;- Relitto a -25m&#10;- Grotta a -12m (cautela per chi non è certificato cave)",
      generaBriefing: "Genera Briefing",
      generazione: "Generazione...",
      compilaAutomaticamentePuntiDiInteressePericoli: "Compila automaticamente punti di interesse, pericoli e piano di emergenza",
      generaConAi: "Genera con AI",
      es22: "es. 22",
      es05: "es. 0.5",
      es45: "es. 45",
      es30: "es. 30",
      erroreGenerazioneAi: "Errore generazione AI",
      briefingAiGenerato: "Briefing AI generato",
      verificaLeAutorizzazioniNecessariePrimaDel: "Verifica le autorizzazioni necessarie prima del briefing. Aggiungi le istruzioni di conformità al piano di emergenza.",
      zonaTutelataL702026Art: "Zona Tutelata — L.70/2026 art.13-14",
    },
    pagesDivecenterCreateCourseWizard: {
      iClientiPotrannoTrovareEIscriversi: "I clienti potranno trovare e iscriversi al corso.",
      corsoAttivo: "Corso attivo",
      modalitaIscrizione: "Modalità iscrizione",
      prezzo: "Prezzo (€)",
      richiedeBrevettoMinimo: "Richiede brevetto minimo",
      es2: "Es. 2",
      durataSettimane: "Durata (settimane)",
      maxStudenti: "Max studenti *",
      descriviGliObiettiviLeCompetenzeAcquisite: "Descrivi gli obiettivi, le competenze acquisite e le attività del corso…",
      descrizione: "Descrizione",
      esOpenWaterDiverAdvancedOpen: "Es. Open Water Diver, Advanced Open Water…",
      nomeDelCorso: "Nome del corso *",
      esOwdAowdRescueDivemaster: "Es. OWD, AOWD, Rescue, Divemaster…",
      livelloDelCorso: "Livello del corso",
      nonHaiAncoraIndicatoLeTue: "Non hai ancora indicato le tue agenzie nel profilo istruttore: la creazione del corso potrebbe essere rifiutata. Compila il profilo istruttore per poter creare corsi.",
      nonRisultiCertificatoComeIstruttore: "Non risulti certificato come istruttore",
      agenziaDiCertificazione: "Agenzia di certificazione *",
      configuraUnCorsoDiCertificazionePer: "Configura un corso di certificazione per il tuo dive center",
      creaUnNuovoCorso: "Crea un nuovo corso",
      corsoCreatoConSuccesso: "Corso creato con successo!",
      agenziePerCuiSeiCertificatoCome: "Agenzie per cui sei certificato come istruttore",
    },
    pagesDivecenterDCAdminPage: {
      polizzeAssicurative: "🛡️ Polizze Assicurative",
      esente: "Esente",
      personalizzato: "Personalizzato",
      viaggioDiving: "Viaggio diving",
      noleggioAttrezzatura: "Noleggio attrezzatura",
      corsoOwd: "Corso OWD",
      pacchetto5Immersioni: "Pacchetto 5 immersioni",
      immersioneSingola: "Immersione singola",
      nomeClienteOEmail: "Nome cliente o email",
      nessunPreSocioRegistrato: "Nessun pre-socio registrato",
      inserisciAlmenoEmailOTelefono: "Inserisci almeno email o telefono",
      nomeECognomeObbligatori: "Nome e cognome obbligatori",
      annulla: "Annulla",
      almenoUnoTraEmailETelefono: "* Almeno uno tra email e telefono obbligatorio",
      noteOpzionale: "Note (opzionale)",
      whatsappOpzionale: "WhatsApp (opzionale)",
      telefonoOpzionale: "Telefono (opzionale)",
      emailOpzionale: "Email (opzionale)",
      cognome: "Cognome *",
      nome: "Nome *",
      sociPreRegistrati: "Soci pre-registrati",
      sospendi: "Sospendi",
      rinnova: "Rinnova",
      nessunSocioTrovato: "Nessun socio trovato",
      caricamento: "Caricamento…",
      online: "Online",
      bonifico: "Bonifico",
      contanti: "Contanti",
      metodoPagamento: "Metodo pagamento",
      dataPagamento: "Data pagamento",
      es3000: "es. 30.00",
      quota: "Quota (€)",
      tipoTessera: "Tipo tessera",
      uuidDellUtente: "uuid dell'utente",
      userId: "User ID",
      nuovoSocio: "Nuovo socio",
      gestioneSoci: "Gestione Soci",
      preSocioRimosso: "Pre-socio rimosso",
      preSocioAggiunto: "Pre-socio aggiunto",
      tesseraRinnovata: "Tessera rinnovata",
      tesseraSospesa: "Tessera sospesa",
      socioAggiunto: "Socio aggiunto",
      rimuovi: "Rimuovi",
      archivioDocumenti: "Archivio documenti",
      eventualiNote: "Eventuali note",
      note: "Note",
      associationsXyzStatutoPdf: "associations/xyz/statuto.pdf",
      chiaveFileMinio: "Chiave file MinIO",
      esAssembleaStraordinariaNotaioRossi: "es. Assemblea Straordinaria, Notaio Rossi",
      emessoDa: "Emesso da",
      scadenza: "Scadenza",
      approvatoIl: "Approvato il",
      es2024V12: "es. 2024 / v1.2",
      versione: "Versione",
      esStatutoSociale2024: "es. Statuto Sociale 2024",
      titolo: "Titolo *",
      tipoDocumento: "Tipo documento *",
      archiviaDocumento: "Archivia documento",
      mancante: "Mancante",
      documentiObbligatori: "Documenti obbligatori",
      documentoRimosso: "Documento rimosso",
      erroreNelSalvataggio: "Errore nel salvataggio",
      documentoArchiviato: "Documento archiviato",
      minore: "⚠️ Minore",
      compliance: "Compliance",
      erroreNellaDenunciaInail: "Errore nella denuncia INAIL",
      denunciaInailRegistrata: "Denuncia INAIL registrata",
      erroreNellaTrasmissione: "Errore nella trasmissione",
      segnalazioneTrasmessaAllAutorita: "Segnalazione trasmessa all'autorità",
      marioRossi: "Mario Rossi",
      esImmersioneDiGruppo8Subacquei: "Es: Immersione di gruppo - 8 subacquei - Secca delle Seggiole",
      infoCentroIt: "info@centro.it",
      viaRoma1Napoli: "Via Roma 1, Napoli",
      campoObbligatorio: "Campo obbligatorio",
      nessunDocumentoArchiviatoUsaIlForm: "Nessun documento archiviato — usa il form sopra per caricare Statuto, Regolamento di Sicurezza e Atto Costitutivo",
    },
    pagesDivecenterDCBoatsPage: {
      tipo: "Tipo",
      matricola: "Matricola",
      nome: "Nome",
      assicurazioneScaduta: "Assicurazione scaduta",
      inattiva: "Inattiva",
      aggiungiLeBarcheDelTuoCentro: "Aggiungi le barche del tuo centro per gestirne assicurazione e manutenzione",
      distanzaPercorsa: "Distanza percorsa",
      carburanteConsumato: "Carburante consumato",
      usciteNelPeriodo: "Uscite nel periodo",
      al: "Al",
      dal: "Dal",
      costo: "Costo",
      eseguitoDa: "Eseguito da",
      data: "Data",
      scadenza: "Scadenza",
      quantita: "Quantità",
      categoria: "Categoria",
      articolo: "Articolo",
      esZatteraDiSalvataggio6Pax: "es. Zattera di salvataggio 6 pax",
      premio: "Premio",
      valida: "Valida",
      copertura: "Copertura",
      polizza: "Polizza",
      es120000: "es. 1200.00",
      esBOffshoreCCostiera: "es. B – offshore, C – costiera",
      seleziona: "— seleziona —",
      scaduto: "Scaduto",
    },
    pagesDivecenterDCCalendarPage: {
      divemaster: "Divemaster",
      istruttore: "Istruttore",
      guida: "Guida",
      partecipante: "Partecipante",
      iso21417: "ISO 21417",
      nomeDelSito: "Nome del sito",
      esMattinataAlleSeccheDiTor: "es. Mattinata alle Secche di Tor Paterno",
      "61Limit": "6:1 LIMIT ⚠️",
    },
    pagesDivecenterDCCompliancePage: {
      l702026Art13Aree: "L.70/2026 Art.13 — Aree Marine Protette",
      iso21416PraticheEcoSostenibili: "ISO 21416 — Pratiche Eco-sostenibili",
      iso21417Sensibilizzazione: "ISO 21417 — Sensibilizzazione",
      staiUsandoLaRegolaPredefinitaDi: "Stai usando la regola predefinita di eDive.",
      daQuiParteLInvitoGentile: "Da qui parte l'invito gentile al rinnovo (deve essere prima della scadenza).",
      sollecitiDalMese: "Solleciti dal mese",
      oltreQuestaEtaLIdoneitaVa: "Oltre questa età, l'idoneità va rinnovata.",
      validitaMassimaMesi: "Validità massima (mesi)",
      attivaloSeLaTuaGiurisdizioneRichiede: "Attivalo se la tua giurisdizione richiede il certificato medico a prescindere dal brevetto. Ha la precedenza sulla regola qui sopra.",
      certificatoMedicoSempreObbligatorio: "Certificato medico sempre obbligatorio",
      seIlSubacqueoHaUnBrevetto: "Se il subacqueo ha un brevetto che abilita la profondità dell'immersione, il certificato medico non è obbligatorio. È il comportamento accogliente consigliato.",
      brevettoAdeguatoCertificatoMedicoOpzionale: "Brevetto adeguato → certificato medico opzionale",
      idoneitaMedicaLaTuaRegolaPer: "Idoneità medica: la tua regola per i subacquei",
      caricamento: "Caricamento…",
      regolaDiIdoneitaAggiornata: "Regola di idoneità aggiornata",
      no: "No",
      si: "Sì",
      rinviata: "Rinviata",
      respinta: "Respinta",
      approvata: "Approvata",
      titoloDelibera: "Titolo delibera",
      aggiungiDelibera: "Aggiungi delibera",
      nessunaDeliberaRegistrata: "Nessuna delibera registrata",
      quorum: "Quorum ✓",
      verbalizzata: "Verbalizzata",
      nessunaAssembleaRegistrata: "Nessuna assemblea registrata",
      ordineDelGiorno: "Ordine del giorno",
      luogo: "Luogo",
      dataEOra: "Data e ora",
      tipoAssemblea: "Tipo assemblea",
      registraAssemblea: "Registra Assemblea",
      leAsdDevonoTenereIlLibro: "— Le ASD devono tenere il libro verbali delle assemblee. Le assemblee ordinarie annuali devono approvare bilancio e relazione del consiglio.",
      codiceCivileArtt1442D: "Codice Civile artt. 14-42 + D.Lgs. 36/2021 Art. 7",
      erroreNelSalvataggioDelibera: "Errore nel salvataggio delibera",
      deliberaAggiunta: "Delibera aggiunta",
      erroreNellaRimozione: "Errore nella rimozione",
      assembleaRimossa: "Assemblea rimossa",
      erroreNelSalvataggio: "Errore nel salvataggio",
      assembleaRegistrata: "Assemblea registrata",
      nessunaRegistrazioneFederaleInserita: "Nessuna registrazione federale inserita",
      note: "Note",
      scadenzaSeApplicabile: "Scadenza (se applicabile)",
      dataIscrizione: "Data iscrizione",
      numeroIscrizione: "Numero iscrizione",
      enteEsFipsasFidesSsiRegione: "Ente (es. FIPSAS, FIDeS, SSI, Regione Lombardia)",
      tipoRegistro: "Tipo registro",
      nuovaRegistrazioneFederale: "Nuova Registrazione Federale",
      leAsdDevonoEssereIscritteAl: "— Le ASD devono essere iscritte al RASD (Sport e Salute). Le APS/ODV devono essere iscritte al RUNTS. Obbligo di affiliazione a FSN/EPS riconosciuta dal CONI.",
      dLgs362021DLgs: "D.Lgs. 36/2021 + D.Lgs. 117/2017",
      registrazioneRimossa: "Registrazione rimossa",
      registrazioneFederaleAggiunta: "Registrazione federale aggiunta",
      nessunaPolizzaRcRegistrata: "Nessuna polizza RC registrata",
      dataScadenza: "Data scadenza",
      dataInizio: "Data inizio",
      es1000000: "es. 1000000",
      massimale: "Massimale (€)",
      tipoCopertura: "Tipo copertura",
      numeroPolizza: "Numero polizza",
      esGeneraliZurichCattolica: "es. Generali, Zurich, Cattolica...",
      compagniaAssicurativa: "Compagnia assicurativa",
      nuovaPolizzaRc: "Nuova Polizza RC",
      nessunaPolizzaRcAttivaAdempimentoObbligatorio: "Nessuna polizza RC attiva — adempimento obbligatorio mancante",
      ilDivingCenterDeveAverePolizza: "— Il diving center deve avere polizza RC operativa per attività di istruzione e noleggio attrezzature.",
      dLgs792011Art50: "D.Lgs. 79/2011 Art.50 + L.248/2002",
      polizzaRimossa: "Polizza rimossa",
      polizzaRcAggiunta: "Polizza RC aggiunta",
      l702026Art11: "L.70/2026 Art. 11",
      decidiComeIlTuoCentroAccoglie: "Decidi come il tuo centro accoglie i subacquei. La regola predefinita è pensata per non",
      nuovaAssemblea: "Nuova Assemblea",
      aggiungiRegistrazione: "Aggiungi Registrazione",
      aggiungiPolizzaRc: "Aggiungi Polizza RC",
    },
    pagesDivecenterDCCustomersPage: {
      si: "Sì",
      cliente: "Cliente",
      versione: "Versione",
      sommozzatore: "Sommozzatore",
      scadenza: "Scadenza",
      emesso: "Emesso",
      tipo: "Tipo",
      idoneitaMedica: "Idoneità medica",
      whatsapp: "WhatsApp",
    },
    pagesDivecenterDCDashboardPage: {
      notificheDelCentro: "Notifiche del centro",
      impossibileAggiornareLeNotifiche: "Impossibile aggiornare le notifiche",
      notificheSegnateComeLette: "Notifiche segnate come lette",
      lePrenotazioniLeRichiesteDiCorso: "Le prenotazioni, le richieste di corso, le adesioni staff e le recensioni",
    },
    pagesDivecenterDCHRPage: {
      tiInvitiamoAFarParteDel: "Ti invitiamo a far parte del nostro team come…",
      messaggioOpzionale: "Messaggio (opzionale)",
      ruoloProposto: "Ruolo proposto",
      cercaPerNomeCognomeOCitta: "Cerca per nome, cognome o città…",
      utenteEdiveDaInvitare: "Utente eDive da invitare",
      lUtenteRiceveraLInvitoE: "L'utente riceverà l'invito e potrà accettare o rifiutare dalla sua area personale.",
      invitaUnUtenteNelTeam: "Invita un utente nel team",
      padiOwPadiAiEfr: "PADI OW, PADI AI, EFR…",
      certificazioniSeparateDaVirgola: "Certificazioni (separate da virgola)",
      ruoloNelCentro: "Ruolo nel centro",
      utenteEdive: "Utente eDive",
      aggiungeImmediatamenteUnUtenteEdiveRegistrato: "Aggiunge immediatamente un utente eDive registrato al team (senza richiesta di conferma).",
      nessunUtenteTrovato: "Nessun utente trovato",
      nonDisponibile: "Non disponibile",
      disponibile: "Disponibile",
      staff: "Staff",
      inattivo: "Inattivo",
      erroreNellaRimozione: "Errore nella rimozione",
      inAttesa: "In attesa",
    },
    pagesDivecenterDCLogbookPage: {
      marioRossiDm12345: "Mario Rossi — DM #12345",
      firmaDelDivemaster: "Firma del Divemaster *",
      daFirmare: "Da firmare",
      certificata: "Certificata",
      nessunaImmersioneDisponibile: "Nessuna immersione disponibile.",
      caricamentoImmersioni: "Caricamento immersioni...",
      firmaDigitaleDivemaster: "✍️ Firma Digitale Divemaster",
      importDaComputerSub: "💻 Import da Computer Sub",
      privacy: "Privacy",
      tipo: "Tipo",
      durata: "Durata",
      profondita: "Profondità",
      sito: "Sito",
      data: "Data",
      nessunaImmersioneRegistrata: "Nessuna immersione registrata",
      caricamento: "Caricamento...",
      visualizzaLogbookImportDaComputerSub: "Visualizza logbook, import da computer sub, firma DM, certificati",
      "6LogbookCertificazione": "6. Logbook & Certificazione",
      laFirmaVieneInviataViaEvento: "La firma viene inviata via evento al logbook del subacqueo.",
      selezionaLeImmersioniDaCertificareE: "Seleziona le immersioni da certificare e apponi la firma digitale del Divemaster.",
    },
    pagesDivecenterDCWaiverSignPage: {
      firmaGenitoreTutore: "Firma genitore/tutore",
      firmaGenitore: "Firma genitore",
      rispondiATutteLeDomandePer: "Rispondi a tutte le domande per continuare.",
      nomeCognome: "Nome Cognome",
      nomeECognomeGenitoreTutore: "Nome e cognome genitore/tutore *",
      consensoGenitoreTutoreL70Art: "Consenso genitore/tutore (L.70 Art.17)",
      firmaGenitoreAcquisita: "Firma genitore acquisita",
    },
    pagesDivecenterDiveCenterProfilePage: {
      apriLaSchedaAnagraficaUnicaParty: "Apri la scheda anagrafica unica (Party)",
      cambiaLogo: "Cambia logo",
      erroreUploadLogo: "Errore upload logo",
      logoAggiornato: "Logo aggiornato",
      erroreDuranteIlRifiuto: "Errore durante il rifiuto",
      richiestaRifiutata: "Richiesta rifiutata",
      erroreDuranteLApprovazione: "Errore durante l'approvazione",
      associatoApprovato: "Associato approvato ✓",
      richiestaDiAdesioneInviata: "Richiesta di adesione inviata!",
      anagraficaUnica: "Anagrafica unica",
    },
    pagesDivecenterDiveCentersPage: {
      logoUrl: "Logo URL",
      support: "support@...",
      email3: "Email 3",
      booking: "booking@...",
      email2: "Email 2",
      info: "info@...",
      email: "Email",
      whatsapp: "WhatsApp",
    },
    pagesDivecenterInviteStaffWizard: {
      esBenvenutoNelTeamTiContatteremo: "Es. Benvenuto nel team! Ti contatteremo per onboarding…",
      notaOpzionale: "Nota opzionale",
      scegliIlRuoloDaAssegnareA: "Scegli il ruolo da assegnare a",
      cellulareChiaveDiRiconciliazione: "Cellulare (chiave di riconciliazione)",
      emanueleEsempioIt: "emanuele@esempio.it",
      emailChiaveDiRiconciliazione: "Email (chiave di riconciliazione)",
      iacobini: "Iacobini",
      cognome: "Cognome *",
      emanuele: "Emanuele",
      nome: "Nome *",
      inserisciIDatiDellaPersona: "Inserisci i dati della persona",
      esMarioRossiEmailItOppure: "Es. mario.rossi@email.it oppure Mario Rossi",
      cercaPerEmailONome: "Cerca per email o nome",
      invitaMembroDelloStaff: "Invita membro dello staff",
      anagraficaAggiuntaSaraCollegataAllAccount: "Anagrafica aggiunta. Sarà collegata all'account eDive alla registrazione.",
      invitoInviatoConSuccesso: "Invito inviato con successo!",
      almenoUnaTraEmailECellulare: "Almeno una tra email e cellulare è obbligatoria per la riconciliazione automatica.",
      tornaAllaRicerca: "← Torna alla ricerca",
      saraCollegataAutomaticamenteQuandoQuestaPersona: "Sarà collegata automaticamente quando questa persona si registrerà su eDive con la stessa email o telefono.",
      aggiungiComeNuovaAnagrafica: "Aggiungi come nuova anagrafica",
    },
    pagesDivecenterIssueCertificateWizard: {
      seLasciatoVuotoIlNumeroVerra: "Se lasciato vuoto, il numero verrà generato automaticamente.",
      esPadi1234567: "Es. PADI-1234567",
      numeroCertificatoOpzionale: "Numero certificato (opzionale)",
      nessunoStudenteAttivoTrovatoPerQuesto: "Nessuno studente attivo trovato per questo corso.",
      nessunCorsoAttivoTrovato: "Nessun corso attivo trovato.",
      selezionaIlCorsoPerIlQuale: "Seleziona il corso per il quale vuoi emettere un brevetto.",
      certificaIlCompletamentoDiUnCorso: "Certifica il completamento di un corso da parte di uno studente",
      emettiBrevetto: "Emetti brevetto",
      brevettoEmessoConSuccesso: "Brevetto emesso con successo!",
      ilBrevettoSaraAggiuntoAlProfilo: "Il brevetto sarà aggiunto al profilo dello studente e risulterà verificato dall'istruttore.",
    },
    pagesDivecenterJoinDiveCenterWizard: {
      presentatiBrevementeEsperienzaBrevettiDisponibilita: "Presentati brevemente: esperienza, brevetti, disponibilità…",
      facoltativo: "(facoltativo)",
      qualeRuoloVorrestiRicoprireIn: "Quale ruolo vorresti ricoprire in",
      nessunCentroTrovato: "Nessun centro trovato",
      digitaAlmeno2CaratteriPerCercare: "Digita almeno 2 caratteri per cercare",
      cambia: "Cambia",
      cercaPerNomeCentroCitta: "Cerca per nome centro, città…",
      inviaUnaRichiestaDiCollaborazione: "Invia una richiesta di collaborazione",
      entraInUnCentroSub: "Entra in un centro sub",
      richiestaInviata: "Richiesta inviata!",
      erroreNellInvioDellaRichiesta: "Errore nell'invio della richiesta",
      haiGiaUnaRichiestaPendentePer: "Hai già una richiesta pendente per questo centro",
      riceveraLaTuaRichiestaETi: "riceverà la tua richiesta e ti risponderà al più presto.",
    },
    pagesDivecenterTabsAdminTab: {
      erroreConversione: "Errore conversione",
      convertiTipo: "Converti tipo",
      dettagliCentro: "Dettagli centro",
      vaiAlPannelloAdminCentri: "Vai al pannello admin centri",
      strumentiAmministrativi: "Strumenti amministrativi",
    },
    pagesDivecenterTabsGestioneTab: {
      impostazioniCentro: "Impostazioni centro",
    },
    pagesDivecenterTabsOverviewTab: {
      suggeritoPerVicinanzaDaConfermareDal: "Suggerito per vicinanza — da confermare dal centro",
      tesseraSospesa: "Tessera sospesa",
      richiestaInAttesa: "Richiesta in attesa",
    },
    pagesDivecenterTabsStaffTab: {
      rimuoviDalTeam: "Rimuovi dal team",
      inattivo: "Inattivo",
      aggiungiIlTuoPrimoCollaboratore: "Aggiungi il tuo primo collaboratore",
      nessunMembroStaff: "Nessun membro staff",
      ruoloNelCentro: "Ruolo nel centro",
      nessunUtenteTrovato: "Nessun utente trovato",
      cercaPerNomeCognome: "Cerca per nome, cognome…",
      cercaUtenteEdive: "Cerca utente eDive",
      aggiungiMembroAlTeam: "Aggiungi membro al team",
      erroreRimozione: "Errore rimozione",
      membroRimossoDalTeam: "Membro rimosso dal team",
      membroAggiuntoAlTeam: "Membro aggiunto al team",
      membriDelloStaff: "Membri dello staff",
      aggiungiMembroStaff: "Aggiungi membro staff",
    },
    pagesDivecenterUnifiedDiveCenterPage: {
      ilCentroGestisceBriefingRegistroL: "Il centro gestisce briefing, registro L.70 e certificazione medica — tu pensi solo a immergerti.",
      immergiti: "Immergiti",
      riservaUnaSessioneUnCorsoO: "Riserva una sessione, un corso o un'escursione direttamente dalla piattaforma in pochi tap.",
      prenota: "Prenota",
      cercaUnCentroVicinoATe: "Cerca un centro vicino a te, filtra per specializzazione, lingua e certificazioni offerte.",
      scopri: "Scopri",
      comeFunziona: "Come funziona",
      conformitaNormativa: "Conformità normativa",
      strumenti: "Strumenti",
      corsiDisponibili: "Corsi disponibili",
      centriRegistrati: "Centri registrati",
      divingCenter: "Diving Center",
      sfogliaICentriRegistrati: "Sfoglia i centri registrati",
      cosaPuoiFare: "Cosa puoi fare",
      scopriCentriDiImmersionePrenotaSessioni: "Scopri centri di immersione, prenota sessioni, esplora corsi certificati e trova istruttori qualificati. Tutto ciò di cui hai bisogno per organizzare la tua attività subacquea.",
      registroEdive: "Registro eDive",
      divingCenterHub: "Diving Center Hub",
    },
    pagesDiverDivemasterOnboardingWizard: {
      presentatiDoveOperiEsperienzaTipiDi: "Presentati: dove operi, esperienza, tipi di immersioni che guidi…",
      bioProfessionale: "Bio professionale",
      visibilitaNellaDirectory: "Visibilità nella directory",
      esWreck: "Es. Wreck…",
      attivitaInCuiSeiEspertoCome: "Attività in cui sei esperto come DM.",
      specialita: "Specialità",
      esBlueOceanDivingSharmEl: "Es. Blue Ocean Diving, Sharm el Sheikh",
      centroStrutturaAttuale: "Centro / struttura attuale",
      paese: "Paese *",
      palermo: "Palermo",
      citta: "Città",
      seleziona: "— seleziona —",
      anniDiEsperienza: "Anni di esperienza",
      esPadi: "Es. PADI…",
      agenzieDiCertificazione: "Agenzie di certificazione *",
      mostraLaTuaEsperienzaAllaCommunity: "Mostra la tua esperienza alla community",
      configuraProfiloDivemaster: "Configura profilo Divemaster",
      erroreNelSalvataggio: "Errore nel salvataggio",
      profiloDivemasterConfigurato: "Profilo Divemaster configurato!",
      puoiApparireComeGuidaSuggeritaQuando: "Puoi apparire come guida suggerita quando i subacquei pianificano immersioni nella tua area.",
    },
    pagesDivesitesMPAZonesPage: {
      provaAModificareIFiltriDi: "Prova a modificare i filtri di ricerca.",
      nessunaZonaTrovata: "Nessuna zona trovata",
      riprovaPiuTardiOContattaL: "Riprova più tardi o contatta l'assistenza.",
      impossibileCaricareLeZoneProtette: "Impossibile caricare le zone protette",
      tuttiITipi: "Tutti i tipi",
      cercaPerNomeZonaOEnte: "Cerca per nome zona o ente gestore...",
      areeSoggetteARestrizioniAiSensi: "Aree soggette a restrizioni ai sensi della Legge 70/2026 e normativa ambientale italiana.",
      zoneMarineProtette: "Zone Marine Protette",
    },
    pagesDivesitesNearMePage: {
      nessunSitoTrovato: "Nessun sito trovato",
      escursioni: "Escursioni",
      centri: "Centri",
      siti: "Siti",
      aggiornaPosizione: "Aggiorna posizione",
      trovaSitiVicinoATe: "Trova siti vicino a te",
      corr: "Corr",
      vis: "Vis",
      vediCentro: "Vedi centro →",
      vediSito: "Vedi sito →",
      dettagli: "Dettagli",
      usaLaMiaPosizione: "Usa la mia posizione",
      rilevamentoPosizione: "Rilevamento posizione…",
      abilitaLaGeolocalizzazionePerScoprireSiti: "Abilita la geolocalizzazione per scoprire siti di immersione e centri sub nelle vicinanze.",
    },
    pagesDivesitesTabsConditionsWeatherTabs: {
      onde: "onde",
      corrente: "corrente",
      fondo: "fondo",
      superfice: "superfice",
      visibilita: "visibilità",
    },
    pagesDivesitesTabsInfoTab: {
      divingCenterNelleVicinanzeNonAncora: "Diving center nelle vicinanze, non ancora confermato dal centro",
      nessunAvvistamentoRegistratoSiiIlPrimo: "Nessun avvistamento registrato — sii il primo a segnalarne uno!",
      meteo: "🌊 Meteo",
      nautico: "⚓ Nautico",
      satellite: "🛰️ Satellite",
      specieAvvistate: "Specie avvistate",
      periodoOttimalePerImmergersi: "📅 Periodo Ottimale per Immergersi",
    },
    pagesEventsDCComplianceReportModal: {
      nessunaImmersioneCertificataNelPeriodoSelezionato: "Nessuna immersione certificata nel periodo selezionato",
      al: "Al",
      dal: "Dal",
      art12L702026Registro: "Art. 12 L.70/2026 — Registro immersioni certificate",
      rapportoConformita: "Rapporto Conformità",
      ediveRapportoGeneratoAutomaticamenteAiSensi: "eDive · Rapporto generato automaticamente ai sensi dell'Art.12 L.70/2026 · Documento non sostitutivo del registro originale",
      profonditaMassima: "Profondità massima",
      conPreDiveCheck: "Con pre-dive check",
      partecipantiTotali: "Partecipanti totali",
      immersioniCertificate: "Immersioni certificate",
      rapportoConformitaImmersioni: "Rapporto Conformità Immersioni",
      piattaformaDivingItaliana: "Piattaforma Diving Italiana",
      dive: "Dive",
      rapportoConformitaL702026: "Rapporto Conformità L.70/2026",
      idoneitaMedica: "Idoneità medica",
      profonditaMax: "Profondità max",
      nBrevetto: "N° brevetto",
      brevetto: "Brevetto",
      ente: "Ente",
      idSubacqueo: "ID Subacqueo",
      stampaRapporto: "Stampa rapporto",
    },
    pagesEventsDCExcursionsPage: {
      guida: "Guida",
      gas: "Gas",
      durata: "Durata",
      profonditaMax: "Profondità max",
      rapportoL70: "Rapporto L.70",
      certificaImmersione: "Certifica immersione",
      certificata: "Certificata",
      preDive: "Pre-dive ✓",
    },
    pagesEventsExcursionCertifyModal: {
      certificaERegistraNelLogbook: "Certifica e registra nel logbook",
      certificazione: "Certificazione…",
      condizioniMeteoFaunaOsservazioniParticolari: "Condizioni meteo, fauna, osservazioni particolari…",
      noteOpzionale: "Note (opzionale)",
      es20: "es. 20",
      visibilitaM: "Visibilità (m)",
      es22: "es. 22",
      tempAcquaC: "Temp. acqua (°C)",
      miscelaRespiratoria: "Miscela respiratoria",
      oraUscita: "Ora uscita",
      oraIngresso: "Ora ingresso",
      es45: "es. 45",
      es18: "es. 18",
      nomeECognome: "Nome e cognome",
      art12L702026Registro: "Art. 12 L. 70/2026 — Registro post-immersione",
      certificaImmersione: "Certifica Immersione",
      eLImmersioneVerraMarcataCome: "e l'immersione verrà marcata come completata.",
    },
    pagesEventsExcursionPreDiveModal: {
      registraPreDiveCheck: "Registra pre-dive check",
      salvataggio: "Salvataggio…",
      es1234567: "es. 1234567",
      nBrevetto: "N° brevetto",
      technicalGt40m: "Technical (&gt;40m)",
      rescueDmMax40m: "Rescue/DM (max 40m)",
      advancedMax30m: "Advanced (max 30m)",
      openWaterMax18m: "Open Water (max 18m)",
      seleziona: "Seleziona",
      livelloBrevetto: "Livello brevetto",
      ente: "Ente",
      nessunPartecipanteConfermato: "Nessun partecipante confermato",
      nomeECognomeDellaGuidaIstruttore: "Nome e cognome della guida/istruttore",
      rapportoGuidaSubacquei: "Rapporto guida:subacquei",
      art12L702026Registro: "Art. 12 L. 70/2026 — Registro brevetti partecipanti",
      checkPreImmersione: "Check Pre-Immersione",
      preDiveCheckRegistrato: "Pre-dive check registrato",
      idoneitaMedicaVerificataAutodichiarazioneRaccolta: "Idoneità medica verificata / autodichiarazione raccolta",
      caricamentoPartecipanti: "Caricamento partecipanti…",
    },
    pagesGamesSpeciesQuizPage: {
      leFotoProvengonoDallEnciclopediaEdive: "Le foto provengono dall'enciclopedia eDive. Impara riconoscendo!",
      classificaInArrivoGiocaPerPrimo: "Classifica in arrivo… gioca per primo!",
      registrati: "Registrati",
      classifica: "Classifica",
      studiaLeSpecie: "Studia le specie",
      giocaAncora: "Gioca ancora",
      traguardoSbloccato: "Traguardo sbloccato",
      nuovoRecordPersonale: "Nuovo record personale! 🎉",
      specieDaIndovinare: "specie da indovinare",
      iniziaAGiocare: "Inizia a giocare",
      caricoLeSpecie: "Carico le specie…",
      recordPersonale: "Record personale",
      riconosciLaSpecie: "🐠 Riconosci la specie",
      riconosciLaSpecieGiocoEdive: "Riconosci la specie — Gioco eDive",
      perEntrareInClassificaESfidare: "per entrare in classifica e sfidare gli altri sub.",
    },
    pagesGdprGDPRPage: {
      supportEdiveTech: "support@edive.tech",
      privacyPolicy: "Privacy policy",
      richiesteGdpr: "Richieste GDPR",
      gestioneConsensi: "Gestione consensi",
      gestisciITuoiConsensiELe: "Gestisci i tuoi consensi e le richieste GDPR (Reg. UE 2016/679)",
      privacyDatiPersonali: "Privacy & Dati personali",
      digitaCancella: "Digita CANCELLA",
      cancellaAccount: "Cancella account",
      esportaITuoiDati: "Esporta i tuoi dati",
      scaricaArchivio: "Scarica archivio",
      richiestePrecedenti: "Richieste precedenti",
      nessunaModificaRegistrata: "Nessuna modifica registrata",
      storicoConsensi: "Storico consensi",
      nessunConsensoRegistrato: "Nessun consenso registrato",
      vediStorico: "Vedi storico",
      perConfermare: "per confermare.",
      tuttiITuoiDatiPersonaliVerranno: "Tutti i tuoi dati personali verranno eliminati in modo irreversibile da tutti i sistemi",
    },
    pagesHelpManualiPage: {
      consigliatoPerTe: "Consigliato per te",
      guideOperativeCompletePerOgniRuolo: "Guide operative complete per ogni ruolo: funzioni, wizard passo-passo, glossario e FAQ. Scarica il PDF o aprilo nel browser.",
      manualiDUso: "Manuali d'uso",
      ilTuoRuolo: "Il tuo ruolo",
      scaricaPdf: "Scarica PDF",
    },
    pagesInstallInstallPage: {
      copiaIlLinkEApriloSul: "Copia il link e aprilo sul tuo smartphone per installare l'app.",
      apriSuUnAltroDispositivo: "Apri su un altro dispositivo",
      installazioneSuIphoneIpadSafari: "Installazione su iPhone/iPad (Safari)",
      installazioneManualeChrome: "Installazione manuale (Chrome)",
      installaEdive: "Installa eDive",
      ediveEGiaInstallatoSulTuo: "eDive è già installato sul tuo dispositivo. Puoi aprirlo direttamente dalla schermata home.",
      appInstallata: "App installata!",
      suIosLInstallazioneFunzionaSolo: "Su iOS l'installazione funziona solo con Safari. Assicurati di usare Safari, non Chrome o Firefox.",
      ilPulsanteDiInstallazioneAutomaticaNon: "Il pulsante di installazione automatica non è disponibile in questo momento. Segui le istruzioni manuali qui sotto.",
      installaEdiveSuAndroid: "Installa eDive su Android",
      aggiungiEdiveAllaSchermataHomeDel: "Aggiungi eDive alla schermata home del tuo smartphone per un'esperienza nativa: avvio rapido, notifiche push e accesso offline al logbook.",
    },
    pagesInstructorInstructorDirectoryPage: {
      nessunIstruttoreTrovato: "Nessun istruttore trovato",
      paese: "Paese…",
      tutteLeSpecialita: "Tutte le specialità",
      tutteLeAgenzie: "Tutte le agenzie",
      nomeCittaSpecialita: "Nome, città, specialità…",
      cercaIstruttoriCertificatiPerAgenziaSpecialita: "Cerca istruttori certificati per agenzia, specialità e zona",
      trovaUnIstruttore: "Trova un istruttore",
      online: "Online ✓",
      nessunaRecensione: "Nessuna recensione",
      rimuoviIFiltri: "Rimuovi i filtri",
      azzeraFiltri: "Azzera filtri",
    },
    pagesInstructorMyCertificationsPage: {
      inserisciManualmente: "Inserisci manualmente",
    },
    pagesInsuranceInsurancePage: {
      attivaPolizza: "Attiva polizza",
      polizzeScaduteAnnullate: "Polizze scadute/annullate",
      nessunaPolizzaAttiva: "Nessuna polizza attiva",
      danEurope: "DAN Europe",
      dan123456: "DAN-123456",
      tesseraDanOpzionale: "Tessera DAN (opzionale)",
      esPuntaCampanella: "Es. Punta Campanella",
      sitoDiImmersione: "Sito di immersione",
      descriviBrevementeLaSituazione: "Descrivi brevemente la situazione…",
      messaggioDiEmergenza: "Messaggio di emergenza",
      inviaSegnaleDiEmergenzaAiSoccorsi: "Invia segnale di emergenza ai soccorsi subacquei",
      emergenzaSos: "Emergenza SOS",
      impossibileOttenereLaPosizione: "Impossibile ottenere la posizione",
      sosInviato: "SOS inviato",
      rossi: "Rossi",
      cognomeOpzionale: "Cognome (opzionale)",
      esDan123456: "es. DAN-123456",
      numeroTesseraDan: "Numero tessera DAN *",
      controllaLaValiditaDelNumeroDi: "Controlla la validità del numero di tessera DAN",
      verificaTesseraDan: "Verifica tessera DAN",
      nessunContattoDisponibile: "Nessun contatto disponibile",
      caricamento: "Caricamento...",
      numeriDanEServiziDiSoccorso: "Numeri DAN e servizi di soccorso per paese",
      contattiDiEmergenzaGlobali: "Contatti di emergenza globali",
      nonRisultanoPolizzeAttivePerLa: "Non risultano polizze attive per la data odierna.",
      nessunaCoperturaAttiva: "Nessuna copertura attiva",
      seiCoperto: "✓ Sei coperto",
      verificaInCorso: "Verifica in corso...",
      controllaSeSeiCopertoPerUn: "Controlla se sei coperto per un'immersione oggi",
      verificaCoperturaAttiva: "Verifica copertura attiva",
      descriviLIncidenteOIlDanno: "Descrivi l'incidente o il danno (min. 10 caratteri)",
      sitoUfficialeDan: "sito ufficiale DAN",
      usareSoloInCasoDiReale: "⚠️ Usare solo in caso di reale emergenza subacquea. Il segnale viene inoltrato ai centri di soccorso.",
    },
    pagesLandingLandingPage: {
      madeWithInItaly: "Made with 🤿 in Italy",
      facebookEdive: "📘 Facebook: eDive",
      whatsapp393397641396: "💬 WhatsApp: +39 339 7641396",
      supportEdiveTech: "✉ support@edive.tech",
    },
    pagesLogbookDiveComparePage: {
      confrontaImmersioni: "Confronta immersioni",
      chiudi: "← Chiudi",
      risultatoConfronto: "Risultato confronto",
      nessunConfrontoAncoraCreaneUnoNella: "Nessun confronto ancora. Creane uno nella tab \"Nuovo confronto\".",
      caricamento: "Caricamento...",
      condividiQuestoLinkConIlDiver: "Condividi questo link con il diver con cui vuoi confrontare l'immersione. Appena accetterà vedrai il confronto qui.",
      linkDiInvitoCreato: "Link di invito creato!",
      esStessaImmersioneACapoVaticano: "es. Stessa immersione a Capo Vaticano, confrontiamo i profili...",
      messaggioOpzionale: "Messaggio (opzionale)",
      scegliLImmersioneDaConfrontare: "Scegli l'immersione da confrontare",
      laTuaImmersione: "La tua immersione",
      richiediConfronto: "Richiedi confronto",
      invitoAlConfrontoRicevuto: "Invito al confronto ricevuto",
      annulla: "Annulla",
      seleziona: "— Seleziona —",
      selezionaLImmersioneCheVuoiConfrontare: "Seleziona l'immersione che vuoi confrontare. Solo i parametri numerici anonimizzati saranno visibili all'altro diver.",
      rifiuta: "Rifiuta",
      accetta: "Accetta",
      nessunParametroComparabileDisponibile: "Nessun parametro comparabile disponibile.",
      parametro: "Parametro",
      confrontoParametri: "Confronto parametri",
      paese: "Paese",
      selezionaUnaTuaImmersioneGeneraIl: "Seleziona una tua immersione, genera il link e condividilo con un altro diver.",
      accettaEScegliLaTuaImmersione: "Accetta e scegli la tua immersione",
      accettaConfronto: "Accetta confronto",
      vediRisultato: "Vedi risultato",
    },
    pagesLogbookDiveLogPDF: {
      visM: "Vis m",
      min: "Min",
      maxM: "Max m",
      sitoTipo: "Sito / Tipo",
      data: "Data",
      registroImmersioni: "REGISTRO IMMERSIONI",
      logbookPersonale: "Logbook personale",
      generatoDaEdiveEdiveApp: "Generato da eDive · edive.app",
    },
    pagesLogbookDiveSharePage: {
      registraAncheLeTueImmersioni: "Registra anche le tue immersioni",
      visibilita: "Visibilità",
      tAcqua: "T. acqua",
      durata: "Durata",
      profonditaMax: "Profondità max",
      immersioneCondivisaSuEdive: "Immersione condivisa su eDive",
      vaiAEdive: "Vai a eDive →",
      questoLinkPotrebbeEssereScadutoO: "Questo link potrebbe essere scaduto o l'immersione è privata.",
      immersioneNonTrovataOPrivata: "Immersione non trovata o privata",
      caricamentoImmersione: "Caricamento immersione…",
      "0Min": "0 min",
      ilLogbookSubacqueo: "— il logbook subacqueo",
      uniscitiAEdive: "Unisciti a eDive",
      profiloDiProfondita: "Profilo di profondità",
    },
    pagesLogbookGasPlannerPage: {
      modPpo16: "MOD (ppO₂ 1.6)",
      modPpo14: "MOD (ppO₂ 1.4)",
      noFly: "No-Fly",
      sacRate: "SAC Rate",
    },
    pagesLogbookLogbookReconcileModal: {
      importazione: "Importazione…",
      leImmersioniSelezionateSonoOraNel: "Le immersioni selezionate sono ora nel tuo logbook",
      importazioneCompletata: "Importazione completata",
      nuovaImmersione: "Nuova immersione",
      nuoveDaImportare: "Nuove da importare",
      giaNelLogbook: "Già nel logbook",
      trovateNelFile: "Trovate nel file",
      garminSuuntoShearwaterMacdiveSubsurfaceE: "Garmin · Suunto · Shearwater · MacDive · Subsurface e altri",
      formatiSupportatiUddfXmlUddfCsv: "Formati supportati: UDDF (.xml, .uddf) · CSV (.csv)",
      cliccaPerSelezionareIlFile: "Clicca per selezionare il file",
      importaDalComputerSubacqueoSenzaDuplicati: "Importa dal computer subacqueo senza duplicati",
      riconciliazioneLogbook: "Riconciliazione Logbook",
      fileNonValidoOFormatoNon: "File non valido o formato non supportato",
      nessunaImmersioneTrovataNelFile: "Nessuna immersione trovata nel file",
      erroreDuranteLImportazione: "Errore durante l'importazione",
      erroreDuranteLaRiconciliazione: "Errore durante la riconciliazione",
      selezionaLeImmersioniDaImportareLe: "Seleziona le immersioni da importare. Le già presenti nel logbook sono pre-deselezionate.",
      analisiInCorso: "Analisi in corso…",
      caricaIlFileEsportatoDalTuo: "Carica il file esportato dal tuo computer subacqueo o dal software di gestione.",
    },
    pagesMarineMarineMediaDetailPage: {
      eliminaAnnotazione: "Elimina annotazione",
      nessunaAnnotazioneAncoraSiiIlPrimo: "Nessuna annotazione ancora. Sii il primo!",
      approvatoIl: "Approvato il",
      approvatoDa: "Approvato da",
      specieAi: "Specie AI",
      tipoFile: "Tipo file",
      dimensione: "Dimensione",
      autore: "Autore",
      dataScatto: "Data scatto",
      profondita: "Profondità",
      metadati: "Metadati",
      approvaTraining: "Approva Training",
      rimuoviTraining: "Rimuovi Training",
      mediaNonTrovato: "Media non trovato.",
      annotazioneEliminata: "Annotazione eliminata",
      approvatoPerTrainingAi: "Approvato per training AI",
      approvazioneTrainingRimossa: "Approvazione training rimossa",
      mediaEliminato: "Media eliminato",
      noteOpzionale: "Note (opzionale)",
      tipo: "Tipo",
      annotazioneAggiunta: "Annotazione aggiunta",
      profonditaM: "Profondità (m)",
      descrizione: "Descrizione",
      titolo: "Titolo",
      modificaMedia: "Modifica media",
      mediaAggiornato: "Media aggiornato",
      elimina: "Elimina",
      modifica: "Modifica",
      galleryScientifica: "Gallery scientifica",
      nuovaAnnotazione: "Nuova annotazione",
    },
    pagesMarineMarineTrainingHubPage: {
      gestisciIlDatasetEIJob: "Gestisci il dataset e i job di training per il modello AI marino",
      top10SpecieNelDataset: "Top 10 specie nel dataset",
      trainingAvviato: "Training avviato!",
      annotazioni: "Annotazioni",
      dataApprovazione: "Data approvazione",
      approvatoDa: "Approvato da",
      confidenzaAi: "Confidenza AI",
      specieValidata: "Specie validata",
      file: "File",
      nessunMediaNelDataset: "Nessun media nel dataset",
      caricamentoDataset: "Caricamento dataset…",
      distribuzioneSpecie: "Distribuzione specie",
      filtraPerSpecie: "Filtra per specie",
      rimossoDalDataset: "Rimosso dal dataset",
      specieNonIdentificata: "Specie non identificata",
      aggiorna: "Aggiorna",
      mediaApprovatiPerIlTraining: "Media approvati per il training",
      erroreDuranteLApprovazione: "Errore durante l'approvazione",
      mediaApprovatoPerIlTraining: "Media approvato per il training",
      esAggiuntaNuoveSpecieMediterraneo: "es. Aggiunta nuove specie Mediterraneo...",
      noteOpzionale: "Note (opzionale)",
      trainingHub: "Training Hub",
      nessunTrainingJobAvviaIlPrimo: "Nessun training job. Avvia il primo training!",
      caricamentoJob: "Caricamento job…",
      avviaNuovoTraining: "Avvia Nuovo Training",
      trainingInCorso: "Training in corso…",
      questiMediaSonoStatiValidatiMa: "Questi media sono stati validati ma non ancora inclusi nel dataset di training. Approvali per aggiungerli.",
      mediaApprovatiNelDataset: "media approvati nel dataset.",
      avviaTrainingAi: "Avvia Training AI",
    },
    pagesMediaMediaPage: {
      leImmaginiNellEnciclopedia: "Le immagini nell'enciclopedia",
      immaginiEVideoSubacqueiPrivatiIn: "Immagini e video subacquei — privati, in revisione o nell'enciclopedia",
      fotoSubacquee: "Foto Subacquee",
      immagineEliminata: "Immagine eliminata",
      correggiColoriFotoSubacquee: "Correggi colori (foto subacquee)",
      identificaPrimaLaSpecie: "Identifica prima la specie",
      specieNonIdentificata: "Specie non identificata",
      caricaIdentifica: "Carica & Identifica",
      identificaPrima: "Identifica prima",
    },
    pagesMedicalDiveDoctorPage: {
      subacquea: "Subacquea",
      max: "Max",
      min: "Min",
      nome: "Nome",
      nessunAnalitaTrovato: "Nessun analita trovato",
      caricamentoCatalogo: "Caricamento catalogo…",
      cercaAnalitaNomeCodice: "Cerca analita (nome, codice)…",
      iTuoiArticoliPubblicati: "I tuoi articoli pubblicati",
      compensazionePrevenzioneFisiologia: "Compensazione, prevenzione, fisiologia",
      gruppiTematici: "Gruppi tematici",
      rispondiADomandeGenericheDellaCommunity: "Rispondi a domande generiche della community",
      domandeRisposte: "Domande & Risposte",
      condividiLineeGuidaPrevenzioneFisiologia: "Condividi linee guida, prevenzione, fisiologia",
      scriviUnArticolo: "Scrivi un articolo",
      protocolloDiPrimoSoccorsoSubacqueo: "Protocollo di primo soccorso subacqueo",
      algoritmoDiRispostaRapida: "Algoritmo di risposta rapida",
      visitaSpecialistica: "→ visita specialistica",
      riferimentoInformativoBasatoSuPadiDmq: "Riferimento informativo basato su PADI DMQ e WRSTC.",
      postImmersione: "Post-immersione",
      panoramica: "Panoramica",
      ultimi30Giorni: "Ultimi 30 giorni",
      profonditaMedia: "Profondità media",
      profonditaMax: "Profondità max",
      immersioniTotali: "Immersioni totali",
      datiNonAncoraCondivisi: "Dati non ancora condivisi",
      inAttesaDiRisposta: "In attesa di risposta",
      partecipaAiGruppiTematici: "Partecipa ai gruppi tematici",
      community: "Community",
      supportaLaCommunityInModoNon: "Supporta la community in modo non clinico",
      rispondiADomande: "Rispondi a domande",
      condividiConoscenzeConLaCommunity: "Condividi conoscenze con la community",
      pubblicaUnArticolo: "Pubblica un articolo",
      segnaComeLetto: "Segna come letto",
      partecipaAllaCommunityCondividendoConoscenzePreventive: "Partecipa alla community condividendo conoscenze preventive e informative.",
      centriIperbariciItalia: "Centri iperbarici — Italia",
      numeriDiEmergenzaSubacquea: "Numeri di emergenza subacquea",
      schemaDiRiferimentoBasatoSuLinee: "Schema di riferimento basato su linee guida DAN, UHMS e algoritmi di triage subacqueo.",
      schedeInformativeBasateSuLineeGuida: "Schede informative basate su linee guida UHMS, DAN Europe e PADI Medical.",
      altaFrequenzaDiImmersioniNellUltimo: "Alta frequenza di immersioni nell'ultimo mese. Potrebbe essere utile orientare il subacqueo verso un controllo preventivo.",
      inserisciLIdUtenteDelSubacqueo: "Inserisci l'ID utente del subacqueo. Una volta accettato l'invito, potrai visualizzare",
    },
    pagesMedicalSafetySection: {
      danMember: "DAN member #",
      condividiLaMiaSchedaEmergenzaDurante: "Condividi la mia scheda emergenza durante le immersioni",
      danInternational: "DAN International",
      quandoAttivoIlDivingCenterLa: "Quando attivo, il diving center, la guida/divemaster e i compagni della stessa",
    },
    pagesMedicalTabsLabTab: {
      riAnalizzaDocumento: "Ri-analizza documento",
      passwordDelPdf: "Password del PDF...",
      pdfProtettoDaPassword: "PDF protetto da password",
      pdfPdfAJpgPngMax: "PDF, PDF-A, JPG, PNG — max 20 MB",
      erroreNelRiavvioDellAnalisi: "Errore nel riavvio dell'analisi",
      riAnalisiAvviata: "Ri-analisi avviata",
      flag: "Flag",
      eProtettoDaPasswordInserisciLa: "è protetto da password. Inserisci la password per procedere con l'analisi.",
    },
    pagesMedicalTabsReportsImagingTabs: {
      analisiAiInCorso: "Analisi AI in corso...",
      ultimo: "· ultimo",
      confrontoRefertiPerSpecializzazione: "Confronto referti per specializzazione",
      testoGrezzoEstrattoOcr: "Testo grezzo estratto (OCR)",
      caricaIlPrimoRefertoMedicoPer: "Carica il primo referto medico per tenere traccia della tua idoneità subacquea.",
      nessunRefertoCaricato: "Nessun referto caricato",
      estrazioneParzialeCompletaICampiMancanti: "Estrazione parziale — completa i campi mancanti",
      datiEstrattiAutomaticamenteVerificaECorreggi: "✓ Dati estratti automaticamente — verifica e correggi se necessario",
      pdfJpgPngMax20Mb: "PDF, JPG, PNG — max 20 MB",
      cliccaPerScegliereIlFile: "Clicca per scegliere il file",
      selezionaUnPdfOUnaFoto: "Seleziona un PDF o una foto del referto. I dati verranno estratti automaticamente.",
      caricaRefertoMedico: "Carica referto medico",
      estrazioneAutomaticaNonRiuscitaPuoiCompilare: "Estrazione automatica non riuscita. Puoi compilare i campi manualmente.",
    },
    pagesMedicalTabsVitalsPdfExport: {
      impossibileGenerareIlPdf: "Impossibile generare il PDF",
      schedaParametriEsportata: "Scheda parametri esportata",
      ediveFascicoloSanitarioElettronico: "eDive · Fascicolo Sanitario Elettronico",
      note: "Note",
      pesoKg: "Peso (kg)",
      spo: "SpO₂",
      fcBpm: "FC (bpm)",
      paMmhg: "PA (mmHg)",
      data: "Data",
      storicoRilevazioni: "Storico rilevazioni",
      peso: "Peso",
      frequenzaCardiaca: "Frequenza cardiaca",
      pressione: "Pressione",
      riepilogoUltimoValoreEVariazioneNel: "Riepilogo (ultimo valore e variazione nel periodo)",
      schedaParametriDiPrevenzione: "Scheda parametri di prevenzione",
      documentoGeneratoDaEdiveDalFascicolo: "Documento generato da eDive dal Fascicolo Sanitario dell'utente ai fini di consultazione medica.",
    },
    pagesMerchMerchShopPage: {
      roma: "Roma",
      viaRoma1: "Via Roma 1",
      marioRossi: "Mario Rossi",
      tuEsempioIt: "tu@esempio.it",
      accediPerRitrovareIlCarrelloSugli: "Accedi per ritrovare il carrello sugli altri tuoi dispositivi.",
    },
    pagesNotificationsNotificationsPage: {
      da: "Da",
      oreSilenzioseUtc: "Ore silenziose (UTC)",
      erroreNellAggiornamentoPreferenze: "Errore nell'aggiornamento preferenze",
      preferenzeNotifiche: "Preferenze notifiche",
    },
    pagesPhotographerPhotographerOnboardingWizard: {
      directoryFotografiSubacquei: "directory fotografi subacquei",
      visibilitaNellaDirectoryFotografi: "Visibilità nella directory fotografi",
      esMaldive: "Es. Maldive…",
      destinazioniDoveLavoriOHaiEsperienza: "Destinazioni dove lavori o hai esperienza.",
      zoneOperative: "Zone operative",
      esCanonEosR5: "Es. Canon EOS R5…",
      corpoMacchinaHousingOtticheIlluminazione: "Corpo macchina, housing, ottiche, illuminazione.",
      attrezzaturaFotografica: "Attrezzatura fotografica",
      presentatiAnniDiEsperienzaStileFotografico: "Presentati: anni di esperienza, stile fotografico, specializzazioni (macro, grandangolo, video), premi…",
      bioProfessionale: "Bio professionale",
      sitoPersonaleInstagramBehance500px: "Sito personale, Instagram, Behance, 500px…",
      urlPortfolio: "URL portfolio",
      mostraIlTuoPortfolioAllaCommunity: "Mostra il tuo portfolio alla community e ai centri diving",
      configuraProfiloFotografoSubacqueo: "Configura profilo fotografo subacqueo",
      erroreNelSalvataggio: "Errore nel salvataggio",
      profiloFotografoConfigurato: "Profilo fotografo configurato!",
      ePotraiCaricareFotoCheContribuiscono: "e potrai caricare foto che contribuiscono all'enciclopedia marina di eDive.",
      iCentriDivingPossonoCercartiPer: "I centri diving possono cercarti per collaborazioni fotografiche nelle loro destinazioni.",
    },
    pagesPhotographerPhotographerPortalPage: {
      leMieContribuzioni: "Le mie contribuzioni",
      comeFunziona: "Come funziona",
      usaIlModuloSopraPerContribuire: "Usa il modulo sopra per contribuire alla banca dati marina.",
      nonHaiAncoraInviatoNessunaFoto: "Non hai ancora inviato nessuna foto.",
      caricamento: "Caricamento...",
      esclusivamentePerLaConsultazioneDellaBanca: "esclusivamente per la consultazione della banca dati marina",
      dataELuogoDelloScattoCondizioni: "Data e luogo dello scatto, condizioni visibilità, profondità...",
      noteOpzionale: "Note (opzionale)",
      inserisciIlLinkDirettoAllImmagine: "Inserisci il link diretto all'immagine. Assicurati che sia pubblica e di tua proprietà.",
      urlDellImmagine: "URL dell'immagine",
      cercaSpecieEsDentexDentex: "Cerca specie (es. Dentex dentex)...",
      specie: "Specie",
      erroreDuranteLInvioRiprova: "Errore durante l'invio. Riprova.",
      fotoInviataSaraRevisionataDalTeam: "Foto inviata! Sarà revisionata dal team di biologia marina.",
      contribuisciUnaFoto: "Contribuisci una foto",
    },
    pagesPlanningComponentsDivePlanPDF: {
      min: "min",
    },
    pagesPlanningComponentsDiveProfileChart: {
      inversioneGas: "inversione gas",
      bar: "bar",
      sat: "sat %",
      comp: "comp.",
      ttsMin: "TTS (min)",
      inversione: "↑ INVERSIONE",
      pressioneBombole: "pressione bombole",
    },
    pagesPlanningPlanningDisclaimer: {
      hoLettoEAccettoLeCondizioni: "Ho letto e accetto le condizioni sopra indicate",
      avvisoDiSicurezza: "Avviso di Sicurezza",
      laPianificazioneDelleImmersioniEGenerata: "La pianificazione delle immersioni è generata da software dedicati e potrebbe non riflettere tutte",
    },
    pagesPlanningTabsSafetyTab: {
      ppo: "ppO₂",
      narcosis: "Narcosis",
      endEquivalentNarcoticDepthTotalNarcotic: "• END: Equivalent Narcotic Depth — total narcotic contribution (O₂ + N₂)",
      eadEquivalentAirDepthNarcoticLoad: "• EAD: Equivalent Air Depth — narcotic load of nitrox/trimix referenced to air depth",
      narcoticDepth: "narcotic depth",
      equivAirDepth: "equiv. air depth",
      bar: "bar",
      he: "He %",
      critiche: "critiche",
      primaDiEntrareInAcqua: "prima di entrare in acqua",
      danItalia390642115685: "DAN Italia +39 06 4211 5685",
      ossigenoAl100: "ossigeno al 100%",
      ricompressioneInCameraIperbarica: "ricompressione in camera iperbarica",
      oEmboliaGassosaArteriosaPuoManifestarsi: "— o embolia gassosa arteriosa — può manifestarsi minuti o ore dopo la risalita. Il trattamento standard è la",
      malattiaDaDecompressioneMdd: "malattia da decompressione (MDD)",
      sonoIndispensabiliPerIlTrattamentoDella: "sono indispensabili per il trattamento della malattia da decompressione — non immergerti se non sono disponibili.",
    },
    pagesProfessionalsProfessionalsDirectoryPage: {
      provaACambiareIFiltriO: "Prova a cambiare i filtri o la ricerca.",
      nessunProfessionistaTrovato: "Nessun professionista trovato.",
      caricamento: "Caricamento…",
      cercaPerNomeSpecialitaZona: "Cerca per nome, specialità, zona…",
      trovaIstruttoriMediciIperbariciFotografiSubacquei: "Trova istruttori, medici iperbarici, fotografi subacquei, centri diving e agenzie di viaggio verificati su eDive.",
      directoryProfessionisti: "Directory Professionisti",
      accettaPazienti: "Accetta pazienti",
      richiediLezione: "Richiedi lezione ›",
      lezioniOnline: "Lezioni online",
      creaIlTuoProfiloProfessionaleSu: "Crea il tuo profilo professionale su eDive e fatti trovare da migliaia di subacquei.",
    },
    pagesProfileCertCardPage: {
      comeFunziona: "Come funziona",
      qrValidoPer24Ore: "QR valido per 24 ore",
      qrCodeVerificaCertificazione: "QR Code verifica certificazione",
      dataEmissione: "Data emissione",
      numero: "Numero",
      codice: "Codice",
      cartaCertificazioneDigitale: "Carta Certificazione Digitale",
      certificazioneNonTrovata: "Certificazione non trovata.",
      cartaCertificazione: "Carta Certificazione",
      caricamento: "Caricamento...",
      erroreCopia: "Errore copia",
      linkCopiato: "Link copiato!",
      ilDivingCenterScansionaIlQr: "Il diving center scansiona il QR o apre il link per verificare istantaneamente la tua",
      copiaLink: "Copia link",
      qrNonDisponibile: "QR non disponibile",
      tornaAlProfilo: "Torna al profilo",
    },
    pagesProfileCertVerifyPage: {
      emessaIl: "Emessa il",
      numero: "Numero",
      verificaCertificazioneSubacquea: "Verifica Certificazione Subacquea",
      certificazioneVerificataTramiteEdiveQrValido: "Certificazione verificata tramite eDive · QR valido 24 ore",
      ediveVerified: "eDive Verified",
      valido: "Valido",
    },
    pagesProfileCertWalletVerifyPage: {
      subacqueoVerificato: "Subacqueo Verificato",
      verificaPortafoglioCertificazioni: "Verifica Portafoglio Certificazioni",
      verificatoTramiteEdiveCertificazioniConStatus: "Verificato tramite eDive · Certificazioni con status VERIFIED in data odierna",
      valido: "Valido",
    },
    pagesProfileCheckInQRPage: {
      qrCheckIn: "QR check-in",
      qrDiVerifica: "QR di Verifica",
      mostraQuestoQrAlBancoDel: "Mostra questo QR al banco del diving per la verifica istantanea",
      checkInQr: "Check-in QR",
      ilDivingCenterScansionaIlQr: "Il diving center scansiona il QR code per verificare istantaneamente le tue",
      comeFunziona: "Come funziona",
      rigeneraQr: "Rigenera QR",
      qrInScadenza: "QR in scadenza",
      prontoPerImmersione: "Pronto per immersione",
      erroreNelCaricamentoDelQrRiprova: "Errore nel caricamento del QR. Riprova.",
      verificato: "Verificato",
    },
    pagesProfileEmergencyMedicalVerifyPage: {
      noteDiEmergenza: "Note di Emergenza",
      restrizioniImmersioni: "Restrizioni Immersioni",
      patologie: "Patologie",
      farmaciInUso: "Farmaci in Uso",
      gruppoSanguigno: "Gruppo Sanguigno",
      subacqueo: "Subacqueo",
      impossibileVerificareIlQrCodePotrebbe: "Impossibile verificare il QR code. Potrebbe essere scaduto o danneggiato.",
      qrNonValido: "QR Non Valido",
      schedaDiEmergenzaSubacquea: "Scheda di Emergenza Subacquea",
      contattoDiEmergenza: "Contatto di Emergenza",
      allergie: "Allergie",
      verificato: "Verificato",
    },
    pagesProfileEmergencyQRPage: {
      comeFunziona: "Come funziona",
      qrEmergenzaMedica: "QR emergenza medica",
      scansionaInCasoDiEmergenza: "Scansiona in caso di emergenza",
      unQrPermanenteCheUnSoccorritore: "Un QR permanente che un soccorritore può scansionare — senza app né login — per vedere i tuoi dati salvavita.",
      tesseraDiEmergenza: "Tessera di emergenza",
      impossibileRigenerareIlCodice: "Impossibile rigenerare il codice",
      nuovoCodiceGeneratoLeTessereStampate: "Nuovo codice generato — le tessere stampate in precedenza non sono più valide",
      stampaTessera: "Stampa tessera",
      rigeneraCodice: "Rigenera codice",
      codicePermanenteValidoFincheNonLo: "Codice permanente · valido finché non lo rigeneri",
      ediveEmergenzaMedica: "eDive — Emergenza medica",
    },
    pagesProfileEquipmentPage: {
      annulla: "Annulla",
      note: "Note",
      fornitore: "Fornitore",
      prossimaRevisione: "Prossima revisione",
      dataAcquisto: "Data acquisto",
      prezzoAcquisto: "Prezzo acquisto (€)",
      numeroSeriale: "Numero seriale",
      modello: "Modello",
      marca: "Marca",
      categoria: "Categoria",
      nessunaRevisioneRegistrata: "Nessuna revisione registrata",
      officina: "Officina",
      tecnico: "Tecnico",
      costo: "Costo (€)",
      data: "Data",
      aggiungi: "+ Aggiungi",
      storicoRevisioni: "Storico Revisioni",
      ritira: "Ritira",
      aggiungiRicarica: "Aggiungi ricarica",
      entro30gg: "Entro 30gg",
      scaduta: "Scaduta",
    },
    pagesProfilePublicDiverProfilePage: {
      caricamento: "Caricamento...",
      paesi: "Paesi",
      oreInAcqua: "Ore in acqua",
      profonditaMax: "Profondità max",
      immersioni: "Immersioni",
      statisticheImmersioni: "Statistiche immersioni",
      seguiti: "seguiti",
      follower: "follower",
      segui: "Segui",
      nonSeguire: "Non seguire",
      apriChat: "Apri chat",
      profiloNonTrovato: "Profilo non trovato.",
      nessunBrevettoRegistrato: "Nessun brevetto registrato.",
      nessunaImmersionePubblica: "Nessuna immersione pubblica.",
      nessunPostPubblicoAncora: "Nessun post pubblico ancora.",
      immersioniInEvidenza: "🔖 Immersioni in evidenza",
      traguardiRaggiunti: "Traguardi raggiunti",
      vediImmersione: "🤿 Vedi immersione",
    },
    pagesProfileSubscriptionUpgradeWizard: {
      tuttoPronto: "Tutto pronto!",
      fatturatoAnnualmentePuoiDisdireInQualsiasi: "Fatturato annualmente. Puoi disdire in qualsiasi momento.",
      riepilogoOrdine: "Riepilogo ordine",
      selezionaIlPianoPiuAdattoAlle: "Seleziona il piano più adatto alle tue esigenze.",
      sbloccaTutteLeFunzionalitaEdive: "Sblocca tutte le funzionalità eDive",
      aggiornaIlTuoPiano: "Aggiorna il tuo piano",
      pianoAggiornatoModalitaDemo: "Piano aggiornato (modalità demo)!",
      dopoIlPagamentoIlPianoSara: "Dopo il pagamento il piano sarà attivo immediatamente.",
      verraiReindirizzatoAStripePerIl: "Verrai reindirizzato a Stripe per il pagamento sicuro.",
    },
    pagesProfileTabsMedicoTab: {
      scaduta: "Scaduta",
      rcSubacqueoDan: "RC Subacqueo, DAN...",
      descrivereUlterioriDettagli: "Descrivere ulteriori dettagli…",
      informazioniCritichePerIlSoccorso: "Informazioni critiche per il soccorso…",
      esNoNarcosiMax18m: "es. No narcosi, max 18m…",
      modifica: "Modifica",
    },
    pagesProfileTabsPrivacyTab: {
      telefonoERecapiti: "Telefono e recapiti",
      chiVedeIlTuoProfilo: "Chi vede il tuo profilo",
      caricamento: "Caricamento…",
      nonEStatoPossibileSalvare: "Non è stato possibile salvare",
      impostazioneSalvata: "Impostazione salvata",
      leModificheHannoEffettoSubito: "Le modifiche hanno effetto subito.",
    },
    pagesPublicCampagnaLazioPage: {
      parliamone: "Parliamone",
      chiSiamoSenzaGiriDiParole: "Chi siamo, senza giri di parole",
      iNostriImpegni: "I nostri impegni",
      comeFunziona: "Come funziona",
      cosaMettiamoADisposizione: "Cosa mettiamo a disposizione",
      cinqueCentriDelLazio: "cinque centri del Lazio",
      legge7Maggio2026NNbsp: "Legge 7 maggio 2026, n.&nbsp;70",
      senzaCartaESenzaFogliDi: "senza carta e senza fogli di calcolo",
      tutteLeFunzioniPerICentri: "tutte le funzioni per i centri",
      cercateIlVostroCentroNellaDirectory: "Cercate il vostro centro nella directory",
      nonViStiamoVendendoUnGestionale: "Non vi stiamo vendendo un gestionale. Vi stiamo chiedendo di provare uno strumento",
      unaPropostaDiCollaborazioneNonUn: "Una proposta di collaborazione, non un contratto di fornitura.",
      scuoleECentriSubDelLazio: "Scuole e centri sub del Lazio",
    },
    pagesPublicCookiePolicyPage: {
      supportEdiveTech: "support@edive.tech",
      ultimoAggiornamento24Maggio2026: "Ultimo aggiornamento: 24 maggio 2026",
      utilizziamoPlausibleAnalyticsPerLeStatistiche: "utilizziamo Plausible Analytics per le statistiche di traffico. Plausible è uno strumento cookieless e privacy-first: non installa cookie, non traccia gli utenti tra siti diversi e non trasferisce dati a terzi. Non è necessario il tuo consenso per questa analisi.",
      puoiRevocareOModificareInQualsiasi: "puoi revocare o modificare in qualsiasi momento il consenso ai cookie opzionali cliccando sul pulsante \"Preferenze cookie\" nel footer del sito, oppure tramite le impostazioni del tuo browser.",
      puoiGestireLePreferenzeCookieTramite: "Puoi gestire le preferenze cookie tramite il banner che appare al primo accesso al sito, oppure tramite le impostazioni del tuo browser. Disabilitare i cookie tecnici necessari potrebbe compromettere il funzionamento del servizio.",
    },
    pagesPublicPublicDivePage: {
      tieniIlTuoLogbookConEdive: "Tieni il tuo logbook con eDive",
      note: "Note",
      profonditaMedia: "Profondità media",
      acqua: "Acqua",
      orarioUscita: "Orario uscita",
      orarioEntrata: "Orario entrata",
      entrata: "Entrata",
      visibilita: "Visibilità",
      dettagli: "Dettagli",
      tipo: "Tipo",
      tempAcqua: "Temp. acqua",
      durata: "Durata",
      profonditaMax: "Profondità max",
      edive: "🤿 eDive",
      immersioneNonTrovata: "Immersione non trovata",
      caricamentoImmersione: "Caricamento immersione...",
      profiloDiImmersione: "Profilo di immersione",
      registraAnalizzaECondividiLeTue: "Registra, analizza e condividi le tue immersioni. Gratis.",
      questaImmersioneNonEsisteONon: "Questa immersione non esiste o non è stata condivisa pubblicamente.",
    },
    pagesQaQuestionPage: {
      accedi: "Accedi",
      scriviLaTuaRisposta: "Scrivi la tua risposta…",
      eliminaRisposta: "Elimina risposta",
      modificaRisposta: "Modifica risposta",
      modificaDomanda: "Modifica domanda",
      rispostaEliminata: "Risposta eliminata",
      rispostaAggiornata: "Risposta aggiornata",
      domandaAggiornata: "Domanda aggiornata",
      votoNegativo: "Voto negativo",
      votoPositivo: "Voto positivo",
      questaDomandaEChiusaNonSono: "Questa domanda è chiusa — non sono accettate nuove risposte.",
      perRispondere: "per rispondere.",
      annulla: "Annulla",
      rispostaCertificataDivemaster: "Risposta certificata Divemaster",
    },
    pagesReferralReferralPage: {
      invitaAmiciSuEdiveEMonitora: "Invita amici su eDive e monitora la tua rete",
      referralInviti: "Referral & Inviti",
      iniziaAInvitareAmiciPerCostruire: "Inizia a invitare amici per costruire la tua rete.",
      ilTuoAlberoReferralEVuoto: "Il tuo albero referral è vuoto",
      personeNelTuoAlberoReferral: "persone nel tuo albero referral",
      creaIlTuoPrimoInvitoPer: "Crea il tuo primo invito per portare amici su eDive.",
      nessunInvitoAncora: "Nessun invito ancora",
      iTuoiInviti: "I tuoi inviti",
      revocaInvito: "Revoca invito",
      copiaLink: "Copia link",
      scadenza: "Scadenza",
      amicoExampleCom: "amico@example.com",
      opzionale: "(opzionale)",
      canaleDiInvito: "Canale di invito",
      nuovoInvito: "Nuovo invito",
      oppureCondividiIlLinkDiretto: "Oppure condividi il link diretto",
      chiUsaQuestoCodiceInFase: "Chi usa questo codice in fase di registrazione viene collegato al tuo account.",
      ilTuoCodiceReferral: "Il tuo codice referral",
      tu: "(tu)",
      nessunReferralAncoraSiiIlPrimo: "Nessun referral ancora. Sii il primo a invitare!",
      caricamento: "Caricamento…",
      classificaReferrer: "🏆 Classifica referrer",
      perOgniAmicoCheSiIscrive: "per ogni amico che si iscrive con il tuo codice.",
      guadagni: "Guadagni",
      puntiGuadagnati: "Punti guadagnati",
      invitaITuoiAmici: "Invita i tuoi amici",
      condividiEdiveConChiAmaIl: "Condividi eDive con chi ama il mare. Ogni subacqueo che si registra con il tuo codice arricchisce la community.",
    },
    pagesSafetyReportIncidentWizard: {
      descrizione: "Descrizione",
      riepilogoIncidente: "Riepilogo incidente",
      esPrimoSoccorsoChiamataAl118: "Es. Primo soccorso, chiamata al 118, trasporto in camera iperbarica…",
      azioniIntraprese: "Azioni intraprese",
      descriviCosaESuccessoLeCircostanze: "Descrivi cosa è successo, le circostanze e la sequenza degli eventi…",
      attivaLaSegnalazioneObbligatoriaAiSensi: "Attiva la segnalazione obbligatoria ai sensi L.70 Art.15",
      minoreCoinvolto: "Minore coinvolto",
      descriviEventualiFeriteOCondizioniMediche: "Descrivi eventuali ferite o condizioni mediche",
      infortuniFeriti: "Infortuni / feriti",
      esSeccaDelCoralloPortoTorres: "Es. Secca del Corallo, Porto Torres…",
      sitoDiImmersione: "Sito di immersione",
      dataEOraDellIncidente: "Data e ora dell'incidente",
      gravita: "Gravità",
      tipoDiIncidente: "Tipo di incidente",
      registraUnEventoAvversoDuranteL: "Registra un evento avverso durante l'immersione",
      segnalaIncidente: "Segnala incidente",
      incidenteRegistrato: "Incidente registrato",
      incidenteRegistrato2: "Incidente registrato.",
      ilReportSaraVisibileAlResponsabile: "Il report sarà visibile al responsabile del centro e all'amministrazione eDive.",
      ilReportEStatoSalvatoIl: "Il report è stato salvato. Il responsabile del centro riceverà una notifica.",
    },
    pagesSafetySafetyCheckInWizard: {
      es393331234567: "Es. +39 333 1234567",
      contattoDiEmergenzaTelefono: "Contatto di emergenza — Telefono",
      esGiuliaRossi: "Es. Giulia Rossi",
      contattoDiEmergenzaNome: "Contatto di emergenza — Nome",
      opzionaleInserisciLEmailOIl: "Opzionale — inserisci l'email o il nome del tuo compagno di immersione.",
      esMarioRossiEmailItOppure: "Es. mario.rossi@email.it oppure Mario Rossi",
      buddyEmailONome: "Buddy (email o nome)",
      es45: "Es. 45",
      durataPianificataMin: "Durata pianificata (min) *",
      es20: "Es. 20",
      profonditaPianificataM: "Profondità pianificata (m)",
      dataEOraPianificata: "Data e ora pianificata",
      esSeccaDiPuntaCampanellaRelitto: "Es. Secca di Punta Campanella, Relitto Umbria…",
      sitoDiImmersione: "Sito di immersione *",
      registraIDettagliDellaTuaImmersione: "Registra i dettagli della tua immersione pianificata",
      checkInPreImmersione: "Check-in pre-immersione",
      checkInAttivatoBuonaImmersione: "Check-in attivato! Buona immersione.",
      ricordatiDiFareCheckOutAl: "Ricordati di fare check-out al termine dell'immersione per disattivare l'alert.",
    },
    pagesSettingsSettingsPage: {
      copiato: "Copiato!",
      annulla: "Annulla",
      mfaQrCode: "MFA QR Code",
      autenticazioneADueFattoriMfa: "Autenticazione a due fattori (MFA)",
      mfaDisattivata: "MFA disattivata",
      mfaAttivata: "MFA attivata",
      disattivato: "— Disattivato —",
      aggiungiUnSecondoLivelloDiSicurezza: "Aggiungi un secondo livello di sicurezza al tuo account. Al login ti verrà richiesto un codice temporaneo.",
    },
    pagesSettingsTwoFactorPage: {
      chiudiSessione: "Chiudi sessione",
      questoDispositivo: "questo dispositivo",
      sessioneChiusa: "Sessione chiusa",
      daDoveHaiEffettuatoLAccesso: "Da dove hai effettuato l'accesso. Se non riconosci un dispositivo, chiudi la sua sessione.",
      sessioniAttive: "Sessioni attive",
    },
    pagesSocialBuddyMatchesPage: {
      seguiAltriSubacqueiPerRicevereSuggerimenti: "Segui altri subacquei per ricevere suggerimenti di affinità.",
      nessunBuddyTrovato: "Nessun buddy trovato",
      trovaCompagniDiImmersioneCompatibiliCon: "Trova compagni di immersione compatibili con il tuo livello e i tuoi interessi, e pianifica le prossime uscite insieme.",
      buddy: "Buddy",
      nessunSubacqueoTrovato: "Nessun subacqueo trovato",
      ricercaInCorso: "Ricerca in corso...",
      richiestaInviata: "✓ Richiesta inviata",
      distanza: "distanza",
      quandoUnUtenteCheSeguiTi: "Quando un utente che segui ti segue a sua volta, apparirà qui.",
      nessunBuddyReciproco: "Nessun buddy reciproco",
      compatibile: "compatibile",
      subacqueiCheSeguiECheTi: "Subacquei che segui e che ti seguono a loro volta — i tuoi buddy reciproci.",
      scopriLaCommunity: "Scopri la community",
      subacqueiConCuiSeiGiaIn: "Subacquei con cui sei già in contatto, ordinati per affinità di stile, esperienza e specialità.",
      usaLaMiaPosizione: "Usa la mia posizione",
      trovaSubacqueiNelleVicinanzeEScopri: "Trova subacquei nelle vicinanze e scopri chi è più compatibile con il tuo profilo.",
    },
    pagesSocialTabsFeedTab: {
      nessunCommentoAncora: "Nessun commento ancora",
      aggiungiFoto: "Aggiungi foto",
    },
    pagesSocialTabsSfideBadgeGruppiTabs: {
      uuidDellUtenteDiContatto: "UUID dell'utente di contatto",
      infoGruppoIt: "info@gruppo.it",
      esSubPalermoDeepExplorers: "Es. Sub Palermo, Deep Explorers...",
      eliminaGruppo: "Elimina gruppo",
      eliminazione: "Eliminazione...",
      supportEdiveTech: "support@edive.tech",
      notificaIPartecipantiViaEmail: "Notifica i partecipanti via email",
      eliminaGruppoAdmin: "Elimina gruppo (admin)",
      modificaGruppo: "Modifica gruppo",
      completaLeSfideERaggiungiI: "Completa le sfide e raggiungi i traguardi per ottenere badge.",
      nessunBadgeGuadagnato: "Nessun badge guadagnato",
      riprovaTraQualcheMomento: "Riprova tra qualche momento",
      completata: "Completata",
      leSfideArrivanoPrestoTornaA: "Le sfide arrivano presto. Torna a controllare!",
      nessunaSfidaDisponibile: "Nessuna sfida disponibile",
      perInformarliDellEliminazione: "per informarli dell'eliminazione.",
    },
    pagesSpeciesBulkUploadConsolePage: {
      iucnRedList: "🛡 IUCN Red List",
      inaturalistComputerVision: "🔬 iNaturalist Computer Vision",
    },
    pagesSpeciesMarineBiologistPortal: {
      usaIlModuloQuiSopraPer: "Usa il modulo qui sopra per contribuire all'enciclopedia.",
      nessunaPropostaTrovata: "Nessuna proposta trovata.",
      caricamento: "Caricamento…",
      rifiutate: "Rifiutate",
      approvate: "Approvate",
      inAttesa: "In attesa",
      tutte: "Tutte",
      nuovaProposta: "Nuova proposta",
      seApprovataIlCatalogoVieneAggiornato: "Se approvata, il catalogo viene aggiornato automaticamente e ricevi una notifica.",
      ilTeamEdiveEsaminaLaProposta: "Il team eDive esamina la proposta entro 5 giorni lavorativi.",
      compilaIlModuloConLaTua: "Compila il modulo con la tua proposta e i dati scientifici.",
      comeFunziona: "Come funziona",
      json: "(JSON)",
      descriviBrevementeLaPropostaELa: "Descrivi brevemente la proposta e la fonte scientifica...",
      noteMotivazione: "Note / Motivazione",
      esStazioneZoologicaAntonDohrn: "es. Stazione Zoologica Anton Dohrn",
      enteIstituzione: "Ente / Istituzione",
      genusSpecies: "Genus species",
      nomeScientifico: "Nome scientifico *",
      tipoDiProposta: "Tipo di proposta *",
      propostaInviataConSuccessoIlTeam: "Proposta inviata con successo — il team eDive la esaminerà entro 5 giorni lavorativi.",
      noteDelRevisore: "Note del revisore",
      inserisciICampiCheVuoiProporre: "Inserisci i campi che vuoi proporre nel formato JSON standard.",
    },
    pagesSpeciesMyContributionsPage: {
      nessunaContribuzioneAncora: "Nessuna contribuzione ancora",
      azione: "Azione",
      specieFile: "Specie / File",
      leMieContribuzioni: "Le mie contribuzioni",
      contribuzioneRimossaDallEnciclopedia: "Contribuzione rimossa dall'enciclopedia",
      impossibileCaricareLeContribuzioni: "Impossibile caricare le contribuzioni",
      impossibileCaricareIDettagli: "Impossibile caricare i dettagli",
      rimuoviContribuzioneDallEnciclopedia: "Rimuovi contribuzione dall'enciclopedia",
      vediDatiEstrattiDallaPipeline: "Vedi dati estratti dalla pipeline",
      specieSconosciuta: "Specie sconosciuta",
      rimuoviContribuzione: "Rimuovi contribuzione",
      note: "Note",
      metadati: "📋 Metadati",
      idIucn: "ID IUCN",
      tendenzaPopolazione: "TENDENZA POPOLAZIONE",
      statusIucnNonDisponibile: "Status IUCN non disponibile",
      iucnRedList: "🛡 IUCN Red List",
      datiNonDisponibiliPerQuestaSpecie: "Dati non disponibili per questa specie",
      nessunCandidatoRilevato: "Nessun candidato rilevato",
      inaturalistComputerVision: "🔬 iNaturalist Computer Vision",
      datiEstrattiDallaPipeline: "Dati estratti dalla pipeline",
      leFotoChePubblichiNellEnciclopedia: "Le foto che pubblichi nell'enciclopedia appariranno qui.",
      fotoPubblicateNellEnciclopedia: "foto pubblicate nell'enciclopedia",
      fotoCheHaiPubblicatoNellEnciclopedia: "Foto che hai pubblicato nell'enciclopedia marina",
      lImmagineVerraEsclusaDallEnciclopedia: "L'immagine verrà esclusa dall'enciclopedia. Non sarà visibile agli altri utenti.",
      caricamentoDati: "Caricamento dati…",
    },
    pagesSpeciesSpeciesLifeList: {
      es18: "es. 18",
      spScientificName: "${sp.scientific_name}",
    },
    pagesSportcentersSportCenterDetailPage: {
      nonCiSonoSessioniAperteIn: "Non ci sono sessioni aperte in questo periodo",
      nessunaSessioneDisponibile: "Nessuna sessione disponibile",
      tuttiILivelli: "Tutti i livelli",
      tuttiITipi: "Tutti i tipi",
      sessioniDisponibili: "Sessioni disponibili",
      creaLaPrimaSessioneConIl: "Crea la prima sessione con il pulsante qui sopra",
      nessunaSessioneCreata: "Nessuna sessione creata",
      sessioni: "Sessioni",
      annulla: "Annulla",
      modificaCentro: "Modifica centro",
      profonditaMax: "Profondità max",
      corsie: "Corsie",
      lunghezza: "Lunghezza",
      sitoWeb: "Sito web",
      piscinaScoperta: "Piscina scoperta",
      piscinaCoperta: "Piscina coperta",
      centroNonTrovato: "Centro non trovato",
      sessioneAnnullata: "Sessione annullata",
      prenotazioneAnnullata: "Prenotazione annullata",
      prenotazioneConfermata: "Prenotazione confermata!",
      nuovaSessione: "Nuova sessione",
      indietro: "Indietro",
      prenotaSessione: "Prenota sessione",
      annullaPrenotazione: "Annulla prenotazione",
    },
    pagesSportcentersSportCentersPage: {
      piscinaScoperta: "Piscina scoperta",
      piscinaCoperta: "Piscina coperta",
      provaAModificareIFiltriDi: "Prova a modificare i filtri di ricerca",
      nessunCentroTrovato: "Nessun centro trovato",
      nessunCentroTrovatoConIFiltri: "Nessun centro trovato con i filtri selezionati",
      tuttiITipiSessione: "Tutti i tipi sessione",
      citta: "Città",
      cercaCentroSportivo: "Cerca centro sportivo...",
      centriSportiviConPiscina: "Centri Sportivi con Piscina",
      mappa: "Mappa",
      lista: "Lista",
      trovaCentriSportiviDotatiDiPiscina: "Trova centri sportivi dotati di piscina che offrono sessioni di addestramento subacqueo",
    },
    pagesTripsComponentsTripDetail: {
      aggiungiElementoPersonalizzato: "Aggiungi elemento personalizzato…",
      nessunaImmersioneRegistrataInQuestoPeriodo: "Nessuna immersione registrata in questo periodo",
      copiaReport: "Copia report",
      copiatoNegliAppunti: "Copiato negli appunti!",
      faunaOsservata: "Fauna osservata",
      highlights: "Highlights",
      rispostaDaCache: "Risposta da cache",
      generaReportAi: "Genera report AI",
      generazioneInCorso: "Generazione in corso…",
      generaIlReportDelViaggio: "Genera il report del viaggio",
      cercaUnSitoDiImmersioneSopra: "Cerca un sito di immersione sopra",
      nessunSitoAggiunto: "Nessun sito aggiunto",
      aggiungiSitiDaEsplorareECompleta: "Aggiungi siti da esplorare e completa la checklist!",
      sitiInclusi: "Siti inclusi",
      giorni: "Giorni",
      preparazione: "Preparazione",
      sitiPianificati: "Siti pianificati",
      mappaSitiPianificati: "Mappa siti pianificati",
      preparazioneZaino: "Preparazione zaino",
      inCorso: "🟢 In corso!",
      erroreNellaGenerazioneDelReportAi: "Errore nella generazione del report AI",
      erroreEliminazione: "Errore eliminazione",
      viaggioEliminato: "Viaggio eliminato",
      annulla: "Annulla",
      esSharmElSheikhEgitto: "es. Sharm el-Sheikh, Egitto",
      destinazione: "Destinazione",
      dataFine: "Data fine",
      dataInizio: "Data inizio *",
      esMaldiveAgosto2026: "es. Maldive Agosto 2026",
      nomeViaggio: "Nome viaggio *",
      nuovoViaggioSubacqueo: "Nuovo viaggio subacqueo",
      erroreNellaCreazione: "Errore nella creazione",
      viaggioCreato: "Viaggio creato!",
      vaiAlLogbook: "Vai al logbook →",
      rigenera: "Rigenera",
    },
    pagesTripsTripPlannerPage: {
      oppure: "oppure",
      selezionaUnViaggio: "Seleziona un viaggio",
      cercaPerDestinazione: "Cerca per destinazione…",
      iMieiDiariDiViaggio: "I miei diari di viaggio",
      esploraLeGiteEILiveaboard: "Esplora le gite e i liveaboard pubblicati da istruttori e dive center della community.",
      ilLinkEScadutoONon: "Il link è scaduto o non esiste.",
      invitoNonValido: "Invito non valido",
      seiStatoAggiuntoAlPianoCollaborativo: "Sei stato aggiunto al piano collaborativo.",
      invitoAccettato: "Invito accettato!",
      accettazioneInvitoInCorso: "Accettazione invito in corso…",
      pianificaUnNuovoViaggio: "Pianifica un nuovo viaggio",
      nuovo: "Nuovo",
      pianiCollaborativi: "Piani collaborativi",
      iMieiViaggi: "I miei viaggi",
    },
    pagesUnsubscribePage: {
      supportEdiveTech: "support@edive.tech",
      aiSensiDelGdprArt17: "Ai sensi del GDPR (art. 17), elaboreremo entro 30 giorni",
      richiediCancellazioneDati: "Richiedi cancellazione dati",
      riceviDiNuovoAggiornamentiDaEdive: "Ricevi di nuovo aggiornamenti da eDive",
      riattivaComunicazioni: "Riattiva comunicazioni",
      nonRiceveraiPiuEmailDaEdive: "Non riceverai più email da eDive",
      annullaIscrizione: "Annulla iscrizione",
      operazioneCompletata: "Operazione completata",
      linkNonValido: "Link non valido",
      gestioneComunicazioni: "Gestione comunicazioni",
    },
    componentsUiDiveSiteMiniMap: {
      tornaAlSito: "Torna al sito",
      zoomOut: "Zoom out",
      zoomIn: "Zoom in",
      mappaSitoDiImmersione: "Mappa sito di immersione",
      mappaNonDisponibile: "Mappa non disponibile",
    },
    pagesProfileProfileSetupWizard: {
      english: "English",
      italiano: "Italiano",
      rossi: "Rossi",
      anna: "Anna",
      mario: "Mario",
    },
    pagesDivecenterDiveCenterOnboardingWizard: {
      infoCentroIt: "info@centro.it",
      onchangePPartial: "; onChange: (p: Partial",
    },
    pagesMedicalDoctorOnboardingWizard: {
      onchangePPartial: "; onChange: (p: Partial",
      caricamento: "Caricamento…",
      caricaIlCertificatoDiAbilitazioneIscrizione: "Carica il certificato di abilitazione/iscrizione all'albo (JPG, PNG, WEBP o PDF, max 8MB). Verrà verificato dallo staff prima di rendere pubblico il profilo.",
      documentoDiAbilitazione: "Documento di abilitazione",
      fileTroppoGrandeMax8mb: "File troppo grande (max 8MB).",
      formatoNonValidoJpgPngWebp: "Formato non valido (JPG, PNG, WEBP o PDF).",
      caricamentoNonRiuscitoRiprova: "Caricamento non riuscito, riprova.",
      documentoCaricatoSaraVerificatoABreve: "Documento caricato: sarà verificato a breve.",
    },
    pagesProfileTabsProfessionaleTab: {
      esMedicinaIperbaricaFisiopatologiaSubacquea: "es. Medicina Iperbarica, Fisiopatologia Subacquea",
      esOspedaleSanMartinoGenova: "es. Ospedale San Martino - Genova",
      es12345: "es. 12345",
      onsaveVRecord: "; onSave: (v: Record",
      presentatiAllaCommunity: "Presentati alla community…",
      esMarRossoMaldiveMediterraneo: "es. Mar Rosso, Maldive, Mediterraneo",
      esSonyA7rVNauticamLuce: "es. Sony A7R V + Nauticam, luce Sola 4000",
      presentatiAiPotenzialiAllievi: "Presentati ai potenziali allievi…",
      esItEnFr: "es. IT, EN, FR",
      esWreckCaveNitroxUnderwaterPhotography: "es. Wreck, Cave, Nitrox, Underwater Photography",
      es150: "es. 150",
      esPadiIdcStaffInstructor: "es. PADI IDC Staff Instructor",
    },
    pagesMedicalFindMedicalPage: {
      promise: "): Promise",
    },
    pagesAdminWhatsAppAdminPage: {
      marketing: "Marketing",
      perLaGestioneCampagneDiMassa: "Per la gestione campagne di massa usa la sezione",
      leCredenzialiVengonoLetteDalleVariabili: "Le credenziali vengono lette dalle variabili d'ambiente del container — non sono memorizzate nel database.",
      lAccessTokenDeveAvereScope: "L'Access Token deve avere scope",
      iMessaggiPossonoEssereInviatiSolo: "I messaggi possono essere inviati solo a utenti che hanno precedentemente contattato il tuo numero Business o hanno dato il consenso esplicito (WhatsApp Business Policy).",
      inviaMessaggioDallaPiattaforma: "Invia messaggio dalla piattaforma",
      apriSuWhatsappWeb: "Apri su WhatsApp Web",
      cercaPerNomeOEmail: "Cerca per nome o email…",
      formatoInternazionaleConPrefissoCountryEs: "Formato internazionale con prefisso country, es. +393331234567",
      "393xxXxxXxxx": "+39 3XX XXX XXXX",
      copia: "Copia",
      whatsappBusinessMessaging: "whatsapp_business_messaging",
    },
    pagesCoursesCourseEnrollWizard: {
      confermandoLIscrizioneIlCorsoApparira: "Confermando l'iscrizione, il corso apparirà in",
      perContinuareIlPercorsoFormativo: "per continuare il percorso formativo.",
      iMieiCorsi: "I miei corsi",
      puoiTrovarloIn: "Puoi trovarlo in",
      seiGiaIscrittoAQuestoCorso: "Sei già iscritto a questo corso",
      nessunCorsoTrovato: "Nessun corso trovato",
      tutteLeAgenzie: "Tutte le agenzie",
      tuttiILivelli: "Tutti i livelli",
      cercaCorso: "Cerca corso…",
      trovaIlCorsoGiustoECompleta: "Trova il corso giusto e completa l'iscrizione",
      iscrivitiAUnCorso: "Iscriviti a un corso",
      iscrizioneCompletata: "Iscrizione completata!",
      lIstruttoreVerraNotificatoEPotra: ". L'istruttore verrà notificato e potrà contattarti per organizzare le lezioni.",
    },
    pagesDivecenterCreateExcursionWizard: {
      lEscursioneVerraCreataInStato: "L'escursione verrà creata in stato",
      dopoQuestaDataLOffertaNon: "Dopo questa data l'offerta non sarà più mostrata nella vetrina.",
      visibileFinoAlOpzionale: "Visibile fino al (opzionale)",
      chiPrenoteraResteraInvitatoAncheSe: "Chi prenoterà resterà invitato anche se in seguito cambi la visibilità.",
      useridDaInvitare: "userId da invitare",
      invitaUtentiIdEdive: "Invita utenti (ID eDive)",
      soloAgliUtentiCheInviti: "Solo agli utenti che inviti",
      riservata: "🔒 Riservata",
      visibileATuttiNellaVetrinaEdive: "Visibile a tutti nella vetrina eDive",
      pubblica: "🌐 Pubblica",
      visibilitaDellOfferta: "Visibilità dell'offerta",
      ilPrezzoComprendeBcdErogatoreE: "Il prezzo comprende BCD, erogatore e muta",
      attrezzaturaInclusa: "Attrezzatura inclusa",
      livelloMinimoRichiesto: "Livello minimo richiesto",
      prezzoPersona: "Prezzo (€/persona)",
      maxSubacquei: "Max subacquei *",
      notePerLoStaff: "Note per lo staff",
      noteInterne: "Note interne",
      durataStimataMin: "Durata stimata (min)",
      oraPartenza: "Ora partenza",
      data: "Data *",
      descrizione: "Descrizione",
      esImmersioneAlRelittoDiCapo: "Es. Immersione al relitto di Capo Muro",
      titoloEscursione: "Titolo escursione *",
      nomeSitoLibero: "Nome sito libero",
      cercaSito: "Cerca sito…",
      sitoDiImmersione: "Sito di immersione",
      pubblicaUnaNuovaUscitaSubPer: "Pubblica una nuova uscita sub per i tuoi clienti",
      creaEscursioneGuidata: "Crea escursione guidata",
      perCreareUnEscursioneDeviPrima: "Per creare un'escursione devi prima configurare il tuo centro diving.",
      nessunCentroTrovato: "Nessun centro trovato",
      escursioneCreata: "Escursione creata!",
      potraiPubblicarlaDallaDashboardDelCentro: ". Potrai pubblicarla dalla dashboard del centro.",
      bozza: "Bozza",
    },
    componentsAdminAdminProfileEditModal: {
      esRomaNapoli: "Es. Roma, Napoli…",
    },
    componentsAdminAdminQueueBanner: {
      almenoUnaCodaNonERaggiungibile: "Almeno una coda non è raggiungibile: il totale è parziale.",
      codeInAttesaDiRevisione: "Code in attesa di revisione",
    },
    componentsBottomNav: {
      home: "Home",
    },
    componentsDirectoryUnifiedCatalogBanner: {
      catalogoAnagraficoUnico: "catalogo anagrafico unico",
    },
    componentsDiveTipCard: {
      consiglioDelGiorno: "Consiglio del giorno",
    },
    componentsEducationalEducationalDrawer: {
      close: "Close",
    },
    componentsNavbar: {
      menu: "Menu",
    },
    componentsNewsCarousel: {
      next: "Next",
      previous: "Previous",
    },
    componentsQuickLogFAB: {
      salvaImmersione: "Salva immersione",
      salvataggio: "Salvataggio…",
      condizioniFaunaVistaBuddy: "Condizioni, fauna vista, buddy…",
      noteOpzionale: "Note (opzionale)",
      valutazione: "Valutazione",
      tipo: "Tipo",
      nomeSito: "Nome sito…",
      sito: "Sito",
      inserisciLaDurata: "Inserisci la durata",
      min: "(min)",
      inserisciLaProfondita: "Inserisci la profondità",
      data: "Data",
      logRapido: "Log rapido",
      registraImmersione: "Registra immersione",
      logRapidoImmersione: "Log rapido immersione",
      erroreNelSalvataggio: "Errore nel salvataggio",
      immersioneRegistrata: "Immersione registrata!",
    },
    componentsSessionManager: {
      sessioneInScadenza: "Sessione in scadenza",
    },
    componentsSidebar: {
      tech: ".tech",
      mostraMeno: "Mostra meno",
    },
    componentsTrainingShared: {
      chiudi: "Chiudi",
    },
    componentsUiCenterPicker: {
      nessunCentroTrovato: "Nessun centro trovato",
      ricerca: "Ricerca…",
      rimuovi: "Rimuovi",
      cambiaDivingCenter: "Cambia diving center",
    },
    componentsUiCountrySelect: {
      nessunRisultato: "Nessun risultato",
    },
    componentsUiFeatureJourney: {
      perArrivarciTiServe: "Per arrivarci ti serve",
      cosaTiAspetta: "Cosa ti aspetta",
      unaNuovaTappaTiAspetta: "Una nuova tappa ti aspetta",
    },
    componentsUiPageHeader: {
      tornaIndietro: "Torna indietro",
    },
    componentsUiPhoneInput: {
      nessunRisultato: "Nessun risultato",
      cercaPaeseOPrefisso: "Cerca paese o prefisso...",
    },
    componentsUiProvinceSelect: {
      nessunRisultato: "Nessun risultato",
    },
    componentsWaiverDiveWaiverPDF: {
      firmaDigitale: "Firma digitale",
      consensiEspliciti: "Consensi espliciti",
      esoneroDiResponsabilita: "Esonero di responsabilità",
      dichiarazioneMedica: "Dichiarazione medica",
      telEmergenza: "Tel. emergenza",
      contattoEmergenza: "Contatto emergenza",
      brevetto: "Brevetto",
      enteCertificante: "Ente certificante",
      telefono: "Telefono",
      codiceFiscale: "Codice Fiscale",
      nazionalita: "Nazionalità",
      dataDiNascita: "Data di nascita",
      cognome: "Cognome",
      nome: "Nome",
      datiDelSubacqueo: "Dati del subacqueo",
      moduloDiAutorizzazionePreImmersione: "Modulo di Autorizzazione Pre-Immersione",
      piattaformaPerSubacqueiProfessionisti: "Piattaforma per subacquei professionisti",
    },
    pagesAcademyAcademyDashboardPage: {
      esCorsoOpenWaterPoolSession: "es. Corso Open Water — pool session 1",
    },
    pagesAcademyAcademyOnboardingWizard: {
      infoAcademyIt: "info@academy.it",
      viaRoma1: "Via Roma 1",
      milano: "Milano",
      esAquasubAcademy: "Es. AquaSub Academy",
    },
    pagesAdminAdminChallengesPage: {
      elimina: "Elimina",
      modifica: "Modifica",
      esPrime100Immersioni: "es. Prime 100 immersioni",
      esFirst100Dives: "es. first-100-dives",
    },
    pagesAdminAdminContentPagesPage: {
      chiSiamo: "chi-siamo",
    },
    pagesAdminAdminEmailPage: {
      selezionaTutti: "Seleziona tutti",
    },
    pagesAdminAdminNewsPage: {
      erroreBulkApprove: "Errore bulk approve",
    },
    pagesAdminAdminPromotionsPage: {
      esPrenotaOra: "Es. Prenota ora",
      esDa480Persona: "Es. Da €480 / persona",
      esAtolloDiMaleSudMaldive: "Es. Atollo di Malé Sud, Maldive",
      esBlueCoralResort: "Es. Blue Coral Resort",
      es7ImmersioniTuttoIncluso: "Es. 7 immersioni · tutto incluso",
      esImmersioniEstateMaldive2026: "Es. Immersioni Estate Maldive 2026",
      esMantaPoint: "Es. Manta Point",
    },
    pagesAdminAdminRbacPolicyPage: {
      regoleConfermate: "Regole confermate",
      areaRisorsa: "Area / risorsa",
      matriceDeiPermessi: "Matrice dei permessi",
      principi: "Principi",
      ondate24DatoDelDiver: "Ondate 2–4 (dato del diver, professionisti, approvazioni) — da applicare.",
      giaProtettaAccessoStaffViaRuolo: "— già protetta (accesso staff via ruolo nel centro; listing pubblico separato per i diver).",
      agendaDivingCenter: "Agenda diving center",
      giaProtettoAdminOnlyPrimaDell: "— già protetto (admin-only) prima dell'ondata.",
      marketing: "Marketing",
      adminOnlyDenyByDefaultCon: "— admin-only, deny-by-default con allowlist pubblica. Applicato e verificato (test E2E 2264).",
      statoDellApplicazioneAlCodice: "Stato dell'applicazione al codice",
      ondata1CrmAdminOnlyApplicato: "✓ Ondata 1: CRM admin-only applicato",
      denyByDefault: "Deny-by-default",
      "11Profili34Servizi": "11 profili · 34 servizi",
      v10Approvata: "v1.0 approvata",
      chiPuoVedereEFareCosa: "Chi può vedere e fare cosa sulla piattaforma. Documento di riferimento v1.0.",
      policyDiSicurezzaRbac: "Policy di sicurezza — RBAC",
    },
    pagesAdminAdminSpeciesCurationPage: {
      deseleziona: "Deseleziona",
      escludiTutte: "✕ Escludi tutte",
      includiTutte: "✓ Includi tutte",
      escluse: "Escluse",
      incluse: "Incluse",
      inRevisione: "In revisione",
      tutte: "Tutte",
      selezionaUnaSpecieDallaListaPer: "Seleziona una specie dalla lista per gestire le foto",
      gestisciLeFotoPerSpecieIncludi: "Gestisci le foto per specie — includi, escludi, identifica duplicati visivi",
      curazioneFotoEnciclopediaMarina: "Curazione Foto Enciclopedia Marina",
      errore: "Errore",
      fotoPrincipaleAggiornata: "Foto principale aggiornata",
      erroreAggiornamentoBulk: "Errore aggiornamento bulk",
      erroreNellAggiornamento: "Errore nell'aggiornamento",
      statoCodaRiconoscimento: "STATO CODA RICONOSCIMENTO",
      soloConFotoInAttesa: "Solo con foto in attesa",
      cercaSpecie: "Cerca specie…",
      impostaComeFotoPrincipale: "Imposta come foto principale",
      escludi: "✕ Escludi",
      escludiDallEnciclopedia: "Escludi dall'enciclopedia",
      includi: "✓ Includi",
      includiNellEnciclopedia: "Includi nell'enciclopedia",
    },
    pagesAdminCrmCrmAgendaPage: {
      cancellaAppuntamento: "Cancella appuntamento",
      esportaIcalOutlookMobile: "Esporta iCal (Outlook/mobile)",
      interno: "💌 Interno",
      wa: "💬 WA",
      email: "📧 Email",
    },
    pagesAdminCrmCrmContactFormPage: {
      logo: "Logo",
      nonSpecificato: "— Non specificato —",
      tipoContatto: "Tipo contatto",
      es124964: "Es. 12.4964",
      longitudineGps: "Longitudine GPS",
      es419028: "Es. 41.9028",
      latitudineGps: "Latitudine GPS",
      didatticaDiRiferimento: "Didattica di riferimento",
      caratteristicheDiving: "Caratteristiche diving",
      nonSpecificata: "— Non specificata —",
      linguaPreferitaPerComunicazioni: "Lingua preferita per comunicazioni",
      viaRoma100100Roma: "Via Roma 1, 00100 Roma",
      indirizzo: "Indirizzo",
      esItalia: "Es. Italia",
      nazionePaese: "Nazione / Paese",
      esRm: "Es. RM",
      provincia: "Provincia",
      esRoma: "Es. Roma",
      localita: "Località",
      esPresidenteManager: "Es. Presidente, Manager...",
      esAsdDiveSecureSub: "Es. ASD Dive Secure SUB",
      indicaAlmenoUnNomeUnaRagione: "Indica almeno un nome, una ragione sociale, un\\u2019email o un telefono",
      perUnEnteServeLaRagione: "Per un ente serve la ragione sociale",
      rimozioneNonRiuscita: "Rimozione non riuscita",
      logoRimosso: "Logo rimosso",
      logoCaricato: "Logo caricato",
    },
    pagesAdminCrmCrmContactsPage: {
      paeseLingua: "Paese / Lingua",
      contatto: "Contatto",
      consensi: "Consensi",
      tuttiITipi: "Tutti i tipi",
      eliminaContatto: "Elimina contatto",
      modificaAnagrafica: "Modifica anagrafica",
      apriNellAnagraficaUnicaVistaConsolidata: "Apri nell'Anagrafica Unica (vista consolidata persona)",
      arricchisciDatiEmailTelefonoIndirizzoLingua: "Arricchisci dati (email, telefono, indirizzo, lingua)",
      email: "✓ Email",
      revocato: "✕ Revocato",
      membroEdive: "Membro eDive",
      nonSpecificata: "— Non specificata —",
      linguaPreferitaPerComunicazioni: "Lingua preferita per comunicazioni",
      italia: "Italia",
      paeseNazione: "Paese / Nazione",
      milano: "Milano",
      citta: "Città",
      viaRoma1Interno3: "Via Roma 1, interno 3...",
      indirizzo: "Indirizzo",
      "39XxxXxxXxxx": "+39 xxx xxx xxxx",
      telefono: "Telefono",
      emailEsempioCom: "email@esempio.com",
      email2: "Email",
      arricchisciContatto: "Arricchisci contatto",
      erroreNelSalvataggio: "Errore nel salvataggio",
      contattoAggiornato: "Contatto aggiornato",
    },
    pagesAdminCrmCrmDashboardPage: {
      revocato: "Revocato",
      consensoAttivo: "Consenso attivo",
      recuperati: "Recuperati",
      rimbalzati: "Rimbalzati",
      inviati: "Inviati",
      campagnaOutreachB2b: "Campagna Outreach B2B",
    },
    pagesAdminTabsCurationTab: {
      deseleziona: "Deseleziona",
      escludiTutte: "✕ Escludi tutte",
      includiTutte: "✓ Includi tutte",
      escluse: "Escluse",
      incluse: "Incluse",
      inRevisione: "In revisione",
      tuttiGliStati: "Tutti gli stati",
      selezionaUnaSpecieDallaListaPer: "Seleziona una specie dalla lista per gestire le foto",
      errore: "Errore",
      fotoPrincipaleAggiornata: "Foto principale aggiornata",
      erroreAggiornamentoBulk: "Errore aggiornamento bulk",
      erroreNellAggiornamento: "Errore nell'aggiornamento",
    },
    pagesAdminTabsInatTab: {
      falliti: "Falliti",
      arricchiti: "Arricchiti",
      daArricchire: "Da arricchire",
      tuttiGliArricchimenti: "Tutti gli arricchimenti",
    },
    pagesAdminTabsRealtimeTabs: {
      creataIl: "Creata il",
      dataArchivio: "Data archivio",
      archiviataDa: "Archiviata da",
      tipo: "Tipo",
      conversazione: "Conversazione",
      caricamento: "Caricamento...",
      cercaPerNomeOId: "Cerca per nome o ID...",
    },
    pagesAdminTabsSecurityTabs: {
      rateLimit: "RATE LIMIT",
      invalidToken: "INVALID TOKEN",
      ipUnblocked: "IP UNBLOCKED",
      ipBlockedManual: "IP BLOCKED MANUAL",
      ipBlockedAuto: "IP BLOCKED AUTO",
      blockedIpAttempt: "BLOCKED IP ATTEMPT",
      bruteForce: "BRUTE FORCE",
      failedLogin: "FAILED LOGIN",
      bruteForceScanning: "Brute force, scanning…",
    },
    pagesAdminTabsSpeciesTab: {
      import: "Import",
      worms: "WoRMS",
    },
    pagesAdminTabsSyncTab: {
      importJson: "Import JSON",
      sealifebase: "SeaLifeBase",
      fishbase: "FishBase",
      wikimediaWikidata: "Wikimedia / Wikidata",
      iucnRedList: "IUCN Red List",
      worms: "WoRMS",
    },
    pagesAdminTabsUsersTabs: {
      schedaAnagraficaCompleta: "Scheda anagrafica completa",
      nome: "Nome",
      nomeCognomeEmailTelefono: "Nome, cognome, email, telefono…",
    },
    pagesApneaTrainingTableRunner: {
      sec: "sec",
      min: "min",
    },
    pagesApneaTrainingTrainingHub: {
      min: "min",
    },
    pagesAssociationsAssociationDetailPage: {
      email: "Email *",
      nessunPreSocioRegistrato: "Nessun pre-socio registrato",
      inserisciAlmenoEmailOTelefono: "Inserisci almeno email o telefono",
      nomeECognomeObbligatori: "Nome e cognome obbligatori",
      almenoUnoTraEmailETelefono: "* Almeno uno tra email e telefono è obbligatorio",
      noteOpzionale: "Note (opzionale)",
      whatsappOpzionale: "WhatsApp (opzionale)",
      telefonoOpzionale: "Telefono (opzionale)",
      emailOpzionale: "Email (opzionale)",
      cognome: "Cognome *",
      nome: "Nome *",
      controllaSeIPreSociSi: "Controlla se i pre-soci si sono nel frattempo registrati su eDive",
      sociPreRegistrati: "Soci pre-registrati",
      annulla: "Annulla",
      dataDiCostituzione: "Data di costituzione",
      modificaInformazioni: "Modifica informazioni",
      nonInserita: "Non inserita",
      inseritaInEdive: "Inserita in eDive",
      responsabile: "Responsabile",
      cambiaLogo: "Cambia logo",
      erroreUploadLogo: "Errore upload logo",
      logoAggiornato: "Logo aggiornato",
      erroreAggiornamento: "Errore aggiornamento",
      informazioniAggiornate: "Informazioni aggiornate",
      erroreDuranteLaRiconciliazione: "Errore durante la riconciliazione",
      preSocioRimosso: "Pre-socio rimosso",
      preSocioAggiunto: "Pre-socio aggiunto",
    },
    pagesAssociationsAssociationFormModal: {
      infoAssociazioneIt: "info@associazione.it",
    },
    pagesAssociationsAssociationOnboardingWizard: {
      approvazioneIscrizioni: "Approvazione iscrizioni",
      iContattiVengonoMostratiAiPotenziali: "I contatti vengono mostrati ai potenziali soci nella pagina dell'associazione.",
      infoAssociazioneIt: "info@associazione.it",
      emailDiContatto: "Email di contatto",
      telefonoDiContatto: "Telefono di contatto",
      scopoDellAssociazioneAttivitaChiPuo: "Scopo dell'associazione, attività, chi può iscriversi…",
      descrizione: "Descrizione",
      esClubSubacqueoMediterraneo: "Es. Club Subacqueo Mediterraneo",
      nomeAssociazione: "Nome associazione *",
      unisciLaCommunitySubacqueaIntornoA: "Unisci la community subacquea intorno a un progetto comune",
      creaLaTuaAssociazione: "Crea la tua associazione",
      associazioneCreata: "Associazione creata!",
    },
    pagesAuthRegisterPage: {
      esAbc123xy: "es. ABC123XY",
    },
    pagesBiologycenterBiologyCenterDashboard: {
      vediSuObis: "Vedi su OBIS →",
      contributoObisOceanBiodiversityInformationSystem: "Contributo OBIS — Ocean Biodiversity Information System",
    },
    pagesBiologycenterJoinMissionWizard: {
      datiDaRaccogliere: "Dati da raccogliere",
      tornaPiuTardiNuoveMissioniVengono: "Torna più tardi — nuove missioni vengono pubblicate regolarmente.",
      nessunaMissioneAperta: "Nessuna missione aperta",
      contribuisciAllaRicercaMarinaComeVolontario: "Contribuisci alla ricerca marina come volontario",
      partecipaAUnaMissione: "Partecipa a una missione",
      ilTeamDellaMissioneEsamineraLa: "Il team della missione esaminerà la tua candidatura e ti notificherà via email quando sarà approvata.",
      candidaturaInviata: "Candidatura inviata!",
      erroreNellInvioDellaCandidatura: "Errore nell'invio della candidatura",
      tiSeiGiaCandidatoAQuesta: "Ti sei già candidato a questa missione",
    },
    pagesBiologycenterMarineProjectDetailPage: {
      chiudi: "Chiudi",
    },
    pagesBookingsBookDiveWizard: {
      confermandoLOrganizzatoreRiceveraLaTua: "Confermando, l'organizzatore riceverà la tua prenotazione e potrà contattarti per i dettagli logistici. Il pagamento verrà gestito direttamente con il centro.",
      riepilogoPrenotazione: "Riepilogo prenotazione",
      leMiePrenotazioni: "Le mie prenotazioni",
      troviTuttiIDettagliIn: "Trovi tutti i dettagli in",
      haiGiaPrenotatoQuestaSessione: "Hai già prenotato questa sessione",
      esIntolleranzeRichiesteParticolari: "Es. intolleranze, richieste particolari…",
      notePerLOrganizzatoreOpzionale: "Note per l'organizzatore (opzionale)",
      provaAModificareLeDateO: "Prova a modificare le date o rimuovere i filtri.",
      nessunaSessioneDisponibile: "Nessuna sessione disponibile",
      livelloMinimo: "Livello minimo",
      esItEgMv: "Es. IT, EG, MV…",
      paese: "Paese",
      da: "Da",
      trovaEPrenotaLaProssimaImmersione: "Trova e prenota la prossima immersione guidata",
      prenotaUnUscitaSub: "Prenota un'uscita sub",
      prenotazioneConfermata: "Prenotazione confermata!",
      attrezzaturaInclusa: "attrezzatura inclusa",
    },
    pagesCharterMyCharterPage: {
      loading: "Loading…",
      campoObbligatorio: "Campo obbligatorio",
      prezzoGiorno: "Prezzo/giorno (€)",
      sNUnivoco: "S/N univoco",
      es6Miglia: "es. 6 miglia",
    },
    pagesChatChatPage: {
      inviaFoto: "Invia foto",
      annulla: "Annulla",
      elimina: "Elimina",
      modifica: "Modifica",
      archiviaConversazione: "Archivia conversazione",
      conversazioneArchiviata: "Conversazione archiviata",
    },
    pagesCoursesPSSExamPage: {
      dettaglioRisposte: "Dettaglio risposte",
      minimo: "Minimo",
      minuti: "Minuti",
      domande: "Domande",
      tornaAiCorsi: "← Torna ai corsi",
      nessunCorsoPssDisponibileAlMomento: "Nessun corso PSS disponibile al momento.",
      professionalScubaSchoolsSimulazioneDEsame: "Professional Scuba Schools — Simulazione d'esame",
      esamiPss: "Esami PSS",
    },
    pagesDiariesDiaryJourneyPlayer: {
      ricomincia: "Ricomincia",
      caricamento: "Caricamento…",
      viaggioVirtuale: "Viaggio virtuale",
    },
    pagesDiariesDiaryPdfExport: {
      esportaComePdf: "Esporta come PDF",
      erroreNellaGenerazioneDelPdf: "Errore nella generazione del PDF",
      pdfScaricato: "PDF scaricato!",
      nessunPernottamentoRegistrato: "Nessun pernottamento registrato",
      pernottamenti: "Pernottamenti",
      nessunaTrattaRegistrata: "Nessuna tratta registrata",
      tratte: "Tratte",
      ediveDiarioDiViaggio: "eDive · Diario di Viaggio",
    },
    pagesDirectoryAttributes: {
      nessunDatoRegistrato: "Nessun dato registrato.",
    },
    pagesDirectoryChangeHistory: {
      nessunaModificaRegistrata: "Nessuna modifica registrata.",
      caricamento: "Caricamento…",
    },
    pagesDirectoryDocumentsPanel: {
      max50mb: "max 50MB",
      categoriaOpz: "Categoria (opz.)",
      elimina: "Elimina",
      scarica: "Scarica",
      nessunDocumentoAllegato: "Nessun documento allegato.",
      caricamento: "Caricamento…",
      downloadNonRiuscito: "Download non riuscito",
      uploadNonRiuscito: "Upload non riuscito",
      documentoCaricato: "Documento caricato",
    },
    pagesDirectoryImportWizard: {
      chiudi: "Chiudi",
      errori: "errori",
      aggiornatiDedup: "aggiornati (dedup)",
      creati: "creati",
      cambiaFile: "Cambia file",
      anteprimaPrime5: "Anteprima (prime 5)",
      ignora: "— ignora —",
      selezionaUnFileCsvIntestazioniNella: "Seleziona un file CSV (intestazioni nella prima riga)",
      importNonRiuscito: "Import non riuscito",
      csvVuotoOSenzaRigheDati: "CSV vuoto o senza righe dati",
    },
    pagesDirectoryMembershipManager: {
      nessunRisultato: "Nessun risultato",
      ricerca: "Ricerca…",
      annulla: "annulla",
      terminaLegame: "Termina legame",
      principale: "principale",
      caricamento: "Caricamento…",
    },
    pagesDirectoryPartyPersonByUserPage: {
      aproLaScheda: "Apro la scheda…",
      tornaAllaGestioneUtenti: "Torna alla gestione utenti",
      perQuestoUtenteNonEsisteAncora: "Per questo utente non esiste ancora una scheda anagrafica.",
    },
    pagesDirectoryProfileCardPDF: {
      documentoRiservato: "Documento riservato",
      generatoDaEdiveTech: "Generato da eDive.tech",
      anagrafica: "Anagrafica",
      nessunContattoRegistrato: "Nessun contatto registrato",
      contatti: "Contatti",
      nessunRuoloAssegnato: "Nessun ruolo assegnato",
      ruoliNelProgettoEdive: "Ruoli nel progetto eDive",
      iscrittoIl: "Iscritto il",
      qualifica: "Qualifica",
      schedaUtente: "Scheda utente",
      tech: ".tech",
    },
    pagesDivecenterDCBookingsPage: {
      annulla: "Annulla",
    },
    pagesDivecenterDCCoursesPage: {
      prezzo: "Prezzo",
      livello: "Livello",
      agenzia: "Agenzia",
      titolo: "Titolo",
      esPadi2026It044892: "es. PADI-2026-IT-044892",
    },
    pagesDivecenterDCEquipmentItemDetailPage: {
      divingEquipment: "diving equipment",
    },
    pagesDivecenterDCEquipmentMaintenancePage: {
      divingEquipment: "diving equipment",
    },
    pagesDivecenterDCEventsTab: {
      cover: "cover",
    },
    pagesDivecenterDCInvoicesPage: {
      iva: "IVA%",
      unitCent: "€ unit (cent)",
      qty: "Qty",
      edive20260001: "EDIVE-2026-0001",
    },
    pagesDivecenterDCMedCertRequestsPage: {
      esCertificatoNecessarioPerIlCorso: "Es. Certificato necessario per il corso Open Water del 15 luglio...",
      opzionale: "(opzionale)",
      messaggio: "Messaggio",
      scadenza: "Scadenza",
      tipoCertificato: "Tipo certificato",
      sommozzatore: "Sommozzatore",
      aggiungiUnMessaggioOpzionaleEVerifica: "Aggiungi un messaggio opzionale e verifica i dati prima di inviare.",
      scadenzaPerLaRisposta: "Scadenza per la risposta",
      tipoDiCertificato: "Tipo di Certificato *",
      specificaIlTipoDiCertificatoRichiesto: "Specifica il tipo di certificato richiesto e l'eventuale scadenza.",
      cambia: "Cambia",
      ricerca: "Ricerca...",
      cercaPerNome: "Cerca per nome...",
      cercaIlSommozzatorePerNomeO: "Cerca il sommozzatore per nome o cognome.",
      inviaUnaRichiestaAlSommozzatore: "Invia una richiesta al sommozzatore",
      richiestaCertificatoMedico: "Richiesta Certificato Medico",
      richiestaInviata: "Richiesta inviata",
    },
    pagesDivecenterDCOperationsPage: {
      owAow: "OW, AOW…",
      padiSsi: "PADI, SSI…",
      cercaFraIClientiDelCentro: "Cerca fra i clienti del centro: nome, email o telefono",
      cambia: "cambia",
      chiEntraInAcqua: "Chi entra in acqua",
      openWaterAow: "Open Water, AOW...",
      padiSsiCmas: "PADI / SSI / CMAS...",
      iso24803: "ISO 24803",
    },
    pagesDivecenterDCPlanningPage: {
      sacLMin: "SAC (l/min)",
    },
    pagesDivecenterDCRentalPage: {
      opzionale: "(opzionale)",
      restituzione: "Restituzione",
      cliente: "Cliente",
      articolo: "Articolo",
      inserisciIDatiDelClienteE: "Inserisci i dati del cliente e la data di restituzione prevista.",
      manutenzioneOkNessunAvvisoPerQuesta: "Manutenzione OK — nessun avviso per questa categoria",
      note: "Note",
      prezzoGiorno: "Prezzo/giorno",
      quantita: "Quantità",
      taglia: "Taglia",
      categoria: "Categoria",
      aggiungiUnArticoloDisponibileANoleggio: "Aggiungi un articolo disponibile a noleggio",
    },
    pagesDivecenterDCSetupWizard: {
      viaDelMare1: "Via del Mare, 1",
      napoli: "Napoli",
      italia: "Italia",
      infoMiocentroIt: "info@miocentro.it",
      esBlueOceanDivingCenter: "es. Blue Ocean Diving Center",
    },
    pagesDivecenterDCShiftsPage: {
      informazioniAggiuntiveSulTurno: "Informazioni aggiuntive sul turno...",
      opzionale: "(opzionale)",
      attivita: "Attività",
      orario: "Orario",
      data: "Data",
      staff: "Staff",
      impostaGliOrariELAttivita: "Imposta gli orari e l'attività prevista per questo turno.",
      selezionaIlMembroDelloStaffE: "Seleziona il membro dello staff e la data del turno.",
      pianificaUnTurnoPerIlTuo: "Pianifica un turno per il tuo staff",
    },
    pagesDivecenterDCStudentProgressPage: {
      skillChecklist: "Skill checklist",
    },
    pagesDivecenterDivecenterProfileShared: {
      friendExampleCom: "friend@example.com",
    },
    pagesDivecenterDiveSitesManager: {
      rimuovi: "Rimuovi",
      confermaCheIlCentroAccompagnaQui: "Conferma che il centro accompagna qui",
      suggeritoAutomaticamentePerVicinanzaGeografica: "Suggerito automaticamente per vicinanza geografica",
      nessunPuntoDiImmersioneCollegatoCerca: "Nessun punto di immersione collegato. Cerca e aggiungi dal catalogo.",
      caricamento: "Caricamento…",
      giaAggiunto: "già aggiunto",
      nessunPuntoTrovato: "Nessun punto trovato",
      ricerca: "Ricerca…",
      cercaUnPuntoDiImmersione: "Cerca un punto di immersione…",
      quelliRealiORimuoviGliAltri: "quelli reali o rimuovi gli altri.",
      conferma: "conferma",
      erroreNellaConferma: "Errore nella conferma",
      puntoConfermato: "Punto confermato",
      erroreNellaRimozione: "Errore nella rimozione",
      puntoRimosso: "Punto rimosso",
      erroreImpossibileAggiungereIlPunto: "Errore: impossibile aggiungere il punto",
      puntoDiImmersioneAggiunto: "Punto di immersione aggiunto",
    },
    pagesDivecenterSafetyRegisterPage: {
      critico: "Critico",
      serio: "Serio",
      moderato: "Moderato",
      lieve: "Lieve",
    },
    pagesDivecenterTabsImpostazioniTab: {
      descrizione: "Descrizione",
      sitoWeb: "Sito web",
      email: "Email",
      telefono: "Telefono",
      indirizzo: "Indirizzo",
      paese: "Paese",
      citta: "Città",
      nome: "Nome",
      impostazioniCentro: "Impostazioni centro",
      erroreNelSalvataggio: "Errore nel salvataggio",
      impostazioniSalvate: "Impostazioni salvate",
    },
    pagesDivecenterTabsSociTab: {
      marioEsempioIt: "mario@esempio.it",
      rossi: "Rossi",
      mario: "Mario",
    },
    pagesDiverTrainingDiverTrainingHub: {
      min: "min",
    },
    pagesDivesitesDiveSiteShared: {
      km: "km",
      kn: "kn",
      aggiungiDettagliSulleCondizioniGenerali: "Aggiungi dettagli sulle condizioni generali…",
      esMurenaPolipoCernia: "es. Murena, Polipo, Cernia",
      es03: "es. 0.3",
      es05: "es. 0.5",
      es18: "es. 18",
      es24: "es. 24",
      es15: "es. 15",
      nomeVisualizzato: "Nome visualizzato",
      uuidDelDivingCenter: "UUID del diving center",
      es108813: "es. 10.8813",
      es425772: "es. 42.5772",
    },
    pagesDivesitesRecommendationsPage: {
      provaAdAmpliareIlRaggioO: "Prova ad ampliare il raggio o modificare i filtri.",
      nessunSitoTrovato: "Nessun sito trovato",
      tipiPreferiti: "Tipi preferiti",
      "500Km": "500 km",
      "20Km": "20 km",
      nessunaBrevettazioneMostraTutto: "Nessuna brevettazione (mostra tutto)",
      brevettazione: "Brevettazione",
      erroreAggiornamentoWishlist: "Errore aggiornamento wishlist",
      impossibileOttenereLaPosizione: "Impossibile ottenere la posizione",
      sitoVerificato: "Sito verificato",
    },
    pagesEventsEventInvitationPage: {
      edivePiattaformaSub: "eDive — Piattaforma sub",
    },
    pagesEventsExcursionDetailPage: {
      rifiuta: "Rifiuta",
      conferma: "Conferma",
    },
    pagesInstructorInstructorDashboardPage: {
      vetrinaPubblicaEdive: "vetrina pubblica eDive",
      pubblicaUnEscursioneVisibileNellaVetrina: "Pubblica un'escursione visibile nella vetrina pubblica eDive",
    },
    pagesInstructorInstructorOnboardingWizard: {
      caricamentoDocumento: "Caricamento documento…",
      pdfJpgPngMax8Mb: "PDF, JPG, PNG — max 8 MB",
    },
    pagesInstructorMyStaffRequestsPage: {
      presentatiAlResponsabileDelCentroDescrivi: "Presentati al responsabile del centro, descrivi la tua esperienza...",
      opzionale: "(opzionale)",
      ruoloRichiesto: "Ruolo richiesto",
      centro: "Centro",
      selezionaIlRuoloPerCuiTi: "Seleziona il ruolo per cui ti candidi presso",
      cambia: "Cambia",
      ricerca: "Ricerca...",
      cercaCentroSubacqueo: "Cerca centro subacqueo...",
      cercaIlCentroSubacqueoPerNome: "Cerca il centro subacqueo per nome o città.",
      inviaUnaCandidaturaAUnCentro: "Invia una candidatura a un centro subacqueo",
      richiestaPosizioneStaff: "Richiesta Posizione Staff",
    },
    pagesJobsJobBoardPage: {
      disponibileRemote: "Disponibile remote",
      emailContatto: "Email contatto",
      compensoAGiorno: "Compenso â‚¬/giorno",
      padiSsi: "PADI, SSI...",
      ente: "Ente",
      esRomaSharmElSheikh: "Es. Roma, Sharm el-Sheikh¦",
      cittaZona: "CittÃ  / zona",
      descrizione: "Descrizione *",
      esCercoIstruttorePadiPerEstate: "es. Cerco istruttore PADI per estate 2026",
      titolo: "Titolo *",
      chiuso: "Chiuso",
      cittaZona2: "CittÃ  / zona...",
      tuttiITipi: "Tutti i tipi",
    },
    pagesLogbookDiveDetailPage: {
      dismiss: "dismiss",
    },
    pagesLogbookDiveDetailPDF: {
      tags: "Tags",
      buddy: "Buddy",
      note: "Note",
      temperaturaSottAcqua: "Temperatura sott'acqua",
      profiloDiProfondita: "Profilo di profondità",
      cnsO: "CNS O₂%",
      sacRate: "SAC rate",
      zavorra: "Zavorra",
      gasEAttrezzatura: "Gas e attrezzatura",
      valutazione: "Valutazione",
      orario: "Orario",
      ingresso: "Ingresso",
      visibilita: "Visibilità",
      tipo: "Tipo",
      tAcqua: "T. acqua",
      durata: "Durata",
      profonditaMedia: "Profondità media",
      profonditaMax: "Profondità max",
      parametriPrincipali: "Parametri principali",
      bombola: "bombola",
      barFine: "bar fine",
      barInizio: "bar inizio",
      he: "He",
      profondita: "Profondità",
      sosteDiDecompressione: "SOSTE DI DECOMPRESSIONE",
      temperatura: "Temperatura",
    },
    pagesLogbookDiveImportWizard: {
      microsoftEdge: "Microsoft Edge",
      googleChrome: "Google Chrome",
      uddfCsvFitSmlXml: "UDDF, CSV, FIT, SML, XML",
    },
    pagesLogbookDivePrintModal: {
      dive: "Dive",
      l702026Art12: "✦ L.70/2026 Art.12 ✦",
    },
    pagesLogbookExportLogbookWizard: {
      ilFileVerraScaricatoDirettamenteNel: "Il file verrà scaricato direttamente nel browser. Per importarlo in altri software, consulta la documentazione del software di destinazione.",
      fileScaricato: "File scaricato!",
      prestoDisponibile: "Presto disponibile",
      da: "Da *",
      immersioniNelLogbook: "immersioni nel logbook",
      hai: "Hai",
      scaricaLeTueImmersioniInDiversi: "Scarica le tue immersioni in diversi formati",
      esportaLogbook: "Esporta logbook",
      erroreNellEsportazione: "Errore nell'esportazione",
      esportazioneCompletata: "Esportazione completata!",
      formatoNonAncoraDisponibile: "Formato non ancora disponibile",
    },
    pagesLogbookGasDecoPage: {
      modPo: "MOD PO₂",
      he: "He %",
      he2: "He",
    },
    pagesLogbookGoalsPage: {
      times: "&times;",
    },
    pagesLogbookLogbookAnalyticsPage: {
      nessunDatoNelPeriodoSelezionato: "Nessun dato nel periodo selezionato.",
      minutiSottAcquaPerPeriodo: "Minuti sott'acqua per periodo",
      profonditaMassimaM: "Profondità massima (m)",
      immersioniPerPeriodo: "Immersioni per periodo",
      andamentoImmersioniHypertable: "Andamento immersioni (hypertable)",
    },
    pagesLogbookSyncOnlineModal: {
      eonSteelEonCoreD5Ocean: "Eon Steel · Eon Core · D5 · Ocean",
      suuntoApp: "Suunto App",
      fit: ".fit",
      diConnect: "DI_CONNECT/",
      account: "→ Account →",
      garminConnect: "Garmin Connect",
      cloudflareAntiBot: "Cloudflare anti-bot",
      descentMk1Mk2Mk3DescentG1: "Descent Mk1/Mk2/Mk3 · Descent G1",
      db: ".db",
      xml: ".xml",
      shearwaterDesktop: "Shearwater Desktop",
      perdixTericPeregrineTernPetrelNerd: "Perdix · Teric · Peregrine · Tern · Petrel · Nerd",
      shearwater: "Shearwater",
    },
    pagesLogbookTabsDiveAlertsTab: {
      ppo: "PPO₂",
      cns: "CNS%",
      critical: "Critical",
      warning: "Warning",
      info: "Info",
    },
    pagesLogbookTabsDiveDecompressionTab: {
      gfHigh: "GF High",
      gfLow: "GF Low",
    },
    pagesLogbookTabsDiveOverviewTab: {
      blackout: "Blackout",
      sambaLcm: "Samba / LCM",
    },
    pagesLogbookTabsDiveTissuesTab: {
      mValue: "M-value",
      mVal: "M-val",
      he: "He",
    },
    pagesLogbookTabsDiveWhatIfTab: {
      gfHigh: "GF High",
      gfLow: "GF Low",
    },
    pagesMarineMarineGalleryPage: {
      eliminaMedia: "Elimina media",
      modificaIFiltriOAggiungiMedia: "Modifica i filtri o aggiungi media dai tuoi log",
      nessunMediaTrovato: "Nessun media trovato",
      rifiutato: "Rifiutato",
      validato: "Validato",
      aiPending: "AI Pending",
      inAttesa: "In attesa",
      tutti: "Tutti",
      statoValidazione: "Stato validazione",
      esChromisChromis: "es. Chromis chromis",
      cercaSpecie: "Cerca specie",
      mediaBiologiciDaiLogDiImmersione: "Media biologici dai log di immersione",
      galleryScientificaMarina: "Gallery Scientifica Marina",
      approvatoPerTraining: "Approvato per training",
      approvazioneRimossa: "Approvazione rimossa",
      mediaEliminato: "Media eliminato",
    },
    pagesMedicalDoctorProfilePage: {
      xxxxxxxxXxxxXxxxXxxxXxxxxxxxxxxx: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    },
    pagesMedicalMedicalAssessmentWizard: {
      presentatiDescriviEventualiCondizioniMedicheRilevanti: "Presentati, descrivi eventuali condizioni mediche rilevanti o domande specifiche per il medico…",
      messaggioOpzionale: "Messaggio (opzionale)",
      seleziona: "— seleziona —",
      categoriaDiBrevettoRichiesta: "Categoria di brevetto richiesta",
      motivoDellaVisita: "Motivo della visita *",
      dopoAverInviatoLaRichiestaIl: "Dopo aver inviato la richiesta, il medico potrà accettarla e contattarti per organizzare la visita.",
      caricarlo: "caricarlo",
      caricaloQui: "Caricalo qui →",
      inserisciAlmenoIlNomeDelMedico: "Inserisci almeno il nome del medico",
      annulla: "Annulla",
      citta: "Città",
      strutturaStudioEsPoliambulatorioMarina: "Struttura / studio (es. Poliambulatorio Marina)",
      nomeDelMedico: "Nome del medico *",
      ilTuoMedicoNonESu: "Il tuo medico non è su eDive? Indicalo qui.",
      cambia: "Cambia",
      cercaMedicoPerNomeOCitta: "Cerca medico per nome o città…",
      prenotaUnaVisitaConUnMedico: "Prenota una visita con un medico. Se hai già il certificato, caricalo dal Fascicolo Sanitario.",
      richiediVisitaDiIdoneita: "Richiedi visita di idoneità",
      ilMedicoRiceveraLaTuaRichiesta: "Il medico riceverà la tua richiesta di visita di idoneità. Troverai la risposta nelle tue notifiche.",
      richiestaInviata: "Richiesta inviata!",
      tuttoPronto: "Tutto pronto!",
      erroreNellInvioDellaRichiesta: "Errore nell'invio della richiesta",
      haiGiaUnaConnessioneConQuesto: "Hai già una connessione con questo medico",
      richiestaInviataAlMedico: "Richiesta inviata al medico!",
    },
    pagesMedicalTabsAccessDoctorsFseTabs: {
      uuidCentroDiving: "UUID centro diving...",
    },
    pagesMedicalTabsAnalyticsTab: {
      aggiungiParametriVitaliOCaricaEsami: "Aggiungi parametri vitali o carica esami per attivare le analisi.",
      nessunDatoVitaleOEsameDisponibile: "Nessun dato vitale o esame disponibile per il periodo selezionato.",
      sintomiPostImmersioneUltimi90Gg: "Sintomi Post-Immersione (ultimi 90 gg)",
      andamentoEsamiDiLaboratorio: "Andamento Esami di Laboratorio",
      andamentoParametriVitali: "Andamento Parametri Vitali",
      correlazioniRilevate: "Correlazioni Rilevate",
      raccomandazioni: "Raccomandazioni",
      scaduta: "(SCADUTA)",
      analisiSanitariaAmpRiskScore: "Analisi Sanitaria &amp; Risk Score",
      erroreNelCaricamentoAnalytics: "Errore nel caricamento analytics",
      calcoloProfiloDiRischio: "Calcolo profilo di rischio…",
      validaFinoAl: "Valida fino al",
      esDrMarioRossi: "Es. Dr. Mario Rossi",
      medicoEnteRilasciante: "Medico / Ente rilasciante",
      idoneitaSubacquea: "🤿 Idoneità subacquea",
      condizioniMediche: "🏥 Condizioni mediche",
      allergie: "⚠️ Allergie",
      seleziona: "— Seleziona —",
      gruppoSanguigno: "🩸 Gruppo sanguigno",
    },
    pagesMedicalTabsOverviewTab: {
      ediveMedicalProfile: "eDive Medical Profile",
    },
    pagesMedicalTabsVaccinationsVitalsTabs: {
      spo: "SpO₂",
      nessunaRilevazione: "Nessuna rilevazione",
      spo2: "SpO₂ (%)",
    },
    pagesNewsNewsReaderPage: {
      nessunArticoloDisponibile: "Nessun articolo disponibile",
      lingua: "Lingua",
      redazioneNews: "Redazione News",
      leggiArticolo: "Leggi articolo",
    },
    pagesOnboardingwizardutils: {
      altro: "Altro",
      selezionaPaese: "— seleziona paese —",
    },
    pagesPlanningPlanDiveWizard: {
      buhlmannZhl16cGf3085: "(Bühlmann ZHL-16C · GF 30/85)",
    },
    pagesPlanningPlanningToolsPage: {
      pianifica: "Pianifica",
      calcolatriciAvanzateMultiImmersioneMisceleGas: "Calcolatrici avanzate: multi-immersione, miscele gas, MOD/EAD, gas blending, CCR e utilità. Per la pianificazione standard usa Pianifica.",
      strumentiTecnici: "Strumenti tecnici",
    },
    pagesPlanningTabsCCRTab: {
      vpmB: "VPM-B",
      buhlmannZhl16c: "Bühlmann ZHL-16C",
      cnsOtu: "CNS / OTU",
    },
    pagesPlanningTabsConditionsTab: {
      previsioni7Giorni: "Previsioni 7 giorni",
    },
    pagesPlanningTabsDiveProfileTab: {
      "3Min": "3 min",
      ceil: "Ceil.",
      lowHigh: "Low / High",
      rgbmFactor: "RGBM Factor",
      vpmBConservatism: "VPM-B Conservatism",
      min: "min",
      piuProfonditaTempoRPiuBasso: ". Più profondità/tempo → R più basso → prima sosta più profonda. GF High rimane invariato.",
      gfLowR: "GF Low × R",
      gfLowEffettivo: "GF Low effettivo =",
      "005BarHr": "(ω = 0.05 bar⁻¹·hr⁻¹)",
      gfHigh: "GF High",
      algoritmoDelVolumeCritico2295: "algoritmo del Volume Critico (λ ≈ 229.5 bar·min) — aggiunge conservatismo iterativo per immersioni lunghe/profonde.",
      "179DyneCmC257": "γ = 17.9 dyne/cm · γ_c = 257 dyne/cm · 16 compartimenti tissutali (N₂ + He separati).",
      iMicronucleiGassosiDiRaggioR: "I micronuclei gassosi di raggio r₀ vengono schiacciati dalla pressione massima di discesa. In risalita la supersaturazione tissutale non può superare 2γ/r_crushed.",
      gfLow: "GF Low",
      presetGradientFactors: "Preset Gradient Factors",
      ppo: "ppO₂",
      rmvLMin: "RMV (L/min)",
      gt15: "&gt;15'",
      totale: "Totale",
      he: "He",
    },
    pagesPlanningTabsGasBlendingTab: {
      modPpo14: "MOD (ppO₂ 1.4)",
      he: "He",
    },
    pagesPlanningTabsGasTab: {
      rmvLMin: "RMV (L/min)",
      mod16: "MOD @ 1.6",
      mod14: "MOD @ 1.4",
      mix: "Mix",
      ppo16: "@ ppO₂ 1.6",
      contingencyMod: "Contingency MOD",
      ppo14: "@ ppO₂ 1.4",
      trainingMod: "Training MOD",
      ppoLimitBar: "ppO₂ limit (bar)",
      oFraction: "O₂ Fraction",
    },
    pagesPlanningTabsMultiDiveTab: {
      gfHigh: "GF High",
      gfLow: "GF Low",
    },
    pagesPlanningTabsUtilityTab: {
      kcalHr: "kcal/hr",
      kcal: "kcal",
      wh: "Wh",
    },
    pagesProfileAddCertificationWizard: {
      es123456: "Es. #123456",
      marioRossi: "Mario Rossi",
      esPadi1234567: "Es. PADI-1234567",
    },
    pagesProfileAddEquipmentWizard: {
      esAbyssMk25: "Es. Abyss, Mk25…",
      esMaresScubapro: "Es. Mares, ScubaPro…",
    },
    pagesProfileCertScanQueue: {
      cert: "cert",
    },
    pagesProfileCertScanWizard: {
      cert: "cert",
    },
    pagesProfileCertWalletPage: {
      qrWalletCertificazioni: "QR wallet certificazioni",
    },
    pagesProfileTabsAnagraficaTab: {
      campoObbligatorio: "Campo obbligatorio",
      esRomaMilano: "Es. Roma, Milano…",
    },
    pagesProfileTabsBrevettiTab: {
      back: "back",
      front: "front",
      es123456: "es. 123456",
      esMarioRossi: "es. Mario Rossi",
      opz: "(opz.)",
      esP12345678: "es. P-12345678",
      fronteBrevetto: "Fronte brevetto",
    },
    pagesProfileTabsContattiTab: {
      username: "@username",
    },
    pagesProfileTabsEmergenzaTab: {
      campoObbligatorio: "Campo obbligatorio",
      allergieFarmaciCondizioniRilevanti: "Allergie, farmaci, condizioni rilevanti...",
      coniugeGenitore: "Coniuge, Genitore...",
    },
    pagesProfileTabsFreedivingTab: {
      es30: "es. 30",
      es75: "es. 75",
      es300: "es. 300",
      rebreather: "Rebreather",
      snorkeling: "Snorkeling",
    },
    pagesProfileTabsPreferenzeTab: {
      europeRome: "Europe/Rome",
      english: "English",
      italiano: "Italiano",
    },
    pagesProfileTabsRuoliTab: {
      descrivitiBrevementeEsperienzaCertificazioniStruttura: "Descriviti brevemente: esperienza, certificazioni, struttura...",
    },
    pagesPublicBlogPage: {
      blogEdiveSicurezzaTecnicaESiti: "Blog eDive — sicurezza, tecnica e siti d'immersione",
    },
    pagesPublicContattiPage: {
      privacyPolicy: "Privacy Policy",
      whatsapp: "WhatsApp",
      supportEdiveTech: "support@edive.tech",
    },
    pagesPublicDataDeletionPage: {
      supportEdiveTech: "support@edive.tech",
    },
    pagesPublicGdprInfoPage: {
      wwwGaranteprivacyItPiazzaVenezia11: "www.garanteprivacy.it · Piazza Venezia 11, Roma",
      garantePerLaProtezioneDeiDati: "Garante per la Protezione dei Dati Personali",
      supportEdiveTech: "support@edive.tech",
    },
    pagesPublicPrivacyPolicyPage: {
      supportEdiveTech: "support@edive.tech",
      ultimoAggiornamento24Maggio2026Versione: "Ultimo aggiornamento: 24 maggio 2026 · Versione 2.2",
    },
    pagesPublicPublicArticlePage: {
      registratiGratis: "Registrati gratis",
      entraNellaCommunityEdive: "Entra nella community eDive",
      tornaAlBlog: "← Torna al blog",
      articoloNonTrovato: "Articolo non trovato.",
      caricamento: "Caricamento…",
      blog: "← Blog",
    },
    pagesPublicPublicCenterDetailPage: {
      iniziaConEdive: "Inizia con eDive",
      sito: "Sito",
      divingCenter: "Diving center",
      directory: "← Directory",
      centroNonTrovato: "Centro non trovato.",
      caricamento: "Caricamento…",
      divingCenter2: "← Diving center",
    },
    pagesPublicPublicCentersPage: {
      nessunCentroDisponibile: "Nessun centro disponibile.",
      caricamento: "Caricamento…",
      centriImmersioneCensitiNellaCommunityEdive: "Centri immersione censiti nella community eDive.",
      divingCenter: "Diving center",
      registrati: "Registrati",
      divingCenterDirectoryEdive: "Diving center — directory eDive",
    },
    pagesPublicPublicDiveSiteDetailPage: {
      iniziaGratis: "Inizia gratis",
      logbookDigitaleCentriDivingSicurezzaE: "Logbook digitale, centri diving, sicurezza e community — gratis.",
      aPortataDaQuestoPuntoD: "A portata da questo punto d'immersione — non ancora confermato dai centri.",
      valutazione: "Valutazione",
      difficolta: "Difficoltà",
      visibilita: "Visibilità",
      profondita: "Profondità",
      sitiDImmersione: "Siti d'immersione",
      tuttiISitiDImmersione: "← Tutti i siti d'immersione",
      sitoDImmersioneNonTrovato: "Sito d'immersione non trovato.",
      caricamento: "Caricamento…",
      tuttiISiti: "Tutti i siti",
    },
    pagesPublicPublicDiveSitesPage: {
      nessunSitoDisponibile: "Nessun sito disponibile.",
      caricamento: "Caricamento…",
      sitiDImmersione: "Siti d'immersione",
      registrati: "Registrati",
      sitiDImmersioneNelMondoGuida: "Siti d'immersione nel mondo — Guida eDive",
    },
    pagesPublicPublicSpeciesDetailPage: {
      registratiGratis: "Registrati gratis",
      specie: "Specie",
      enciclopedia: "← Enciclopedia",
      specieNonTrovata: "Specie non trovata.",
      caricamento: "Caricamento…",
    },
    pagesPublicPublicSpeciesPage: {
      nessunaSpecieDisponibile: "Nessuna specie disponibile.",
      caricamento: "Caricamento…",
      mettitiAllaProva: "🐠 Mettiti alla prova",
      enciclopediaDelleSpecieMarine: "Enciclopedia delle specie marine",
      registrati: "Registrati",
      enciclopediaDelleSpecieMarineEdive: "Enciclopedia delle specie marine — eDive",
    },
    pagesPublicTerminiServizioPage: {
      ultimoAggiornamento24Maggio2026Versione: "Ultimo aggiornamento: 24 maggio 2026 · Versione 2.1",
    },
    pagesReferralMyNetworkPage: {
      totaleRete: "Totale rete",
      "2Livello": "2° livello",
      "1Livello": "1° livello",
      condividiIlTuoCodiceInvitoDal: "Condividi il tuo codice invito dal profilo per iniziare a costruire la tua rete.",
      nessunInvitoAncora: "Nessun invito ancora",
      caricamento: "Caricamento…",
      lePersoneCheHaiInvitato1: "Le persone che hai invitato (1° livello) e quelle invitate da loro (2° livello)",
      laMiaRete: "La mia rete",
    },
    pagesResearchcenterResearchCenterPage: {
      depthM: "depth_m",
    },
    pagesSearchSearchPage: {
      sitiSubacqueiEventiCentriSpecieMarine: "Siti, subacquei, eventi, centri, specie marine, articoli",
      iniziaACercare: "Inizia a cercare",
      cerca: "Cerca",
      cercaSitiSubacqueiEventiCentriSpecie: "Cerca siti, subacquei, eventi, centri, specie...",
      provaConParoleDiverseOControlla: "Prova con parole diverse o controlla l'ortografia",
    },
    pagesServicesServiceDetailPage: {
      whatsapp: "WhatsApp",
      breadcrumb: "breadcrumb",
    },
    pagesSocialCreateSquadWizard: {
      dopoLaCreazionePotraiInvitareMembri: "Dopo la creazione potrai invitare membri, organizzare uscite e chattare nel feed dello squad.",
      squadEmailIt: "squad@email.it",
      emailContatto: "Email contatto",
      telefonoContatto: "Telefono contatto",
      visibilita: "Visibilità",
      chiSieteDoveOperateCosaOrganizzate: "Chi siete, dove operate, cosa organizzate…",
      descrizione: "Descrizione",
      tipoDiSquad: "Tipo di squad *",
      esPalermitaniSubDeepHunters: "Es. Palermitani Sub, Deep Hunters…",
      nomeDelloSquad: "Nome dello squad *",
      riunisciSubacqueiConInteressiSimili: "Riunisci subacquei con interessi simili",
      creaUnoSquad: "Crea uno squad",
      squadCreato: "Squad creato!",
    },
    pagesSocialDiveSquadsPage: {
      esDeepBlueExplorers: "es. Deep Blue Explorers",
    },
    pagesSocialTabsBuddyRadarTab: {
      buddyRadar: "Buddy Radar",
    },
    pagesSocialTabsEventiTab: {
      esUscitaCapoCacciaNightDive: "Es. Uscita Capo Caccia, Night Dive...",
    },
    pagesSocialTabsPersoneTab: {
      apriChat: "Apri chat",
    },
    pagesSpeciesContributeSpeciesMediaWizard: {
      inaturalistCv: "iNaturalist CV",
      preview: "preview",
    },
    pagesSpeciesSpeciesEncyclopedia: {
      ediveEdiveFreeddnsIt: "eDive — edive.freeddns.it",
      mergedScientificName: "${merged.scientific_name}",
    },
    pagesSpeciesUnifiedSpeciesPage: {
      gestioneDati: "Gestione dati",
      mieiContributi: "Miei contributi",
      laMiaLista: "La mia lista",
      enciclopedia: "Enciclopedia",
    },
    pagesTourismTourismPage: {
      strumentiEsplora: "Strumenti esplora",
      pubblico: "Pubblico",
      nessunViaggioPianificatoCreaIlTuo: "Nessun viaggio pianificato. Crea il tuo primo itinerario!",
      caricamento: "Caricamento…",
      iTuoiViaggiSubacqueiPianificati: "I tuoi viaggi subacquei pianificati",
      viaggioEliminato: "Viaggio eliminato",
      viaggioAggiornato: "Viaggio aggiornato",
      viaggioCreato: "Viaggio creato",
      aggiungiPrenotazione: "+ Aggiungi prenotazione",
      annulla: "Annulla",
      noteOpzionale: "Note (opzionale)",
      dataFine: "Data fine",
      dataInizio: "Data inizio *",
      prenotazioneAggiunta: "Prenotazione aggiunta",
      note: "Note",
      cittaZona: "Città / zona",
      destinazione: "Destinazione",
      esEstate2026Maldive: "Es. Estate 2026 — Maldive",
      titolo: "Titolo *",
      infoOperatoreIt: "info@operatore.it",
      emailContatto: "Email contatto",
      telefonoContatto: "Telefono contatto",
      inclusoNelPrezzo: "Incluso nel prezzo",
      dataFineDisponibilita: "Data fine disponibilità",
      dataInizioDisponibilita: "Data inizio disponibilità",
      esOwdAowd: "Es. OWD, AOWD",
      certificazioneMinima: "Certificazione minima",
      esSharmElSheikh: "Es. Sharm el-Sheikh",
      portoCittaDiPartenza: "Porto / Città di partenza",
      esMarRossoMaldive: "Es. Mar Rosso, Maldive",
      regioneArea: "Regione / Area",
      chiudi: "Chiudi",
      nessunaPrenotazionePerQuestoPacchetto: "Nessuna prenotazione per questo pacchetto",
      gestionePrenotazioni: "Gestione prenotazioni",
      dataDiPartenza: "Data di partenza",
      prezzoAPersona: "Prezzo a persona",
    },
    pagesTripsComponentsTripParts: {
      cercaSitoDiImmersione: "Cerca sito di immersione…",
    },
  },
  mktAdmin: {
    filtroEmailTitolo: "Filtra per presenza dell'indirizzo e-mail",
    emailTutti: "E-mail: tutti",
    emailSi: "E-mail: sì",
    emailNo: "E-mail: no",
    nomeMancante: "nome mancante",
    indirizzoRimosso: "indirizzo rimosso",
    conteggioParziale: "conteggio parziale (prime {{n}} righe)",
    conteggioParzialeAnagrafiche: "conteggio parziale (prime {{n}} anagrafiche)",
    filtrati: "(filtrati)",
    quando: "Quando",
    percheSucccede: "perché succede",
    tutte: "Tutte",
    definitivoSi: "Definitivo: riprovare non serve",
    definitivoNo: "Si può riprovare più avanti",
    rimbalziConteggio: "{{n}} rimbalzi",
    azioniAnagrafica: "Anagrafica",
    azioniElimina: "Elimina",
    azioniRimuoviIndirizzo: "Rimuovi indirizzo",
    titoloAggiornaAnagrafica: "Aggiorna nome, telefono e dati della persona",
    titoloRimuoviIndirizzo: "L'indirizzo non esiste più: toglilo dall'anagrafica",
    titoloElimina: "Elimina il contatto, e se vuoi anche la scheda in anagrafica",
    rimbalzi: {
      "casella-inesistente": {
        etichetta: "Casella inesistente",
        descrizione: "Il server accetta posta per quel dominio, ma quell'utente non esiste.",
        spiegazione: "Di solito è una persona che ha lasciato l'azienda, oppure un indirizzo trascritto male. Non tornerà a funzionare: o si trova il recapito nuovo, o si toglie l'indirizzo.",
      },
      "dominio-inesistente": {
        etichetta: "Dominio inesistente",
        descrizione: "Il dominio dopo la chiocciola non esiste più o non riceve posta.",
        spiegazione: "L'azienda ha chiuso, ha cambiato dominio o non ha mai avuto un server di posta. Va tolto l'indirizzo: ogni tentativo successivo è un errore annunciato.",
      },
      "accesso-negato": {
        etichetta: "Rifiutato dal destinatario",
        descrizione: "Il server destinatario ha rifiutato il messaggio per una sua regola.",
        spiegazione: "Antispam, lista di blocco o una politica che accetta solo mittenti conosciuti. Non dice niente sull'esistenza della casella: se sono tanti sullo stesso provider, il problema è la reputazione del nostro mittente, non l'indirizzo.",
      },
      "casella-piena": {
        etichetta: "Casella piena",
        descrizione: "La casella ha superato lo spazio disponibile.",
        spiegazione: "L'indirizzo è valido e la persona c'è: semplicemente non entra altra posta. Ha senso riprovare più avanti; se resta piena per settimane, è una casella abbandonata.",
      },
      "casella-non-disponibile": {
        etichetta: "Casella non disponibile",
        descrizione: "La casella esiste ma è disattivata, sospesa o non accetta posta.",
        spiegazione: "Tipico degli account chiusi di recente e delle caselle di servizio disabilitate. Va trattata come un recapito perso, salvo conferma contraria dalla persona.",
      },
      "indirizzo-non-valido": {
        etichetta: "Indirizzo non valido",
        descrizione: "Il server ha rifiutato l'indirizzo come scritto male.",
        spiegazione: "Uno spazio, un carattere strano, una virgola al posto del punto. Si corregge l'indirizzo in anagrafica e si rimette in coda.",
      },
      temporaneo: {
        etichetta: "Problema temporaneo",
        descrizione: "Il server ha chiesto di riprovare più tardi.",
        spiegazione: "Sovraccarico, manutenzione o greylisting (il filtro che rifiuta il primo tentativo di un mittente mai visto). Si riprova: spesso il secondo invio passa.",
      },
      "rifiuto-definitivo": {
        etichetta: "Rifiuto definitivo",
        descrizione: "Il server ha rifiutato la consegna senza dire il motivo preciso (550).",
        spiegazione: "Nella maggior parte dei casi è una casella che non esiste più, ma può essere anche un filtro che ci ha bloccati. Se lo stesso dominio rifiuta tutto, guarda la reputazione del mittente prima di cancellare gli indirizzi.",
      },
      sconosciuto: {
        etichetta: "Motivo non riportato",
        descrizione: "Il rimbalzo è arrivato senza codice né testo utilizzabile.",
        spiegazione: "Il messaggio di ritorno non conteneva il motivo, oppure l'abbiamo registrato prima di saperlo leggere. Per capirne di più serve il rapporto di mancata consegna originale.",
      },
    },
    disiscritti: {
      tab: "Disiscritti",
      intro: "Hanno revocato il consenso: nessuna campagna li raggiunge più. Da qui si eliminano definitivamente dalla rubrica. La revoca resta registrata nel Centro Comunicazioni anche dopo la cancellazione, così l'indirizzo non torna contattabile per sbaglio.",
      conteggio: "{{n}} disiscritti",
      revocatoIl: "Revocato il",
      origine: "Origine",
      nessunoTitolo: "Nessun disiscritto",
      nessunoDesc: "Nessuno ha revocato il consenso: non c'è niente da ripulire.",
      apriScheda: "Apri la scheda",
      eliminaDallaRubrica: "Elimina dalla rubrica",
    },
    completare: {
      tab: "Da completare",
      intro: "Anagrafiche a cui manca qualcosa per essere contattabili. Escono una alla volta, quelle più facili da trovare per prime: chi ha un sito, un numero o una città si rintraccia in un minuto. Le schede dei Servizi non entrano in questa coda — non vanno contattate comunque.",
      conteggio: "<strong>{{n}}</strong> da completare",
      riepilogo: "senza e-mail {{email}} · senza nome {{nome}} · senza telefono {{telefono}}",
      includiRimandati: "rimetti dentro quelle rimandate",
      nessunaTitolo: "Nessuna scheda da completare",
      nessunaDesc: "Tutte le anagrafiche contattabili hanno nome, indirizzo e telefono.",
      bloccoFinito: "Finito questo blocco: {{n}} schede viste.",
      caricaProssimo: "Carica il blocco successivo",
      posizione: "scheda {{i}} di {{n}}",
      manca: "manca {{cosa}}",
      cosaEmail: "e-mail",
      cosaNome: "nome",
      cosaTelefono: "telefono",
      cosaIndirizzo: "indirizzo",
      cosaSito: "sito",
      azienda: "azienda",
      persona: "persona",
      doveCercare: "Dove cercare",
      cercaGoogle: "Cerca su Google",
      cercaLinkedin: "Cerca su LinkedIn",
      cercaNumero: "Cerca il numero",
      apriSito: "Apri il sito",
      facebook: "Facebook",
      instagram: "Instagram",
      profiloLinkedin: "Profilo LinkedIn",
      campoNome: "Nome",
      campoEmail: "E-mail",
      campoTelefono: "Telefono",
      campoIndirizzo: "Indirizzo",
      campoCitta: "Città",
      campoCap: "CAP",
      campoPaese: "Paese",
      campoSito: "Sito web",
      campoNascita: "Data di nascita",
      placeholderNome: "Nome e cognome, o ragione sociale",
      placeholderEmail: "nome@dominio.it",
      placeholderTelefono: "+39…",
      placeholderIndirizzo: "Via e numero civico",
      placeholderSito: "https://…",
      notaConsenso: "Salvando, l'anagrafica torna fra i raggiungibili. Il consenso resta da chiedere: un indirizzo trovato su internet non è un consenso.",
      salva: "Salva e rimetti in coda",
      rimanda: "Rimanda",
      elimina: "Elimina",
      propostePerTitolo: "Trovato sul sito",
      proposteNota: "Letto da {{sito}}. Clicca un valore per metterlo nel campo.",
      cercaSulSito: "Cerca sul sito",
      cercaSulSitoInCorso: "sto leggendo il sito…",
      nienteSulSito: "Sul sito non si è trovato nessun recapito.",
      sitoIrraggiungibile: "Il sito non risponde.",
      salvataOk: "Scheda completata: il contatto è di nuovo raggiungibile",
      salvataSenzaRecapito: "Scheda aggiornata",
    },
    orario: {
      titolo: "Ora per ora",
      nota: "Ogni riga è l'ora in cui i messaggi sono partiti: accettati dal server del destinatario, respinti (con il motivo), aperti, cliccati, e quante conferme di consenso sono arrivate da chi ha ricevuto in quell'ora.",
      ora: "Ora",
      partiti: "Partiti",
      accettati: "Accettati",
      respinti: "Respinti",
      aperti: "Aperti",
      click: "Click",
      conferme: "Conferme",
      totale: "Totale",
      respintiPerMotivo: "Respinti per motivo: {{elenco}}",
      invii: "Invii, uno per uno",
    },
    toast: {
      contattoEAnagrafica: "Contatto e anagrafica eliminati",
      anagraficaNonCancellata: "Contatto eliminato. Anagrafica NON cancellata: {{motivo}}",
      anagraficaRifiutata: "rifiutata",
      indirizzoRimosso: "Indirizzo {{email}} rimosso dall'anagrafica",
      senzaRecapito: "Contatto marcato senza recapito",
      erroreSyncUtenti: "Errore sincronizzazione utenti",
      erroreSyncCatalogo: "Errore sincronizzazione catalogo",
    },
    referral: {
      cerca: "Cerca per nome, codice o ID…",
      nessunaRete: "Nessuna rete referral",
      nessunaReteDesc: "Non ci sono ancora collegamenti di invito.",
      collegatoIl: "collegato all'invitante il {{data}}",
    },
  },
  medItems: {
    start: "Inizio",
    end: "Fine",
    ongoing: "In corso",
  },
  wizardShell: {
    stepCounter: "Passo {{current}} di {{total}} — {{label}}",
    cancel: "Annulla",
    back: "Indietro",
    next: "Avanti",
    save: "Salva",
    saving: "Salvataggio…",
  },
  regRoles: {
    title: "Vuoi anche un ruolo operativo?",
    intro: "Il tuo account parte come utente base del sistema. Se operi come professionista o organizzazione, seleziona qui sotto i ruoli che ti interessano: verranno valutati dall'amministratore e autorizzati successivamente, previa raccolta delle informazioni necessarie.",
    notesLabel: "Note per la richiesta (facoltative)",
    notesPlaceholder: "Indica informazioni utili alla valutazione: brevetti, agenzia didattica, sede, esperienza…",
    pendingNote: "I ruoli selezionati resteranno in attesa di approvazione dell'amministratore.",
    certNote: "Le qualifiche di Divemaster e Istruttore non si richiedono qui: si ottengono automaticamente registrando il relativo brevetto dal tuo profilo.",
    finish: "Completa registrazione",
  },
  diveSitePicker: {
    label: "Punto di immersione",
    searchPlaceholder: "Cerca un punto censito o scrivi il nome…",
    registered: "censito",
    hideCoords: "Nascondi coordinate",
    enterCoords: "Inserisci coordinate",
    proposeNew: "Proponi un nuovo punto",
    latitude: "Latitudine",
    longitude: "Longitudine",
    latExample: "es. 40.5523",
    lngExample: "es. 14.3341",
    geocoding: "Rilevamento nazione/comune dalle coordinate…",
    recent: "Recenti:",
  },
  contributeSpecies: {
    stepPhoto: "Carica foto",
    stepIdentify: "Identifica specie",
    stepDetails: "Dettagli",
    stepSummary: "Riepilogo e invio",
    scanPhaseAnalyzing: "Analisi immagine in corso…",
    scanPhaseMorphology: "Ricerca caratteristiche morfologiche…",
    scanPhaseDatabase: "Confronto con il database marino…",
    scanPhaseIdentifying: "Identificazione in corso…",
    confidenceHigh: "Alta",
    confidenceMedium: "Media",
    confidenceLow: "Bassa",
    confidenceLabel: "Fiducia",
    notInDb: "non nel DB",
    errorInvalidImage: "Seleziona un'immagine valida (JPG, PNG, HEIC)",
    errorImageTooLarge: "Immagine troppo grande (max 20 MB)",
    errorUploadFailed: "Errore nel caricamento della foto. Riprova.",
    visionNoModelResponse: "Il modello AI non ha risposto. Cerca la specie manualmente.",
    errorNoImagesSent: "Nessuna immagine inviata",
    toastSubmitted: "Contributo inviato!",
    errorSubmit: "Errore nell'invio",
    thankYouTitle: "Grazie!",
    thankYouBody: "Il tuo contributo arricchisce la banca dati marina di eDive. Il team di biologia marina esaminerà le foto entro",
    sevenDays: "7 giorni",
    thankYouEmail: "📧 Riceverai un'email di ringraziamento a breve.",
    followReviews: "Segui le revisioni →",
    close: "Chiudi",
    title: "Contribuisci all'archivio marino",
    subtitle: "Carica foto di specie marine — l'AI le identifica per te",
    finalLabel: "Invia contributo",
    step0Intro: "Carica una foto di una specie marina.",
    step0IntroBold: "L'AI riconoscerà automaticamente la specie",
    step0IntroEnd: "— potrai confermare o correggere nel passo successivo.",
    uploadDragDrop: "Trascina o clicca per caricare",
    uploadFormats: "JPG, PNG, HEIC — max 20 MB",
    aiAutoRecognition: "Riconoscimento AI automatico",
    speciesDetected: "{{count}} specie rilevate",
    manualSearch: "Ricerca manuale",
    photoUploaded: "Foto caricata",
    identifyingInProgress: "🔍 Identificazione in corso…",
    aiAnalyzingPhoto: "Il modello AI analizza la tua foto (15–45 secondi)",
    tipLabel: "Consiglio:",
    tipBody: "Usa foto nitide con buona illuminazione. Il riconoscimento funziona meglio quando la specie occupa almeno metà dell'inquadratura.",
    speciesIdentifiedOne: "Specie identificata dall'AI",
    speciesIdentifiedMany: "{{count}} specie identificate dall'AI",
    orSearchManually: "oppure cerca manualmente",
    noSpeciesRecognized: "Nessuna specie riconosciuta dalla foto",
    aiUnavailable: "Riconoscimento AI non disponibile",
    noSpeciesRecognizedBody: "Il modello non ha identificato specie con sufficiente certezza. Puoi cercare la specie manualmente qui sotto — bastano le prime lettere del nome comune o scientifico.",
    aiUnavailableBody: "Il servizio AI non ha risposto. Cerca la specie manualmente qui sotto.",
    typeSpeciesName: "👇 Digita il nome della specie nel campo di ricerca",
    searchPhotographedSpecies: "Cerca la specie fotografata usando il campo qui sotto.",
    searchPlaceholder: "Cerca per nome comune o scientifico…",
    speciesUnidentified: "Specie non identificata",
    moderatorsWillAssign: "I moderatori analizzeranno la foto e assegneranno la specie",
    dontKnowSpecies: "🔍 Non conosco la specie — lascia identificare ai moderatori",
    speciesToIdentify: "Specie da identificare",
    moderatorsWillAssignCorrect: "I moderatori analizzeranno la foto e assegneranno la specie corretta",
    depthLabel: "Profondità (m)",
    depthPlaceholder: "Es. 12",
    locationLabel: "Luogo / sito sub",
    locationPlaceholder: "Es. Secca del Corallo",
    notesLabel: "Note",
    optional: "(facoltativo)",
    notesPlaceholder: "Comportamento osservato, condizioni di luce, ora del giorno…",
    addMoreHint: "Nel passo successivo potrai aggiungere altre specie dallo stesso diving.",
    contributionReadyOne: "contributo pronto",
    contributionReadyMany: "contributi pronti",
    itemUnidentified: "🔍 Specie non identificata",
    willBeIdentified: "Verrà identificata dai moderatori",
    depthMeters: "{{depth}} m",
    addAnotherSpecies: "Aggiungi un'altra specie",
    consentTitle: "📋 Informativa contributo fotografico",
    consentBody: "Dichiarando di essere l'autore, concedi a eDive una licenza non esclusiva per inserire le foto nella banca dati marina pubblica con attribuzione al tuo profilo. Le immagini saranno sottoposte a revisione entro 7 giorni.",
    consentCheckbox: "Sono l'autore delle immagini e autorizzo eDive a pubblicarle con attribuzione.",
    emailOnCompletion: "📧 Riceverai un'email di ringraziamento al completamento.",
  },
  mediaEditor: {
    linkToDive: "Collega a immersione",
    diveSearchPlaceholder: "Cerca per sito, data, numero…",
    audioEditorTitle: "Editor Audio",
    videoEditorTitle: "Editor Video",
    imageEditorTitle: "Editor Immagine",
    save: "Salva",
    saving: "Salvataggio…",
    saveCopy: "Salva copia",
    saveLink: "Salva collegamento",
    download: "Scarica",
    downloadOriginal: "Scarica originale",
    metadata: "Metadati",
    metadataSaved: "Metadati salvati",
    paramsSaved: "Parametri salvati",
    metadataSavedLocally: "Metadata salvati localmente — elaborazione in coda",
    saveError: "Errore nel salvataggio",
    saveFailed: "Salvataggio fallito",
    imageSavedToLibrary: "Immagine salvata nella libreria",
    linkUpdated: "Collegamento aggiornato",
    downloadFailed: "Download fallito",
    imageLoadError: "Impossibile caricare l'immagine per la modifica",
    recordingDepth: "Profondità registrazione (m)",
    captureDepth: "Profondità ripresa (m)",
    waterTemp: "Temperatura acqua (°C)",
    visibility: "Visibilità (m)",
    depthPlaceholder: "es. 18",
    tempPlaceholder: "es. 22",
    visibilityPlaceholder: "es. 15",
    notes: "Note",
    notesPlaceholderAudio: "Descrizione, specie avvistate…",
    notesPlaceholderVideo: "Posizione, specie avvistate…",
    diveParams: "Parametri immersione",
    previewUnavailable: "Anteprima non disponibile",
    enhancementQueue: "Coda miglioramenti",
    enhancementQueueDesc: "Seleziona i filtri da applicare in elaborazione",
    videoBackgroundNote: "I miglioramenti video vengono elaborati in background — il file originale rimane invariato.",
    enhBrightness: "Luminosità",
    enhContrast: "Contrasto",
    enhSaturation: "Saturazione",
    enhRedRecovery: "Recupero rossi (sub)",
    enhDehaze: "Rimozione foschia",
    loading: "Caricamento…",
    underwaterCorrectionInProgress: "Correzione subacquea in corso…",
    tabCrop: "Ritaglia",
    tabRotate: "Ruota",
    tabUnderwater: "Sub",
    tabFilters: "Filtri",
    tabExport: "Export",
    cropHint: "Trascina sull'immagine per selezionare l'area di ritaglio.",
    cropSelection: "Selezione: {{w}} × {{h}} px",
    cropOrigin: "Origine: ({{x}}, {{y}})",
    removeSelection: "Rimuovi selezione",
    quickRatios: "Proporzioni rapide",
    freeAngle: "Angolo libero",
    resetRotation: "Ripristina rotazione",
    imageAnalysis: "Analisi immagine",
    redDeficit: "Deficit rosso",
    haze: "Foschia",
    contrast: "Contrasto",
    estimatedDepth: "Profondità stimata:",
    autoOptimize: "Auto-ottimizza",
    autoOptimizeDesc: "Analizza e applica automaticamente la correzione ottimale",
    orChooseByDepth: "Oppure scegli per profondità",
    depthDescShallow: "Standard · cast lieve",
    depthDescMedium: "Standard · cast moderato",
    depthDescDeep: "UDCP · rossi quasi assenti",
    depthDescAbyss: "UDCP · quasi monocromatico",
    advancedAdjustment: "Regolazione avanzata",
    correctionStrength: "Forza correzione",
    localContrastClahe: "Contrasto locale (CLAHE)",
    off: "off",
    sharpness: "Nitidezza",
    gammaLift: "Gamma lift",
    algorithm: "Algoritmo",
    reset: "Ripristina",
    presets: "Preimpostazioni",
    presetOriginal: "Originale",
    presetVivid: "Vivace",
    presetCold: "Freddo",
    presetVintage: "Vintage",
    presetBw: "B&N",
    brightness: "Luminosità",
    contrastFilter: "Contrasto",
    saturation: "Saturazione",
    hue: "Tonalità (°)",
    blur: "Sfocatura (px)",
    resetFilters: "Ripristina filtri",
    outputFormat: "Formato output",
    quality: "Qualità",
    estimatedSize: "Dimensione stimata",
    originalSize: "Originale: {{kb}} KB",
  },
  dcOps: {
    kitCOMPRESSOR_SERVICE: "Manutenzione compressore",
    kitAIR_QUALITY: "Analisi dell’aria",
    kitFILTER_CHANGE: "Cambio filtri compressore",
    phase_PRE_DEPARTURE: "A terra, prima della partenza",
    phase_ON_BOARD: "A bordo, prima dell’ingresso in acqua",
    kitTitle: "Kit di sicurezza",
    kitOXYGEN: "Kit ossigeno",
    kitFIRST_AID: "Kit di primo soccorso",
    kitCheckedAt: "Verificato il",
    kitNextDue: "Prossimo controllo entro il",
    kitRegister: "Registra verifica",
    kitNone: "Nessuna verifica registrata.",
    kitSaved: "Verifica registrata",
    kitError: "Registrazione non riuscita.",
    tabCheckin: "Check-in",
    tabBriefing: "Briefing",
    tabPostDive: "Post-Immersione",
    tabRegister: "Registro L.70",
    briefingConfirmed: "Briefing confermato",
    briefingConfirmError: "Errore conferma briefing",
    ecoConfirmed: "Eco-awareness confermata",
    ecoConfirmError: "Errore conferma eco-awareness",
    preDiveRegSaved: "Registrazione pre-immersione salvata",
    regError: "Errore nella registrazione",
    postDiveRegistered: "Post-immersione registrata",
    updateError: "Errore aggiornamento",
    noDiveReadFromComputer: "Nessuna immersione letta dal computer",
    readFromComputer: "Letto dal computer: max {{max}} m · {{min}} min",
    computerReadError: "Errore lettura computer",
    depthUpdatedFromComputer: "Profondità aggiornata col dato del computer",
    pageSubtitle: "Check-in, safety checklist pre-immersione, briefing RSTC, note post-dive",
    confirmedBookingsTitle: "Prenotazioni Confermate",
    checklistLink: "Checklist",
    safetyChecklistTitle: "Safety Checklist Pre-Immersione",
    dm1996Items: "{{checked}}/{{total}} item obbligatori",
    compliant: "conformi",
    missing: "mancanti",
    diveReference: "Riferimento immersione",
    diveReferencePlaceholder: "ID prenotazione o nome uscita...",
    itemsCompleted: "{{checked}}/{{total}} voci completate",
    additionalNotes: "Note aggiuntive",
    additionalNotesPlaceholder: "Condizioni particolari, avvertenze, osservazioni...",
    saving: "Salvataggio...",
    savePreDiveChecklist: "Salva Checklist Pre-Dive",
    briefingStandardRstc: "Briefing Standard RSTC",
    briefingSiteSection: "1. Presentazione del sito",
    briefingSiteContent: "Descrizione del sito, punti di interesse, condizioni del giorno",
    briefingDepthContent: "Profondità massima, tempo fondo, piano risalita",
    briefingSignalsSection: "3. Segnali manuali",
    briefingSignalsContent: "Segnali OK, problema, ascendi, discendi, emergenza",
    briefingEmergencySection: "4. Procedure di emergenza",
    briefingEmergencyContent: "Perdita del buddy, corrente, malessere, segnalazione superficie",
    briefingMedicalSection: "5. Emergenze mediche",
    briefingMedicalContent: "Localizzazione O₂, kit pronto soccorso, contatti emergenza",
    briefingRulesSection: "6. Regole del sito",
    briefingRulesContent: "Distanza dai coralli, divieto prelievo, rispetto fauna marina",
    briefingCompleted: "Briefing Completato",
    print: "Stampa",
    participantBriefingSignature: "Firma Briefing Partecipanti",
    participantBriefingDesc: "Registra la conferma individuale di ricezione del briefing per ogni partecipante di oggi.",
    outing: "Uscita",
    noParticipantsRegistered: "Nessun partecipante registrato",
    briefingBtn: "Briefing",
    ecoBtn: "Eco",
    law70Banner: "Legge 70/2026 Art.11-12 — Registro pre/post immersione obbligatorio",
    registerPreDive: "Registra Pre-Immersione",
    diverIdName: "ID / Nome Subacqueo *",
    diverIdNamePlaceholder: "userId o nome completo",
    guideDivemaster: "Guida / Divemaster",
    guideNamePlaceholder: "Nome guida",
    certAgency: "Agenzia Cert.",
    certCode: "Brevetto / Codice",
    plannedDepth: "Profondità pianificata (m)",
    gas: "Gas",
    registerCheckIn: "Registra Check-in",
    dayRegister: "Registro del giorno ({{count}})",
    exportCsv: "Esporta CSV",
    guideLabel: "Guida",
    medCertMissing: "Cert. medico mancante",
    medCertExpired: "Cert. medico scaduto",
    checkOutLabel: "Check-out",
    maxLabel: "Max",
    exitTime: "Ora uscita",
    maxDepthShort: "Profon. max (m)",
    save: "Salva",
    postDive: "Post-dive",
    postDiveNotesTitle: "Note Post-Immersione",
    divemasterGeneralNotes: "Note generali del Divemaster",
    divemasterNotesPlaceholder: "Condizioni, comportamento gruppo, osservazioni marine, problemi riscontrati...",
    groupBehavior: "Comportamento gruppo",
    seaConditions: "Condizioni mare",
    incidentsNearMiss: "Incidenti / Near-miss",
    incidentsPlaceholder: "Nessuno / Descrizione se necessario",
    equipmentReturn: "Riconsegna attrezzatura",
    allReturned: "Tutto riconsegnato",
    damageReported: "Danni segnalati",
    savePostDiveNotes: "Salva Note Post-Dive",
    prePostDiveRegister: "Registro Pre/Post Immersione",
    law70Subtitle: "Legge 70/2026 Art. 11-12 — obbligatorio per ogni immersione",
    dayReport: "Resoconto del {{date}}",
    statDives: "Immersioni",
    statInWater: "In acqua",
    statReturned: "Rientrati",
    statReconciled: "Riconciliate",
    statDiscrepancies: "Discrepanze",
    stillInWater: "Ancora in acqua ({{count}}):",
    guest: "Ospite",
    guideLower: "guida",
    checkInLower: "check-in",
    checkInPreDive: "Check-in Pre-Immersione",
    date: "Data",
    userIdGuest: "ID Utente / Ospite",
    userIdGuestPlaceholder: "userId o nome ospite",
    guideInstructor: "Guida/Istruttore",
    certAgencyShort: "Agenzia cert.",
    certCodeShort: "Codice cert.",
    entriesOf: "Voci del {{date}} ({{count}})",
    noRegistrationForDate: "Nessuna registrazione per questa data.",
    certExpired: "Cert. scaduto",
    certMissing: "Cert. mancante",
    certLabel: "Cert",
    checkInLabel: "Check-in",
    plannedDepthLabel: "Profondità pianificata",
    depthAchieved: "Profondità raggiunta",
    reconciledWithLogbook: "Riconciliato col logbook",
    computerLabel: "computer",
    applyComputerData: "Applica dato computer",
    readFromDiverComputer: "Leggi dal computer del sub:",
    checkOutTime: "Orario check-out",
    maxDepthAchieved: "Profondità max raggiunta (m)",
    savePostDive: "Salva Post-dive",
    cancel: "Annulla",
    confirmBriefingIso: "Conferma Briefing (ISO 24803)",
    dive: "Immersione",
    confirmBriefingTitle: "Conferma briefing",
    confirmEcoTitle: "Conferma eco-awareness ISO 21417",
  },
  dcSoci: {
    memberAdded: "Associato aggiunto",
    memberAddError: "Errore aggiunta socio",
    memberApproved: "Associato approvato ✓",
    approveError: "Errore durante l'approvazione",
    requestRejected: "Richiesta rifiutata",
    rejectError: "Errore durante il rifiuto",
    cardSuspended: "Tessera sospesa",
    suspendError: "Errore durante la sospensione",
    emailSent: "Email inviata",
    emailSendError: "Errore invio email",
    emailSentToMembers: "Email inviata a {{count}} associati",
    preMemberLinked: "Pre-associato collegato",
    linkError: "Errore durante il collegamento",
    matchApproved: "Corrispondenza approvata — utente collegato",
    candidateDismissed: "Candidato scartato",
    deleteError: "Errore durante l'eliminazione",
    preMemberAdded: "Pre-socio aggiunto",
    addError: "Errore durante l'aggiunta",
    preMemberRemoved: "Pre-socio rimosso",
    removeError: "Errore rimozione",
    preMembersReconciled: "{{count}} pre-associato riconciliato",
    noNewToReconcile: "Nessun nuovo utente da riconciliare",
    reconcileError: "Errore durante la riconciliazione",
    edivemembers: "Associati eDive ({{count}})",
    writeToAllActiveTitle: "Scrivi a tutti gli associati attivi",
    writeToAll: "Scrivi a tutti",
    add: "Aggiungi",
    searchByCardOrEmail: "Cerca per tessera o email…",
    filterAll: "Tutti",
    filterActive: "Attivi",
    filterSuspended: "Sospesi",
    searchEdiveUser: "Cerca utente eDive *",
    searchByNameSurnameEmail: "Cerca per nome, cognome o email…",
    edivUser: "Utente eDive",
    noUserFound: "Nessun utente trovato",
    annualFee: "Quota annuale (€)",
    cardExpiry: "Scadenza tessera",
    notes: "Note",
    notesPlaceholder: "Pagamento contanti, data iscrizione…",
    cancel: "Annulla",
    saving: "Salvataggio…",
    noEdiveMembers: "Nessun socio eDive",
    addFirst: "Aggiungi il primo",
    pendingRequests: "{{count}} richiesta/e in attesa di approvazione",
    cardLabel: "Tessera #{{number}}",
    requestedOn: "Richiesta il {{date}}",
    approve: "Approva",
    confirmRejectRequest: "Rifiutare questa richiesta?",
    reject: "Rifiuta",
    noMembersFiltered: "Nessun associato",
    withStatus: "con stato \"{{status}}\"",
    statusActive: "Attivo",
    statusSuspended: "Sospeso",
    forQuery: "per \"{{query}}\"",
    nameUnavailable: "Nome non disponibile",
    statusExpired: "Scaduto",
    expiresShort: "scad. {{date}}",
    sendEmailToMemberTitle: "Invia email a questo associato",
    confirmSuspendCard: "Sospendere la tessera #{{number}}?",
    suspendCardTitle: "Sospendi tessera",
    reactivate: "Riattiva",
    preMembers: "Pre-associati ({{count}})",
    preMembersSubtitle: "Persone aggiunte manualmente, non ancora iscritte su eDive",
    reconcileTitle: "Verifica se i pre-associati si sono nel frattempo registrati su eDive",
    reconcile: "Riconcilia",
    firstName: "Nome *",
    lastName: "Cognome *",
    email: "Email",
    phoneWhatsapp: "Telefono / WhatsApp",
    preMemberNotesPlaceholder: "Quota 2024, pagata contanti…",
    save: "Salva",
    noPreMembers: "Nessun pre-associato in lista",
    notOnEdive: "Non su eDive",
    candidatesCount: "{{count}} candidato/i",
    linkManuallyTitle: "Collega manualmente a un account eDive",
    link: "Collega",
    confirmRemovePreMember: "Rimuovere {{name}}?",
    possibleMatches: "Possibili corrispondenze eDive — attende conferma",
    viaReason: "via {{reason}}",
    reasonEmail: "email",
    reasonPhone: "telefono",
    reasonName: "nome",
    dismiss: "Scarta",
    autoLinkNotice: "Quando un pre-associato si iscrive a eDive, il sistema li collegherà automaticamente.",
    writeToAllActive: "Scrivi a tutti gli associati attivi",
    writeToThisMember: "Scrivi a questo associato",
    subject: "Oggetto *",
    emailSubjectPlaceholder: "Oggetto dell'email",
    message: "Messaggio *",
    messagePlaceholder: "Scrivi il tuo messaggio…",
    sending: "Invio…",
    send: "Invia",
    linkToEdiveUser: "Collega a utente eDive",
    searchByNameSurnameEmailPhone: "Cerca per nome, cognome, email o telefono",
    reconcileSearchPlaceholder: "Mario Rossi, mario@email.it, +39 333…",
    resultsFound: "{{count}} risultato/i trovati — seleziona l'utente corretto:",
    edivUserShort: "eDive user",
    noEdiveUserForQuery: "Nessun utente eDive trovato per \"{{query}}\"",
    selectedUser: "Utente selezionato",
    linking: "Collegamento…",
  },
  instrDash: {
    responseSent: "Risposta inviata",
    sendError: "Errore nell'invio",
    loading: "Caricamento…",
    noValidationRequests: "Nessuna richiesta di convalida in attesa.",
    requestsWaiting: "{{count}} richieste in attesa",
    dive: "Immersione",
    requestedAt: "Richiesta",
    diverNote: "Nota del diver",
    optionalNotePlaceholder: "Nota opzionale al diver…",
    approve: "Approva",
    reject: "Rifiuta",
    excursionCreated: "Escursione creata",
    error: "Errore",
    newGuidedDive: "Nuova immersione guidata",
    titleRequired: "Titolo *",
    titlePlaceholder: "es. Immersione a Portofino",
    description: "Descrizione",
    startDateRequired: "Data inizio *",
    endDate: "Data fine",
    locationLabel: "Luogo",
    locationPlaceholder: "es. Baia di Napoli",
    meetingPoint: "Punto di raduno",
    meetingPointPlaceholder: "es. Porto di Mergellina",
    diveType: "Tipo immersione",
    any: "— Qualsiasi —",
    minCert: "Brevetto minimo",
    maxParticipants: "Max partecipanti",
    feeEuro: "Quota (€)",
    maxDepth: "Prof. max (m)",
    cancellationWithin: "Cancellazione entro (ore)",
    publiclyVisible: "Visibile pubblicamente",
    creating: "Creazione…",
    createExcursion: "Crea escursione",
    cancel: "Annulla",
    excursionType_TECHNICAL: "Tecnica",
    excursionType_RECREATIONAL: "Ricreativa",
    excursionType_BOTH: "Tecnica & Ricreativa",
    certLevel_NONE: "Nessuna",
    certLevel_OPEN_WATER: "Open Water",
    certLevel_ADVANCED: "Advanced",
    certLevel_RESCUE_DM: "Rescue/DM",
    certLevel_TECHNICAL: "Tecnico",
    loadingParticipants: "Caricamento partecipanti…",
    noParticipantsYet: "Nessun partecipante ancora.",
    confirm: "Conferma",
    participants: "partecipanti",
    hideParticipants: "Nascondi partecipanti",
    manageParticipants: "Gestisci partecipanti",
    excursionsOrganized: "{{count}} escursioni organizzate",
    newExcursion: "Nuova escursione",
    noExcursionsOrganized: "Nessuna escursione organizzata",
    noExcursionsHint: "Crea la tua prima immersione guidata per i tuoi studenti e contatti.",
    teachingHours: "Ore insegnamento",
    totalStudents: "Studenti totali",
    avgRating: "Rating medio",
    reviews: "Recensioni",
    assignedCourses: "Corsi assegnati",
    active: "Attivo",
    inactive: "Inattivo",
    rcMissing: "RC professionale non inserita — obbligatoria (L.70/2026 Art.11)",
    rcExpired: "RC scaduta il {{date}} — rinnovare urgentemente",
    rcExpiringSoon: "RC in scadenza il {{date}} — rinnova presto",
    rcValid: "RC professionale valida",
    rcVerified: "Verificata",
    rcInsuranceTitle: "Assicurazione RC Professionale",
    policyNumber: "N° polizza",
    update: "Aggiorna",
    completeProfilePrompt1: "Completa il tuo profilo professionale nella tab",
    publicProfileTab: "Profilo Pubblico",
    completeProfilePrompt2: "per apparire nella directory istruttori e ricevere contatti dai diver.",
    allCourses: "Tutti i corsi",
    enrollments: "{{count}} iscrizioni",
    noStudentsFound: "Nessuno studente trovato",
    student: "Studente",
    status: "Stato",
    enrolledOn: "Iscritto il",
    completedOn: "Completato il",
    cert: "Cert",
    openChat: "Apri chat",
    collected: "Incassato",
    paidSessions: "Sessioni pagate",
    avgPerSession: "Media per sessione",
    last12MonthsTrend: "Andamento ultimi 12 mesi",
    paidSessionsThisMonth: "Sessioni pagate nel mese",
    session: "Sessione",
    date: "Data",
    amount: "Importo",
    noPaidSessionsIn: "Nessuna sessione pagata in {{month}}",
    prev: "Prec",
    next: "Succ",
    availabilityHint: "Clicca su un giorno per segnarlo come non disponibile (grigio = disponibile di default)",
    dowMon: "Lun",
    dowTue: "Mar",
    dowWed: "Mer",
    dowThu: "Gio",
    dowFri: "Ven",
    dowSat: "Sab",
    dowSun: "Dom",
    available: "Disponibile",
    unavailable: "Non disponibile",
    professionalInfo: "Informazioni professionali",
    teachingAgencies: "Agenzie insegnamento",
    specialties: "Specializzazioni",
    teachingLangs: "Lingue insegnamento",
    maxCertLevel: "Livello max certificazione",
    maxCertLevelPlaceholder: "Es: PADI IDC Staff Instructor",
    dailyRate: "Tariffa giornaliera (€)",
    dailyRatePlaceholder: "0 = su richiesta",
    publicBio: "Bio pubblica",
    publicBioPlaceholder: "Descrivi la tua esperienza, specializzazioni e approccio all'insegnamento…",
    availableOnline: "Disponibile online (video lezioni)",
    profileVisibleInDirectory: "Profilo visibile nella directory",
    publicCardPreview: "Anteprima card pubblica",
    instructor: "Istruttore",
    saving: "Salvataggio…",
    saveProfile: "Salva profilo",
    tabOverview: "Panoramica",
    tabStudents: "Studenti",
    tabAvailability: "Disponibilità",
    tabEarnings: "Guadagni",
    tabPrivateLessons: "Lezioni Private",
    tabValidations: "Convalide",
    tabExcursions: "Escursioni",
    tabPublicProfile: "Profilo Pubblico",
    pageTitle: "Dashboard Istruttore",
    pageSubtitle: "Gestisci la tua attività professionale",
    profileVisibleBanner: "Il tuo profilo è visibile nella directory istruttori",
  },
  lbPrint: {
    diveTypeRecreational: "Ricreativa",
    diveTypeTechnical: "Tecnica",
    diveTypeWreck: "Relitto",
    diveTypeCave: "Grotta",
    diveTypeIce: "Ghiaccio",
    diveTypeAltitude: "Altitudine",
    diveTypeDrysuit: "Muta stagna",
    diveTypeFreediving: "Apnea",
    diveTypeDrift: "Deriva",
    diveTypePhoto: "Foto",
    diveTypeNight: "Notturna",
    waterTypeFresh: "Dolce",
    waterTypeSalt: "Salata",
    waterTypeBrackish: "Salmastra",
    entryTypeShore: "Riva",
    entryTypeBoat: "Barca",
    entryTypeIce: "Ghiaccio",
    air: "Aria",
    stampVerified: "IMMERSIONE VERIFICATA",
    responsibleGuide: "Guida responsabile",
    certifiedOn: "Certificata il",
    diverSignature: "Firma subacqueo",
    guideSignature: "Firma guida / istruttore",
    docTitle: "Logbook Immersione #{{num}}",
    personalLogbook: "Libretto di Immersione Personale",
    generatedOn: "Generato il {{date}}",
    diveTitle: "Immersione #{{num}} — {{site}}",
    siteNotSpecified: "Sito non specificato",
    entry: "Ingresso",
    exit: "Uscita",
    diver: "Subacqueo",
    diveType: "Tipo immersione",
    maxDepth: "Profondità max",
    meters: "metri",
    duration: "Durata",
    minutes: "minuti",
    avgDepth: "Prof. media",
    waterTemp: "Temp. acqua",
    breathingMix: "Miscela respiratoria",
    tankPressure: "Pressione bombola",
    visibility: "Visibilità",
    waterTypeLabel: "Tipo acqua",
    entryTypeLabel: "Tipo entrata",
    suit: "Muta",
    weights: "Piombi",
    airTemp: "Temp. aria",
    rating: "Valutazione",
    notes: "Note",
    footer: "eDive Platform · Logbook digitale conforme L.70/2026 · Documento generato automaticamente",
    enablePopups: "Abilita i popup per stampare",
    modalTitle: "Stampa logbook",
    diveLabel: "Immersione #{{num}}",
    stampIncluded: "Timbro diving center incluso",
    docDescriptionIntro: "Il documento include tutti i parametri dell'immersione",
    docDescriptionCertified: " e il timbro di verifica del diving center (Art.12 L.70/2026).",
    docDescriptionSignatures: " con spazio per le firme del subacqueo e della guida.",
    siteShort: "Sito",
    depthShort: "Profondità",
    durationShort: "Durata",
    tempShort: "Temp",
    cancel: "Annulla",
    printSavePdf: "Stampa / Salva PDF",
  },
  dcEquip: {
    statusAvailable: "Disponibile",
    statusRented: "In noleggio",
    statusMaintenance: "Manutenzione",
    statusRetired: "Ritirato",
    safetyO2: "Bombola O₂ terapeutico (> 80%)",
    safetyFirstAid: "Kit di pronto soccorso completo",
    safetyVhf: "Radio VHF funzionante (canale 16)",
    safetySmb: "Palloni SMB a bordo (uno per guida)",
    safetyKnife: "Coltello di sicurezza",
    safetyTorches: "Torce subacquee cariche",
    safetyEmergencyList: "Lista emergenze aggiornata",
    tabTanks: "Bombole",
    tabEquipment: "Attrezzatura",
    tabSafety: "Sicurezza",
    pageTitle: "4. Logistica & Attrezzatura",
    pageSubtitle: "Bombole, attrezzatura noleggio, barca, check sicurezza",
    addTank: "Aggiungi Bombola",
    colSerial: "Matricola",
    colVol: "Vol.",
    colPressure: "Pressione",
    colLastHydro: "Ultima idro.",
    colNextHydro: "Prossima idro.",
    colStatus: "Stato",
    steelAbbr: "Acc.",
    aluAbbr: "All.",
    available: "Disponibile",
    notAvailable: "Non disp.",
    addEquipment: "Aggiungi Attrezzatura",
    lastService: "Ultima revisione",
    next: "Prossima",
    assign: "Assegna",
    returned: "Restituito",
    safetyTitle: "Check Sicurezza Pre-Partenza",
    allChecksPassed: "Tutti i check superati  Pronti alla partenza!",
    completeChecks: "⚠ Completare tutti i check prima di partire",
    registering: "Registrazione...",
    registerCheck: "Registra Check ({{time}})",
    assignTitle: "Assegna {{name}}",
    stepBooking: "Prenotazione",
    stepConfirm: "Conferma",
    assigning: "Assegnazione...",
    bookingRef: "ID / Riferimento prenotazione *",
    bookingRefPlaceholder: "Es: booking-2026-04-30-001",
    notes: "Note",
    assignNotesPlaceholder: "Taglia, condizioni, note speciali...",
    tankStep1: "Matricola e Volume",
    tankStep2: "Pressione e Valvola",
    tankStep3: "Data e Note",
    serialRequired: "Matricola *",
    serialPlaceholder: "Es: IT-2024-001",
    volumeRequired: "Volume (L) *",
    material: "Materiale",
    steel: "Acciaio",
    aluminium: "Alluminio",
    currentPressure: "Pressione attuale (bar)",
    valveType: "Tipo valvola",
    valvePlaceholder: "Es: DIN, INT",
    serial: "Matricola",
    volume: "Volume",
    pressure: "Pressione",
    nextHydro: "Prossima idrostatica",
    notesOptional: "Note opzionali",
    eqStep1: "Tipo e Brand",
    eqStep2: "Seriale e Date",
    eqStep3: "Note e Conferma",
    typeRequired: "Tipo *",
    brand: "Marca",
    brandPlaceholder: "Es: Scubapro",
    model: "Modello",
    modelPlaceholder: "Es: MK25 EVO",
    serialNumber: "Numero seriale",
    snOptional: "SN opzionale",
    sizeCode: "Taglia / Codice",
    sizePlaceholder: "S, M, L, XL...",
    purchaseDate: "Data acquisto",
    lastServiceLabel: "Ultima revisione",
    nextServiceLabel: "Prossima revisione",
    type: "Tipo",
    size: "Taglia",
  },
  profDiver: {
    certMedicalOts: "Idoneità medica OTS (D.M. Marina Mercantile)",
    certMedicalHseDiving: "HSE — Medical Fitness to Dive",
    certMedicalOgukOeuk: "OGUK/OEUK Offshore Medical",
    certBosietOpito: "BOSIET (OPITO)",
    certHuetOpito: "HUET (OPITO)",
    certFoetOpito: "FOET — refresh BOSIET (OPITO)",
    certDiverMedicDmt: "Diver Medic Technician (DMT/IMCA)",
    certFirstAidO2: "Primo soccorso + ossigeno (HSE)",
    certGwo: "GWO (Global Wind Organisation)",
    certMist: "MIST (Minimum Industry Safety Training)",
    certOther: "Altro",
    catOtsShallow: "OTS Acque Basse (≤30m)",
    catOtsMedium: "OTS Acque Medie (≤50m)",
    catOtsDeep: "OTS Acque Profonde (>50m)",
    catHyperbaricTi: "Tecnico Iperbarico",
    catDescOtsShallow: "Operatore subacqueo professionale fino a 30m di profondità",
    catDescOtsMedium: "Operatore subacqueo professionale fino a 50m di profondità",
    catDescOtsDeep: "Operatore subacqueo professionale oltre i 50m di profondità",
    catDescHyperbaricTi: "Tecnico specializzato in attività iperbariche",
    doctorUsmaf: "USMAF (Unità Sanitaria Marittima)",
    doctorIperbarica: "Medicina Iperbarica",
    doctorSpecialista: "Specialista del Lavoro",
    stepCategoria: "Categoria",
    stepLicenza: "Licenza e Scadenze",
    stepRiepilogo: "Riepilogo",
    toastLibrettoDownloaded: "Libretto scaricato",
    toastLibrettoDownloadError: "Errore download libretto",
    toastLicenseUpdated: "Licenza aggiornata",
    toastLicenseRegistered: "Licenza registrata con successo",
    toastSaveError: "Errore durante il salvataggio",
    toastLicenseDeleted: "Licenza eliminata",
    pageTitle: "Operatore Subacqueo Professionale",
    pageSubtitle: "Legge 26 gennaio 2026 n. 9 — Registro Operatori Professionali",
    loading: "Caricamento...",
    emptyTitle: "Nessuna licenza professionale registrata",
    emptyDescription: "Registra la tua categoria OTS o Tecnico Iperbarico ai sensi della L. 9/2026.",
    registerLicenseCta: "+ Registra Licenza",
    confirmDeleteLicense: "Eliminare la licenza professionale?",
    wizardTitleEdit: "Modifica Licenza Professionale",
    wizardTitleNew: "Registra Licenza Professionale",
    wizardSubtitle: "Legge 26 gennaio 2026 n. 9 — Artt. 19-24",
    registerLicenseFinal: "Registra Licenza",
    professionalDives: "Immersioni Professionali",
    downloading: "Download...",
    downloadLibretto: "Scarica Libretto (JSON)",
    noDives: "Nessuna immersione professionale. Contrassegna le immersioni come \"professionale\" dal Logbook.",
    colDate: "Data",
    colSite: "Sito",
    colDepth: "Prof.",
    colDuration: "Durata",
    colType: "Tipo",
    colCertified: "Certificato",
    signed: "Firmato",
    legalNoticeTitle: "Legge 26 gennaio 2026 n. 9 — Artt. 19-24",
    legalNoticeBody: "I dati del registro professionale sono conservati ai sensi della normativa vigente. Il libretto personale informatico (art. 21) dovrà essere operativo entro il 30/12/2027.",
    stepCategoriaIntro: "Seleziona la categoria professionale ai sensi della Legge 9/2026, art. 19.",
    statusLabel: "Stato Licenza",
    statusActive: "Attiva",
    statusSuspended: "Sospesa",
    statusRevoked: "Revocata",
    statusExpired: "Scaduta",
    stepLicenzaIntro: "Inserisci i dettagli della licenza e le informazioni sull'idoneità medica.",
    fieldLicenseNumber: "Numero Licenza",
    placeholderLicenseNumber: "es. OTS/2026/001",
    fieldIssuingAuthority: "Autorità Rilasciatrice",
    placeholderIssuingAuthority: "es. MIT — Ministero delle Infrastrutture",
    fieldIssuedAt: "Data Rilascio",
    fieldExpiresAt: "Scadenza Licenza",
    fieldMedicalFitnessAt: "Idoneità Medica (ultima visita)",
    fieldMedicalDoctorType: "Tipo Medico",
    doctorNone: "— Nessuno —",
    fieldNotes: "Note",
    placeholderNotes: "Note aggiuntive...",
    stepRiepilogoIntro: "Verifica i dati prima di registrare la licenza.",
    summaryCategory: "Categoria",
    summaryStatus: "Stato",
    summaryLicenseNumber: "Numero Licenza",
    summaryIssuingAuthority: "Autorità Rilasciatrice",
    summaryIssuedAt: "Data Rilascio",
    summaryExpiresAt: "Scadenza",
    summaryMedicalFitness: "Idoneità Medica",
    summaryMedicalDoctorType: "Tipo Medico",
    summaryNotes: "Note",
    stepRiepilogoNotice: "I dati saranno registrati nel tuo profilo professionale ai sensi della Legge 9/2026, art. 19-24. Potrai modificarli in qualsiasi momento.",
    edit: "Modifica",
    delete: "Elimina",
    toastCertSaved: "Certificazione salvata",
    toastCertSaveError: "Errore nel salvataggio",
    toastCertDeleted: "Certificazione eliminata",
    certStatusExpired: "Scaduta",
    certStatusExpiring: "In scadenza",
    certStatusValid: "Valida",
    certsTitle: "Certificazioni e idoneità professionali",
    certsSubtitle: "Imbarco su navi da ricerca/offshore — scadenze monitorate (avviso a 90/30/7 giorni e alla scadenza).",
    addCta: "+ Aggiungi",
    noCerts: "Nessuna certificazione professionale registrata (es. BOSIET, OGUK/OEUK, idoneità medica OTS, Diver Medic…).",
    colAuthorityNumber: "Ente / N°",
    colIssued: "Rilascio",
    colExpiry: "Scadenza",
    colStatus: "Stato",
    colActions: "Azioni",
    confirmDeleteCert: "Eliminare questa certificazione?",
    certModalTitleEdit: "Modifica certificazione",
    certModalTitleNew: "Nuova certificazione professionale",
    certFieldType: "Tipo *",
    certValidityHint: "Validità tipica: {{months}} mesi (scadenza precompilata dalla data di rilascio).",
    certFieldName: "Nome certificazione",
    certFieldAuthority: "Ente",
    certFieldNumber: "N° certificato",
    certFieldIssued: "Data rilascio",
    certFieldExpiry: "Scadenza *",
    certFieldNotes: "Note",
    cancel: "Annulla",
    saving: "Salvataggio…",
    save: "Salva",
  },
  wizDiary: {
    stepInfo: "Info base",
    stepDestination: "Destinazione",
    stepParticipants: "Partecipanti",
    stepStages: "Tappe",
    stepAccommodations: "Pernottamenti",
    errImageUpload: "Errore nel caricamento immagine",
    titleLabel: "Titolo *",
    titlePlaceholder: "es. Maldive 2026",
    required: "Campo obbligatorio",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Una breve descrizione del viaggio...",
    coverLabel: "Immagine di copertina",
    coverAlt: "copertina",
    uploading: "Caricamento…",
    clickToUpload: "Clicca per caricare",
    country_IT: "Italia",
    country_EG: "Egitto",
    country_MV: "Maldive",
    country_TH: "Thailandia",
    country_HR: "Croazia",
    country_GR: "Grecia",
    country_ES: "Spagna",
    country_PT: "Portogallo",
    country_MT: "Malta",
    country_CY: "Cipro",
    country_PH: "Filippine",
    country_AU: "Australia",
    country_ID: "Indonesia",
    country_MX: "Messico",
    country_BZ: "Belize",
    country_US: "USA",
    countryLabel: "Paese",
    selectPlaceholder: "— seleziona —",
    specificLocationLabel: "Luogo specifico",
    specificLocationPlaceholder: "es. Atollo di Ari",
    startDateLabel: "Data inizio",
    endDateLabel: "Data fine",
    visibilityLabel: "Visibilità",
    private: "Privato",
    privateDesc: "Solo i partecipanti invitati",
    public: "Pubblico",
    publicDesc: "Visibile alla community",
    errEmailRequired: "Inserisci un indirizzo email",
    errEmailInvalid: "Email non valida",
    errEmailDuplicate: "Già aggiunto",
    participantsIntro: "Invita i partecipanti per email. Potranno anche richiedere accesso al diario se è pubblico.",
    emailPlaceholder: "email@esempio.com",
    roleAuthor: "Autore",
    roleViewer: "Lettore",
    noParticipants: "Nessun partecipante aggiunto — potrai invitare in seguito",
    stagesIntro: "Pianifica le tappe del viaggio prima della partenza.",
    stageNamePlaceholder: "Nome tappa *",
    locationPlaceholder: "Luogo",
    notesOptionalPlaceholder: "Note (opzionale)",
    cancel: "Annulla",
    updateStage: "Aggiorna tappa",
    addStage: "Aggiungi tappa",
    noStages: "Nessuna tappa — potrai aggiungerle anche dopo",
    edit: "modifica",
    accommodationsIntro: "Aggiungi le sistemazioni previste durante il viaggio.",
    accommodationNamePlaceholder: "Nome struttura *",
    stageOptionalPlaceholder: "— tappa (opz.) —",
    checkInLabel: "Check-in",
    checkOutLabel: "Check-out",
    bookingRefPlaceholder: "Riferimento prenotazione (opz.)",
    notesShortPlaceholder: "Note (opz.)",
    update: "Aggiorna",
    addAccommodation: "Aggiungi pernottamento",
    noAccommodations: "Nessuna sistemazione — potrai aggiungerle anche dopo",
    stagePrefix: "Tappa: {{title}}",
    bookingRefPrefix: "Rif: {{ref}}",
    diaryCreated: "Diario creato!",
    errDiaryCreation: "Errore nella creazione del diario",
    headerTitle: "Nuovo diario di viaggio",
    stepCounter: "Passo {{current}} di {{total}} — {{label}}",
    back: "Indietro",
    creating: "Creazione…",
    createDiary: "Crea diario",
    next: "Avanti",
  },
  lbSync: {
    title: "Sync da Logbook Online",
    cancel: "Annulla",
    connect: "Connetti",
    connecting: "Connessione...",
    connected: "Connesso",
    disconnect: "Disconnetti",
    synchronize: "Sincronizza",
    lastSync: "Ultimo sync:",
    importFile: "Importa file",
    importingInProgress: "Importazione in corso...",
    importingShort: "Importazione...",
    importGenericError: "Errore durante l'importazione",
    selectShearwaterFile: "Seleziona file Shearwater (.xml / .db)",
    shearwaterFormatError: "Formato file Shearwater non supportato",
    swStep1a: "Apri",
    swStep1b: "o l'app Shearwater Cloud",
    swStep2a: "Esporta il logbook in formato",
    swStep2b: "(File → Export) oppure usa direttamente il file",
    swStep2c: "del backup",
    swStep3: "Seleziona il file qui sotto — verrà importato automaticamente",
    oauthStartError: "Errore avvio OAuth {{provider}}",
    garminFitImported: "Garmin FIT importato · {{count}} immersioni",
    garminCsvImported: "Garmin CSV importato · {{count}} immersioni",
    alreadyPresent: "({{skipped}} già presenti)",
    fitInvalidError: "File .fit non valido o non contiene immersioni",
    csvInvalidError: "File CSV non valido o nessuna immersione trovata",
    garminWhyTitle: "Perché non posso accedere direttamente?",
    garminWhyBody1: "Garmin protegge il sito di login con",
    garminWhyBody2: ", che blocca tutti i sistemi automatizzati — incluso eDive. È una scelta di sicurezza di Garmin, non un errore dell'app. Per importare i tuoi dati usa una delle opzioni qui sotto.",
    csvOptionTitle: "Esporta CSV — tutte le immersioni in un click",
    basicData: "dati base",
    csvOptionDesc: "Data · profondità · durata · temperatura.",
    csvOptionDescEm: "Non include il profilo grafico.",
    csvStep1a: "Vai su",
    csvStep1b: "→ sezione",
    csvStep1Activities: "Attività",
    csvStep2: "Filtra per immersioni (tab con l'icona sub)",
    csvStep3a: "Clicca",
    csvStep3Btn: "\"Esporta CSV\"",
    csvStep3b: "in alto a destra",
    csvStep4: "Carica il file qui sotto",
    uploadCsvBtn: "↑ Carica file CSV Garmin",
    fitOptionTitle: "Esporta file .fit — dati completi con profilo",
    recommended: "consigliato",
    fitOptionDesc: "Include il profilo di profondità/tempo, temperatura, gas.",
    fitSingleTitle: "Per una singola immersione:",
    fitSingleStep1: "Garmin Connect → Attività → clicca sull'immersione",
    fitSingleStep2a: "Menu",
    fitSingleStep2Btn: "\"Esporta originale\"",
    fitSingleStep2b: "→ scarica il",
    fitAllTitle: "Per tutto il logbook in una volta:",
    fitAllStep1Privacy: "Privacy dei dati",
    fitAllStep2a: "Clicca",
    fitAllStep2Btn: "\"Esporta i tuoi dati\"",
    fitAllStep2b: "— Garmin invia un link via email",
    fitAllStep3a: "Estrai lo zip → cartella",
    fitAllStep3b: "→ importa i file",
    fitAllStep3c: "delle immersioni",
    uploadFitBtn: "↑ Carica file .fit Garmin",
    divelogsDesc: "Sincronizza automaticamente tutte le immersioni",
    divelogsUserPlaceholder: "Email / Username Divelogs.de",
    passwordPlaceholder: "Password",
    synchronizingInProgress: "Sincronizzazione in corso...",
    syncFromDivelogs: "Sincronizza da Divelogs.de",
  },
  dcCenters: {
    editCenter: "Modifica centro",
    newCenter: "Nuovo centro",
    nameLabel: "Nome *",
    countryLabel: "Paese *",
    searchCountryPlaceholder: "Cerca nazione…",
    requiredField: "Campo obbligatorio",
    cityLabel: "Città *",
    loading: "Caricamento…",
    searchCityPlaceholder: "Cerca città…",
    addressLabel: "Indirizzo",
    phoneLabel: "Telefono",
    websiteLabel: "Sito web",
    licenseNoLabel: "Nr. Licenza",
    latitudeLabel: "Latitudine",
    longitudeLabel: "Longitudine",
    active: "Attivo",
    descriptionLabel: "Descrizione",
    cancel: "Annulla",
    update: "Aggiorna",
    createCenter: "Crea centro",
    yourLocation: "La tua posizione",
    viewProfile: "Vedi profilo",
    inactive: "Inattivo",
    resort: "Resort",
    site: "Sito",
    edit: "Modifica",
    delete: "Elimina",
    centerCreated: "Centro creato",
    centerUpdated: "Centro aggiornato",
    centerDeleted: "Centro eliminato",
    invalidCsv: "CSV non valido",
    importedCenters: "Importati {{count}} centri",
    pageTitle: "Diving Centers",
    searching: "Ricerca in corso…",
    centersFoundOne: "{{count}} centro trovato",
    centersFoundOther: "{{count}} centri trovati",
    searchRegistry: "Cerca anagrafica",
    importing: "Importando…",
    importCsv: "Importa CSV",
    addCenter: "Aggiungi centro",
    joinCenter: "Entra in un centro",
    importErrorsSuffix: ", {{count}} errori",
    searchPlaceholder: "Cerca per nome, città…",
    allCountries: "Tutti i paesi",
    locating: "Localizzando…",
    nearMe: "Vicino a me",
    filterAll: "Tutti",
    filterDiveCenters: "Centri Diving",
    viewCards: "Schede",
    viewTable: "Tabella",
    viewMap: "Mappa",
    csvFormat: "Formato CSV",
    mapCoverage: "{{mappable}} di {{total}} centri hanno coordinate geografiche",
    noCentersFound: "Nessun centro trovato",
    noCentersHint: "Prova a modificare i filtri o cerca un'altra città.",
    addFirstCenter: "Aggiungi il primo centro",
    colName: "Nome",
    colCity: "Città",
    colCountry: "Paese",
    colContacts: "Contatti",
    colSite: "Sito",
    colGps: "GPS",
    colStatus: "Stato",
    colActions: "Azioni",
    deleteCenter: "Elimina centro",
    deleteConfirm: "Questa azione è irreversibile. Continuare?",
  },
  lbValidation: {
    statusPending: "In attesa",
    statusApproved: "Approvata",
    statusRejected: "Rifiutata",
    requestSent: "Richiesta inviata",
    alreadyRequested: "Già richiesto a questo istruttore",
    sendError: "Errore nell'invio",
    requestValidation: "Richiedi convalida",
    instructorIdLabel: "ID Istruttore *",
    instructorIdPlaceholder: "UUID dell'istruttore",
    askYourInstructor: "Chiedilo al tuo istruttore",
    notesLabel: "Note (opzionale)",
    notesPlaceholder: "Aggiungi informazioni utili all'istruttore…",
    cancel: "Annulla",
    sending: "Invio…",
    sendRequest: "Invia richiesta",
    requestCancelled: "Richiesta cancellata",
    error: "Errore",
    loading: "Caricamento…",
    instructorValidations: "Convalide istruttore",
    intro: "Richiedi a un istruttore di convalidare questa immersione per certificazioni o documentazione.",
    request: "Richiedi",
    emptyState: "Nessuna richiesta di convalida ancora inviata.",
    instructor: "Istruttore",
    requestedOn: "Richiesto: {{date}}",
    respondedOn: "Risposto: {{date}}",
    yourNote: "La tua nota:",
    instructorNote: "Nota istruttore:",
    cancelRequest: "Annulla richiesta",
  },
  lbSpecies: {
    toxicityLow: "Bassa",
    toxicityMedium: "Media",
    toxicityHigh: "Alta",
    atDepth: "a {{depth}}m",
    remove: "Rimuovi",
    addSightedSpecies: "Aggiungi specie avvistata",
    searchPlaceholder: "Cerca specie (es. Murena, Cernia…)",
    noSpeciesFound: "Nessuna specie trovata",
    depthLabel: "Profondità (m)",
    depthPlaceholder: "es. 18",
    saving: "Salvataggio…",
    addSighting: "Aggiungi avvistamento",
    cancel: "Annulla",
    saveError: "Errore durante il salvataggio",
    spottedSpecies: "Specie Avvistate",
    speciesRecorded: "specie registrate",
    add: "Aggiungi",
    noSpeciesRecorded: "Nessuna specie registrata",
    emptyStateHint: "Aggiungi le specie che hai avvistato durante questa immersione",
    addFirstSpecies: "Aggiungi prima specie",
    contributeCta: "Hai foto di questa immersione? Contribuisci all'enciclopedia marina",
  },
  lbMedia: {
    processing: "Elaborazione…",
    previewUnavailable: "Anteprima non disponibile",
    consentText: "Confermo che:\n• La foto/video è di mia esclusiva proprietà e ho il diritto di cederne l'uso\n• Autorizzo eDive a pubblicarla nella galleria dell'enciclopedia della biologia marina\n• Autorizzo l'inserimento permanente nella banca dati scientifica di eDive\n• Il contenuto non viola diritti di terzi né mostra soggetti minori non autorizzati",
    imageUrlUnavailable: "URL immagine non disponibile",
    submitError: "Errore durante l'invio. Riprova.",
    proposeTitle: "Proponi alla banca dati specie",
    proposalSent: "Proposta inviata!",
    proposalSentDesc: "Il centro di biologia marina valuterà la tua immagine entro 7 giorni. Se approvata, sarà aggiunta alla galleria della specie.",
    close: "Chiudi",
    speciesPhotographed: "Specie fotografata",
    searchSpeciesPlaceholder: "Cerca specie (nome scientifico o comune)…",
    acceptConsent: "Accetto e autorizzo la pubblicazione (versione 1.0)",
    cancel: "Annulla",
    submitting: "Invio…",
    proposeButton: "Proponi alla banca dati",
    mediaDeleted: "Media eliminato",
    deleteError: "Errore eliminazione",
    uploadError: "Errore caricamento: {{name}}",
    confirmDelete: "Eliminare \"{{name}}\"?",
    clickToUpload: "Clicca per caricare",
    orDragMedia: "o trascina foto/video",
    acceptedFormats: "JPG, PNG, MP4, MOV",
    noMedia: "Nessun media",
    uploadFromDive: "Carica foto o video dall'immersione",
    photosCount: "Foto ({{count}})",
    videosCount: "Video ({{count}})",
    addMore: "Aggiungi altro",
  },
  profTessere: {
    statusActive: "Attiva",
    statusPending: "In attesa",
    statusSuspended: "Sospesa",
    statusExpired: "Scaduta",
    loading: "Caricamento tessere…",
    numberPrefix: "N° {{number}}",
    expires: "Scade {{date}}",
    emptyTitle: "Nessuna tessera",
    emptySubtitle: "Iscriviti a un'associazione o collegati a un diving center per vedere le tue tessere qui.",
    sectionAssociations: "Associazioni",
    sectionDivingCenter: "Diving Center",
  },
  profReferral: {
    loadingCode: "Caricamento codice…",
    loadError: "Impossibile caricare il codice referral.",
    shareText: "Iscriviti a eDive con il mio codice invito: {{refLink}}",
    copied: "Copiato negli appunti",
    yourInviteCode: "Il tuo codice invito",
    yourInviteCodeDesc: "Condividilo: chi si iscrive con il tuo codice viene collegato al tuo account.",
    codeLabel: "Codice",
    copyCode: "Copia codice",
    inviteLinkLabel: "Link d'invito",
    copyLink: "Copia link",
    emailSubject: "Ti invito su eDive",
    email: "Email",
    totalInvites: "Inviti totali",
    thisMonth: "Questo mese",
    ranking: "Classifica",
    myNetwork: "La mia rete",
    myNetworkDesc: "Vedi chi hai invitato (1° livello) e chi hanno invitato loro (2° livello)",
    fullManagement: "Gestione completa inviti",
    fullManagementDesc: "Inviti diretti, albero referral e statistiche dettagliate",
  },
  planCcr: {
    decoProfileTitle: "Profilo decompressione CCR",
    noDecoRequired: "Nessuna deco richiesta",
    totalAscent: "Risalita totale",
    gasSwitch: "Switch gas",
    safetyChecks: "Safety checks",
    allChecksPassed: "Tutti i controlli superati",
    problemsDetected: "Problemi rilevati",
    bottomParams: "Parametri fondo",
    bottomDepthLabel: "Profondità fondo (m)",
    bottomTimeLabel: "Tempo fondo (min)",
    algorithm: "Algoritmo",
    diluentSetpoint: "Diluente & Setpoint",
    diluentO2Label: "Diluente O₂ (0.04–1.0)",
    diluentHeLabel: "Diluente He (0–0.96)",
    setpointLowLabel: "Setpoint basso (bar)",
    setpointHighLabel: "Setpoint alto (bar)",
    switchDepthLabel: "Profondità switch setpoint (m)",
    gradientFactors: "Gradient factors",
    gfLow: "GF Low",
    gfHigh: "GF High",
    bailoutGasTitle: "Gas bailout (cilindro 1)",
    volumeLabel: "Volume (L)",
    startPressureLabel: "Pressione inizio (bar)",
    o2FracLabel: "O₂ frac (0.04–1.0)",
    heFracLabel: "He frac (0–0.96)",
    calculating: "Calcolo in corso…",
    calculateCcrPlan: "Calcola piano CCR",
    calcError: "Errore durante il calcolo. Verifica i parametri inseriti.",
  },
  planGas: {
    methodPartialPressure: "Pressione Parziale",
    methodContinuousFlow: "Flusso Continuo",
    methodTopup: "Top-up",
    finalComposition: "Composizione finale",
    blendingProcedure: "Procedura di blending",
    calcError: "Errore nel calcolo del blending",
    selectAtLeastOneGas: "Seleziona almeno un gas disponibile",
    targetPressureMustBeHigher: "La pressione target deve essere maggiore di quella iniziale",
    o2HeCannotExceed100: "O₂% + He% non può superare 100%",
    blendingMethod: "Metodo di blending",
    cylinderVolume: "Volume cilindro (L)",
    startPressure: "Pressione iniziale (bar)",
    targetPressure: "Pressione target (bar)",
    targetO2: "O₂ target (%)",
    targetHe: "He target (%)",
    resultingN2: "N₂ risultante:",
    availableGases: "Gas disponibili",
    calculating: "Calcolo in corso…",
    calculateBlending: "Calcola Blending",
  },
  planUtility: {
    suitNone: "No suit",
    suitRashguard: "Rashguard",
    suitWetsuit3mm: "Wetsuit 3mm",
    suitWetsuit5mm: "Wetsuit 5mm",
    suitWetsuit7mm: "Wetsuit 7mm",
    suitSemiDry: "Semi-dry",
    suitDrysuit: "Drysuit",
    waterSalt: "Salt",
    waterFresh: "Fresh",
    tankAluminium: "Aluminium",
    tankSteel: "Steel",
    bcdJacket: "Jacket",
    bcdBackplateWing: "Backplate & Wing",
    bcdSidemount: "Sidemount",
    primaryTorch: "Primary torch",
    diveComputer: "Dive computer",
    itemTorch: "Torch",
    itemScooter: "Scooter",
    itemComputer: "Computer",
    itemCamera: "Camera",
    labelPlaceholder: "Label",
    add: "+ Add",
    remaining: "{{pct}}% remaining",
    objectWeight: "Object weight",
    objectVolume: "Object volume",
    waterType: "Water type",
    requiredVolume: "Required volume",
    recommendedBag: "Recommended bag",
    waterTemp: "Water temp",
    intensity: "Intensity",
    intensityLIGHT: "LIGHT",
    intensityMODERATE: "MODERATE",
    intensityHARD: "HARD",
    metabolicRate: "Metabolic rate",
  },
  planSaved: {
    reconcileTitle: "Riconcilia con logbook",
    reconcileIntroBefore: "Collega",
    reconcileIntroAfter: "a un'immersione effettuata per confrontare pianificato vs reale.",
    alreadyReconciled: "Piano già riconciliato — seleziona un'altra immersione per aggiornare.",
    maybeOneOfThese: "Forse è una di queste",
    diveFromLogbook: "Immersione dal logbook",
    selectDiveOption: "— Seleziona immersione —",
    saving: "Salvataggio…",
    link: "Collega",
    unlink: "Scollega",
    editPlanTitle: "Modifica piano",
    nameLabel: "Nome",
    notesLabel: "Note",
    saveChanges: "Salva modifiche",
    statusCompleted: "Completata",
    statusPending: "Da eseguire",
    plannedFor: "Pianificata per il {{date}} · {{time}}",
    createdOn: "Creato il {{date}}",
    reconciledOn: "Riconciliata il {{date}}",
    logDive: "Registra immersione",
    loadIntoPlanner: "Carica nel pianificatore",
    planLabel: "Piano",
    aiBriefing: "Briefing AI",
    reconciledClickToEdit: "Riconciliata — clicca per modificare",
    linkedLabel: "Collegata",
    reconcileLabel: "Riconcilia",
    editNameNotes: "Modifica nome e note",
    editLabel: "Modifica",
    deletePlan: "Elimina piano",
    deleteLabel: "Elimina",
    deleteThisPlanQuestion: "Eliminare questo piano?",
    cancel: "Annulla",
    deleteQuestionBefore: "Eliminare",
    deleteQuestionAfter: "?",
    confirmDelete: "Conferma elimina",
    logDiveFromPlan: "Registra immersione da questo piano",
    createdShort: "creato {{date}}",
    filterAll: "Tutti",
    filterPending: "Da eseguire",
    filterDone: "Completate",
    reconciledCount: "{{count}} riconciliate",
    newPlan: "Nuova pianificazione",
    unsavedTitle: "Pianificazione non salvata",
    unsavedBody: "Hai una pianificazione in corso non ancora salvata. La bozza resta disponibile al tuo ritorno, ma per conservarla in modo permanente salvala tra i tuoi piani.",
    unsavedStay: "Continua a modificare",
    unsavedLeave: "Esci (mantieni la bozza)",
    noPendingPlans: "Nessun piano da eseguire.",
    noCompletedPlans: "Nessun piano completato.",
    colPlan: "Piano",
    colTechProfile: "Profilo tecnico",
    colStatus: "Stato",
    colDate: "Data",
    colActions: "Azioni",
    gasAir: "Aria",
    conflictsHint: "Le scelte “Piano” aggiornano l'immersione; le altre restano invariate.",
    conflictsTitle: "Valori diversi tra piano e immersione — scegli quale tenere",
    fromDive: "Immersione",
    fromPlan: "Piano",
    lockedReconciled: "Piano riconciliato: annulla la riconciliazione per modificarlo",
  },
  medSafety: {
    locating: "Localizzazione...",
    foundNearYou: "{{count}} trovate vicino a te",
    findNearest: "Trova più vicina a me",
    loading: "Caricamento...",
    nearestBadge: "Più vicina",
    kmFromYou: "{{km}} km da te",
    emergencyNumbers: "Numeri di Emergenza",
    danItaly: "DAN Italia",
    coastGuard: "Guardia Costiera",
    genericEmergency: "Emergenza Generica",
    firstAid: "Pronto Soccorso",
    police: "Polizia",
    diverEmergencyProtocol: "Protocollo Emergenza Sub",
    protocolStep1: "Portare il subacqueo in superficie — risalita controllata",
    protocolStep2: "Somministrare ossigeno al 100% se disponibile",
    protocolStep3: "Chiamare il 118 e il DAN (+39 06 4211 5685)",
    protocolStep4: "Mantenere orizzontale, idratare se cosciente",
    protocolStep5: "NON somministrare aspirina o ibuprofene",
    protocolStep6: "Raggiungere la camera iperbarica più vicina",
    dcsSymptoms: "Sintomi Malattia da Decompressione",
    symptomJointPain: "Dolori articolari",
    symptomItchSkin: "Prurito / macchie cutanee",
    symptomAbnormalFatigue: "Stanchezza anomala",
    symptomNeurological: "Disturbi neurologici",
    symptomBreathing: "Difficoltà respiratorie",
    symptomChestPain: "Dolore toracico",
    cardSaved: "Scheda emergenza salvata",
    saveError: "Errore nel salvataggio",
    personalEmergencyCard: "Scheda Emergenza Personale",
    printPdf: "Stampa / PDF",
    loadingData: "Caricamento dati…",
    bloodType: "Gruppo Sanguigno",
    unknown: "Non noto",
    highestCert: "Brevetto più alto",
    highestCertPlaceholder: "es. PADI Rescue Diver",
    allergies: "Allergie",
    allergiesPlaceholder: "es. Penicillina, lattice",
    currentMeds: "Farmaci in corso",
    currentMedsPlaceholder: "es. Nessuno",
    emergencyContact: "Contatto emergenza",
    emergencyContactPlaceholder: "Nome e cognome",
    relationship: "Relazione",
    emergencyPhone: "Telefono emergenza",
    danCard: "Tessera DAN",
    danCardPlaceholder: "Numero tessera",
    insurance: "Assicurazione",
    insurancePlaceholder: "es. DAN Standard",
    policyNumber: "Numero polizza",
    policyNumberPlaceholder: "es. DAN-12345678",
    saving: "Salvataggio…",
    saveCard: "Salva scheda emergenza",
    diverEmergencyCardTitle: "SCHEDA EMERGENZA SUBACQUEO",
    bloodTypeShort: "Gruppo sanguigno",
    cert: "Brevetto",
    meds: "Farmaci",
    emergency: "Emergenza",
    positionDetected: "Posizione rilevata",
    positionError: "Impossibile rilevare la posizione",
    sosSendError: "Errore invio SOS",
    sosDanTitle: "SOS DAN — Emergenza Subacquea",
    sosDanDescription: "Questo tasto attiva un SOS al DAN ed ai contatti di emergenza.",
    sosDanWarning: "Usare SOLO in caso di vera emergenza.",
    activateSos: "Attiva SOS",
    orCallDirectly: "Oppure chiama direttamente",
    quickDanContacts: "Contatti DAN rapidi",
    aboutToSendSos: "Stai per inviare un SOS di emergenza",
    gpsPosition: "Posizione GPS",
    detecting: "Rilevamento...",
    detectPosition: "Rileva posizione",
    diveSite: "Sito di immersione",
    diveSitePlaceholder: "Nome del sito",
    danCardNumber: "Numero tessera DAN",
    message: "Messaggio",
    messagePlaceholder: "Descrivi la situazione...",
    cancel: "Annulla",
    sending: "Invio...",
    sendSos: "Invia SOS",
    sosSent: "SOS inviato",
    contactDirectly: "Contatta direttamente",
    doNotClosePage: "Non chiudere questa pagina fino alla conferma dei soccorsi",
    danRegional: "DAN (zona)",
  },
  wizOnboarding: {
    selectCountry: "Seleziona nazione…",
    searchCountry: "Cerca nazione…",
    noResults: "Nessun risultato",
    profileIntro: "Come ti chiami? Come vuoi essere conosciuto nella community?",
    displayNameLabel: "Nome visualizzato",
    displayNamePlaceholder: "Es. Mario Rossi",
    displayNameError: "Nome obbligatorio (min. 2 caratteri)",
    bioLabel: "Bio",
    optional: "(opzionale)",
    bioPlaceholder: "Raccontaci qualcosa di te e delle tue immersioni...",
    mobileLabel: "Cellulare",
    phoneRequired: "Numero obbligatorio",
    phoneTooShort: "Numero troppo corto (min 8 cifre)",
    phoneTooLong: "Numero troppo lungo (max 15 cifre)",
    phoneInvalid: "Numero non valido",
    dobLabel: "Data di nascita",
    dobError: "Data obbligatoria",
    countryLabel: "Nazione",
    back: "Indietro",
    next: "Avanti",
    certIntro: "Hai già un brevetto? Seleziona la tua didattica e il livello. Potrai aggiungerne altri in seguito.",
    agencyLabel: "Didattica",
    none: "Nessuna",
    certLabel: "Brevetto",
    selectCert: "Seleziona brevetto…",
    noCertAvailable: "— nessun brevetto disponibile —",
    certLaterPrefix: "Potrai aggiungere i tuoi brevetti in qualsiasi momento dalla sezione",
    certLaterSection: "Profilo → Certificazioni",
    certLaterSuffix: ".",
    jobTracciaLabel: "Tengo il logbook",
    jobTracciaDesc: "Registro immersioni e analizzo statistiche",
    jobTracciaLink: "Vai al logbook",
    jobEsploraLabel: "Esploro nuovi posti",
    jobEsploraDesc: "Cerco siti, scopro mete, pianfico viaggi",
    jobEsploraLink: "Esplora i siti",
    jobImparaLabel: "Mi alleno e studio",
    jobImparaDesc: "Seguo corsi, cerco un istruttore",
    jobImparaLink: "Vedi i corsi",
    jobSicuroLabel: "Rimango in sicurezza",
    jobSicuroDesc: "Gestisco cartella medica e check-in",
    jobSicuroLink: "Cartella medica",
    jobConnettoLabel: "Mi connetto con altri",
    jobConnettoDesc: "Trovo buddy, partecipo alla community",
    jobConnettoLink: "Community",
    jobGestiscoLabel: "Organizzo la logistica",
    jobGestiscoDesc: "Calendario, prenotazioni e attrezzatura",
    jobGestiscoLink: "Apri calendario",
    jobLavoroLabel: "Gestisco un'attività",
    jobLavoroDesc: "Istruttore, divemaster o centro diving",
    jobLavoroLink: "Dashboard pro",
    jobProteggoLabel: "Proteggo l'oceano",
    jobProteggoDesc: "Citizen science, specie, ricerca marina",
    jobProteggoLink: "Missioni",
    jtbdTitle: "Come usi eDive?",
    jtbdSubtitle: "Seleziona tutto ciò che ti riguarda — personalizziamo la tua esperienza.",
    continueSelected: "Continua ({{count}} selezionati)",
    skip: "Salta",
    doneLinkLogbook: "Logbook",
    doneLinkSites: "Siti",
    doneLinkCommunity: "Community",
    doneLinkPlanning: "Pianificazione",
    doneTitle: "Benvenuto in eDive!",
    doneSubtitleSelected: "Il tuo profilo è pronto. Ecco da dove vuoi iniziare.",
    doneSubtitleDefault: "Il tuo profilo è pronto. Esplora la piattaforma.",
    goToDashboard: "Vai alla Dashboard",
    error: "Errore",
    centerAlreadyClaimed: "Questo centro è già stato reclamato.",
    centerRequiredFields: "Nome, città e nazione sono obbligatori",
    centerCreateError: "Errore durante la creazione",
    centerLinked: "✓ Centro collegato al tuo profilo",
    continue: "Continua",
    dcSearchIntro: "Cerca il tuo Diving Center per collegarlo al tuo profilo.",
    dcSearchPlaceholder: "Nome del diving center...",
    search: "Cerca",
    dcNoCenterFound: "Nessun centro trovato",
    dcCreateNew: "+ Crea nuovo centro",
    claim: "Reclama",
    configureLater: "Configura dopo →",
    dcFieldName: "Nome del centro *",
    dcFieldNamePh: "Es. Blue Shark Diving",
    dcFieldCity: "Città *",
    dcFieldCityPh: "Es. Palermo",
    dcFieldCountry: "Nazione *",
    dcFieldCountryPh: "Es. IT",
    dcFieldPhone: "Telefono",
    dcFieldEmail: "Email",
    dcFieldWebsite: "Sito web",
    creating: "Creazione...",
    createAndLink: "Crea e collega",
    requestSentTo: "Richiesta inviata a {{name}}",
    alreadyMember: "Sei già in questa organizzazione",
    joinError: "Errore durante l'iscrizione",
    typeDiveCenter: "Diving Center",
    typeDiveResort: "Dive Resort",
    typeAssociation: "Associazione",
    connectTitle: "Appartieni a un centro sub o a un'associazione?",
    connectSubtitle: "Cerca e collegati per ricevere le comunicazioni del tuo centro. Puoi farlo anche in seguito.",
    connectSearchPlaceholder: "Nome del centro o associazione…",
    requestsSent: "Richieste inviate:",
    connectNoResults: "Nessun risultato — prova con un nome diverso",
    sent: "✓ Inviato",
    connectAction: "Collegati",
    continueConnected: "Continua ({{count}} collegati)",
    stepProfile: "Profilo",
    stepActivate: "Attiva",
    stepConnect: "Collegati",
    stepCert: "Brevetto",
    stepInterests: "Interessi",
    stepStart: "Inizia!",
    profileSaveError: "Errore nel salvataggio del profilo",
    activateTitle: "Cosa vuoi fare su eDive?",
    activateSubtitle: "Attiviamo subito le funzioni giuste per te. Potrai aggiungerne altre quando vuoi.",
    activateVerifyBadge: "verifica",
    activateDoctorHint: "Invieremo la tua richiesta di verifica come Medico: ti avviseremo appena approvata.",
    activateCenterHint: "Per registrare un centro serve una verifica: potrai farlo dal tuo profilo dopo l'onboarding.",
    activateContinue: "Continua",
    activateSkip: "Salta per ora",
    activateProfileDone: "Profilo attivato!",
    activateDoctorSent: "Richiesta Medico inviata: ti avviseremo appena verificata.",
    activateDoctorError: "Non è stato possibile inviare la richiesta.",
    wizardTitle: "Configura il tuo profilo",
    stepCounter: "Passo {{current}} di {{total}}",
    countryIT: "Italia",
    countryDE: "Germania",
    countryFR: "Francia",
    countryES: "Spagna",
    countryGB: "Regno Unito",
    countryCH: "Svizzera",
    countryAT: "Austria",
    countryBE: "Belgio",
    countryNL: "Paesi Bassi",
    countryPT: "Portogallo",
    countryGR: "Grecia",
    countryHR: "Croazia",
    countryMT: "Malta",
    countryCY: "Cipro",
    countryEG: "Egitto",
    countryTH: "Thailandia",
    countryID: "Indonesia",
    countryPH: "Filippine",
    countryAU: "Australia",
    countryUS: "Stati Uniti",
    countryCA: "Canada",
    countryMX: "Messico",
    countryBR: "Brasile",
    countryAR: "Argentina",
    countryZA: "Sudafrica",
    countryMV: "Maldive",
    countryLK: "Sri Lanka",
    countryJP: "Giappone",
    countryRU: "Russia",
    countryTR: "Turchia",
    countryAE: "Emirati Arabi",
    countryIL: "Israele",
    countryMA: "Marocco",
    countryTN: "Tunisia",
    countrySE: "Svezia",
    countryNO: "Norvegia",
    countryDK: "Danimarca",
    countryFI: "Finlandia",
    countryPL: "Polonia",
    countryCZ: "Repubblica Ceca",
    countryHU: "Ungheria",
    countryRO: "Romania",
    countrySI: "Slovenia",
    countrySK: "Slovacchia",
    countryBG: "Bulgaria",
    countryLT: "Lituania",
    countryLV: "Lettonia",
    countryEE: "Estonia",
    countryIE: "Irlanda",
    countryNZ: "Nuova Zelanda",
    countrySG: "Singapore",
    countryMY: "Malaysia",
    countryKE: "Kenya",
    countryTZ: "Tanzania",
    countryMZ: "Mozambico",
    countryMU: "Mauritius",
    countryRE: "Réunion",
    countryNC: "Nuova Caledonia",
    countryPF: "Polinesia Francese",
    countryCK: "Isole Cook",
    countryFJ: "Figi",
    countryVN: "Vietnam",
    countryKH: "Cambogia",
    countryMM: "Myanmar",
    countryIN: "India",
    countryCN: "Cina",
    countryKR: "Corea del Sud",
    countryHK: "Hong Kong",
    countryTW: "Taiwan",
    countryEC: "Ecuador",
    countryCO: "Colombia",
    countryPA: "Panama",
    countryCU: "Cuba",
    countryCL: "Cile",
    countryPE: "Perù",
    countryVE: "Venezuela",
    countryDO: "Rep. Dominicana",
    countryJM: "Giamaica",
    countryBB: "Barbados",
    countryLC: "Santa Lucia",
    countryTT: "Trinidad e Tobago",
    countryAW: "Aruba",
    countryBQ: "Bonaire",
    countryCW: "Curaçao",
  },
  profileActivation: {
    title: "Attiva il tuo profilo",
    subtitle: "Dicci chi sei sott'acqua: attiviamo le funzioni giuste per te. Potrai sempre aggiungerne altre.",
    verifyBadge: "Con verifica",
    activateNow: "Attiva subito",
    activating: "Attivazione…",
    sending: "Invio…",
    profileDone: "Profilo attivato! Benvenuto nel tuo percorso.",
    profileError: "Non è stato possibile attivare il profilo, riprova.",
    requestSent: "Richiesta inviata! Ti avviseremo appena verrà verificata.",
    requestError: "Non è stato possibile inviare la richiesta, riprova.",
    diverTitle: "Subacqueo",
    diverBlurb: "Registra le tue immersioni, pianifica e cresci nel logbook.",
    freediverTitle: "Apneista",
    freediverBlurb: "Allena respirazione e apnea, cronometra le tue statiche.",
    photographerTitle: "Fotografo subacqueo",
    photographerBlurb: "Crea il tuo portfolio e contribuisci all'enciclopedia delle specie.",
    doctorTitle: "Medico subacqueo",
    doctorBlurb: "Valuta l'idoneità dei subacquei e accedi al portale medico.",
    doctorCta: "Richiedi la verifica",
    centerTitle: "Responsabile centro diving",
    centerBlurb: "Porta il tuo centro su eDive: corsi, uscite, staff e prenotazioni.",
    centerCta: "Registra il centro",
  },
  wizImport: {
    methodFileTitle: "Ho un file",
    methodFileDesc: "UDDF, CSV, FIT, XML o JSON Garmin dal tuo computer o dal software del dive computer",
    methodComputerTitle: "Connetto il computer",
    methodComputerDesc: "Via USB o Bluetooth — Chrome/Edge richiesto",
    methodCloudTitle: "Sincronizza dal cloud",
    methodCloudDesc: "Garmin Connect, Divelogs.de, Shearwater Cloud",
    methodManualTitle: "Inserisco a mano",
    methodManualDesc: "Compila tu i dati dell'immersione passo dopo passo",
    step1Heading: "Come vuoi aggiungere le immersioni?",
    step1Subtitle: "Scegli il metodo più comodo per te",
    reviewHeading: "Conferma le immersioni",
    reviewFoundPrefix: "Trovate",
    reviewFoundSuffix: "immersioni.",
    reviewPossibleDuplicates: "{{count}} possibili duplicate",
    reviewChooseEach: "scegli cosa fare per ciascuna.",
    badgeNew: "{{count}} nuove",
    badgeDuplicate: "{{count}} duplicate",
    badgeToImport: "{{count}} da importare",
    deselectAll: "Deseleziona tutte",
    selectAllNew: "Seleziona tutte le nuove",
    deletedWillRestore: "Eliminata — verrà ripristinata",
    probableDuplicate: "Probabile duplicato",
    maybeDuplicate: "Forse duplicato",
    colToImport: "Da importare",
    colDeleted: "Eliminata",
    colAlreadyPresent: "Già presente",
    certified: "certificata",
    actionSkip: "Salta",
    actionImportAnyway: "Importa comunque",
    actionRestore: "Ripristina",
    actionUpdateExisting: "Aggiorna l'esistente",
    overwriteExisting: "Sovrascrivi anche i dati già presenti con quelli importati (più aggiornati)",
    errorNoDivesInFile: "Nessuna immersione trovata nel file. Verifica il formato.",
    errorFileUnreadable: "File non leggibile o formato non supportato.",
    fileHeading: "Carica il tuo file",
    fileDescPart1: "Trascina qui il file esportato dal tuo dive computer o dal suo software. Supportiamo",
    fileDescAnd: "e il",
    fileDescGarminJson: "JSON di Garmin Connect",
    dropFileHere: "Trascina il file qui",
    orClickToBrowse: "oppure clicca per sfogliare",
    dontKnowHowExport: "Non sai come esportare dal tuo computer?",
    viewModelGuide: "Consulta la guida modelli",
    statusSelectUsbPort: "Seleziona la porta USB del dive computer…",
    statusReadingData: "Lettura dati in corso (max 30 sec)…",
    statusAnalyzingData: "Analisi dati…",
    errorNoDivesInDevice: "Nessuna immersione trovata nel dispositivo",
    errorUsbConnection: "Errore connessione USB",
    statusSearchingBle: "Ricerca dispositivo Bluetooth…",
    statusConnectedReading: "Connesso a {{name}}. Lettura immersioni…",
    errorNoDivesFound: "Nessuna immersione trovata",
    errorBleConnection: "Errore connessione Bluetooth",
    computerHeading: "Connetti il dive computer",
    computerSubtitle: "Scegli come collegare il tuo computer subacqueo al dispositivo.",
    viaUsb: "Via USB",
    usbBrands: "Suunto, Mares, Cressi e altri",
    requiresChromeEdge: "Richiede Chrome/Edge",
    viaBluetooth: "Via Bluetooth",
    bleBrands: "Shearwater, EON Steel e altri",
    statusConnecting: "Connessione…",
    browserUnsupportedPart1: "Il tuo browser non supporta la connessione diretta ai dive computer. Usa",
    browserUnsupportedOr: "o",
    browserUnsupportedPart2: "su desktop, oppure esporta il file dal software del computer e usa la modalità \"Ho un file\".",
    errorBadCredentials: "Credenziali errate o servizio non raggiungibile",
    cloudHeading: "Sincronizza dal cloud",
    cloudSubtitle: "Seleziona il servizio e inserisci le tue credenziali.",
    usernameOrEmail: "Username o email",
    password: "Password",
    cloudDedupNote: "Il cloud sincronizzo rimuove automaticamente le duplicate. Non potrai rivedrle prima dell'import.",
    connectingSyncing: "Connessione e sincronizzazione…",
    syncDives: "Sincronizza immersioni",
    errorSelectAtLeastOne: "Seleziona almeno un'immersione da importare",
    errorDuringImport: "Errore durante l'importazione",
    checkingDuplicates: "Controllo duplicati in corso…",
    back: "Indietro",
    toastSelectAtLeastOne: "Seleziona almeno un'immersione",
    importing: "Importazione in corso…",
    importButton: "Importa {{count}} immersione/immersioni",
    toastReportError: "Errore invio segnalazione. Riprova.",
    resultImported: "{{count}} immersione importata / immersioni importate",
    resultSkipped: "{{count}} immersioni saltate (duplicate o deselezionate)",
    resultNoneImported: "Nessuna immersione importata",
    resultAllPresent: "Tutte le immersioni erano già presenti nel logbook.",
    moreWarnings: "…e altri {{count}} avvisi",
    goToLogbook: "Vai al logbook",
    importMoreFiles: "Importa altri file",
    somethingWentWrong: "Qualcosa non ha funzionato",
    reportToAdmin: "Segnala il problema all'amministratore",
    reportToAdminDesc: "Un amministratore esaminerà il tuo file e ti contatterà per supportarti. Di solito rispondiamo entro 24 ore.",
    describeProblemPlaceholder: "Descrivi brevemente il problema (facoltativo)…",
    sending: "Invio in corso…",
    sendReportToAdmin: "Invia segnalazione all'amministratore",
    cannotAttachFile: "Per errori di connessione (USB/BLE/cloud) non è possibile allegare il file.",
    reportSent: "Segnalazione inviata",
    reportSentDesc: "Ti risponderemo il prima possibile.",
    retry: "Riprova",
    headerTitle: "Aggiungi immersioni",
    uniHeading: "Importa le tue immersioni",
    uniDesc: "Trascina qui i tuoi file — anche molti insieme, di qualsiasi formato. Ci pensa il sistema a riconoscerli e importarli.",
    uniDrop: "Trascina qui i file (anche più di uno)",
    uniProgress: "{{done}}/{{total}} file",
    uniFileResult: "{{imp}} imp · {{dup}} dup",
    uniSummary: "Fatto: {{imp}} immersioni importate, {{dup}} duplicate saltate, {{err}} errori.",
    uniGoLogbook: "Vai al logbook",
    uniMore: "Altri file",
    uniError: "Errore di importazione",
  },
  wizInsurance: {
    stepCoverageType: "Tipo copertura",
    stepDurationTerritory: "Durata e territorio",
    stepSummaryPurchase: "Riepilogo e acquisto",
    coverageBasicLabel: "Base",
    coverageBasicDesc: "Copertura standard per subacquei ricreativi. Incidenti, evacuazione medica.",
    coverageExtendedLabel: "Avanzata",
    coverageExtendedDesc: "Include immersioni tecniche, nitrox, rebreather. Doppio massimale.",
    coverageDanLabel: "DAN Partner",
    coverageDanDesc: "Polizza DAN completa con camera iperbarica, repatriazione, assistenza globale.",
    duration1M: "1 mese",
    duration6M: "6 mesi",
    duration1Y: "1 anno",
    duration2Y: "2 anni",
    territoryItaly: "Italia",
    territoryEurope: "Europa",
    territoryWorldwide: "Mondiale",
    policyActivated: "Polizza attivata!",
    activationError: "Errore attivazione polizza",
    policyActiveLine1: "La tua assicurazione {{coverage}} è attiva.",
    policyActiveLine2: "Hai ricevuto una conferma via email.",
    viewMyPolicies: "Vedi le mie polizze",
    title: "Assicurazione subacquea",
    subtitle: "Proteggiti durante ogni immersione",
    activatePolicy: "Attiva polizza",
    chooseCoverageHint: "Scegli il tipo di copertura più adatta alle tue attività.",
    perYear: "/anno",
    durationLabel: "Durata",
    territoryLabel: "Territorio di copertura",
    summaryCoverage: "Copertura",
    summaryDuration: "Durata",
    summaryTerritory: "Territorio",
    totalToPay: "Totale da pagare",
    vatIncludedStripe: "IVA inclusa — pagamento sicuro via Stripe",
    termsAcceptPrefix: "Cliccando \"Attiva polizza\" accetti i",
    insuranceTerms: "termini assicurativi",
    errSelectCoverage: "Scegli una copertura per continuare.",
    errSelectDuration: "Scegli una durata.",
    errSelectTerritory: "Scegli un territorio di validità.",
  },
  wizRole: {
    motivationCertLabel: "Brevetto",
    motivationCertNumber: "N° {{num}}",
  },
  wizTravel: {
    stepDestination: "Destinazione",
    stepChoosePackage: "Scegli pacchetto",
    stepParticipants: "Partecipanti",
    stepConfirm: "Conferma",
    priceAny: "Qualsiasi prezzo",
    priceUpTo500: "Fino a €500",
    priceUpTo1000: "Fino a €1.000",
    priceUpTo2000: "Fino a €2.000",
    priceUpTo5000: "Fino a €5.000",
    daysCount: "{{count}} giorni",
    divesCount: "{{count}} immersioni",
    perPersonSuffix: "/persona",
    title: "Cerca pacchetto viaggio sub",
    subtitle: "Trova e prenota il tuo prossimo viaggio",
    finalLabel: "Invia prenotazione",
    bookingSent: "Prenotazione inviata all'agenzia!",
    bookingError: "Errore nella prenotazione",
    destinationLabel: "Destinazione",
    maxBudgetLabel: "Budget massimo",
    noPackagesFound: "Nessun pacchetto trovato",
    noPackagesHint: "Prova a modificare la destinazione o il budget.",
    participantsCountLabel: "Numero partecipanti",
    maxLabel: "max {{max}}",
    estimatedTotal: "Totale stimato",
    notesLabel: "Note per l'agenzia (opzionale)",
    notesPlaceholder: "Es. esigenze alimentari, richieste speciali, certificazioni del gruppo…",
    requestSummary: "Riepilogo richiesta",
    participantsCount: "{{count}} partecipanti",
    estimatedAmount: "€{{amount}} stimati",
    confirmInfo: "L'agenzia riceverà la tua richiesta e ti contatterà per confermare disponibilità, dettagli di pagamento e logistica del viaggio.",
  },
  wizBuddy: {
    totalDivesPlaceholder: "Es. 50",
  },
  wizBookDive: {
    stepSearch: "Cerca sessioni",
    stepSelect: "Seleziona",
    stepDetails: "Dettagli",
    stepConfirm: "Conferma",
  },
  wizCourseEnroll: {
    stepChoose: "Scegli corso",
    stepDetails: "Dettagli",
    stepConfirm: "Conferma",
  },
  wizReportIncident: {
    stepTypeSeverity: "Tipo e gravità",
    stepWhereWhen: "Dove e quando",
    stepDetails: "Dettagli",
    stepConfirm: "Conferma",
  },
  wizSubscriptionUpgrade: {
    stepChoosePlan: "Scegli piano",
    stepConfirm: "Conferma",
    stepPayment: "Pagamento",
  },
  wizContribute: {
    stepReview: "Verifica",
    stepContext: "Contesto",
    stepConsent: "Conferma",
    stepDone: "Inviata",
    backToLibrary: "Torna alla libreria",
    consentRequired: "Conferma di essere titolare dei diritti per inviare.",
    submitError: "Invio fallito. Riprova.",
  },
  wizUploadIdentify: {
    stepUpload: "Carica",
    stepIdentify: "Identifica",
    stepConfirm: "Conferma",
    stepDone: "Salvata",
  },
  wizKyc: {
    docPassportLabel: "Passaporto",
    docPassportSub: "Documento di viaggio internazionale",
    docIdCardLabel: "Carta d'identità",
    docIdCardSub: "CIE o carta identità cartacea",
    docLicenseLabel: "Patente di guida",
    docLicenseSub: "Fronte e retro della patente",
    introDescription: "La verifica dell'identità è richiesta per accedere a funzionalità avanzate come la firma elettronica dei moduli di waiver, la gestione di certificati e l'accesso a servizi assicurativi.",
    introDuration: "Il processo richiede circa 2 minuti. I tuoi documenti sono trattati in modo sicuro e non vengono condivisi con terze parti.",
    whatYouNeed: "Cosa ti serve",
    needDocument: "Passaporto, carta d'identità o patente",
    needPhotos: "Foto leggibili (fronte, eventualmente retro)",
    needNotExpired: "Documento non scaduto",
    startVerification: "Inizia verifica",
    selectDocTypePrompt: "Seleziona il tipo di documento che vuoi caricare.",
    back: "Indietro",
    next: "Avanti",
    errSelectImage: "Seleziona un file immagine",
    errImageTooLarge: "Immagine troppo grande (max 8 MB)",
    tapToUpload: "Tocca per caricare",
    fileHint: "JPG, PNG — max 8 MB",
    uploadPrompt: "Carica foto chiare del tuo documento. Assicurati che tutti i dati siano leggibili.",
    frontLabel: "Fronte documento *",
    backLabel: "Retro documento *",
    photoHint: "Scatta la foto in un ambiente ben illuminato. Evita riflessi e ombre sul documento.",
    submitDocuments: "Invia documenti",
    doneIntro: "I tuoi documenti sono stati inviati con successo. Il team di verifica li esaminerà entro",
    doneTimeframe: "24–48 ore lavorative",
    doneNotify: "Riceverai una notifica quando la verifica sarà completata.",
    statusTitle: "Stato verifica",
    statusUnderReview: "In revisione",
    statusJustSubmitted: "Invio appena completato",
    backToProfile: "Torna al profilo",
    errSubmit: "Errore durante l'invio. Riprova.",
    stepIntro: "Introduzione",
    stepDocType: "Tipo documento",
    stepUpload: "Carica foto",
    stepDone: "Completato",
    title: "Verifica identità",
    stepCounter: "Passo {{current}} di {{total}} — {{name}}",
  },
  wizMedical: {
    moreSuggestions: "+{{count}} altre…",
    bloodType: "Gruppo sanguigno",
    bloodTypeHint: "Informazione critica in caso di emergenza.",
    allergiesLabel: "Allergie note",
    allergiesHint: "Aggiungi farmaci, sostanze o alimenti ai quali sei allergico/a.",
    allergiesPlaceholder: "Es. Penicillina…",
    conditionsPrivacyBefore: "Queste informazioni rimangono",
    conditionsPrivacyStrong: "private e cifrate",
    conditionsPrivacyAfter: "Vengono condivise solo con i medici che autorizzi esplicitamente.",
    conditionsLabel: "Patologie / condizioni pregresse",
    conditionsHint: "Inserisci condizioni rilevanti per la pratica subacquea.",
    conditionsPlaceholder: "Es. Asma bronchiale…",
    medicationsLabel: "Farmaci in uso",
    medicationsHint: "Elenco farmaci assunti regolarmente.",
    medicationsPlaceholder: "Es. Metformina…",
    healthNotesLabel: "Note aggiuntive sulla salute",
    healthNotesPlaceholder: "Es. intervento chirurgico recente, limitazioni fisiche, note per il medico subacqueo…",
    diveCatP1: "P1 — Non autonomo fino a -12m",
    diveCatP2: "P2 — Autonomo fino a -20m",
    diveCatP3: "P3 — Autonomo fino a -40m",
    diveCatPA: "PA — Apnea",
    diveCatTech: "Tecnica",
    maxDepthLabel: "Profondità massima certificata (m)",
    maxDepthPlaceholder: "Es. 40",
    maxDepthHint: "Corrisponde al limite della tua certificazione più avanzata.",
    maxDepthFromLogbook: "Dal tuo logbook: max {{depth}} m.",
    medicalCertSection: "Certificato medico subacqueo",
    issuedByLabel: "Rilasciato da",
    issuedByPlaceholder: "Dott. Mario Rossi / Poliambulatorio…",
    categoryLabel: "Categoria",
    selectOption: "— seleziona —",
    validFromLabel: "Valido dal",
    validUntilLabel: "Valido fino al",
    certExpiredBefore: "⚠️ Il certificato inserito risulta",
    certExpiredStrong: "scaduto",
    certExpiredAfter: "Rinnova la visita medica prima di immergerti.",
    uploadPdfBefore: "Puoi caricare il documento PDF dalla pagina",
    uploadPdfStrong: "Medico → Certificati",
    uploadPdfAfter: "nel tuo profilo.",
    registeredContact: "Contatto registrato",
    replace: "Sostituisci",
    contactSavedNote: "Questi dati vengono salvati nel tuo profilo e sono condivisi con tutti i check-in di sicurezza.",
    emergencyWarning: "In caso di incidente subacqueo questa è la prima persona che viene contattata. Assicurati che i dati siano sempre corretti.",
    cancelRestorePrevious: "← Annulla e ripristina contatto precedente",
    firstNameLabel: "Nome *",
    firstNamePlaceholder: "Anna",
    lastNameLabel: "Cognome *",
    lastNamePlaceholder: "Rossi",
    phoneLabel: "Telefono *",
    phonePlaceholder: "+39 340 000 0000",
    relationshipLabel: "Relazione",
    dossierSummarySection: "Riepilogo fascicolo",
    dossierSummaryBefore: "Il fascicolo sanitario elettronico sarà accessibile solo a te e ai medici subacquei che autorizzi. Potrai aggiornarlo in qualsiasi momento da",
    dossierSummaryStrong: "Sicurezza → Medico",
    stepDatiBase: "Dati base",
    stepCondizioni: "Condizioni",
    stepIdoneita: "Idoneità sub",
    stepEmergenza: "Emergenza",
    saveSuccess: "Fascicolo sanitario salvato!",
    saveError: "Errore nel salvataggio",
    title: "Fascicolo sanitario elettronico",
    subtitle: "Dati medici privati per la tua sicurezza in immersione",
    finalLabel: "Salva fascicolo",
  },
  wizPlan: {
    stepWhereWhen: "Dove e quando",
    stepProfile: "Profilo",
    stepDetails: "Dettagli",
    stepSummary: "Riepilogo",
    siteSearchHint: "Cerca un sito di immersione o inserisci il nome manualmente.",
    siteSearchPlaceholder: "Cerca sito (es. Portofino, Blue Hole…)",
    siteNotFoundPrefix: "Nessun sito trovato — verrà salvato come ",
    siteNotFoundSuffix: ".",
    useThisName: "Usa questo nome",
    groupSize: "Dimensione gruppo",
    person: "persona",
    persons: "persone",
    addBuddies: "Aggiungi buddy / compagni",
    buddyNamePlaceholder: "Nome del buddy",
    noBuddies: "Nessun buddy aggiunto — puoi procedere anche senza",
    noEquipment: "Non hai ancora attrezzatura salvata nel profilo.",
    addEquipmentPrefix: "Puoi aggiungerla da ",
    addEquipmentPath: "Il mio profilo → Attrezzatura",
    addEquipmentSuffix: " e tornare qui.",
    proceedAnyway: "Procedi pure con la pianificazione!",
    selectEquipment: "Seleziona l'attrezzatura che porterai in questa immersione.",
    dateLabel: "Data *",
    entryTimeLabel: "Ora di ingresso",
    detailsOptional: "Tutto opzionale — puoi salvare la pianificazione anche senza compilare questa sezione.",
    equipment: "Attrezzatura",
    logisticsNotes: "Note logistiche",
    logisticsNotesPlaceholder: "Es. punto di ritrovo, parcheggio, accesso…",
    addToCalendar: "Aggiungi al calendario",
    addToCalendarHint: "Crea un evento nel tuo calendario eDive",
    maxDepthLabel: "Profondità max (m) *",
    durationLabel: "Durata prevista (min) *",
    gasMix: "Miscela gas",
    gasAir: "Aria",
    gasNitrox: "Nitrox",
    gasTrimix: "Trimix",
    o2Label: "O₂ % (21–40)",
    modAtPpo2: "MOD a ppO₂ 1.4: {{depth}}m",
    trimixHintPrefix: "Per pianificazioni Trimix avanzate usa il ",
    technicalPlanner: "Pianificatore tecnico",
    trimixHintSuffix: " completo.",
    rowSite: "Sito",
    notSpecifiedM: "(non specificato)",
    rowDate: "Data",
    atTime: "alle {{time}}",
    notSpecifiedF: "(non specificata)",
    rowGroup: "Gruppo",
    rowDepth: "Profondità",
    rowGas: "Gas",
    compressedAir: "Aria compressa",
    rowEquipment: "Attrezzatura",
    itemsSelected: "{{count}} item selezionati",
    rowCalendar: "Calendario",
    willBeAdded: "Verrà aggiunto ✓",
    notAdded: "Non aggiunto",
    calculatedProfile: "Profilo calcolato",
    calculating: "Calcolo in corso…",
    calcUnavailable: "Calcolo non disponibile — il piano verrà salvato con i parametri inseriti.",
    exceedsNdl: "Supera l'NDL — risalita con soste obbligatorie",
    withinNdl: "Entro i limiti senza decompressione (NDL {{ndl}} min)",
    totalAscentTime: "Tempo totale di risalita ~{{min}} min",
    savedHintPrefix: "La pianificazione verrà salvata nel tuo profilo. Potrai aprirla nel pannello ",
    savedPlansPath: "Pianificatore → Piani salvati",
    savedHintSuffix: ".",
    defaultPlanName: "Immersione",
    notesBuddy: "Buddy: {{names}}",
    notesGroup: "Gruppo: {{count}} persone",
    savedToast: "Pianificazione salvata!",
    saveErrorToast: "Errore nel salvataggio",
    title: "Pianifica un'immersione",
    subtitle: "Modalità Rapido — per il pianificatore tecnico passa a Esperto",
    finalLabel: "Salva pianificazione",
    modeQuick: "Rapido",
    modeExpert: "Esperto",
    notesEquipment: "Attrezzatura selezionata: {{count}} elementi",
  },
  wizLogDive: {
    noDivesInUddf: "Nessuna immersione trovata nel file UDDF",
    importedFromFile: "Dati importati da {{name}} — verifica e completa",
    invalidUddf: "File UDDF non valido o non supportato",
    importFromComputer: "Importa da computer (UDDF)",
    waterSalt: "Salata (mare)",
    waterFresh: "Dolce (lago/fiume)",
    waterBrackish: "Salmastra",
    entryShore: "Riva",
    entryBoat: "Barca",
    entryLiveaboard: "Liveaboard",
    entryIce: "Ghiaccio",
    styleScuba: "SCUBA",
    styleFreediving: "Apnea",
    styleSnorkeling: "Snorkeling",
    diveSiteLabel: "Sito di immersione",
    divingCenter: "Diving center",
    centerPlaceholder: "Centro che ti ha accompagnato…",
    centerHint: "Chi ti ha portato a fare l'immersione (facoltativo).",
    dateRequired: "Data *",
    style: "Stile",
    entryTime: "Ora entrata",
    exitTime: "Ora uscita",
    diveType: "Tipo immersione",
    selectPlaceholder: "— seleziona —",
    ccrTitle: "ISO 24804 — Rebreather (CCR)",
    ccrBody: "Le immersioni con circuito chiuso richiedono una certificazione ISO 24804 o equivalente (CCR no-deco). Verifica di avere la qualifica adeguata nel tuo",
    gearProfile: "profilo attrezzatura",
    maxDepthRequired: "Profondità max (m) *",
    durationRequired: "Durata (min) *",
    avgDepth: "Profondità media (m)",
    visibility: "Visibilità (m)",
    waterTemp: "Temp. acqua (°C)",
    airTemp: "Temp. aria (°C)",
    waterType: "Tipo acqua",
    entryType: "Tipo entrata",
    freedivingData: "Dati apnea",
    breathHold: "Durata apnea (secondi)",
    breathHoldPlaceholder: "es. 120",
    lcmEvent: "LCM (Loss of Motor Control)",
    boEvent: "BO (Blackout)",
    o2Percent: "O₂ % (21-100)",
    hePercent: "He % (0-80)",
    barStart: "Bar inizio",
    barEnd: "Bar fine",
    modLabel: "MOD (ppO₂ 1.4):",
    suitType: "Tipo muta",
    weight: "Zavorra (kg)",
    weightSuggestion: "Suggerito per “{{suit}}”: ~{{kg}} kg",
    tankPressure: "Pressione tank (bar)",
    inviteEmailSubject: "Unisciti a eDive",
    inviteEmailBody: "Ciao! Ti invito a registrarti su eDive per condividere le nostre immersioni. Registrati qui: https://edive.app/register?ref=buddy_invite",
    searchBuddyPlaceholder: "Cerca buddy per nome…",
    addAsName: "+ Aggiungi \"{{name}}\" come nome",
    inviteViaEmail: "Invita via email",
    showQr: "Mostra QR",
    noBuddy: "Nessun buddy — procedi pure da solo",
    inviteYourBuddy: "Invita il tuo buddy",
    buddyScanQr: "Il tuo buddy scansiona il QR per registrarsi su eDive",
    qrAlt: "QR registrazione eDive",
    close: "Chiudi",
    rowSite: "Sito",
    notSpecified: "(non specificato)",
    rowDate: "Data",
    rowStyle: "Stile",
    rowDepth: "Profondità",
    avgValue: "(media {{avg}}m)",
    rowDuration: "Durata",
    rowGas: "Gas",
    rowWaterTemp: "Temp. acqua",
    notAvailable: "N/D",
    rowBuddy: "Buddy",
    none: "Nessuno",
    notes: "Note",
    notesPlaceholder: "Condizioni, fauna avvistata, memo…",
    tagsLabel: "Tag (premi Invio)",
    tagsPlaceholder: "es: notturna, tartaruga, corrente…",
    privacy: "Privacy",
    privacyPrivate: "Privata",
    privacyFriends: "Amici",
    privacyPublic: "Pubblica",
    rating: "Valutazione",
    restrictionMpa: "Area Marina Protetta",
    restrictionCulturalHeritage: "Patrimonio Culturale Sommerso",
    restrictionFishingProhibited: "Pesca Vietata",
    restrictionAnchorProhibited: "Ancoraggio Vietato",
    restrictionAccessRestricted: "Accesso Regolamentato",
    protectedZone: "Zona Tutelata — L.70/2026 art.13-14",
    zoneDistance: "({{authority}}, {{distance}}m di distanza)",
    checkAuthorizations: "Verifica le autorizzazioni necessarie prima di immergerti in questa zona.",
    stepSiteDate: "Sito e data",
    stepParams: "Parametri",
    stepGasSuit: "Gas e muta",
    stepBuddy: "Buddy",
    stepSummary: "Riepilogo",
    diveUpdated: "Immersione aggiornata",
    diveSaved: "Immersione salvata!",
    reconcileManually: "Immersione salvata. Riconcilia il piano manualmente dai Piani Salvati.",
    saveError: "Errore nel salvataggio",
    titleEdit: "Modifica immersione",
    titleCreate: "Registra un'immersione",
    subtitleEdit: "Aggiorna i dati della tua immersione",
    subtitleCreate: "Aggiungi al logbook in pochi passi",
    finalUpdate: "Aggiorna",
    finalSave: "Salva nel logbook",
    ecoTitle: "Sensibilizzazione ambientale ISO 21417",
    ecoBody: "Confermo di aver rispettato le norme di tutela ambientale e le pratiche eco-sostenibili per questa zona (ISO 21417 / L.70/2026 art.13).",
  },
  dcDash2: {
    reviewSent: "Recensione inviata",
    error: "Errore",
    replySent: "Risposta inviata",
    replySaveError: "Errore nel salvataggio della risposta",
    centerReviews: "Recensioni del Centro",
    reviewCount: "({{count}} recensioni)",
    writeReview: "Scrivi una recensione",
    titleOptional: "Titolo (opzionale)",
    experienceOptional: "La tua esperienza (opzionale)",
    sending: "Invio…",
    submitReview: "Invia recensione",
    loading: "Caricamento…",
    noReviewsYet: "Nessuna recensione ancora. Sii il primo!",
    verifiedBooking: "Prenotazione verificata",
    centerReply: "Risposta del centro",
    yourReply: "La tua risposta…",
    reply: "Rispondi",
    cancel: "Annulla",
    equipMaintenanceDue: "Attrezzatura: manutenzione in scadenza",
    equipExpiredCount: "{{count}} scaduta/e",
    equipExpiringSoonCount: "{{count}} in scadenza (30 gg)",
    clickToManage: "Clicca per gestire",
    groupOperative: "Operativo",
    tileBookings: "Prenotazioni",
    tileBookingsSub: "Lead, conferme, disponibilità",
    tileCalendar: "Calendario",
    tileCalendarSub: "Programma e agenda immersioni",
    tilePlanning: "Pianificazione",
    tilePlanningSub: "Gruppi, gas, briefing automatico",
    tileOperations: "Operazioni",
    tileOperationsSub: "Check-in, post-dive, incidenti",
    tileCustomers: "Clienti",
    tileCustomersSub: "Brevetti, medici, waiver",
    groupEquipment: "Attrezzatura",
    tileEquipment: "Attrezzatura",
    tileEquipmentSub: "Inventario, bombole, tank",
    tileMaintenance: "Manutenzione",
    tileMaintenanceSub: "Scadenze, revisioni, alert",
    tileBoats: "Barche",
    tileBoatsSub: "Flotta, assicurazioni, uso",
    tileRental: "Noleggio",
    tileRentalSub: "Prezzi, disponibilità, transazioni",
    groupTraining: "Formazione",
    tileCourses: "Corsi",
    tileCoursesSub: "PADI/SSI/RAID, studenti, esami",
    tileLogbook: "Logbook",
    tileLogbookSub: "Import, firma DM, certificati",
    tileBriefings: "Briefing",
    tileBriefingsSub: "Crea e condividi piani immersione",
    tileExcursions: "Escursioni",
    tileExcursionsSub: "Viaggi, guide, partecipanti",
    groupManagement: "Gestione",
    tileHr: "Staff & HR",
    tileHrSub: "Ruoli, richieste, inviti",
    tileShifts: "Turni",
    tileShiftsSub: "Calendario turni, reperibilità",
    tileAdmin: "Amministrazione",
    tileAdminSub: "Attività, incidenti, staff",
    tileInvoices: "Fatture",
    tileInvoicesSub: "Emissione, stati, storico",
    tilePricing: "Prezzi",
    tilePricingSub: "Regole stagionali, dinamici",
    tileWidget: "Widget Web",
    tileWidgetSub: "Codice booking per il sito",
    groupAnalyticsMarketing: "Analytics & Marketing",
    tileAnalytics: "Analytics",
    tileAnalyticsSub: "Revenue, KPI, fill rate",
    tileReports: "Report",
    tileReportsSub: "Annuali, corsi, clienti",
    tileMarketing: "Marketing",
    tileMarketingSub: "Fedeltà, newsletter, premi",
    tileCompliance: "Compliance",
    tileComplianceSub: "Documenti, scadenze, score L.70",
    groupDidacticsWork: "Didattica & Lavoro",
    tileCourseCatalog: "Catalogo Corsi",
    tileCourseCatalogSub: "PADI, SSI, CMAS e altri",
    tileTrainingHub: "Formazione Hub",
    tileTrainingHubSub: "Brevetti, esami, istruttori",
    tileSportCenter: "Sport Center",
    tileSportCenterSub: "Il tuo centro sportivo",
    tileJobs: "Offerte lavoro",
    tileJobsSub: "Staff e collaboratori",
    tanksHydroAlert: "bombole necessitano di collaudo idrostatico nei prossimi 60 giorni.",
    viewArrow: "Vedi →",
    kpiRegisteredCustomers: "Clienti registrati",
    kpiBookingsMonth: "Prenotazioni (mese)",
    kpiRevenueMonth: "Fatturato (mese)",
    kpiAvailableEquipment: "Attrezzatura disponibile",
    tanksSub: "{{count}} bombole",
    kpiBoatsInService: "Barche operative",
    kpiUpcomingTrips: "Viaggi in programma",
    kpiTanksToReview: "Bombole da revisionare",
    loyaltyProgram: "Programma fedeltà",
    manageArrow: "Gestisci →",
    kpiCompletedCoursesMonth: "Corsi completati (mese)",
    kpiIncidentsMonth: "Incidenti (mese)",
    kpiExpiredMedCerts: "Cert. medici scaduti",
    upcomingEvents: "Prossimi eventi",
    tileSafety: "Registro sicurezza",
    tileSafetySub: "Incidenti, report e audit",
  },
  marketplace2: {
    catBcd: "BCD",
    catRegulator: "Erogatore",
    catWetsuit: "Muta",
    catDrysuit: "Stagna",
    catFins: "Pinne",
    catMask: "Maschera",
    catComputer: "Computer",
    catCamera: "Fotocamera",
    catTorch: "Torcia",
    catAccessories: "Accessori",
    catBook: "Libri",
    catCourseVoucher: "Voucher Corso",
    catOther: "Altro",
    error: "Errore",
    offers: "Offerte",
    edit: "Modifica",
    delete: "Elimina",
    noOffersReceived: "Nessuna offerta ricevuta",
    category: "Categoria",
    priceEur: "Prezzo (€)",
    city: "Città",
    country: "Paese",
    statusPending: "In attesa",
    statusAccepted: "Accettata",
    statusRejected: "Rifiutata",
    statusWithdrawn: "Ritirata",
    statusPaid: "Pagata ✓",
    pay: "Paga",
    withdraw: "Ritira",
    myOffers: "Le mie offerte",
  },
  associations2: {
    deleted: "Eliminato",
    deleteError: "Errore durante l'eliminazione",
    statusUpdated: "Stato aggiornato",
    statusUpdateError: "Errore aggiornamento stato",
    convertedToDc: "Convertito in Diving Center",
    convertError: "Errore durante la conversione",
    joinRequestSent: "Richiesta di iscrizione inviata",
    joinError: "Errore durante l'iscrizione",
    dashboard: "Dashboard",
    allStatuses: "Tutti gli stati",
    loadError: "Errore nel caricamento",
    retryLater: "Riprova tra qualche momento",
    colName: "Nome",
    colStatus: "Stato",
    colType: "Tipo",
    colCity: "Città",
    colMembers: "Soci",
    colMembership: "Iscrizione",
    colActions: "Azioni",
    edivProfile: "Profilo eDive",
    statusJoined: "Iscritto",
    statusPending: "In attesa",
    staff: "Staff",
    join: "Iscriviti",
    statusSuspended: "Sospeso",
    profile: "Profilo",
    details: "Dettagli",
    status: "Stato",
    convertToDc: "Converti in Diving Center",
    dc: "DC",
    delete: "Elimina",
    countLabel: "{{count}} associazione",
    convertBody: "verrà convertito in Diving Center.",
    convertArchiveNote: "L'associazione originale sarà archiviata.",
    convertMigrationWarning: "I soci e le attività non verranno migrati automaticamente.",
    cancel: "Annulla",
    converting: "Conversione…",
    confirm: "Conferma",
    deleteConfirmBefore: "Sei sicuro di voler eliminare",
    deleteConfirmAfter: "? L'operazione non è reversibile.",
    deleting: "Eliminazione…",
    statusActive: "Attiva",
    statusSuspendedLabel: "Sospesa",
    statusClosed: "Chiusa",
    manageActions: "Altre azioni",
  },
  biology2: {
    activityIdentification: "Identificazione",
    activityChat: "Assistente AI",
    activityReport: "Report specie",
    activityJournal: "Diario campo",
    activityMission: "Missione",
    activityAlert: "Alert",
    timeAgoSeconds: "{{count}}s fa",
    timeAgoMinutes: "{{count}}min fa",
    timeAgoHours: "{{count}}h fa",
    timeAgoDays: "{{count}}g fa",
    recentActivity: "Attività recenti",
    spotlightTitle: "Specie in evidenza questa settimana",
    family: "Famiglia:",
    orderSuffix: " · Ordine: {{order}}",
    encyclopedia: "Enciclopedia →",
    generateReport: "Genera report",
  },
  mediaCorrect2: {
    headerTitle: "Correzione foto & video",
    headerSubtitle: "Correggi i colori delle tue immagini subacquee: recupero dei rossi, rimozione della dominante blu/verde, contrasto e nitidezza.",
    infoDescription: "L'elaborazione avviene nel tuo browser: nessun upload necessario per correggere e scaricare. Puoi anche salvare il risultato nella tua libreria.",
    step1Title: "Carica",
    step1Body: "Trascina una foto o un video, oppure selezionalo dal dispositivo.",
    step2Title: "Correggi",
    step2Body: "Usa \"Auto\" per la correzione automatica o regola i parametri (preset per profondità, CLAHE, nitidezza).",
    step3Title: "Salva",
    step3Body: "Scarica l'immagine corretta o salvala nella tua libreria eDive.",
    dropTitle: "Trascina qui foto o video",
    dropHint: "oppure clicca per selezionare — JPG, PNG, WebP, MP4, MOV",
    photo: "Foto",
    video: "Video",
  },
  events2: {
    eventFallback: "Evento",
    stepTitleType: "Titolo e Tipo",
    stepDateLocation: "Data e Luogo",
    stepDetailsConfirm: "Dettagli e Conferma",
  },
  services: {
    title: "Servizi",
    subtitle: "Trova e contatta servizi utili in tutto il mondo",
    backDashboard: "Dashboard",
    intro: "I dati provengono da fonti pubbliche (OpenStreetMap) e da controlli periodici. Ogni scheda indica quanto è affidabile: prima di partire verifica sempre i recapiti.",
    emergencyTitle: "Serve aiuto subito?",
    emergencyIntro: "Trova l'ospedale, il primo soccorso o l'ambasciata più vicini a te.",
    emergencyNote: "In caso di pericolo di vita chiama subito il numero di emergenza locale (112 nell'Unione Europea).",
    emergencyHospitals: "Ospedali",
    emergencyFirstAid: "Primo soccorso",
    emergencyEmbassies: "Ambasciate e consolati",
    nearMe: "Vicino a me",
    searchPlaceholder: "Cerca per nome in tutte le categorie…",
    search: "Cerca",
    categories: "Categorie",
    categoriesError: "Non riesco a caricare le categorie.",
    retry: "Riprova",
    countLabel: "Schede: {{count}}",
    allTitle: "Tutti i servizi",
    allSubtitle: "Risultati da tutte le categorie",
    categoryNotFound: "Categoria non trovata.",
    hints: "Cosa trovi qui",
    filterName: "Cerca per nome",
    filterCountry: "Tutti i paesi",
    filterCity: "Città",
    radius: "Raggio",
    km: "{{n}} km",
    features: "Caratteristiche",
    anyFeature: "Qualsiasi",
    open24h: "Aperto 24h",
    withPhone: "Con telefono",
    verifiedOnly: "Solo verificate",
    resetFilters: "Azzera filtri",
    geoLoading: "Rilevo la tua posizione…",
    geoDenied: "Non posso leggere la posizione: consenti l'accesso alla posizione nelle impostazioni del browser.",
    geoUnavailable: "Posizione non disponibile al momento. Riprova o cerca per paese e città.",
    geoUnsupported: "Il tuo browser non supporta la geolocalizzazione.",
    view: "Vista",
    viewList: "Elenco",
    viewMap: "Mappa",
    results: "Risultati: {{count}}",
    loading: "Caricamento…",
    searchError: "Ricerca non riuscita. Riprova tra poco.",
    emptyTitle: "Nessun servizio trovato",
    emptyText: "Nessun servizio trovato con questi filtri; l'archivio si arricchisce ogni giorno.",
    mapLoading: "Carico la zona…",
    mapNote: "La mappa mostra tutte le schede della zona visibile ({{count}}): sposta o ingrandisci per vedere le altre.",
    yourPosition: "La tua posizione",
    openDetail: "Apri scheda",
    pagination: "Paginazione",
    prev: "Precedente",
    next: "Successiva",
    pageOf: "Pagina {{page}} di {{pages}}",
    badge24h: "24h",
    call: "Chiama",
    detailNotFound: "Scheda non trovata o non più disponibile.",
    detailError: "Non riesco a caricare la scheda. Riprova tra poco.",
    presumedClosedTitle: "Possibile chiusura",
    presumedClosedText: "Questa struttura potrebbe essere chiusa definitivamente. Verifica prima di recarti sul posto.",
    openReports: "Altri utenti hanno segnalato un problema con questa scheda (segnalazioni aperte: {{count}}).",
    verif: {
      VERIFIED: "Verificata",
      PARTIAL: "Parziale",
      UNVERIFIED: "Non verificata",
    },
    verifDesc: {
      VERIFIED: "Controllata di recente con una fonte esterna.",
      PARTIAL: "Alcuni dati sono stati controllati, altri no.",
      UNVERIFIED: "Dato raccolto da una fonte pubblica e non ancora controllato.",
    },
    verifiedOn: "Verificato il {{date}}",
    verifExplainTitle: "Come leggere l'affidabilità",
    contacts: "Contatti",
    noContacts: "Nessun recapito disponibile per questa scheda.",
    email: "Scrivi una email",
    website: "Sito web",
    emergencyPhone: "Telefono emergenze",
    appointment: "Prenota un appuntamento",
    copy: "Copia",
    copied: "Copiato negli appunti",
    copyFailed: "Impossibile copiare",
    address: "Indirizzo",
    noAddress: "Indirizzo non disponibile.",
    openOsm: "Apri in OpenStreetMap",
    directions: "Indicazioni",
    openMapsApp: "Apri nell'app Mappe",
    servicesOffered: "Servizi offerti",
    hours: "Orari",
    alwaysOpen: "Aperto 24 ore su 24, 7 giorni su 7",
    hoursNote: "Orari come indicati nella fonte: verifica prima di andare.",
    langAndAccess: "Lingue e accessibilità",
    languages: "Lingue parlate",
    wheelchair: {
      yes: "Accessibile in sedia a rotelle",
      limited: "Accesso parziale per sedia a rotelle",
      no: "Non accessibile in sedia a rotelle",
    },
    details: "Dettagli",
    operator: "Gestore",
    priceRange: "Fascia di prezzo",
    capacity: "Capacità",
    stars: "Stelle",
    emergency24h: "Servizio attivo 24 ore su 24",
    sources: "Fonti dei dati",
    sourcesIntro: "Da dove arrivano questi dati e quando sono stati controllati.",
    lastChange: "Ultima modifica dei dati",
    lastCheck: "Ultimo controllo esterno",
    noSources: "Nessuna fonte registrata.",
    sourceLinks: "Pagine consultate",
    recentChecks: "Controlli recenti",
    sourceType: {
      OSM: "OpenStreetMap",
      AGENT: "Ricerca automatica",
      WEBSITE: "Sito ufficiale",
      MANUAL: "Inserimento manuale",
    },
    field: {
      name: "Nome",
      address: "Indirizzo",
      phones: "Telefono",
      email: "Email",
      pec: "PEC",
      whatsapp: "WhatsApp",
      website: "Sito web",
      openingHours: "Orari",
      description: "Descrizione",
      languages: "Lingue",
      servicesOffered: "Servizi offerti",
      social: "Social",
      wheelchair: "Accessibilità",
      attributes: "Dettagli",
    },
    report: "Segnala un problema",
    reportTitle: "Segnala un problema con questa scheda",
    reportIntro: "Aiutaci a mantenere i dati corretti. Cosa non va?",
    reportKind: {
      WRONG_PHONE: "Telefono errato",
      WRONG_ADDRESS: "Indirizzo errato",
      CLOSED: "Struttura chiusa",
      WRONG_INFO: "Altre informazioni errate",
      OTHER: "Altro",
    },
    reportMessage: "Dettagli (facoltativo)",
    reportMessagePh: "Ad esempio: il numero corretto è…",
    send: "Invia segnalazione",
    sending: "Invio…",
    cancel: "Annulla",
    close: "Chiudi",
    reportThanks: "Grazie! La segnalazione è stata registrata e verrà controllata.",
    reportAlready: "Hai già segnalato questa scheda oggi. Grazie, la controlleremo.",
    reportError: "Impossibile inviare la segnalazione. Riprova più tardi.",
    attr: {
      electricity: "Corrente elettrica",
      showers: "Docce",
      wifi: "Wi-Fi",
      dogsAllowed: "Cani ammessi",
      waterFill: "Carico acqua",
      wasteDisposal: "Scarico acque e rifiuti",
      free: "Gratuito",
      fee: "A pagamento",
      hyperbaricChamber: "Camera iperbarica",
      ambulance: "Ambulanza",
      airportPickup: "Ritiro in aeroporto",
      skipperIncluded: "Skipper incluso",
      representedCountry: "Paese rappresentato",
      representationType: "Tipo di rappresentanza",
      pitches: "Piazzole",
      bedsCount: "Posti letto",
      fleetSize: "Veicoli in flotta",
      vehicleTypes: "Tipi di veicolo",
      boatTypes: "Tipi di barca",
      maxPassengers: "Passeggeri massimi",
    },
    value: {
      embassy: "Ambasciata",
      consulate: "Consolato",
      consulate_general: "Consolato generale",
      honorary_consulate: "Consolato onorario",
      honorary_consul: "Console onorario",
      car: "Auto",
      van: "Furgone",
      motorcycle: "Moto",
      scooter: "Scooter",
      bicycle: "Bicicletta",
      camper: "Camper",
      sailboat: "Barca a vela",
      motorboat: "Barca a motore",
      rib: "Gommone",
      catamaran: "Catamarano",
      yacht: "Yacht",
      kayak: "Kayak",
    },
  },
  photography: {
    back: "Dashboard",
    title: "Fotografia",
    subtitle: "Foto subacquee e correzione in un unico posto",
    intro: "Gestisci le tue foto subacquee e migliorale con gli strumenti di correzione.",
  },
  diving: {
    back: "Dashboard",
    title: "Diving",
    subtitle: "Logbook, siti di immersione e pianificazione in un unico posto",
    intro: "Queste tre aree sono strettamente collegate: scegli il sito, pianifichi l'immersione, la registri nel logbook e usi ciò che hai registrato per pianificare la prossima.",
    mainAreas: "Le tre aree",
    checkinLabel: "Check-in sicurezza",
    checkinDesc: "Avvisa un contatto prima di immergerti: allerta automatica se non torni in tempo.",
    logbookLabel: "Logbook",
    logbookCount: "{{count}} immersioni registrate",
    logbookEmpty: "Registra la prima immersione",
    sitesLabel: "Siti di immersione",
    sitesDesc: "Mappa e schede dei siti da esplorare",
    planningLabel: "Pianificazione",
    planningDesc: "Gas, deco e profili immersione",
    shortcutsLogbook: "Scorciatoie Logbook",
    shortcutsSites: "Scorciatoie Siti",
    shortcutsPlanning: "Scorciatoie Pianificazione",
    newDiveLabel: "Registra immersione",
    newDiveDesc: "Wizard guidato in pochi minuti",
    statsLabel: "Statistiche",
    statsDesc: "Profondità, tempi e andamento",
    importLabel: "Importa immersioni",
    importDesc: "Dal dive computer",
    compareLabel: "Confronta immersioni",
    compareDesc: "Due immersioni a confronto",
    nearMeLabel: "Vicino a me",
    nearMeDesc: "Siti nei dintorni della tua posizione",
    recsLabel: "Consigliati",
    recsDesc: "Siti scelti in base al tuo profilo",
    wishlistLabel: "Lista desideri",
    wishlistDesc: "I siti che vuoi visitare",
    mpaLabel: "Aree marine protette",
    mpaDesc: "Zone di tutela e regole",
    wizardLabel: "Pianifica immersione",
    wizardDesc: "Percorso guidato passo dopo passo",
    toolsLabel: "Calcolatori",
    toolsDesc: "Gas, deco, multidive e sicurezza",
    briefingLabel: "Briefing AI",
    briefingDesc: "Briefing di sicurezza pre-immersione",
    gasLabel: "Pianificatore gas",
    gasDesc: "Consumi e riserve di gas",
  },
  formazione2: {
    activeCourses: "Corsi attivi",
    seeAll: "Vedi tutti",
    dashboard: "Dashboard",
    title: "Formazione",
    subtitle: "Brevetti, corsi, simulazione esami e risorse didattiche",
    quickAccess: "Accesso rapido",
    coursesLabel: "Brevetti & Corsi",
    coursesDesc: "Conseguiti, in corso, catalogo",
    inProgressLabel: "In corso",
    inProgressDesc: "Materiali e progressi",
    examSimLabel: "Simulazione esami",
    examSimDesc: "Esercitati con i test teorici",
    findInstructorLabel: "Trova istruttore",
    findInstructorDesc: "Istruttori certificati vicino a te",
    findCenterLabel: "Trova diving center",
    findCenterDesc: "Centri che erogano il corso",
    qaLabel: "Q&A",
    qaDesc: "Domande alla community",
    glossaryLabel: "Glossario",
    glossaryDesc: "Terminologia subacquea",
    myCertsLabel: "I miei brevetti",
    myCertsDesc: "Certificazioni conseguite",
    professionalCareer: "Professionale & carriera",
    myLessonsLabel: "Le mie lezioni",
    myLessonsDesc: "Lezioni private prenotate",
    staffRequestsLabel: "Richieste staff",
    staffRequestsDesc: "Candidature come staff di un centro",
    jobsLabel: "Lavoro",
    jobsDesc: "Offerte di lavoro nel mondo sub",
    ctaTitle: "Brevetti conseguiti e nuovi corsi",
    ctaSubtitle: "Gestisci i tuoi brevetti, monitora i corsi attivi e scopri nuovi percorsi formativi",
    goToCourses: "Vai ai corsi",
  },
  courses2: {
    titleAndLevel: "Titolo e Livello",
    detailsAndConfirm: "Dettagli e Conferma",
    titlePlaceholder: "Es. Open Water Diver OWD",
    certLevelPlaceholder: "Es. Open Water Diver, Advanced...",
    question: "Domanda {{n}}",
    years: "{{count}} anni",
    minYears: "min {{count}} anni",
    message: "Messaggio",
    formazione: "Formazione",
    myBrevetti: "I miei brevetti",
    inProgress: "In corso",
    catalog: "Catalogo",
    brevettiEarned: "Brevetti conseguiti",
    addBrevetto: "+ Aggiungi brevetto",
    noBrevettiRegistered: "Nessun brevetto registrato",
    noBrevettiHint: "Aggiungi le tue certificazioni per tenere traccia del tuo percorso formativo",
    certNumber: "N° {{number}}",
    expires: "Scad.",
    discoverNewCourses: "Scopri nuovi corsi",
    discoverNewCoursesHint: "Sfoglia il catalogo brevetti e trova istruttori certificati",
    goToCatalogArrow: "Vai al catalogo →",
  },
  medical2: {
    dashboard: "Dashboard",
    pageTitle: "Salute & Sicurezza",
    groupOverview: "Panoramica",
    groupReports: "Referti",
    groupPrevention: "Prevenzione",
    groupAccess: "Accessi",
    groupAnalytics: "Analytics",
    groupSafety: "Sicurezza",
    subReports: "Referti",
    subLab: "Laboratorio",
    subImaging: "Diagnostica",
    subVaccines: "Vaccini",
    subVitals: "Vitali",
    subCenterAccess: "Accessi centro",
    subMyDoctors: "I miei medici",
    subFse: "FSE",
    subChambers: "Camere",
    subEmergency: "Emergenza",
    subSheet: "Scheda",
    subSosDan: "SOS DAN",
    badgeOverviewLabel: "Panoramica",
    badgeOverviewDesc: "Scheda medica e stato",
    badgeLabLabel: "Referti & Lab",
    badgeLabDesc: "Esami e analisi",
    badgeVaccinesLabel: "Vaccinazioni",
    badgeVaccinesDesc: "Storico vaccini",
    badgeVitalsLabel: "Parametri",
    badgeVitalsDesc: "Pressione, peso, BMI",
    badgeFseLabel: "FSE",
    badgeFseDesc: "Fascicolo sanitario",
    badgeSafetyLabel: "Sicurezza",
    badgeSafetyDesc: "Emergenze e scheda",
    badgeCertDesc: "Carica il certificato medico, conserva lo storico e mostralo al centro immersioni",
    badgeCertLabel: "Certificato di idoneità",
    badgeFitnessDesc: "Idoneità subacquea, apnea e referral iperbarici emessi dal tuo medico",
    badgeFitnessLabel: "Valutazioni del medico",
    subFitnessCert: "Certificato di idoneità",
  },
  community2: {
    exploreHeading: "Esplora la Community",
    socialFeedLabel: "Social & Feed",
    socialFeedDesc: "Post, buddy finder e radar",
    challengesLabel: "Sfide & Badge",
    challengesDesc: "Classifiche e obiettivi",
    professionalsLabel: "Professionisti",
    professionalsDesc: "Istruttori e Divemaster",
    associationsLabel: "Associazioni",
    associationsDesc: "Club subacquei",
    chatLabel: "Chat",
    chatDesc: "Messaggi diretti",
    buddyMatchLabel: "Buddy Match",
    buddyMatchDesc: "Trova compagni d'immersione",
    squadsLabel: "Squadre",
    squadsDesc: "Team e gruppi sub",
    pollsDesc: "Vota e scopri l'opinione della community",
    pollsLabel: "Sondaggi",
  },
  layout: {
    profileIncompleteTitle: "Profilo incompleto.",
    profileIncompleteBody: "Per usufruire di tutti i servizi eDive completa i dati personali obbligatori (cellulare e data di nascita).",
    updateNow: "Aggiorna ora →",
    close: "Chiudi",
  },
  profile2: {
    groupAccount: "Account",
    groupDiving: "Diving",
    groupSalute: "Salute",
    groupLegale: "Legale",
    groupPro: "Pro",
    tabAnagrafica: "Anagrafica",
    tabContatti: "Contatti",
    tabInvita: "Invita",
    tabPreferenze: "Preferenze",
    tabBrevetti: "Brevetti",
    tabAttrezzatura: "Attrezzatura",
    tabFreediving: "Freediving",
    tabMedico: "Medico",
    tabEmergenza: "Emergenza",
    tabConsensi: "Consensi",
    tabPrivacy: "Privacy",
    tabKyc: "Verifica ID",
    tabTessere: "Tessere",
    tabRuoli: "Ruoli",
    tabProfessionale: "Professionale",
    quickMyCourses: "I Miei Corsi",
    quickWallet: "Portafoglio",
    quickSubscription: "Abbonamento",
    quickCertWallet: "Cert Wallet",
    quickCheckinQr: "QR Check-in",
    quickInviteFriends: "Invita Amici",
    quickAccess: "Accesso rapido",
    userFallback: "Utente",
    publicProfile: "Profilo pubblico",
    edit: "Modifica",
  },
  calendar2: {
    planToolTechnicalTitle: "Piano Tecnico",
    planToolTechnicalDesc: "Calcola mix gas, profili di decompressione, autonomia e tabelle SAC",
    planToolAiBriefingTitle: "AI Briefing",
    planToolAiBriefingDesc: "Genera briefing pre-immersione con meteo, condizioni e piani di emergenza",
    planToolBookSessionTitle: "Prenota Sessione",
    planToolBookSessionDesc: "Riserva il tuo posto per la prossima immersione guidata o corso",
    planToolMyTripsTitle: "I Miei Viaggi",
    planToolMyTripsDesc: "Organizza e pianifica le tue prossime spedizioni subacquee",
    dayMon: "Lun",
    dayTue: "Mar",
    dayWed: "Mer",
    dayThu: "Gio",
    dayFri: "Ven",
    daySat: "Sab",
    daySun: "Dom",
    searchDiveSitePlaceholder: "Cerca un punto di immersione...",
    pageSubtitle: "La tua agenda personale: immersioni, corsi, viaggi ed eventi tutto in un posto. Clicca su un giorno per vedere o aggiungere appuntamenti.",
    planningToolsHeading: "Strumenti di pianificazione",
  },
  planning2: {
    tabProfile: "Pianifica",
    firstTimeTitle: "Prima volta qui?",
    firstTimeBody: "Usa il wizard guidato per pianificare la tua immersione in pochi passi, senza configurare ogni parametro tecnico.",
    useWizard: "Usa il wizard",
    headerSubtitle: "Crea piani di immersione dettagliati con calcolo gas, tabelle di decompressione e briefing da condividere con il tuo team.",
    newPlan: "Nuova pianificazione",
    technicalTools: "Strumenti tecnici",
    technicalToolsDesc: "Multi-immersione, miscele gas, MOD/EAD, gas blending, CCR, utilità",
    unsavedTitle: "Pianificazione non salvata",
    unsavedBody: "Hai una pianificazione in corso non ancora salvata. La bozza resta disponibile al tuo ritorno, ma per conservarla in modo permanente salvala tra i tuoi piani.",
    unsavedStay: "Continua a modificare",
    unsavedLeave: "Esci (mantieni la bozza)",
  },
  divesites2: {
    noSitesInView: "Nessun sito in quest'area — sposta o rimpicciolisci la mappa",
    showingSubset: "Stai vedendo {{shown}} di {{total}} siti in quest'area",
    yourPosition: "La tua posizione",
    centerOnMyPosition: "Centra sulla mia posizione",
    myZone: "La mia zona",
    showAllSites: "Mostra tutti i siti",
    allSitesBtn: "Tutti i siti",
    protectedZones: "Zone Protette",
    countryItaly: "Italia",
    countryCroatia: "Croazia",
    countryGreece: "Grecia",
    countrySpain: "Spagna",
    countryMalta: "Malta",
    countryFrance: "Francia",
    countryTurkey: "Turchia",
    countryEgypt: "Egitto",
    countryCyprus: "Cipro",
    countryTunisia: "Tunisia",
    countryPortugal: "Portogallo",
    toggleMpaTitle: "Mostra/nascondi Aree Marine Protette",
    stepNameLocation: "Nome e Posizione",
    stepCoordinates: "Coordinate",
    stepFeatures: "Caratteristiche",
    coordinatesHint: "Inserisci le coordinate geografiche del sito di immersione.",
    latPlaceholder: "es. 40.7128",
    lngPlaceholder: "es. 14.2681",
  },
  logbook2: {
    toolStatsTitle: "Statistiche",
    toolStatsDesc: "Grafici depth, SAC e tendenze",
    toolAiProfileTitle: "Profilo AI",
    toolAiProfileDesc: "Analisi intelligente del tuo stile",
    toolCompareTitle: "Confronta",
    toolCompareDesc: "Metti a confronto immersioni",
    toolPeerTitle: "Peer Compare",
    toolPeerDesc: "Confronta con la community",
    toolTripTitle: "Trip Report",
    toolTripDesc: "Genera report AI del viaggio",
    toolImportTitle: "Importa",
    toolImportDesc: "CSV, UDDF, Subsurface e altro",
    toolComputerTitle: "Computer",
    toolComputerDesc: "Collega il tuo computer subacqueo",
    toolGearGasTitle: "Attrezzatura tecnica",
    toolGearGasDesc: "Miscele gas, profili deco e computer subacquei",
    toolApneaTitle: "Apnea",
    toolApneaDesc: "Dashboard apnea e freediving",
    exportPdfError: "Errore export PDF",
    importUnsupportedFormat: "Formato file non supportato o errore di importazione",
    divesRegistered: "{{count}} immersioni registrate",
    importing: "Importazione...",
    manage: "Gestisci",
    sectionAdd: "Aggiungi",
    guidedWizard: "Wizard guidato",
    recommended: "Consigliato",
    quickEntry: "Inserimento rapido",
    sectionImport: "Importa",
    fromDiveComputer: "Da computer subacqueo",
    reconcileNoDuplicates: "Riconcilia senza duplicati",
    newBadge: "Nuovo",
    fileFormats: "File (UDDF, SML, CSV, Subsurface...)",
    syncOnline: "Sync Online",
    sectionExport: "Esporta",
    exportUddfError: "Errore export UDDF",
    generatingPdf: "Generazione PDF...",
    advancedTools: "Strumenti avanzati",
    statTotalDives: "Immersioni totali",
    statHoursUnderwater: "Ore sott'acqua",
    statMaxDepth: "Profondità massima",
    statOnFilteredDives: "su immersioni filtrate",
    statCountriesVisited: "Paesi visitati",
    shortcutGoals: "Obiettivi",
    shortcutTripReport: "Resoconto viaggio",
    shortcutCompare: "Confronta",
    shortcutDiaries: "Diari di viaggio",
    shortcutFullAnalysis: "Analisi completa",
    filterDives: "Filtra immersioni",
    ofLoaded: "di {{count}} caricate",
    ofDives: "di",
    divesWord: "immersioni",
    clearFilters: "Cancella filtri",
    searchPlaceholder: "Cerca per sito, paese...",
    allTypes: "Tutti i tipi",
    typeRecreational: "Ricreativa",
    typeTechnical: "Tecnica",
    depthLabel: "Profondità",
    minPlaceholder: "min",
    maxPlaceholder: "max",
    dateFrom: "Dal",
    dateTo: "al",
    clientFilterNote: "I filtri per testo, profondità e tipo si applicano alle {{count}} immersioni già caricate. Il filtro per data invece interroga tutto l'archivio.",
    noResults: "Nessun risultato",
    emptyLogbook: "Il tuo diario è vuoto",
    importFile: "Importa file",
    importFromDiveComputer: "Importa da dive computer",
    addManually: "Aggiungi manualmente",
    loadMoreDives: "Carica altre immersioni",
    divesByCountry: "Immersioni per paese",
    unspecifiedCountry: "Non specificato ",
    countryDivesOne: "{{count}} immersione",
    countryDivesOther: "{{count}} immersioni",
    depthStat: "↓ Profondità",
    temperatureStat: "Temperatura",
    diveTypeRecreational: "Ricreativa",
    diveTypeTechnical: "Tecnica",
    diveTypeCcr: "CCR",
    diveTypeSidemount: "Sidemount",
  },
  dash: {
    logbook: "Logbook",
    sites: "Siti",
    calendar: "Calendario",
    planning: "Pianificazione",
    community: "Community",
    health: "Salute",
    safety: "Sicurezza",
    training: "Formazione",
    diaries: "Diari",
    centers: "Centri",
    biology: "Biologia",
    library: "Foto Subacquee",
    tourism: "Turismo",
    associations: "Associazioni",
    marketplace: "Marketplace",
    shop: "Shop eDive",
    news: "Notizie",
    panel: "Pannello",
    courses: "Corsi",
    sportCenter: "Sport Center",
    certs: "Brevetti",
    center: "Centro",
    bookings: "Prenotazioni",
    customers: "Clienti",
    staff: "Staff",
    compliance: "Compliance",
    authorizations: "Autorizzazioni",
    agency: "Agenzia",
    packages: "Pacchetti",
    medicalArea: "Area Medica",
    doctorPortal: "Portale Medico",
    medicalProfile: "Profilo Medico",
    doctors: "Medici",
    academy: "Accademia",
    missions: "Missioni",
    biologistPortal: "Portale Biologo",
    photos: "Foto",
    batchUpload: "Upload batch",
    species: "Specie",
    myAssociation: "La Mia Associazione",
    events: "Eventi",
    certifications: "Certificazioni",
    healthSafety: "Salute & Sicurezza",
    photoCorrection: "Correzione foto",
    manual: "Manuale d'uso",
    logbookSubCount: "{{count}} immersioni registrate",
    logbookSubEmpty: "Registra la prima immersione",
    logbookSubCountShort: "{{count}} immersioni",
    apnea: "Allenamento apnea",
    apneaSub: "Respirazione, tabelle CO₂/O₂, statica",
    logbookSubMine: "Le tue immersioni",
    logbookSubData: "Dati e immersioni",
    logbookSubStart: "Inizia il tuo logbook",
    sitesSub: "Esplora siti di immersione",
    calendarSubEvents: "I tuoi eventi e appuntamenti",
    calendarSubSessions: "Sessioni e disponibilità",
    calendarSubShifts: "Pianificazione e turni",
    calendarSubVisits: "Le tue visite e appuntamenti",
    calendarSubLessons: "Lezioni, sessioni e missioni",
    planningSub: "Gas, deco e profili immersione",
    diving: "Diving",
    photography: "Fotografia",
    photographySub: "Foto subacquee e correzione",
    divingSub: "Logbook, siti e pianificazione",
    services: "Servizi",
    servicesSub: "Ambasciate, ospedali, noleggi, campeggi…",
    communitySub: "Social, buddy finder e chat",
    communitySubConnect: "Connettiti con la community",
    communitySubNetwork: "Network subacqueo",
    healthSub: "Salute, emergenze e sicurezza",
    safetySub: "Check-in, emergenze, incidenti",
    trainingSub: "Corsi, lezioni e brevetti",
    diariesSub: "Racconta le tue avventure",
    diariesSubShort: "Racconta le avventure",
    centersSub: "Diving center e prenotazioni",
    biologySubDiver: "Specie, missioni e ricerca",
    biologySubMeasure: "Specie, misure, ecosistemi",
    librarySub: "Le tue foto subacquee",
    tourismSubDiver: "Destinazioni e mete sub",
    tourismSubDest: "Destinazioni e mete",
    assocSubCount: "{{count}} tessere attive",
    assocSubEmpty: "Club e associazioni sub",
    marketplaceSub: "Compra e vendi attrezzatura",
    shopSub: "Gadget e merchandising",
    newsSub: "News dal mondo subacqueo",
    panelSub: "Il tuo profilo professionale",
    coursesSubTeaching: "Attività didattica",
    coursesSubCatalog: "Catalogo corsi disponibili",
    sportCenterSub: "Il tuo centro sportivo",
    certsSubMaintain: "Mantieni le qualifiche",
    certsSubMine: "Le tue qualifiche",
    centerSubOps: "Dashboard operativa",
    bookingsSubManage: "Gestisci le prenotazioni",
    bookingsSubClients: "Prenotazioni clienti",
    customersSubDir: "Directory clienti",
    staffSubManage: "Gestisci il personale",
    complianceSub: "Conformità normativa L.70",
    authorizationsSub: "Autorizzazioni immersione (PDF)",
    agencySub: "Dashboard agenzia viaggio",
    packagesSub: "Offerte e pacchetti dive",
    medicalAreaSub: "Certificati e visite",
    doctorPortalSub: "Pazienti e referti",
    medicalProfileSub: "Il tuo profilo sanitario",
    doctorsSubFind: "Trova medici specializzati",
    academySub: "Dashboard corsi e certificazioni",
    missionsSub: "Centro ricerche marine",
    biologistPortalSub: "Strumenti per biologi marini",
    photosSub: "Carica e gestisci foto",
    batchUploadSub: "Caricamento batch specie",
    speciesSub: "Catalogo specie marine",
    myAssociationSub: "Gestisci l'associazione",
    eventsSub: "Organizza e partecipa",
    certificationsSubMembers: "Qualifiche dei soci",
    photoCorrectionSub: "Migliora foto e video subacquei",
    manualSub: "Guida operativa del tuo ruolo (PDF)",
  },
  common: {
    copyManual: "Copia non riuscita: seleziona il testo e copialo a mano.",
    learnMore: "Approfondisci →",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    create: "Crea",
    search: "Cerca",
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    confirm: "Conferma",
    back: "Indietro",
    next: "Avanti",
    submit: "Invia",
    close: "Chiudi",
    view: "Visualizza",
    download: "Scarica",
    upload: "Carica",
    noData: "Nessun dato disponibile",
    required: "Campo obbligatorio",
    actions: "Azioni",
    deleted: "Eliminato con successo",
    title: "Titolo",
    status: "Stato",
    notes: "Note",
    remove: "Rimuovi",
    optional: "opzionale",
    previous: "Precedente",
    pageOf: "Pagina {{page}} di {{pages}}",
    saveError: "Errore nel salvataggio. Riprova.",
    apply: "Applica",
    expand: "espandi",
    accept: "Accetta",
    reject: "Rifiuta",
    saved: "Salvato",
    noResults: "Nessun risultato",
    register: "Registrati",
    deleting: "Eliminazione…",
    description: "Descrizione",
    done: "Fatto",
    filter: "Filtra",
    manage: "Gestisci",
    reset: "Reimposta",
    revoke: "Revoca",
    saving: "Salvataggio…",
    add: "Aggiungi",
  },
  auth: {
    login: "Accedi",
    logout: "Esci",
    register: "Registrati",
    email: "Email",
    password: "Password",
    confirmPassword: "Conferma Password",
    firstName: "Nome",
    lastName: "Cognome",
    forgotPassword: "Password dimenticata?",
    noAccount: "Non hai un account?",
    hasAccount: "Hai già un account?",
    loginSuccess: "Accesso effettuato con successo",
    registerSuccess: "Registrazione completata",
    logoutSuccess: "Disconnessione effettuata",
    invalidCredentials: "Credenziali non valide",
    redirecting: "Reindirizzamento…",
    orContinueWith: "oppure continua con",
    continueWithGoogle: "Continua con Google",
    continueWithMetaMask: "Continua con MetaMask",
    emailNotVerified: "Devi verificare la tua email prima di accedere. Controlla la casella di posta.",
    verifyEmailTitle: "Controlla la tua email",
    verifyEmailSentTo: "Abbiamo inviato un link di verifica a",
    verifyEmailInstructions: "Clicca il link nell'email per attivare il tuo account e accedere.",
    verifyEmailCheckSpam: "Email non arrivata?",
    verifyEmailSpamNote: "Controlla la cartella spam. L'email viene inviata da noreply@edive.tech.",
    verifyEmailExpiry: "Il link scade dopo 24 ore.",
    goToLogin: "Vai al login",
    openInMetaMask: "Apri in MetaMask",
    metamaskNotFound: "MetaMask non trovato. Installa l'estensione MetaMask.",
    metamaskRejected: "Firma rifiutata.",
    metamaskError: "Accesso con MetaMask fallito. Riprova.",
    connecting: "Connessione…",
    emailPlaceholder: "nome@email.com",
    socialLoginError: "Errore avvio accesso social. Riprova.",
    passwordRequired: "Password obbligatoria",
    tagline: "La piattaforma digitale per il mondo delle immersioni",
    mobilePhone: "Cellulare",
    dateOfBirth: "Data di nascita",
    mobilePhoneInvalid: "Inserisci un numero di cellulare valido",
    dateOfBirthRequired: "La data di nascita è obbligatoria",
    dateOfBirthInvalid: "Data non valida",
    consentRequired: "Consenso obbligatorio mancante",
    fillRequiredFields: "Compila tutti i campi obbligatori prima di continuare.",
    consentTermsRequired: "Devi accettare i Termini di Servizio per continuare",
    consentPersonalDataRequired: "Il consenso al trattamento dei dati personali è obbligatorio",
    orgTypeRequired: "Seleziona il tipo di organizzazione",
    gdprTitle: "I tuoi dati, la tua esperienza",
    gdprBody: "Bastano pochi dati per iniziare: nome, email e password. Il resto del profilo (telefono, data di nascita, brevetti) lo completi dopo, quando vuoi, per avere promemoria sulle scadenze e prenotazioni più rapide.",
    gdprCompliance: "eDive è GDPR compliant by design. In qualsiasi momento puoi accedere a tutti i tuoi dati, modificarli o cancellarli definitivamente in autonomia dalla sezione Profilo → Privacy & Dati — senza dover contattare nessuno.",
    invitedByCommunity: "Sei stato invitato da un membro della community eDive!",
    isOrgLabel: "Registro un'organizzazione o sono un professionista medico",
    orgTypeSelectPlaceholder: "Seleziona tipo...",
    referralCodeLabel: "Codice referral",
    optional: "opzionale",
    recommended: "consigliato",
    referralCodeApplied: "Codice applicato",
    termsOfService: "Termini di Servizio",
    privacyPolicy: "Privacy Policy",
    consentTermsText: "Ho letto e accetto i",
    consentTermsAnd: "e la",
    consentPersonalDataText: "Autorizzo il trattamento dei miei dati personali (nome, cognome, data di nascita, cellulare) da parte di eDive per l'erogazione dei servizi della piattaforma, ai sensi dell'",
    consentAdminAccessText: "Autorizzo gli amministratori di eDive ad accedere ai miei dati personali (nome, cognome, email, telefono) per la verifica dell'identità (KYC) e la gestione dell'account ai sensi dell'art. 6.1(a) GDPR.",
    consentMarketingText: "Desidero ricevere newsletter, offerte e aggiornamenti della community eDive.",
    emailAlreadyExists: "Questa email è già registrata. Prova ad accedere o usa \"Password dimenticata\".",
    invalidData: "Dati non validi. Controlla i campi e riprova.",
    invalidRequest: "Richiesta non valida. Verifica i dati inseriti.",
    noInternet: "Nessuna connessione a Internet. Controlla la rete e riprova.",
    registrationFailed: "Errore durante la registrazione. Riprova tra qualche secondo.",
    rolesTitle: "Profili aggiuntivi",
    rolesSubtitle: "Vuoi richiedere ruoli aggiuntivi? Le richieste verranno esaminate dagli amministratori e sarai notificato via email.",
    diverChoiceTitle: "Sei un subacqueo?",
    diverChoiceSubtitle: "Scegli come iniziare. Potrai sempre cambiare in seguito.",
    diverChoiceDiver: "Sì, sono un subacqueo",
    diverChoiceDiverDesc: "Registra immersioni, brevetti e abilita le funzioni da sub.",
    diverChoiceNonDiver: "Non sono (ancora) un subacqueo",
    diverChoiceNonDiverDesc: "Esplora la community, i centri e i corsi. Diventerai subacqueo quando vuoi.",
    diverChoiceLaterNote: "Brevetti, didattica e ruoli professionali (istruttore, divemaster, medico…) si aggiungono dopo, dal tuo profilo: abiliteranno automaticamente le funzioni del tuo livello.",
    diverChoiceContinue: "Continua",
    rolesApprovalTitle: "Come funziona l'approvazione?",
    rolesApprovalWithKyc: "Con KYC completato (documento d'identità verificato): l'approvazione è automatica in pochi minuti.",
    rolesApprovalWithoutKyc: "Senza KYC: la richiesta viene esaminata manualmente. Riceverai un contatto dall'amministratore entro 48 ore.",
    rolesAccessNote: "Puoi comunque accedere alla piattaforma come Subacqueo da subito e richiedere altri ruoli in qualsiasi momento dal tuo profilo.",
    submitWithRoles: "Invia richiesta e accedi",
    submitNoRoles: "Accedi senza richieste aggiuntive",
    roleInstructor: "Istruttore",
    roleInstructorDesc: "Abilita la gestione di corsi e allievi",
    roleDivemaster: "Divemaster",
    roleDivemasterDesc: "Guida immersioni, gestione dive log avanzato",
    roleDiveDoctorName: "Medico Subacqueo",
    roleDiveDoctorDesc: "Certificazioni mediche e idoneità",
    roleDiveCenterName: "Centro Diving",
    roleDiveCenterDesc: "Gestione centro, prenotazioni, staff",
    roleTravelAgencyName: "Agenzia Viaggi",
    roleTravelAgencyDesc: "Pacchetti viaggio subacquei",
    roleAssociationName: "Associazione",
    roleAssociationDesc: "Gestione associazione e soci",
    roleAcademyName: "Accademia",
    roleAcademyDesc: "Formazione e programmi di certificazione",
    orgTypeDiveDoctor: "Medico Subacqueo",
    orgTypeDiveCenter: "Centro Diving",
    orgTypeTravelAgency: "Agenzia Viaggi",
    orgTypeAssociation: "Associazione",
    orgTypeAcademy: "Accademia",
    resetEmailSent: "Email inviata!",
    resetEmailDesc: "Se l\\",
    resetEmailDesc2: "è registrato su eDive, riceverai un link per reimpostare la password entro pochi minuti.",
    resetEmailSpam: "Controlla anche la cartella spam.",
    backToLogin: "Torna al login",
    resendEmail: "Invia di nuovo",
    forgotPasswordDesc: "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
    sendResetLink: "Invia link di recupero",
    rememberPassword: "Ti sei ricordato la password?",
    emailOrPhone: "Email o Cellulare",
    emailOrPhonePlaceholder: "email@esempio.com o +39333...",
    passwordResetSuccess: "Password aggiornata!",
    passwordResetError: "Errore nel reset. Riprova.",
    resetLinkInvalid: "Link non valido o scaduto",
    resetLinkExpiredDesc: "Il link per il reset della password è scaduto o non è corretto. I link sono validi per 1 ora.",
    requestNewLink: "Richiedi un nuovo link",
    passwordUpdated: "Password aggiornata!",
    passwordUpdatedDesc: "La tua password è stata reimpostata con successo. Ora puoi accedere con la nuova password.",
    resetPassword: "Nuova password",
    resetPasswordDesc: "Scegli una password sicura per il tuo account eDive.",
    newPassword: "Nuova password",
    setNewPassword: "Imposta nuova password",
    consentAdminAccessRequired: "Il consenso all'accesso amministrativo per la verifica dell'identità è obbligatorio",
    consentMarketingRequired: "Il consenso alle comunicazioni è obbligatorio",
    invalidMfaCode: "Codice non valido",
    mfaBack: "Torna indietro",
    mfaCode: "Codice di verifica",
    mfaCodePlaceholder: "123456 oppure xxxx-xxxx-xx",
    mfaEmailPrompt: "Abbiamo inviato un codice alla tua email. Inseriscilo qui sotto.",
    mfaTotpPrompt: "Inserisci il codice dalla tua app di autenticazione, oppure un recovery code.",
    verify: "Verifica",
    verifyEmailResend: "Non hai ricevuto l'email? Reinvia",
    verifyEmailResendError: "Non è stato possibile reinviare l'email. Riprova tra qualche minuto.",
    verifyEmailResent: "Email di verifica inviata di nuovo.",
  },
  nav: {
    dashboard: "Dashboard",
    logbook: "Diario Immersioni",
    divesites: "Siti di Immersione",
    courses: "Corsi",
    planning: "Pianificazione",
    social: "Social",
    events: "Eventi",
    chat: "Messaggi",
    media: "Media",
    bookings: "Prenotazioni",
    insurance: "Assicurazione",
    qa: "Forum Q&A",
    medical: "Cartelle Cliniche",
    admin: "Amministrazione",
    profile: "Profilo",
    divecenter: "Centro Diving",
    trips: "Viaggi",
    equipment: "Attrezzatura",
    instructors: "Istruttori",
    calendar: "Calendario",
    marketplace: "Marketplace",
    merch: "Shop eDive",
    students: "Studenti",
    divers: "Subacquei",
    reports: "Report",
    content: "Contenuti",
    associations: "Associazioni",
    tourism: "Viaggi & Pacchetti",
    ai: "AI Assistant",
    safety: "Sicurezza",
    species: "Fauna",
    instructor: "Dashboard Istruttore",
    compliance: "Compliance",
    hr: "Staff",
    myCourses: "I Miei Corsi",
    myCertifications: "I Miei Brevetti",
    myStaffRequests: "Inviti Staff",
    jobs: "Bacheca Lavoro",
    community: "Community",
    glossary: "Glossario",
    notifications: "Notifiche",
    "group.dives": "Immersioni",
    "group.training": "Formazione",
    "group.agenda": "Agenda",
    "group.services": "Servizi",
    "group.teaching": "Insegnamento",
    "group.guiding": "Guida Sub",
    "group.medical": "Medicina",
    "group.content": "Contenuti",
    "group.tools": "Strumenti",
    "group.association": "Associazione",
    "group.discovery": "Esplora",
    "group.academy": "Accademia",
    "group.biology": "Biologia Marina",
    "group.center": "Centro Diving",
    "group.photographer": "Fotografo Subacqueo",
    "group.admin": "Amministrazione",
    "group.config": "Configurazione",
    "group.agency": "Agenzia Viaggi",
    "group.apnea": "Apnea & Freediving",
    "group.ai": "AI & Automazione",
    "group.crmMarketing": "CRM & Marketing",
    recommendedSites: "Siti Consigliati",
    wishlist: "Wishlist siti",
    nearMe: "Vicino a me",
    divingCenter: "Diving Center",
    pools: "Piscine & Pool",
    diveAuthorization: "Autorizzazione pre-immersione",
    medcerts: "Certificati medici",
    safetyCheckin: "Check-in immersione",
    privateLessons: "Lezioni private",
    findInstructor: "Trova istruttore",
    scienceMissions: "Missioni scientifiche",
    excursions: "Escursioni",
    boats: "Imbarcazioni",
    equipmentMaintenance: "Manutenzione Attrezzatura",
    travelDiaries: "Diari di viaggio",
    leaderboard: "Classifica",
    buddySuggested: "Buddy suggeriti",
    diveSquads: "Dive Squads",
    proDirectory: "Directory Professionisti",
    dataLab: "Data Lab",
    devPortal: "Developer Portal",
    medicalPortal: "Portale Medico",
    medicalTools: "Strumenti Medico",
    medicalProfile: "Profilo & Valutazioni",
    associationDashboard: "Dashboard Associazione",
    members: "Soci",
    sportCenter: "Centro sportivo",
    speciesPortal: "Portale Proposte Specie",
    speciesEditor: "Editor Schede Specie",
    scientificMediaGallery: "Galleria Media Scientifica",
    manuals: "Manuali",
    citizenScienceDashboard: "Dashboard Citizen Science",
    monitoringMissions: "Missioni di Monitoraggio",
    environmentalAlerts: "Allerte Ambientali",
    instructorDirectory: "Directory Istruttori",
    courseManagement: "Gestione Corsi",
    userManagement: "Gestione Utenti",
    speciesSync: "Enciclopedia & Sync",
    marketing: "Marketing",
    roleRequests: "Richieste Ruolo",
    certVerifications: "Verifica Brevetti",
    divePromotions: "Promozioni Diving",
    adminMerch: "Ordini Shop",
    adminEquipment: "Catalogo Attrezzatura",
    emailDashboard: "Email Dashboard",
    divingCenters: "Diving Centers",
    dataLabLicenses: "Data Lab Licenze",
    communityChallenges: "Sfide Community",
    statistics: "Statistiche",
    analytics: "Analytics",
    settings: "Impostazioni",
    aiTools: "Strumenti AI",
    aiChat: "Chat con l'AI",
    photoContribute: "Contribuisci foto specie",
    marineEncyclopedia: "Enciclopedia marina",
    agencyDashboard: "Dashboard Agenzia",
    travelPackages: "Pacchetti Viaggio",
    apneaDashboard: "Dashboard apnea",
    tripReport: "Resoconto viaggio",
    compareDives: "Confronta immersioni",
    aiProfile: "Profilo AI",
    goals: "Obiettivi",
    importDives: "Importa dal computer",
    diveComputers: "Computer subacquei",
    pssExams: "Esami PSS",
    pssManagement: "Gestione PSS",
    pssQuestions: "Domande PSS",
    findDoctor: "Trova Medico",
    emergencyQr: "QR Emergenza",
    challengesBadges: "Sfide & Badge",
    aiBriefing: "Briefing AI",
    gasPlanner: "Gas Planner",
    certWallet: "Wallet certificazioni",
    myGear: "La mia attrezzatura",
    equipmentCatalogue: "Catalogo attrezzatura",
    bioCenterHub: "Hub Centro",
    aiIdentifier: "Identificatore IA",
    analysisStats: "Analisi & Statistiche",
    taxonomy: "Esplora Tassonomia",
    aiAssistant: "Assistente IA",
    fieldJournal: "Diario di Campo",
    conservationReport: "Report Conservazione",
    missionsDashboard: "Dashboard missioni",
    academyDashboard: "Dashboard Academy",
    myProductivity: "La mia produttività",
    mailClient: "Client Mail",
    newsEditor: "Redazione News",
    medicalRecord: "Fascicolo Sanitario",
    searchPlaceholder: "Cerca siti, subacquei...",
    crmDashboard: "Dashboard CRM",
    crmContacts: "Contatti CRM",
    crmImportMap: "Importa da mappa",
    crmEnrich: "Arricchimento web",
    crmAgenda: "Agenda CRM",
    crmTodos: "Todo CRM",
    "group.traccia": "Tengo il logbook",
    "group.esplora": "Esploro nuovi posti",
    "group.impara": "Mi alleno e studio",
    "group.sicuro": "Rimango in sicurezza",
    "group.connetto": "Mi connetto con altri",
    "group.gestisco": "Organizzo la logistica",
    "group.lavoro": "Gestisco un'attività",
    "group.proteggo": "Proteggo l'oceano",
    "group.crm": "CRM",
    "group.mail": "Mail",
    "group.directory": "Directory",
    "group.formazione": "Formazione",
    analyticsStats: "Statistiche & Analytics",
    medSites: "Siti Mediterraneo",
    dirDivingCenters: "Diving Center",
    dirInstructors: "Istruttori",
    dirDoctors: "Medici Subacquei",
    dirHospitals: "Ospedali & Cliniche",
    dirResearchCenters: "Centri di Ricerca",
    dirPools: "Piscine per Immersioni",
    dirCarRentals: "Noleggio Auto",
    dirBoatRentals: "Noleggio Barca",
    contact: "Contatti",
    achievements: "Traguardi",
    loyalty: "Punti fedeltà",
    referral: "Invita amici",
    install: "Installa App",
    wallet: "Wallet",
    subscription: "Abbonamento",
    checkinQr: "QR Check-in",
    medicalHistory: "Storico Medico",
    privacy: "Privacy",
    dcBookings: "Lead & Prenotazioni",
    dcCustomers: "Clienti & Documenti",
    dcCalendar: "Calendario Uscite",
    operations: "Operatività",
    rental: "Noleggio",
    shifts: "Turni Staff",
    briefings: "Briefing",
    invoices: "Fatture",
    pricing: "Prezzi Dinamici",
    dcPanel: "Centro Diving",
    dcSubtitle: "Gestione Operativa Completa",
    "group.myLogbook": "Logbook",
    "group.explore": "Esplora",
    "group.plan": "Pianifica",
    "group.community": "Comunità",
    "group.mySafety": "Sicurezza",
    "group.myProfile": "Il mio Profilo",
    "group.myCenter": "Il mio Centro",
    "group.clientsBookings": "Clienti & Prenotazioni",
    "group.staffDC": "Staff & Turni",
    "group.coursesDC": "Corsi & Formazione",
    "group.statsDC": "Operatività & Report",
    "group.doctor": "Attività Medica",
    "group.agencyWork": "La mia Agenzia",
    "group.research": "Ricerca & Biologia",
    "group.photography": "Fotografia Subacquea",
    "group.charter": "Charter Subacqueo",
    peerCompare: "Con un altro diver",
    more: "Altro",
  },
  cookies: {
    title: "Utilizziamo i cookie",
    desc: "Usiamo cookie tecnici (necessari) e cookie analitici per migliorare l'esperienza. Nessun dato viene venduto a terzi.",
    customize: "Personalizza",
    acceptNecessary: "Solo necessari",
    acceptAll: "Accetta tutti",
    savePreferences: "Salva preferenze",
    preferences: "Preferenze cookie",
    necessary: "Cookie tecnici",
    necessaryDesc: "Necessari per il funzionamento del sito. Non possono essere disattivati.",
    functional: "Cookie funzionali",
    functionalDesc: "Ricordano le tue preferenze (lingua, tema) tra le sessioni.",
    analytics: "Cookie analitici",
    analyticsDesc: "Ci aiutano a capire come usi l'app (dati pseudonimizzati, mai venduti).",
    marketing: "Cookie di marketing",
    marketingDesc: "Comunicazioni personalizzate su corsi, offerte e novità della community.",
  },
  notifications: {
    title: "Notifiche",
    markAllRead: "Segna tutte come lette",
    allRead: "Tutte le notifiche segnate come lette",
    noNotifications: "Nessuna notifica",
    noNotificationsDesc: "Sei aggiornato!",
    empty: "Nessuna notifica",
    noUnread: "Nessuna notifica non letta",
    filterAll: "Tutte",
    filterUnread: "Non lette",
    loadMore: "Carica altre",
    justNow: "Adesso",
    minutesAgo: "{{n}} min fa",
    hoursAgo: "{{n}}h fa",
    daysAgo: "{{n}}g fa",
    timeAgo: {
      now: "Adesso",
      minutesAgo: "{{n}} min fa",
      hoursAgo: "{{n}}h fa",
      daysAgo: "{{n}}g fa",
    },
  },
  dashboard: {
    welcome: "Benvenuto",
    totalDives: "Immersioni Totali",
    lastDive: "Ultima Immersione",
    totalDepth: "Profondità Massima",
    diveHours: "Ore Sott'acqua",
    recentActivity: "Attività Recente",
    quickLogCta: "Log rapido",
    quickActions: "Azioni Rapide",
    newDive: "Nuova Immersione",
    noRecentActivity: "Il tuo diario di bordo è pronto: la tua prima avventura ti aspetta.",
    aiProfile: "Analisi AI profilo",
    aiAnalyzing: "Analisi…",
    aiRefresh: "Aggiorna",
    aiAnalyze: "Analizza",
    aiDescription: "Analisi AI basata sulle tue immersioni recenti",
    aiStart: "Avvia analisi",
    aiUnavailable: "Analisi non disponibile. Riprova più tardi.",
    maxDepth: "Profondità max",
    uniqueSites: "Siti visitati",
    achievements: "Traguardi",
    weeklyStreak: "Streak settimanale",
    observedSpecies: "Specie osservate",
    travelDiaries: "Diari di viaggio",
    patients: "Pazienti",
    academySessions: "Sessioni",
    researchMissions: "Missioni",
    sectionWhat: "Cosa vuoi fare?",
    sectionExplore: "Esplora le funzionalità",
    sectionActivity: "La tua attività",
    seeAll: "Tutte",
    registerFirstDive: "Registra la prima",
    equipmentAlert_one: "1 attrezzatura richiede manutenzione",
    equipmentAlert_other: "{{count}} attrezzature richiedono manutenzione",
    manageLink: "Gestisci →",
    completeProfileTitle: "Completa il tuo profilo",
    profileProgress: "{{done}} di {{total}} completati",
    checkAvatar: "Foto profilo",
    checkName: "Nome e cognome",
    checkCity: "Città",
    checkBio: "Bio",
    checkPhone: "Telefono",
    checkFirstDive: "Prima immersione",
    activityHeatmap: "Attività immersioni",
    heatmapSubtitle_one: "1 immersione nell'ultimo anno",
    heatmapSubtitle_other: "{{count}} immersioni nell'ultimo anno",
    heatmapLess: "Meno",
    heatmapMore: "Più",
    heatmapDive_one: "1 immersione",
    heatmapDive_other: "{{count}} immersioni",
    dayAbbr: {
      sun: "D",
      mon: "L",
      tue: "M",
      wed: "M",
      thu: "G",
      fri: "V",
      sat: "S",
    },
    onboardingTitle: "Configura il tuo profilo",
    onboardingDesc: "Ci vogliono 2 minuti — aggiungi brevetti, obiettivi e foto.",
    onboardingBtn: "Configura",
    onboardingLater: "Dopo",
    actionRegister: "Registra",
    actionPlan: "Pianifica",
    actionFindBuddy: "Trova buddy",
    actionDiary: "Diario",
    actionApnea: "Apnea",
    actionConfigProfile: "Configura profilo",
    actionPanel: "Pannello",
    actionMyCourses: "I miei corsi",
    actionCalendar: "Calendario",
    actionProductivity: "Produttività",
    actionLogbook: "Logbook",
    actionDCDashboard: "Dashboard centro",
    actionBookings: "Prenotazioni",
    actionCustomers: "Clienti",
    actionConfigCenter: "Configura centro",
    actionDoctorArea: "Area medico",
    actionDirectory: "Directory",
    actionDocumentation: "Documentazione",
    actionConfigAgency: "Configura agenzia",
    actionAgencyDashboard: "Dashboard agenzia",
    actionPackages: "Pacchetti",
    actionConfigAcademy: "Configura academy",
    actionAcademyDashboard: "Dashboard",
    actionMyFacility: "La mia struttura",
    actionCourses: "Corsi",
    actionResearchAccess: "Accesso ricerca",
    actionMissions: "Missioni",
    actionSpeciesDashboard: "Dashboard specie",
    actionEnvAlerts: "Alert ambientali",
    actionUploadPhoto: "Carica foto",
    actionUploadBulk: "Carica in massa",
    actionEncyclopedia: "Enciclopedia",
    actionCreateAssociation: "Crea associazione",
    actionMyAssociation: "La mia associazione",
    actionCommunity: "Community",
    actionEvents: "Eventi",
    descRegisterDive: "Aggiungi un'immersione",
    descPlanOuting: "Organizza la prossima uscita",
    descFindBuddyDiver: "AI match con altri subacquei",
    descFindBuddyApnea: "AI match con altri apneisti",
    descDiaryWrite: "Racconta il tuo viaggio",
    descApneaSession: "Sessione di allenamento",
    descConfigInstructor: "Agenzie, specialità, tariffe",
    descConfigDivemaster: "Esperienza e specialità",
    descConfigDoctor: "Licenza, specializzazioni",
    descConfigPhotographer: "Portfolio e attrezzatura",
    descInstructorPanel: "Corsi, alunni, calendario",
    descDivemasterPanel: "Attività e briefing",
    descActiveCourses: "Corsi attivi",
    descCalendar: "Prossime lezioni",
    descProductivity: "Report e statistiche",
    descLogbook: "Registro immersioni",
    descDCDashboard: "Panoramica attività",
    descBookings: "Gestisci le prenotazioni",
    descCustomers: "Anagrafica e storico",
    descConfigCenter: "Setup guidato del profilo",
    descDoctorArea: "Pazienti e idoneità",
    descDirectory: "Il tuo profilo pubblico",
    descDocumentation: "Certificati e referti",
    descConfigAgency: "Setup guidato in 4 passi",
    descAgencyDashboard: "Panoramica attività",
    descPackages: "Viaggi e pacchetti",
    descConfigAcademy: "Setup struttura guidato",
    descAcademyDashboard: "Sessioni e istruttori",
    descMyFacility: "Vasca e attrezzatura",
    descCoursesCatalog: "Catalogo e iscrizioni",
    descResearchAccess: "Attiva le funzionalità avanzate",
    descMissions: "Gestisci le missioni",
    descSpeciesDashboard: "Citizen science",
    descEnvAlerts: "Monitoraggio attivo",
    descUploadPhoto: "Caricamento singolo",
    descUploadBulk: "Fino a 100 immagini",
    descEncyclopedia: "Sfoglia le specie marine",
    descCreateAssociation: "Setup guidato in 3 passi",
    descMyAssociation: "Gestisci soci ed eventi",
    descCommunity: "Feed e notizie",
    descEvents: "Organizza e promuovi",
    featDiaryTrip: "Diario viaggio",
    featHealth: "Salute",
    featNews: "Notizie",
    featAICoach: "AI Coach",
    featMyGear: "Il mio gear",
    featCertWallet: "Cert Wallet",
    featDiveCenter: "Dive Center",
    featRental: "Noleggio",
    featShifts: "Turni",
    featMaintenance: "Manutenzione",
    featConfigure: "Configura",
    featCertifications: "Certificazioni",
    featEquipment: "Attrezzatura",
    badgeSingle: "Singolo",
    badgeNew: "NUOVO",
    dive: "Immersione",
    equipmentAlert: "{{count}} attrezzature richiedono attenzione",
  },
  newsCarousel: {
    sectionTitle: "Notizie dal mondo subacqueo",
    updated: "Aggiornato",
    readArticle: "Leggi articolo",
    justNow: "Ora",
    hoursAgo: "{{n}}h fa",
    daysAgo: "{{n}}g fa",
    categories: {
      news: "News",
      safety: "Sicurezza",
      science: "Scienza",
      magazine: "Magazine",
      freediving: "Freediving",
    },
  },
  logbook: {
    title: "Diario Immersioni",
    newDive: "Nuova Immersione",
    trip: {
      styles: {
        narrative: { label: "Narrativo", desc: "Racconto coinvolgente del viaggio" },
        technical: { label: "Tecnico",   desc: "Dati, profondità, profili e analisi" },
        social:    { label: "Social",    desc: "Post pronto per Instagram e blog" },
      },
    },
    detail: {
      collegata_al_piano: 'Collegata al piano',
      collegamento_non_riuscito: 'Collegamento non riuscito',
      questa_immersione_corrisponde_a_un_piano: 'Questa immersione corrisponde a un piano?',
      affinita: 'affinità',
      collega_al_piano: 'Collega al piano',
      collegata_alla_pianificazione: 'Collegata alla pianificazione',
      collegamento_rimosso: 'Collegamento rimosso',
      scollega: 'Scollega',
      collega_a_una_pianificazione_salvata: 'Collega a una pianificazione salvata',
      scegli_una_pianificazione: 'Scegli una pianificazione',
      nessuna_pianificazione_salvata_disponibi: 'Nessuna pianificazione salvata disponibile.',
      senza_data: 'senza data',
      collega: 'Collega',
      chiudi: 'Chiudi',
      errore_generazione_pdf: 'Errore generazione PDF',
      massimo_5_immersioni_in_evidenza: 'Massimo 5 immersioni in evidenza',
      rimossa_dagli_highlights: 'Rimossa dagli highlights',
      aggiunta_agli_highlights: 'Aggiunta agli highlights',
      contrassegnata_come_immersione_professio: 'Contrassegnata come immersione professionale',
      contrassegno_professionale_rimosso: 'Contrassegno professionale rimosso',
      errore_aggiornamento: 'Errore aggiornamento',
      caricamento_immersione: 'Caricamento immersione...',
      immersione_non_trovata: 'Immersione non trovata.',
      torna_al_logbook: '← Torna al logbook',
      indietro: 'Indietro',
      dettaglio_immersione: 'Dettaglio immersione',
      rimuovi_dagli_highlights: 'Rimuovi dagli highlights',
      aggiungi_agli_highlights: 'Aggiungi agli highlights',
      esporta_immersione: 'Esporta immersione',
      esporta: 'Esporta',
      dan_dl7_dona_limmersione_alla_ricerca: 'DAN DL7 — dona l\'immersione alla ricerca',
      rimuovi_contrassegno_professionale_l9202: 'Rimuovi contrassegno professionale (L.9/2026)',
      segna_come_immersione_professionale_l920: 'Segna come immersione professionale (L.9/2026)',
      condividi_immersione: 'Condividi immersione',
      condividi: 'Condividi',
      modifica_immersione: 'Modifica immersione',
    },
    // DV-11: label dei tab del dettaglio immersione. Prima erano hardcoded
    // in it/en nel componente; ora passano da qui, tradotte nelle 14 lingue.
    tabs: {
      overview: "Panoramica",
      stats: "Statistiche",
      decompression: "Decompressione",
      tissues: "Tessuti",
      whatif: "What-If",
      alerts: "Avvisi",
      species: "Specie",
      media: "Foto & Video",
      map: "Mappa",
      validation: "Convalida",
      debrief: "Debrief AI",
    },
    // DV-11 sweep onda 2: label dello ShareModal (dettaglio immersione).
    // Prima erano hardcoded in IT/EN tramite helper L(it,en); ora qui, usate
    // da t() con defaultValue per retro-compatibilita' sulle lingue nuove.
    share: {
      title: "Condividi immersione",
      defaultContent: "Ho appena registrato un'immersione! 🤿",
      defaultContentWithSite: "Ho appena registrato un'immersione a {{site}}! 🤿",
      publicLinkHelp: "Link pubblico — visibile a chiunque",
      enableLinkPlaceholder: "Abilita link per condividere",
      copy: "Copia",
      copied: "Copiato!",
      enableAndCopy: "Abilita e copia",
      removePublicLink: "Rimuovi link pubblico",
      tokenLinkHelp: "Link privato con token — non indicizza il tuo profilo",
      generateTokenPlaceholder: "Genera un link privato…",
      generate: "Genera",
      revokeLink: "Revoca link",
      orPostToFeed: "oppure pubblica nel feed",
      contentPlaceholder: "Cosa vuoi condividere?",
      privacyPublic: "🌐 Pubblico",
      privacyFriends: "👥 Amici",
      share: "Condividi",
      sharing: "Condivisione...",
      sharedFeed: "Condiviso nel feed!",
      errShare: "Errore nella condivisione",
      errGenerate: "Errore nella generazione del link",
      linkRevoked: "Link revocato",
    },
    date: "Data",
    site: "Sito",
    depth: "Profondità (m)",
    duration: "Durata (min)",
    temperature: "Temperatura (°C)",
    type: "Tipo",
    privacy: "Privacy",
    notes: "Note",
    buddy: "Buddy",
    gas: "Miscela Gas",
    visibility: "Visibilità (m)",
    current: "Corrente",
    diveTypes: {
      RECREATIONAL: "Ricreativo",
      TECHNICAL: "Tecnico",
      CCR: "Rebreather",
      SIDEMOUNT: "Sidemount",
    },
    privacyOptions: {
      PRIVATE: "Privato",
      FRIENDS: "Amici",
      PUBLIC: "Pubblico",
    },
    currentOptions: {
      NONE: "Nessuna",
      LIGHT: "Leggera",
      MODERATE: "Moderata",
      STRONG: "Forte",
    },
    saved: "Immersione salvata con successo",
    deleted: "Immersione eliminata",
    colDate: "Data",
    colSite: "Sito immersione",
    colDepth: "Profondità",
    colDuration: "Durata",
    colType: "Tipo",
    colCenter: "Diving center",
    colActions: "Azioni",
    details: "Dettagli",
    delete: "Elimina",
    confirmDelete: "Eliminare questa immersione?",
    divesites: {
      visibilityOptions: {
        POOR: "Scarsa",
        LIMITED: "Limitata",
        GOOD: "Buona",
        EXCELLENT: "Ottima",
      },
      entryTypes: {
        SHORE: "Da riva",
        BOAT: "Da barca",
        LIVEABOARD: "Liveaboard",
        ICE: "Sotto il ghiaccio",
      },
    },
    certifiedTooltip: "Certificata da un diving center",
    certifiedNoDelete: "Immersione certificata da un diving center: non eliminabile",
    deleteCertifiedBlocked: "Immersione certificata da {{center}}: non può essere eliminata.",
    aCenter: "un diving center",
    deleteError: "Errore durante l'eliminazione",
    oauthDisconnected: "{{provider}} disconnesso",
    photoUploaded: "{{name}} caricata",
    photoUploadError: "Errore caricamento {{name}}",
    oauthConnected_one: "{{provider}} collegato — importata {{count}} immersione",
    oauthConnected_other: "{{provider}} collegato — importate {{count}} immersioni",
    oauthConnectError: "Errore connessione {{provider}}",
    oauthSynced_one: "Sync {{provider}} — {{count}} nuova immersione",
    oauthSynced_other: "Sync {{provider}} — {{count}} nuove immersioni",
    oauthSyncError: "Errore sync {{provider}}",
    divelogsSynced: "Sincronizzate {{imported}} immersioni da Divelogs.de",
    divelogsSyncedSkipped: "Sincronizzate {{imported}} immersioni da Divelogs.de ({{skipped}} già presenti)",
    shearwaterImported: "Importate {{imported}} immersioni da Shearwater",
    shearwaterImportedSkipped: "Importate {{imported}} immersioni da Shearwater ({{skipped}} già presenti)",
    importSyncError: "Errore di sincronizzazione",
    goals: {
      title: "Obiettivi",
      subtitle: "Monitora i tuoi obiettivi di immersione",
      add: "Aggiungi obiettivo",
      active: "Attivi",
      completed: "Completati",
      none: "Nessun obiettivo attivo per il {{year}}",
      createFirst: "Imposta il tuo primo obiettivo di immersione",
      saved: "Obiettivo salvato",
      completedBadge: "Completato!",
      avgProgress: "avanzamento medio",
      suggestions: "Obiettivi suggeriti",
      editGoal: "Modifica obiettivo",
      newGoal: "Nuovo obiettivo",
      year: "Anno",
      type: "Tipo",
      target: "Obiettivo",
      eg: "Es.",
      invalidValue: "Valore non valido",
      deleteConfirm: "Eliminare questo obiettivo?",
      saving: "Salvataggio…",
      saveChanges: "Salva modifiche",
      createGoal: "Crea obiettivo",
      typeDiveCount: "Numero immersioni",
      typeMaxDepth: "Profondità massima",
      typeTotalHours: "Ore sott'acqua",
      typeUniqueSites: "Siti unici",
      typeUniqueCountries: "Paesi visitati",
      unitDives: "immersioni",
      unitHours: "ore",
      unitSites: "siti",
      unitCountries: "paesi",
      descDiveCount: "Quante immersioni vuoi completare?",
      descMaxDepth: "Profondità massima da raggiungere",
      descTotalHours: "Ore totali in acqua nell'anno",
      descUniqueSites: "Siti diversi da visitare",
      descUniqueCountries: "Paesi diversi dove immergersi",
      noneHint: "Imposta i tuoi obiettivi per monitorare i progressi.",
    },
    imported_one: "{{count}} immersione importata",
    imported_other: "{{count}} immersioni importate",
    importedSkipped_one: "{{count}} immersione importata ({{skipped}} saltate)",
    importedSkipped_other: "{{count}} immersioni importate ({{skipped}} saltate)",
    maxPhotos: "Massimo 10 foto per immersione",
    unknownSite: "Sito sconosciuto",
    removeLink: "rimuovi",
    diveTypeLabel: "Tipo",
    entryTypeLabel: "Entrata",
    waterTypeLabel: "Tipo acqua",
    suitLabel: "Muta",
    weightLabel: "Zavorra",
    tankPressureLabel: "Pressione partenza",
    buddyLabel: "Buddy",
    decoStopsSection: "Tappe deco",
    depthProfile: "Profilo di profondità",
    depthProfileNoData: "Dati profilo non disponibili",
    diveSiteSection: "Sito di immersione",
    satellite: "Satellite →",
    addPhoto: "Aggiungi foto",
    loading: "Caricamento...",
    editDive: "Modifica immersione",
    newDiveForm: "Nuova immersione",
    cancelButton: "Annulla",
    saveButton: "Salva immersione",
    updateButton: "Aggiorna",
    savingButton: "Salvataggio...",
    diveUpdated: "Immersione aggiornata",
    diveSaved: "Immersione salvata!",
    formTabBase: "Base",
    formTabConditions: "Condizioni",
    formTabGear: "Equipaggiamento",
    formTabGas: "Gas & Deco",
    formLabelStyle: "Stile",
    formSelectStyle: "Seleziona stile",
    formApnea: "Apnea (Freediving)",
    formApneaSection: "Dati apnea",
    formApneaDuration: "Durata apnea (secondi)",
    formPrivateOption: "Privata",
    formFriendsOption: "Amici",
    formPublicOption: "Pubblica",
    formVisibilitySelect: "seleziona",
    formEntryTypeSelect: "seleziona",
    formWaterSalt: "Marina",
    formWaterFresh: "Dolce",
    formWaterBrackish: "Salmastra",
    buddySearchPlaceholder: "Cerca buddy per nome…",
    buddyInviteEmail: "Invita via email",
    buddyShowQR: "Mostra QR",
    buddyInviteTitle: "Invita il tuo buddy",
    buddyInviteDesc: "Il tuo buddy scansiona il QR per registrarsi su eDive",
    buddyClose: "Chiudi",
    statTotalDives: "Immersioni totali",
    statUnderwaterHours: "Ore sott'acqua",
    statMaxDepth: "Profondità massima",
    statCountries: "Paesi visitati",
    statsAndCharts: "Statistiche e grafici",
    fullAnalysis: "Analisi completa →",
    prerequisites: "Prerequisiti brevetti →",
    divesPerMonth: "Immersioni per mese",
    depthDistribution: "Distribuzione profondità",
    topSites: "Siti più frequentati",
    sacTrend: "Trend SAC (ogni 10 immersioni)",
    filterDives: "Filtra immersioni",
    filterShowing: "{{count}} di {{total}} caricate",
    filterShowingAll: "{{loaded}} di {{total}} immersioni",
    filterClear: "Cancella filtri",
    filterSearchPlaceholder: "Cerca per sito, paese...",
    filterAllTypes: "Tutti i tipi",
    filterRecreational: "Ricreativa",
    filterTechnical: "Tecnica",
    filterDepth: "Profondità",
    filterFrom: "Dal",
    filterTo: "al",
    filterPartialLoad: "Caricate {{loaded}} di {{total}} immersioni",
    filterLoadMore: "Carica altre →",
    tabDives: "Immersioni",
    tabGoals: "Obiettivi",
    tripReport: "Resoconto viaggio",
    compareDives: "Confronta",
    comparePeer: "Con un diver",
    diaries: "Diari di viaggio",
    noResults: "Nessun risultato",
    emptyDiary: "Il tuo diario è vuoto",
    importFile: "Importa file",
    importFromComputer: "Importa da dive computer",
    addManually: "Aggiungi manualmente",
    loadMoreDives: "Carica altre immersioni",
    deleteConfirm: "Eliminare questa immersione?",
    importingLabel: "Importazione...",
    importComputer: "Importa Computer",
    importAdvanced: "Importa avanzato",
    syncOnline: "Sync Online",
    guidedWizard: "Wizard guidato",
    myGoals: "I miei obiettivi di immersione",
    goalsAdd: "Aggiungi",
    goalsEmpty: "Nessun obiettivo ancora. Aggiungine uno sopra!",
    goalsCompleted: "{{done}}/{{total}} completati",
    countriesModalTitle: "Immersioni per paese",
    countryUnspecified: "Non specificato",
    overview: {
      depthProfile: "Profilo di profondità",
      details: "Dettagli",
      maxDepthM: "Profondità max (m)",
      durationMin: "Durata (min)",
      rating: "Valutazione",
      dateLabel: "Data",
      maxDepth: "Profondità max",
      duration: "Durata",
      avgDepth: "Profondità media",
      entryTime: "Ora entrata",
      exitTime: "Ora uscita",
      waterTemp: "Temp. acqua",
      airTemp: "Temp. aria",
      suit: "Muta",
      weights: "Piombi",
      tankPressure: "Pressione bombola",
      visibility: "Visibilità",
      waterType: "Tipo acqua",
      entryType: "Tipo entrata",
      tagLabel: "Tag",
      tagPlaceholder: "Nuovo tag...",
      site: "Sito",
      country: "Paese",
      city: "Città",
      buddy: "Buddy",
      gasMix: "Miscela gas",
      mix: "Miscela",
      startPressure: "Pressione inizio",
      endPressure: "Pressione fine",
      freediving: "Apnea",
      discipline: "Disciplina",
      breathHold: "Durata apnea",
      safetyEvent: "Evento di sicurezza registrato. Consulta un istruttore qualificato.",
      decoStops: "Tappe decompressive",
      depth: "Profondità",
      time: "Tempo",
      notes: "Note",
      notesPlaceholder: "Aggiungi note su questa immersione...",
      photos: "Foto",
      addPhoto: "Aggiungi foto",
      addPhotoPrompt: "Aggiungi le tue foto di questa immersione",
      saving: "Salvataggio...",
      save: "Salva",
      cancel: "Annulla",
      edit: "Modifica",
      diveUpdated: "Immersione aggiornata",
      saveFailed: "Errore nel salvataggio",
      speciesSighted: "Specie avvistate",
      addSighting: "Aggiungi",
      needsSite: "Richiede sito",
      noSpecies: "Nessuna specie registrata per questa immersione",
      linkSite: "Associa un sito all'immersione per registrare avvistamenti",
      recordSighting: "Registra avvistamento",
      sightingRecorded: "Avvistamento registrato",
      sightingError: "Errore",
      depthOptional: "Opzionale",
      depthM: "Profondità (m)",
      saveSighting: "Salva avvistamento",
      searchSpecies: "Cerca specie...",
      noSpeciesFound: "Nessuna specie trovata",
      uploadError: "Errore caricamento foto",
      dateReqSent: "Richiesta inviata: la data sarà aggiornata dopo l\\",
      dateReqPending: "Modifica data in attesa di approvazione",
      dateReqRejected: "Ultima richiesta rifiutata",
      requestDateChange: "Richiedi modifica data",
      dateReqMotivation: "Motivazione (opzionale)",
      dateReqSubmit: "Invia richiesta",
      diveSite: "Punto di immersione",
      reconcileSite: "Riconcilia punto di immersione",
      setSite: "Imposta punto di immersione",
      reconcileSiteTitle: "Punto di immersione",
      siteReconciled: "Punto di immersione aggiornato",
      fromLinkedPlan: "Dalla pianificazione collegata",
      usePlanSite: "Usa dal piano",
    },
    stats: {
      statistics: "Statistiche",
      cylinders: "Bombole e gas",
      fromPlan: "da pianificazione",
      planFallbackNote: "I dati mancanti dal computer sono integrati dalla pianificazione collegata.",
      depth: "Profondità",
      avgDepth: "Prof. med.",
      maxDepth: "Profondità massima",
      diveTime: "Tempo di immersione",
      thisDive: "Questa immersione",
      n2Loading: "Caricamento N₂",
      cnsLoading: "Caricamento CNS",
      exit: "Uscita",
      trainingEffect: "Training Effect",
      primaryBenefit: "Beneficio principale",
      aerobic: "Aerobico",
      anaerobic: "Anaerobico",
      exerciseLoad: "Carico di esercizio",
      conditions: "Condizioni",
      altitude: "Quota",
      waterType: "Tipo di acqua",
      waterTemp: "Temperatura acqua",
      avgWaterTemp: "Temp media acqua",
      minWaterTemp: "Temperatura minima acqua",
      maxWaterTemp: "Temperatura massima acqua",
      altitudeStat: "Quota",
      totalAscent: "Ascesa totale",
      totalDescent: "Discesa totale",
      minAltitude: "Quota minima",
      maxAltitude: "Quota max",
      depthChart: "Profondità",
      decoCeiling: "Tetto di decompressione",
      temperature: "Temperatura",
      avg: "Media",
      exitPosition: "Posizione di uscita",
      noData: "Dati statistici non disponibili per questa immersione.",
      cylinderType: "Tipo di bombola",
      cylinderSize: "Dimensioni bombola",
      startPressure: "Pressione iniziale",
      endPressure: "Pressione",
      noCylinders: "Nessuna bombola registrata per questa immersione.",
      backGas: "Back gas",
      mainGas: "Gas principale",
      air: "Aria",
      comparisonTitle: "Confronto ultimi {{n}} mesi",
      newDepthRecord: "Nuovo record di profondità!",
      newDurRecord: "Nuova durata record!",
      personalAvg: "Media personale",
      avgDuration: "Media durata",
    },
    deco: {
      algorithmNotAvailable: "Dati algoritmo non disponibili per questa immersione.",
      algorithmConfig: "Configurazione algoritmo",
      algorithm: "Algoritmo",
      lastStop: "Ultima tappa",
      salinity: "Salinità",
      ascentRate: "Vel. risalita",
      gfRange: "Intervallo GF",
      noDecoStops: "Nessuna tappa decompressiva — immersione in NDL.",
      decoStops: "Tappe decompressive",
      stops: "tappe",
      total: "totali",
      depth: "Profondità",
      plannedTime: "Tempo pianificato",
      type: "Tipo",
      safetyStop: "Safety stop",
      decoStop: "Deco stop",
      runtimeRecap: "Riepilogo profilo",
      descent: "Discesa",
      bottom: "Fondo",
      stop: "Tappa",
      ascent: "Risalita",
      surface: "Superficie",
      totalLabel: "totali",
      whatIsGF: "Cos'è il Gradient Factor?",
    },
    map: {
      entryPoint: "Punto di entrata",
      exitPoint: "Punto di uscita",
      gpsTrack: "Traccia GPS (profondità)",
      noGps: "Nessun dato GPS per questa immersione. Associa un sito per vedere la posizione.",
      gpsTrackData: "Dati traccia GPS",
      gpsPoints: "Punti GPS",
      maxDepth: "Profondità max",
      duration: "Durata",
      entryPopup: "Entrata",
      exitPopup: "Uscita",
    },
    alerts: {
      allTypes: "Tutti i tipi",
      allSeverities: "Tutti i livelli",
      allSources: "Tutte le fonti",
      alertCount_one: "{{count}} avviso calcolato dai dati disponibili.",
      alertCount_other: "{{count}} avvisi calcolati dai dati disponibili.",
      noAlertFilters: "Nessun avviso corrisponde ai filtri selezionati.",
      noAlerts: "Nessun avviso rilevato.",
      noAlertsHint: "Importa un'immersione da Shearwater, Suunto o UDDF per analisi più dettagliate su saturazione tissutale e CNS%.",
      ascentRateLabel: "Velocità risalita",
    },
    tissues: {
      buhlmann16: "16 compartimenti Bühlmann",
      tissueNotComputed: "Dati tessuti non calcolati — questa immersione non ha un profilo temporale.",
      whatIsCompartment: "Cos'è un compartimento tissutale?",
      tissueSaturation: "Saturazione tissutale",
      simulatedData: "Dati simulati",
      minute: "Minuto",
      halfTime: "Emivita",
      n2Saturation: "Saturazione N₂",
      compartment: "Compartimento",
      leading: "Leading",
      tissueHalfTime: "Emivita tissutale",
      leadingCompartment: "Compartimento leading",
    },
    imported: "{{count}} immersioni importate",
    importedSkipped: "{{count}} immersioni importate, {{skipped}} saltate (duplicati)",
    oauthConnected: "{{provider}} collegato — {{count}} immersioni importate",
    oauthSynced: "{{provider}}: {{count}} immersioni sincronizzate",
  },
  diveGoals: {
    title: "Obiettivi {{year}}",
    add: "Aggiungi",
    noGoals: "Nessun obiettivo impostato",
    setFirst: "Imposta il primo obiettivo",
    allAdded: "Tutti gli obiettivi sono stati aggiunti.",
    saving: "Salvataggio…",
    removeGoal: "Rimuovi obiettivo",
    DIVE_COUNT: "Immersioni",
    DIVE_COUNT_unit: "immersioni",
    MAX_DEPTH: "Profondità max",
    MAX_DEPTH_unit: "m",
    TOTAL_HOURS: "Ore sott'acqua",
    TOTAL_HOURS_unit: "ore",
    UNIQUE_SITES: "Siti visitati",
    UNIQUE_SITES_unit: "siti",
    UNIQUE_COUNTRIES: "Paesi",
    UNIQUE_COUNTRIES_unit: "paesi",
  },
  "siteDetails": {
    "tab": "Sicurezza e logistica",
    "intro": "Informazioni inserite dalla community e verificate da un amministratore. Nulla è precompilato: se un campo è vuoto, nessuno l'ha ancora segnalato.",
    "notProvided": "Non indicato",
    "propose": "Proponi una modifica",
    "loginToPropose": "Accedi per proporre modifiche a questi dati.",
    "hazards": "Pericoli",
    "hazardsHelp": "Uno per riga, massimo 20 voci.",
    "currents": "Correnti tipiche",
    "altitude": "Altitudine",
    "altitudeHelp": "In metri sul livello del mare (per i laghi o i siti in quota).",
    "altitudeInvalid": "Inserisci un numero valido.",
    "alternative": "Sito alternativo",
    "alternativeSearch": "Cerca un sito per nome…",
    "alternativeClear": "Rimuovi",
    "emergency": "Dati di emergenza",
    "nearestHospital": "Ospedale più vicino",
    "nearestChamber": "Camera iperbarica più vicina",
    "emergencyPhone": "Telefono di emergenza",
    "evacuationNotes": "Note di evacuazione",
    "formHint": "Modifica solo ciò che vuoi cambiare. Un amministratore rivedrà la proposta prima della pubblicazione.",
    "source": "Fonte",
    "sourceHelp": "Facoltativa: come hai ricavato queste informazioni (esperienza diretta, centro immersioni, ordinanza…).",
    "noChanges": "Nessuna modifica rispetto ai dati attuali.",
    "submit": "Invia la proposta",
    "sent": "Proposta inviata. Un amministratore la revisionerà.",
    "sendError": "Invio non riuscito. Riprova.",
    "pendingForSite": "Proposte in attesa per questo sito",
    "queueTitle": "Proposte sui dettagli di sicurezza dei siti",
    "queueEmpty": "Nessuna proposta in attesa.",
    "statusPending": "In attesa",
    "proposedBy": "Proposta da {{id}}",
    "cleared": "(campo svuotato)",
    "approve": "Approva",
    "reject": "Rifiuta",
    "confirmApprove": "Conferma approvazione",
    "confirmReject": "Conferma rifiuto",
    "reviewerNotes": "Note della revisione (facoltative)",
    "approved": "Proposta approvata e applicata al sito.",
    "rejected": "Proposta rifiutata.",
    "reviewError": "Revisione non riuscita.",
  },
  divesites: {
    title: "Siti di Immersione",
    newSite: "Nuovo Sito",
    name: "Nome",
    description: "Descrizione",
    country: "Paese",
    region: "Regione",
    maxDepth: "Profondità Massima (m)",
    minDepth: "Profondità Minima (m)",
    difficulty: "Difficoltà",
    waterType: "Tipo di Acqua",
    rating: "Valutazione",
    latitude: "Latitudine",
    longitude: "Longitudine",
    selectPlaceholder: "— seleziona —",
    viewGrid: "Lista",
    viewMap: "Mappa",
    proposeSite: "Proponi sito",
    searchPlaceholder: "Cerca per nome o regione…",
    allTypes: "Tutti i tipi",
    allLevels: "Tutti i livelli",
    allCountries: "Tutti i paesi",
    sitesCount: "{{count}} siti",
    createSuccess: "Sito creato con successo",
    difficulties: {
      BEGINNER: "Principiante",
      INTERMEDIATE: "Intermedio",
      ADVANCED: "Avanzato",
      TECHNICAL: "Tecnico",
    },
    diveTypes: {
      REEF: "Barriera",
      WALL: "Parete",
      WRECK: "Relitto",
      CAVE: "Grotta",
      DRIFT: "Corrente",
      SHORE: "Da riva",
      NIGHT: "Notturna",
      TRAINING: "Training",
    },
    waterTypes: {
      SALT: "Mare",
      FRESH: "Acqua Dolce",
      BRACKISH: "Salmastra",
    },
    tabs: {
      info: "Dettagli",
      reviews: "Recensioni",
      species: "Fauna marina",
      myDives: "Le mie immersioni",
      conditions: "Condizioni",
      weather: "Meteo",
      photos: "Foto",
      admin: "Admin",
    },
    detail: {
      region: "Regione",
      country: "Paese",
      depthMin: "Profondità min",
      depthMax: "Profondità max",
      visibility: "Visibilità media",
      gps: "Coordinate GPS",
      reportCoords: "Segnala",
      reportCoordsTitle: "Segnala coordinate errate o più precise",
      satellite: "🛰️ Satellite",
      nautical: "⚓ Nautical",
      weather: "🌊 Meteo",
      verified: "✓ Verificato",
      divingCenters: "Diving center attivi su questo sito",
      noDivingCenters: "Nessun diving center collegato ancora.",
      loading: "Caricamento…",
    },
    reviews: {
      leave: "Lascia una recensione",
      submit: "Invia recensione",
      submitting: "Invio…",
      commentPlaceholder: "Descrivi la tua esperienza (visibilità, correnti, fauna, ecc.)…",
      noReviews: "Nessuna recensione ancora. Sii il primo!",
      sentiments: {
        "1": "Pessimo",
        "2": "Scarso",
        "3": "Discreto",
        "4": "Buono",
        "5": "Eccellente",
      },
      sent: "Valutazione inviata!",
    },
    species: {
      none: "Nessun avvistamento registrato per questo sito.",
      sightings: "{{count}} avvistamenti",
    },
    myDives: {
      none: "Non hai ancora immerso in questo sito.",
    },
    coordReport: {
      title: "Segnala coordinate GPS",
      desc: "Hai rilevato le coordinate precise sul posto? Invia la correzione — un amministratore aggiornerà le coordinate dopo verifica.",
      lat: "Latitudine",
      lon: "Longitudine",
      notes: "Note (opzionali)",
      notesPlaceholder: "Descrivi come hai rilevato le coordinate (es. GPS sul pedagno, foto GPS allegata…)",
      cancel: "Annulla",
      submit: "Invia segnalazione",
      submitting: "Invio…",
      success: "Segnalazione inviata — un amministratore la esaminerà",
      error: "Errore durante l'invio",
    },
    addDc: {
      title: "Collega diving center",
      id: "ID Diving Center *",
      name: "Nome (opzionale)",
      url: "URL (opzionale)",
      link: "Collega",
      submitting: "Salvataggio…",
    },
    admin: {
      coordReports: "Segnalazioni coordinate in attesa",
      noReports: "Nessuna segnalazione in attesa.",
      approve: "Approva",
      reject: "Rifiuta",
      coordUpdated: "Coordinate aggiornate",
      reportRejected: "Segnalazione rifiutata",
      dcLinked: "Diving center collegato",
      dcTitle: "Diving center collegati",
      dcAdd: "+ Collega",
      noDc: "Nessun diving center collegato.",
      dcRemove: "Rimuovi",
      currentCoords: "Attuale",
    },
    wishlist: {
      add: "Aggiungi alla wishlist",
      remove: "Rimuovi dalla wishlist",
      save: "Salva",
      saved: "Salvato",
    },
    actions: {
      logDive: "Registra immersione",
      reportConditions: "Segnala condizioni",
      beFirst: "Sii il primo a segnalare!",
    },
    conditionReport: {
      title: "Segnala condizioni del sito",
      desc: "Condividi le condizioni che hai trovato durante la tua immersione. Aiuta la community!",
      diveDate: "Data dell'immersione *",
      visibilityM: "Visibilità (m)",
      tempSurface: "Temp. superfice (°C)",
      tempBottom: "Temp. fondo (°C)",
      currentKn: "Corrente (nodi)",
      waveHeight: "Altezza onde (m)",
      fauna: "Fauna avvistata",
      faunaSep: "(separata da virgole)",
      notes: "Note",
      cancel: "Annulla",
      submit: "Invia report",
      submitting: "Invio…",
      success: "Condizioni segnalate con successo!",
      error: "Errore durante l'invio. Riprova.",
    },
    photos: {
      addPhoto: "Aggiungi una foto",
      caption: "Didascalia (opzionale)",
      uploading: "Caricamento…",
      select: "Seleziona foto",
      modNote: "Le foto vengono mostrate dopo approvazione del team.",
      noPhotos: "Nessuna foto ancora.",
      noPhotosHint: "Sii il primo a condividere un'immagine di questo sito!",
      uploadSuccess: "Foto inviata — sarà visibile dopo la moderazione",
      uploadError: "Caricamento fallito",
      deleted: "Foto eliminata",
    },
    weather: {
      current: "Condizioni attuali",
      air: "aria",
      waves: "Onde",
      wind: "Vento",
      swell: "Swell",
      period: "Periodo",
      clouds: "Nuvole",
      visibility: "Visibilità",
      forecast: "Previsioni",
      today: "Oggi",
      tomorrow: "Domani",
      source: "Fonte: Open-Meteo · Aggiornato ogni 30 min",
      noCoords: "Coordinate non disponibili — impossibile caricare il meteo.",
      unavailable: "Dati meteo non disponibili in questo momento.",
      wmo: {
        clear: "Sereno",
        partlyCloudy: "Poco nuvoloso",
        cloudy: "Nuvoloso",
        fog: "Nebbia",
        drizzle: "Pioggerella",
        rain: "Pioggia",
        snow: "Neve",
        showers: "Rovescio",
        thunderstorm: "Temporale",
        heavyThunderstorm: "Temporale forte",
      },
    },
    conditions: {
      last: "Ultimi",
      days: "gg",
      avgTitle: "Media ultimi {{days}} giorni",
      reports: "{{count}} report",
      noReports: "Nessun report condizioni negli ultimi {{days}} giorni.",
      visibility: "Visibilità",
      tempSurface: "T. superfice",
      tempBottom: "T. fondo",
      current: "Corrente",
      waves: "Onde",
    },
    filterDepthGreater: "Maggiore di",
    filterDepthLess: "Minore di",
    allCategories: "Tutte",
    categoryRecreational: "Ricreativa",
    categoryTechnical: "Tecnica",
    nearMe: {
      title: "Immersioni vicino a me",
      subtitle: "Scopri siti e centri sub nelle vicinanze",
      diffBeginner: "Principiante",
      diffIntermediate: "Intermedio",
      diffAdvanced: "Avanzato",
      diffTechnical: "Tecnico",
    },
    recommendations: {
      title: "Siti Consigliati",
      subtitle: "Siti di immersione personalizzati in base alla tua brevettazione e ai tuoi gusti.",
      diffBeginner: "Principiante",
      diffIntermediate: "Intermedio",
      diffAdvanced: "Avanzato",
      diffTechnical: "Tecnico",
    },
  },
  courses: {
    title: "Corsi",
    newCourse: "Nuovo Corso",
    enroll: "Iscriviti",
    enrolled: "Iscritto",
    level: "Livello",
    agency: "Ente Certificatore",
    duration: "Durata (giorni)",
    price: "Prezzo",
    maxStudents: "Max Studenti",
    prerequisiteDives: "Immersioni Prerequisito",
    language: "Lingua",
    statuses: {
      DRAFT: "Bozza",
      PUBLISHED: "Pubblicato",
      ARCHIVED: "Archiviato",
    },
    enrollmentStatuses: {
      ENROLLED: "Iscritto",
      IN_PROGRESS: "In corso",
      COMPLETED: "Completato",
      CANCELLED: "Annullato",
      FAILED: "Non superato",
    },
    enrolledSuccess: "Iscrizione completata con successo",
    noCoursesFound: "Nessun corso trovato con i filtri selezionati",
    loadingInstructors: "Caricamento istruttori...",
    noInstructors: "Nessun istruttore {{agency}} registrato su eDive al momento.",
    noInstructorsHint: "Prova a contattare direttamente un diving center nella tua area.",
    noCourses: "Nessun corso",
    noCoursesDesc: "Non sei ancora iscritto a nessun corso. Cerca un centro immersioni o un istruttore.",
    noMaterials: "Nessun materiale disponibile",
    noSessions: "Nessuna sessione pianificata",
    selectCourse: "Seleziona un corso per i dettagli",
    inProgress: "In corso",
    completedSection: "Completati",
    detailsTab: "Dettagli",
    materialsTab: "Materiali",
    sessionsTab: "Sessioni",
    enrolledOn: "Iscritto il",
    startDate: "Inizio corso",
    endDate: "Fine corso",
    completedOn: "Completato il",
    feePaid: "Quota pagata",
    certObtained: "Certificazione ottenuta!",
    certIssuedOn: "Emessa il",
    contactInstructor: "Messaggio istruttore",
    instructor: "Istruttore",
    paymentSuccess: "Pagamento completato!",
    paymentCancelled: "Pagamento annullato",
    examTab: "Esame",
    previousAttempts: "Tentativi precedenti",
    startExam: "Inizia esame",
    retryExam: "Nuovo tentativo",
    examTimeLimit: "L'esame ha un limite di tempo di 60 minuti",
    certDownloadError: "Impossibile scaricare il certificato",
    scoreLabel: "Punteggio",
    created: "Corso creato",
    createTitle: "Nuovo corso",
    titleLabel: "Titolo",
    certLevel: "Livello di certificazione",
    description: "Descrizione",
    descriptionPlaceholder: "Descrizione del corso…",
    durationDays: "Durata (giorni)",
    createBtn: "Crea corso",
    sessionTypes: {
      THEORY: "Teoria",
      POOL: "Piscina",
      OPEN_WATER: "Acque aperte",
      EXAM: "Esame",
      BRIEFING: "Briefing",
    },
    depthMax: "Profondità max",
    minAge: "Età minima",
    searchPlaceholder: "Cerca corso o abilità...",
    prereqs: "Prerequisiti",
    findInstructors: "Trova istruttori eDive",
    contact: {
      convName: "Richiesta corso {{course}}",
      defaultMsg: "Ciao! Sono interessato/a al corso {{course}} ({{agency}}). Potresti darmi qualche informazione in più su date, costi e prerequisiti?",
      message: "Messaggio",
      messagePlaceholder: "Presentati e racconta all'istruttore cosa vorresti imparare…",
      requestedCourse: "Corso richiesto",
      title: "Contatta {{name}}",
      btn: "Contatta",
    },
    enrollSuccess: "Iscrizione effettuata!",
    enrollError: "Errore iscrizione",
    catalog: {
      title: "Catalogo",
      eDiveCourses: "Corsi eDive disponibili",
      searchPlaceholder: "Cerca corsi...",
      allAgencies: "Tutte le didattiche",
      allLevels: "Tutti i livelli",
      allCategories: "Tutte le categorie",
      resetFilters: "Azzera",
      coursesCount: "{{count}} corsi",
      noCoursesFiltered: "Nessun corso trovato con i filtri selezionati.",
      enroll: "Iscriviti",
      course: "Corso",
      courseCount: "{{count}} corsi",
      instructor: "Istruttore",
      reset: "Azzera filtri",
      student: "Allievo",
      students: "allievi",
      findInstructors: "Trova istruttori",
    },
    myCourses: {
      title: "I miei corsi",
      managing: "Corsi che gestisco",
      enrollments: "Le mie iscrizioni",
      noCourses: "Nessun corso ancora. Crea il tuo primo corso!",
      create: "Crea corso",
      noEnrollments: "Nessuna iscrizione. Esplora il catalogo e iscriviti a un corso!",
      goToCatalog: "Vai al catalogo",
      students: "Studenti",
      enrolled: "{{count}} iscritti",
      startQuiz: "Avvia quiz",
      goToLessons: "Vai alle lezioni",
    },
    students: {
      title: "Studenti",
      tab: "Studenti",
      detailTab: "Dettaglio corso",
      loading: "Caricamento...",
      none: "Nessuno studente iscritto",
      validate: "Valida",
      approve: "Approva",
      confirmed: "Confermato",
      confirmSuccess: "Iscrizione confermata",
      confirmError: "Errore conferma",
      detailAvailable: "Dettaglio corso disponibile nella gestione completa.",
    },
    quiz: {
      title: "Quiz completato",
      great: "Ottimo lavoro!",
      completed: "Hai completato il quiz del corso \"{{title}}\"",
      close: "Chiudi",
      exit: "Esci",
      next: "Avanti",
      complete: "Completa",
      q1: "Qual è la regola fondamentale del sub?",
      q1o1: "Non risalire mai",
      q1o2: "Non trattenere il respiro",
      q1o3: "Non usare la muta",
      q1o4: "Nuotare sempre veloce",
      q2: "Cosa indica il simbolo alfa in immersione?",
      q2o1: "Segnale di pericolo",
      q2o2: "Operazioni subacquee in corso",
      q2o3: "Imbarcazione di soccorso",
      q2o4: "Profondità massima",
      q3: "Cos'è la malattia da decompressione?",
      q3o1: "Ipotermia",
      q3o2: "Formazione di bolle di azoto nei tessuti",
      q3o3: "Intossicazione da CO2",
      q3o4: "Nessuna delle precedenti",
    },
    categories: {
      Ricreativo: "Ricreativo",
      Soccorso: "Soccorso",
      "Specialità": "Specialità",
      Professionale: "Professionale",
      Tecnico: "Tecnico",
      Rebreather: "Rebreather",
      Overhead: "Overhead",
    },
    instructorDisclaimer: "Gli istruttori mostrati sono professionisti registrati sulla piattaforma eDive.",
    instructorDisclaimerAffiliate: "Non siamo affiliati a {{agency}} né garantiamo disponibilità o prezzi.",
    availableInstructors: "{{count}} istruttori disponibili",
    instructorCount: "{{count}} istruttori disponibili",
    pageTitle: "Corsi & Brevetti",
    pageSubtitle: "Sfoglia il catalogo, iscriviti a corsi eDive e gestisci le tue certificazioni",
    enrollWizard: "Iscriviti a un corso",
    addCert: "Aggiungi brevetto",
    cancelEnrollSuccess: "Iscrizione cancellata",
    cancelEnrollError: "Errore nella cancellazione",
    cancelEnrollConfirm: "Cancellare l\\",
    cancelEnroll: "Cancella iscrizione",
    enrollStatus: {
      pending: "In attesa di conferma",
      confirmed: "Confermata",
      completed: "Completata",
      cancelled: "Annullata",
    },
  },
  gasPlanner: {
    title: "Pianificazione Gas",
    subtitle: "Calcola consumo, pressioni di riserva e turnaround per la tua immersione",
    cylinder: "Bombola",
    volume: "Volume",
    liters: "litri",
    startPressure: "Pressione iniziale",
    reserve: "Riserva",
    reserveHint: "Pressione minima da non consumare",
    planning: "Pianificazione",
    depthMax: "Profondità max",
    duration: "Durata prevista",
    sacRate: "SAC Rate",
    usePersonalSac: "Usa il mio SAC medio ({{sac}} L/min)",
    sacHint: "Consumo in superficie. Media: 12-20 L/min",
    sacFromLogbook: "Calcolato dalle tue ultime immersioni",
    tabs: {
      plan: "Piano Gas",
      nitrox: "Nitrox / EAD",
      rmv: "RMV & Consumi",
      nitrogen: "Azoto & No-Fly",
      multidive: "Multi-Dive",
    },
    plan: {
      feasible: "Piano fattibile — margine {{margin}}%",
      notFeasible: "Gas insufficiente per questo piano",
      available: "{{available}} L disponibili vs {{required}} L necessari",
      notEnough: "Servono {{required}} L ma hai solo {{available}} L utili",
      gasNeeded: "Gas necessario",
      gasNeededSub: "≈ {{bar}} bar sul tuo cilindro",
      gasAvailable: "Gas disponibile (utile)",
      gasAvailableSub: "{{bar}} bar sopra riserva",
      turnPressure: "Pressione di turn",
      turnPressureSub: "Rientro a metà consumo (1/2 rule)",
      endPressure: "Pressione fine stimata",
      endAboveReserve: "Sopra riserva ✓",
      endBelowReserve: "Sotto riserva ⚠",
      sacUsed: "SAC utilizzato",
      sacPersonal: "Personale (media storica)",
      sacManual: "Manuale",
      maxAutonomy: "Autonomia massima",
      maxAutonomySub: "a {{depth}} m con SAC {{sac}} L/min",
      thirdsRule: "Regola dei Terzi (cave / technical)",
      thirdsOut: "1/3 Andata",
      thirdsReturn: "1/3 Ritorno",
      thirdsReserve: "1/3 Riserva",
    },
    nitrox: {
      blend: "Miscela",
      oxygenPct: "Ossigeno (%)",
      oxygenHint: "21% = aria. EANx32, EANx36 comuni per ricreativo.",
      mod14: "MOD (ppO₂ 1.4)",
      mod14Sub: "Profondità max operativa",
      mod16: "MOD (ppO₂ 1.6)",
      mod16Sub: "Limite assoluto / deco",
      ead: "EAD a piano",
      eadSub: "Profondità equivalente aria a {{depth}} m",
      ppo2: "ppO₂ a piano",
      ppo2Sub: "a {{depth}} m con O₂ {{o2}}%",
      analysisRequired: "Analisi obbligatoria",
      analysisNote: "Verifica sempre la percentuale di O₂ con un analizzatore prima di immergerti con Nitrox.",
    },
    rmv: {
      sacSurface: "SAC (superficie)",
      sacSurfaceSub: "Consumo in superficie",
      rmvAtPlan: "RMV a piano",
      rmvAtPlanSub: "a {{depth}} m",
      totalConsumption: "Consumo totale",
      totalConsumptionSub: "{{duration}} min × RMV {{rmv}} L/min",
      absPressure: "Pressione assoluta",
      absPressureSub: "a {{depth}} m",
      depthTable: "Consumo per profondità (30 min)",
    },
    nitrogen: {
      noRecentDives: "Nessuna immersione recente trovata",
      surfaceSaturation: "I tessuti sono a saturazione di superficie (equilibrio).",
      basedOn: "Basato su {{count}} immersioni recenti",
      lastDive: "ultima {{hours}}h fa",
      maxSat: "Saturazione massima attuale: {{pct}}% del valore-M. Modello Bühlmann ZHL-16B.",
      noFly: "No-Fly",
      safeToFly: "Sicuro per volare",
      waitBeforeFly: "Attesa prima di volare",
      ndlAtDepth: "NDL a {{depth}} m",
      decoRequired: "STOP DECO richiesta!",
      narrowMargin: "Margine stretto",
      ndlFromPlan: "Profondità dal Piano Gas",
      ceiling: "Soffitto",
      noCeiling: "Nessuno",
      noCeilingNote: "Nessuna deco richiesta",
      decoRequired2: "Stop deco obbligatoria!",
      tissueTitle: "Saturazione tessuti (% del valore-M a superficie)",
      tissueNote: "100% = tessuto al limite di decompressione in superficie. Le immersioni ricreative si mantengono tipicamente sotto 80%.",
      modelNote: "Nota sul modello",
      modelDesc: "Calcolo basato su profili rettangolari stimati dal logbook (profondità max + durata). Per pianificazione tecnica usare software certificato (Subsurface, DAN DivePlanner). Verifica sempre con il tuo computer.",
      loading: "Caricamento immersioni...",
      fast: "Veloce",
      medium: "Medio",
      slow: "Lento",
    },
    multidive: {
      dive: "Immersione {{n}}",
      outsideNdl: "Fuori NDL",
      depthMax: "Profondità max",
      duration: "Durata",
      surfaceInterval: "Intervallo superficie",
      surfaceIntervalHint: "Dopo la precedente immersione",
      ndlAvailable: "NDL disponibile",
      satAfter: "Saturazione dopo",
      reduceDuration: "Piano: {{planned}} min — ridurre durata",
      addDive: "Aggiungi immersione ({{count}}/4)",
      noFlyAfter: "No-Fly dopo sequenza",
      safeToFly: "Sicuro per volare",
      waitRecommended: "Attesa consigliata",
      divesPlanned: "Immersioni pianificate",
      allWithinNdl: "Tutte entro NDL ✓",
      someOutsideNdl: "Alcune fuori NDL ⚠",
      gasMix: "Mix gas: {{o2}}% O₂ — usa il tab Nitrox/EAD per modificarlo",
      simNote: "La simulazione usa profili rettangolari. NDL mostrato all'inizio di ogni immersione, tenendo conto del carico di azoto residuo dalla precedente.",
    },
  },
  exam: {
    loading: "Caricamento esame…",
    backToCourse: "Torna al corso",
    passed: "Esame superato",
    failed: "Esame non superato",
    passedMsg: "Complimenti! Hai raggiunto il punteggio minimo.",
    minScore: "Punteggio minimo richiesto: 70%",
    reviewAnswers: "Revisione risposte",
    questionOf: "Domanda {{current}} di {{total}}",
    submit: "Consegna esame",
    submitting: "Consegna…",
    prev: "Precedente",
    next: "Successiva",
    answeredCount: "{{answered}} / {{total}} risposte",
    missingParams: "Parametri mancanti",
    startError: "Impossibile avviare l'esame",
    submitError: "Errore durante la consegna",
    unansweredTitle: "Domande senza risposta",
    unansweredMsg: "Hai risposto a {{answered}} di {{total}} domande. Le domande senza risposta saranno considerate errate.",
    backToExam: "Torna all'esame",
    submitAnyway: "Consegna comunque",
  },
  planning: {
    multiErr_depth: "Immersione {{dive}}: la profondità deve essere tra 1 e 60 m.",
    multiErr_time: "Immersione {{dive}}: il tempo di fondo deve essere tra 1 e 300 minuti.",
    multiErr_interval: "Immersione {{dive}}: l’intervallo in superficie deve essere tra 0 e 1440 minuti.",
    multiErr_gf: "Il GF basso non può superare il GF alto.",
    multiErr_count: "Servono da 1 a 10 immersioni.",
    multiErr_server: "Il calcolo non è riuscito. Controlla i valori e riprova.",
    title: "Pianificazione Immersioni",
    ndl: "Limite di Non Decompressione",
    deco: "Pianificazione Decompressione",
    gas: "Gas",
    depth: "Profondità",
    time: "Tempo (min)",
    bottomTime: "Tempo di Fondo",
    calculate: "Calcola",
    ndlMinutes: "NDL: {{minutes}} min",
    decoStops: "Soste di Decompressione",
    totalAscent: "Tempo Totale Risalita",
    warnings: "Avvisi",
    gasMixture: "Miscela",
    sacRate: "Consumo SAC (l/min)",
    tankVolume: "Volume Bombola (l)",
    startPressure: "Pressione Iniziale",
    gasConsumption: "Consumo Gas",
    cylinder: "Bombola",
    gasMix: "Miscela Gas",
    decoRequired: "Decompressione Richiesta",
    ndlLimit: "Limite di Non Deco",
    gasConsumed: "Gas Consumato",
    safeToStart: "Gas sufficiente",
    insufficientGas: "Gas insufficiente",
    reserve: "Riserva",
    algorithm: "Algoritmo",
    stopTime: "Tempo Sosta",
    savePlan: "Salva Piano",
    planName: "Nome del piano",
    planNotes: "Note (opzionale)",
    loadPlan: "Carica",
    noSavedPlans: "Nessun piano salvato",
    noSavedPlansHint: "Calcola un'immersione e salvala per vederla qui",
    plans: "piani",
    calculateToSeeProfile: "Configura i parametri e calcola per vedere il profilo",
    modTable: "Tabella MOD Rapida",
    bailout: "Gas di Emergenza",
    calculateBailout: "Calcola Emergenza",
    gasNeeded: "Gas Necessario",
    minVolume: "Volume Minimo",
    recommendedCylinder: "Bombola Consigliata",
    safetyFactor: "Fattore di Sicurezza",
    narcosisHpns: "Narcosi / HPNS",
    gasDensity: "Densità Gas",
    gasDensityWarning: "Alta densità del gas aumenta il WOB e il rischio di ritenzione CO₂",
    analyzeRisk: "Analizza Rischio",
    riskAssessment: "Valutazione Rischio",
    experience: "Esperienza",
    prevDives: "Immersioni precedenti oggi",
    weight: "Zavorra",
    battery: "Batterie",
    liftbag: "Lift Bag",
    calories: "Calorie",
    bodyWeight: "Peso Corporeo",
    suit: "Muta",
    waterType: "Tipo d'Acqua",
    tankMaterial: "Materiale Bombola",
    estimatedWeight: "Zavorra Stimata",
    diveTime: "Tempo Immersione",
    checkConditions: "Controlla Condizioni",
    divingRecommendation: "Raccomandazione",
    windSpeed: "Velocità Vento",
    waveHeight: "Altezza Onde",
    seaTemp: "Temperatura Superficie",
    visibility: "Visibilità",
    current: "Corrente",
    tide: "Marea",
    latitude: "Latitudine",
    longitude: "Longitudine",
    date: "Data",
    dive: "Immersione",
    repetitive: "Ripetitiva",
    surfaceInterval: "Intervallo Superficie",
    addDive: "Aggiungi Immersione",
    ceiling: "Soffitto",
    n2Loading: "Carico N₂",
    tabs: {
      profile: "Profilo",
      multidive: "Multi-Immersione",
      gas: "Gas & MOD",
      safety: "Sicurezza",
      utility: "Utilità",
      conditions: "Condizioni",
      saved: "Piani Salvati",
    },
    updatePlan: "Aggiorna pianificazione",
  },
  events: {
    title: "Eventi",
    newEvent: "Nuovo Evento",
    register: "Registrati",
    registered: "Registrato",
    startDate: "Data Inizio",
    endDate: "Data Fine",
    location: "Luogo",
    maxParticipants: "Max Partecipanti",
    price: "Prezzo",
    statuses: {
      UPCOMING: "In Programma",
      ONGOING: "In Corso",
      COMPLETED: "Completato",
      CANCELLED: "Annullato",
    },
    createdDraft: "Evento creato come bozza",
    published: "Evento pubblicato",
    cancelled: "Evento annullato",
    completed: "Evento completato",
    registered_success: "Iscrizione completata!",
    full: "Posti esauriti",
    alreadyRegistered: "Sei già iscritto",
    createError: "Errore nella creazione",
    tabExplore: "Esplora",
    tabInvitations: "Inviti",
    tabAttending: "Partecipo",
    tabMyEvents: "I miei eventi",
    statusDraft: "Bozza",
    statusPublished: "Pubblicato",
    statusCancelled: "Annullato",
    statusCompleted: "Completato",
    typeDiveTrip: "Gita subacquea",
    typeGuidedDive: "Immersione guidata",
    typeCourse: "Corso",
    typeCompetition: "Gara",
    typeSeminar: "Seminario",
    typeSocial: "Evento sociale",
    typeCleanup: "Pulizia fondale",
    typeLiveaboard: "Liveaboard",
    typeOther: "Altro",
    free: "Gratuito",
    discoverTitle: "Scopri eventi della community",
    searchPlaceholder: "Cerca evento…",
    allTypes: "Tutti i tipi",
    noEvents: "Nessun evento disponibile",
    enrolled: "Iscritto",
    leaveEvent: "Abbandona",
    fullSlots: "Posti esauriti",
    enrolling: "Iscrizione…",
    participate: "Partecipa",
    noInvitations: "Nessun invito in attesa",
    accept: "Accetta",
    decline: "Rifiuta",
    noAttending: "Non partecipi a nessun evento",
    noOrganized: "Non hai ancora creato eventi",
    createFirst: "Crea il primo evento",
    publishEvent: "Pubblica",
    completeEvent: "Completa",
    cancelEvent: "Annulla",
    noEnrolled: "Nessun iscritto",
    markPaid: "Segna pagato",
    exempt: "Esonera",
    payPending: "In attesa",
    payPaid: "Pagato",
    payWaived: "Esentato",
    payRefunded: "Rimborsato",
    invPending: "In attesa",
    invAccepted: "Accettato",
    invDeclined: "Rifiutato",
    invExpired: "Scaduto",
    invitesSent: "Inviti inviati",
    loadingInvites: "Caricamento…",
    noInvitesSent: "Nessun invito inviato",
    formTitleLbl: "Titolo *",
    formTitlePlaceholder: "Es. Gita alle Eolie",
    formTypeLbl: "Tipo evento *",
    formTypeSelect: "Seleziona…",
    formLocationLbl: "Luogo",
    formLocationPlaceholder: "Es. Stromboli, Sicilia",
    formStartLbl: "Data inizio *",
    formEndLbl: "Data fine",
    formMaxParticipantsLbl: "Max partecipanti",
    formFeeLbl: "Quota (€)",
    formFeePlaceholder: "0 = gratuito",
    formDescriptionLbl: "Descrizione",
    formPublicLbl: "Evento pubblico (visibile a tutti)",
    formDraftNote: "L'evento viene salvato come bozza. Potrai pubblicarlo dalla scheda \"I miei eventi\".",
    createDraft: "Crea bozza",
    enrolledCount: "{{count}} iscritti",
    leaveSuccess: "Hai abbandonato l'evento",
    subtitle: "Partecipa a gite, corsi ed eventi organizzati dalla community. Esplora le opportunità disponibili, accetta inviti e tieni traccia degli appuntamenti confermati.",
    discoverDesc: "Gite subacquee, immersioni guidate, corsi e pulizie del fondale organizzati da istruttori, divemaster e centri. Iscriviti con un click e unisciti all'avventura.",
    invitationsTitle: "I tuoi inviti in attesa",
    invitationsDesc: "Un istruttore o un amico ti ha invitato a partecipare a un evento. Accetta per iscriverti automaticamente, o rifiuta se non sei disponibile.",
    attendingTitle: "I tuoi eventi confermati",
    attendingDesc: "Qui trovi tutti gli eventi a cui sei iscritto. Puoi abbandonare un evento se i tuoi piani cambiano — l'organizzatore verrà notificato.",
    participantsLabel: "Partecipanti",
    inviteAccepted: "Invito accettato",
    inviteDeclined: "Invito rifiutato",
    payFree: "Gratuito",
  },
  qa: {
    title: "Forum Q&A",
    askQuestion: "Fai una Domanda",
    question: "Domanda",
    body: "Descrizione",
    tags: "Tag",
    answer: "Rispondi",
    acceptAnswer: "Accetta Risposta",
    accepted: "Accettata",
    views: "Visualizzazioni",
    answers: "Risposte",
    votes: "voti",
    acceptedAnswer: "Risposta accettata",
    tagsHint: "(separati da virgola)",
    tagsPlaceholder: "immersioni, sicurezza, attrezzatura",
    noQuestions: "Nessuna domanda trovata",
    askFirst: "Fai la prima domanda!",
    answerAccepted: "Risposta accettata",
    answerPublished: "Risposta pubblicata",
    questionPublished: "Domanda pubblicata",
  },
  medical: {
    title: "Cartelle Cliniche",
    overview: "Panoramica",
    reports: "Referti medici",
    labResults: "Esami di Laboratorio",
    imaging: "Diagnostica per Immagini",
    centerAccess: "Accesso Centri",
    bloodType: "Gruppo Sanguigno",
    emergencyContact: "Contatto di Emergenza",
    conditions: "Patologie",
    medications: "Farmaci",
    allergies: "Allergie",
    fitnessNotes: "Note Idoneità",
    editRecord: "Modifica Scheda",
    activeCenterAccess: "accesso/i attivo/i a centri diving",
    uploadLab: "Carica Esame",
    labName: "Laboratorio",
    testDate: "Data Esame",
    file: "File",
    upload: "Carica",
    noLabResults: "Nessun esame di laboratorio caricato",
    download: "Scarica file",
    addReport: "Aggiungi Referto",
    reportType: "Tipo Visita",
    issuedBy: "Rilasciato da",
    reportDate: "Data Visita",
    specialization: "Specializzazione",
    institution: "Struttura",
    fitToDive: "Idoneità",
    validUntil: "Valido Fino a",
    summary: "Sommario",
    attachFile: "Allega File",
    noReports: "Nessun referto medico presente",
    uploadImaging: "Carica Immagine Diagnostica",
    noImaging: "Nessuna diagnostica per immagini caricata",
    accessGrantsWarning: "Gli accessi consentono ai centri diving di leggere parti specifiche della tua cartella clinica. Puoi revocarli in qualsiasi momento.",
    grantAccess: "Concedi Accesso",
    centerIdLabel: "ID Centro Diving",
    selectScope: "Seleziona i dati condivisi",
    expiresAt: "Scade il",
    optional: "opzionale",
    noAccessGrants: "Nessun accesso attivo",
    revoke: "Revoca",
  },
  courseEligibility: {
    title: "Requisiti di accesso",
    eligible: "Hai tutti i requisiti",
    missing: "Ti manca ancora qualcosa",
    unknown: "non verificabile",
    MIN_AGE: "Età minima: {{required}} anni",
    MIN_TOTAL_DIVES: "Immersioni totali: {{actual}} su {{required}}",
    MIN_DIVES_AFTER_ENTRY: "Dopo il brevetto base: {{actual}} su {{required}}",
    MIN_SPECIAL_CONDITION_DIVES: "In condizioni particolari: {{actual}} su {{required}}",
    PREREQUISITE_LEVEL: "Brevetto richiesto: {{item}}",
    SUPPORT_CERT: "Brevetto di soccorso valido: {{item}}",
    MEDICAL_CERTIFICATE: "Certificato medico valido",
  },
  medQuestionnaire: {
    title: "Questionario medico",
    subtitle: "Compila e firma il questionario: serve al medico per valutare la tua idoneità.",
    disclaimer: "Il risultato è solo una segnalazione, non un'idoneità medica. Nel dubbio decide il medico.",
    noQuestionnaire: "Nessun questionario è ancora disponibile.",
    yes: "Sì",
    no: "No",
    unsure: "Non so",
    choose: "Scegli…",
    signerName: "Nome e cognome di chi firma",
    signConfirm: "Confermo che le risposte sono veritiere e le firmo",
    isMinor: "Chi compila è minorenne",
    guardianName: "Nome e cognome del tutore",
    guardianRelationship: "Relazione con il minore",
    guardianConfirm: "Il tutore conferma e firma",
    submit: "Firma e invia",
    sending: "Invio…",
    sendError: "Non è stato possibile inviare il questionario.",
    outcomeTitle: "Esito",
    outCLEAR: "Dalle risposte non emergono segnalazioni. Non è un'idoneità medica.",
    outNO_ACTIVE_RULES: "Risposte salvate. Non c'è ancora un controllo automatico attivo: la valutazione spetta al medico.",
    outDOUBT: "Alcune risposte richiedono la valutazione di un medico. È stata aperta una richiesta.",
    outRELATIVE: "Dalle risposte emerge un aspetto da far valutare a un medico. È stata aperta una richiesta.",
    outTEMPORARY: "Dalle risposte emerge un periodo di attesa. Serve la valutazione di un medico.",
    outABSOLUTE: "Dalle risposte emerge un aspetto che un medico deve valutare prima di immergerti.",
    waitUntil: "Attesa fino al",
    doctorOpened: "Richiesta al medico aperta",
    requestDoctor: "Chiedi la valutazione di un medico",
    requestSent: "Richiesta inviata al medico.",
    policyLabel: "Segnala le controindicazioni del questionario medico",
    policyHint: "Solo segnalazione: al check-in viene registrato un avviso interno. Nessun blocco finché non c'è la revisione di un medico.",
    requiresReview: "richiede revisione {{role}}",
  },
  adminRules: {
    title: "Regole in osservazione",
    subtitle: "Ogni regola nuova parte in sola segnalazione. Qui vedi quante volte avrebbe bloccato e decidi se renderla vincolante.",
    rule: "Regola",
    allowed: "Consentite",
    wouldDeny: "Avrebbe bloccato",
    denied: "Bloccate",
    lastViolation: "Ultima violazione",
    shadow: "Solo segnalazione",
    enforced: "Vincolante",
    enable: "Rendi vincolante",
    disable: "Torna a solo segnalazione",
    confirmEnable: "Rendere vincolante questa regola? Da questo momento le richieste che la violano verranno rifiutate.",
    empty: "Nessuna regola ha ancora registrato attività.",
    loadError: "Impossibile caricare le regole.",
    saveError: "Impossibile salvare la modifica.",
    hint: "Conviene passare a vincolante solo dopo almeno due settimane di misura, controllando che i casi segnalati siano davvero errori.",
  },
  dcCourseTeam: {
    open: "Team del corso",
    title: "Assistenti e tirocinanti",
    staff: "Membro dello staff",
    role: "Ruolo",
    ASSISTANT_INSTRUCTOR: "Assistente Istruttore",
    TRAINEE: "Tirocinante",
    assign: "Assegna",
    remove: "Rimuovi",
    none: "Nessun assistente o tirocinante.",
    internship: "Ore di tirocinio",
    total: "Totale",
    signedHours: "Firmate",
    pending: "Da firmare",
    date: "Data",
    hours: "Ore",
    activity: "Attività",
    log: "Registra ore",
    sign: "Firma",
    signed: "Firmata",
    error: "Operazione non riuscita.",
    sessions: "Sessioni e conduttore",
    noSessions: "Nessuna sessione.",
    conductor: "Chi conduce",
    conductorNone: "Non assegnato",
    conductorSaved: "Conduttore salvato.",
    ruleNotice: "Avviso della regola",
  },
  dcSheet: {
    handover: "Passaggio barca",
    handoverHint: "Per le immersioni autonome: consegna al comandante prima che il gruppo scenda. Modificare le voci annulla la firma.",
    handover_safety_assistant_assigned: "Assistente di sicurezza assegnato",
    handover_oxygen_on_board: "Ossigeno a bordo",
    handover_return_time_agreed: "Orario di rientro concordato",
    handover_dive_plan_shared: "Piano d’immersione condiviso",
    handover_emergency_contacts_given: "Contatti d’emergenza consegnati",
    handover_recall_signal_agreed: "Segnale di richiamo concordato",
    captainName: "Comandante",
    handoverSign: "Firma il passaggio",
    handoverSigned: "Firmato il",
    handoverMissing: "Mancano voci: la firma non è possibile.",
    risks: "Analisi dei rischi",
    risksHint: "Valuta ogni classe e indica che cosa fai per ridurre i rischi alti.",
    riskClass_ENVIRONMENT: "Ambiente",
    riskClass_EQUIPMENT: "Attrezzatura",
    riskClass_PEOPLE: "Persone",
    riskClass_GAS_AND_DECOMPRESSION: "Gas e decompressione",
    riskClass_BOAT_AND_SURFACE: "Barca e superficie",
    riskClass_EMERGENCY_ACCESS: "Accesso ai soccorsi",
    riskClass_MARINE_LIFE: "Fauna e flora",
    riskLevel_NONE: "Nessuno",
    riskLevel_LOW: "Basso",
    riskLevel_MEDIUM: "Medio",
    riskLevel_HIGH: "Alto",
    riskNotAssessed: "Non valutato",
    riskMitigation: "Misura per ridurre il rischio",
    whatIf: "E se…",
    whatIfScenario: "Scenario",
    whatIfResponse: "Che cosa facciamo",
    whatIfAdd: "Aggiungi scenario",
    whatIfRemove: "Rimuovi",
    riskWarn_high_without_mitigation: "Rischio alto senza misura di mitigazione: {{classes}}.",
    riskWarn_classes_not_assessed: "Classi non ancora valutate: {{classes}}.",
    plan: "Piano dell’immersione",
    planGas: "O2 della miscela (%)",
    planTurn: "Pressione di giro (bar)",
    planReserve: "Pressione di riserva (bar)",
    planStopDepth: "Profondità sosta (m)",
    planStopMin: "Durata sosta (min)",
    planAlternate: "Sito alternativo",
    planEmergency: "Piano d’emergenza",
    warn_depth_over_recreational_limit: "La profondità prevista supera il limite ricreativo.",
    warn_gas_mod_exceeded: "La miscela non regge la profondità prevista.",
    warn_reserve_not_below_turn: "La riserva deve essere inferiore alla pressione di giro.",
    warn_safety_stop_out_of_range: "La sosta di sicurezza è fuori dalla fascia 3–6 m.",
    autoChecks: "Verifiche automatiche",
    auto_ok: "Dati coerenti",
    auto_ko: "Da controllare",
    auto_unknown: "Non verificabile",
    open: "Foglio barca",
    title: "Foglio barca e debriefing",
    staff: "Staff",
    participants: "Partecipanti",
    crew: "Equipaggio",
    onBoard: "A bordo",
    status_NOT_CHECKED_IN: "A terra",
    status_IN_WATER: "In acqua",
    status_OVERDUE: "In ritardo",
    status_RETURNED: "Rientrato",
    briefing: "Briefing",
    medical_VALID: "Certificato valido",
    medical_EXPIRED: "Certificato scaduto",
    medical_MISSING: "Certificato mancante",
    medical_UNKNOWN: "Non verificabile",
    warnNoStaff: "Ci sono partecipanti ma nessuna guida o istruttore.",
    warnBriefing: "Briefing non ancora confermato da {{count}} partecipanti.",
    warnMedical: "Certificato medico scaduto o mancante per {{count}} partecipanti.",
    debriefing: "Debriefing",
    notes: "Note",
    save: "Salva",
    saved: "Salvato",
    error: "Operazione non riuscita.",
    topic_headcount_at_exit: "Appello all’uscita dall’acqua",
    topic_gas_remaining: "Gas rimasto",
    topic_incidents_and_notes: "Incidenti e osservazioni",
    topic_log_signed: "Logbook firmato",
    topic_lights_count: "Conteggio delle luci",
    topic_drift_log: "Registro della deriva",
    topic_repetitive_dive_limits: "Limiti per l’immersione ripetitiva",
    topic_exit_headcount: "Appello all’uscita",
    topic_reboard_order: "Ordine di risalita a bordo",
    briefingTitle: "Briefing in tre fasi e debriefing",
    briefingHint: "Spunta le voci man mano che le tratti: prima, durante e dopo l’immersione. Le voci si adattano al tipo di immersione.",
    kindsLabel: "Tipo di immersione",
    kind_NIGHT: "Notturna",
    kind_LOW_VISIBILITY: "Visibilità ridotta",
    kind_WRECK: "Relitto",
    kind_CURRENT: "Corrente",
    kind_DEEP: "Profonda",
    kind_WALL: "Parete",
    kind_SHORE: "Da riva",
    kind_BOAT: "Da barca",
    kind_DRIFT: "In deriva",
    phase_BEFORE: "Prima dell’immersione",
    phase_DURING: "Durante l’immersione",
    phase_AFTER: "Dopo l’immersione (debriefing)",
    briefingProgress: "{{done}} di {{total}}",
    rollEnter: "Segna in acqua",
    rollReturn: "Segna rientro",
    rollError: "Operazione non riuscita: controlla i requisiti del partecipante.",
    topic_site_and_conditions: "Sito e condizioni",
    topic_plan_depth_time: "Profondità e tempo previsti",
    topic_group_and_buddies: "Gruppo e coppie",
    topic_signals: "Segnali subacquei",
    topic_turn_pressure: "Pressione di giro",
    topic_emergency_procedure: "Procedura d’emergenza",
    topic_headcount_at_entry: "Conteggio all’ingresso",
    topic_buddy_checks: "Controlli tra compagni",
    topic_turn_pressure_check: "Controllo della pressione di giro",
    topic_safety_stop: "Sosta di sicurezza",
    topic_lights_backup: "Luci di riserva",
    topic_light_signals: "Segnali luminosi",
    topic_entry_exit_markers: "Segnali di ingresso e uscita",
    topic_stay_close: "Restare vicini",
    topic_contact_rules: "Regole di contatto",
    topic_guideline_or_tether: "Sagola o cima di collegamento",
    topic_lost_buddy_procedure: "Procedura per compagno perso",
    topic_reduced_spacing: "Distanze ridotte",
    topic_penetration_limits: "Limiti di penetrazione",
    topic_entanglement_hazards: "Rischi di impigliamento",
    topic_max_depth_on_wreck: "Profondità massima sul relitto",
    topic_no_overhead_without_training: "Niente ambienti sovrastati senza formazione",
    topic_current_direction: "Direzione della corrente",
    topic_surface_marker: "Boa di segnalazione",
    topic_pickup_plan: "Piano di recupero",
    topic_against_current_first: "Prima contro corrente",
    topic_depth_limit: "Limite di profondità",
    topic_gas_planning: "Pianificazione dei gas",
    topic_narcosis_awareness: "Consapevolezza della narcosi",
    topic_monitor_depth_time: "Controllo di profondità e tempo",
    topic_depth_limit_on_wall: "Limite di profondità lungo la parete",
    topic_buoyancy_discipline: "Disciplina dell’assetto",
    topic_wall_side_awareness: "Attenzione al lato della parete",
    topic_entry_exit_points: "Punti di entrata e uscita",
    topic_surf_conditions: "Condizioni del moto ondoso",
    topic_surface_swim: "Nuotata in superficie",
    topic_boat_rules: "Regole di bordo",
    topic_entry_technique: "Tecnica di entrata",
    topic_ascent_line_pickup: "Cima di risalita e recupero",
    topic_group_cohesion: "Coesione del gruppo",
    topic_stay_together: "Restare uniti",
  },
  career: {
    title: "Percorso professionale",
    subtitle: "Cosa ti manca per il livello successivo, calcolato sui brevetti verificati.",
    noPath: "Non c’è ancora un percorso: aggiungi un brevetto professionale.",
    loadError: "Impossibile caricare il percorso.",
    statusHELD: "Posseduto",
    statusNEXT: "Prossimo",
    statusLOCKED: "Più avanti",
    missing: "Cosa manca",
    allDone: "Hai raggiunto l’ultimo livello del percorso.",
    req_MIN_AGE: "Età minima: {{required}} anni",
    req_MIN_TOTAL_DIVES: "Immersioni totali: {{required}}",
    req_MIN_DIVES_AFTER_ENTRY: "Immersioni dopo il brevetto base: {{required}}",
    req_MIN_SPECIAL_CONDITION_DIVES: "Immersioni in condizioni particolari: {{required}}",
    req_PREREQUISITE_LEVEL: "Livello richiesto: {{item}}",
    req_SUPPORT_CERT: "Brevetto di soccorso valido: {{item}}",
    req_MEDICAL_CERTIFICATE: "Certificato medico valido",
    unknown: "dato non disponibile",
    cvTitle: "Curriculum professionale",
    certifications: "Brevetti",
    verified: "verificato",
    notVerified: "non verificato",
    memberships: "Qualifica annuale",
    currentYear: "in corso",
    dives: "Immersioni",
    divesTotal: "Totali",
    divesValidated: "Convalidate",
    noCerts: "Nessun brevetto registrato.",
  },
  anagraficaDup: {
    menuTruncated: "Mostrate le prime {{shown}} voci su {{total}}: unisci prima i più simili e riapri il menu.",
    hugeGroup: "Gruppo molto grande: probabilmente nato da un’importazione ripetuta.",
    showMoreMembers: "Mostra altri {{count}} record ({{hidden}} nascosti)",
    showMoreGroups: "Mostra altri {{count}} gruppi ({{hidden}} nascosti)",
  },
  clipboard: {
    copyFailed: "Copia non riuscita: seleziona il testo e copialo a mano.",
  },
  hardcoded: {
    fjNeedPlaceOrSpecies: "Inserisci almeno il luogo o una specie osservata",
    fjSaved: "Osservazione salvata",
    fjSaveError: "Errore nel salvataggio",
    fjDeleted: "Osservazione eliminata",
    fjDeleteError: "Errore nella cancellazione",
    fjExportDwc: "Export Darwin Core avviato",
    fjNothingToExport: "Nessuna osservazione da esportare",
    fjExportCsv: "Export CSV avviato",
    errTitle: "Ci scusiamo, qui qualcosa si è inceppato",
    errBody: "Non è colpa tua. Riprova, oppure torna alla dashboard: i tuoi dati sono al sicuro.",
    errDetails: "Dettagli tecnici (per assistenza)",
    errRetry: "Riprova",
    opFailed: "Operazione non riuscita",
    badgeHidden: "Badge nascosto agli utenti",
    badgeVisible: "Badge visibile agli utenti",
    fjSciName: "Nome scientifico *",
    fjCommonName: "Nome comune",
    fjNoObs: "Nessuna osservazione registrata",
    date: "Data",
    name: "Nome",
    partyDeleteUserTitle: "Eliminare definitivamente questo utente?",
    partyDeleteRecordTitle: "Eliminare questa anagrafica?",
    partyDeleteUserBody: "Verrà avviata la cancellazione GDPR dell’account <strong>{{name}}</strong> e di tutti i suoi contenuti (immersioni, brevetti, dati medici…). L’operazione è <strong>irreversibile</strong>.",
    partyDeleteRecordBody: "L’anagrafica di <strong>{{name}}</strong> non è un account registrato: verrà rimossa dal registro. L’operazione è <strong>irreversibile</strong>.",
    partyCrm: "Scheda CRM (interazioni/agenda)",
    boatsAddHint: "Aggiungi le barche del tuo centro per gestirne assicurazione e manutenzione",
    mktEmailRemoved: "Indirizzo {{email}} rimosso dall’anagrafica",
    mktNoContact: "Contatto marcato senza recapito",
    mktRemoveBody: "Sto per togliere <mono>{{email}}</mono> dall’anagrafica di <strong>{{name}}</strong>.",
    mktThisContact: "questo contatto",
    bookCertMissing: "Brevetto minimo <strong>{{level}}</strong> non tra i tuoi registrati.",
    bookCertOk: "Brevetto: requisito <strong>{{level}}</strong> soddisfatto.",
    bookCertNone: "Nessun brevetto minimo richiesto.",
    catalogBanner: "{{module}} è un modulo operativo sul <em>catalogo anagrafico unico</em>. I contatti vivono nell’Anagrafica; qui gestisci le funzioni specifiche del modulo.",
    ropaNote: "— Il titolare del trattamento tiene un registro delle attività di trattamento svolte. Obbligatorio per organizzazioni con più di 250 dipendenti <em>o</em> che trattano categorie particolari di dati (es. dati sanitari, biometrici).",
    adminDeleteWarn: "L’operazione è <strong>irreversibile</strong>. Il processo di eliminazione viene avviato immediatamente e completato entro pochi minuti.",
    shannonNote: "<strong>H’</strong> elevato → buona diversità nel tempo; H’=0 → tutti gli avvistamenti in un solo periodo",
    markdownHelp: "Usa <code>**testo**</code> per il <strong>grassetto</strong>, <code>_testo_</code> per il <em>corsivo</em>, <code>## Titolo</code> per le intestazioni. La descrizione è visibile a tutti gli utenti.",
    crmHubNote: "Queste funzioni non sono più nel pannello di Amministrazione: vivono qui, e le vede anche chi ha il ruolo <role>sales</role> senza essere amministratore.",
    dashPhotoHint: "Carica le tue immagini — l’AI di <strong>iNaturalist</strong> identifica la specie automaticamente · revisione del team di biologia marina",
    webhookSig: "Ogni chiamata includerà l’header <code>X-eDive-Signature</code> con HMAC-SHA256 del body per la verifica.",
    dupNote: "<b>Possibili duplicati</b> — record con lo stesso nome e cognome, segnalati dall’import quando ha trovato un omonimo. Sono ordinati per nome, così le due schede della stessa persona compaiono vicine: aprile per confrontarle e, se sono davvero la stessa persona, usa <b>Unisci</b> dalla scheda. Attenzione agli omonimi reali (persone diverse con lo stesso nome).",
    yourPosition: "La tua posizione",
    medBookDone: "Organizza la visita con <strong>{{name}}</strong>. Quando avrai il certificato di idoneità, caricalo nel tuo Fascicolo Sanitario indicando il suo nome.",
    medExternal: "Questo medico non è su eDive: organizzerai la visita direttamente con lui. Una volta ottenuto il certificato di idoneità, potrai <strong>caricarlo</strong> nel tuo Fascicolo Sanitario indicando il suo nome come emittente.",
    photoCopyright: "Caricando questa immagine, concedo a eDive il diritto di utilizzarla <strong>esclusivamente per la consultazione della banca dati</strong>. Non ne autorizzo la riproduzione, distribuzione o uso commerciale al di fuori di questo contesto.",
  },
  profile: {
    title: "Profilo",
    editProfile: "Modifica Profilo",
    profileType: "Tipo Profilo",
    certificationLevel: "Livello Certificazione",
    totalDives: "Immersioni Totali",
    nationality: "Nazionalità",
    bio: "Biografia",
    language: "Lingua",
    profileTypes: {
      USER: "Utente",
      DIVER: "Subacqueo",
      FREEDIVER: "Apneista",
      INSTRUCTOR: "Istruttore",
      DIVEMASTER: "Divemaster",
      DIVE_DOCTOR: "Medico Iperbarico",
      UNDERWATER_PHOTOGRAPHER: "Fotografo Subacqueo",
      RESEARCH_CENTER: "Centro di Ricerca",
      DIVE_CENTER: "Centro Diving",
      TRAVEL_AGENCY: "Agenzia Viaggi Sub",
      ASSOCIATION: "Associazione Culturale",
      ACADEMY: "Accademia",
      CHARTER_OPERATOR: "Operatore Charter",
      PROFESSIONAL_DIVER: "Operatore Subacqueo Professionale",
    },
    saved: "Profilo aggiornato con successo",
    avatar: "Foto profilo",
    changeAvatar: "Cambia foto",
    avatarUpdated: "Foto profilo aggiornata",
    tabs: {
      anagrafica: "Anagrafica",
      contatti: "Contatti",
      emergenza: "Emergenza",
      brevetti: "Brevetti",
      attrezzatura: "Attrezzatura",
      kyc: "Documenti",
      medico: "Medico",
      preferenze: "Preferenze",
      freediving: "Freediving",
      privacy: "Privacy & Dati",
      professionale: "Professionale",
      ruoli: "Accesso",
    },
    firstName: "Nome",
    lastName: "Cognome",
    dateOfBirth: "Data di Nascita",
    placeOfBirth: "Luogo di Nascita",
    gender: "Genere",
    genders: {
      MALE: "Maschio",
      FEMALE: "Femmina",
      OTHER: "Altro",
      PREFER_NOT_TO_SAY: "Preferisco non dirlo",
    },
    fiscalCode: "Codice Fiscale",
    displayName: "Nome Pubblico",
    mobilePhone: "Telefono Cellulare",
    homePhone: "Telefono di Casa",
    verified: "Verificato",
    notVerified: "Non verificato",
    address: "Indirizzo",
    street: "Via / Piazza",
    streetNumber: "Civico",
    municipality: "Comune",
    province: "Provincia",
    postalCode: "CAP",
    city: "Città",
    country: "Paese (codice ISO, es. IT)",
    website: "Sito Web",
    instagramHandle: "Instagram Handle",
    onlineSocial: "Profili Online",
    searchProvince: "Cerca provincia...",
    emergencyContact: "Contatto di Emergenza (ICE)",
    relationship: "Relazione",
    primaryPhone: "Telefono Principale",
    secondaryPhone: "Telefono Secondario",
    medicalNotes: "Note Mediche",
    noEmergencyContact: "Nessun contatto di emergenza impostato",
    certifications: "Brevetti",
    addCertification: "Aggiungi Brevetto",
    agency: "Ente Certificatore",
    level: "Livello",
    certNumber: "Numero Brevetto",
    issuedAt: "Data Rilascio",
    certCardPhoto: "Foto della tessera di certificazione",
    certCardFront: "Fronte",
    certCardBack: "Retro",
    certCardUploadHint: "Clicca per selezionare immagine",
    certCardUploadError: "Caricamento foto tessera fallito — puoi caricarla in seguito dal dettaglio del brevetto.",
    expiresAt: "Data Scadenza",
    equipment: "Attrezzatura",
    addEquipment: "Aggiungi Attrezzatura",
    brand: "Marca",
    model: "Modello",
    serialNumber: "Numero Seriale",
    purchasedAt: "Data Acquisto",
    lastService: "Ultimo Intervento",
    nextService: "Prossimo Intervento",
    logService: "Registra Manutenzione",
    equipmentTypes: {
      BCD: "Jacket / BCD",
      REGULATOR: "Erogatore",
      WETSUIT: "Muta",
      DRYSUIT: "Muta Stagna",
      MASK: "Maschera",
      FINS: "Pinne",
      COMPUTER: "Computer",
      TANK: "Bombola",
      TORCH: "Torcia",
      CAMERA: "Fotocamera",
      OTHER: "Altro",
    },
    kycStatus: "Stato Verifica",
    kycStatuses: {
      NOT_STARTED: "Non avviata",
      IN_PROGRESS: "In corso",
      VERIFIED: "Verificato",
      REJECTED: "Rifiutato",
    },
    documentType: "Tipo Documento",
    documentTypes: {
      IDENTITY_CARD: "Carta d'Identità",
      PASSPORT: "Passaporto",
      DRIVING_LICENSE: "Patente",
    },
    uploadFront: "Fronte",
    uploadBack: "Retro (opzionale)",
    uploadDocument: "Carica Documento",
    kycUploaded: "Documento caricato",
    kycDeleted: "Documento eliminato",
    noKycDocuments: "Nessun documento caricato",
    medicalCerts: "Certificati Medici",
    addMedicalCert: "Aggiungi Certificato",
    certType: "Tipo Certificato",
    certTypes: {
      AGONISTIC: "Agonistico",
      NON_AGONISTIC: "Non Agonistico",
    },
    fitnessCertExpiry: "Scadenza Idoneità",
    insurances: "Assicurazioni Subacquee",
    addInsurance: "Aggiungi Assicurazione",
    company: "Compagnia",
    policyNumber: "Numero Polizza",
    coverageType: "Tipo Copertura",
    expiry: "Scadenza",
    attachDoc: "Allega documento (opz.)",
    measurementUnit: "Unità di Misura",
    measurementUnits: {
      METRIC: "Metrico (m, kg)",
      IMPERIAL: "Imperiale (ft, lb)",
    },
    timezone: "Fuso Orario",
    personalRmv: "RMV Personale (l/min)",
    certifiedMaxDepth: "Profondità Massima Certificata (m)",
    privacyConsent: "Consenso al trattamento dei dati personali",
    marketingConsent: "Consenso comunicazioni promozionali",
    publicProfile: "Profilo pubblico",
    publicProfileHint: "Gli altri utenti possono vedere il tuo profilo",
    medicalHistory: {
      title: "Anamnesi Medica",
      subtitle: "Informazioni sanitarie personali per uso di emergenza",
      backToProfile: "Torna al profilo",
      bloodType: "Gruppo sanguigno",
      conditions: "Condizioni mediche",
      allergies: "Allergie",
      allergiesPlaceholder: "es. Penicillina, crostacei…",
      medications: "Farmaci",
      medicationsPlaceholder: "Elenca i farmaci attuali…",
      pathologies: "Patologie",
      pathologiesPlaceholder: "Patologie note…",
      diveRestrictions: "Restrizioni di immersione",
      diveRestrictionsPlaceholder: "es. profondità max 30 m…",
      emergencyNotes: "Note di emergenza",
      emergencyNotesPlaceholder: "Note per il personale di emergenza…",
      emergencyQr: "QR Emergenza",
      save: "Salva",
      saved: "Anamnesi salvata",
    },
    firstNameRequired: "Il nome è obbligatorio",
    lastNameRequired: "Il cognome è obbligatorio",
    relationshipRequired: "Il tipo di rapporto è obbligatorio",
    fieldRequired: "Campo obbligatorio",
    whatsappNumber: "Numero WhatsApp",
    whatsappHint: "Formato internazionale (es. +39 333 1234567). Consente ai centri e agli istruttori di contattarti direttamente.",
    kycGuidedVerify: "Verifica guidata",
    addCertTitle: "Aggiungi brevetto",
    selectAgency: "Seleziona didattica",
    selectCert: "Seleziona brevetto",
    depth: "Profondità",
    minAgeYears: "Età min: {{age}} anni",
    depthMax: "Profondità max",
    instructorNameLabel: "Nome istruttore",
    instructorNumberLabel: "N° istruttore",
    instructorOptional: "Nome istruttore (opzionale)",
    instructorNumberOptional: "N° istruttore (opzionale)",
    certSaved: "✓ salvata",
    certMissing: "⚠ Immagine Mancante",
    certReplace: "Sostituisci",
    certUploadFront: "Carica fronte",
    certUploadBack: "Carica retro",
    certSearchInstructor: "🔍 Ricerca istruttore in corso…",
    pathChooserNoRecognized: "I tuoi brevetti non sono stati riconosciuti nel database. Aggiungi i brevetti tramite la ricerca guidata per vedere i percorsi disponibili.",
    pathChooserNoCerts: "Aggiungi i tuoi brevetti nella scheda",
    pathChooserNoCertsTab: "I miei brevetti",
    pathChooserNoCertsSuffix: "per scoprire i corsi disponibili.",
    allAgencies: "Tutte le didattiche",
    allCategories: "Tutte le categorie",
    removeFilters: "Rimuovi filtri",
    coursesAvailable: "{{count}} corsi disponibili",
    noCourses: "Nessun corso disponibile con i filtri selezionati.",
    prerequisites: "Prerequisiti",
    categories: {
      Ricreativo: "Ricreativo",
      Soccorso: "Soccorso",
      "Specialità": "Specialità",
      Professionale: "Professionale",
      Tecnico: "Tecnico",
      Rebreather: "Rebreather",
      Overhead: "Overhead",
      Apnea: "Apnea",
      Mermaiding: "Mermaiding",
    },
    myBrevetti: "I miei brevetti",
    growthPath: "Percorso di crescita",
    equipCategory: "Categoria",
    purchasedDate: "Data acquisto",
    nextRevision: "Prossima revisione",
    equipNotes: "Note",
    equipFreeModel: "Inserisci liberamente il modello",
    equipSave: "Salva modifiche",
    equipSaving: "Salvataggio…",
    equipConfirmDelete: "Eliminare questa attrezzatura?",
    equipPurchased: "Acquistato",
    equipRevision: "Revisione",
    diveStyleLabel: "Stile di immersione preferito",
    diveStyleUnspecified: "Non specificato",
    diveStyleApnea: "Apnea (Freediving)",
    freediverLevelLabel: "Livello freediver",
    personalRecords: "Record personali apnea",
    staticApnea: "Apnea statica PB (sec)",
    dynamicApnea: "Apnea dinamica PB (m)",
    depthApnea: "Profondità apnea PB (m)",
    apneaStatic: "Statica",
    apneaDynamic: "Dinamica",
    apneaDepth: "Profondità",
    basicHealthData: "Dati Sanitari di Base",
    bloodTypeLabel: "Gruppo sanguigno",
    bloodTypeSelect: "— Seleziona —",
    allergiesLabel: "Allergie",
    medsLabel: "Farmaci correnti",
    conditionsLabel: "Patologie",
    restrictionsLabel: "Restrizioni subacquee",
    emergencyNotesLabel: "Note di emergenza",
    emergencyNotesHint: "(visibili al personale di soccorso)",
    savingLabel: "Salvataggio…",
    newCheck: "Nuovo check",
    symptomCheck: "Check Sintomi Post-Immersione",
    checksLast30: "{{count}} check ultimi 30gg",
    alertsLast30: "{{count}} allerte",
    lastCheckLabel: "Ultimo",
    sympLabels: {
      earPain: "Dolore orecchio",
      sinusPain: "Dolore seni nasali",
      headache: "Cefalea",
      jointPain: "Dolori articolari",
      musclePain: "Dolori muscolari",
      skinRash: "Manifestazioni cutanee",
      fatigue: "Affaticamento",
      breathingDiff: "Difficoltà respiratorie",
      chestPain: "Dolore toracico",
      dizziness: "Vertigini",
      vision: "Problemi visivi",
      numbness: "Formicolio/intorpidimento",
      nausea: "Nausea",
    },
    sympSevNone: "—",
    sympSevMild: "Lieve",
    sympSevModerate: "Moderato",
    sympSevSevere: "Grave",
    additionalNotes: "Note aggiuntive",
    sympAlertMsg: "Allerta sintomi: {{level}} — Il tuo medico è stato notificato.",
    sympCheckDone: "Check sintomi registrato.",
    sympSendError: "Errore durante l'invio.",
    sendCheck: "Invia check",
    sendingCheck: "Invio…",
    diveFitnessTitle: "Piano di Idoneità Subacquea",
    diveFitnessNone: "Nessun piano di idoneità attivo emesso dal tuo medico.",
    diveFitnessActive: "Attivo",
    diveFitnessIssued: "Emesso il {{date}}",
    diveFitnessValidUntil: "· valido fino al {{date}}",
    diveFitnessMaxDepth: "Max {{depth}} m",
    diveFitnessMaxDuration: "Max {{min}} min",
    diveFitnessMaxDives: "Max {{n}} imm/giorno",
    diveFitnessBuddy: "Buddy obbligatorio",
    diveFitnessOxygen: "O₂ di emergenza richiesto",
    cpEnvLabels: {
      OPEN_WATER: "Mare aperto",
      POOL: "Piscina",
      CONFINED: "Acque confinate",
      CAVE: "Grotta",
      WRECK: "Relitto",
      NIGHT: "Notturna",
      ALTITUDE: "Quota",
      ICE: "Ghiaccio",
      DRIFT: "Corrente",
    },
    exportDataTitle: "Esporta i tuoi dati",
    exportDataHint: "Ricevi una copia completa di tutti i dati che eDive conserva su di te (logbook, profilo, brevetti, ecc.). Il file sarà disponibile per 7 giorni.",
    exportAlreadyPending: "Richiesta già in corso",
    exportSending: "Invio…",
    exportRequest: "Richiedi esportazione",
    deleteAccountTitle: "Cancella il tuo account",
    deleteAccountHint: "Rimuove permanentemente tutti i tuoi dati personali da eDive.",
    deleteAlreadyPending: "Cancellazione già richiesta",
    deleteRequest: "Richiedi cancellazione account",
    deleteAreYouSure: "Sei sicuro? Questa azione non può essere annullata.",
    deleteConfirmBtn: "Sì, cancella il mio account",
    requestHistory: "Storico richieste",
    noRequests: "Nessuna richiesta inviata",
    downloadAvailable: "✓ Download disponibile",
    gdprStatusLabels: {
      PENDING: "In attesa",
      IN_PROGRESS: "In elaborazione",
      COMPLETED: "Completata",
      FAILED: "Fallita",
      CANCELLED: "Annullata",
    },
    instructorAgencies: "Didattiche",
    maxCertLevel: "Livello massimo insegnamento",
    dailyRate: "Tariffa giornaliera (€)",
    specialtiesTaught: "Specialità insegnate (separate da virgola)",
    teachingLanguages: "Lingue di insegnamento (separate da virgola)",
    publicBio: "Bio pubblica",
    showInDirectory: "Mostrami nella directory pubblica dei professionisti",
    availableOnline: "Disponibile per lezioni online",
    saveInstructorProfile: "Salva profilo istruttore",
    portfolioUrl: "URL Portfolio",
    photographicEquipment: "Attrezzatura fotografica",
    serviceAreas: "Zone di servizio (separate da virgola)",
    savePhotographerProfile: "Salva profilo fotografo",
    licenseNumber: "N. iscrizione albo / licenza",
    licenseCountry: "Paese di abilitazione",
    institutionLabel: "Istituzione / Camera iperbarica",
    cityLabel: "Città",
    specializationsLabel: "Specializzazioni (separate da virgola)",
    acceptsNewPatients: "Accetto nuovi pazienti per visite di idoneità",
    saveDoctorProfile: "Salva profilo medico",
    noExtendedProfile: "Nessun profilo professionale esteso per il tipo",
    centerProfileNote: "I centri diving e le agenzie di viaggio gestiscono il profilo nella sezione dedicata.",
    kycVerifiedBanner: "La tua identità è verificata (KYC). Le richieste di ruolo vengono approvate automaticamente in pochi minuti.",
    kycNotVerifiedBanner: "Senza verifica KYC, le richieste sono soggette a revisione manuale. Riceverai un contatto dall'amministratore entro 48 ore. Completa la verifica nella tab Documenti per l'approvazione automatica.",
    myRequests: "Le tue richieste",
    requestRoleTitle: "Richiedi accesso a un ruolo",
    requestRolePendingNote: "Non puoi fare più richieste per lo stesso ruolo finché quella precedente è in attesa.",
    motivationLabel: "Motivazione (opzionale)",
    roleStatusApproved: "Approvato",
    roleStatusPending: "In attesa",
    roleRequest: {
      backToProfile: "Torna al profilo",
      divemasterDesc: "Guidi subacquei certificati, assisti gli istruttori nei corsi e conduci immersioni ricreative. È il primo livello professionale.",
      instructorDesc: "Formi e certifichi nuovi subacquei in autonomia. È il livello professionale dedicato all'insegnamento.",
      noCerts: "Nessun brevetto idoneo",
      noCertsHint: "Non troviamo un brevetto adatto a questo ruolo tra quelli sul tuo profilo. Aggiungi il brevetto professionale corrispondente nella sezione Brevetti, poi torna qui per completare la richiesta.",
      stepCertHint: "Scegli il brevetto che attesta la tua qualifica di",
      stepRoleHint: "Quale qualifica professionale vuoi attivare?",
      steps: {
        cert: "Brevetto",
        selectRole: "Ruolo",
        summary: "Riepilogo",
      },
      submitBtn: "Invia richiesta",
      submitError: "Non è stato possibile inviare la richiesta. Riprova.",
      subtitle: "Attiva la tua qualifica professionale in pochi passaggi.",
      successMsg: "Abbiamo ricevuto la tua richiesta. Verificheremo il brevetto e ti avviseremo appena il ruolo sarà attivo sul tuo profilo.",
      successTitle: "Richiesta inviata",
      summaryAgencyLabel: "Agenzia",
      summaryCardNumLabel: "Numero brevetto",
      summaryCertLabel: "Brevetto",
      summaryFooter: "Verifica i dati prima di inviare: verranno trasmessi al team eDive per la convalida del ruolo.",
      summaryIssuedLabel: "Data di rilascio",
      summaryRoleLabel: "Ruolo richiesto",
      title: "Richiedi un ruolo professionale",
      btn: "Richiedi",
    },
    guidedWizard: "✨ Wizard guidato",
    roleStatusRejected: "Rifiutato",
    roles: {
      ASSISTANT_INSTRUCTOR: "Assistente Istruttore",
      INSTRUCTOR: "Istruttore",
      DIVEMASTER: "Divemaster",
      DIVE_DOCTOR: "Medico Subacqueo",
      DIVE_CENTER: "Centro Diving",
      TRAVEL_AGENCY: "Agenzia Viaggi",
      ASSOCIATION: "Associazione",
      ACADEMY: "Accademia",
      UNDERWATER_PHOTOGRAPHER: "Fotografo Subacqueo",
      RESEARCH_CENTER: "Centro Ricerca",
    },
    rolesDesc: {
      ASSISTANT_INSTRUCTOR: "Teoria e acque delimitate sotto la supervisione di un istruttore",
      INSTRUCTOR: "Gestione corsi e allievi",
      DIVEMASTER: "Guida immersioni e logbook avanzato",
      DIVE_DOCTOR: "Certificazioni mediche e idoneità",
      DIVE_CENTER: "Gestione centro, prenotazioni, staff",
      TRAVEL_AGENCY: "Pacchetti viaggio subacquei",
      ASSOCIATION: "Gestione associazione e soci",
      ACADEMY: "Formazione e programmi di certificazione",
      UNDERWATER_PHOTOGRAPHER: "Portfolio e commissioni fotografiche",
      RESEARCH_CENTER: "Ricerca scientifica marina",
    },
    notifSectionSocial: "Social",
    notifSectionDiving: "Immersioni & Corsi",
    notifSectionEquip: "Attrezzatura & Shop",
    notifSectionHealth: "Salute & Assicurazioni",
    notifSocialLabel: "Attività social",
    notifSocialDesc: "Follower, like, richieste buddy",
    notifBuddyLabel: "Radar buddy",
    notifBuddyDesc: "Corrispondenze dal radar buddy",
    notifAchievLabel: "Traguardi",
    notifAchievDesc: "Badge, sfide e progressi",
    notifBookingsLabel: "Prenotazioni",
    notifBookingsDesc: "Conferme, modifiche e cancellazioni",
    notifCoursesLabel: "Corsi & Brevetti",
    notifCoursesDesc: "Lezioni, valutazioni, certificati",
    notifEventsLabel: "Eventi & Escursioni",
    notifEventsDesc: "Inviti ed aggiornamenti eventi",
    notifSafetyLabel: "Sicurezza & KYC",
    notifSafetyDesc: "Alerting di sicurezza, stato KYC",
    notifEquipLabel: "Manutenzione gear",
    notifEquipDesc: "Scadenze e avvisi manutenzione",
    notifMerchLabel: "Ordini shop",
    notifMerchDesc: "Conferme e aggiornamenti ordini",
    notifLoyaltyLabel: "Punti fedeltà",
    notifLoyaltyDesc: "Upgrade tier e gift card",
    notifInsuranceLabel: "Assicurazioni",
    notifInsuranceDesc: "Scadenza polizze",
    aiLogbookTitle: "Riepilogo AI logbook",
    aiLogbookRefresh: "Rigenera",
    aiLogbookGenerate: "Genera",
    aiLogbookHint: "Clicca \"Genera\" per una descrizione AI del tuo percorso da subacqueo.",
    divesCount: "immersioni",
    countriesCount: "paesi",
    addCertLink: "Aggiungi brevetto",
    addGearLink: "Aggiungi attrezzatura",
    viewPublicProfile: "Vedi profilo pubblico",
    checkinQr: "QR Check-in",
    notifPrefsTitle: "Preferenze notifiche",
    notifPrefsSaved: "Le preferenze si salvano automaticamente",
    notifLoadingPrefs: "Caricamento preferenze…",
    profileCompleteBanner: "Completa il profilo in 2 minuti",
    profileCompleteBannerHint: "Nome, contatti, contatto emergenza e preferenze — tutto in un wizard guidato.",
    profileStartWizard: "Avvia wizard",
    depthFromLogbook: "Dal logbook: {{depth}} m — clicca per usarlo",
    certWizard: {
      title: "Aggiungi brevetto",
      subtitle: "Registra una certificazione subacquea nel tuo profilo",
      steps: {
        agency: "Agenzia",
        cert: "Brevetto",
        data: "Dati",
        summary: "Riepilogo",
      },
      stepAgencyHint: "Seleziona l'agenzia di certificazione che ha rilasciato il brevetto.",
      stepDataCardNumber: "Numero tessera / card",
      stepDataIssueDate: "Data conseguimento",
      stepDataInstructor: "Nome istruttore",
      stepDataInstructorNum: "N° istruttore",
      stepDataOptionalHint: "Tutti i campi sono opzionali ma aiutano a completare il tuo profilo e a generare il QR di verifica.",
      summaryAgency: "Agenzia",
      summaryCert: "Brevetto",
      summaryCategory: "Categoria",
      summaryDepth: "Profondità",
      summaryCardNum: "N° tessera",
      summaryDate: "Data",
      summaryInstructor: "Istruttore",
      summaryFooter: "Il brevetto verrà aggiunto al tuo profilo e apparirà nel portafoglio digitale.",
      addBtn: "Aggiungi brevetto",
      saveSuccess: "Brevetto aggiunto!",
      saveError: "Errore nel salvataggio",
    },
    equipWizard: {
      title: "Aggiungi attrezzatura",
      subtitle: "Registra un nuovo pezzo di equipaggiamento",
      steps: {
        type: "Tipo",
        brandModel: "Marca e modello",
        purchase: "Acquisto e manutenzione",
        summary: "Riepilogo",
      },
      brandLabel: "Marca",
      modelLabel: "Modello",
      serialLabel: "Numero seriale",
      serialPlaceholder: "Sulla targhetta dell'attrezzatura",
      purchasedLabel: "Data acquisto",
      nextRevisionLabel: "Prossima revisione",
      notesLabel: "Note",
      notesPlaceholder: "Configurazioni, modifiche, storia manutenzioni…",
      pastRevisionWarning: "⚠️ La data di revisione è nel passato — controlla che l'attrezzatura sia stata revisionata.",
      summarySeriale: "Seriale",
      summaryAcquisto: "Acquisto",
      summaryRevisione: "Revisione",
      addBtn: "Aggiungi al profilo",
      nextRevisionNote: "Prossima revisione: {{date}}",
      saveSuccess: "Attrezzatura aggiunta!",
      saveError: "Errore nel salvataggio",
    },
    certScan: {
      title: "Scansiona brevetto con AI",
      scanCta: "Scansiona brevetto",
      uploadStep: "1 · Carica immagine",
      scanningStep: "2 · Analisi AI in corso…",
      reviewStep: "2 · Verifica i dati estratti",
      uploadingStep: "3 · Salvataggio…",
      doneStep: "3 · Completato",
      uploadHint: "Scatta una foto o seleziona l'immagine del tuo brevetto. L'AI estraggerà automaticamente agenzia, nome del brevetto, numero e scadenza.",
      dropHere: "Trascina la foto del brevetto qui",
      orClick: "oppure clicca per selezionare un file",
      formats: "JPEG · PNG · WEBP · HEIC — max 8 MB",
      manualEntry: "Preferisci inserire i dati manualmente?",
      invalidImage: "Seleziona un file immagine (JPEG, PNG, WEBP)",
      scanning: "Analisi in corso…",
      claudeReading: "Claude sta leggendo il brevetto",
      scanFields: {
        agency: "Agenzia",
        certName: "Nome brevetto",
        certNumber: "Numero certificato",
        expiry: "Scadenza",
      },
      extractedData: "Dati estratti dall'immagine",
      holderDetected: "Titolare rilevato",
      confidenceHigh: "Alta confidenza",
      confidenceMedium: "Confidenza media — verifica i dati",
      confidenceLow: "Bassa confidenza — compila manualmente",
      cancelBtn: "Annulla",
      uploadBtn: "Carica brevetto",
      savingMsg: "Salvataggio brevetto…",
      doneTitle: "Brevetto caricato!",
      doneMsg: "Il team verificherà il documento — ti avviseremo via email.",
      closeBtn: "Chiudi",
      extractionFailed: "Estrazione dati fallita — compila manualmente",
      submitFailed: "Invio fallito — riprova",
      queueTitle: "Scansiona brevetti con AI",
      queueHeader: "Scansione brevetti",
      queueHint: "Puoi caricare più brevetti contemporaneamente. L'AI estrae automaticamente agenzia, nome, numero, istruttore e scadenza. La coda viene conservata anche se navighi ad altre pagine.",
      inQueue: "{{count}} in coda",
      toComplete: "{{count}} da completare",
      dropMultipleHere: "Trascina le foto dei brevetti",
      dropMultipleHint: "oppure clicca · JPEG, PNG, WEBP · max 8 MB · più file contemporaneamente",
      invalidImages: "Seleziona immagini valide (JPEG, PNG, WEBP — max 8 MB)",
      statusScanning: "Analisi in corso…",
      statusNeedsReview: "Completa i dati",
      statusUploading: "Salvataggio…",
      statusDone: "Caricato",
      statusError: "Errore",
      aiReading: "L'AI sta leggendo il brevetto…",
      retryTooltip: "Riprova analisi AI",
      retryNoFile: "Ricarica il file per riprovare",
      discardBtn: "Scarta",
      uploadCertBtn: "Carica brevetto",
      uploadSuccess: "Brevetto caricato — in attesa di verifica",
      uploadFailed: "Invio fallito — riprova",
      fileUnavailable: "File non disponibile — ricaricalo per riprovare",
      holderLabel: "Titolare",
    },
    consents: {
      title: "Gestione Consensi",
      subtitle: "Puoi modificare le tue preferenze di consenso in qualsiasi momento.",
    },
    privacyConsentHint: "Richiesto per utilizzare il servizio (art. 13 GDPR)",
    marketingConsentHint: "Newsletter, offerte e aggiornamenti da eDive",
  },
  divecenter: {
    title: "Centro Diving",
    trips: "Viaggi",
    newTrip: "Nuovo Viaggio",
    equipment: "Attrezzatura in Vendita",
    newEquipment: "Nuovo Articolo",
    instructors: "Istruttori",
    manageBookings: "Gestisci Prenotazioni",
    centerInfo: "Informazioni Centro",
    services: "Servizi Offerti",
    certifications: "Certificazioni",
    phone: "Telefono",
    address: "Indirizzo",
    website: "Sito Web",
  },
  admin: {
    title: "Amministrazione",
    clips: {
      title: "Moderazione eDive Live",
      subtitle: "Rivedi le clip inviate dalla community prima che compaiano in vetrina.",
      empty: "Nessuna clip in attesa. Tutto in ordine! 🌊",
      approve: "Pubblica",
      reject: "Rifiuta",
      rejectTitle: "Motivo del rifiuto",
      rejectDesc: "Spiega con gentilezza cosa non va: l'autore lo leggerà e potrà riprovare.",
      rejectPlaceholder: "Es. il video è troppo mosso, o mostra dati personali…",
      confirmReject: "Rifiuta la clip",
    },
    users: "Utenti",
    totalUsers: "Utenti Totali",
    activeUsers: "Utenti Attivi",
    newUsers: "Nuovi Utenti (7 giorni)",
    manageUsers: "Gestisci Utenti",
    content: "Gestione Contenuti",
    reports: "Report",
    systemHealth: "Stato Sistema",
    roles: "Ruoli",
    makeAdmin: "Rendi Amministratore",
    removeAdmin: "Rimuovi Amministratore",
    deleteUser: "Elimina Utente",
    confirmDelete: "Sei sicuro di voler eliminare questo utente?",
    liveUsers: {
      tabLabel: "Utenti Live",
      title: "Utenti Online in Tempo Reale",
      subtitle: "Aggiornamento automatico ogni 30 secondi",
      totalOnline: "Utenti connessi",
      totalDesc: "Sessioni WebSocket attive negli ultimi 60 secondi",
      noUsersOnline: "Nessun utente connesso in questo momento",
      lastRefresh: "Ultimo aggiornamento",
      impersonate: "Impersona",
      byRole: "Per categoria",
    },
    email: {
      pageTitle: "Email",
      pageDesc: "Diario delle email inviate, template registrati e statistiche di consegna.",
      tabLogs: "Diario invii",
      tabTemplates: "Template",
      tabStats: "Statistiche",
      searchPlaceholder: "Cerca per nome, cognome o email...",
      allTemplates: "Tutti i template",
      emailsFound: "{{count}} email trovate",
      loading: "Caricamento...",
      noEmails: "Nessuna email registrata",
      colDate: "Data/ora",
      colTemplate: "Template",
      colRecipient: "Destinatario",
      colEmail: "Email",
      colSubject: "Oggetto",
      colStatus: "Stato",
      prevPage: "← Precedente",
      nextPage: "Successiva →",
      pageOf: "Pagina {{page}} di {{total}}",
      subject: "Oggetto",
      updatedAt: "Aggiornato {{date}}",
      preview: "Anteprima →",
      noTemplates: "Nessun template salvato. I template vengono registrati automaticamente al primo invio.",
      statsByTemplate: "Invii per template",
      statsLast30: "Invii ultimi 30 giorni",
      noData: "Nessun dato disponibile",
      sent: "inviati",
      failed: "falliti",
      loadingPreview: "Caricamento anteprima...",
      tplWelcome: "Benvenuto",
      tplPasswordReset: "Reset Password",
      tplMfaOtp: "Codice OTP",
      tplGdprExport: "Export GDPR",
      tplImageApproved: "Foto Approvata",
      tplImageRejected: "Foto Rifiutata",
      tplBookingReceived: "Prenotazione Ricevuta",
      tplBookingConfirmed: "Prenotazione Confermata",
      tplLessonRequested: "Lezione Privata Richiesta",
      tplLessonAccepted: "Lezione Privata Accettata",
      tplLessonDeclined: "Lezione Privata Rifiutata",
      tplSessionCancelled: "Sessione Annullata",
      tplContactForm: "Modulo Contatti",
      drillByTemplate: "Email",
      drillByDay: "Email del",
      editProfile: "Modifica profilo",
      clickRowHint: "Clicca su una riga per vedere i destinatari",
      clickBarHint: "Clicca su una barra per vedere i destinatari di quel giorno",
    },
    page: {
      roleUser: "Utente",
      roleAdmin: "Amministratore",
      roleDivemaster: "Divemaster",
      roleInstructor: "Istruttore",
      roleDiver: "Subacqueo",
      roleFreediver: "Apneista",
      roleMedical: "Medico",
      roleDiveCenter: "Centro Immersioni",
      roleTravelAgency: "Agenzia Viaggi",
      roleUnderwaterPhotographer: "Fotografo Subacqueo",
      roleResearchCenter: "Centro di Ricerca",
      unlockReason1: "Avvenuto pagamento",
      unlockReason2: "Bonus",
      unlockReason3: "Premio fedeltà",
      unlockReason4: "Premio Attività di Promozione",
      lockedTrialExpired: "Trial scaduto (30 gg)",
      lockedAdminSuspended: "Sospeso manualmente",
      unlockModalTitle: "Sblocca account — {{email}}",
      unlockCurrentLockReason: "Motivo blocco attuale",
      unlockNotSpecified: "Non specificato",
      unlockTrialExpiredOn: "Trial scaduto il {{date}}",
      unlockCausal: "Causale sblocco *",
      unlockTrialNote: "Il nuovo trial decorre da oggi per 30 giorni.",
      unlockCancel: "Annulla",
      unlockPending: "Sblocco…",
      unlockSubmit: "Sblocca account",
      unlockSuccess: "Account {{email}} sbloccato",
      unlockError: "Errore durante lo sblocco",
      unlocksTitle: "Gestione sblocco utenze",
      unlocksSubtitle: "Account limitati dopo 30 giorni di trial e sblocchi eseguiti",
      unlocksTabLocked: "Account bloccati ({{count}})",
      unlocksTabHistory: "Storico sblocchi",
      unlocksTotalBlocked: "Totale bloccati",
      unlocksTrialExpired: "Trial scaduto",
      unlocksSuspended: "Sospesi manualmente",
      unlocksUnknownReason: "Motivo non specificato",
      unlocksFilterAll: "Tutti",
      unlocksFilterTrial: "Trial scaduto",
      unlocksFilterSuspended: "Sospesi manualmente",
      unlocksLoading: "Caricamento…",
      unlocksNoLocked: "Nessun account bloccato",
      unlocksAllActive: "Tutti gli account sono attivi",
      unlocksColUser: "Utente",
      unlocksColRoles: "Ruoli",
      unlocksColLockReason: "Motivo blocco",
      unlocksColTrialExpired: "Trial scaduto",
      unlocksColRegistered: "Registrato",
      unlocksColActions: "Azioni",
      unlocksNd: "N/D",
      unlocksUnlockBtn: "Sblocca",
      unlocksHistoryColUser: "Utente sbloccato",
      unlocksHistoryColCausal: "Causale sblocco",
      unlocksHistoryColPrevious: "Precedente motivo",
      unlocksHistoryColAdmin: "Admin",
      unlocksHistoryColDate: "Data",
      unlocksNoHistory: "Nessuno sblocco registrato",
      roleModalTitle: "Ruoli — {{email}}",
      roleModalCancel: "Annulla",
      roleModalSaving: "Salvataggio…",
      roleModalSave: "Salva ruoli",
      usersTotal: "Utenti totali",
      usersAdmins: "Amministratori",
      usersSuspended: "Sospesi",
      usersSearchPlaceholder: "Cerca per email esatta…",
      usersColEmail: "Email",
      usersColStatus: "Stato",
      usersColRoles: "Ruoli",
      usersColCreated: "Creato",
      usersManageRoles: "Gestisci ruoli",
      usersImpersonate: "Impersona",
      usersResendVerificationTitle: "Reinvia email di conferma",
      usersResendVerificationSent: "Email di conferma reinviata a {{email}}",
      usersReactivate: "Riattiva",
      usersActivate: "Attiva",
      usersActivateConfirm: "Attivare l'account di {{email}} senza attendere la verifica email?",
      usersSuspend: "Sospendi",
      usersDelete: "Elimina",
      usersSuspendConfirm: "Sospendere {{email}}?",
      usersDeleteConfirm: "Eliminare definitivamente {{email}}?",
      dmFilterAll: "Tutti",
      dmFilterPending: "In attesa",
      dmFilterActive: "Attivi",
      dmFilterSuspended: "Sospesi",
      dmResults: "{{count}} risultati",
      dmLoading: "Caricamento…",
      dmEmpty: "Nessun divemaster trovato",
      dmColUserId: "User ID",
      dmColServices: "Servizi",
      dmColStatus: "Stato",
      dmColApplication: "Candidatura",
      dmStatusSuspended: "Sospeso",
      dmStatusActive: "Attivo",
      dmStatusPending: "In attesa",
      dmApprove: "Approva",
      dmSuspend: "Sospendi",
      dmSuspendModalTitle: "Sospendi Divemaster",
      dmSuspendReasonPlaceholder: "Motivo della sospensione…",
      dmSuspendCancel: "Annulla",
      dmSuspendSending: "Invio…",
      dmSuspendConfirm: "Sospendi",
      kycFilterPending: "Da verificare",
      kycFilterVerified: "Verificati",
      kycFilterRejected: "Rifiutati",
      kycDocuments: "{{count}} documenti",
      kycLoading: "Caricamento…",
      kycEmpty: "Nessun documento trovato",
      kycColUser: "Utente",
      kycColDocument: "Documento",
      kycColUploaded: "Caricato",
      kycColStatus: "Stato",
      kycDocIdCard: "Carta identità",
      kycDocPassport: "Passaporto",
      kycDocDrivingLicense: "Patente",
      kycStatusPending: "Da verificare",
      kycStatusVerified: "Verificato",
      kycStatusRejected: "Rifiutato",
      kycVerify: "Verifica",
      kycReject: "Rifiuta",
      kycRejectModalTitle: "Rifiuta documento KYC",
      kycRejectPlaceholder: "Motivo del rifiuto (visibile all'utente)…",
      kycRejectCancel: "Annulla",
      kycRejectSending: "Invio…",
      kycRejectConfirm: "Rifiuta",
      logbookTitle: "Importa logbook per un subacqueo",
      logbookDesc: "Seleziona un utente registrato e carica il file di esportazione del suo computer subacqueo (.db Shearwater, .uddf, .sml, .csv, .gpx, .fit, .xml, .txt).",
      logbookSearchLabel: "Cerca subacqueo",
      logbookSearchPlaceholder: "Cerca per email…",
      logbookLoading: "Caricamento…",
      logbookChange: "Cambia",
      logbookImporting: "Importazione in corso…",
      logbookChooseFile: "Scegli file e importa",
      logbookResultTitle: "Risultato importazione",
      logbookImported: "importate",
      logbookSkipped: "saltate (duplicate)",
      logbookErrors: "errori",
      subQueueTitle: "Coda richieste utenti",
      subStatusPending: "In attesa",
      subStatusProcessing: "In lavorazione",
      subStatusDone: "Completato",
      subStatusError: "Errore",
      subStatusRejected: "Rifiutato",
      subLoading: "Caricamento…",
      subEmpty: "Nessuna submission con stato \"{{status}}\"",
      subEmptyAll: "Nessuna submission",
      subProcess: "Importa",
      subProcessing: "Elaborazione…",
      subReject: "Rifiuta",
      subRejectPlaceholder: "Motivo del rifiuto (opzionale)",
      subConfirm: "Conferma",
      subCancel: "Annulla",
      subAdminNotes: "Note admin: {{notes}}",
      subRejected: "Submission rifiutata",
      proposalFilterPending: "In attesa",
      proposalFilterApproved: "Approvate",
      proposalFilterRejected: "Rifiutate",
      proposalCount: "{{count}} proposte",
      proposalLoading: "Caricamento…",
      proposalEmpty: "Nessuna proposta trovata",
      proposalStatusPending: "In attesa",
      proposalStatusApproved: "Approvata",
      proposalStatusRejected: "Rifiutata",
      proposalSubmittedOn: "inviata il {{date}}",
      proposalSiteId: "Sito ID: {{id}}",
      proposalSiteRef: "→ sito #{{id}}",
      proposalDepthMin: "Prof. min",
      proposalDepthMax: "Prof. max",
      proposalVisibility: "Visibilità",
      proposalWater: "Acqua",
      proposalProposerNotes: "Note del proponente",
      proposalReviewerNotes: "Note revisore",
      proposalProposerId: "ID proponente: {{id}}",
      proposalApproveBtn: "Approva",
      proposalRejectBtn: "Rifiuta",
      proposalApproveTitle: "Approva proposta",
      proposalRejectTitle: "Rifiuta proposta",
      proposalApproveNote: "Il punto di immersione verrà creato nell'archivio e marcato come verificato.",
      proposalApproveNotesPlaceholder: "Note facoltative per il proponente…",
      proposalRejectNotesPlaceholder: "Motivo del rifiuto (facoltativo)…",
      proposalModalCancel: "Annulla",
      proposalSending: "Invio…",
      proposalApproveConfirm: "Conferma approvazione",
      proposalRejectConfirm: "Conferma rifiuto",
      diffBeginner: "Principiante",
      diffIntermediate: "Intermedio",
      diffAdvanced: "Avanzato",
      diffTechnical: "Tecnico",
      typeReef: "Barriera",
      typeWall: "Parete",
      typeWreck: "Relitto",
      typeCave: "Grotta",
      typeDrift: "Corrente",
      typeShore: "Da riva",
      typeNight: "Notturna",
      typeTraining: "Training",
      securityTitle: "Monitoraggio Sicurezza",
      securityAutoRefresh: "Auto-aggiornamento (30s)",
      securityEventsToday: "Eventi oggi",
      securityLastHour: "Ultima ora",
      securityBlockedIps: "IP bloccati",
      securityBlockedIpsTitle: "Blocchi IP attivi",
      securityBlockIp: "+ Blocca IP",
      securityIpLabel: "Indirizzo IP",
      securityExpiresIn: "Scade tra (secondi, opzionale)",
      securityReason: "Motivo",
      securityBlockCancel: "Annulla",
      securityBlocking: "Blocco…",
      securityBlockBtn: "Blocca",
      securityNoBlockedIps: "Nessun IP bloccato",
      securityColIp: "IP",
      securityColReason: "Motivo",
      securityColBlockedBy: "Bloccato da",
      securityColBlockedAt: "Bloccato il",
      securityColExpires: "Scade",
      securityUnblockBtn: "Sblocca",
      securityUnblockConfirm: "Sbloccare {{ip}}?",
      securityFailedTitle: "Tentativi falliti (ultime 24h)",
      securityNoFailed: "Nessun tentativo fallito",
      securityColAttempts: "Tentativi",
      securityColLast: "Ultimo",
      securityBruteForceReason: "Brute force — tentativi multipli falliti",
      securityEventsTitle: "Log eventi di sicurezza",
      securityFilterAllSeverity: "Tutte le severità",
      securityFilterAllTypes: "Tutti i tipi",
      securityFilterIpPlaceholder: "Filtra per IP…",
      securityEventsTotal: "{{count}} eventi totali",
      securityPrev: "← Precedente",
      securityNext: "Successiva →",
      securityColDate: "Data",
      securityColType: "Tipo",
      securityColSeverity: "Severità",
      securityColEndpoint: "Endpoint",
      securityColDetails: "Dettagli",
      securityColUser: "Utente",
      securityColDevice: "Dispositivo",
      securityEmpty: "Nessun evento trovato",
      apiKeysTitle: "API Keys B2B",
      apiKeysTotal: "{{count}} chiavi totali",
      apiKeysEmpty: "Nessuna chiave API registrata",
      apiKeysColName: "Nome",
      apiKeysColPrefix: "Prefix",
      apiKeysColScopes: "Scopes",
      apiKeysColOrg: "Org",
      apiKeysColRateLimit: "Rate limit",
      apiKeysColStatus: "Stato",
      apiKeysColLastUsed: "Ultimo uso",
      apiKeysColExpiry: "Scadenza",
      apiKeysActive: "Attiva",
      apiKeysRevoked: "Revocata",
      apiKeysRevokeConfirm: "Revocare questa chiave?",
      apiKeysRevokeTitle: "Revoca chiave",
      apiKeysRevokeSuccess: "Chiave revocata",
      apiKeysRevokeError: "Errore nella revoca",
      apiKeysLoading: "Caricamento...",
      kycIamSubmissions: "{{count}} sottomissioni",
      kycIamLoading: "Caricamento…",
      kycIamEmpty: "Nessuna sottomissione KYC",
      kycIamStatusPending: "In attesa",
      kycIamStatusReviewing: "In revisione",
      kycIamStatusApproved: "Approvata",
      kycIamStatusRejected: "Rifiutata",
      kycIamColUserId: "User ID",
      kycIamColDocument: "Documento",
      kycIamColCountry: "Paese",
      kycIamColSubmitted: "Inviata",
      kycIamColStatus: "Stato",
      kycIamReview: "Rivedi",
      kycIamReviewTitle: "Revisione KYC",
      kycIamDocLabel: "Documento",
      kycIamIssuingCountry: "Paese emissione",
      kycIamDocNumber: "Numero documento",
      kycIamFront: "Fronte",
      kycIamBack: "Retro",
      kycIamSelfie: "Selfie",
      kycIamNotAvailable: "Non disponibile",
      kycIamLoadingDetails: "Caricamento dettagli…",
      kycIamCannotLoad: "Impossibile caricare i dettagli.",
      kycIamApproving: "Approvazione…",
      kycIamApprove: "Approva KYC",
      kycIamRejectBtn: "Rifiuta KYC",
      kycIamStatusLabel: "Stato",
      kycIamRejectionReason: "Motivo rifiuto: {{reason}}",
      kycIamRejectModalTitle: "Rifiuta sottomissione KYC",
      kycIamRejectPlaceholder: "Motivo del rifiuto (visibile all'utente)…",
      kycIamRejectCancel: "Annulla",
      kycIamRejectSending: "Invio…",
      kycIamRejectConfirm: "Rifiuta",
      kycIamApproveSuccess: "KYC approvata",
      kycIamApproveError: "Errore approvazione KYC",
      kycIamRejectSuccess: "KYC rifiutata",
      kycIamRejectError: "Errore rifiuto KYC",
      kycIamDocPassport: "Passaporto",
      kycIamDocIdCard: "Carta identità",
      kycIamDocDrivingLicense: "Patente",
      backupRunning: "Backup in corso…",
      backupIdle: "Nessun backup attivo",
      backupScheduleActive: "attivo",
      backupScheduleDisabled: "disabilitato",
      backupRestoreInProgress: "Ripristino in corso…",
      backupLastRestore: "Ultimo ripristino",
      backupTriggerTitle: "Avvia backup manuale",
      backupTriggerStarting: "Avvio…",
      backupTriggerStart: "Avvia backup",
      backupTriggerNote: "Il backup gira in background. Lo stato si aggiorna automaticamente ogni 5 secondi.",
      backupHistoryTitle: "Storico backup",
      backupHistoryUpdated: "aggiornato {{time}}",
      backupEmpty: "Nessun backup registrato",
      backupTypeFull: "Completo",
      backupTypePostgres: "Solo PostgreSQL",
      backupTypeMinio: "Solo MinIO",
      backupStatusRunning: "In corso",
      backupStatusCompleted: "Completato",
      backupStatusFailed: "Fallito",
      backupDuration: "Durata: {{d}}",
      backupSize: "Dimensione: {{s}}",
      backupFiles: "File: {{n}}",
      backupTriggeredBy: "Da: {{by}}",
      backupTriggeredSchedule: "Schedulazione automatica",
      backupDownload: "Download",
      backupRestoreDb: "Ripristina DB",
      backupDeleteTitle: "Elimina backup",
      backupDeleteDesc: "Tutti i file di questo backup verranno eliminati da MinIO. Questa operazione è irreversibile.",
      backupDeleteCancel: "Annulla",
      backupDeleting: "Eliminazione…",
      backupDeleteConfirm: "Elimina",
      backupDeleteSuccess: "Backup eliminato",
      backupDeleteError: "Errore eliminazione backup",
      backupStartSuccess: "Backup avviato in background",
      backupStartError: "Errore avvio backup",
      downloadTitle: "Download backup — {{id}}…",
      downloadGenerating: "Generazione link in corso…",
      downloadLinkInfo: "Link validi per {{min}} minuti · {{n}} file",
      downloadError: "Errore nel recupero dei link.",
      downloadClose: "Chiudi",
      restoreStatusTitle: "Stato ripristino",
      restoreNoOp: "Nessuna operazione di ripristino registrata.",
      restoreType: "Tipo",
      restoreStatus: "Stato",
      restoreStarted: "Avviato",
      restoreCompleted: "Completato",
      restoreErrors: "Errori ({{count}})",
      restoreLogTitle: "Log operazione",
      restoreClose: "Chiudi",
      restoreTitle: "Ripristino — backup {{id}}…",
      restoreWarning: "Il ripristino è <strong>distruttivo</strong>: i dati esistenti vengono eliminati e sostituiti con quelli del backup. Procedere solo in ambienti controllati.",
      restoreStep1: "Tipo",
      restoreStep2: "Selezione",
      restoreStep3: "Conferma",
      restoreWhatQuestion: "Cosa vuoi ripristinare?",
      restoreTypeFull: "Ripristino completo",
      restoreTypeFullDesc: "Tutti i database PostgreSQL + tutti i bucket MinIO",
      restoreTypePostgres: "Solo PostgreSQL",
      restoreTypePostgresDesc: "Uno o più database — i bucket MinIO restano invariati",
      restoreTypeMinio: "Solo MinIO",
      restoreTypeMinioDesc: "Uno o più bucket — i database PostgreSQL restano invariati",
      restoreMinioMode: "Modalità MinIO",
      restoreReplace: "Sostituisci (cancella contenuto attuale)",
      restoreMerge: "Unisci (aggiunge senza cancellare)",
      restoreNext: "Avanti →",
      restoreSelectDbs: "Database PostgreSQL ({{count}})",
      restoreSelectBuckets: "Bucket MinIO ({{count}})",
      restoreSelectAll: "Seleziona tutto",
      restoreDeselectAll: "Deseleziona tutto",
      restoreNoDbSelection: "Nessuna selezione = tutti i database verranno ripristinati.",
      restoreNoBucketSelection: "Nessuna selezione = tutti i bucket verranno ripristinati.",
      restoreLoadingManifest: "Caricamento manifesto backup…",
      restoreBack: "← Indietro",
      restoreSummaryTitle: "Riepilogo operazione",
      restoreSummaryType: "Tipo:",
      restoreSummaryMinioMode: "Modalità MinIO:",
      restoreSummaryDbs: "Database:",
      restoreSummaryBuckets: "Bucket:",
      restoreSummaryAll: "Tutti ({{count}})",
      restoreReplaceWarning: "I dati esistenti verranno eliminati e sostituiti. Questa operazione NON è reversibile.",
      restoreMergeWarning: "Gli oggetti del backup verranno aggiunti senza eliminare quelli esistenti.",
      restoreStarting: "Avvio…",
      restoreStartBtn: "Avvia ripristino",
      restoreStartSuccess: "Ripristino avviato in background",
      restoreStartError: "Errore avvio ripristino",
      restoreReplaceLabel: "Sostituisci",
      restoreMergeLabel: "Unisci",
      analyticsLoading: "Caricamento dati analytics…",
      analyticsError: "Errore nel caricamento dei dati.",
      analyticsSessions: "Sessioni (30g)",
      analyticsUniqueUsers: "Utenti unici (30g)",
      analyticsTopPage: "Top page",
      analyticsTopEvent: "Top evento",
      analyticsVisits: "visite",
      analyticsEvents: "eventi",
      analyticsUsers: "Utenti",
      analyticsDauTitle: "Utenti attivi giornalieri — ultimi 30 giorni",
      analyticsNoData: "Nessun dato disponibile",
      analyticsTopPages: "Top pagine (30g)",
      analyticsTopEvents: "Top eventi (30g)",
      analyticsCount: "Conteggio",
      analyticsRegFunnel: "Funnel registrazione",
      analyticsDiveFunnel: "Funnel prima immersione",
      analyticsLast30: "Ultimi 30 giorni",
      healthUpdatedAt: "Aggiornato alle {{time}} · auto-refresh 30s",
      healthRefreshing: "Aggiornamento…",
      healthRefresh: "Aggiorna ora",
      healthChecking: "Verifica servizi in corso…",
      healthColService: "Servizio",
      healthColStatus: "Stato",
      healthColLatency: "Latenza",
      healthColDeps: "Dipendenze",
      healthStatusHealthy: "Sano",
      healthStatusDegraded: "Degradato",
      healthStatusUnreachable: "Non raggiungibile",
      auditAllActions: "Tutte le azioni",
      auditTotal: "{{count}} eventi totali",
      auditLoading: "Caricamento…",
      auditEmpty: "Nessuna azione registrata",
      auditEmptyDesc: "Le azioni admin verranno registrate qui non appena eseguite.",
      auditColWhen: "Quando",
      auditColAction: "Azione",
      auditColAdmin: "Admin",
      auditColTarget: "Target",
      auditColDetails: "Dettagli",
      auditColIp: "IP",
      auditPageInfo: "{{total}} eventi · pagina {{page}} di {{totalPages}}",
      auditPrev: "Precedente",
      auditNext: "Successiva",
      auditRoleAssign: "Ruolo assegnato",
      auditRoleRevoke: "Ruolo revocato",
      auditUserSuspend: "Utente sospeso",
      auditUserActivate: "Utente riattivato",
      auditUserDelete: "Utente eliminato",
      auditImpersonation: "Impersonazione",
      auditIpBlock: "IP bloccato",
      auditIpUnblock: "IP sbloccato",
      auditKycApprove: "KYC approvato",
      auditKycReject: "KYC rifiutato",
      auditBackupTrigger: "Backup avviato",
      auditBackupDelete: "Backup eliminato",
      auditAnnouncementCreate: "Annuncio creato",
      auditAnnouncementUpdate: "Annuncio aggiornato",
      auditAnnouncementDelete: "Annuncio eliminato",
      cmsTotal: "{{count}} annunci totali",
      cmsNewBtn: "Nuovo annuncio",
      cmsNewTitle: "Nuovo annuncio",
      cmsLoading: "Caricamento…",
      cmsEmpty: "Nessun annuncio",
      cmsEmptyDesc: "Crea il primo annuncio per informare gli utenti.",
      cmsFormTitle: "Titolo",
      cmsFormTitlePlaceholder: "Titolo annuncio",
      cmsFormType: "Tipo",
      cmsFormPinned: "In evidenza",
      cmsFormActive: "Attivo",
      cmsFormBody: "Messaggio",
      cmsFormBodyPlaceholder: "Testo dell'annuncio…",
      cmsFormCancel: "Annulla",
      cmsFormSaving: "Salvataggio…",
      cmsFormUpdate: "Aggiorna",
      cmsFormPublish: "Pubblica",
      cmsBadgeInfo: "Info",
      cmsBadgeWarning: "Attenzione",
      cmsBadgeMaintenance: "Manutenzione",
      cmsBadgeFeature: "Novità",
      cmsFeatured: "Evidenziato",
      cmsInactive: "Inattivo",
      cmsCreateSuccess: "Annuncio creato",
      cmsCreateError: "Errore nella creazione",
      cmsUpdateSuccess: "Annuncio aggiornato",
      cmsUpdateError: "Errore nell'aggiornamento",
      cmsDeleteSuccess: "Annuncio eliminato",
      cmsDeleteError: "Errore nell'eliminazione",
      cmsDeleteConfirm: "Eliminare questo annuncio?",
      invitesTitle: "Monitoraggio Inviti",
      invitesSubtitle: "Stato degli inviti, accettazioni e ruoli assegnati",
      invitesRefresh: "Aggiorna",
      invitesSent: "Inviati",
      invitesAccepted: "Accettati",
      invitesPending: "In attesa",
      invitesRevoked: "Revocati",
      invitesByRole: "Inviti per ruolo target",
      invitesFilterAllStatus: "Tutti gli stati",
      invitesFilterPending: "In attesa",
      invitesFilterAccepted: "Accettati",
      invitesFilterRevoked: "Revocati",
      invitesFilterAllRoles: "Tutti i ruoli target",
      invitesLoading: "Caricamento...",
      invitesEmpty: "Nessun invito trovato",
      invitesColInviter: "Invitante",
      invitesColTargetRole: "Ruolo target",
      invitesColChannel: "Canale",
      invitesColStatus: "Stato",
      invitesColUses: "Usi",
      invitesColInvited: "Invitato / Ruolo assegnato",
      invitesColDate: "Data",
      invitesNoRole: "nessun ruolo",
      invitesNotRegistered: "non registrato",
      invitesPageInfo: "{{total}} inviti · pagina {{page}}/{{totalPages}}",
      invitesPrev: "← Prec",
      invitesNext: "Succ →",
      targetRoleInstructor: "Istruttore",
      targetRoleDivemaster: "Divemaster",
      targetRoleDiveDoctor: "Medico Iperbarico",
      targetRoleUwPhotographer: "Fotografo Sub",
      targetRoleDiveCenter: "Centro Diving",
      targetRoleTravelAgency: "Agenzia Viaggi",
      targetRoleAcademy: "Accademia",
      liveUsersTitle: "Utenti Online in Tempo Reale",
      liveUsersSubtitle: "Aggiornamento automatico ogni 30 secondi · Ultimo: {{time}}",
      liveUsersEmpty: "Nessun utente connesso in questo momento",
      liveUsersConnected: "Utenti connessi",
      liveUsersConnectedDesc: "Sessioni WebSocket attive negli ultimi 60 secondi",
      liveUsersColRoles: "Ruoli",
      liveUsersColActions: "Azioni",
      tabLive: "Utenti Live",
      tabInvites: "Inviti",
      tabAnalytics: "Analytics",
      tabHealth: "System Health",
      tabAudit: "Audit Trail",
      tabCms: "Annunci",
      tabUnlocks: "Sblocchi",
      tabUsers: "Utenti",
      tabDivemasters: "Divemaster",
      tabKyc: "Documenti KYC",
      tabKyciam: "KYC Verifiche",
      tabLogbook: "Import Logbook",
      tabProposals: "Proposte siti",
      tabSecurity: "Sicurezza",
      tabApikeys: "API Keys B2B",
      tabBackup: "Backup",
      headerDivingCenter: "Diving Center",
      headerSpecies: "Enciclopedia specie",
      headerImpersonate: "Impersona utente",
      headerWhatsapp: "WhatsApp",
      headerEmail: "Email",
      colStatus: "Stato",
    },
    news: {
      pageTitle: "Redazione News",
      pageSubtitle: "{{count}} articoli · pipeline di revisione editoriale",
      filterAll: "Tutti",
      filterDraft: "Bozze",
      filterApproved: "Approvati",
      filterPublished: "Pubblicati",
      filterRejected: "Rifiutati",
      statusDraft: "Bozza",
      statusApproved: "Approvato",
      statusPublished: "Pubblicato",
      statusRejected: "Rifiutato",
      statusArchived: "Archiviato",
      searchPlaceholder: "Cerca titolo o sito…",
      colArticle: "Articolo",
      colQuality: "Qualità",
      colExtracted: "Estratto",
      colStatus: "Stato",
      translations: "{{count}} traduz.",
      loading: "Caricamento articoli…",
      empty: "Nessun articolo trovato",
      emptyHint: "Il crawler popola questa lista automaticamente ogni 6 ore.",
      totalArticles: "{{count}} articoli totali",
      langOriginal: "Originale",
      sectionTranslatedTitle: "Titolo tradotto",
      sectionSummary: "Sommario",
      sectionContent: "Contenuto",
      sectionOriginalText: "Testo originale",
      sourceLink: "Fonte",
      actionApprove: "Approva",
      actionPublish: "Pubblica",
      actionReject: "Rifiuta",
      actionArchive: "Archivia",
      statusChanged: "Articolo → {{status}}",
      statusChangeError: "Errore",
      tabLabel: "News",
    },
    roleRequests: {
      pageTitle: "Richieste di ruolo",
      pageDesc: "Approva o rifiuta le richieste degli utenti per ruoli professionali.",
      pendingBadge: "{{count}} in attesa",
      filterPending: "In attesa",
      filterApproved: "Approvate",
      filterRejected: "Rifiutate",
      filterAll: "Tutte",
      colApplicant: "Richiedente",
      colRole: "Ruolo richiesto",
      colMotivation: "Motivazione",
      colDate: "Data",
      colStatus: "Stato",
      colActions: "Azioni",
      unknownUser: "Utente sconosciuto",
      defaultUser: "Utente",
      approve: "Approva",
      reject: "Rifiuta",
      loading: "Caricamento…",
      emptyTitle: "Nessuna richiesta",
      emptyPending: "Nessuna richiesta in attesa di revisione.",
      emptyOther: "Nessuna richiesta trovata per questo filtro.",
      prevPage: "← Precedente",
      nextPage: "Successiva →",
      pageInfo: "Pagina {{page}} di {{totalPages}} · {{total}} totali",
      approveSuccess: "Ruolo approvato — l'utente è stato notificato",
      approveError: "Errore durante l'approvazione",
      rejectSuccess: "Richiesta rifiutata",
      rejectError: "Errore durante il rifiuto",
      rejectModalTitle: "Rifiuta richiesta",
      rejectModalDesc: "Rifiuta la richiesta di <strong>{{name}}</strong> per il ruolo <strong>{{role}}</strong>.",
      rejectNoteLabel: "Motivazione (opzionale — inviata all'utente)",
      rejectNotePlaceholder: "es. Documentazione insufficiente, riprova in seguito…",
      rejectCancel: "Annulla",
      rejectPending: "Rifiuto…",
      rejectConfirm: "Rifiuta richiesta",
      roleInstructor: "Istruttore",
      roleDivemaster: "Divemaster",
      roleDiveDoctor: "Medico subacqueo",
      roleDiveCenter: "Centro Immersioni",
      roleTravelAgency: "Agenzia Viaggi",
      roleAssociation: "Associazione",
      roleAcademy: "Accademia",
      roleUnderwaterPhotographer: "Fotografo Subacqueo",
      roleResearchCenter: "Centro di Ricerca",
      bulkApprove: "Approva selezionate",
      bulkApproveSuccess: "{{count}} richieste approvate",
      bulkClear: "Annulla",
      bulkPartial: "{{ok}} completate, {{failed}} non riuscite",
      bulkReject: "Rifiuta selezionate",
      bulkRejectSuccess: "{{count}} richieste rifiutate",
      bulkSelected: "{{count}} selezionate",
      selectAll: "Seleziona tutte",
      selectRow: "Seleziona richiesta",
      rejectBulkDesc: "Stai per rifiutare {{count}} richieste selezionate. La motivazione (se indicata) sarà inviata a tutte.",
    },
    certVerifications: {
      pageTitle: "Verifiche Brevetti",
      pageDesc: "Verifica i brevetti inviati dagli utenti.",
      pendingBadge: "{{count}} in attesa",
      filterPending: "In attesa",
      filterVerified: "Verificati",
      filterRejected: "Rifiutati",
      filterExpired: "Scaduti",
      filterAll: "Tutti",
      colUser: "Utente",
      colCertification: "Brevetto",
      colAgency: "Ente",
      colCertNumber: "N° certificato",
      colSubmitted: "Inviato",
      colStatus: "Stato",
      colActions: "Azioni",
      colUnlocksRole: "Sblocca ruolo",
      verify: "Verifica",
      reject: "Rifiuta",
      expire: "Scaduto",
      loading: "Caricamento…",
      emptyTitle: "Nessun brevetto",
      emptyPending: "Nessun brevetto in attesa di revisione.",
      emptyOther: "Nessun brevetto trovato per questo filtro.",
      prevPage: "← Precedente",
      nextPage: "Successiva →",
      pageInfo: "Pagina {{page}} di {{totalPages}} · {{total}} totali",
      verifySuccess: "Brevetto verificato — ruolo sbloccato",
      verifyError: "Errore durante la verifica",
      rejectSuccess: "Brevetto rifiutato",
      rejectError: "Errore durante il rifiuto",
      expireSuccess: "Brevetto segnato come scaduto",
      expireError: "Errore durante la scadenza",
      rejectModalTitle: "Rifiuta brevetto",
      rejectModalDesc: "Rifiuta il brevetto <strong>{{cert}}</strong> di <strong>{{name}}</strong>.",
      rejectReasonLabel: "Motivazione (obbligatoria — inviata all'utente)",
      rejectReasonPlaceholder: "es. Il numero di certificato non è leggibile, si prega di ricaricare…",
      rejectCancel: "Annulla",
      rejectPending: "Rifiuto…",
      rejectConfirm: "Rifiuta",
      viewImage: "Visualizza immagine",
      noImage: "Nessuna immagine",
      noRole: "Nessuno",
      statusPending: "In attesa",
      statusVerified: "Verificato",
      statusRejected: "Rifiutato",
      statusExpired: "Scaduto",
    },
    impersonating: "Stai impersonando l'utente",
    impersonatingNote: "— le azioni vengono eseguite a nome di questo utente.",
    stopImpersonation: "Termina impersonificazione",
    challenges: {
      pageTitle: "Sfide community",
      pageDesc: "Gestisci le sfide visibili a tutti gli utenti.",
      newChallenge: "Nuova sfida",
      editChallenge: "Modifica sfida",
      noData: "Nessuna sfida",
      createFirst: "Crea la prima sfida per la community.",
      colChallenge: "Sfida",
      colMetric: "Metrica",
      colTarget: "Target",
      slugLabel: "Slug *",
      metricLabel: "Metrica *",
      titleLabel: "Titolo *",
      descLabel: "Descrizione",
      cancelBtn: "Annulla",
      saveBtn: "Salva modifiche",
      createBtn: "Crea sfida",
      deleteTitle: "Elimina sfida",
      deleteConfirm: "Sei sicuro di voler eliminare \"{{name}}\"?",
      deleting: "Eliminazione…",
      deleteBtn: "Elimina",
      metrics: {
        DIVES: "Immersioni",
        TOTAL_METERS: "Metri totali",
        COUNTRIES: "Paesi visitati",
      },
      metricUnit: {
        DIVES: "immersioni",
        TOTAL_METERS: "m",
        COUNTRIES: "paesi",
      },
      createSuccess: "Sfida creata",
      updateSuccess: "Sfida aggiornata",
      deleteSuccess: "Sfida eliminata",
      createError: "Errore nella creazione",
      updateError: "Errore aggiornamento",
      deleteError: "Errore eliminazione",
    },
    datalab: {
      pageTitle: "Data Lab — Licenze",
      pageDesc: "Rivedi e approva le richieste di accesso ai dataset",
      pendingBadge: "{{count}} richieste in attesa di revisione",
      noPending: "Nessuna richiesta in attesa",
      noPendingDesc: "Tutte le richieste sono state revisionate.",
      colOrg: "Organizzazione:",
      colRequestedAt: "Richiesta il",
      colPurpose: "Scopo d'uso",
      adminNote: "Nota admin",
      adminNotePlaceholder: "opzionale",
      adminNoteHint: "Inserisci una nota…",
      typeAggregate: "Aggregato",
      typeBySite: "Per sito",
      typeFull: "Completo",
      reviewTitle: "Rivedi richiesta licenza",
      rejectBtn: "Rifiuta",
      approveBtn: "Approva",
      reviewBtn: "Rivedi",
      approveSuccess: "Licenza approvata",
      rejectSuccess: "Richiesta rifiutata",
      reviewError: "Errore durante la revisione",
    },
    stats: {
      pageTitle: "Statistiche piattaforma",
      pageDesc: "Panoramica in tempo reale — aggiornamento ogni 5 min",
      loadError: "Errore nel caricamento delle statistiche.",
      registeredUsers: "Utenti registrati",
      activeUsers30: "Utenti attivi (30 gg)",
      kycPending: "KYC in attesa",
      activeApiKeys: "API key attive",
      invitesSent: "Inviti inviati",
      emailsSent: "Email inviate",
      kycSection: "KYC & Inviti",
      kycApproved: "KYC approvati",
      kycPendingLabel: "KYC in attesa",
      invitesAccepted: "Inviti accettati",
      invitesPending: "Inviti in attesa",
      percentOfTotal: "% del totale",
      last7d: "negli ultimi 7 giorni",
      b2bKeysNote: "Chiavi B2B non revocate",
      activeSubscriptions: "abbonamenti attivi",
      subscriptionDist: "Distribuzione abbonamenti",
      noSubscriptionData: "Nessun dato abbonamenti",
      transactionalEmail: "Email transazionali",
      totalSent: "Totale inviate",
      delivered: "Consegnate",
      failed: "Fallite",
      newUsersChart: "Nuovi utenti (ultimi 6 mesi)",
      noGrowthData: "Nessun dato crescita disponibile",
    },
    diveCenters: {
      pageTitle: "Diving Center — Anagrafica",
      centersCount: "{{count}} centri registrati",
      addCenter: "Aggiungi centro",
      importCsv: "Importa CSV",
      importing: "Importazione…",
      csvFormat: "Formato CSV atteso",
      searchPlaceholder: "Cerca per nome, città…",
      noData: "Nessun centro registrato",
      noDataHint: "Aggiungine uno o importa un CSV.",
      colName: "Nome",
      colLocation: "Paese / Città",
      colContacts: "Contatti",
      colGps: "GPS",
      colStatus: "Stato",
      colActions: "Azioni",
      statusActive: "Attivo",
      statusInactive: "Inattivo",
      editCenter: "Modifica centro",
      newCenter: "Nuovo centro",
      nameLabel: "Nome *",
      countryLabel: "Paese *",
      cityLabel: "Città *",
      addressLabel: "Indirizzo",
      phoneLabel: "Telefono",
      whatsappLabel: "WhatsApp",
      emailLabel: "Email",
      websiteLabel: "Sito web",
      latLabel: "Latitudine",
      lngLabel: "Longitudine",
      licenseLabel: "Licenza / n. autorizzazione",
      activeLabel: "Attivo / visibile",
      descLabel: "Descrizione",
      cancelBtn: "Annulla",
      updateBtn: "Aggiorna",
      createBtn: "Crea centro",
      deleteTitle: "Elimina centro?",
      deleteConfirm: "Questa operazione è irreversibile per \"{{name}}\".",
      csvError: "CSV vuoto o formato non riconosciuto",
      csvSuccess: "Importazione completata: {{count}} centri",
    },
    marketing: {
      pageTitle: "Marketing",
      tabDashboard: "Dashboard",
      tabCampaigns: "Campagne",
      tabContacts: "Contatti",
      tabBounced: "Bounced",
      bouncedIntro: "Indirizzi email che hanno fatto bounce (rifiutati dal server destinatario). Questi contatti sono stati disiscritti automaticamente. Correggi l'indirizzo per rimetterli in coda.",
      bouncedNone: "Nessun indirizzo bounced",
      bouncedNoneDesc: "Tutte le email risultano consegnate. Ottimo!",
      bouncedReason: "Motivo bounce",
      bouncedCampaign: "Campagna",
      bouncedUnknown: "Sconosciuto",
      bouncedFixAction: "Correggi e rimetti in coda",
      bouncedFixTitle: "Correggi indirizzo email",
      bouncedFixIntro: "Correggi l'indirizzo di {{name}}. Il contatto verrà ri-iscritto e i suoi invii rimbalzati rimessi in coda per il nuovo indirizzo.",
      bouncedOldEmail: "Indirizzo rimbalzato",
      bouncedNewEmail: "Nuovo indirizzo email",
      bouncedFixNote: "Il contatto tornerà iscritto (consenso da riconfermare) e riceverà i prossimi invii al nuovo indirizzo.",
      bouncedFixConfirm: "Correggi e rimetti in coda",
      bouncedFixedSuccess: "Email corretta — {{count}} invii rimessi in coda",
      bouncedDuplicate: "Un altro contatto ha già questa email",
      tabReplies: "Risposte",
      tabDocuments: "Documenti",
      tabQrLinks: "QR & Link",
      campaignsSent: "Campagne inviate",
      contactsSubscribed: "Contatti iscritti",
      consentRate: "Tasso consenso",
      avgOpenRate: "Tasso apertura medio",
      statuses: {
        DRAFT: "Bozza",
        SCHEDULED: "Programmata",
        SENDING: "In invio",
        SENT: "Inviata",
        FAILED: "Fallita",
      },
      consent: {
        GRANTED: "Accordato",
        REVOKED: "Revocato",
        PENDING: "In attesa",
      },
      newCampaign: "Nuova campagna",
      editCampaign: "Modifica campagna",
      noContacts: "Nessun contatto",
      noContactsDesc: "Importa contatti per iniziare.",
      noCampaigns: "Nessuna campagna",
      noCampaignsDesc: "Crea la prima campagna.",
      subtitle: "Campagne, rubrica contatti, GDPR, WhatsApp, analisi",
      statCampaignsSent: "Campagne inviate",
      statCampaignsTotal: "di {{total}} totali",
      statContactsSubscribed: "Contatti iscritti",
      statConsentGranted: "Consenso accordato",
      statSuccessRate: "Tasso successo invii",
      statSendsSent: "{{count}} inviati",
      statReplies: "Risposte ricevute",
      statDownloads: "Download documenti",
      consentChartTitle: "Stato consenso contatti",
      consentGrantedLabel: "Consenso accordato",
      consentPendingLabel: "In attesa",
      sendsChartTitle: "Invii totali",
      sendsSentLabel: "Inviati con successo",
      sendsFailedLabel: "Falliti",
      recentCampaigns: "Ultime campagne",
      noCampaignsYet: "Nessuna campagna ancora",
      newCampaignBtn: "Nuova campagna",
      campaignCount: "{{count}} campagne",
      campaignSubject: "Oggetto:",
      campaignCreated: "Creata",
      campaignSent: "Inviata",
      sendBtn: "Invia",
      searchContactsPlaceholder: "Cerca per nome, email, telefono…",
      importCsv: "Importa CSV",
      importingCsv: "Importazione…",
      exportCsv: "Esporta CSV",
      reconcileUsers: "Riconcilia utenti",
      reconcilingUsers: "Riconciliazione…",
      newContactBtn: "Nuovo contatto",
      csvHint: "CSV: colonne name, email, phone, tags (separati da ;). I duplicati (stessa email) vengono aggiornati.",
      contactsTableName: "Nome",
      contactsTableActions: "Azioni",
      contactsTableEmail: "Email",
      contactsTablePhone: "Telefono",
      contactsTableTags: "Tag",
      contactsTableSubscribed: "Iscritto",
      contactsTableGdpr: "Consenso GDPR",
      contactsTableEdiveUser: "Utente eDive",
      contactsLinked: "Collegato",
      contactsYes: "Sì",
      contactsNo: "No",
      contactsFooter: "{{total}} contatti · {{subscribed}} iscritti · {{consent}} consenso accordato",
      repliesCount: "{{count}} risposte ricevute",
      unknownContact: "Contatto sconosciuto",
      noReplies: "Nessuna risposta",
      noRepliesDesc: "Quando i contatti rispondono alle campagne WhatsApp, le risposte appariranno qui",
      docsCount: "{{count}} documenti tracciati",
      docsHint: "Ogni documento genera un link tracciato /v1/marketing/d/:slug che registra chi scarica il file.",
      newDocBtn: "Nuovo documento",
      docDownloads: "{{count}} download tracciati",
      qrHowTitle: "Reverse Solicitation — Come funziona",
      qrHowDesc: "Invece di inviare il primo messaggio (soggetto ad approvazione template Meta), condividi questo QR o link. Quando il contatto scrive per primo, si apre una finestra di 24 ore in cui puoi rispondere liberamente.",
      qrConfigTitle: "Configura il tuo link WhatsApp",
      qrPhoneLabel: "Numero WhatsApp Business (con prefisso)",
      qrMessageLabel: "Messaggio pre-compilato",
      qrCopyLink: "Copia",
      qrCodeTitle: "QR Code",
      qrCodeHint: "Inserisci questo QR in brochure, volantini, biglietti da visita e materiali fisici.",
      qrDownload: "Scarica QR",
      qrCopyLinkBtn: "Copia link",
      qrExampleTitle: "Esempio — Testo per email o social",
      qrCopyText: "Copia testo",
      linkCopied: "Link copiato!",
      textCopied: "Testo copiato!",
      campaignFormNameLabel: "Nome campagna *",
      campaignFormNamePlaceholder: "Es: Promo estate 2026",
      campaignFormChannel: "Canale",
      campaignFormEmailSubject: "Oggetto email",
      campaignFormEmailBody: "Corpo email (HTML)",
      campaignFormEmailBodyHint: "Supporta HTML. Il link di disiscrizione e il blocco consenso GDPR vengono aggiunti automaticamente al primo invio.",
      campaignFormWaTemplate: "Template WhatsApp (approvato Meta)",
      campaignFormWaTemplateHint: "Lascia vuoto per testo libero (solo entro finestra 24h da risposta del contatto).",
      campaignFormWaText: "Testo WhatsApp",
      campaignFormSave: "Salva campagna",
      campaignFormSaving: "Salvataggio…",
      sendDialogChannel: "Canale: {{channel}} · {{count}} contatti iscritti disponibili",
      sendDialogRecipients: "Destinatari",
      sendDialogAll: "Tutti i contatti iscritti",
      sendDialogAllDesc: "{{count}} contatti",
      sendDialogByTag: "Filtra per tag",
      sendDialogByTagDesc: "Inserisci uno o più tag separati da virgola",
      sendDialogManual: "ID specifici",
      sendDialogManualDesc: "ID contatto separati da virgola o a capo",
      sendDialogWarning: "⚠ L'invio è irreversibile. Al primo invio ogni contatto riceve automaticamente il link per il consenso GDPR.",
      sendDialogSend: "Invia campagna",
      sendDialogSending: "Invio in corso…",
      sendDialogStarted: "Invio avviato per {{count}} contatti",
      contactFormName: "Nome *",
      contactFormEmail: "Email",
      contactFormPhone: "Telefono (WhatsApp)",
      contactFormTags: "Tag (separati da virgola)",
      contactFormSubscribed: "Iscritto (riceve comunicazioni marketing)",
      docFormSlug: "Slug (URL-safe) *",
      docFormName: "Nome documento *",
      docFormDescription: "Descrizione",
      docFormUrl: "URL file *",
      deleteCampaignTitle: "Elimina campagna",
      deleteCampaignConfirm: "Vuoi eliminare \"{{name}}\"? L'operazione è irreversibile.",
      deleteContactTitle: "Elimina contatto",
      deleteContactConfirm: "Vuoi eliminare \"{{name}}\"?",
      deleteDocTitle: "Elimina documento",
      deleteDocConfirm: "Vuoi eliminare il documento \"{{name}}\" e tutti i suoi {{count}} download tracciati?",
      deleting: "Eliminazione…",
      campaignCreatedSuccess: "Campagna creata",
      campaignUpdatedSuccess: "Campagna aggiornata",
      campaignDeletedSuccess: "Campagna eliminata",
      contactAddedSuccess: "Contatto aggiunto",
      contactUpdatedSuccess: "Contatto aggiornato",
      contactDeletedSuccess: "Contatto eliminato",
      contactsImportedSuccess: "Importati {{imported}} contatti ({{skipped}} saltati)",
      consentSentSuccess: "Consenso inviato — Email: {{email}} · WhatsApp: {{wa}}",
      reconciledSuccess: "Riconciliati {{matched}} contatti su {{total}}",
      reconciledOneSuccess: "Contatto collegato all'utente eDive",
      docAddedSuccess: "Documento aggiunto",
      docUpdatedSuccess: "Documento aggiornato",
      docDeletedSuccess: "Documento eliminato",
      exportError: "Errore nell'esportazione",
      docDownloadsTitle: "Download — {{name}}",
      docDownloadsCount: "{{count}} download registrati per",
      docDownloadsColDate: "Data",
      docDownloadsColIp: "IP",
      docDownloadsColReferrer: "Referrer",
      docDownloadsColUtm: "UTM",
      noDownloads: "Nessun download ancora",
    },
    species: {
      pageTitle: "Gestione Specie",
      tabSpecies: "Gestione Specie",
      tabSync: "Sincronizzazione",
      tabProposals: "Proposte",
      tabJobs: "Background Jobs",
      proposalTypes: {
        ADD: "Nuova specie",
        EDIT: "Modifica",
        DELETE: "Elimina",
        MERGE: "Unisci",
      },
      jobStates: {
        RUNNING: "In esecuzione",
        PENDING: "In attesa",
        PAUSED: "In pausa",
        ERROR: "Errore",
        UNKNOWN: "Sconosciuto",
      },
      checkpointSaved: "Checkpoint salvato",
      forceRun: "Forza esecuzione",
      pauseNow: "Metti in pausa",
      pauseNext: "Sospendi prossima",
      resumeCheckpoint: "Riprendi dal checkpoint",
      resume: "Riprendi",
      resetCheckpoint: "Ricomincia da capo",
      subtitleSpecies: "Gestione, import/export e sincronizzazione del database specie marine",
      draftsTitle: "Bozze in attesa di approvazione",
      draftsSubtitle: "Specie importate da WoRMS/GBIF non ancora visibili nel catalogo pubblico",
      approveAllBtn: "Approva tutte ({{count}})",
      filterScientificName: "Filtra per nome scientifico…",
      noDrafts: "Nessuna bozza in attesa — il catalogo è aggiornato",
      colScientificName: "Nome scientifico",
      colClass: "Classe",
      colFamily: "Famiglia",
      colHabitat: "Habitat",
      colSource: "Fonte",
      approve: "Approva",
      paginationInfo: "Pagina {{page}} · {{total}} totali",
      prevPage: "← Precedente",
      nextPageBtn: "Successiva →",
      exportTitle: "Esporta database specie (JSON v1.0)",
      exportMediterranean: "Solo Mediterraneo",
      exportIncludeDrafts: "Includi bozze (non approvate)",
      exportDownload: "Scarica JSON",
      importTitle: "Importa specie da file JSON",
      importDesc: "Il file deve essere conforme allo schema species_export_v1.",
      importSelectFile: "Seleziona file JSON",
      importLoading: "Importazione…",
      importSuccess: "Completato: {{imported}} nuove, {{updated}} aggiornate, {{errors}} errori",
      syncCyclesTitle: "Cicli di sincronizzazione",
      syncStartNow: "Avvia ora",
      syncLogTitle: "Log sincronizzazione",
      syncAllSources: "Tutte le fonti",
      syncColDate: "Data",
      syncColCycle: "Ciclo",
      syncColSource: "Fonte",
      syncColSpecies: "Specie",
      syncColAction: "Azione",
      syncColFields: "Campi",
      syncNoLogs: "Nessun log trovato",
      proposalAll: "Tutte",
      proposalNone: "Nessuna proposta trovata",
      proposalReviewerNotes: "Note revisore:",
      proposalApprove: "Approva",
      proposalReject: "Rifiuta",
      proposalApproveTitle: "Approva proposta",
      proposalRejectTitle: "Rifiuta proposta",
      proposalApproveDesc: "Il payload verrà applicato alla specie. Questa azione non è reversibile.",
      proposalRejectDesc: "La proposta verrà contrassegnata come rifiutata e il proponente ne sarà informato.",
      proposalNotesPlaceholder: "Note (opzionale)…",
      proposalSpeciesUnknown: "Specie non specificata",
      jobsInfoTitle: "Monitoraggio attività pianificate",
      jobsLoading: "Caricamento stato job…",
      jobsRedisError: "Impossibile caricare lo stato dei job. Verificare che Redis sia raggiungibile.",
      jobsLastRun: "Ultima esecuzione:",
      jobsNext: "Prossima:",
      jobsStartedAt: "Avviato:",
      jobsPauseTitle: "Mettere in pausa «{{label}}»?",
      jobsPauseDesc: "Il job è attualmente in esecuzione al passo:",
      jobsPauseConfirm: "Conferma pausa",
      jobsPauseRunning: "Pausa richiesta…",
      approveAllTitle: "Approva tutte le bozze",
      approveAllConfirmBtn: "Approva tutte",
      inatSyncTitle: "Sincronizzazione iNaturalist",
      inatLastSync: "Ultima sync:",
      inatStaged: "stagionati",
      inatNoSync: "Nessuna sync eseguita",
      inatStartSync: "Avvia sync",
      inatStarting: "Avvio…",
      inatPending: "In attesa",
      inatApproved: "Approvati",
      inatRejected: "Scartati",
      inatImported: "Importati",
      inatNewOnly: "Solo nuove specie",
      inatMinScore: "Score min:",
      inatAny: "Qualsiasi",
      inatNew: "Nuova",
      inatMatch: "Match",
      inatNoneTitle: "Nessun elemento trovato per i filtri selezionati",
      inatNonePendingHint: "Avvia una sync per importare nuovi dati da iNaturalist.",
      inatNoneHint: "Prova a cambiare il filtro.",
      inatImport: "Importa",
      inatAll: "Tutte",
      loading: "Caricamento…",
      approveError: "Errore nell'approvazione",
      rejectError: "Errore nel rifiuto",
      importError: "Errore durante l'import JSON",
      exportError: "Errore nell'export",
      exportSuccess: "Export scaricato",
      syncStartError: "Errore nell'avvio del sync",
      triggerError: "Errore nell'avvio del job",
      pauseError: "Errore nella richiesta di pausa",
      resumeError: "Errore nella ripresa del job",
      resetError: "Errore nel reset del checkpoint",
      draftApprovedSuccess: "{{name}} approvata",
      approveAllConfirmDesc: "Verranno pubblicate nel catalogo pubblico {{count}} specie importate da WoRMS. L'operazione non è reversibile.",
      approveAllError: "Errore durante l'approvazione massiva",
      approveAllSuccess: "{{count}} specie approvate e pubblicate nel catalogo",
      proposalApprovedSuccess: "Proposta approvata e applicata",
      proposalRejectedSuccess: "Proposta rifiutata",
      importCompletedLabel: "Completato:",
      importNew: "nuove,",
      importUpdated: "aggiornate,",
      importErrors: "errori",
      importErrorDetails: "{{count}} specie con errori — controlla il file JSON",
      inatSyncStarted: "Sync iNaturalist avviato",
      inatItemApproved: "Elemento approvato",
      inatItemRejected: "Elemento scartato",
      inatImportedSuccess: "{{name}} importata nell'enciclopedia",
      inatSpeciesDefault: "Specie",
      inatBadgePending: "{{count}} in attesa",
      jobsBadgeRunning: "{{count}} in corso",
      jobsBadgePaused: "{{count}} in pausa",
      jobsProcessing: "Elaborazione…",
      jobsInfoDesc: "Ogni job mostra lo stato in tempo reale e può essere messo in pausa in modo sicuro — il progresso viene salvato automaticamente in un checkpoint e la ripresa continua dall'esatto punto di interruzione, senza perdere lavoro già fatto.",
      jobsPauseHint1: "✓ Il job si fermerà al prossimo checkpoint sicuro — i dati parziali non vengono persi.",
      jobsPauseHint2: "✓ Il progresso viene salvato automaticamente.",
      jobsPauseHint3: "✓ La ripresa continuerà esattamente dal punto di interruzione.",
      inatColSpecies: "Specie",
      inatColType: "Tipo",
      inatColObservations: "Osservazioni",
      inatColScore: "Score",
      inatColEnrichment: "Arricch.",
      inatColStatus: "Stato",
      syncLightFreq: "ogni 7 giorni",
      syncFullFreq: "ogni 30 giorni",
      syncWormsDesc: "Nuove specie dal registro mondiale",
      syncInatDesc: "Foto tassonomiche CC da osservatori naturalistici",
      syncGbifDesc: "Immagini e dati di occorrenza (licenza CC)",
      syncWikimediaDesc: "Immagini CC-BY/CC0 da Commons e Wikidata",
      syncFishbaseDesc: "Dati fisiologici: lunghezza, peso, età, vulnerabilità (pesci)",
      syncSealifeDesc: "Dati fisiologici per invertebrati marini",
      syncJobsNote: "I cicli vengono eseguiti in background — dopo l'avvio verrai reindirizzato al tab Background Jobs per monitorare il progresso.",
    },
    gdpr: {
      pageTitle: "Richieste GDPR",
      pageSubtitle: "Richieste di export e cancellazione dati degli utenti",
      refresh: "Aggiorna",
      reqSectionTitle: "Richieste dati da lavorare",
      reqNone: "Nessuna richiesta in sospeso.",
      reqTypeExport: "Export dati",
      reqTypeDeletion: "Cancellazione dati",
      reqForce: "Forza chiusura",
      reqForceConfirm: "Forzare la chiusura di questa cancellazione? I servizi ancora pendenti verranno marcati completati.",
      reqForceError: "Errore nel forzare la richiesta",
      reqReprocess: "Ri-processa",
      reqReprocessConfirm: "Rilanciare questa richiesta? Verrà elaborata di nuovo da zero: tutti i servizi risponderanno e il file (per gli export) sarà rigenerato.",
      reqReprocessSuccess: "Richiesta rilanciata — elaborazione in corso",
      reqReprocessError: "Errore nel rilancio della richiesta",
      reqStaleHint: "Ferma da tempo: probabilmente il processo non è mai arrivato in fondo. Prova a ri-processarla.",
      statusPending: "In attesa",
      sagasSectionTitle: "Saga di cancellazione",
      filterAll: "Tutte",
      filterInProgress: "In corso",
      filterCompleted: "Completate",
      filterTimedOut: "Scadute",
      loading: "Caricamento…",
      noSagas: "Nessuna saga trovata",
      noSagasInProgress: "Nessuna cancellazione in corso.",
      noSagasFilter: "Nessun dato per il filtro selezionato.",
      statusInProgress: "In corso",
      statusCompleted: "Completata",
      statusTimedOut: "Scaduta",
      statusFailed: "Fallita",
      stuck: "BLOCCATA",
      startedAgo: "Avviata",
      age: "età:",
      services: "servizi",
      servicesDetail: "{{pending}} pendenti, {{completed}} completati",
      servicesDetailTimedOut: "{{pending}} pendenti, {{completed}} completati, {{timedOut}} scaduti",
      forceAll: "Forza tutti ({{count}})",
      forceService: "Forza",
      forceServiceSuccessComplete: "Saga completata — {{service}} forzato",
      forceServiceSuccessRemaining: "{{service}} forzato — {{remaining}} servizi rimanenti",
      forceServiceError: "Errore nel forzare il servizio",
      forceAllSuccess: "Saga forzata — {{count}} servizi completati",
      forceAllError: "Errore nel forzare la saga",
      eventLog: "Log eventi",
      legendTitle: "Legenda servizi",
      legendCompleted: "Completato normalmente",
      legendForced: "Forzato da admin",
      legendPending: "In attesa",
      legendStuck: "Bloccato (>20s)",
      legendTimeout: "Timeout",
      stuckAlert_one: "{{count}} richiesta GDPR è in stallo e richiede attenzione.",
      stuckAlert_other: "{{count}} richieste GDPR sono in stallo e richiedono attenzione.",
      slaOverdue: "Scadenza GDPR superata di {{days}} gg",
      slaDaysLeft: "Scadenza GDPR tra {{days}} gg",
    },
    profileEdit: {
      title: "Modifica profilo utente",
      sectionAnagrafica: "Anagrafica",
      sectionContacts: "Contatti",
      sectionResidence: "Residenza",
      sectionPublicProfile: "Profilo pubblico",
      sectionPreferences: "Preferenze",
      sectionDiving: "Dati subacquei",
      sectionFreediving: "Apnea / Freediving",
      sectionPrivacy: "Privacy & Consensi",
      firstName: "Nome",
      lastName: "Cognome",
      dateOfBirth: "Data di nascita",
      placeOfBirth: "Luogo di nascita",
      fiscalCode: "Codice fiscale",
      nationality: "Nazionalità (ISO 2)",
      nationalityPlaceholder: "es. IT",
      gender: "Genere",
      mobilePhone: "Cellulare",
      homePhone: "Telefono fisso",
      whatsapp: "WhatsApp",
      street: "Via / Piazza",
      streetNumber: "Civico",
      municipality: "Comune",
      province: "Provincia (2 lettere)",
      provincePlaceholder: "es. RM",
      postalCode: "CAP",
      city: "Città (visualizzata)",
      country: "Paese (ISO 2)",
      countryPlaceholder: "es. IT",
      displayName: "Nome visualizzato",
      bio: "Biografia",
      website: "Sito web",
      instagramHandle: "Instagram handle",
      profileType: "Tipo di profilo",
      locale: "Lingua interfaccia",
      isPublic: "Profilo pubblico",
      isPublicNote: "Se attivo, il profilo è visibile ad altri utenti",
      preferredLanguage: "Lingua preferita (BCP47)",
      preferredLanguagePlaceholder: "es. it-IT",
      timezone: "Fuso orario (IANA)",
      timezonePlaceholder: "es. Europe/Rome",
      measurementUnit: "Unità di misura",
      diveStyle: "Stile di immersione",
      personalRmv: "RMV personale (l/min)",
      certifiedMaxDepth: "Profondità max certificata (m)",
      freediverLevel: "Livello apneista",
      staticApneaPb: "PB apnea statica (s)",
      dynamicApneaPb: "PB apnea dinamica (m)",
      depthApneaPb: "PB apnea profonda (m)",
      privacyConsent: "Consenso privacy (GDPR Art.6)",
      marketingConsent: "Consenso marketing",
      marketingConsentNote: "Newsletter, offerte e aggiornamenti",
      selectPlaceholder: "— seleziona —",
      savingProfile: "Salvataggio…",
      saveProfile: "Salva profilo",
      savedSuccess: "Profilo aggiornato",
      saveError: "Errore salvataggio profilo",
      genderMale: "Maschio",
      genderFemale: "Femmina",
      genderOther: "Altro",
      genderPreferNot: "Preferisco non indicarlo",
      profileTypeDiver: "Subacqueo ricreativo",
      profileTypeFreediver: "Apneista",
      profileTypeInstructor: "Istruttore",
      profileTypeDivemaster: "Divemaster",
      profileTypeDiveDoctor: "Medico subacqueo",
      profileTypePhotographer: "Fotografo subacqueo",
      profileTypeResearch: "Centro di ricerca",
      profileTypeDiveCenter: "Centro immersioni",
      profileTypeAgency: "Agenzia viaggi",
      profileTypeAssociation: "Associazione",
      profileTypeAcademy: "Accademia",
      diveStyleScuba: "SCUBA",
      diveStyleFreediving: "Apnea",
      diveStyleSnorkeling: "Snorkeling",
      diveStyleRebreather: "Rebreather",
      freediverBeginner: "Principiante",
      freediverIntermediate: "Intermedio",
      freediverAdvanced: "Avanzato",
      freediverInstructor: "Istruttore",
      measureMetric: "Metrico (m, kg, °C)",
      measureImperial: "Imperiale (ft, lb, °F)",
    },
    whatsapp: {
      pageTitle: "WhatsApp Business",
      configured: "WhatsApp Business configurato",
      notConfigured: "WhatsApp Business non configurato",
      setupGuide: "Guida configurazione",
      sendTest: "Invia messaggio di prova",
      testPhone: "Numero di telefono destinatario",
      testMessage: "Messaggio",
      contacts: "Rubrica contatti WhatsApp",
      noContacts: "Nessun contatto con numero di telefono trovato.",
      importantNotes: "Note importanti",
      saving: "Invio…",
    },
    pss: {
      pageTitle: "Gestione Domande PSS",
      pageDesc: "Abilita/disabilita domande d'esame per ogni corso",
      importJson: "Importa domande da JSON",
      courseList: "Corsi PSS",
      noCourses: "Nessun corso. Importa prima le domande.",
      questionsCount: "{{count}} domande",
      selectCourse: "Seleziona un corso per vedere le domande",
      filterAll: "Tutte",
      filterActive: "Attive",
      filterDisabled: "Disabilitate",
      allChapters: "Tutti i capitoli",
      chapterLabel: "Capitolo {{ch}}",
      colQuestion: "Domanda",
      colNumber: "#",
      colChapter: "Capitolo",
      colStatus: "Stato",
      noQuestions: "Nessuna domanda trovata",
      pagination: "Pagina {{page}} / {{totalPages}}",
      prevPage: "Precedente",
      nextPage: "Successiva",
      seedResult: "{{added}} aggiunte, {{updated}} aggiornate, {{skipped}} saltate",
      loadCoursesError: "Errore caricamento corsi",
      loadQuestionsError: "Errore caricamento domande",
      updateError: "Errore aggiornamento domanda",
      seedError: "Errore seed",
    },
    mail: {
      pageTitle: "Mail",
      compose: "Scrivi",
      syncing: "Sincronizzando…",
      sync: "Sincronizza",
      selectAccount: "Seleziona un account",
      noResults: "Nessun risultato",
      noMessages: "Nessun messaggio",
      messagesCount: "{{count}} messaggi",
      mailboxes: {
        INBOX: "Posta in arrivo",
        SENT: "Inviati",
        DRAFTS: "Bozze",
        TRASH: "Cestino",
        SPAM: "Spam",
      },
      from: "Da:",
      to: "A:",
      date: "Data:",
      noContent: "Nessun contenuto",
      remoteBlocked: "Bloccati {{count}} elementi remoti: il mittente saprebbe quando hai aperto l'email.",
      remoteBlocked_one: "Bloccato 1 elemento remoto: il mittente saprebbe quando hai aperto l'email.",
      remoteBlocked_other: "Bloccati {{count}} elementi remoti: il mittente saprebbe quando hai aperto l'email.",
      showRemote: "Mostra le immagini",
      noMessageSelected: "Nessun messaggio selezionato",
      selectMessageHint: "Seleziona un messaggio dalla lista",
      composeNew: "Nuova email",
      composeFrom: "Da",
      composeTo: "A",
      composeCc: "CC",
      composeBcc: "CCN",
      hideCc: "Nascondi CC",
      addCc: "Aggiungi CC",
      composeSubject: "Oggetto",
      composeBody: "Corpo",
      composePlaceholder: "Scrivi il tuo messaggio…",
      recipientPlaceholder: "Indirizzo email o nome…",
      template: "Modello",
      templateNone: "— Nessun modello —",
      attachments: "Allegati",
      addAttachment: "Aggiungi file",
      cancelBtn: "Annulla",
      sendingBtn: "Invio…",
      sendBtn: "Invia",
      unknownSender: "(sconosciuto)",
      noSubject: "(nessun oggetto)",
    },
  },
  adminComms: {
    title: "Comunicazioni",
    subtitle: "Cosa e stato spedito, com e andata, e con quali modelli",
    tabMessages: "Messaggi",
    tabTemplates: "Modelli",
    allStates: "Tutti",
    loadError: "Non e stato possibile leggere i messaggi. Serve un ruolo di amministratore.",
    noMessages: "Nessun messaggio.",
    newTemplate: "Nuovo modello",
    noTemplates: "Nessun modello.",
    active: "Attivo",
    inactive: "Non attivo",
    key: "Chiave",
    channel: "Canale",
    locale: "Lingua",
    category: "Categoria",
    subject: "Oggetto",
    body: "Corpo",
    upsertHint: "Chiave, canale e lingua insieme identificano il modello: risalvarlo lo aggiorna.",
    templateSaved: "Modello salvato",
    templateError: "Non riuscito",
  },
  adminPages: {
    title: "Pagine del sito",
    subtitle: "Contenuti statici, dati per i motori di ricerca e storico delle versioni",
    new: "Nuova pagina",
    total: "Totale",
    draftsHint: "Ci sono {{n}} pagine non pubblicate: non compaiono nell elenco qui sotto, che e quello pubblico. Si aprono dal loro indirizzo.",
    search: "Cerca per indirizzo o titolo",
    empty: "Nessuna pagina pubblicata.",
    content: "Contenuto",
    seoTitle: "Titolo per i motori",
    seoDesc: "Descrizione",
    versions: "Versioni",
    noVersions: "Nessuna versione precedente.",
    slug: "Indirizzo (slug)",
    lang: "Lingua",
    pageTitle: "Titolo",
    status: "Stato",
    body: "Contenuto",
    created: "Pagina creata",
    createError: "Non riuscito: forse lo slug e gia in uso",
  },
  crm: {
    dashboard: {
      pageTitle: "CRM Dashboard",
      pageDesc: "Gestione contatti e relazioni",
      newContact: "Nuovo contatto",
      totalContacts: "Contatti totali",
      interactions7d: "Interazioni (7gg)",
      appointments7d: "Appuntamenti (7gg)",
      pendingTodos: "Todo pendenti",
      overdueGoals: "Obiettivi scaduti",
      newContactsChart: "Nuovi contatti per mese",
      noChartData: "Nessun dato disponibile",
      acquisitionChannels: "Canali di acquisizione",
      noContacts: "Nessun contatto",
      tabContacts: "Contatti",
      tabBounced: "Bounced",
      bouncedIntro: "Indirizzi email che hanno fatto bounce (rifiutati dal server destinatario). Questi contatti sono stati disiscritti automaticamente. Correggi l'indirizzo per rimetterli in coda.",
      bouncedNone: "Nessun indirizzo bounced",
      bouncedNoneDesc: "Tutte le email risultano consegnate. Ottimo!",
      bouncedReason: "Motivo bounce",
      bouncedCampaign: "Campagna",
      bouncedUnknown: "Sconosciuto",
      bouncedFixAction: "Correggi e rimetti in coda",
      bouncedFixTitle: "Correggi indirizzo email",
      bouncedFixIntro: "Correggi l'indirizzo di {{name}}. Il contatto verrà ri-iscritto e i suoi invii rimbalzati rimessi in coda per il nuovo indirizzo.",
      bouncedOldEmail: "Indirizzo rimbalzato",
      bouncedNewEmail: "Nuovo indirizzo email",
      bouncedFixNote: "Il contatto tornerà iscritto (consenso da riconfermare) e riceverà i prossimi invii al nuovo indirizzo.",
      bouncedFixConfirm: "Correggi e rimetti in coda",
      bouncedFixedSuccess: "Email corretta — {{count}} invii rimessi in coda",
      bouncedDuplicate: "Un altro contatto ha già questa email",
      tabAgenda: "Agenda",
      tabTodos: "Todo list",
      tabGoals: "Obiettivi",
    },
    contacts: {
      pageTitle: "Contatti CRM",
      contactsTotal: "{{count}} contatti totali",
      importMap: "Importa da mappa",
      searchPlaceholder: "Cerca nome, email, azienda...",
      allChannels: "Tutti i canali",
      allStatuses: "Tutti gli stati",
      colContact: "Contatto",
      colChannel: "Canale",
      colStatus: "Stato",
      colSocial: "Social",
      colAdded: "Aggiunto",
      noContacts: "Nessun contatto trovato",
      addFirst: "Aggiungi il primo contatto",
      prevPage: "Precedente",
      nextPage: "Successiva",
      pageInfo: "Pagina {{page}} di {{pages}}",
      deleteSuccess: "Contatto eliminato",
    },
    detail: {
      eDiveMember: "Membro eDive",
      interactionRecorded: "Interazione registrata",
      newInteraction: "Nuova interazione",
      sent: "Inviato",
      received: "Ricevuto",
      internalNotePlaceholder: "Per i messaggi interni...",
      saving: "Salvataggio...",
      logInteraction: "Registra interazione",
      inviteSent: "Invito inviato",
      inviteFailed: "Invio fallito",
      inviteBtn: "Invita su eDive.tech",
      alreadyMember: "Già registrato su eDive",
      invitesSentLabel: "Inviti inviati",
      inviteAccepted: "Accettato",
      inviteExpired: "Scaduto",
      invitePending: "In attesa",
      loading: "Caricamento...",
      notFound: "Contatto non trovato",
      sectionInfo: "Informazioni",
      emailLabel: "Email:",
      phoneLabel: "Tel:",
      scoreLabel: "Punteggio:",
      socialProfiles: "Profili social",
      reconcileBtn: "Riconcilia con eDive",
      historyTitle: "Storico interazioni",
      noInteractions: "Nessuna interazione registrata",
      goalsTitle: "Obiettivi",
      noGoals: "Nessun obiettivo",
      goalDeadline: "Scadenza:",
      appointmentsTitle: "Appuntamenti",
      noAppointments: "Nessun appuntamento",
      reconcileSuccess: "Contatto riconciliato con eDive",
      memberNotFound: "Membro eDive non trovato",
      enrichSuccess: "Contatto arricchito",
      enrichError: "Arricchimento fallito",
      enrichBtn: "Arricchisci",
      editBtn: "Modifica",
    },
    form: {
      editTitle: "Modifica contatto",
      newTitle: "Nuovo contatto",
      sectionAnagrafica: "Anagrafica",
      firstNameLabel: "Nome *",
      lastNameLabel: "Cognome *",
      emailLabel: "Email",
      phoneLabel: "Telefono",
      companyLabel: "Azienda / Organizzazione",
      roleLabel: "Ruolo",
      channelLabel: "Canale di ingresso *",
      statusLabel: "Stato",
      notesLabel: "Note",
      sectionSocial: "Profili Social",
      cancelBtn: "Annulla",
      saving: "Salvataggio...",
      updateBtn: "Aggiorna",
      createBtn: "Crea contatto",
      updateSuccess: "Contatto aggiornato",
      createSuccess: "Contatto creato",
      saveError: "Errore nel salvataggio",
    },
    agenda: {
      pageTitle: "Agenda personale",
      pageDesc: "I tuoi appuntamenti CRM",
      exportIcal: "Esporta iCal",
      newBtn: "Nuovo",
      upcomingTab: "Prossimi",
      pastTab: "Passati",
      noUpcoming: "Nessun appuntamento in programma",
      noPast: "Nessun appuntamento passato",
      icalBannerText: "Per sincronizzare con Outlook o il calendario mobile, usa il link personale qui sotto:",
      copyBtn: "Copia",
      urlCopied: "URL copiato",
      exportTitle: "Esporta iCal (Outlook/mobile)",
      deleteTitle: "Cancella appuntamento",
      types: {
        CALL: "Telefonata",
        VIDEO_CALL: "Video call",
        MEETING: "Meeting",
        EMAIL: "Email",
        OTHER: "Altro",
      },
      newModal: {
        title: "Nuovo appuntamento",
        titleLabel: "Titolo *",
        contactLabel: "Contatto",
        noContact: "— Nessun contatto —",
        startLabel: "Inizio *",
        endLabel: "Fine *",
        typeLabel: "Tipo",
        locationLabel: "Luogo",
        locationPlaceholder: "Indirizzo o link...",
        notesLabel: "Note",
        notificationsLabel: "Notifiche",
        notifyEmail: "Email",
        notifyWhatsapp: "WhatsApp",
        notifyInternal: "Interno",
        cancelBtn: "Annulla",
        saving: "Salvataggio...",
        createBtn: "Crea appuntamento",
      },
      createSuccess: "Appuntamento creato",
      deleteSuccess: "Appuntamento cancellato",
      createError: "Errore nella creazione",
    },
    todos: {
      pageTitle: "Todo list",
      overdueLabel: "{{count}} todo scaduto/i",
      tabPending: "Da fare",
      tabCompleted: "Completati",
      addPlaceholder: "Aggiungi todo...",
      titlePlaceholder: "Titolo del todo...",
      saving: "Salvataggio...",
      cancelBtn: "Annulla",
      addBtn: "Aggiungi",
      noPending: "Nessun todo pendente! 🎉",
      noCompleted: "Nessun todo completato",
      deleteSuccess: "Todo eliminato",
      priorities: {
        HIGH: "Alta",
        MEDIUM: "Media",
        LOW: "Bassa",
      },
    },
    enrich: {
      pageTitle: "Arricchimento contatti via web",
      pageDesc: "Cerca online informazioni mancanti per ogni contatto CRM: email, telefono, sito, pagina Facebook",
      howItWorks: "Come funziona",
      configTitle: "Configurazione",
      contactsToProcess: "Contatti da elaborare",
      estimatedDuration: "Durata stimata: ~{{min}} min",
      forceEnrich: "Riarricchisci tutti (ignora cache 30gg)",
      startBtn: "Avvia arricchimento web ({{count}} contatti)",
      running: "Arricchimento in corso…",
      resultTitle: "Risultati",
      resultRunningTitle: "Arricchimento avviato in background",
      processed: "Elaborati",
      enriched: "Aggiornati",
      skipped: "Saltati",
      errors: "Errori",
      viewEnriched: "Visualizza contatti arricchiti →",
      startSuccess: "Arricchimento avviato",
      startError: "Errore durante l'arricchimento",
      jobExpired: "Job scaduto — rilancia l\\",
    },
    osmImport: {
      pageTitle: "Importa dive center da OpenStreetMap",
      pageDesc: "Clicca sulla mappa per selezionare una nazione ed avviare l'importazione",
      worldImportTitle: "Importa mercato italiano mondiale",
      worldImportDesc: "17 paesi — max 300 dive center per paese",
      worldStartBtn: "🚀 Avvia importazione globale",
      worldStarted: "✓ Avviata",
      worldStarting: "Avvio…",
      fixChannelTitle: "Hai contatti importati senza canale?",
      fixChannelDesc: "Clicca per assegnare automaticamente la sorgente \"OSM / Directory\" ai contatti già importati.",
      fixChannelBtn: "Correggi canale",
      fixChannelFixing: "Correzione…",
      fixChannelFixed: "✓ Corretti {{count}}",
      geocoding: "Rilevazione paese in corso…",
      clickMap: "Clicca sulla mappa per selezionare un paese",
      noBbox: "Bounding box non predefinita per questo paese — l'importazione potrebbe non trovare risultati",
      maxResults: "Risultati massimi",
      dryRun: "Anteprima (dry run)",
      importBtn: "Importa dive center in {{country}}",
      previewBtn: "Anteprima dive center in {{country}}",
      importing: "Importazione in corso…",
      resultTitle: "Risultati importazione",
      resultRunningTitle: "Importazione avviata in background",
      previewTitle: "Anteprima risultati",
      found: "Trovati",
      created: "Creati",
      duplicates: "Doppi",
      previewLabel: "Anteprima (prime {{count}} voci):",
      removeDryRun: "Rimuovi la spunta \"dry run\" e riavvia per salvare i contatti nel CRM.",
      viewImported: "Visualizza i contatti importati →",
      colName: "Nome",
      colCity: "Città",
      colPhone: "Telefono",
      colWebsite: "Sito",
      countryUnknown: "Paese non riconosciuto per questa posizione",
      fixSuccess: "Corretti {{count}} contatti",
      fixError: "Errore durante la correzione",
      worldSuccess: "Importazione mondiale avviata — {{count}} paesi",
      worldError: "Errore durante l'importazione mondiale",
      importError: "Errore durante l'importazione",
    },
  },
  social: {
    title: "Social",
    newPost: "Nuovo Post",
    like: "Mi piace",
    unlike: "Non mi piace più",
    comment: "Commenta",
    follow: "Segui",
    unfollow: "Smetti di seguire",
    feed: "Feed",
    attachDive: "Allega Immersione",
    tabs: {
      feed: "Feed",
      challenges: "Sfide",
      badges: "Badge",
      groups: "Gruppi",
      events: "Eventi",
      people: "Persone",
      radar: "Buddy Radar",
    },
    achievementUnlocked: "Traguardo sbloccato",
    noActivity: "Nessuna attività",
    noActivityDesc: "Segui altri subacquei per vedere le loro attività qui.",
    sharePrompt: "Condividi qualcosa con la community...",
    commentPlaceholder: "Scrivi un commento...",
    send: "Invia",
    noComments: "Nessun commento ancora",
    postPublished: "Post pubblicato",
    visibility: "Visibilità",
    publish: "Pubblica",
    publishing: "Pubblicazione...",
    joinGroup: "Unisciti",
    leaveGroup: "Abbandona",
    joinEvent: "Partecipa",
    leaveEvent: "Abbandona",
    participants: "{{count}} partecipanti",
    members: "{{count}} membri",
    noGroups: "Nessun gruppo disponibile",
    noChallenges: "Nessuna sfida disponibile",
    noEvents: "Nessun evento disponibile",
    noPeople: "Nessun utente trovato",
    followSuccess: "Stai seguendo questo utente",
    unfollowSuccess: "Hai smesso di seguire questo utente",
    viewDive: "Vedi immersione",
    user: "Utente",
    diver: "Subacqueo",
    retryMessage: "Riprova tra qualche momento",
    subtitle: "Il tuo spazio social subacqueo: condividi aggiornamenti, segui amici, sfoglia i logbook della community e resta connesso.",
    groupCreated: "Gruppo creato",
    groupUpdated: "Gruppo aggiornato",
    groupUpdateError: "Errore aggiornamento gruppo",
    groupConverted: "Gruppo convertito in associazione con successo",
    groupConvertError: "Errore conversione",
    searchGroupsPh: "Cerca gruppi...",
    groupPrivate: "Privato",
    groupAssociation: "Associazione",
    memberCount_one: "{{count}} membro",
    memberCount_other: "{{count}} membri",
    convertToAssociation: "Converti in associazione",
    confirmConvert: "Converti \"{{name}}\" in associazione? Diventerai il Presidente. Questa azione non è reversibile.",
    createGroupTitle: "Crea gruppo",
    editGroupTitle: "Modifica: {{name}}",
    groupNameLabel: "Nome gruppo *",
    groupDescLabel: "Descrizione",
    groupPublicLabel: "Gruppo pubblico (visibile a tutti)",
    groupContactsTitle: "Contatti",
    groupContactPhone: "Telefono di contatto",
    groupContactEmail: "Email di contatto",
    groupContactUserId: "ID utente di riferimento",
    noGroupsDesc: "Crea il primo gruppo o cerca community di subacquei.",
    createEventBtn: "Crea evento",
    noEventsDesc: "Organizza un'uscita o un'attività con la community.",
    upcomingEvents: "Prossimi eventi",
    pastEvents: "Passati",
    createEventTitle: "Crea evento community",
    eventTitleLabel: "Titolo *",
    eventDescLabel: "Descrizione",
    eventLocationLabel: "Luogo",
    eventMaxPLabel: "Max partecipanti",
    eventDateLabel: "Data e ora *",
    eventCreated: "Evento creato",
    fullEvent: "Pieno",
    participantsLabel: "partecipanti",
    viewProfile: "Vedi profilo →",
    divesCount_one: "{{count}} immersione",
    divesCount_other: "{{count}} immersioni",
    chatError: "Errore nell'apertura della chat",
    followersLabel: "Ti segue",
    followingLabel: "Stai seguendo",
    noFollowers: "Nessun follower ancora",
    noFollowersDesc: "Quando qualcuno ti seguirà, apparirà qui.",
    noFollowing: "Non segui nessuno",
    noFollowingDesc: "Cerca persone nella tab Cerca e inizia a seguirle.",
    loadError: "Errore nel caricamento",
    searchPeoplePh: "Cerca per nome, città…",
    profilesFound_one: "{{count}} profilo trovato",
    profilesFound_other: "{{count}} profili trovati",
    subTabSearch: "Cerca",
    subTabFollowers: "Seguaci",
    subTabFollowing: "Seguiti",
    radarDesc: "Attiva il radar per trovare subacquei nelle vicinanze che programmano un'immersione nella stessa data. Il tuo ping scade automaticamente dopo 48 ore.",
    diveDateLabel: "Data prevista immersione",
    searchRadiusLabel: "Raggio ricerca (km)",
    activatingRadar: "Attivazione…",
    radarActive: "Radar Attivo — Aggiorna posizione",
    activateRadar: "Attiva Radar",
    radarExpiry: "La tua posizione radar scade tra 48 ore",
    nearbyDivers: "Subacquei nelle vicinanze",
    foundInRadius: "{{total}} trovati entro {{km}} km",
    noBuddyFound: "Nessun buddy trovato",
    noBuddyDesc: "Nessun subacqueo con radar attivo entro {{km}} km per la data selezionata.",
    radarActivated: "Radar attivato — gli altri subacquei potranno trovarti per 48 ore",
    geoPermError: "Permesso di geolocalizzazione negato. Abilita la posizione nel browser.",
    profileType: {
      DIVER: "🤿 Subacqueo",
      FREEDIVER: "🧘 Apneista",
      INSTRUCTOR: "🎓 Istruttore",
      DIVE_MASTER: "⭐ Divemaster",
      DIVE_DOCTOR: "⚕️ Medico subacqueo",
      UNDERWATER_PHOTOGRAPHER: "📷 Fotografo subacqueo",
      RESEARCH_CENTER: "🔬 Centro di ricerca",
    },
    profileTypeFilter: {
      all: "Tutti",
      DIVER: "Subacquei",
      FREEDIVER: "Apneisti",
      INSTRUCTOR: "Istruttori",
      DIVE_MASTER: "Divemaster",
      DIVE_DOCTOR: "Medici subacquei",
      UNDERWATER_PHOTOGRAPHER: "Fotografi subacquei",
      RESEARCH_CENTER: "Centri di ricerca",
    },
    divesCount: "{{count}} immersioni",
    memberCount: "{{count}} membri",
    noPeopleDesc: "Nessun subacqueo corrisponde ai criteri di ricerca. Prova a modificare i filtri o ad allargare l'area.",
    profilesFound: "{{count}} profili trovati",
    radarPrompt: "Consenti l'accesso alla tua posizione per scoprire i subacquei che si sono immersi vicino a te.",
  },
  chat: {
    title: "Messaggi",
    newConversation: "Nuova Conversazione",
    newConvTitle: "Nuova conversazione",
    typeMessage: "Scrivi un messaggio...",
    send: "Invia",
    noConversations: "Nessuna conversazione",
    startChatting: "Inizia a chattare →",
    online: "Online",
    live: "Live",
    connecting: "Connessione…",
    offline: "Offline",
    participants: "{{count}} partecipanti",
    conversationLabel: "Conversazione #{{id}}",
    selectConversation: "Seleziona una conversazione",
    selectConversationHint: "o iniziane una nuova con il pulsante +",
    noMessages: "Nessun messaggio ancora. Di qualcosa! 👋",
    searchPlaceholder: "Cerca per nome o username…",
    searchHint: "Digita almeno 2 caratteri per cercare",
    noUsersFound: "Nessun utente trovato",
    creating: "Creazione…",
    startConversation: "Avvia conversazione",
    createSuccess: "Conversazione creata",
    createError: "Errore nella creazione della conversazione",
    personalNote: "Nota personale",
    participantsSection: "Partecipanti",
    you: "(tu)",
    removeParticipant: "Rimuovi",
    removeParticipantConfirm: "Rimuovere questo partecipante?",
    removeParticipantSuccess: "Partecipante rimosso",
    removeParticipantError: "Errore nella rimozione del partecipante",
    addParticipant: "Aggiungi partecipante",
    addParticipantTitle: "Aggiungi partecipante",
    addParticipantSuccess: "Partecipante aggiunto",
    addParticipantError: "Errore nell'aggiunta del partecipante",
    userPrefix: "Utente",
  },
  insurance: {
    title: "Assicurazione",
    plans: "Piani Disponibili",
    myPolicies: "Le Mie Polizze",
    subscribe: "Sottoscrivi",
    policyNumber: "Numero Polizza",
    startDate: "Inizio",
    endDate: "Scadenza",
    statuses: {
      ACTIVE: "Attiva",
      EXPIRED: "Scaduta",
      CANCELLED: "Annullata",
    },
    coverage: "Copertura",
    premium: "Premio",
    maxCoverage: "massimale",
    startDateLabel: "Data inizio",
    policyCancelled: "Polizza annullata",
    claimFiled: "Sinistro aperto con successo",
    claimError: "Errore nell'apertura del sinistro",
    policyActivated: "Polizza attivata",
    activationError: "Errore nell'attivazione",
    cancelPolicy: "Annulla polizza",
    cancelConfirm: "Sei sicuro di voler annullare questa polizza?",
    claims: "Sinistri",
    hideClaims: "Nascondi sinistri",
    openClaim: "Apri sinistro",
    newClaim: "Nuovo sinistro",
    noClaims: "Nessun sinistro aperto",
    claimDescription: "Descrizione",
    claimDate: "Data incidente",
    claimAmount: "Importo richiesto (€)",
    claimNotes: "Note aggiuntive",
    submitting: "Invio…",
    claimStatuses: {
      DRAFT: "Bozza",
      SUBMITTED: "Inviata",
      PROCESSING: "In lavorazione",
      APPROVED: "Approvata",
      REJECTED: "Rifiutata",
      PAID: "Pagata",
    },
  },
  bookings: {
    title: "Prenotazioni",
    newBooking: "Nuova Prenotazione",
    sessions: "Sessioni Disponibili",
    myBookings: "Le Mie Prenotazioni",
    statuses: {
      PENDING: "In Attesa",
      CONFIRMED: "Confermata",
      CANCELLED: "Annullata",
      COMPLETED: "Completata",
    },
    confirmBooking: "Conferma prenotazione",
    booking: "Prenotazione…",
    booked: "Prenotazione effettuata",
    cancelled: "Prenotazione annullata",
    confirmed: "Prenotazione confermata",
    noSessions: "Nessuna sessione disponibile",
    noBookings: "Nessuna prenotazione",
    notesPlaceholder: "Certificazione, esigenze speciali, richieste particolari…",
    full: "Sessione al completo — nessun posto disponibile",
    alreadyBooked: "Hai già una prenotazione per questa sessione",
    testData: "Dati di test — questa sessione non è ancora operativa",
    genericError: "Errore nella prenotazione",
    unavailable: "Prenotazioni non disponibili",
    unavailableDesc: "Riprova tra qualche istante o rieffettua il login.",
    spotsAvailable: "{{available}} posti disponibili su {{total}}",
    notesOptional: "Note (opzionale)",
    sessionCreated: "Sessione creata",
    sessionCreateError: "Errore nella creazione",
    free: "Gratuito",
    status: {
      pending: "In attesa",
      confirmed: "Confermata",
      cancelled: "Annullata",
      paid: "Pagata",
    },
    tabs: {
      sessions: "Sessioni",
      myBookings: "Le mie prenotazioni",
      mySessions: "Le mie sessioni",
    },
    newSession: "Nuova sessione",
    sessionsCount: "{{count}} sessioni",
    noSessionsFiltered: "Nessuna sessione corrisponde ai filtri",
    equipIncluded: "Attrezzatura inclusa",
    book: "Prenota",
    signWaiver: "Firma liberatoria",
    authorize: "Autorizza",
    pay: "Paga",
    paymentUnavailable: "Pagamento non disponibile",
    sessionsUnavailable: "Sessioni non disponibili",
    retryLater: "Riprova più tardi",
    noSessionsYet: "Ancora nessuna sessione",
    createFirstSession: "Crea la prima sessione",
    requestSentPending: "Richiesta inviata: in attesa di conferma dal centro",
  },
  media: {
    title: "Media",
    upload: "Carica File",
    uploadSuccess: "File caricato con successo",
    gallery: "Galleria",
    myMedia: "I Miei Media",
    attachToDive: "Allega a Immersione",
    empty: "Nessun file caricato",
    processing: "Elaborazione...",
  },
  associations: {
    title: "Associazioni",
    subtitle: "Scopri e gestisci le associazioni culturali di immersione",
    create: "Crea Associazione",
    createTitle: "Nuova Associazione",
    createFirst: "Crea la prima associazione",
    createConfirm: "Crea Associazione",
    created: "Associazione creata con successo",
    empty: "Nessuna associazione trovata",
    searchPlaceholder: "Cerca per nome...",
    allStatuses: "Tutti gli stati",
    name: "Nome",
    namePlaceholder: "Nome dell'associazione",
    description: "Descrizione",
    descriptionPlaceholder: "Descrizione dell'associazione (opzionale)",
    autoApprove: "Approvazione automatica",
    autoApproveHint: "i nuovi soci vengono approvati automaticamente",
    autoApproveOn: "Approvazione automatica",
    autoApproveOff: "Approvazione manuale",
    presidentHint: "Diventerai automaticamente il Presidente dell'associazione",
    stepInfo: "Informazioni",
    stepReview: "Riepilogo",
    members: "Soci",
    creatorType: "Tipo creatore",
    approvalMode: "Modalità iscrizione",
    tabInfo: "Info",
    tabManagers: "Responsabili",
    tabMembers: "Iscrizione",
    tabEvents: "Eventi",
    join: "Iscriviti",
    leave: "Abbandona",
    joinedOk: "Iscrizione effettuata",
    leftOk: "Hai abbandonato l'associazione",
    approve: "Approva",
    revoke: "Revoca",
    memberApproved: "Socio approvato",
    memberRevoked: "Iscrizione revocata",
    addManagerPlaceholder: "User ID del nuovo responsabile",
    managerAdded: "Responsabile aggiunto",
    managerRemoved: "Responsabile rimosso",
    newEvent: "Nuovo Evento",
    eventTitle: "Titolo dell'evento",
    createEvent: "Crea Evento",
    eventCreated: "Evento creato",
    eventJoined: "Sei iscritto all'evento",
    eventLeft: "Hai abbandonato l'evento",
    status: {
      ACTIVE: "Attiva",
      SUSPENDED: "Sospesa",
      CLOSED: "Chiusa",
    },
  },
  errors: {
    networkError: "Errore di connessione. Riprova.",
    unauthorized: "Accesso non autorizzato",
    notFound: "Non abbiamo trovato quello che cercavi. Potrebbe essere stato spostato.",
    serverError: "Errore del server. Riprova più tardi.",
    invalidEmail: "Email non valida",
    passwordMismatch: "Le password non corrispondono",
    passwordTooShort: "La password deve essere di almeno 8 caratteri",
    network: "Sembra esserci un problema di connessione. Controlla la rete e riprova tra poco.",
    forbidden: "Questa sezione fa parte di un percorso dedicato: continua a crescere su eDive per accedervi.",
    timeout: "La richiesta ha impiegato troppo tempo. Riprova tra un momento.",
    conflict: "Qualcosa è cambiato nel frattempo. Ricarica e riprova.",
    tooLarge: "Il file è troppo grande. Prova a comprimerlo o a ridurne le dimensioni.",
    validation: "Alcuni dati non sono nel formato giusto. Controlla i campi e riprova.",
    rateLimit: "Un attimo di respiro: troppe richieste ravvicinate. Riprova tra qualche secondo.",
    server: "Un piccolo intoppo dalla nostra parte. Stiamo sistemando: riprova tra poco.",
    generic: "Qualcosa non è andato come previsto. Riprova, e se il problema resta scrivici.",
  },
  tourism: {
    title: "Viaggi & Pacchetti",
    browse: "Sfoglia",
    myBookings: "Le Mie Prenotazioni",
    myPackages: "I Miei Pacchetti",
    searchPackages: "Cerca pacchetti...",
    noPackages: "Nessun pacchetto disponibile",
    noBookings: "Nessuna prenotazione",
    book: "Prenota",
    confirmBook: "Conferma Prenotazione",
    notesPlaceholder: "Note o richieste speciali...",
    createPackage: "Crea Pacchetto",
    publish: "Pubblica",
    days: "giorni",
    participants: "partecipanti",
    location: "Destinazione",
    duration: "Durata",
    pricePerPerson: "Prezzo a persona",
    bookingSent: "Prenotazione inviata!",
    bookingError: "Errore nella prenotazione",
    bookingConfirmed: "Prenotazione confermata",
    confirmError: "Errore nella conferma",
    bookingCancelled: "Prenotazione annullata",
    cancelError: "Errore nell'annullamento",
    packageDraft: "Pacchetto creato come bozza",
    packagePublished: "Pacchetto pubblicato",
    createError: "Errore nella creazione",
    subtitle: "Pacchetti di viaggio subacqueo, liveaboard e destinazioni curate per ogni livello. Scopri, compara e prenota la tua prossima avventura.",
  },
  marketplace: {
    title: "Marketplace",
    browse: "Sfoglia",
    wishlist: "Lista Desideri",
    myListings: "I Miei Annunci",
    search: "Cerca attrezzatura...",
    allCategories: "Tutte le categorie",
    noListings: "Nessun annuncio trovato",
    wishlistEmpty: "Lista desideri vuota",
    createListing: "Crea Annuncio",
    offer: "Offerta",
    makeOffer: "Fai un'Offerta",
    askingPrice: "Prezzo richiesto",
    yourOffer: "La tua offerta",
    message: "Messaggio",
    sendOffer: "Invia Offerta",
    condition: "Condizioni",
    paidOn: "Pagato il",
  },
  calendar: {
    title: "Calendario",
    newEvent: "Nuovo Evento",
    editEvent: "Modifica Evento",
    eventType: "Tipo",
    startsAt: "Inizio",
    endsAt: "Fine",
    location: "Luogo",
    reminder: "Promemoria",
    noEvents: "Nessun evento in questo giorno",
    upcomingEvents: "Prossimi eventi",
    before: "prima",
    endAt: "Fine",
    type: "Tipo",
  },
  content: {
    title: "Articoli & Guide",
    feed: "Sfoglia",
    write: "Scrivi",
    myArticles: "I Miei Articoli",
    moderation: "Moderazione",
    searchArticles: "Cerca articoli...",
    noArticles: "Nessun articolo pubblicato",
    noMyArticles: "Non hai ancora scritto articoli",
    noArticlesPending: "Nessun articolo in attesa di revisione",
    newArticle: "Nuovo Articolo",
    summary: "Sommario",
    body: "Contenuto",
    bodyPlaceholder: "Scrivi il tuo articolo qui...",
    tags: "Tag",
    saveDraft: "Salva Bozza",
    draftSaved: "Bozza salvata",
    submit: "Invia per Revisione",
    approve: "Approva",
    reject: "Rifiuta",
    rejectionReason: "Motivo del rifiuto...",
    allLanguages: "Tutte le lingue",
    allCategories: "Tutte le categorie",
    allSources: "Tutte le fonti",
    articlesFound: "{{count}} articoli trovati",
    loadingNews: "Caricamento notizie...",
    readMore: "Leggi di più",
    readLess: "Mostra meno",
    fullArticle: "Articolo completo",
    firstDivePrompt: "Registra la tua prima immersione",
    loyaltyPoints: "Punti fedeltà",
    uploadFailed: "Upload fallito",
    newsWeb: "Notizie Web",
    catNews: "Notizie",
    catMagazine: "Magazine",
    catSafety: "Sicurezza",
    catScience: "Scienza",
    noArticlesInLang: "Nessun articolo disponibile in questa lingua.",
    showAllLanguages: "Mostra tutte le lingue",
  },
  directory: {
    subtitle: "Directory mediterranea — catalogo ricercabile delle strutture",
    allCountries: "Tutti i paesi",
    importMediterranean: "Importa dati Mediterraneo",
    importMediterraneanCategory: "Importa {{category}} dal Mediterraneo",
    importMediterraneanHint: "Importa automaticamente {{category}} dal Mediterraneo via OpenStreetMap",
    records: "record",
    empty: "Nessuna voce presente",
    emptyHint: "Usa il tasto importa per caricare i dati del Mediterraneo",
    colName: "Nome",
    colCity: "Città",
    colCountry: "Paese",
    colContact: "Contatto",
    colWebsite: "Sito web",
    colSource: "Fonte",
    sitesTitle: "Siti di Immersione nel Mediterraneo",
    sitesSubtitle: "{{count}} siti curati in tutto il Mar Mediterraneo",
    searchPlaceholder: "Cerca per nome, regione…",
    allLevels: "Tutti i livelli",
    allTypes: "Tutti i tipi",
    viewList: "Lista",
    viewMap: "Mappa",
    noResults: "Nessun sito corrisponde ai filtri.",
    resultsCount: "{{count}} siti trovati",
    maxDepth: "Max {{depth}}m",
    highlights: "Punti di interesse",
    openInMaps: "Apri su Maps",
    "level.beginner": "Principiante",
    "level.intermediate": "Intermedio",
    "level.advanced": "Avanzato",
    "level.technical": "Tecnico",
    "type.wall": "Parete",
    "type.wreck": "Relitto",
    "type.reef": "Barriera",
    "type.cave": "Grotta",
    "type.drift": "Corrente",
    "type.mixed": "Misto",
  },
  ai: {
    title: "AI Assistant",
    subtitle: "Assistente intelligente per pianificazione, sicurezza e identificazione specie marine",
    advisorTitle: "Consulente AI",
    advisorDesc: "Chat intelligente per consigli personalizzati",
    divePlan: "Piano Immersione",
    divePlanDesc: "Pianifica la tua prossima immersione con l'AI",
    safety: "Sicurezza",
    safetyDesc: "Valuta i rischi e verifica la sicurezza pre-immersione",
    speciesId: "Specie",
    speciesIdDesc: "Identifica specie marine da una descrizione",
    equipment: "Attrezzatura",
    equipmentDesc: "Consigli attrezzatura per ogni tipo di immersione",
    sites: "Siti",
    sitesDesc: "Trova i migliori siti vicino a te o per la tua prossima meta",
    courses: "Corsi",
    coursesDesc: "Scopri i corsi consigliati per il tuo livello",
    tabProfileDesc: "Analisi intelligente del tuo stile di immersione",
    tabTripReportDesc: "Genera un report dettagliato del tuo viaggio subacqueo",
    tabDebriefDesc: "Analisi post-immersione e suggerimenti personalizzati",
    tabBuddyDesc: "Trova il buddy ideale per la tua prossima uscita",
    getDivePlan: "Genera Piano",
    assessSafety: "Valuta Sicurezza",
    identifySpecies: "Identifica Specie",
    recommendEquipment: "Consiglia Attrezzatura",
    findDiveSites: "Trova Siti",
    recommendCourses: "Consiglia Corsi",
    thinking: "L'AI sta elaborando...",
    cached: "Risposta dalla cache",
    confidence: "Affidabilità",
    speciesDescription: "Descrivi l'animale osservato",
    speciesDescriptionPlaceholder: "Es: pesce allungato, colore arancione con strisce bianche, circa 15cm, nuotava vicino alle madrepore...",
    durationMin: "Durata (min)",
    gasLabel: "Gas misto",
    locationLabel: "Posizione",
    locationRegion: "Posizione / regione",
    locationPlaceholder: "Mediterraneo, Mar Rosso...",
    locationPlaceholderShort: "Mediterraneo...",
    locationPlaceholderSites: "Italia, Maldive...",
    recentDives: "Immersioni recenti",
    depthM: "Profondità (m)",
    diverTypeLabel: "Tipo subacqueo",
    environmentLabel: "Ambiente",
    budgetLabel: "Budget (€)",
    maxDepthM: "Profondità max (m)",
    currentCerts: "Brevetti attuali (separati da virgola)",
    goalsLabel: "Obiettivi (separati da virgola)",
    totalDives: "Immersioni totali",
    certPlaceholder: "PADI OW, PADI AOW...",
    goalsPlaceholder: "relitti, tecnica...",
    noResult: "Nessun risultato disponibile per questa richiesta.",
    maxDepthLabel: "Profondità massima",
    prerequisitesLabel: "Prerequisiti",
    gasAir: "Aria",
    gasNitrox32: "Nitrox 32%",
    gasNitrox36: "Nitrox 36%",
    gasNitrox50: "Nitrox 50% (EAN50)",
    gasTrimix: "Trimix",
    gasTrimix2135: "Trimix 21/35",
    expBeginner: "Principiante",
    expIntermediate: "Intermedio",
    expAdvanced: "Avanzato",
    expTechnical: "Tecnico",
    diverRecreational: "Ricreativo",
    diverTechnical: "Tecnico",
    diverFreediving: "Apnea",
    diverProfessional: "Professionale",
    envWarmWater: "Acque calde",
    envColdWater: "Acque fredde",
    envMixed: "Misto",
    tripReportTitle: "Genera il Resoconto del Viaggio",
    tripReportDesc: "L'AI crea un documento completo del tuo viaggio subacqueo — narrativo per il blog, tecnico per il logbook o social per i tuoi profili. Inserisci titolo, destinazione e i dettagli di ogni immersione: profondità, durata, visibilità, temperatura, gas usato e note sulle specie avvistate. L'AI elabora tutto e produce statistiche aggregate, highlights del viaggio, sezioni descrittive e hashtag pronti per la condivisione.",
    tabProfile: "Analisi",
    tabTripReport: "Resoconto",
    tabDebrief: "Debrief",
    tabBuddy: "Buddy",
    reportToCommunity: "Segnala alla community",
    reportSpeciesTitle: "Segnala alla community",
    reportSpeciesSuccess: "Avvistamento segnalato!",
    reportSpeciesSuccessDesc: "Visibile nella sezione \"Specie\" del tuo profilo",
    reportSpeciesLabel: "Specie",
    reportSpeciesPlaceholder: "Nome specie...",
    reportSpeciesAiId: "Identificata da AI (confidenza: {{pct}}%)",
    reportDateLabel: "Data",
    reportDepthLabel: "Profondità (m)",
    reportNotesLabel: "Note (opzionale)",
    reportNotesPlaceholder: "Descrizione, comportamento...",
    reportSendError: "Errore nell'invio. Riprova.",
    reportSubmit: "Segnala avvistamento",
    profileAnalysisDesc: "Analisi AI del tuo profilo di immersione basata sugli ultimi {{n}} log.",
    profileStatTotalDives: "Immersioni totali",
    profileStatNight: "Notturne",
    profileStatDeco: "Deco",
    profileAnalyzing: "Analisi in corso…",
    profileAnalyzeBtn: "Analizza il mio profilo",
    profileNoLogs: "Aggiungi immersioni al logbook per abilitare l'analisi.",
    profileCachedResult: "Risultato dalla cache",
    profileError: "Errore nell'analisi. Riprova tra qualche istante.",
    tripTitleLabel: "Titolo viaggio",
    tripTitlePlaceholder: "Es. Settimana alle Maldive",
    tripDestLabel: "Destinazione",
    tripDestPlaceholder: "Es. Atollo di Ari, Maldive",
    tripStyleLabel: "Stile del resoconto",
    tripStyleNarrative: "Narrativo",
    tripStyleTechnical: "Tecnico",
    tripStyleSocial: "Social",
    tripDivesHeader: "Immersioni ({{count}}/30)",
    tripAddDive: "+ Aggiungi immersione",
    tripDiveNum: "Immersione {{n}}",
    tripDiveRemove: "Rimuovi",
    tripDiveDateLabel: "Data",
    tripDiveSiteLabel: "Sito",
    tripDiveSitePlaceholder: "Nome sito",
    tripDiveDepthLabel: "Profondità (m)",
    tripDiveDurationLabel: "Durata (min)",
    tripDiveVisibilityLabel: "Visibilità (m)",
    tripDiveTempLabel: "Temp (°C)",
    tripDiveGasLabel: "Gas",
    tripDiveGasPlaceholder: "aria",
    tripDiveNotesLabel: "Note",
    tripDiveNotesPlaceholder: "Condizioni, aneddoti...",
    tripDiveSpeciesLabel: "Fauna avvistata (separata da virgola)",
    tripDiveSpeciesPlaceholder: "Tartaruga, Barracuda…",
    tripDiveBuddiesLabel: "Buddy (separati da virgola)",
    tripDiveBuddiesPlaceholder: "Marco, Sara…",
    tripGenerating: "Generazione in corso...",
    tripGenerate: "Genera resoconto",
    tripGenerateError: "Errore nella generazione. Riprova.",
    tripCachedResponse: "Risposta dalla cache",
    tripStatDives: "Immersioni",
    tripStatMinutes: "Minuti totali",
    tripStatMaxDepth: "Profondità max",
    tripStatAvgDepth: "Profondità media",
    tripStatAvgVis: "Visibilità media",
    tripHighlights: "Highlights",
    tripFauna: "Fauna avvistata",
    debriefIntro: "Inserisci i dati dell'immersione appena completata per ricevere un'analisi tecnica e consigli di sicurezza.",
    debriefDateLabel: "Data",
    debriefMaxDepthLabel: "Profondità max (m)",
    debriefDurationLabel: "Durata (min)",
    debriefAscentLabel: "Velocità risalita (m/min)",
    debriefAscentPlaceholder: "es. 9",
    debriefSacLabel: "SAC rate (L/min)",
    debriefSacPlaceholder: "es. 18",
    debriefTempLabel: "Temp. acqua (°C)",
    debriefTempPlaceholder: "es. 22",
    debriefO2Label: "O₂% gas",
    debriefHeLabel: "He% (trimix)",
    debriefDiveTypeLabel: "Tipo immersione",
    debriefNotesLabel: "Note (incidenti, sensazioni, condizioni)",
    debriefNotesPlaceholder: "es. leggera narcosi a 28m, corrente moderata, visibilità 10m...",
    debriefAnalyzing: "Analisi in corso...",
    debriefAnalyze: "Analizza immersione",
    debriefOverallRating: "Valutazione complessiva",
    debriefNitrogenLoad: "Carico azoto stimato",
    debriefSafetyIssues: "Problemi di sicurezza",
    debriefRecommendations: "Raccomandazioni",
    debriefNextDive: "Prossima immersione",
    debriefRatingExcellent: "Eccellente",
    debriefRatingGood: "Buona",
    debriefRatingAcceptable: "Accettabile",
    debriefRatingNeedsImprovement: "Da migliorare",
    debriefNitrogenLow: "Basso",
    debriefNitrogenModerate: "Moderato",
    debriefNitrogenHigh: "Alto",
    buddyIntro: "Descriviti come subacqueo per ricevere un profilo del buddy ideale e consigli su come trovarlo.",
    buddyTotalDives: "Immersioni totali",
    buddyCertLabel: "Certificazione",
    buddyDepthLabel: "Profondità preferita (m)",
    buddyDiveTypesLabel: "Tipi immersione (virgola)",
    buddyDiveTypesPlaceholder: "recreational, wreck, cave",
    buddyInterestsLabel: "Interessi (virgola)",
    buddyInterestsPlaceholder: "fotografia, biologia marina",
    buddyRegionLabel: "Regione / area",
    buddyRegionPlaceholder: "es. Mar Mediterraneo",
    buddySearching: "Ricerca in corso...",
    buddyFind: "Trova buddy ideale",
    buddyIdealProfile: "Profilo buddy ideale",
    buddyExpLevel: "Livello esperienza",
    buddyCertMin: "Certificazione minima",
    buddyCommStyle: "Stile comunicazione",
    buddySharedInterests: "Interessi condivisi",
    buddySpecialSkills: "Skill speciali utili",
    buddyMatchingTips: "Consigli per trovare il buddy",
    buddySafety: "Sicurezza in coppia",
    buddyWhereToFind: "Dove trovare buddy",
    backToHub: "Tutti gli strumenti AI",
    hubSectionTitle: "Scegli uno strumento",
    goNoGo: "Esito",
    recommendations: "Raccomandazioni",
    warnings: "Avvertenze",
    equipmentSuggestions: "Attrezzatura suggerita",
    riskFactors: "Fattori di rischio",
    mitigations: "Mitigazioni",
    essentialGear: "Attrezzatura essenziale",
    optionalGear: "Attrezzatura opzionale",
    brands: "Marche consigliate",
    tips: "Consigli",
    facts: "Curiosità",
    relatedSpecies: "Specie affini",
  },
  analytics: {
    title: "Statistiche & Analytics",
    subtitle: "Utilizzo piattaforma — ultimi 30 giorni",
    loadError: "Errore nel caricamento dei dati analytics",
    retry: "Riprova tra qualche istante.",
    noData: "Nessun dato disponibile",
    totalSessions: "Sessioni totali",
    uniqueUsers: "Utenti unici",
    topPages: "Pagine più visitate",
    topEvents: "Funzionalità più usate",
    dau: "Utenti attivi al giorno",
    lastNDays: "ultimi {{n}} giorni",
    tabDashboard: "Web Analytics",
    tabPlatform: "Piattaforma",
    tabFunnel: "Funnel",
    tabTimeline: "Timeline Utente",
  },
  species: {
    sightingSuccess: "Avvistamento registrato!",
    sightingError: "Errore nella registrazione",
    photoCopyrightNotice: "Caricando questa immagine, concedo a eDive il diritto di utilizzarla esclusivamente per la consultazione della banca dati marina eDive. Non autorizzo la riproduzione, distribuzione o uso commerciale al di fuori di questo contesto. Confermo di essere il titolare dei diritti sull'immagine.",
    lifeList: {
      noResults: "Nessun risultato per i filtri selezionati",
    },
    encyclopedia: {
      noResults: "Nessuna specie trovata con i filtri selezionati.",
    },
  },
  wallet: {
    title: "Portafoglio",
    subtitle: "Saldo, ricariche e programmi fedeltà dei centri partner",
    balance: "Saldo",
    topup: "Ricarica",
    topupTitle: "Ricarica wallet",
    customAmount: "Oppure inserisci importo personalizzato",
    transactions: "Transazioni",
    noTransactions: "Nessuna transazione ancora",
    points: "Punti eDive",
    noPoints: "Ancora nessun punto guadagnato",
    pointsHowTitle: "Punti eDive — Come funziona",
    loyalty: "Programmi Fedeltà",
    redeem: "Riscatta",
    unavailable: "Servizio non disponibile",
    topupError: "Errore durante la ricarica",
    redeemError: "Errore durante il riscatto",
    redeemSuccess: "Premio riscattato! Codice: {{code}}",
    noLoyaltyAccount: "Nessun account fedeltà",
    noLoyaltyDesc: "I tuoi punti appariranno qui dopo aver prenotato attività con centri partner di eDive.",
    noRewards: "Nessun premio disponibile al momento",
    recentTransactions: "Transazioni recenti",
    howItWorks: "Come funziona?",
    startDiving: "Registra un'immersione per iniziare!",
    txTypes: {
      TOPUP: "Ricarica",
      REFUND: "Rimborso",
      PURCHASE: "Acquisto",
      ADJUSTMENT: "Rettifica",
      EXPIRATION: "Scadenza",
    },
    txStatus: {
      COMPLETED: "Completato",
      PENDING: "In corso",
      FAILED: "Fallito",
      REVERSED: "Stornato",
    },
    creditAdded: "Credito aggiunto!",
    customAmountActive: "Importo personalizzato attivo",
    amountRange: "L'importo deve essere tra €5 e €500",
    totalToAdd: "Totale da aggiungere",
    amount: "Importo",
    availableBalance: "Saldo disponibile",
    movements: "movimenti",
    eDivePoints: "Punti eDive",
    toTier: "al",
    availablePoints: "punti disponibili",
    pointsEarned: "punti guadagnati",
    pointsSpent: "punti spesi",
    latestTransactions: "Ultime transazioni",
    availableRewards: "Premi disponibili",
    redemptionHistory: "Storico riscatti",
    noRedemptions: "Nessun riscatto effettuato",
    usedOn: "Usato il {{date}}",
    expiredOn: "Scaduto il {{date}}",
    redeemedOn: "Riscattato il {{date}}",
    remaining: "rimasti",
    totalPoints: "punti totali",
    activeCenters: "centri attivi",
    highestTier: "tier più alto",
    loyaltyDesc: "I tuoi punti e premi nei centri immersione partner",
    myGiftCards: "Le mie Gift Card",
    noGiftCards: "Nessuna gift card",
    noGiftCardsDesc: "Puoi acquistare gift card per i tuoi centri sub preferiti dalla loro pagina profilo.",
    diveCenter: "Centro sub",
    gcActive: "Attiva",
    gcRedeemed: "Usata",
    gcExpired: "Scaduta",
    gcCancelled: "Annullata",
    pointsDesc: "I punti eDive misurano la tua attività sulla piattaforma e ti permettono di salire di livello, sbloccare badge esclusivi e ottenere sconti nei dive center partner.",
    howToEarn: "Come guadagnare punti",
    tiers: "Livelli",
    pointsUsedFor: "A cosa servono",
    pointsUse1: "Sconti prenotazioni nei dive center partner (100 pt = €1)",
    pointsUse2: "Badge e riconoscimenti esclusivi nel profilo",
    pointsUse3: "Accesso anticipato a eventi e corsi speciali",
    pointsUse4: "Classifiche community e sfide di immersione",
    earnDiveLogged: "Immersione registrata",
    earnDive30m: "Immersione tra 30 e 39 m",
    earnDive40m: "Immersione ≥ 40 m",
    earnCertAdded: "Certificazione aggiunta al profilo",
    earnBookingConfirmed: "Prenotazione dive center confermata",
    earnRegistrationBonus: "Bonus registrazione (una tantum)",
    tierBeginner: "Principiante",
    tierOpenWater: "Open Water",
    tierAdvanced: "Advanced Diver",
    tierMaster: "Master Diver",
    tierLegend: "Dive Legend",
    eventDiveCompleted: "Immersione completata",
    eventCertAdded: "Certificazione aggiunta",
    eventBookingConfirmed: "Prenotazione confermata",
    eventRegistrationBonus: "Bonus registrazione",
    eventManual: "Assegnazione manuale",
    topupHint: "Credito aggiunto immediatamente al tuo wallet",
  },
  achievements: {
    title: "Traguardi",
    subtitle: "Sblocca badge completando attività ed esplorando la piattaforma",
    unlocked: "{{count}} di {{total}} traguardi sbloccati",
    recent: "Recenti:",
    noneInCategory: "Nessun traguardo in questa categoria",
    earnedOn: "Sbloccato il",
    loadError: "Errore nel caricamento",
    loadErrorDesc: "Riprova tra qualche momento",
    tiers: {
      BRONZE: "Bronzo",
      SILVER: "Argento",
      GOLD: "Oro",
      PLATINUM: "Platino",
    },
    categories: {
      all: "Tutti",
      dives: "Immersioni",
      depth: "Profondità",
      certifications: "Certificazioni",
      social: "Community",
      content: "Contenuti",
      special: "Speciali",
    },
  },
  glossary: {
    noTerms: "Nessun termine trovato.",
    resetFilters: "Azzera filtri",
    // DV-11 onda 3: label fisse (hero, filtri) prima hardcoded in it/en.
    pageTitle: "📖 Glossario Subacqueo",
    pageSubtitle: "{{count}} termini — decompressione, fisiologia, gas, sicurezza",
    searchPlaceholder: "Cerca termini...",
    allCategories: "Tutte le categorie",
    allLevels: "Tutti i livelli",
    resultsCount: "{{count}} risultati",
    disclaimer: "Questo glossario ha scopo puramente didattico. Immergersi sempre con computer subacqueo calibrato e istruttore qualificato.",
    categoryAlgorithm: "Algoritmo",
    categoryPhysiology: "Fisiologia",
    categoryGas: "Gas",
    categorySafety: "Sicurezza",
    categoryPhysics: "Fisica",
    categoryUnit: "Unità",
    levelBasic: "Base",
    levelIntermediate: "Intermedio",
    levelAdvanced: "Avanzato",
  },
  search: {
    diffBeginner: "Principiante",
    diffIntermediate: "Intermedio",
    diffAdvanced: "Avanzato",
  },
  speciesQuiz: {
    diffEasy: "Facile",
    diffNormal: "Normale",
    diffHard: "Esperto",
  },
  jobs: {
    title: "Bacheca Lavoro",
    publishJob: "Pubblica annuncio",
    noJobs: "Nessun annuncio",
    noJobsDesc: "Prova a modificare i filtri o pubblica il primo annuncio.",
    myNoJobs: "Nessun annuncio",
    myNoJobsDesc: "Pubblica il tuo primo annuncio per trovare istruttori, centri o collaborazioni.",
    deleteConfirm: "Eliminare questo annuncio?",
    jobType: "Tipo annuncio",
    expiresAt: "Scadenza annuncio",
    publishModal: "Pubblica annuncio",
    jobTypes: {
      INSTRUCTOR_WANTED: "Cerco Istruttore",
      DIVEMASTER_WANTED: "Cerco Divemaster",
      CENTER_WANTED: "Cerco Centro",
      FREELANCE_AVAILABLE: "Disponibile Freelance",
    },
  },
  gdpr: {
    exportRequested: "Richiesta di esportazione inviata",
    exportRequestedFull: "Richiesta di esportazione inviata. Riceverai un link entro 48 ore.",
    deleteRequested: "Richiesta di cancellazione inviata",
    deleteRequestedFull: "Richiesta di cancellazione inviata. Il tuo account verrà eliminato entro 48 ore.",
    requestError: "Errore nell'invio della richiesta",
    requestUnavailable: "Impossibile inviare la richiesta",
    consentRevoked: "\"{{label}}\" revocato",
    consentEnabled: "\"{{label}}\" attivato",
    exportError: "Impossibile ottenere il download",
    exportUnavailable: "Download non disponibile o scaduto",
  },
  referral: {
    codeCopied: "Codice copiato!",
    linkCopied: "Link copiato!",
    inviteCreated: "Invito creato!",
    inviteRevoked: "Invito revocato",
  },
  diveDoctor: {
    inviteSent: "Invito inviato",
    inviteError: "Errore invio invito",
    linkRevoked: "Collegamento revocato",
    tabDashboard: "Dashboard",
    tabDivers: "Subacquei",
    tabEducation: "Educazione",
    tabFitness: "Idoneità",
    tabSymptoms: "Sintomi",
    tabResources: "Emergenze",
    tabCommunity: "Community",
    pageTitle: "Area Medico Subacqueo",
    disclaimerText: "Strumento di supporto informativo — nessuna attività clinica.",
    linkedDiversCount: "Subacquei collegati",
    pendingInvitesCount: "Inviti in attesa",
    criticalAlertsCount: "Alert critici",
    totalAlertsCount: "Alert totali non letti",
    alertsHeading: "Alert comportamentali (non clinici)",
    connectDiverTitle: "Collega un subacqueo",
    diverIdPlaceholder: "ID utente subacqueo (UUID)",
    messagePlaceholder: "Messaggio (opzionale)",
    sendInviteBtn: "Invia invito",
    sendingInviteBtn: "Invio…",
    pendingBadge: "In attesa",
    linkedDiversTitle: "Subacquei collegati",
    loadingDivers: "Caricamento…",
    noDivers: "Nessun subacqueo collegato. Invia un invito per iniziare.",
    closeBtn: "Chiudi",
    detailsBtn: "Dettagli",
    revokeBtn: "Revoca",
    revokeConfirm: "Revocare il collegamento?",
    setupTitle: "Configura il profilo medico",
    setupDesc: "Aggiungi licenza, specializzazioni e disponibilità per apparire nella directory medici subacquei.",
    setupBtn: "Configura",
    callBtn: "Chiama",
    allRegions: "Tutte le regioni",
    facilityCol: "Struttura",
    cityCol: "Città",
    regionCol: "Regione",
    noArticles: "Non hai ancora pubblicato articoli.",
    writeFirstBtn: "Scrivi il primo",
    viewsLabel: "visualizzazioni",
  },
  cart: {
    added: "{{name}} aggiunto al carrello",
  },
  assocShop: {
    productCreated: "Prodotto creato",
    variantAdded: "Variante aggiunta",
    orderUpdated: "Stato ordine aggiornato",
    orderPlaced: "Ordine effettuato!",
    orderCancelled: "Ordine annullato",
  },
  dcCourses: {
    certIssued: "Certificazione emessa",
    certError: "Errore nella emissione",
    courseCreated: "Corso creato",
    courseCreateError: "Errore nella creazione del corso",
    courseDeactivated: "Corso disattivato",
    materialAdded: "Materiale aggiunto",
    materialRemoved: "Materiale rimosso",
    sessionCreatedDC: "Sessione creata",
    sessionDeleted: "Sessione eliminata",
    saveError: "Errore nel salvataggio",
    questionAdded: "Domanda aggiunta",
    questionRemoved: "Domanda rimossa",
    confirmRemoveQuestion: "Rimuovere questa domanda?",
    addQuestion: "Aggiungi domanda",
    newQuestion: "Nuova domanda",
    questionText: "Testo domanda *",
    answerOptions: "Opzioni di risposta *",
    addOption: "Aggiungi opzione",
    correctAnswerHint: "Seleziona il radio button sulla risposta corretta",
    explanationLabel: "Spiegazione (opzionale)",
    explanationPlaceholder: "Mostrata dopo la risposta…",
    questionPool: "Pool domande",
    noQuestions: "Nessuna domanda",
    noQuestionsDesc: "Aggiungi domande per abilitare il test teorico",
    examResultsTitle: "Risultati esame",
    attempts: "{{count}} tentativi",
    attemptsPassed: "{{passed}} superati ({{pct}}%)",
    noAttempts: "Nessun tentativo registrato",
    passed: "Superato",
    failed: "Non superato",
    tabActiveCoursesLabel: "Corsi Attivi",
    tabEnrollmentsLabel: "Iscrizioni",
    tabMaterialsLabel: "Materiali",
    tabSessionsLabel: "Sessioni",
    tabTestLabel: "Test",
    tabAnalyticsLabel: "Analisi",
    totalEnrollments: "Iscrizioni totali",
    completionRateLabel: "Tasso completamento",
    revenueLabel: "Fatturato",
    avgExamScoreLabel: "Punteggio medio esame",
    enrollmentDistribution: "Distribuzione iscrizioni",
    monthlyRevenue: "Entrate mensili",
    examPassRateLabel: "Tasso superamento esame",
    avgScoreLabel: "Punteggio medio",
    allCourses: "Tutti i corsi",
    yearLabel: "Anno",
    courseLabel: "Corso",
    selectCoursePrompt: "Seleziona un corso per gestire il test teorico",
    noAttemptsSelected: "Nessun tentativo registrato",
    statsLoading: "Caricamento statistiche…",
    pageTitle: "Corsi & Formazione",
    pageSubtitle: "Gestione multi-agenzia, iscrizioni, emissione brevetti",
    newCourse: "Nuovo Corso",
    noCourses: "Nessun corso creato",
    createFirstCourse: "Crea primo corso",
    loadError: "Errore nel caricamento",
    loadErrorRetry: "Riprova tra qualche momento",
    colCourse: "Corso",
    colAgency: "Ente",
    colLevel: "Livello",
    colDates: "Date",
    colPrice: "Prezzo",
    colEnrolled: "Iscritti",
    colUser: "Utente",
    colStatus: "Stato",
    colEnrolledAt: "Iscritto il",
    colCompletedAt: "Completato il",
    colCertNumber: "N° Brevetto",
    colPaid: "Pagato",
    colSession: "Sessione",
    colType: "Tipo",
    colDate: "Data",
    colDuration: "Durata",
    colSkill: "Skill",
    colQuestion: "Domanda",
    colOptions: "Opzioni",
    colScore: "Punteggio",
    colResult: "Esito",
    enrollmentsLink: "Iscrizioni",
    deactivateConfirm: "Disattivare questo corso?",
    deactivate: "Disattiva",
    selectCourse: "Seleziona un corso",
    selectCourseForEnrollments: "Seleziona un corso per vedere le iscrizioni",
    noEnrollments: "Nessuna iscrizione",
    noEnrollmentsDesc: "Nessuno iscritto a \"{{title}}\"",
    progressLink: "Progresso",
    issueCertLink: "Emetti brevetto",
    issueCertTitle: "Emetti Certificazione",
    issueCertDesc: "Stai per emettere la certificazione per l'iscrizione {{id}}.",
    certNumberLabel: "Numero Brevetto (opzionale)",
    issuing: "Emissione...",
    issueCertBtn: "Emetti Brevetto",
    materialsCount: "{{count}} materiali",
    noMaterials: "Nessun materiale",
    noMaterialsDesc: "Aggiungi video, PDF o link didattici",
    addBtn: "Aggiungi",
    addMaterialTitle: "Aggiungi materiale",
    formMaterialTitle: "Titolo *",
    formMaterialType: "Tipo",
    formMaterialUrl: "URL *",
    formMaterialDesc: "Descrizione",
    materialTypeDocument: "Documento",
    sessionsCount: "{{count}} sessioni",
    noSessions: "Nessuna sessione",
    noSessionsDesc: "Pianifica lezioni teoriche, in piscina, acque aperte ed esami",
    addSessionBtn: "Aggiungi sessione",
    newSessionTitle: "Nuova sessione",
    formSessionTitle: "Titolo *",
    formSessionType: "Tipo",
    formSessionDuration: "Durata (min)",
    formSessionDate: "Data e ora *",
    formSessionNotes: "Note",
    createSessionBtn: "Crea",
    sessionTypeTheory: "Teoria",
    sessionTypePool: "In piscina",
    sessionTypeOpenWater: "Acque aperte",
    sessionTypeExam: "Esame",
    sessionTypeBriefing: "Briefing",
    levelDiscover: "Discover",
    levelOpenWater: "Open Water",
    levelAdvanced: "Advanced",
    levelRescue: "Rescue",
    levelDivemaster: "Divemaster",
    levelInstructor: "Instructor",
    levelSpecialty: "Specialty",
    formTitle: "Titolo *",
    formAgency: "Ente certificatore",
    formLevel: "Livello *",
    formCertCode: "Codice certificazione",
    formCertName: "Nome certificazione",
    formDescription: "Descrizione",
    formPrice: "Prezzo (€)",
    formDuration: "Durata (giorni)",
    formMaxStudents: "Max studenti",
    formStartDate: "Data inizio",
    formEndDate: "Data fine",
    createCourseBtn: "Crea Corso",
    questionPlaceholder: "Inserisci la domanda...",
    optionLabel: "Opzione",
    certCodePlaceholder: "es. PADI-OWD",
    certNamePlaceholder: "es. Open Water Diver",
    pricePlaceholder: "350",
    sessionDurationPlaceholder: "90",
    materialUrlPlaceholder: "https://...",
    materialTypeVideo: "Video",
    materialTypePdf: "PDF",
    materialTypeLink: "Link",
    tabPackagesLabel: "Pacchetti",
    newPackage: "Nuovo pacchetto",
    noPackages: "Nessun pacchetto",
    noPackagesDesc: "Un pacchetto e il corso come lo vende il centro: prezzo, durata, posti e cosa comprende.",
    packageActive: "Attivo",
    packageInactive: "Non attivo",
    packageCreated: "Pacchetto creato",
    packageError: "Non riuscito",
    packageName: "Nome",
    packageAgency: "Agenzia",
    packagePrice: "Prezzo (EUR)",
    packageDuration: "Durata (giorni)",
    packageMax: "Posti massimi",
    packageDescription: "Descrizione",
    days: "giorni",
  },
  dcAdmin: {
    profileUpdated: "Profilo aggiornato",
    logAdded: "Voce aggiunta al registro",
    logDeleted: "Voce eliminata",
    saveError: "Errore nel salvataggio",
    incidentRecorded: "Incidente registrato",
    incidentResolved: "Incidente risolto",
  },
  dcCompliance: {
    incidentRecorded: "Incidente registrato",
    recordError: "Errore nella registrazione",
    documentAdded: "Documento aggiunto",
    documentRemoved: "Documento rimosso",
    saveError: "Errore nel salvataggio",
    removeError: "Errore nella rimozione",
  },
  dcCustomers: {
    certAdded: "Certificato aggiunto",
    waiverSigned: "Liberatoria firmata e registrata",
    pdfError: "Errore nella generazione del PDF",
    customerAdded: "Cliente aggiunto al CRM",
    customerRemoved: "Cliente rimosso",
    removeError: "Errore rimozione",
    saveError: "Errore nel salvataggio",
    pageTitle: "Registrazione & Documentazione Clienti",
    pageSubtitle: "CRM clienti, certificati medici, liberatorie, screening pre-immersione",
    tabList: "📋 Clienti Registrati",
    tabMedical: "🩺 Certificati Medici",
    tabWaivers: "📄 Liberatorie",
    tabScreening: "🔍 Screening",
    tabQr: "📲 Scansiona QR",
    totalCerts: "{{count}} certificati totali",
    totalWaivers: "{{count}} liberatorie totali",
    totalCustomers: "{{count}} clienti registrati",
    addCert: "Aggiungi Certificato",
    addCertTitle: "Aggiungi Certificato Medico",
    noCerts: "Nessun certificato medico registrato",
    colType: "Tipo",
    colStatus: "Stato",
    colIssuedAt: "Rilasciato il",
    colExpiresAt: "Scade il",
    colDoctor: "Medico",
    colVersion: "Versione",
    colSignedAt: "Firmata il",
    colSignature: "Firma",
    colCustomer: "Cliente",
    colCertLevel: "Livello Cert.",
    colMedical: "Idoneità Medica",
    colBookings: "Prenotazioni",
    certTypeAgonistic: "Agonistica",
    certTypeNonAgonistic: "Non agonistica",
    certTypeSelfDeclaration: "Autodichiarazione",
    certValid: "Valido",
    certExpired: "Scaduto",
    certPendingRenewal: "Da rinnovare",
    certNotRegistered: "Non registrata",
    diverLabel: "Subacqueo *",
    selectDiver: "Seleziona un subacqueo",
    certTypeLabel: "Tipo certificato *",
    issuedAtLabel: "Data rilascio *",
    expiresAtLabel: "Data scadenza *",
    doctorLabel: "Medico rilasciante",
    notesLabel: "Note",
    signWaiver: "Firma Liberatoria",
    signWaiverTitle: "Firma Liberatoria",
    noWaivers: "Nessuna liberatoria registrata",
    permanent: "Permanente",
    digital: "Digitale",
    paper: "Cartacea",
    defaultCenterName: "Centro Diving",
    templateVersionLabel: "Versione template",
    digitalSignatureLabel: "Firma digitale",
    signatureHint: "Firma con il mouse o, su tablet, con il dito. La firma verrà inclusa nel PDF.",
    registering: "Registrazione...",
    registerAndSign: "Registra e Firma",
    addCustomer: "Aggiungi Cliente",
    addCustomerTitle: "Aggiungi Cliente al CRM",
    noCustomers: "Nessun cliente nel CRM",
    noCustomersDesc: "Aggiungi i tuoi clienti abituali per gestirne la documentazione",
    emailLabel: "Email",
    certLevelLabel: "Livello certificazione",
    internalNotesLabel: "Note interne",
    internalNotesPlaceholder: "Preferenze, note staff...",
    doctorPlaceholder: "Dott. Rossi Mario",
    emailPlaceholder: "cliente@email.com",
    certLevelPlaceholder: "Es: PADI OW, CMAS 2*…",
    vipLabel: "Cliente VIP",
    adding: "Aggiunta...",
    addBtn: "Aggiungi",
    sendWhatsApp: "Invia WhatsApp",
    removeConfirm: "Rimuovere questo cliente dal CRM?",
    remove: "Rimuovi",
    searchPlaceholder: "Cerca subacqueo per nome...",
    searchByName: "Cerca per nome...",
    searching: "Ricerca...",
    noResults: "Nessun risultato",
    qrScanTitle: "Verifica QR Diver",
    qrScanDesc: "Incolla il token QR del diver per verificare certificazioni, KYC e idoneità medica.",
    qrTokenPlaceholder: "Incolla qui il token QR del subacqueo...",
    verifying: "Verifica...",
    verifyDiver: "Verifica Diver",
    qrInvalid: "QR non valido o scaduto",
    qrVerifyError: "Errore di verifica",
    readyToDive: "Pronto per immersione",
    checkBeforeDive: "Verificare prima dell'immersione",
    kycVerified: "Verificato",
    medicalFitness: "Idoneità medica",
    certifications: "Certificazioni",
    noCertifications: "Nessuna certificazione registrata",
    verifiedAt: "Verificato il",
    noCenter: "Nessun centro configurato",
    expiredCertsWarning: "{{count}} certificato/i medico/i scaduto/i — richiede visita medica prima dell'immersione",
    screeningTitle: "Check-Dive / Valutazione Iniziale",
    screeningQ1: "Esperienza precedente (numero immersioni)",
    screeningQ2: "Ultima immersione (data + profondità)",
    screeningQ3: "Condizioni fisiche attuali",
    screeningQ4: "Familiarità con l'attrezzatura",
    screeningQ5: "Eventuali problemi alle orecchie / seni",
    screeningQ6: "Assunzione di farmaci",
    divemasterNotes: "Note del Divemaster",
    divemasterNotesPlaceholder: "Valutazione esperienza, note aggiuntive...",
    saveEvaluation: "Salva Valutazione",
    whatsappTitle: "Invia WhatsApp",
    whatsappTo: "A",
    whatsappPlaceholder: "Scrivi il messaggio...",
    whatsappSent: "WhatsApp inviato",
    whatsappError: "Invio fallito",
    sending: "Invio...",
    send: "Invia",
    certWizardStepFind: "Trova Sommozzatore",
    certWizardStepTypeDates: "Tipo e Date",
    certWizardStepDoctorNotes: "Medico e Note",
    waiverWizardStepFind: "Trova Sommozzatore",
    waiverWizardStepVersion: "Versione Liberatoria",
    waiverWizardStepSign: "Firma",
    customerWizardStepFind: "Trova Cliente",
    customerWizardStepDetails: "Dettagli",
    customerWizardStepConfirm: "Conferma",
  },
  dcEquipment: {
    returnError: "Errore nella restituzione",
    safetyChecked: "Check sicurezza registrato nel log attività",
    saveError: "Errore nel salvataggio",
    tankAdded: "Bombola aggiunta",
    equipmentAdded: "Attrezzatura aggiunta",
    boatAdded: "Imbarcazione aggiunta",
    assigned: "{{name}} assegnata",
    returned: "{{name}} marcata come restituita",
    assignError: "Errore nell'assegnazione",
    catalogueSearch: "Cerca nel catalogo (opzionale)",
    allStatuses: "Tutti gli stati",
    noEquipmentFound: "Nessuna attrezzatura trovata",
    noExpired: "Nessuna attrezzatura scaduta",
    noExpiringSoon: "Nessuna attrezzatura in scadenza",
    loadingEquipment: "Caricamento...",
    noTanks: "Nessuna bombola registrata.",
    noEquipment: "Nessuna attrezzatura registrata.",
    selectType: "Seleziona tipo...",
  },
  dcHR: {
    staffDeactivated: "Staff disattivato",
    deactivateError: "Errore nella disattivazione",
    availabilityError: "Errore aggiornamento disponibilità",
    staffAdded: "Staff aggiunto",
    noStaff: "Nessun membro dello staff.",
    noActiveStaff: "Nessun membro dello staff attivo.",
    noRequests: "Nessuna richiesta ricevuta",
    addStaffTitle: "Aggiungi membro dello staff",
    availabilityTab: "Disponibilità",
    requestApproved: "Richiesta approvata. L'utente è ora membro dello staff.",
    requestRejected: "Richiesta rifiutata.",
    requestApproveError: "Errore durante l'approvazione.",
    requestRejectError: "Errore durante il rifiuto.",
    inviteSent: "Invito inviato! L'utente lo troverà nella sua area personale.",
    inviteError: "Errore durante l'invio dell'invito.",
    addStaffError: "Errore aggiunta staff",
  },
  dcMarketing: {
    pointsAssigned: "Punti assegnati",
    assignError: "Errore nell'assegnazione punti",
    campaignError: "Errore nell'invio della campagna",
    tripPublished: "Viaggio pubblicato",
    publishError: "Errore nella pubblicazione",
    tripDraft: "Viaggio creato come bozza",
    tripError: "Errore nella creazione del viaggio",
    campaignSent_one: "Campagna inviata a {{count}} destinatario",
    campaignSent_other: "Campagna inviata a {{count}} destinatari",
    pageTitle: "9. Marketing & Customer Retention",
    pageSubtitle: "Follow-up automatici, programma fedeltà, campagne, viaggi diving",
    tabFollowup: "Follow-up",
    tabLoyalty: "Programma Fedeltà",
    tabCampaigns: "Campagne",
    tabGiftCards: "Gift Card",
    churnRiskTitle: "Clienti a rischio churn",
    churnRiskDesc: "Clienti registrati senza prenotazioni — candidati ideali per un re-engagement",
    customersCount: "{{count}} clienti",
    allHaveBookings: "Tutti i clienti hanno almeno una prenotazione 🎉",
    colCustomer: "Cliente",
    colContact: "Contatto",
    colCert: "Brevetto",
    colRegisteredAt: "Iscritto il",
    sent: "Inviato",
    reEngage: "Riattiva",
    postDiveAutomations: "Automazioni Post-Immersione",
    autoTrigger1: "Dopo ogni immersione",
    autoAction1: "Invia logbook firmato + foto del giorno",
    autoDelay1: "1h dopo",
    autoTrigger2: "Dopo corso completato",
    autoAction2: "Invia certificato + richiesta feedback",
    autoDelay2: "24h dopo",
    autoTrigger3: "30 giorni senza immersioni",
    autoAction3: "Invia email \"Ci manchi!\" con offerta",
    autoDelayAuto: "Automatico",
    autoTrigger4: "1 settimana prima scadenza medica",
    autoAction4: "Reminder visita medica",
    active: "Attivo",
    off: "Off",
    feedbackCollection: "Raccolta Feedback",
    postDiveEmailTemplate: "Template email post-immersione",
    postDiveEmailBody: "\"Ciao [Nome]! Grazie per aver immerso con noi oggi. Com'è stata la tua esperienza? Lascia una recensione in 30 secondi → [LINK]\"",
    avgRating: "Rating medio",
    responseRate: "Tasso risposta",
    tierBronzeBenefit: "5% sconto",
    tierSilverBenefit: "10% sconto + gift",
    tierGoldBenefit: "15% + immersione omaggio",
    tierPlatinumBenefit: "20% + viaggio dedicato",
    topLoyalCustomers: "Top Clienti Fedeli",
    noLoyaltyMembers: "Nessun iscritto al programma fedeltà.",
    colPoints: "Punti",
    colTotalEarned: "Totale guadagnati",
    colTier: "Livello",
    addPoints: "+ Punti",
    newCampaign: "Nuova Campagna",
    campType: "Tipo campagna",
    campTypeNewsletter: "Newsletter",
    campTypeSpecialEvent: "Evento speciale",
    campTypeDiveTrip: "Viaggio diving",
    campTypeNewCourse: "Nuovo corso",
    campTypePromo: "Offerta promozionale",
    campSubject: "Oggetto *",
    campSubjectPlaceholder: "Es: Viaggio alle Maldive - Maggio 2026!",
    campRecipients: "Destinatari",
    campAllCustomers: "Tutti i clienti ({{count}})",
    campGoldPlatinum: "Solo Gold/Platinum",
    campSchedule: "Programma invio",
    campScheduleHint: "Lascia vuoto per inviare subito",
    campMessage: "Messaggio *",
    campMessagePlaceholder: "Contenuto della campagna...",
    sending: "Invio...",
    sendNow: "Invia Ora",
    required: "Campo obbligatorio",
    diveTrips: "Viaggi Diving",
    newTrip: "+ Nuovo Viaggio",
    noTrips: "Nessun viaggio diving creato.",
    spots: "posti",
    published: "Pubblicato",
    draft: "Bozza",
    publish: "Pubblica",
    redeemGiftCard: "Riscatta Gift Card",
    gcCodePlaceholder: "Codice gift card",
    verify: "Verifica",
    gcValue: "Valore",
    gcExpires: "Scade",
    gcValid: "Valida",
    gcBookingId: "ID Prenotazione (opzionale)",
    gcBookingIdPlaceholder: "Associa a una prenotazione specifica",
    redeeming: "Riscatto...",
    redeemGiftCardBtn: "Riscatta Gift Card",
    gcCancelConfirm: "Annullare definitivamente questa gift card?",
    gcCancelBtn: "Annulla Gift Card",
    gcRedeemed: "Gift card riscattata",
    gcRedeemError: "Errore nel riscatto della gift card",
    gcCancelled: "Gift card annullata",
    gcCancelError: "Errore annullamento",
    gcNotFound: "Codice non trovato",
    awardPointsTitle: "Assegna punti fedeltà — cliente #{{id}}",
    currentBalance: "Saldo attuale",
    tier: "Livello",
    pointsToAward: "Punti da assegnare *",
    pointsInvalid: "Valore non valido (1-10000)",
    awardReason: "Motivazione",
    awardReasonPlaceholder: "Es: Bonus corso completato, referral, compleanno...",
    awarding: "Assegnazione...",
    awardPointsBtn: "Assegna Punti",
    newTripTitle: "Nuovo Viaggio Diving",
    tripTitleLabel: "Titolo *",
    tripTitlePlaceholder: "Es: Maldive — Atollo di Ari",
    tripDestination: "Destinazione *",
    tripDestinationPlaceholder: "Es: Maldive, Mar Rosso, Raja Ampat...",
    tripDepartureDate: "Data partenza *",
    tripReturnDate: "Data ritorno",
    tripSpots: "Posti disponibili *",
    tripFee: "Quota (€)",
    tripFeePlaceholder: "0 = gratuito",
    tripDescription: "Descrizione",
    tripDescriptionPlaceholder: "Itinerario, incluso/escluso, requisiti di certificazione...",
    createTrip: "Crea Viaggio",
    campaignSent: "Campagna inviata a {{count}} destinatari",
  },
  dcOperations: {
    checklistSaved: "Checklist pre-dive salvata",
    checklistError: "Errore nel salvataggio della checklist",
    briefingSaved: "Briefing registrato nel log attività",
    briefingError: "Errore nel salvataggio del briefing",
    notesSaved: "Note post-dive salvate",
    notesError: "Errore nel salvataggio",
    sectionTitle: "5. Operatività sul Campo",
    briefingDepthSection: "2. Profondità e tempo",
    visibility: "Visibilità",
    incidentWarning: "Verrà creato un rapporto incidente nel registro",
    noConfirmedBookings: "Nessuna prenotazione confermata",
    confirmedBadge: "Confermata",
  },
  dcPlanning: {
    planSaved: "Piano giornaliero salvato nel log attività",
    planError: "Errore nel salvataggio del piano",
    groupSaved: "Gruppo salvato",
    groupError: "Errore salvataggio gruppo",
    groupDeleted: "Gruppo eliminato",
    groupDeleteError: "Errore eliminazione gruppo",
    maxDepthLabel: "Profondità massima (m)",
    depthLabel: "Profondità (m)",
    hyperbaricChamber: "Camera iperbarica più vicina: indicare",
    noScheduled: "Nessuna uscita programmata per oggi. Creane una nel Calendario.",
    newGroup: "Nuovo Gruppo",
    pageTitle: "3. Pianificazione Immersioni",
    pageSubtitle: "Pianificazione operativa, gruppi, gas planning, briefing automatico",
    tabDaily: "Pianificazione Giornaliera",
    tabGroups: "Gruppi",
    tabTechnical: "Tecnica (Gas + Deco)",
    tabBriefing: "Briefing Auto",
    operatingConditions: "Condizioni Operative",
    diveSite: "Sito di Immersione",
    selectSite: "— seleziona sito —",
    weather: "Meteo",
    sea: "Mare",
    guidesAvailable: "Guide disponibili",
    boatSeatsAvailable: "Posti barca disponibili",
    saving: "Salvataggio...",
    planConfirmed: "Piano confermato",
    confirmDayPlan: "Conferma Piano Giornaliero",
    todaySummary: "Riepilogo Odierno",
    ratioExceededTitle: "Rapporto 6:1 superato (L.70/2026 Art.11)",
    ratioExceededBody: "{{participants}} partecipanti / {{guides}} guide = {{ratio}}:1. Aggiungere guide o ridurre i partecipanti.",
    confirmedBookings: "Prenotazioni confermate",
    assignedGuides: "Guide assegnate",
    rentedEquipment: "Attrezzatura noleggiata",
    seaConditions: "Condizioni mare",
    participantGuideRatio: "Rapporto partecipanti:guida",
    max6to1: "MAX 6:1",
    calendarOuting: "Uscita del calendario",
    selectOuting: "— seleziona un'uscita —",
    seaOuting: "Uscita in mare",
    scheduledOuting: "Uscita programmata — {{site}}",
    groupsForOuting: "Gruppi per questa uscita",
    noGroups: "Nessun gruppo definito. Crea il primo gruppo.",
    levelLabel: "Livello:",
    maxLabel: "Max:",
    groupName: "Nome Gruppo",
    groupNamePlaceholder: "Gruppo A, Tecnici, Fotografi...",
    requiredCertLevel: "Livello brevetto richiesto",
    certLevelPlaceholder: "OWD, AOWD, Rescue...",
    objective: "Obiettivo",
    objectiveRecreational: "Ricreativo",
    objectivePhotography: "Fotografia",
    objectiveTraining: "Training / Corso",
    objectiveExploration: "Esplorazione",
    createGroup: "Crea Gruppo",
    gasMix: "Miscela Gas",
    gasType: "Tipo gas",
    timeMin: "Tempo (min)",
    pressureBar: "Pressione (bar)",
    calculating: "Calcolo...",
    calcGasConsumption: "Calcola Consumo Gas",
    decompression: "Decompressione",
    bottomMin: "Fondo (min)",
    calcDeco: "Calcola Deco",
    result: "Risultato",
    decoStops: "Soste decompressione:",
    liters: "litri",
    autoBriefingTitle: "Briefing Automatico RSTC",
    print: "Stampa",
    site: "Sito",
    toBeSelected: "Da selezionare",
    maxBottomTime: "Tempo massimo fondo",
    emergencySignal: "Segnale di emergenza",
    smbMandatory: "Pallone SMB obbligatorio",
    emergencyProcedures: "Procedure di Emergenza:",
    procSurfaceBoat: "Barca di superficie sempre visibile",
    procVhf: "Radio VHF canale 16",
    procO2: "Bombola O₂ a bordo",
    procCoastGuard: "Numero guardia costiera: 1530",
    notesSite: "Sito",
    notUnspecified: "non specificato",
    notesGuides: "Guide",
    notesBoatSeats: "Posti barca",
    dayPlanConfirmedDesc: "Piano giornaliero confermato",
  },
  dcBookings: {
    paymentCompleted: "Pagamento completato con successo",
    paymentCancelled: "Pagamento annullato",
    bookingCancelled: "Prenotazione annullata",
    instructorAssigned: "Istruttore assegnato",
    assignError: "Errore nell'assegnazione",
  },
  dcLogbook: {
    importSuccess: "Import completato con successo",
    importError: "Formato file non supportato o errore di import",
    centerNotFound: "Centro non trovato",
    selectDives: "Seleziona almeno un'immersione",
    signatureRequired: "Inserisci la firma del Divemaster",
    certified_one: "{{count}} immersione certificata con successo",
    certified_other: "{{count}} immersioni certificate con successo",
    certifyPartialError: "{{count}} immersioni non certificate",
    certifyAllError: "Tutte le certificazioni sono fallite",
    certifyError: "Errore nella certificazione",
    certified: "{{count}} immersioni certificate",
  },
  proposeNewSite: {
    sent: "Proposta inviata! Sarà esaminata da un amministratore.",
    error: "Errore nell'invio della proposta. Riprova.",
    adminConfirmHint: "Il punto sarà confermato da un amministratore.",
    stepPosition: "Posizione",
    stepIdentity: "Identificazione",
    stepCharacteristics: "Caratteristiche",
    depthMaxReqLbl: "Profondità massima (m)",
    depthMaxPlaceholder: "es. 30",
    previewMarker: "Punto inserito",
    mapRadiusHint: "Visualizzazione nell'intorno di ~50 km dal punto inserito",
    mapClickHint: "Clicca sulla mappa per impostare il punto, oppure inserisci le coordinate a mano",
    mapPlaceholder: "Inserisci Latitudine e Longitudine per vedere la mappa.",
    selectCountry: "— Seleziona la nazione —",
    comuneLbl: "Comune",
    comunePlaceholder: "es. Massa Lubrense",
    comuneAfterCountry: "Scegli prima la nazione",
    localityLbl: "Zona / Località (facoltativo)",
    localityPlaceholder: "es. Baia di Ieranto, Arcipelago de La Maddalena",
    localityHint: "Una zona più specifica del comune, se il punto ne fa parte.",
    diveCenterLbl: "Diving center che ti ha accompagnato",
    diveCenterPlaceholder: "Cerca il diving center…",
    diveCenterHint: "Se indichi il centro, il punto entrerà tra le sue proposte di immersione.",
    geocoding: "Rilevamento nazione e comune dalle coordinate…",
    geocodeEditable: "rilevato dalle coordinate, modificabile",
    optionalDesc: "Questi dettagli sono facoltativi ma aiutano la scheda del sito.",
    adminConfirmNotice: "La proposta verrà esaminata e confermata da un amministratore prima di comparire nell'archivio ufficiale.",
    title: "Proponi un nuovo punto di immersione",
    desc: "Compila la scheda con le informazioni che conosci. Un amministratore verificherà la proposta e la renderà disponibile nell'archivio ufficiale.",
    nameLbl: "Nome del sito *",
    namePlaceholder: "es. Secca di Punta Campanella",
    latLbl: "Latitudine *",
    latPlaceholder: "es. 40.5523",
    lngLbl: "Longitudine *",
    lngPlaceholder: "es. 14.3341",
    coordsHint: "Puoi trovare le coordinate cercando il sito su Google Maps → tasto destro → \"Cosa c'è qui?\"",
    countryLbl: "Paese",
    regionLbl: "Regione / Zona",
    countryPlaceholder: "es. Italia",
    regionPlaceholder: "es. Campania",
    depthMinLbl: "Profondità min (m)",
    depthMaxLbl: "Profondità max (m)",
    avgVisLbl: "Visibilità media (m)",
    diveTypeLbl: "Tipo immersione",
    difficultyLbl: "Difficoltà",
    waterTypeLbl: "Tipo acqua",
    selectPlaceholder: "— Seleziona —",
    descLbl: "Descrizione (italiano)",
    descPlaceholder: "Caratteristiche del sito, fauna tipica, particolarità…",
    notesLbl: "Note per l'amministratore",
    notesPlaceholder: "Fonti, riferimenti, come hai trovato il sito…",
    cancel: "Annulla",
    submitting: "Invio in corso…",
    submit: "Invia proposta",
    waterSalt: "Salata",
    waterFresh: "Dolce",
    waterBrackish: "Salmastra",
    diveReef: "Barriera",
    diveWall: "Parete",
    diveWreck: "Relitto",
    diveCave: "Grotta",
    diveDrift: "Corrente",
    diveShore: "Da riva",
    diveNight: "Notturna",
    diveTraining: "Training",
    diffBeginner: "Principiante",
    diffIntermediate: "Intermedio",
    diffAdvanced: "Avanzato",
    diffTechnical: "Tecnico",
    positionDesc: "Indica dove si trova il punto: tocca la mappa, trascina il segnaposto, cerca il nome di un luogo oppure scrivi le coordinate. Poi inserisci la profondità massima.",
    pickerSearchLabel: "Cerca un luogo per nome",
    pickerSearchPlaceholder: "Cerca un luogo (es. Baia di Ieranto)",
    pickerSearchBtn: "Cerca",
    pickerSearching: "Cerco…",
    pickerSearchFailed: "Ricerca non riuscita. Riprova, oppure tocca direttamente la mappa.",
    pickerNoResults: "Nessun luogo trovato. Prova con un altro nome o tocca la mappa.",
    pickerMapLabel: "Mappa per scegliere il punto di immersione",
    pickerPinTitle: "Punto di immersione: trascinami",
    pickerTilesBroken: "Le mappe non si caricano. Controlla la connessione: puoi comunque scrivere le coordinate a mano.",
    pickerSource_point: "Mappa centrata sul punto che hai indicato.",
    pickerSource_center: "Mappa centrata sul tuo diving center.",
    pickerSource_device: "Mappa centrata sulla tua posizione.",
    pickerSource_approx: "Mappa centrata sulla posizione stimata dalla tua connessione internet (approssimata).",
    pickerSource_country: "Mappa centrata sul tuo Paese (stima dalla connessione). Cerca il luogo o spostati sulla mappa.",
    pickerSource_fallback: "Non so dove ti trovi: la mappa mostra il Mediterraneo. Cerca un luogo o spostati sulla mappa.",
    pickerLocate: "Vai alla mia posizione",
    pickerLocating: "Cerco la tua posizione…",
    pickerGeoDenied: "Non posso usare la tua posizione: il permesso è stato negato. Puoi abilitarlo dalle impostazioni del browser, oppure cercare un luogo.",
    pickerGeoUnavailable: "La tua posizione non è disponibile in questo momento. Cerca un luogo o tocca la mappa.",
    pickerHintPlaced: "Punto impostato. Per spostarlo trascina il segnaposto o tocca un altro punto della mappa.",
    pickerHintEmpty: "Tocca la mappa nel punto esatto dell’immersione: comparirà un segnaposto rosso che potrai trascinare.",
    err_lat_empty: "Scrivi la latitudine (es. 40.5523) oppure tocca la mappa.",
    err_lng_empty: "Scrivi la longitudine (es. 14.3341) oppure tocca la mappa.",
    err_lat_format: "La latitudine deve essere un numero, per esempio 40.5523.",
    err_lat_range: "La latitudine deve stare tra −90 e 90.",
    err_lng_format: "La longitudine deve essere un numero, per esempio 14.3341.",
    err_lng_range: "La longitudine deve stare tra −180 e 180.",
    err_zero: "Il valore 0 non è accettato: indica la posizione reale del punto.",
    err_depth: "Scrivi la profondità massima in metri (da 1 a 400).",
  },
  findBuddy: {
    title: "Trova un buddy",
    subtitle: "L'AI ti suggerisce i compagni più compatibili",
    step0: "Dove e quando",
    step1: "Il tuo livello",
    step2: "Preferenze",
    step3: "Risultati",
    dateLbl: "Data pianificata",
    siteLbl: "Sito di immersione",
    sitePlaceholder: "Cerca sito (opzionale)…",
    atLeastOne: "Almeno uno dei due campi è richiesto per trovare i buddy più compatibili con le tue prossime immersioni.",
    certLevelLbl: "Il tuo livello di certificazione",
    certLevelPlaceholder: "— seleziona —",
    totalDivesLbl: "Numero di immersioni totali",
    totalDivesFromLogbook: "Valore preso automaticamente dal tuo logbook.",
    preferredTypesNote: "Seleziona i tipi di immersione che preferisci — l'AI troverà buddy con interessi simili.",
    noTypeNote: "Nessuna selezione = l'AI considera tutti i tipi.",
    searching: "L'AI sta cercando i tuoi buddy ideali…",
    noResults: "Nessun match trovato",
    noResultsDesc: "Prova a modificare i parametri di ricerca o torna più tardi.",
    contactNote: "Puoi contattare i buddy direttamente dalla loro pagina profilo o via chat.",
    profileLink: "Profilo →",
    finalLabel: "Vai ai match",
    searchError: "Errore nella ricerca buddy",
    userFallback: "Utente",
  },
  privacyWizard: {
    title: "Impostazioni privacy",
    subtitle: "Controlla chi vede i tuoi dati e come vengono usati",
    step0: "Visibilità profilo",
    step1: "Consensi marketing",
    step2: "I tuoi dati",
    visibilityLbl: "Visibilità profilo",
    visPublic: "Pubblico",
    visPublicDesc: "Tutti gli utenti possono vedere il tuo profilo",
    visConnections: "Solo connessioni",
    visConnectionsDesc: "Solo i tuoi buddy e contatti diretti",
    visPrivate: "Privato",
    visPrivateDesc: "Nessuno può vedere il tuo profilo",
    searchableLbl: "Ricercabile",
    searchableDesc: "Appari nei suggerimenti buddy e nella directory",
    logbookLbl: "Logbook pubblico",
    logbookDesc: "Le tue immersioni sono visibili agli altri utenti",
    consentsNote: "Gestisci i consensi per l'uso dei tuoi dati. I consensi obbligatori (contratto e obblighi legali) non possono essere disattivati.",
    consentServiceLbl: "Comunicazioni di servizio",
    consentServiceDesc: "Email transazionali su account, sicurezza e prenotazioni",
    consentNewsletterLbl: "Newsletter e novità eDive",
    consentNewsletterDesc: "Aggiornamenti su nuove funzioni e offerte della piattaforma",
    consentPartnerLbl: "Offerte da partner e centri",
    consentPartnerDesc: "Proposte commerciali da centri diving e agenzie partner",
    consentProfilingLbl: "Profilazione comportamentale",
    consentProfilingDesc: "Analisi delle tue preferenze per suggerimenti personalizzati",
    consentSharingLbl: "Condivisione con terze parti",
    consentSharingDesc: "I tuoi dati anonimi potrebbero essere condivisi con partner scientifici",
    gdprRights: "Hai il diritto di richiedere una copia dei tuoi dati o la eliminazione del tuo account (GDPR art. 15 e 17).",
    exportLbl: "Scarica i miei dati",
    exportDesc: "Ricevi un archivio JSON con tutte le tue immersioni, brevetti e dati di profilo.",
    deleteLbl: "Elimina account",
    deleteDesc: "Richiedi la cancellazione permanente di tutti i tuoi dati.",
    noActionLbl: "Nessuna azione",
    noActionDesc: "Salva solo le impostazioni senza richiedere export o cancellazione.",
    irreversibleTitle: "Azione irreversibile",
    irreversibleDesc: "Questa operazione eliminerà definitivamente il tuo account, logbook, brevetti e tutti i dati associati. Non è possibile annullare questa azione.",
    deleteConfirmLbl: "Digita ELIMINA per confermare",
    exportSuccess: "Richiesta esportazione dati inviata — riceverai un link via email.",
    deleteSuccess: "Richiesta di eliminazione account inviata.",
    saved: "Impostazioni privacy salvate!",
    saveError: "Errore nel salvataggio",
    finalLabel: "Salva impostazioni",
  },
  divePlan: {
    siteNameRequired: "Inserisci il nome del sito",
    invalidCoords: "Coordinate GPS non valide — es. 41.9028 / 12.4964",
    proposalSent: "Richiesta inviata — l'amministratore censirà il sito",
    tankRequired: "Configura almeno una bombola PRINCIPALE prima di calcolare",
  },
  diveProfileTab: {
    roleBottom: "Principale",
    roleDeco: "Deco",
    roleBailout: "Bailout",
    roleAbbrBottom: "fond.",
    roleAbbrDeco: "deco",
    roleAbbrBailout: "bail.",
    algoBuhlmannSub: "con Gradient Factors",
    algoVpmBSub: "Varying Permeability Model",
    algoVpmBESub: "Extended (Volume Critico)",
    algoRgbmSub: "Reduced Gradient Bubble",
    vpmAggressive: "Aggressivo",
    vpmModerateUp: "Moderato+",
    vpmModerate: "Moderato",
    vpmConservative: "Conservativo",
    vpmVeryConservative: "Molto conservativo",
    vpmTechnical: "Tecnico",
    dbTitle: "Differenze: Bombola di Deco vs Bailout",
    dbColAspect: "Aspetto",
    dbColDeco: "Bombola di Deco",
    dbColBailout: "Bombola di Bailout",
    dbAspectFunction: "Funzione",
    dbDecoFunction: "Accelerare la decompressione",
    dbBailoutFunction: "Gestire emergenze",
    dbAspectWhenUsed: "Quando si usa",
    dbDecoWhenUsed: "Solo in risalita, a quote specifiche",
    dbBailoutWhenUsed: "In qualsiasi momento, se necessario",
    dbAspectGasType: "Tipo di gas",
    dbDecoGasType: "O₂, Nitrox ad alta FO₂",
    dbBailoutGasType: "Gas respirabile alla profondità massima",
    dbAspectPlanning: "Pianificazione",
    dbDecoPlanning: "Parte del piano deco",
    dbBailoutPlanning: "Parte del piano di emergenza",
    dbAspectPriority: "Priorità",
    dbDecoPriority: "Fisiologia",
    dbBailoutPriority: "Sopravvivenza",
    dbAspectAccess: "Accesso",
    dbDecoAccess: "A quote precise, non immediato",
    dbBailoutAccess: "Immediato, sempre pronto",
    dbAspectRisk: "Rischio se usata male",
    dbDecoRisk: "Tossicità O₂ (usata troppo profonda)",
    dbBailoutRisk: "Nessuno aggiuntivo (gas di fondo)",
    diveSiteOptional: "Sito di immersione (opzionale)",
    searchByName: "Cerca per nome…",
    suggIncreasePressure: "Aumenta pressione \"{{label}}\"",
    suggReduceBottomTimeGas: "Riduci il tempo di fondo (gas)",
    suggBottomTimeNdl: "Tempo di fondo entro NDL",
    noDeco: "senza deco",
    suggReduceDepth: "Riduci la profondità",
    suggTitle: "Parametri alternativi suggeriti",
    suggRecalcHint: "Dopo aver applicato un suggerimento, ricalcola per verificare il nuovo profilo.",
    gasAir: "Aria",
    gasCustom: "Custom",
    gfProfileConservativeTech: "Conservativo (tecnico)",
    gfProfileBalanced: "Bilanciato",
    gfProfileModerate: "Moderato",
    gfProfileLiberal: "Liberale",
    ndlOkTitle: "Immersione entro il limite di non-decompressione (NDL)",
    safetyStop: "Sosta di sicurezza",
    decoRequiredTitle: "Decompressione obbligatoria — risalita totale {{totalAscentTimeMin}} min",
    mandatory: "obbligatorio",
    decoRequiredBody3: "rispettare ogni sosta indicata di seguito.",
    decoRequiredBody4: "Saltare anche una sola tappa aumenta drasticamente il rischio di MDD.",
    firstStopAt: "La prima sosta è a",
    determinedByGfLow: "(determinata da GF Low {{gfLow}}%)",
    ascentPlanTitle: "Piano di risalita — passo per passo",
    ascendFrom: "Risali da",
    ascendTo: "a",
    surface: "superficie",
    ascendAt: "a {{rate}} m/min",
    gasSwitchAt: "Cambio gas a {{depth}} m",
    gasSwitchNote: "apri rubinetto, controlla pressione, segnala OK al buddy",
    mandatoryStop: "Sosta obbligatoria",
    gas: "gas",
    maintainDepth: "mantieni la profondità esatta · non anticipare la risalita",
    whySwitchGas: "Perché cambiare gas",
    modNoteZeroN2: "Zero azoto: non contribuisce al carico tissutale durante la sosta.",
    modWarning: "Non scendere sotto {{mod}} m con questo gas:",
    modWarningDetail: "la ppO₂ supererebbe 1.6 bar → rischio convulsioni da tossicità del CNS.",
    gfLowFirstStop1: "La prima sosta a",
    deepStop: "deep stop",
    gfLowFirstStop3: "— favorita per ridurre micro-bolle in immersioni profonde o con elio.",
    gfLowNoDeepStop: "Con questo profilo non è richiesta una sosta profonda.",
    cylCat_steel: "Acciaio",
    cylCat_aluminum: "Alluminio",
    cylCat_technical: "Tecnica",
    cylCat_doubles: "Doppie",
    cylCat_bibo: "Bibombole",
    atLeastOneBottom: "Almeno una bombola BOTTOM è richiesta",
    changeRole: "Cambia ruolo",
    pressure: "Pressione (bar)",
    decoCompareTitle: "Confronto decompressione",
    decoCompareSubtitle: "VPN +1…5 min · Bühlmann 20/80 · tappe > 3 m",
    stopGas: "Stop · Gas",
    bottom: "fondo",
    stopShort: "breve",
    stopModerate: "moderata",
    stopLong: "lunga",
    stopExtended: "estesa",
    decoGas: "gas deco",
    stopAt3mNotIncluded: "tappa a 3 m non inclusa",
    diveSiteTitle: "Punto di immersione",
    noSiteSelected: "Nessun sito selezionato",
    removeSite: "Rimuovi sito",
    verified: "Verificato",
    gpsUnavailable: "Coordinate GPS non disponibili",
    depth: "Profondità",
    difficulty: "Difficoltà",
    diffBeginner: "Base",
    diffIntermediate: "Medio",
    diffAdvanced: "Avanzato",
    diffTechnical: "Tecnico",
    water: "Acqua",
    waterSalt: "Marina",
    waterFresh: "Dolce",
    waterBrackish: "Salmastra",
    visibility: "Visibilità",
    type: "Tipo",
    typeReef: "Scogliera",
    typeWreck: "Relitto",
    typeCave: "Grotta",
    typeWall: "Parete",
    typeDrift: "Corrente",
    typeNight: "Notturna",
    typeTraining: "Addestramento",
    coordinates: "Coordinate",
    searchSites: "Cerca tra i siti censiti…",
    siteNotListed: "Sito non presente nell'elenco — richiedi all'amministratore di censirlo",
    proposeSiteName: "Nome del sito di immersione",
    proposeLat: "Latitudine  (es. 41.9028)",
    proposeLng: "Longitudine  (es. 12.4964)",
    proposeNotes: "Note per l'amministratore (facoltativo)",
    sending: "Invio in corso…",
    sendRequest: "Invia richiesta →",
    refCenterTitle: "Diving center di riferimento",
    refCenterNone: "Nessun centro selezionato",
    refCenterHint: "Il centro che ti porterà a fare l'immersione (facoltativo).",
    refCenterSearch: "Cerca tra i centri su eDive…",
    centerNotListed: "Centro non presente — richiedi il censimento",
    centerNameRequired: "Inserisci il nome del centro",
    censusHint: "Invieremo la richiesta di censimento a eDive con i dati che fornisci.",
    censusName: "Nome del centro",
    censusCity: "Città",
    censusCountry: "Paese (ISO, es. IT)",
    censusWebsite: "Sito web",
    censusEmail: "Email",
    censusPhone: "Telefono",
    censusNotes: "Note (facoltativo)",
    censusSent: "Richiesta di censimento inviata. Grazie!",
    dateTimeWeather: "Data, ora e meteo",
    setDateTime: "Imposta data e ora",
    date: "Data",
    localTime: "Orario (ora locale)",
    loadingForecast: "Caricamento previsioni…",
    conditionsOptimal: "Condizioni ottimali per l'immersione",
    conditionsAdverse: "Condizioni avverse — valutare attentamente",
    conditionsModerate: "Condizioni moderate — prestare attenzione",
    wind: "Vento",
    waves: "Onde",
    rain: "Pioggia",
    atmosphere: "Atmosfera",
    marine: "Marine",
    wxCondition: "Condizione",
    wxTemperature: "Temperatura",
    wxWindDir: "Dir. vento",
    wxPressure: "Pressione",
    waveHeight: "Altezza onde",
    wavePeriod: "Periodo",
    waveDir: "Dir. onde",
    seaState: "Stato del mare",
    seaOptimal: "Ottimale",
    seaGood: "Buono",
    seaModerate: "Moderato",
    seaRough: "Avverso",
    waterTemp: "Temp. acqua",
    marineUnavailable: "Dati marini non disponibili (area interna).",
    hourlyTrend: "Tendenza oraria ({{from}}:00 – {{to}}:00)",
    colHour: "Ora",
    colSky: "Cielo",
    colTempC: "Temp °C",
    colDir: "Dir.",
    colWavesM: "Onde m",
    colWaterC: "Acqua °C",
    trendLegend: "↑ in aumento · ↓ in calo · → stabile · ◄ ora immersione",
    forecastSource: "Fonte: Open-Meteo · Previsioni orarie — verificare prima della partenza",
    forecastUnavailable: "Previsioni non disponibili per questa posizione.",
    selectSiteForForecast: "Seleziona un sito di immersione per vedere le previsioni meteo.",
    chamberTitle: "Camere Iperbariche vicine",
    chamberSummary: "{{count}} strutture nelle vicinanze · Emergenza: 118",
    seasonal: "stagionale",
    chamberDisclaimer: "Distanze calcolate in linea d'aria · Verificare disponibilità prima dell'immersione · Fonte: SIMSI / ANCIP",
    paramsTitle: "Parametri e calcolo",
    descentRate: "Vel. discesa (m/min)",
    ascentRate: "Vel. risalita (m/min)",
    algoAndSafety: "Algoritmo & Sicurezza",
    cylinders: "Bombole",
    configureCylinder: "Configura una bombola",
    cylinderCount_one: "{{count}} bombola",
    cylinderCount_other: "{{count}} bombole",
    calcComparison: "Calcolo confronto…",
    algoSafetyTitle: "Algoritmo & Parametri di Sicurezza",
    decoAlgorithm: "Algoritmo decompressione",
    ppO2GasSwitchLimit: "limite cambio gas",
    ppO2ExtraConservative: "Extra conservativo (quota/freddo)",
    ppO2Conservative: "Conservativo",
    ppO2Operational: "Limite operativo (standard)",
    ppO2Intermediate: "Intermedio",
    ppO2DecoMax: "Limite deco (massimo)",
    gfPresetHaldaneanTip: "Nessun deep stop — tabelle classiche",
    gfPresetStandardTip: "Tabelle PADI/NAUI equivalenti",
    gfPresetModerate: "Moderato",
    gfPresetModerateTip: "Computer sport, deco breve",
    gfPresetTechnical: "Tecnico",
    gfPresetTechnicalTip: "Deco tecnica standard",
    gfPresetConservative: "Conservativo",
    gfPresetConservativeTip: "Deep stops marcati",
    gfPresetTrimixTip: "Profondità >60 m, He",
    gfLowDepthHint: "profondità prima sosta",
    gfHighSurfaceHint: "tetto in superficie",
    lastDecoStop: "Ultima sosta di decompressione",
    lastStop6m: "6 m: deep last stop — usato da molti computer tecnici (Shearwater default)",
    lastStop3m: "3 m: standard ricreativo, sosta finale breve in superficie",
    vpmConservatism: "Conservatismo VPM-B",
    lastStop6mVpm: "6 m: usato da molti computer tecnici (Shearwater default)",
    lastStop3mVpm: "3 m: standard ricreativo, risalita finale breve",
    rgbmReduces: "RGBM lo riduce",
    cylinderConfig: "Configurazione Bombole",
    editPlan: "Modifica piano",
    editParams: "Modifica parametri",
    unsavedBadge: "Non salvata",
    planSaved: "Pianificazione salvata",
    unsafePlan: "Piano non sicuro — pressione di fuga insufficiente",
    escapePressureWarning: "La bombola di fondo raggiunge la pressione minima di risalita ({{escapeBar}} bar) dopo soli {{safeBottomMin}} min su {{bottomTime}} min pianificati.",
    turnPointAt: "Inversione obbligatoria al minuto {{t}} ({{depth}} m)",
    escapePressure: "pressione di fuga",
    handoffDeco: "handoff deco a {{depth}} m",
    cylinder: "Bombola",
    barConsumed: "bar consumati",
    remaining: "Rimanente",
    insufficient: "Insufficiente",
    ppO2Bottom: "ppO₂ fondo",
    ppO2AboveLimit: "oltre limite sicurezza",
    ppO2Safe: "sicuro",
    gasSupply: "Scorta gas",
    gasSufficient: "Sufficiente",
    allCylindersOk: "Tutte le bombole coprono il piano con riserva",
    cylinderInsufficient: "Una o più bombole non coprono il piano — riduci profondità/tempo o aggiungi gas",
    diveBriefing: "Briefing Immersione",
    gasSwitches: "Cambi Gas",
    colDepth: "Profondità",
    colFrom: "Da",
    colTo: "A",
    stopTime: "Tempo sosta",
    colMin: "Min",
    colDepthShort: "Prof.",
    logTitle: "Log immersione (minuto per minuto)",
    logShow: "Mostra:",
    logAll: "Tutto",
    logEventsOnly: "Solo eventi importanti",
    logEventsHint: "Inizio/Fine · Fondo · Deco · Cambio gas · 50 bar",
    logEventDiveStart: "Inizio Immersione",
    logEventDiveEnd: "Fine Immersione",
    logEventAtBottom: "Arrivo sul fondo",
    logEventLeavingBottom: "Stacco dal fondo",
    logEventTankLow: "Pressione GAS bombola 50 bar",
    logCheckReserve: "verifica riserva",
    logEventGasSwitch: "Cambio gas",
    logEventDecoStop: "Tappa deco",
    logEventSafetyStop: "Sosta sicurezza",
    weatherAndMarine: "Meteo & Marine",
    atHour: "ore",
    generating: "Generazione…",
    downloadPdf: "Scarica PDF",
    calcDisclaimerTitle: "Avviso di sicurezza — obbligatorio",
    calcDisclaimerSubtitle: "Limitazione di responsabilità — pianificazione immersioni",
    calcDisclaimerBody1: "I calcoli di decompressione forniti da eDive sono generati da modelli matematici (Bühlmann ZHL-16C, VPM-B, RGBM) e hanno esclusivo valore <strong>indicativo</strong>. Non sostituiscono la formazione certificata, il giudizio di un istruttore qualificato né le tabelle ufficiali degli enti di certificazione.",
    calcDisclaimerBody2: "La sicurezza di un'immersione dipende da numerosi fattori non modellabili dal software: condizioni ambientali, stato di salute del subacqueo, corretto funzionamento dell'attrezzatura, esperienza del team. eDive non può essere ritenuta responsabile per incidenti, infortuni o danni derivanti dall'uso di questi calcoli.",
    calcDisclaimerBody3: "È obbligatorio rispettare sempre le procedure di sicurezza apprese durante la propria formazione, incluse le soste di sicurezza, i margini di conservatività e la pianificazione con gas di riserva adeguata.",
    calcDisclaimerBody4: "⚠️ Non immergerti mai senza aver completato un corso certificato e senza supervisione qualificata per il livello di immersione pianificato.",
    calcDisclaimerCheck: "Ho letto e compreso il presente avviso. Utilizzo questi dati esclusivamente come riferimento indicativo e sotto la mia piena responsabilità personale.",
    calcDisclaimerAccept: "Accetto — Calcola piano",
    pdfDisclaimerTitle: "Scarico di responsabilità — obbligatorio",
    pdfDisclaimerSubtitle: "Nota legale e limitazione di responsabilità",
    pdfDisclaimerBody1: "Il piano di immersione generato da eDive è uno <strong>strumento di supporto alla pianificazione</strong> a scopo puramente informativo ed educativo. Non sostituisce la formazione subacquea, il giudizio personale, il computer da immersione, né le tabelle e le procedure della tua didattica.",
    pdfDisclaimerBody2: "I calcoli (profili, decompressione, consumo gas, miscele) si basano su modelli teorici e sui parametri da te inseriti: possono contenere imprecisioni e <strong>non garantiscono l'assenza di rischi</strong>, inclusa la malattia da decompressione. Verifica sempre i dati con un secondo strumento e immergiti entro i limiti del tuo brevetto e della tua esperienza.",
    pdfDisclaimerBody3: "Utilizzando questo piano <strong>ti assumi la piena responsabilità</strong> delle tue immersioni. eDive e i suoi sviluppatori non sono responsabili per eventuali danni, infortuni o decessi derivanti dall'uso di queste informazioni. In caso di dubbi, consulta un istruttore qualificato.",
    pdfDisclaimerCheck: "Ho letto e accetto il presente scarico di responsabilità.",
    pdfDisclaimerAccept: "Accetto — Scarica PDF",
    sky0: "Sereno",
    sky1: "Prev. sereno",
    sky2: "Parz. nuvoloso",
    sky3: "Coperto",
    sky45: "Nebbia",
    sky48: "Nebbia brina",
    sky51: "Pioggerella deb.",
    sky53: "Pioggerella mod.",
    sky55: "Pioggerella int.",
    sky61: "Pioggia deb.",
    sky63: "Pioggia mod.",
    sky65: "Pioggia int.",
    sky71: "Neve deb.",
    sky73: "Neve mod.",
    sky75: "Neve int.",
    sky80: "Rovesci deb.",
    sky81: "Rovesci mod.",
    sky82: "Rovesci viol.",
    sky95: "Temporale",
    sky96: "Temporale+grandine",
    sky99: "Temp. forte+grandine",
    andHelium: " ed elio",
    cylinderCount: "{{count}} bombole",
    decoRequiredBody1: "La saturazione di azoto",
    decoRequiredBody2: " nei tessuti supera il limite consentito per la risalita diretta al GF High {{gfHigh}}%: è",
    gfHighExplain1: "determina il margine di sicurezza in emersione: mantieni ancora un",
    gfHighExplain2: "di distanza dal valore M critico; più questo margine è ampio, più il profilo è prudente.",
    gfLinearExplain: "Tra la prima sosta e la superficie il gradient factor cresce in modo lineare da GF Low {{gfLow}}% a GF High {{gfHigh}}%, rendendo la decompressione progressivamente più permissiva man mano che risali.",
    gfLowExplain: "controlla la profondità della prima sosta di decompressione: valori più bassi generano una prima tappa più profonda e un profilo più conservativo.",
    gfLowFirstStop2: "è una sosta profonda, un cosiddetto ",
    modNoteDecoReduced: "Meno azoto significa soste di decompressione più brevi.",
    modNoteReduceN2: "Questo gas contiene circa il {{pct}}% dell'azoto presente nell'aria, riducendo il carico di gas inerte durante la risalita.",
    ndlOkBody: "A {{depth}} m per {{minutes}} min con GF High {{gfHigh}}% rimani entro la curva di sicurezza: hai ancora un margine di",
    ndlOkRemaining: "prima che diventino necessarie tappe di decompressione. Rimane comunque consigliata una",
    ndlOkSafetyStopNote: "di 3 min a 5 m come buona pratica.",
    planLockedReconciled: "Piano riconciliato con un'immersione: annulla la riconciliazione per poterlo modificare.",
    proposeHint: "Il sito che cerchi non è ancora censito? Proponilo qui: verificheremo i dati e lo aggiungeremo alla mappa, così potrai selezionarlo nei prossimi piani.",
  },
  adminPage: {
    proposalApproved: "Proposta approvata — sito aggiunto all'archivio",
    proposalRejected: "Proposta rifiutata",
    rolesUpdated: "Ruoli aggiornati",
    rolesError: "Errore aggiornamento ruoli",
    statusUpdated: "Stato aggiornato",
    statusError: "Errore aggiornamento stato",
    userDeleted: "Utente eliminato",
    deleteError: "Errore eliminazione",
    dmApproved: "Divemaster approvato",
    approveError: "Errore approvazione",
    dmSuspended: "Divemaster sospeso",
    suspendError: "Errore sospensione",
    docVerified: "Documento verificato",
    verifyError: "Errore verifica",
    docRejected: "Documento rifiutato",
    rejectError: "Errore rifiuto",
    reviewError: "Errore durante la revisione",
    ipBlocked: "IP bloccato",
    ipBlockError: "Errore blocco IP",
    ipUnblocked: "IP sbloccato",
    ipUnblockError: "Errore sblocco IP",
    logbookImported_one: "{{count}} immersione importata per {{user}}",
    logbookImported_other: "{{count}} immersioni importate per {{user}}",
    logbookImportError: "Errore importazione",
    logbookImported: "{{count}} immersioni importate per {{user}}",
  },
  equipment: {
    title: "La Mia Attrezzatura",
    subtitle: "Inventario, revisioni e storico manutenzione",
    added: "Attrezzatura aggiunta",
    addTitle: "Aggiungi attrezzatura",
    add: "Aggiungi",
    service: "Registra revisione",
    retired: "Ritirata",
    saveError: "Errore nel salvataggio",
    serviceAdded: "Revisione registrata",
    fillRegistered: "{{n}} registrati",
    empty: "Nessuna attrezzatura registrata",
    addFirst: "Aggiungi il tuo primo equipaggiamento",
    confirmRetire: "Ritirare questo articolo dal servizio?",
    status: {
      all: "Tutti",
      active: "Attivo",
      retired: "Ritirato",
      sold: "Venduto",
    },
    cylindersLink: "Gestisci le certificazioni e i collaudi delle bombole →",
    suitWet: "Muta umida",
    suitSemidry: "Muta semistagna",
    suitDry: "Muta stagna",
  },
  logbookAnalytics: {
    title: "Le mie statistiche",
    subtitle: "Analisi completa del tuo logbook subacqueo",
    dives_total: "Immersioni totali",
    time_underwater: "Tempo sott'acqua",
    total_hours_sub: "{{h}}h totali",
    max_depth: "Profondità massima",
    avg_depth_sub: "Media: {{depth}}",
    countries: "Paesi visitati",
    unique_sites: "Siti unici",
    hours_in_water: "Ore in acqua",
    lifetime: "lifetime",
    timeline: "Immersioni nel tempo",
    per_month: "Per mese",
    per_year: "Per anno",
    depth_histogram: "Distribuzione profondità",
    top_sites: "Top 10 siti più visitati",
    sac_trend: "Evoluzione consumo aria (SAC)",
    sac_description: "SAC medio per coorti di 10 immersioni — valori in discesa indicano miglioramento della tecnica",
    sac_avg: "SAC medio",
    sac_cohort: "Imm. #{{from}}–{{to}}",
    sac_empty: "Registra le pressioni delle bombole nelle immersioni per vedere il trend SAC",
    heatmap_title: "Attività per giorno",
    heatmap_less: "Meno",
    heatmap_more: "Di più",
    heatmap_dives: "immersione",
    heatmap_dives_plural: "immersioni",
    no_data: "Nessun dato disponibile",
    no_sites: "Nessun sito registrato",
    personal_records: "Record personali",
    record_longest_dive: "Immersione più lunga",
    record_deepest_dive: "Profondità max raggiunta",
    record_night_dives: "Immersioni notturne",
    record_max_dives_day: "Max immersioni in 1 giorno",
    record_current_streak: "Streak attuale",
    record_best_streak: "Miglior streak",
    goals_title: "Obiettivi {{year}}",
    goal_completed: "✓ Completato",
    manage_goals: "Gestisci obiettivi →",
    goal_dive_count: "Immersioni totali",
    goal_max_depth: "Profondità massima",
    goal_total_hours: "Ore sott'acqua",
    goal_unique_sites: "Siti unici",
    goal_unique_countries: "Paesi visitati",
    unit_dives: "immersioni",
    unit_sites: "siti",
    unit_countries: "paesi",
    dive_style: "Stile di immersione",
    style_freediving: "Apnea",
    style_snorkeling: "Snorkeling",
    day_vs_night: "Giorno vs Notte",
    day_dives: "Diurne",
    night_dives: "Notturne",
    by_country: "Immersioni per paese",
    depth_progression: "Progressione profondità",
    depth_max: "Profondità max",
    depth_avg: "Profondità media",
    date_label: "Data",
    temp_seasonal: "Temperatura acqua per mese",
    temp_avg: "Temp. media",
    month_label: "Mese",
    tooltip_dives: "imm.",
    tooltip_count: "Conteggio",
    ai_summary: "Riepilogo AI",
    ai_description: "Lascia che l'AI analizzi il tuo logbook e generi un riepilogo personalizzato delle tue attività recenti.",
    ai_generate: "Genera riepilogo AI",
    ai_generating: "Generazione in corso…",
    ai_regenerate: "Rigenera",
    ai_error: "Errore nella generazione. Riprova.",
    world_map: "Mappa dei Siti",
    world_map_sites: "siti visitati",
  },
  onboarding: {
    wizard_title: "Configura il tuo profilo",
    wizard_step: "Passo {{current}} di {{total}}",
    next: "Avanti",
    back: "Indietro",
    error_save_profile: "Errore salvataggio profilo",
    progress: {
      type: "Tipo",
      profile: "Profilo",
      cert: "Brevetto",
      goal: "Obiettivo",
      interests: "Interessi",
      start: "Inizia!",
    },
    step1: {
      intro: "Come ti pratichi il diving? Scegli il tuo profilo — le funzionalità avanzate si sbloccano caricando i brevetti.",
      individual: "Utente individuale",
      individual_sub: "Sub, apneista, istruttore — le funzionalità si attivano con i brevetti",
      diver: "Subacqueo (ARA)",
      diver_sub: "Immergo con autorespiratore — brevetti PADI, SSI, CMAS e altri",
      freediver: "Apneista",
      freediver_sub: "Pratico l'apnea — brevetti AIDA, CMAS, SSI Freediving e altri",
      org: "Organizzazione o medico",
      org_sub: "Centro diving, agenzia, associazione, accademia, medico subacqueo",
    },
    org: {
      dive_doctor: "Medico subacqueo",
      dive_doctor_sub: "Specializzato in medicina iperbarica",
      dive_center: "Diving Center",
      dive_center_sub: "Gestisco un centro sub",
      travel_agency: "Agenzia viaggi sub",
      travel_agency_sub: "Organizzo viaggi subacquei",
      association: "Associazione",
      association_sub: "Gestisco un'associazione sportiva",
      academy: "Accademia",
      academy_sub: "Scuola o accademia di diving",
      research_center: "Centro di ricerca",
      research_center_sub: "Citizen science e ricerca marina",
    },
    step2: {
      intro: "Come ti chiami? Come vuoi essere conosciuto nella community?",
      display_name: "Nome visualizzato *",
      display_name_placeholder: "Es. Marco Rossi",
      display_name_error: "Minimo 2 caratteri",
      bio: "Bio (opzionale)",
      bio_placeholder: "Raccontaci qualcosa di te e delle tue immersioni…",
      country: "Paese",
      country_placeholder: "Es. Italia",
    },
    step3: {
      intro: "Hai già un brevetto? Aggiungilo al tuo profilo ora. Potrai aggiungerne altri in seguito.",
      agency: "Ente di certificazione",
      certification: "Brevetto",
      select_placeholder: "— Seleziona —",
      skip: "Non ho ancora un brevetto — salta",
    },
    step4: {
      intro: "Scegli un obiettivo per iniziare. Ti aiuterà a tenere traccia dei tuoi progressi.",
      set_goal: "Imposta obiettivo",
      continue: "Continua",
      skip: "Deciderò in seguito — salta",
      goal_10_dives: "10 immersioni",
      goal_50_dives: "50 immersioni",
      goal_30m: "Raggiungere 30m",
      goal_40m: "Raggiungere 40m",
      goal_5_sites: "Visitare 5 siti diversi",
      goal_10h: "Ore 10 sott'acqua",
    },
    step5: {
      title: "Come vuoi usare eDive?",
      intro: "Seleziona tutto ciò che ti interessa — organizzeremo il menu in base alle tue scelte.",
      personalize: "Personalizza ({{count}} selezionati)",
      skip_all: "Salta — userò tutto",
    },
    step6: {
      heading: "Benvenuto su eDive!",
      subtitle_personalized: "Il tuo menu è stato personalizzato. Cosa vuoi fare subito?",
      subtitle_default: "Il tuo profilo è pronto. Cosa vuoi fare prima?",
      link_logbook: "Registra un'immersione",
      link_divesites: "Esplora i siti",
      link_community: "Community",
      link_planning: "Pianifica una sessione",
      go_dashboard: "Vai alla dashboard",
    },
    jtbd: {
      traccia_label: "Tengo il logbook",
      traccia_desc: "Registro le mie immersioni, analizzo le statistiche e tengo traccia dei progressi",
      traccia_link: "Vai al logbook",
      esplora_label: "Esploro nuovi posti",
      esplora_desc: "Cerco siti di immersione, scopro mete, pianifico viaggi e gite",
      esplora_link: "Esplora i siti",
      impara_label: "Mi alleno e studio",
      impara_desc: "Seguo corsi, mi preparo agli esami, cerco un istruttore",
      impara_link: "Vedi i corsi",
      sicuro_label: "Rimango in sicurezza",
      sicuro_desc: "Gestisco la cartella medica, le assicurazioni e i check-in di sicurezza",
      sicuro_link: "Cartella medica",
      connetto_label: "Mi connetto con altri",
      connetto_desc: "Trovo buddy, partecipo alla community, chatto con subacquei",
      connetto_link: "Vai alla community",
      gestisco_label: "Organizzo la logistica",
      gestisco_desc: "Gestisco il calendario, le prenotazioni, l'attrezzatura e gli eventi",
      gestisco_link: "Apri calendario",
      lavoro_label: "Gestisco un'attività",
      lavoro_desc: "Lavoro come istruttore, divemaster o gestisco un centro diving / agenzia",
      lavoro_link: "Dashboard pro",
      proteggo_label: "Proteggo l'oceano",
      proteggo_desc: "Partecipo a missioni citizen science, catalogo specie, contribuisco alla ricerca marina",
      proteggo_link: "Missioni scientifiche",
    },
  },
  certQrCard: {
    title: "Carta di certificazione digitale",
    valid_24h: "QR valido per 24 ore",
    regenerate: "Rigenera QR",
    verified: "Verificata",
    pending: "In revisione",
  },
  freediving: {
    style: "Stile immersione",
    breath_hold: "Apnea (secondi)",
    lcm: "LCM (Perdita controllo motorio)",
    bo: "BO (Svenimento)",
    static_pb: "PB Statica",
    dynamic_pb: "PB Dinamica",
    depth_pb: "PB Profondità",
  },
  rental: {
    title: "Gestione Noleggio",
    checkout: "Check-out",
    return: "Restituzione",
    available: "Disponibile",
    checked_out: "In prestito",
  },
  reviews: {
    title: "Recensioni",
    write: "Scrivi una recensione",
    verified: "Prenotazione verificata",
  },
  emergency: {
    title: "Check-in attivo",
    sos: "SOS",
    checkout: "Check-out",
    dan: "DAN Europe",
  },
  briefing: {
    title: "Briefing Immersione",
    share: "Condividi briefing",
    hazards: "Pericoli",
    points_of_interest: "Punti di interesse",
    emergency_plan: "Piano di emergenza",
  },
  sightings: {
    title: "Avvistamenti",
    report: "Segnala avvistamento",
    community: "Community",
  },
  citizenScience: {
    title: "Dashboard Citizen Science",
    subtitle: "Analisi aggregata degli avvistamenti della community",
    descriptionTitle: "Cos'è la Citizen Science?",
    description: "La Citizen Science (scienza partecipata) è un approccio scientifico in cui i dati vengono raccolti da volontari — in questo caso i subacquei della community eDive. Ogni avvistamento registrato contribuisce a una banca dati condivisa che supporta la ricerca marina, il monitoraggio delle specie e la conservazione degli ecosistemi subacquei.",
    manualTitle: "Guida rapida",
    manualStep1Title: "1. Seleziona la specie",
    manualStep1: "Usa il campo di ricerca per trovare una specie per nome scientifico o comune. Lascia vuoto per analizzare tutti gli avvistamenti.",
    manualStep2Title: "2. Esplora la timeline",
    manualStep2: "Il grafico a barre mostra il numero di avvistamenti nel tempo. Scegli tra visualizzazione mensile e annuale e regola il periodo storico (da 1 a 10 anni).",
    manualStep3Title: "3. Analizza la densità geografica",
    manualStep3: "La tabella di densità raggruppa gli avvistamenti per celle geografiche. La griglia (in gradi) determina la dimensione di ogni cella: valori piccoli (0.1-0.5°) mostrano dettagli locali, valori grandi (1-5°) danno una visione regionale.",
    manualStep4Title: "4. Esporta i dati",
    manualStep4: "Esporta i dati filtrati in formato CSV (compatibile con Excel e R) o in formato Darwin Core XML (standard internazionale per la condivisione di dati sulla biodiversità con GBIF e OBIS).",
    speciesSelection: "Selezione specie",
    speciesPlaceholder: "ID specie (UUID) o lascia vuoto per tutte",
    granularityMonthly: "Mensile",
    granularityYearly: "Annuale",
    yearsLabel: "Anni:",
    gridLabel: "Griglia (°):",
    timelineTitle: "Timeline avvistamenti",
    densityTitle: "Griglia di densità",
    exportTitle: "Esporta dati",
    startDate: "Data inizio",
    endDate: "Data fine",
    downloadCsv: "Scarica CSV",
    downloadDarwinCore: "Scarica Darwin Core XML",
    noData: "Nessun dato disponibile.",
    loading: "Caricamento...",
    errorLoading: "Errore nel caricamento dei dati.",
    selectSpeciesFirst: "Seleziona una specie o scegli \"Tutte le specie\" per visualizzare i grafici.",
    colLat: "Lat",
    colLng: "Lng",
    colSightings: "Avvistamenti",
    exportErrorCsv: "Errore durante l'esportazione CSV.",
    exportErrorDarwinCore: "Errore durante l'esportazione Darwin Core.",
    speciesSearchPlaceholder: "Cerca specie per nome (es. Amphiprion, Squalo)",
    noSpeciesFound: "Nessuna specie trovata",
  },
  widget: {
    title: "Widget prenotazione",
    subtitle: "Integra il form di prenotazione sul sito del tuo centro",
    copy_code: "Copia codice",
    preview: "Anteprima",
  },
  subscription: {
    comingSoon: "Disponibile a breve",
    paymentUnavailable: "I pagamenti non sono ancora attivi: nessun addebito e nessun cambio di piano.",
    title: "Il mio abbonamento",
    currentPlan: "Piano corrente",
    renewsAt: "Rinnovo il",
    cancelAtPeriodEnd: "Annullamento a fine periodo",
    manage: "Gestisci abbonamento",
    upgrade: "Upgrade",
    startFree: "Inizia gratis",
    current: "Attuale",
    plans: {
      FREE: "Free",
      PRO_DIVER: "Pro Diver",
      CENTER_STARTER: "Center Starter",
      CENTER_PRO: "Center Pro",
    },
    statusActive: "Attivo",
    statusCancelled: "Annullato",
    statusExpired: "Scaduto",
    basePlan: "Piano base",
    free: "Gratuito",
    perMonth: "/ mese",
    perYear: "/ anno",
  },
  pageInfo: {
    howToUse: "Come si usa",
    hide: "Nascondi le informazioni",
  },
  pages: {
    dashboard: {
      desc: "La tua pagina personale: panoramica delle attività recenti, immersioni programmate, notifiche importanti e accesso rapido a tutte le funzionalità della piattaforma.",
      step1Title: "Panoramica attività",
      step1: "Visualizza le ultime immersioni registrate, i corsi in corso e gli eventi imminenti.",
      step2Title: "Accesso rapido",
      step2: "Usa le schede rapide per navigare verso Logbook, Siti, Corsi e Prenotazioni.",
      step3Title: "Notifiche",
      step3: "Le notifiche importanti appaiono nella barra superiore: selezionale per i dettagli.",
    },
    logbook: {
      desc: "Il tuo diario di bordo digitale: registra ogni immersione con profilo di profondità, specie avvistate, condizioni del mare e note personali.",
      step1Title: "Aggiungi immersione",
      step1: "Clicca \"Nuova immersione\" e compila i campi: sito, data, profondità massima, durata, temperatura.",
      step2Title: "Gestisci le tue immersioni",
      step2: "Filtra per data, sito o specie. Clicca su una voce per modificarla o aggiungere foto.",
      step3Title: "Statistiche",
      step3: "Il riepilogo in cima mostra totale immersioni, profondità media e ore sott'acqua accumulate.",
      restriction: "Accesso riservato ai profili con ruolo Subacqueo o superiore.",
    },
    divesites: {
      desc: "Esplora il catalogo globale dei siti di immersione: filtra per paese, tipo di immersione, profondità e valutazione della comunità.",
      step1Title: "Cerca un sito",
      step1: "Usa la barra di ricerca o i filtri per trovare siti per nome, paese o caratteristiche.",
      step2Title: "Dettaglio sito",
      step2: "Clicca su un sito per vedere profilo completo, galleria immagini, specie avvistate e recensioni.",
      step3Title: "Aggiungi alla wishlist",
      step3: "Salva i siti che vuoi visitare con l'icona ♡ — li ritrovi in \"Wishlist\".",
    },
    courses: {
      desc: "Catalogo corsi e certificazioni: trova corsi di immersione offerti dai centri diving partner, dalla teoria di base alle specialità avanzate.",
      step1Title: "Sfoglia i corsi",
      step1: "Filtra per livello (principiante, avanzato, specialità), ente certificatore o centro diving.",
      step2Title: "Iscrizione",
      step2: "Seleziona un corso e clicca \"Iscriviti\" per inviare una richiesta al centro diving.",
      step3Title: "I tuoi corsi",
      step3: "Nella tab \"I miei corsi\" trovi lo stato di avanzamento dei corsi già avviati.",
    },
    planning: {
      desc: "Strumenti di calcolo per la pianificazione sicura delle immersioni: tabelle RDP/NDL, calcolo miscele, velocità di risalita e gas planning.",
      step1Title: "Seleziona lo strumento",
      step1: "Scegli tra Tabelle No-Decompressione, Calcolo Nitrox, Gas Planning o Ascent Rate Calculator.",
      step2Title: "Inserisci i parametri",
      step2: "Compila profondità, tempo di fondo, tipo di gas e altitudine per ottenere i limiti di decompressione.",
      step3Title: "Salva il piano",
      step3: "Puoi salvare il piano dell'immersione e condividerlo con il tuo buddy.",
    },
    events: {
      desc: "Scopri eventi subacquei: gare, clean-up dei fondali, raduni di subacquei, corsi speciali e spedizioni organizzate dalla community.",
      step1Title: "Sfoglia gli eventi",
      step1: "Filtra per data, tipo di evento o posizione geografica.",
      step2Title: "Partecipa",
      step2: "Clicca su un evento e seleziona \"Partecipa\" per iscriverti. Riceverai conferma via email.",
      step3Title: "Organizza un evento",
      step3: "Se sei un istruttore o un centro diving, usa il pulsante \"Crea evento\" per pubblicarne uno nuovo.",
    },
    qa: {
      desc: "Forum domande e risposte della community subacquea: poni domande tecniche, condividi esperienze e ricevi risposte da istruttori e subacquei esperti.",
      step1Title: "Poni una domanda",
      step1: "Clicca \"Nuova domanda\", seleziona la categoria e descrivi il tuo dubbio con dettagli.",
      step2Title: "Rispondi",
      step2: "Puoi rispondere alle domande degli altri e votare le risposte più utili.",
      step3Title: "Filtra per categoria",
      step3: "Usa i tag (Sicurezza, Tecnica, Biologia, Attrezzatura) per trovare le discussioni rilevanti.",
    },
    social: {
      desc: "La community sociale di eDive: connettiti con altri subacquei, trova buddy per le tue prossime immersioni e segui i profili più attivi.",
      step1Title: "Trova persone",
      step1: "Usa la tab \"Persone\" per cercare subacquei per nome, zona geografica o specialità.",
      step2Title: "Connettiti",
      step2: "Manda una richiesta di connessione o avvia una chat diretta.",
      step3Title: "Buddy diving",
      step3: "Nella tab \"Buddy\" puoi cercare compagni di immersione per date e siti specifici.",
    },
    chat: {
      desc: "Messaggistica in tempo reale con crittografia end-to-end: comunica privatamente con buddy, istruttori e centri diving.",
      step1Title: "Nuova conversazione",
      step1: "Clicca \"+\" per avviare una chat diretta con un utente o creare un gruppo.",
      step2Title: "Invia messaggi",
      step2: "Supporta testo, immagini e file. I messaggi sono cifrati con AES-256.",
      step3Title: "Notifiche",
      step3: "Attiva le notifiche push nel profilo per ricevere avvisi anche quando l'app è in background.",
    },
    bookings: {
      desc: "Gestione prenotazioni: visualizza le tue prenotazioni attive, i corsi confermati e le uscite programmate con i centri diving.",
      step1Title: "Le tue prenotazioni",
      step1: "Elenco di tutte le prenotazioni con stato: confermata, in attesa, completata o annullata.",
      step2Title: "Dettagli",
      step2: "Clicca su una prenotazione per vedere centro diving, date, istruttore assegnato e note.",
      step3Title: "Annullamento",
      step3: "Per annullare, apri il dettaglio e clicca \"Annulla prenotazione\" — rispetta la politica di cancellazione del centro.",
    },
    insurance: {
      desc: "Assicurazione subacquea: gestisci la tua copertura per immersioni, ricerca e soccorso e camera iperbarica.",
      step1Title: "Verifica copertura",
      step1: "Visualizza lo stato attuale della tua polizza e le date di validità.",
      step2Title: "Rinnova o acquista",
      step2: "Clicca \"Nuova polizza\" per confrontare le opzioni disponibili e procedere all'acquisto.",
      step3Title: "Sinistro",
      step3: "In caso di emergenza o sinistro, usa il pulsante \"Apri sinistro\" per avviare la procedura.",
    },
    media: {
      desc: "Libreria personale di foto e video subacquei: carica, organizza e condividi i tuoi scatti sott'acqua.",
      step1Title: "Carica media",
      step1: "Clicca \"Carica\" per aggiungere foto o video dal tuo dispositivo. Formati supportati: JPEG, PNG, MP4.",
      step2Title: "Organizza",
      step2: "Crea album, aggiungi tag di specie o sito per ritrovare rapidamente i tuoi contenuti.",
      step3Title: "Condividi",
      step3: "Seleziona un media e clicca \"Condividi\" per pubblicarlo nel tuo profilo o inviarlo in chat.",
    },
    medical: {
      desc: "Cartella medica subacquea: gestisci i tuoi idoneità mediche, visita periodica e certificati sanitari richiesti per l'attività subacquea.",
      step1Title: "Idoneità",
      step1: "Carica il tuo certificato di idoneità medica con data di scadenza. Riceverai un promemoria prima della scadenza.",
      step2Title: "Storico visite",
      step2: "Consulta lo storico delle valutazioni mediche e scarica i certificati in PDF.",
      step3Title: "Medico assegnato",
      step3: "Il medico subacqueo assegnato può vedere e aggiornare la tua cartella previo tuo consenso.",
      restriction: "La gestione completa richiede il ruolo Medico Subacqueo. I subacquei possono solo visualizzare.",
    },
    associations: {
      desc: "Associazioni e federazioni subacquee: trova associazioni locali, iscriviti e partecipa alle attività organizzate.",
      step1Title: "Cerca associazione",
      step1: "Filtra per regione, tipo di attività (sportiva, scientifica, ambientale) o ente affiliato.",
      step2Title: "Iscriviti",
      step2: "Clicca su un'associazione per vedere i dettagli e inviare richiesta di iscrizione.",
      step3Title: "Gestisci l'associazione",
      step3: "Se sei un responsabile, puoi gestire soci e pubblicare comunicati dalla sezione Admin.",
    },
    tourism: {
      desc: "Viaggi subacquei: scopri pacchetti turistici, liveaboard e destinazioni di diving in tutto il mondo organizzate dalle agenzie partner.",
      step1Title: "Sfoglia destinazioni",
      step1: "Filtra per area geografica, stagione migliore o tipo di immersione (reef, relitti, grotte).",
      step2Title: "Richiedi preventivo",
      step2: "Seleziona un pacchetto e invia una richiesta all'agenzia viaggi — riceverai risposta entro 24h.",
      step3Title: "Prenota",
      step3: "Una volta concordati i dettagli, conferma la prenotazione e ricevi la documentazione di viaggio.",
    },
    marketplace: {
      desc: "Mercato dell'attrezzatura subacquea: compra e vendi attrezzatura usata, trova offerte su mute, bombole, computer da immersione e altro.",
      step1Title: "Sfoglia annunci",
      step1: "Filtra per categoria (muta, BCD, computer, pinne), stato (nuovo/usato) e prezzo.",
      step2Title: "Pubblica annuncio",
      step2: "Clicca \"Vendi\" per caricare foto, descrizione e prezzo della tua attrezzatura.",
      step3Title: "Contatta il venditore",
      step3: "Usa il pulsante \"Contatta\" per avviare una chat con il venditore e concordare la transazione.",
    },
    calendar: {
      desc: "Calendario personale delle attività subacquee: visualizza immersioni programmate, corsi, eventi e scadenze mediche in un'unica vista.",
      step1Title: "Vista mensile/settimanale",
      step1: "Cambia la visualizzazione con i pulsanti in alto a destra.",
      step2Title: "Aggiungi evento",
      step2: "Clicca su un giorno per aggiungere un'immersione pianificata o un promemoria.",
      step3Title: "Sincronizza",
      step3: "Esporta il calendario in formato iCal per sincronizzarlo con Google Calendar o Apple Calendar.",
    },
    ai: {
      desc: "Assistente AI per subacquei: ottieni consigli personalizzati su siti, specie, sicurezza e pianificazione delle immersioni grazie all'intelligenza artificiale.",
      step1Title: "Fai una domanda",
      step1: "Digita qualsiasi domanda sul diving: sicurezza, biologia marina, attrezzatura o siti da visitare.",
      step2Title: "Raccomandazioni",
      step2: "L'AI analizza il tuo profilo e logbook per suggerire siti, corsi e specie in linea con la tua esperienza.",
      step3Title: "Pianificazione",
      step3: "Chiedi all'AI di aiutarti a pianificare un'immersione sicura in base a profondità e gas.",
    },
    analytics: {
      desc: "Dashboard analitica: visualizza statistiche aggregate sulle attività della piattaforma, crescita utenti e performance dei centri diving.",
      step1Title: "Seleziona periodo",
      step1: "Usa il selettore date per filtrare le statistiche per intervallo temporale.",
      step2Title: "Esporta dati",
      step2: "Clicca \"Esporta\" per scaricare i dati in formato CSV o PDF.",
      restriction: "Accesso riservato agli Amministratori e ai Centri Diving per i propri dati.",
    },
    gdpr: {
      desc: "Gestione dei tuoi dati personali secondo il GDPR: visualizza i consensi forniti, scarica i tuoi dati o richiedi la cancellazione dell'account.",
      step1Title: "Consensi",
      step1: "Nella tab \"Consensi\" vedi lo stato di ogni autorizzazione e puoi modificarla in qualsiasi momento.",
      step2Title: "Esporta dati",
      step2: "Clicca \"Esporta dati\" per ricevere via email un archivio completo delle tue informazioni.",
      step3Title: "Cancellazione",
      step3: "La richiesta di cancellazione anonimizza tutti i tuoi dati entro 30 giorni come previsto dal GDPR.",
    },
    referral: {
      desc: "Programma di referral: invita amici e guadagna punti fedeltà da usare per servizi premium sulla piattaforma.",
      step1Title: "Copia il tuo link",
      step1: "Copia il link univoco di invito e condividilo con amici subacquei.",
      step2Title: "Traccia le conversioni",
      step2: "Per ogni amico che si registra tramite il tuo link guadagni punti bonus.",
      step3Title: "Usa i punti",
      step3: "I punti accumulati si convertono in sconti o accesso a funzionalità premium.",
    },
    achievements: {
      desc: "Trofei e risultati: sblocca badge man mano che raggiungi traguardi subacquei come numero di immersioni, profondità massima o specie avvistate.",
      step1Title: "I tuoi trofei",
      step1: "Visualizza tutti i badge ottenuti con data e descrizione del traguardo raggiunto.",
      step2Title: "Progressi",
      step2: "I badge grigi mostrano obiettivi non ancora raggiunti e i progressi attuali.",
      step3Title: "Condividi",
      step3: "Clicca su un badge per condividerlo nel tuo profilo o sui social.",
    },
    wallet: {
      desc: "Portafoglio e punti fedeltà: gestisci il credito sulla piattaforma, i punti guadagnati e le transazioni effettuate.",
      step1Title: "Saldo",
      step1: "Il saldo attuale in punti e credito è mostrato in cima alla pagina.",
      step2Title: "Storico transazioni",
      step2: "Scorri l'elenco per vedere guadagni (referral, immersioni) e spese (prenotazioni, corsi).",
      step3Title: "Ricarica",
      step3: "Clicca \"Ricarica\" per aggiungere credito tramite carta di credito o PayPal.",
    },
    safety: {
      desc: "Sicurezza subacquea: protocolli di emergenza, procedure DAN, segnali di pericolo e lista di controllo pre-immersione.",
      step1Title: "Checklist pre-immersione",
      step1: "Usa la checklist BWRAF prima di ogni immersione per verificare attrezzatura e sicurezza.",
      step2Title: "Procedure di emergenza",
      step2: "Studia i protocolli per gestire DCS, perdita di aria e smarrimento del buddy.",
      step3Title: "Contatti emergenza",
      step3: "Salva i numeri DAN e dei servizi di emergenza locali prima di ogni immersione.",
    },
    equipment: {
      desc: "Gestione attrezzatura personale: inventario completo della tua attrezzatura con date di revisione, scadenze e manutenzioni programmate.",
      step1Title: "Aggiungi attrezzatura",
      step1: "Clicca \"Aggiungi\" per registrare muta, BCD, erogatore, computer e altro con modello e numero seriale.",
      step2Title: "Manutenzione",
      step2: "Imposta i promemoria per le revisioni periodiche — riceverai notifiche prima della scadenza.",
      step3Title: "Registra interventi",
      step3: "Log ogni intervento di manutenzione con data, officina e pezzi sostituiti.",
    },
    lifeList: {
      desc: "Lista degli avvistamenti personali: tieni traccia di ogni specie marina avvistata durante le tue immersioni, costruendo la tua lista di vita subacquea.",
      step1Title: "Aggiungi avvistamento",
      step1: "Dopo una immersione, cerca la specie avvistata e aggiungila alla lista con data e sito.",
      step2Title: "Statistiche",
      step2: "Visualizza quante specie hai avvistato per famiglia, habitat o area geografica.",
      step3Title: "Condividi",
      step3: "La tua life list è visibile nel profilo pubblico se hai attivato la visibilità.",
    },
    encyclopedia: {
      desc: "Enciclopedia marina collaborativa: sfoglia il catalogo di specie marine o contribuisci con le tue foto subacquee — l'AI identifica la specie e il team di biologia marina approva il contributo.",
      step1Title: "Scatta e carica",
      step1: "Clicca \"Contribuisci foto\" e carica un'immagine subacquea dal tuo logbook o dalla galleria. Puoi caricare anche senza conoscere la specie.",
      step2Title: "L'AI identifica per te",
      step2: "Il modello iNaturalist analizza la foto e suggerisce le specie più probabili con percentuale di fiducia. Puoi confermare, correggere o lasciare la specie ai moderatori.",
      step3Title: "Revisione e pubblicazione",
      step3: "Il team di biologia marina revisiona il contributo entro 7 giorni. Se approvato, la foto appare nell'enciclopedia con attribuzione al tuo profilo.",
    },
    biologistPortal: {
      desc: "Portale per biologi marini: accedi ai dati aggregati di citizen science, gestisci le specie nel catalogo e coordina le missioni di monitoraggio.",
      step1Title: "Gestione specie",
      step1: "Aggiungi e modifica schede specie nel catalogo con dati tassonomici e IUCN aggiornati.",
      step2Title: "Dati avvistamenti",
      step2: "Analizza gli avvistamenti segnalati dalla community con filtri per specie, area e periodo.",
      step3Title: "Missioni",
      step3: "Crea e gestisci missioni di monitoraggio assegnando aree geografiche e protocolli di raccolta dati.",
      restriction: "Accesso riservato ai profili con ruolo Biologo Marino.",
    },
    missions: {
      desc: "Missioni di monitoraggio scientifico: partecipa a ricerche sui fondali marini registrando avvistamenti secondo protocolli standardizzati.",
      step1Title: "Sfoglia le missioni",
      step1: "Esplora le missioni attive filtrate per area geografica o specie target.",
      step2Title: "Partecipa",
      step2: "Clicca \"Partecipa\" su una missione e segui le istruzioni per raccogliere dati sul campo.",
      step3Title: "Registra dati",
      step3: "Al rientro dall'immersione, inserisci gli avvistamenti con coordinate GPS, specie e foto.",
    },
    diveCenters: {
      desc: "Catalogo mondiale dei centri diving e resort subacquei: trova strutture per organizzare le tue immersioni, prenotare corsi e noleggiare attrezzatura.",
      step1Title: "Cerca un centro",
      step1: "Filtra per paese, città o usa la ricerca per nome. Usa il tab \"Resort\" per strutture con alloggio integrato.",
      step2Title: "Dettaglio centro",
      step2: "Clicca su una struttura per vedere servizi, contatti, galleria immagini e recensioni.",
      step3Title: "Prenota",
      step3: "Usa il pulsante \"Prenota\" per inviare una richiesta di disponibilità direttamente al centro.",
    },
    instructorDashboard: {
      desc: "Dashboard istruttore: gestisci i tuoi studenti, corsi, sessioni di brevetto e calendari di insegnamento.",
      step1Title: "Studenti",
      step1: "Visualizza la lista degli studenti attivi con avanzamento nei corsi e certificazioni in corso.",
      step2Title: "Sessioni",
      step2: "Pianifica lezioni teoriche e pratiche, assegna materiali e monitora la presenza.",
      step3Title: "Certifica",
      step3: "A completamento del corso, emetti il brevetto digitale tramite l'ente certificatore integrato.",
      restriction: "Accesso riservato ai profili con ruolo Istruttore.",
    },
    jobs: {
      desc: "Bacheca lavoro subacqueo: offerte di lavoro per istruttori, divemaster, guide subacquee e biologi marini in tutto il mondo.",
      step1Title: "Cerca offerte",
      step1: "Filtra per ruolo, paese, tipo di contratto (stagionale, full-time) o ente certificatore richiesto.",
      step2Title: "Candidatura",
      step2: "Clicca su un'offerta per i dettagli e invia la tua candidatura allegando il CV.",
      step3Title: "Pubblica offerta",
      step3: "Se gestisci un centro diving, usa \"Pubblica offerta\" per trovare nuovi collaboratori.",
    },
    admin: {
      desc: "Pannello di amministrazione: gestione completa degli utenti, monitoraggio della salute dei servizi, audit log e configurazione della piattaforma.",
      step1Title: "Gestione utenti",
      step1: "Cerca, filtra e gestisci tutti gli utenti registrati con accesso a ruoli e impersonificazione.",
      step2Title: "Salute servizi",
      step2: "Il monitor in tempo reale mostra lo stato di tutti i microservizi con latenza e motivo di eventuali anomalie.",
      step3Title: "Audit log",
      step3: "Monitora tutti gli eventi di sicurezza: login, cambio password, esportazioni dati e azioni amministrative.",
      restriction: "Accesso riservato agli Amministratori della piattaforma.",
    },
    dcDashboard: {
      desc: "Dashboard del tuo centro diving: panoramica prenotazioni di oggi, ricavi del mese, clienti attivi e attività in programma.",
      step1Title: "Panoramica giornaliera",
      step1: "Visualizza le uscite e le prenotazioni del giorno con lista partecipanti.",
      step2Title: "KPI mensili",
      step2: "Grafici di ricavi, numero di clienti e tasso di utilizzo delle risorse.",
      step3Title: "Azioni rapide",
      step3: "Accedi con un clic a Prenotazioni, Corsi, Noleggio e Calendario dalla barra laterale.",
      restriction: "Accesso riservato ai gestori del Centro Diving.",
    },
    dcBookings: {
      desc: "Gestione prenotazioni del centro diving: visualizza, conferma e gestisci tutte le richieste di prenotazione dei clienti.",
      step1Title: "Lista prenotazioni",
      step1: "Filtra per stato (in attesa, confermata, completata) o per data di uscita.",
      step2Title: "Conferma/Rifiuta",
      step2: "Clicca su una prenotazione per vedere i dettagli e confermare o rifiutare con nota al cliente.",
      step3Title: "Lista partecipanti",
      step3: "Ogni uscita ha una lista stampabile con nomi, brevetti e note mediche dei partecipanti.",
      restriction: "Accesso riservato ai gestori del Centro Diving.",
    },
    dcCourses: {
      desc: "Gestione corsi del centro diving: crea, pubblica e gestisci i corsi nel catalogo, assegna istruttori e monitora gli iscritti.",
      step1Title: "Crea corso",
      step1: "Clicca \"Nuovo corso\" per definire titolo, livello, durata, prezzo e istruttore responsabile.",
      step2Title: "Gestisci iscritti",
      step2: "Per ogni corso vedi lista studenti, avanzamento e materiali distribuiti.",
      step3Title: "Pubblica nel catalogo",
      step3: "Attiva \"Pubblica\" per rendere visibile il corso agli utenti della piattaforma.",
      restriction: "Accesso riservato ai gestori del Centro Diving.",
    },
    dcMarketing: {
      desc: "Strumenti di marketing per il centro diving: gestisci campagne WhatsApp, email, consensi GDPR e il database contatti clienti.",
      step1Title: "Database contatti",
      step1: "Importa o aggiungi contatti con nome, email, telefono e WhatsApp. Riconcilia con gli utenti eDive registrati.",
      step2Title: "Campagne",
      step2: "Crea campagne email o WhatsApp per promozioni, novità o newsletter stagionali.",
      step3Title: "Consensi",
      step3: "Monitora lo stato dei consensi GDPR: invia richieste e traccia le risposte nel registro immutabile.",
      restriction: "Accesso riservato ai gestori del Centro Diving.",
    },
    dcRental: {
      desc: "Gestione noleggio attrezzatura: tieni traccia dell'inventario, delle prenotazioni di noleggio e delle manutenzioni programmate.",
      step1Title: "Inventario",
      step1: "Registra ogni pezzo di attrezzatura con modello, taglia, stato e data di ultima revisione.",
      step2Title: "Noleggio",
      step2: "Assegna attrezzatura a un cliente per una data specifica e registra la riconsegna.",
      step3Title: "Manutenzione",
      step3: "Segna l'attrezzatura in manutenzione per escluderla automaticamente dalle disponibilità.",
      restriction: "Accesso riservato ai gestori del Centro Diving.",
    },
    dcCompliance: {
      desc: "Conformità normativa: gestisci certificazioni del centro, polizze assicurative, brevetti istruttori e documentazione obbligatoria.",
      step1Title: "Documenti",
      step1: "Carica e tieni aggiornata la documentazione obbligatoria (licenze, polizze, certificazioni).",
      step2Title: "Scadenze",
      step2: "Il calendario delle scadenze avvisa quando un documento sta per scadere.",
      step3Title: "Audit",
      step3: "Genera report di conformità per ispezioni o richieste degli enti certificatori.",
      restriction: "Accesso riservato ai gestori del Centro Diving.",
    },
  },
  atmosphere: {
    soundOn: "Attiva il suono del mare",
    soundOff: "Silenzia il suono del mare",
    soundOnLabel: "Mare acceso",
    soundOffLabel: "Suono del mare",
  },
  live: {
    status: {
      pending: "In revisione",
      active: "Pubblicata",
      rejected: "Non approvata",
      removed: "Rimossa",
    },
    upload: {
      title: "Condividi 30 secondi di mare",
      subtitle: "Un momento della tua immersione, massimo {{max}} secondi. Verrà mostrato su eDive Live e votato dalla community.",
      pick: "Scegli un video",
      constraints: "Max {{max}} secondi · fino a {{mb}} MB · mp4, mov, webm",
      change: "Cambia video",
      titleLabel: "Titolo",
      titlePlaceholder: "Es. Cernia curiosa a Portofino",
      descLabel: "Descrizione (facoltativa)",
      descPlaceholder: "Racconta dov'eri, cosa hai visto…",
      publish: "Invia a eDive Live",
      uploading: "Caricamento in corso…",
      moderationNote: "La clip verrà rivista dal nostro team e comparirà appena approvata.",
      doneTitle: "Clip inviata! 🎉",
      doneDesc: "Grazie per aver condiviso il tuo mare. La rivedremo a breve e comparirà su eDive Live.",
      another: "Carica un'altra",
      backToCommunity: "Torna alla community",
      mineTitle: "Le tue clip",
      errNotVideo: "Il file non sembra un video. Prova con mp4, mov o webm.",
      errTooBig: "Il video supera i {{mb}} MB. Comprimilo o accorcialo.",
      errTooLong: "La clip dura {{actual}}s: il massimo è {{max}}s. Accorciala e riprova.",
      errGeneric: "Qualcosa è andato storto nel caricamento. Riprova tra poco.",
    },
  },
  landing: {
    nav: {
      features: "Funzionalità",
      about: "Chi siamo",
      howItWorks: "Come funziona",
      contact: "Contatti",
      login: "Accedi",
      register: "Registrati",
      startFree: "Inizia gratis",
      hello: "Ciao, {{name}} →",
      goToApp: "Vai all'app →",
    },
    hero: {
      badge: "La piattaforma #1 per subacquei in Italia",
      h1a: "Logbook, salute,",
      h1b: "viaggi e sicurezza.",
      h1c: "Tutto in un'app.",
      sub: "eDive è la piattaforma all-in-one per subacquei, istruttori, centri immersione e medici. Registra le immersioni, trova siti spettacolari, prenota corsi e connettiti con migliaia di appassionati.",
      ctaStart: "Inizia gratis",
      ctaLogin: "Hai già un account? Accedi",
      brochure: "Scarica la brochure eDive (PDF)",
      chip1: "📔 Logbook & Diari viaggio",
      chip2: "🏥 Fascicolo Sanitario",
      chip3: "📅 Pianificazione AI",
      chip4: "🌊 8.200+ siti",
      chip5: "🤿 Buddy finder",
      chip6: "✨ AI assistant",
    },
    stats: {
      divers: "Subacquei registrati",
      dives: "Immersioni registrate",
      sites: "Siti catalogati",
      centers: "Centri partner",
    },
    live: {
      title: "30 secondi di mare",
      subtitle: "Le immersioni più belle della community, in clip da 30 secondi. Guarda, emozionati, vota le tue preferite — non serve registrarsi.",
      sortTop: "Più votate",
      sortRecent: "Ultime",
      play: "Guarda la clip",
      views: "visualizzazioni",
      confirmTitle: "Conferma il tuo voto",
      confirmDesc: "Un piccolo controllo per assicurarci che sei una persona. Grazie per partecipare!",
    },
    unlock: {
      badge: "🎁 Gratis · Nessuna carta · Cancella quando vuoi",
      h2a: "In 2 minuti sblocchi",
      h2b: "tutto questo",
      sub: "Ogni funzionalità è accessibile subito, gratis, senza limiti di tempo. Nessuna sorpresa.",
      socialProofBold: "50.000+ subacquei",
      socialProof: "usano già eDive ogni giorno",
      cta: "Registrati gratis ora",
      disclaimer: "Nessuna carta di credito · Attivo in 2 minuti · Cancella in qualsiasi momento",
      items: {
        logbook: {
          title: "Logbook personale illimitato",
          desc: "Ogni immersione con profilo deco, dati gas, mappa e foto. Esportabile in PDF.",
        },
        medical: {
          title: "Fascicolo Sanitario Elettronico",
          desc: "Certificati di idoneità digitali, storico visite mediche e promemoria scadenze automatici.",
        },
        diaries: {
          title: "Diari di viaggio",
          desc: "Racconta le tue spedizioni con foto, mappe e appunti. Condividi o tieni per te.",
        },
        planning: {
          title: "Pianificazione immersioni",
          desc: "Briefing AI, simulatore tabelle deco, calcolatore gas mix e checklist di sicurezza.",
        },
        sites: {
          title: "8.200+ siti nel mondo",
          desc: "Mappe interattive, condizioni live, valutazioni reali dalla community globale.",
        },
        buddy: {
          title: "Buddy finder intelligente",
          desc: "Trova compagni compatibili per livello, zona e disponibilità. Contattali via chat.",
        },
        ai: {
          title: "AI assistant subacqueo",
          desc: "Risposte tecniche 24/7, analisi del tuo stile di immersione, consigli personalizzati.",
        },
        courses: {
          title: "Corsi e brevetti integrati",
          desc: "Cerca, confronta e prenota corsi certificati PADI, SSI, CMAS, TDI e altri.",
        },
        safety: {
          title: "Strumenti di sicurezza",
          desc: "Tabelle deco, no-fly timer, gas mix, waiver digitale e gestione emergenze.",
        },
        mobile: {
          title: "App mobile iOS & Android",
          desc: "Funziona offline in barca, si sincronizza quando torni in porto.",
        },
      },
    },
    compare: {
      colFeature: "Funzionalità",
      colGuest: "Senza account",
      colMember: "Con eDive",
      unlimited: "Illimitato",
      limited: "Limitato",
      full: "Completo",
      rows: {
        logbook: "Logbook personale",
        medical: "Fascicolo Sanitario Elettronico",
        diaries: "Diari di viaggio",
        planning: "Pianificazione & briefing AI",
        sites: "Siti di immersione",
        buddy: "Buddy finder & chat",
        courses: "Corsi & prenotazioni",
        social: "Community e feed social",
        app: "App mobile nativa",
      },
    },
    profiles: {
      eyebrow: "Per tutti i ruoli",
      h2: "Chi usa eDive?",
      sub: "Una piattaforma pensata per ogni figura del mondo subacqueo — dal principiante all'esperto, dalla scuola al centro immersioni.",
      cta: "Registrati →",
      diver: {
        title: "Subacqueo",
        desc: "Logbook digitale, fascicolo sanitario, diari di viaggio, pianificazione deco e connessione con la community mondiale.",
        f1: "Logbook & Diari",
        f2: "Fascicolo Sanitario",
        f3: "Pianificazione AI",
        f4: "Buddy finder",
      },
      instructor: {
        title: "Istruttore",
        desc: "Gestisci corsi, studenti e certificazioni in un'unica piattaforma. Aumenta la visibilità della tua attività.",
        f1: "Gestione corsi",
        f2: "Studenti & log",
        f3: "Calendario lezioni",
        f4: "Materiale didattico",
      },
      divemaster: {
        title: "Divemaster",
        desc: "Pianifica briefing, gestisci i gruppi, monitora i check-in e garantisci la sicurezza di ogni uscita.",
        f1: "Pianificazione",
        f2: "Check-in sicurezza",
        f3: "Gestione gruppi",
        f4: "Report immersioni",
      },
      doctor: {
        title: "Medico Sub",
        desc: "Emetti e gestisci certificati di idoneità, tieni uno storico clinico dei pazienti subacquei.",
        f1: "FSE subacquei",
        f2: "Storico pazienti",
        f3: "Scadenze automatiche",
        f4: "Firma digitale",
      },
      center: {
        title: "Centro Immersioni",
        desc: "Dashboard completa per gestire prenotazioni, equipment, corsi, staff, marketing e loyalty dei clienti.",
        f1: "Prenotazioni",
        f2: "Fleet & attrezzatura",
        f3: "Loyalty program",
        f4: "Analytics",
      },
    },
    features: {
      eyebrow: "Funzionalità",
      h2: "Tutto ciò di cui hai bisogno",
      sub: "Da strumenti di sicurezza avanzati a funzionalità social, eDive copre ogni aspetto della tua vita subacquea.",
    },
    featureList: {
      logbook: {
        title: "Logbook Digitale",
        desc: "Registra ogni immersione con dati completi: profondità, temperatura, visibilità, gas mix e profilo temporale preciso.",
      },
      medical: {
        title: "Fascicolo Sanitario Elettronico",
        desc: "Gestisci i tuoi certificati di idoneità subacquea, tieni lo storico delle visite mediche e ricevi promemoria automatici sulle scadenze.",
      },
      diaries: {
        title: "Diari di Viaggio",
        desc: "Racconta le tue spedizioni subacquee con foto, note e mappe GPS. Condividi pubblicamente o tieni come memoria privata.",
      },
      planning: {
        title: "Pianificazione Immersioni",
        desc: "Briefing AI personalizzato, simulatore tabelle deco, calcolatore gas mix, checklist sicurezza e waiver digitale.",
      },
      sites: {
        title: "Siti di Immersione",
        desc: "Esplora migliaia di spot in tutto il mondo con mappe interattive, valutazioni e condizioni aggiornate dalla community.",
      },
      courses: {
        title: "Corsi & Certificazioni",
        desc: "Trova e prenota corsi di ogni livello, da OWD a TDI Technical. Gestisci il tuo percorso formativo in un unico posto.",
      },
      social: {
        title: "Social Community",
        desc: "Condividi le tue immersioni, trova buddy, segui altri subacquei e partecipa a una community appassionata.",
      },
      chat: {
        title: "Chat in Tempo Reale",
        desc: "Messaggi diretti e conversazioni di gruppo per organizzare uscite, scambiare consigli e restare connessi.",
      },
      centers: {
        title: "Centri Immersione",
        desc: "Prenota attività e corsi nei migliori diving center, gestisci noleggi equipment e accedi a offerte esclusive.",
      },
      insurance: {
        title: "Assicurazioni",
        desc: "Polizze personalizzate per subacquei: copertura DAN, rimpatrio, iperbarica. Tutto gestibile direttamente dall'app.",
      },
      ai: {
        title: "Assistente AI",
        desc: "Intelligenza artificiale per rispondere alle tue domande tecniche, analizzare i tuoi dati e suggerire miglioramenti.",
      },
      market: {
        title: "Marketplace",
        desc: "Compra e vendi attrezzatura subacquea usata tra appassionati. Annunci verificati e pagamenti sicuri.",
      },
      qa: {
        title: "Q&A Community",
        desc: "Fai domande, condividi la tua esperienza e trova risposte dagli esperti della comunità subacquea.",
      },
    },
    howItWorks: {
      eyebrow: "Inizia subito",
      h2: "Come funziona",
      sub: "Tre semplici passi per entrare nella community subacquea più grande d'Italia.",
      cta: "Crea il tuo account gratuito",
      disclaimer: "Nessuna carta di credito richiesta · Gratis per sempre",
    },
    steps: {
      s1: {
        title: "Registrati in 2 minuti",
        desc: "Crea il tuo account gratuitamente. Scegli il tuo profilo — subacqueo, istruttore, centro immersioni — e personalizza le tue preferenze.",
      },
      s2: {
        title: "Completa il tuo profilo",
        desc: "Aggiungi le tue certificazioni, le tue specialità e la tua attrezzatura. Il tuo profilo diventa il tuo passaporto subacqueo digitale.",
      },
      s3: {
        title: "Immergiti nella community",
        desc: "Inizia a registrare le tue immersioni, esplorare siti, prenotare corsi e connetterti con migliaia di appassionati.",
      },
    },
    strip: {
      app: "App mobile + web",
      appSub: "iOS, Android, browser",
      certs: "Certificazioni integrate",
      certsSub: "PADI, SSI, CMAS, TDI...",
      realtime: "Dati in tempo reale",
      realtimeSub: "Sincronizzazione live",
      gdpr: "GDPR compliant",
      gdprSub: "Dati sicuri e protetti",
    },
    testimonials: {
      eyebrow: "Testimonianze",
      h2: "Cosa dicono di noi",
      t1: "Finalmente un'app che capisce le esigenze di chi fa immersioni ogni giorno. Il logbook digitale ha rivoluzionato il mio modo di lavorare.",
      t2: "La gestione dei corsi è diventata semplicissima. I miei studenti adorano poter seguire i loro progressi direttamente dall'app.",
      t3: "Da quando usiamo eDive per le prenotazioni, abbiamo ridotto i no-show del 40% e aumentato la soddisfazione dei clienti.",
    },
    cta: {
      h2a: "Pronto a tuffarti",
      h2b: "nell'avventura?",
      sub: "Unisciti a oltre 50.000 subacquei che usano eDive ogni giorno. Registrazione gratuita, in due minuti.",
      b1: "Logbook illimitato",
      b2: "AI assistant 24/7",
      b3: "8.200+ siti nel mondo",
      b4: "App iOS & Android",
      b5: "Community & buddy",
      b6: "Gratis per sempre",
      createAccount: "Crea account gratuito",
      disclaimer: "Gratis · Nessuna carta richiesta · Cancella quando vuoi",
    },
    footer: {
      tagline: "La piattaforma all-in-one per la community subacquea italiana e internazionale.",
      platform: "Piattaforma",
      platformLinks: {
        features: "Funzionalità",
        instructors: "Per istruttori",
        centers: "Per centri",
        pricing: "Prezzi",
      },
      company: "Azienda",
      companyLinks: {
        about: "Chi siamo",
        blog: "Blog",
        partners: "Partner",
        contact: "Contatti",
      },
      contactUs: "Contattaci",
      legal: "Legale",
      legalLinks: {
        terms: "Termini di servizio",
      },
      copyright: "Tutti i diritti riservati.",
    },
    liveNews: "Live news",
    readMore: "Leggi →",
    brochure: {
      title: "Scarica la brochure eDive",
      subtitle: "Ti invieremo il link via email",
      sent: "Controlla la tua email!",
      language: "Lingua / Language",
      firstNamePlaceholder: "Mario",
      lastNamePlaceholder: "Rossi",
      emailPlaceholder: "mario@esempio.com",
      phonePlaceholder: "+39 333 1234567",
      send: "Inviami il link",
      sending: "Invio in corso...",
      privacyNote: "I tuoi dati sono al sicuro. Non li condivideremo mai con terze parti.",
    },
    isoCompliance: {
      badge: "Sicurezza & Conformità",
      h2: "Progettata per la Conformità Normativa",
      sub: "eDive è sviluppata nel rispetto delle normative italiane vigenti e degli standard internazionali ISO per le attività subacquee ricreative e professionali.",
      standardsLabel: "Standard ISO supportati",
      lawsLabel: "Normativa italiana",
      featuresLabel: "Come eDive ti protegge",
      badges: {
        iso24803: "Provider ricreativo",
        iso24801: "Formazione subacquei",
        iso24802: "Formazione istruttori",
        iso11121: "Discovery diving",
        iso21416: "Eco-sostenibilità",
        iso21417: "Sensibiliz. ambientale",
        iso24804: "Rebreather (5 livelli)",
        iso11107: "Nitrox / EAN",
      },
      law9title: "Legge 26 gennaio 2026 n. 9",
      law9desc: "Sicurezza e governance delle attività subacquee professionali (OTS/iperbarici). Libretto personale informatico.",
      law70title: "Legge 7 maggio 2026 n. 70",
      law70desc: "Valorizzazione della risorsa mare. Registro pre/post immersione, rapporto istruttori 6:1, certificati medici obbligatori.",
      f1: "Registro pre/post immersione conforme alla Legge 70/2026 art. 11-12",
      f2: "Monitoraggio rapporto istruttori 6:1 con alert automatici",
      f3: "Verifica certificati medici validi al check-in del partecipante",
      f4: "Export dati strutturato per ispezioni delle autorità competenti",
      f5: "Conformità GDPR per tutti i dati sanitari e personali",
      f6: "Supporto standard rebreather ISO 24804-24808 (2022-2024)",
      cta: "Scopri come eDive protegge la tua attività",
    },
  },
  dc: {
    // P3: etichette leggibili per IncidentSeverity del backend
    // (MINOR/MODERATE/SERIOUS/CRITICAL). Varianti m/f perche' concordano con
    // diversi sostantivi ("incidente lieve" vs "severita' minore").
    incidentSeverity: {
      MINOR:    "Lieve",
      MODERATE: "Moderato",
      SERIOUS:  "Grave",
      CRITICAL: "Critico",
      "MINOR.f":    "Minore",
      "MODERATE.f": "Moderata",
      "SERIOUS.f":  "Seria",
      "CRITICAL.f": "Critica",
    },
    briefingCreator: {
      title: "Briefing Creator",
      subtitle: "Crea e condividi briefing pre-immersione con il tuo gruppo",
      newBriefing: "Nuovo briefing",
      created: "Briefing creato con successo!",
      shareLink: "Link condivisibile con il gruppo:",
      copyLink: "Copia link",
      copied: "Copiato!",
      myBriefings: "I miei briefing",
      noSite: "Sito non specificato",
      dateTbd: "Data TBD",
      noBriefings: "Nessun briefing creato ancora.",
      createError: "Errore nella creazione del briefing. Riprova.",
      creating: "Creazione...",
      saveAndShare: "Salva e genera link",
      siteSection: "1. Sito e condizioni",
      interestSection: "2. Punti di interesse",
      hazardsSection: "3. Pericoli e avvertenze",
      emergencySection: "4. Piano di emergenza",
      diveSite: "Sito di immersione",
      manualSite: "Oppure inserisci il nome manualmente",
      diveDate: "Data immersione",
      entryType: "Tipo ingresso",
      maxDepth: "Profondità max (m)",
      plannedDur: "Durata prevista (min)",
      current: "Corrente (nodi)",
      visibility: "Visibilità",
      waterTemp: "Temperatura acqua (°C)",
      boat: "Barca",
      shore: "Riva",
      drift: "Drift",
      visExcellent: "Eccellente (>20m)",
      visGood: "Buona (10–20m)",
      visModerate: "Moderata (5–10m)",
      visPoor: "Scarsa (<5m)",
      searchSite: "Cerca sito...",
      select: "Seleziona...",
      markdownDesc: "Descrizione (supporta Markdown)",
      markdownPreview: "Preview Markdown",
      emergencyPreFilled: "Piano di emergenza (pre-compilato con template base)",
      isoModeLabel: "Modalità ISO 24803 — struttura emergenza conforme allo standard",
      isoChamberLabel: "Camera iperbarica più vicina",
      isoChamberPlaceholder: "es. Ospedale Civile, via Roma 1, Napoli — 20 min",
      isoDanLabel: "Contatto DAN / assistenza medica",
      isoExitLabel: "Procedura di uscita di emergenza",
      isoExitPlaceholder: "es. Raduno a prua della barca, segnalare con SMB",
      isoDcsLabel: "Sintomi DCS illustrati ai partecipanti",
      deleteBriefing: "Elimina briefing",
      expBeginner: "Principiante",
      expIntermediate: "Intermedio",
      expAdvanced: "Avanzato",
      expTechnical: "Tecnico",
    },
    briefingShare: {
      loading: "Caricamento briefing...",
      notFound: "Briefing non trovato",
      notFoundDesc: "Il link potrebbe essere scaduto o non valido.",
      preImmersion: "Briefing pre-immersione",
      noSite: "Sito non specificato",
      entryType: "Tipo ingresso",
      maxDepth: "Profondità max",
      plannedDur: "Durata prevista",
      current: "Corrente",
      visibility: "Visibilità",
      waterTemp: "Temperatura acqua",
      minutes: "minuti",
      knots: "nodi",
      pointsOfInterest: "Punti di interesse",
      hazards: "Pericoli e avvertenze",
      emergencyPlan: "Piano di emergenza",
      generatedWith: "Generato con eDive",
      print: "Stampa",
    },
    admin: {
      title: "Amministrazione & Compliance",
      subtitle: "Fatturazione, assicurazioni, registro attività",
      profileTab: "Profilo Centro",
      invoicesTab: "Fatturazione",
      insuranceTab: "Assicurazioni",
      registerTab: "Registro Attività",
      incidentsTab: "Incidenti",
      medcertsTab: "Cert. Medici",
      centerName: "Nome centro",
      address: "Indirizzo",
      phone: "Telefono",
      email: "Email",
      website: "Sito web",
      onlinePayments: "Pagamenti online (Stripe)",
      onlinePaymentsDesc: "Abilita il checkout Stripe per prenotazioni e corsi.",
      paymentsEnabled: "Pagamenti online attivi",
      paymentsDisabled: "Pagamenti online disabilitati",
      saving: "Salvataggio...",
      save: "Salva",
      loading: "Caricamento...",
      loadError: "Errore nel caricamento",
      loadErrorRetry: "Riprova tra qualche momento",
      noCenter: "Nessun centro associato al tuo account.",
      expiredPolicies_one: "{{count}} polizza assicurativa scaduta — rinnova prima della prossima attività",
      expiredPolicies_other: "{{count}} polizze assicurative scadute — rinnova prima della prossima attività",
      activityLog: "Registro Attività",
      allTypes: "Tutti i tipi",
      exportCsv: "Esporta CSV",
      addEntry: "+ Aggiungi Voce",
      noEntries: "Nessuna voce nel registro. Aggiungi la prima voce per iniziare.",
      modalTitle: "Aggiungi Voce al Registro",
      activityType: "Tipo attività",
      description: "Descrizione",
      descRequired: "Descrizione *",
      date: "Data",
      dateRequired: "Data *",
      responsible: "Responsabile",
      additionalNotes: "Note aggiuntive",
      notesPlaceholder: "Dettagli opzionali...",
      addToLog: "Aggiungi al Registro",
      savingBtn: "Salvataggio...",
      incidentLog: "Registro Incidenti",
      reportIncident: "+ Segnala Incidente",
      noIncidents: "Nessun incidente registrato.",
      severity: "Gravità",
      incidentDateTime: "Data/Ora incidente *",
      actionsTaken: "Azioni intraprese",
      recordIncident: "Registra Incidente",
      reportIncidentModal: "Segnala Incidente",
      resolve: "Risolvi",
      newInvoice: "Nuova Fattura",
      customer: "Cliente",
      service: "Servizio",
      amount: "Importo (€)",
      vat: "IVA %",
      issueInvoice: "Emetti Fattura",
      saveDraft: "Salva Bozza",
      paymentMethods: "Metodi di Pagamento Accettati",
      active: "Attivo",
      inactive: "Non attivo",
      totalPolicies: "Polizze totali",
      activePolicies: "Attive",
      expiredPoliciesCount: "Scadute",
      recommendedProviders: "Provider consigliati",
      expiry: "Scadenza",
      expiredPolicies: "{{count}} polizze assicurative scadute",
    },
    analytics: {
      title: "Analytics",
      subtitle: "Performance operativa e andamento economico",
      totalRevenue: "Fatturato totale",
      bookings: "Prenotazioni",
      certifications: "Certificazioni",
      issuedInYear: "emesse nell'anno",
      newCustomers: "Nuovi clienti",
      noKpi: "Dati KPI non disponibili per l'anno selezionato.",
      aiCenter: "Analisi AI del centro",
      poweredBy: "Powered by Claude",
      askPlaceholder: "Chiedi qualcosa ai dati del tuo centro (opzionale)…",
      analyzing: "Analisi…",
      analyze: "Analizza",
      analysisError: "Errore durante l'analisi. Riprova.",
      insights: "Insights",
      opportunities: "Opportunità",
      alerts: "Alert",
      answer: "Risposta",
      monthlyRevenue: "Andamento fatturato mensile (€)",
      noData: "Nessun dato disponibile",
      courseEnrollments: "Iscrizioni ai corsi",
      sessionFillRate: "Tasso di occupazione sessioni",
      occupancyRate: "Tasso occupazione",
    },
    bookings: {
      title: "Lead & Prenotazioni",
      subtitle: "Gestisci richieste, conferme e assegnazione istruttori",
      sessionsTab: "Sessioni & Prenotazioni",
      internalTab: "Gestione Interna",
      preScreening: "Checklist Pre-Screening Cliente",
      certLevel: "Livello brevetto",
      lastDive: "Ultima immersione",
      medicalConditions: "Condizioni mediche",
      equipmentRental: "Noleggio attrezzatura",
      pending: "In attesa",
      confirmed: "Confermate",
      total: "Totali",
      requiresAction: "Richiedono azione",
      session: "Sessione",
      date: "Data",
      status: "Stato",
      cancel: "Annulla",
      notes: "Note:",
      loadError: "Errore nel caricamento",
      loadErrorRetry: "Riprova tra qualche momento",
      noBookings: "Nessuna prenotazione.",
      internalDesc: "Prenotazioni gestite internamente dal centro — assegna istruttori e monitora stati",
      noInternal: "Nessuna prenotazione interna.",
      noInternalHint: "Le prenotazioni interne vengono create dallo staff del centro.",
      dateCol: "Data",
      typeCol: "Tipo",
      statusCol: "Stato",
      priceCol: "Prezzo",
      instructorCol: "Istruttore",
      noInstructor: "— Nessun istruttore —",
      paid: "Pagato",
      pay: "Paga",
      bookingRef: "Prenotazione #{{id}}",
      confirm: "Conferma",
      confirmError: "Impossibile confermare",
      diver: "Sub",
      incomingRequests: "Richieste in arrivo",
      reject: "Rifiuta",
      requestConfirmed: "Prenotazione confermata",
    },
    calendar: {
      title: "Calendario immersioni",
      subtitle: "Pianifica e gestisci le uscite del centro",
      newDive: "Nuova immersione",
      today: "Oggi",
      add: "Aggiungi",
      noDives: "Nessuna immersione programmata — clicca per aggiungerne una",
      scheduled: "Programmata",
      inProgress: "In corso",
      completed: "Completata",
      cancelled: "Annullata",
      boat: "Barca",
      shore: "Riva",
      recreational: "Ricreativa",
      technical: "Tecnica",
      ccr: "CCR",
      sidemount: "Sidemount",
      typeRecreational: "Ricreativa",
      typeTechnical: "Tecnica",
      typeCCR: "CCR",
      typeSidemount: "Sidemount",
      newDiveModal: "Nuova immersione",
      dateRequired: "Data *",
      tripType: "Tipo uscita",
      titleOptional: "Titolo (opzionale)",
      diveSite: "Sito d'immersione",
      vessel: "Imbarcazione",
      departureTime: "Orario partenza",
      returnTime: "Orario rientro est.",
      diveType: "Tipo immersione",
      maxDepth: "Profondità max (m)",
      maxParticipants: "Max partecipanti",
      mandatory: "Obbligatorio",
      savingDive: "Salvataggio…",
      createDive: "Crea immersione",
      status: "Stato",
      outingType: "Tipo uscita",
      vessel2: "Imbarcazione",
      site: "Sito",
      diveType2: "Tipo immersione",
      maxDepth2: "Profondità max",
      times: "Orari",
      capacity: "Capienza",
      notes2: "Note",
      participants: "Partecipanti ({{count}})",
      updateStatus: "Aggiorna stato",
      markInProgress: "Segna in corso",
      markCompleted: "Segna completata",
      cancelOuting: "Annulla uscita",
      acknowledgeBriefing: "Conferma ricezione briefing (ISO 24803)",
      ecoAwareness: "Sensibilizzazione ambientale confermata (ISO 21417)",
      ecoCodeSign: "Registra la firma del codice di condotta ambientale",
      ecoCodeSigned: "Codice di condotta ambientale firmato",
      ecoCodePrompt: "Nome di chi firma il codice di condotta ambientale",
      ecoCodeError: "Firma non registrata.",
      deleteConfirm: "Eliminare questa immersione?",
      delete: "Elimina",
      scheduledDive: "Immersione programmata",
      selectVessel: "— Seleziona barca —",
      addParticipant: "Aggiungi partecipante",
      participantAdded: "Partecipante aggiunto",
      participantName: "Nome partecipante",
      ratioExceeded: "Rapporto 6:1 superato (L.70/2026 Art.11)",
    },
    compliance: {
      tabEquipment: "Scadenze Attrezzatura",
      tabStaff: "Certificati Staff",
      tabIncidents: "Incidenti",
      tabDocuments: "Documenti Legali",
      tabMedicalPolicy: "Idoneità Medica",
      equipmentTab: "Scadenze Attrezzatura",
      staffTab: "Certificati Staff",
      incidentsTab: "Incidenti",
      documentsTab: "Documenti Legali",
      equipmentTitle: "Attrezzatura — prossime manutenzioni",
      type: "Tipo",
      typeCol: "Tipo",
      brandModel: "Marca / Modello",
      serial: "Seriale",
      statusCol: "Stato",
      nextService: "Prossima manutenzione",
      nextMaintenance: "Prossima manutenzione",
      noEquipment: "Nessuna attrezzatura registrata",
      noneRegistered: "Nessuna attrezzatura registrata",
      tanksTitle: "Bombole — prossime revisioni idrostatiche",
      noTanks: "Nessuna bombola registrata",
      volume: "Volume",
      material: "Materiale",
      lastHydro: "Ultima idro",
      nextHydro: "Prossima idro",
      noActiveStaff: "Nessun membro dello staff attivo.",
      noStaff: "Nessun membro dello staff attivo.",
      noCerts: "Nessuna certificazione registrata",
      rcComplianceNote: "Tutti gli istruttori devono avere un'assicurazione RC professionale valida (L.70/2026). Verificare lo stato per ogni istruttore.",
      rcMissing: "RC mancante",
      rcExpired: "RC scaduta",
      rcExpiringSoon: "RC scade in {{days}}gg",
      rcValid: "RC valida",
      reportTitle: "Report Conformità L.70/2026",
      generateReport: "Genera Report",
      complianceScore: "Score conformità",
      reportTotalDives: "Immersioni",
      reportBriefingPct: "Briefing confermati",
      reportEcoPct: "Eco-consapevolezza (ISO 21417)",
      reportStaff: "Staff attivo",
      reportIncidents: "Incidenti",
      reportExpiredDocs: "Doc. scaduti",
      reportOverdueEq: "Attrezzatura scaduta",
      since: "Da",
      newIncident: "Nuovo incidente",
      registerIncident: "Registra incidente",
      recordIncident: "Registra incidente",
      severity: "Gravità",
      dateTime: "Data e ora",
      description: "Descrizione",
      actionsTaken: "Azioni intraprese",
      register: "Registra",
      noIncidents: "Nessun incidente registrato.",
      addDocument: "Aggiungi documento",
      newDocument: "Nuovo documento",
      titleNumber: "Titolo / Numero",
      titleNum: "Titolo / Numero",
      issuedAt: "Data rilascio",
      issueDate: "Data rilascio",
      expiresAt: "Scadenza",
      expiry: "Scadenza",
      issuedBy: "Ente rilasciante",
      issuingBody: "Ente rilasciante",
      issuedByLabel: "Ente",
      issuedAtLabel: "Rilascio",
      expiresAtLabel: "Scad.",
      add: "Aggiungi",
      noDocuments: "Nessun documento registrato.",
      expired: "scaduto",
      daysShort: "gg",
      issueInfo: "Rilascio",
      expiryInfo: "Scad.",
      loading: "Caricamento…",
      docBoatLicense: "Licenza imbarcazione",
      docLiabilityInsurance: "Assicurazione RC",
      docDiveCenterLicense: "Licenza centro diving",
      docFirstAidCert: "Cert. primo soccorso",
      docSafetyCert: "Cert. sicurezza",
      docTaxDocument: "Documento fiscale",
      docOther: "Altro",
      ecoAwarenessInfo: "Percentuale immersioni in zone MPA con checklist eco completata.",
      ecoPracticesInfo: "Incidenti ambientali registrati, uso materiali certificati, formazione eco-awareness.",
      ecoScore: "Eco-score",
      ecoScoreSub: "Punteggio di sostenibilità ambientale del centro — L.70/2026 art.13",
      ecoScoreTitle: "Eco-Sostenibilità ISO 21416/21417",
      mpaComplianceInfo: "Rispetto delle norme MPA e siti di interesse culturale sommerso.",
      registerExportBtn: "Scarica CSV",
      registerExportSub: "CSV strutturato per ispezioni autorità competenti — Art. 11-12",
      registerExportTitle: "Esporta Registro Immersioni (L.70/2026)",
      reportRcInsurance: "RC Assicurazione Istruttori",
    },
    courses: {
      issueCertModal: "Emetti Certificazione",
      issuingFor: "Stai per emettere la certificazione per l'iscrizione",
      certNumber: "Numero Brevetto (opzionale)",
      certNumberPlaceholder: "es. PADI-2026-IT-044892",
      cancel: "Annulla",
      issuing: "Emissione...",
      issueCert: "Emetti Brevetto",
    },
    customers: {
      searchPlaceholder: "Cerca subacqueo per nome…",
    },
    invoices: {
      title: "Fatturazione Elettronica",
      subtitle: "Gestione fatture FatturaPA",
      newInvoice: "Nuova Fattura",
      draft: "Bozza",
      issued: "Emessa",
      sent: "Inviata",
      paid: "Pagata",
      allStatuses: "Tutti gli stati",
      loading: "Caricamento...",
      noInvoices: "Nessuna fattura trovata",
      numberCol: "Numero",
      customerCol: "Cliente",
      dateCol: "Data",
      totalCol: "Totale",
      statusCol: "Stato",
      actionsCol: "Azioni",
      issue: "Emetti",
      markPaid: "Segna pagata",
      invoiceNumber: "Numero Fattura",
      customerName: "Nome Cliente *",
      vatCode: "P.IVA",
      fiscalCode: "Codice Fiscale",
      sdiCode: "Codice SDI",
      address: "Indirizzo",
      pec: "PEC",
      invoiceLines: "Righe fattura",
      addLine: "+ Aggiungi riga",
      description: "Descrizione",
      subtotal: "Imponibile:",
      vat: "IVA:",
      total: "Totale:",
      cancel: "Annulla",
      saving: "Salvataggio...",
      create: "Crea Fattura",
      remove: "Rimuovi",
      xmlNotAvailable: "XML non disponibile — emetti prima la fattura",
      invoiceCreated: "Fattura creata",
      createError: "Errore creazione fattura",
      issueSuccess: "Fattura emessa",
      issueError: "Errore emissione fattura",
      markPaidSuccess: "Fattura segnata come pagata",
      markPaidError: "Errore aggiornamento stato",
    },
    marketing: {
      title: "Marketing",
    },
    medcerts: {
      title: "Certificati Medici",
      subtitleManager: "Gestisci le richieste di certificato medico per i subacquei",
      subtitleDiver: "Richieste di certificato ricevute dai centri sub",
      pending: "In attesa",
      submitted: "Inviata",
      approved: "Approvata",
      rejected: "Rifiutata",
      all: "Tutte",
      newRequest: "Nuova Richiesta",
      newRequestModal: "Nuova richiesta certificato medico",
      requestSent: "Richiesta inviata",
      sendRequest: "Invia richiesta",
      certType: "Tipo certificato richiesto",
      userId: "User ID",
      userIdPlaceholder: "UUID dell'utente",
      dueDate: "Scadenza richiesta",
      messageOptional: "Messaggio (opzionale)",
      messagePlaceholder: "Istruzioni per il subacqueo…",
      agonistic: "Agonistico",
      nonAgonistic: "Non agonistico",
      selfDeclaration: "Autocertificazione",
      noRequests: "Nessuna richiesta.",
      noRequestsReceived: "Nessuna richiesta di certificato medico ricevuta",
      requestedOn: "Richiesta:",
      expiresOn: "Scade:",
      diverNote: "Nota subacqueo:",
      centerNote: "Nota centro:",
      submit: "Invia certificato",
      confirm: "Conferma",
      approve: "Approva",
      reject: "Rifiuta",
      submittedNotePlaceholder: "Note (es. numero cert, medico…)",
      reviewNotePlaceholder: "Nota per il subacqueo (opzionale)",
      certSubmitted: "Certificato inviato",
      submitError: "Errore nell'invio",
      reviewSaved: "Revisione salvata",
      reviewError: "Errore nella revisione",
      certRequestStepFind: "Trova Sommozzatore",
      certRequestStepTypeDue: "Tipo e Scadenza",
      certRequestStepConfirm: "Conferma",
    },
    pricing: {
      title: "Prezzi Dinamici",
      subtitle: "Regole di pricing per stagione, giorno o periodo",
      newRule: "Nuova Regola",
      newRuleTitle: "Nuova Regola di Pricing",
      editRule: "Modifica Regola",
      noRules: "Nessuna regola configurata",
      active: "Attiva",
      inactive: "Inattiva",
      priorityLabel: "Priorità",
      deleteConfirm: "Eliminare questa regola?",
      ruleUpdated: "Regola aggiornata",
      ruleCreated: "Regola creata",
      ruleDeleted: "Regola eliminata",
      previewError: "Errore nel calcolo anteprima",
      previewTitle: "Anteprima Prezzo",
      previewBasePrice: "Prezzo base (centesimi)",
      previewDate: "Data prenotazione",
      calculating: "Calcolo...",
      calcPrice: "Calcola Prezzo",
      calculatedPrice: "Prezzo calcolato",
      appliedRule: "Regola applicata",
      noRuleApplied: "Nessuna regola applicata",
      daysLabel: "Giorni",
      monthsLabel: "Mesi",
      always: "Sempre",
      daySun: "Dom",
      dayMon: "Lun",
      dayTue: "Mar",
      dayWed: "Mer",
      dayThu: "Gio",
      dayFri: "Ven",
      daySat: "Sab",
      monthJan: "Gen",
      monthFeb: "Feb",
      monthMar: "Mar",
      monthApr: "Apr",
      monthMay: "Mag",
      monthJun: "Giu",
      monthJul: "Lug",
      monthAug: "Ago",
      monthSep: "Set",
      monthOct: "Ott",
      monthNov: "Nov",
      monthDec: "Dic",
      formName: "Nome regola *",
      formNamePlaceholder: "Es. Alta stagione estiva",
      formType: "Tipo di modifica",
      typeMultiplier: "Moltiplicatore (%)",
      typeFixed: "Importo fisso",
      formMultiplierHint: "Moltiplicatore (1.0 = neutro, 1.2 = +20%, 0.8 = -20%)",
      formFixedHint: "Importo fisso aggiuntivo (centesimi)",
      formDaysOfWeek: "Giorni della settimana (vuoto = tutti)",
      formMonthRange: "Limita a intervallo di mesi",
      formPriority: "Priorità",
      formActive: "Regola attiva",
      saving: "Salvataggio...",
      update: "Aggiorna",
      createRule: "Crea Regola",
    },
    rental: {
      title: "Noleggio Attrezzatura",
      subtitle: "Gestione articoli noleggiabili e transazioni",
      newItem: "Nuovo Articolo",
      addItem: "Aggiungi articolo",
      checkout: "Check-out",
      return: "Restituzione",
      available: "Disponibile",
      rented: "In noleggio",
      active: "Attivo",
      overdue: "Scaduto",
      loading: "Caricamento...",
      tabItems: "Articoli disponibili",
      tabTransactions: "Transazioni attive",
      noItems: "Nessun articolo noleggiabile",
      addFirstItem: "Aggiungi il primo articolo",
      noTransactions: "Nessuna transazione attiva",
      colCategory: "Categoria",
      colItem: "Articolo",
      colSize: "Taglia",
      colQty: "Qtà",
      colPriceDay: "€/giorno",
      colStatus: "Stato",
      colCustomer: "Cliente",
      colCheckout: "Check-out",
      colReturnDue: "Restituzione prevista",
      colTotal: "Totale",
      deleteConfirm: "Eliminare questo articolo?",
      itemDeleted: "Articolo eliminato",
      deleteError: "Errore durante l'eliminazione",
      returnRegistered: "Restituzione registrata",
      returnError: "Errore durante la restituzione",
      newItemTitle: "Nuovo articolo noleggiabile",
      formCategory: "Categoria *",
      formBrand: "Marca",
      formModel: "Modello",
      formSize: "Taglia",
      formQuantity: "Quantità",
      formPriceDay: "Prezzo/giorno (€) *",
      formNotes: "Note",
      sizePlaceholder: "S, M, L...",
      priceDayPlaceholder: "es. 15.00",
      formCustomerName: "Nome cliente *",
      formCustomerPlaceholder: "Nome e cognome",
      formReturnDue: "Data restituzione prevista *",
      itemAdded: "Articolo aggiunto",
      saveError: "Errore durante il salvataggio",
      saving: "Salvataggio...",
      addBtn: "Aggiungi",
      checkoutRegistered: "Check-out registrato",
      checkoutError: "Errore durante il check-out",
      checkoutTitle: "Check-out noleggio",
      checkoutItem: "Articolo",
      perDay: "giorno",
      registering: "Registrazione...",
      confirmCheckout: "Conferma check-out",
      catWetsuit: "Muta",
      catBcd: "GAV / BCD",
      catRegulator: "Erogatore",
      catFins: "Pinne",
      catMask: "Maschera",
      catComputer: "Computer",
      catTorch: "Torcia",
      catTank: "Bombola",
      catOther: "Altro",
      maintenanceExpiredWarning: "Attenzione: uno o più articoli tracciati di questa categoria hanno la manutenzione scaduta. Verifica l'attrezzatura prima di procedere.",
      maintenanceSoonWarning: "Nota: alcuni articoli tracciati di questa categoria hanno la manutenzione in scadenza.",
      addItemStepCategory: "Categoria e Articolo",
      addItemStepSizePrice: "Taglia e Prezzi",
      addItemStepNotesConfirm: "Note e Conferma",
      checkoutStepItem: "Articolo",
      checkoutStepCustomerDates: "Cliente e Date",
      checkoutStepConfirm: "Conferma",
    },
    reports: {
      title: "Report & Analisi",
      subtitle: "Fatturato, iscrizioni, tasso di riempimento",
      totalRevenue: "Fatturato totale",
      fromBookings: "Da prenotazioni",
      fromCourses: "Da corsi",
      bookings: "Prenotazioni",
      courses: "Corsi",
      certsIssued: "Brevetti emessi",
      newCustomers: "Nuovi clienti",
      monthlyRevenue: "Fatturato mensile",
      monthlyEnrollments: "Iscrizioni mensili",
      enrolled: "Iscritti",
      completed: "Completati",
      fillRate: "Tasso riempimento barca (%)",
      fillRateNoData: "Dati non disponibili — verifica che le uscite abbiano maxParticipants impostato",
    },
    setup: {
      steps: ["Info base","Posizione & Servizi","Completato"],
      centerName: "Nome centro *",
      phone: "Telefono",
      contactEmail: "Email di contatto",
      website: "Sito web",
      step2Title: "Dove si trova il tuo centro?",
      address: "Indirizzo",
      city: "Città",
      country: "Paese",
      certAgencies: "Agenzie di certificazione (opzionale)",
      services: "Servizi offerti (opzionale)",
      back: "Indietro",
      creating: "Creazione...",
      create: "Crea centro",
      successTitle: "Centro configurato!",
      successDesc: "Hai completato la configurazione base. Esplora la dashboard per gestire prenotazioni, attrezzatura, corsi e molto altro.",
      goToDashboard: "Vai alla dashboard",
      headerTitle: "Configura il tuo centro",
      stepIndicator: "Passo {{step}} di {{total}} — {{name}}",
      step1Desc: "Inserisci le informazioni principali del tuo centro diving. Potrai aggiornarle in qualsiasi momento.",
      step2Desc: "Dove si trova il tuo centro? Quali servizi e agenzie offri?",
      description: "Descrizione breve",
      descriptionPlaceholder: "Descrivi il tuo centro, la tua esperienza e cosa vi distingue...",
      required: "Campo obbligatorio",
      next: "Avanti",
      saveComplete: "Salva e completa",
      saveError: "Errore durante il salvataggio. Riprova.",
      readySuffix: "è pronto!",
      yourCenter: "Il tuo centro",
      serviceOpenWater: "Corsi Open Water",
      serviceAdvanced: "Corsi Advanced",
      serviceRescue: "Rescue Diver",
      serviceDivemaster: "Divemaster",
      serviceInstructor: "Istruttori",
      serviceRental: "Noleggio attrezzatura",
      serviceTanks: "Ricarica bombole",
      serviceBoat: "Uscite in barca",
      serviceNight: "Diving notturno",
      servicePhoto: "Fotografia subacquea",
      serviceTech: "Diving tecnico",
      serviceFreediving: "Freediving",
      featureBookings: "Prenotazioni",
      featureBookingsDesc: "Gestisci lead e sessioni",
      featureCustomers: "Clienti",
      featureCustomersDesc: "Database clienti e docs",
      featureCourses: "Corsi",
      featureCoursesDesc: "Corsi e certificazioni",
      featureEquipment: "Attrezzatura",
      featureEquipmentDesc: "Inventario e manutenzione",
    },
    shifts: {
      title: "Turni Staff",
      subtitleManager: "Pianifica e gestisci i turni",
      subtitleDiver: "I tuoi turni programmati",
      newShift: "Nuovo Turno",
      thisWeek: "Questa settimana",
      today: "Oggi",
      noShifts: "Nessun turno questa settimana",
      shiftCreated: "Turno creato",
      shiftConflict: "Conflitto turni: questo membro dello staff ha già un turno in questo orario.",
      shiftConfirmed: "Turno confermato",
      shiftDeleted: "Turno eliminato",
      confirmDelete: "Eliminare questo turno?",
      confirm: "Conferma",
      addShift: "Aggiungi turno",
      createShift: "Crea turno",
      staffMember: "Membro staff",
      date: "Data",
      startTime: "Inizio",
      endTime: "Fine",
      activity: "Attività",
      activityPlaceholder: "es. Guided dive, Safety diver…",
      scheduled: "Programmati",
      confirmed: "Confermati",
      cancelled: "Cancellati",
    },
    studentProgress: {
      title: "Progressi Studente",
      print: "Stampa",
      session: "Sessione",
      skills: "Competenze",
      noSessions: "Nessuna sessione assegnata.",
      noSkills: "Nessuna competenza per questa sessione.",
      enrolled: "Iscritto",
      loadError: "Impossibile caricare il progresso dello studente.",
      completedSessions: "Sessioni completate",
      passed: "Superate",
      avgScore: "Media punteggio",
      courseProgress: "Avanzamento corso",
      date: "Data",
      score: "Voto",
      result: "Esito",
      courseCompleted: "Corso completato con successo",
      certNumber: "Numero certificato",
      completedOn: "Completato il",
      reportGenerated: "Report generato il",
      skillUpdated: "Skill aggiornata",
      skill_buoyancy_control: "Controllo assetto",
      skill_mask_clearing: "Svuotamento maschera",
      skill_regulator_recovery: "Recupero erogatore",
      skill_fin_pivot: "Pivot con pinne",
      skill_emergency_ascent: "Risalita emergenza",
      skill_weight_removal_replacement: "Rimozione/rimontaggio pesi",
      skill_bcd_oral_inflation: "Gonfiaggio orale GAV",
      skill_navigation: "Navigazione",
      skill_buoyancy_midwater: "Assetto a metà acqua",
      skill_air_sharing: "Condivisione aria",
      skill_controlled_ascent: "Risalita controllata",
      skill_safety_stop: "Sosta sicurezza",
      skill_underwater_compass: "Bussola subacquea",
      skill_tired_diver_tow: "Traino subacqueo",
      skill_quiz_completed: "Quiz completato",
      skill_knowledge_review: "Ripasso conoscenze",
      skill_table_exercises: "Esercizi su tavole",
      skill_written_exam: "Esame scritto",
      skill_practical_exam: "Esame pratico",
      skill_attended: "Presente",
      skill_site_map_reviewed: "Mappa sito revisionata",
      skill_briefing_led: "Briefing condotto",
      skill_debriefing_led: "Debriefing condotto",
      skill_briefing_content_complete: "Briefing completo nei contenuti",
      skill_debriefing_findings_recorded: "Evidenze del debriefing registrate",
      evalTitle: "Valutazione del corso",
      practicalPassed: "Sessioni pratiche superate",
      practicalComplete: "Sessioni pratiche complete",
      practicalRemaining: "Ne mancano {{n}}",
      briefingsLed: "Briefing condotti",
      debriefingsLed: "Debriefing condotti",
      examThreshold: "Soglia dell'esame (standard di agenzia)",
      evalFootnote: "I requisiti arrivano dallo standard di agenzia del corso; se non sono definiti non vengono mostrati.",
    },
    waiver: {
      title: "Autorizzazione pre-immersione",
      signTitle: "Firma liberatoria",
      signSubtitle: "Compila i dati e firma per procedere",
      fullName: "Nome e cognome del subacqueo",
      fullNamePlaceholder: "Mario Rossi",
      template: "Modello liberatoria",
      medicalQuestions: "Dichiarazione medica",
      medicalHonestly: "Risponda onestamente alle seguenti domande.",
      signatureTitle: "Firma",
      confirm: "Conferma e firma",
      submit: "Invia liberatoria firmata",
      submitting: "Invio in corso…",
      signedTitle: "Liberatoria firmata!",
      signedDesc: "La firma è stata registrata correttamente.",
      yes: "Sì",
      no: "No",
      signatureCaptured: "Firma acquisita",
      signHere: "Firma qui sotto per accettare le condizioni",
      resignature: "Rifirma",
      diverData: "Dati del subacqueo",
      templateStandard: "Standard (adulti)",
      templateMinors: "Minori (con consenso genitori)",
      templateAdvanced: "Avanzata (immersioni tecniche)",
      mq_heart_condition: "Condizioni cardiache note?",
      mq_asthma: "Asma o problemi respiratori?",
      mq_diabetes: "Diabete?",
      mq_seizures: "Epilessia o convulsioni?",
      mq_ear_problems: "Problemi alle orecchie o ai seni paranasali?",
      mq_pregnancy: "Gravidanza?",
      mq_medications: "Assunzione di farmaci regolari?",
    },
    authorization: {
      title: "Autorizzazioni pre-immersione",
      subtitle: "Storico dei moduli di autorizzazione firmati.",
      howTo: "Come firmare un'autorizzazione",
      howToDesc: "L'autorizzazione si firma direttamente dalla prenotazione. Vai a <strong>Le mie prenotazioni</strong>, seleziona la prenotazione e premi <strong>\"Autorizza\"</strong> accanto ad essa.",
      goToBookings: "Vai alle prenotazioni",
      previousAuthorizations: "Autorizzazioni precedenti",
      noWaivers: "Nessuna autorizzazione firmata ancora.",
      noWaiversDesc: "Le autorizzazioni firmate dalle prenotazioni appariranno qui.",
      download: "Scarica PDF",
      signed: "Firmata",
    },
    profile: {
      title: "Profilo Centro Diving",
      loading: "Caricamento...",
      noProfile: "Nessun centro diving trovato.",
      bookNow: "Prenota ora",
      sendMessage: "Invia messaggio",
      giftCard: "Gift Card",
      giftCardTitle: "Gift Card",
      giftCardPurchased: "Gift card acquistata!",
      giftCardCode: "Codice gift card",
      giftCardValue: "Valore",
      giftCardNote: "Conserva questo codice. Puoi usarlo al centro durante la prenotazione.",
      giftCardKeep: "Conserva questo codice. Puoi usarlo al centro durante la prenotazione.",
      giftCardError: "Errore durante l'acquisto della gift card",
      giftCardAmount: "Importo",
      giftCardRecipient: "Email destinatario (opzionale)",
      giftCardMessage: "Messaggio (opzionale)",
      giftCardMessagePlaceholder: "Buone immersioni!",
      giftCardBuying: "Acquisto…",
      giftCardBuy: "Acquista",
      buyGiftCard: "Acquista Gift Card",
      recipientEmail: "Email destinatario (opzionale)",
      message: "Messaggio (opzionale)",
      purchase: "Acquista",
      purchasing: "Acquisto...",
      coursesTab: "Corsi",
      reviewsTab: "Recensioni",
      tabOverview: "Panoramica",
      tabCourses: "Corsi",
      tabReviews: "Recensioni",
      noCourses: "Nessun corso disponibile",
      noReviews: "Nessuna recensione",
      beFirst: "Sii il primo a recensire questo centro",
      writeReview: "Scrivi una recensione",
      writeReviewCta: "Scrivi recensione",
      services: "Servizi",
      certifications: "Certificazioni",
      enrollNow: "Iscriviti ora",
      enroll: "Iscriviti al corso",
      enrolled: "Iscritto",
      enrolling: "Iscrizione…",
      enrollSuccess: "Iscrizione completata!",
      enrollError: "Errore iscrizione",
      back: "Indietro",
      explore: "Esplora",
      website: "Sito web",
      staff: "Staff",
      reviewsShort: "rec.",
      review: "recensione",
      reviews: "recensioni",
      centerNotFound: "Centro non trovato",
      yourReview: "Tua",
      verified: "Verificato",
      deleteReviewConfirm: "Eliminare la tua recensione?",
      deleteMyReview: "Elimina la mia recensione",
      reviewDeleted: "Recensione eliminata",
      reviewDeleteError: "Errore durante l'eliminazione",
      ownerReply: "Risposta del centro",
      reviewSubmitted: "Recensione inviata! Sarà visibile dopo approvazione.",
      reviewError: "Errore invio recensione",
      submitting: "Invio…",
      submitReview: "Invia recensione",
      reviewTitlePlaceholder: "Titolo (opzionale)",
      reviewBodyPlaceholder: "Racconta la tua esperienza...",
      statInstructors: "Istruttori",
      statEquipment: "Attrezzatura",
      statTanks: "Bombole",
      statBoats: "Barche",
      diveSitesTitle: "Punti di immersione",
      diveSitesEmpty: "Nessun punto di immersione associato a questo centro.",
      seeCourses: "Vedi corsi",
      contactCenter: "Contatta il centro",
      contactSubject: "Richiesta informazioni",
      days: "gg",
      levelDiscover: "Discover Scuba",
      levelOpenWater: "Open Water",
      levelAdvanced: "Advanced",
      levelRescue: "Rescue",
      levelDivemaster: "Divemaster",
      levelInstructor: "Instructor",
      levelSpecialty: "Specialty",
      levelRebreatherNodeco: "Rebreather No-Deco (ISO 24804)",
      levelRebreatherDeco45: "Rebreather Deco ≤45m (ISO 24805)",
      levelRebreatherDeco60: "Rebreather Deco ≤60m (ISO 24806)",
      levelRebreatherDeco100: "Rebreather Deco ≤100m (ISO 24807)",
      levelRebreatherInstructor: "Istruttore Rebreather (ISO 24808)",
    },
    rebreather: {
      title: "Rebreather",
      subtitle: "Unità CCR/SCR/MCCR con manutenzione ISO 24804-24808",
      noUnits: "Nessuna unità rebreather registrata.",
      addUnit: "Aggiungi Rebreather",
      brand: "Marca",
      model: "Modello",
      serial: "Seriale",
      type: "Tipo",
      lastService: "Ultima manutenzione",
      nextService: "Prossima manutenzione",
      certifiedUntil: "Cert. valida fino",
      notes: "Note",
      save: "Salva",
      saving: "Salvataggio...",
      delete: "Elimina",
      deleteConfirm: "Eliminare questa unità?",
      expired: "Scaduta",
      expiringSoon: "In scadenza",
      valid: "Valida",
    },
    productivity: {
      title: "La mia produttività",
      subtitle: "Storico turni e attività",
      myShifts: "I Miei Turni",
      monthStats: "Statistiche Mensili",
      totalShifts: "Turni effettuati",
      totalHours: "Ore lavorate",
      diveShifts: "Turni immersione",
      distinctActivities: "Attività distinte",
      activityBreakdown: "Ripartizione attività",
      shiftsUnit: "turni",
      shiftDetail: "Dettaglio turni",
      noShiftsMonth: "Nessun turno registrato per {{month}}.",
      noShifts: "Nessun turno questo mese.",
      noCenter: "Non sei associato a nessun centro. Contatta l'amministratore del centro.",
      other: "Altro",
      colDate: "Data",
      colTime: "Orario",
      colActivity: "Attività",
      colDuration: "Durata",
      colStatus: "Stato",
      statusScheduled: "Pianificato",
      statusConfirmed: "Confermato",
      statusCancelled: "Annullato",
      scheduled: "Pianificato",
      confirmed: "Confermato",
      cancelled: "Annullato",
    },
  },
  instructor: {
    requestSent: "Richiesta inviata!",
    requestError: "Errore invio richiesta",
    availabilityUpdated: "Disponibilità aggiornata",
    availabilityError: "Errore aggiornamento",
    profileSaved: "Profilo salvato",
    profileError: "Errore salvataggio",
    dashboard: {
      title: "Dashboard Istruttore",
      overviewTab: "Panoramica",
      studentsTab: "Studenti",
      availabilityTab: "Disponibilità",
      earningsTab: "Guadagni",
      lessonsTab: "Lezioni Private",
      validationsTab: "Validazioni",
      profileTab: "Profilo",
      excursionsTab: "Escursioni",
      validationQueue: "Coda validazioni immersioni",
      noValidations: "Nessuna validazione in attesa.",
      loading: "Caricamento...",
      approve: "Approva",
      reject: "Rifiuta",
      rejectNote: "Nota di rifiuto (opzionale)",
      replySent: "Risposta inviata",
      replyError: "Errore nell'invio",
    },
    publicProfile: {
      back: "Indietro",
      edit: "Modifica profilo",
      requestLesson: "Richiedi lezione privata",
      lessonRequested: "Richiesta inviata!",
      lessonError: "Errore nell'invio",
      requestModal: "Richiedi lezione privata",
      requestedDate: "Data richiesta *",
      duration: "Durata (min)",
      level: "Livello",
      goals: "Obiettivi",
      notes: "Note",
      location: "Luogo",
      sending: "Invio...",
      send: "Invia richiesta",
      beginner: "Principiante",
      intermediate: "Intermedio",
      advanced: "Avanzato",
      technical: "Tecnico",
      noProfile: "Profilo non trovato.",
      loading: "Caricamento...",
      availability: "Disponibilità",
      available: "Disponibile",
      bio: "Biografia",
      contact: "Contatta",
      contactDesc: "Scrivi due righe di presentazione: l'istruttore riceverà il tuo messaggio e ti risponderà appena possibile.",
      contactPlaceholder: "Presentati e racconta cosa vorresti imparare…",
      contactTitle: "Contatta l'istruttore",
      dayFri: "Ven",
      dayMon: "Lun",
      daySat: "Sab",
      daySun: "Dom",
      dayThu: "Gio",
      dayTue: "Mar",
      dayWed: "Mer",
      defaultName: "Istruttore",
      goalsPlaceholder: "Es. migliorare l'assetto, prepararmi al brevetto Advanced…",
      locationPlaceholder: "Es. piscina, mare, centro immersioni…",
      notesPlaceholder: "Eventuali note o richieste particolari (facoltativo)",
      onlineLessons: "Lezioni online",
      perDay: "giorno",
      rateOnRequest: "Tariffa su richiesta",
      specialties: "Specialità",
      students: "allievi",
      teaching: "di insegnamento",
      teachingLangs: "Lingue di insegnamento",
      unavailable: "Non disponibile",
    },
    lessons: {
      title: "Lezioni Private",
      subtitleInstructor: "Gestisci le richieste di lezione dai subacquei",
      subtitleDiver: "Richiedi e gestisci le tue lezioni private",
      filterAll: "Tutte",
      filterPending: "In attesa",
      filterAccepted: "Accettate",
      filterCompleted: "Completate",
      filterDeclined: "Rifiutate",
      noLessons: "Nessuna lezione trovata.",
      noLessonsHint: "Trova un istruttore nella directory e invia una richiesta.",
      respondTitle: "Rispondi alla richiesta",
      accept: "Accetta",
      reject: "Rifiuta",
      accepted: "Richiesta accettata",
      declined: "Richiesta rifiutata",
      respondError: "Errore nell'invio della risposta",
      priceLabel: "Prezzo concordato (€)",
      pricePlaceholder: "es. 80.00",
      noteLabel: "Nota di risposta",
      notePlaceholder: "Messaggio per il subacqueo...",
      goalsLabel: "Obiettivi",
      respond: "Rispondi",
      markCompleted: "Segna come completata",
      completed: "Lezione segnata come completata",
      cancelled: "Lezione annullata",
      cancelConfirm: "Annullare questa lezione?",
      cancelBtn: "Annulla lezione",
      levelBeginner: "Principiante",
      levelIntermediate: "Intermedio",
      levelAdvanced: "Avanzato",
      levelTechnical: "Tecnico",
      statusPENDING: "In attesa",
      statusACCEPTED: "Accettata",
      statusDECLINED: "Rifiutata",
      statusCOMPLETED: "Completata",
      statusCANCELLED: "Annullata",
    },
  },
  myCertifications: {
    pageTitle: "I Miei Brevetti",
    pageDesc: "Carica e monitora i tuoi brevetti subacquei. I brevetti verificati sbloccano i ruoli professionali.",
    addBtn: "Carica un brevetto",
    emptyTitle: "Nessun brevetto caricato",
    emptyDesc: "Carica il tuo primo brevetto per sbloccare le funzionalità da istruttore o divemaster.",
    loading: "Caricamento…",
    statusPending: "In revisione",
    statusVerified: "Verificato",
    statusRejected: "Rifiutato",
    statusExpired: "Scaduto",
    unlocksRole: "Sblocca: {{role}}",
    noRole: "Nessun sblocco ruolo",
    certNumber: "N° {{number}}",
    noCertNumber: "Nessun numero certificato",
    expiresAt: "Scade: {{date}}",
    noExpiry: "Nessuna scadenza",
    rejectedReason: "Motivazione: {{reason}}",
    form: {
      title: "Carica un nuovo brevetto",
      agency: "Ente certificatore *",
      agencyPlaceholder: "es. PADI, SSI, CMAS",
      certCode: "Codice brevetto *",
      certCodePlaceholder: "es. OW, AOW, DM",
      certName: "Nome brevetto *",
      certNamePlaceholder: "es. Open Water Diver",
      certNumber: "Numero certificato (opzionale)",
      certNumberPlaceholder: "es. 12345678",
      imageUrl: "URL immagine (foto della tessera) *",
      imageUrlPlaceholder: "https://…/brevetto.jpg",
      expiresAt: "Data di scadenza (se prevista)",
      submit: "Invia per revisione",
      submitting: "Invio…",
      cancel: "Annulla",
      success: "Brevetto inviato — sarà revisionato dal nostro team.",
      error: "Errore nell'invio del brevetto",
    },
  },
  agency: {
    bookings: {
      title: "Prenotazioni Ricevute",
      subtitle: "Gestisci le prenotazioni dei tuoi pacchetti viaggio",
      all: "Tutte",
      filterAll: "Tutte",
      pending: "In attesa",
      confirmed: "Confermata",
      cancelled: "Cancellata",
      noBookings: "Nessuna prenotazione.",
      noBookingsFilter: "Nessuna prenotazione con questo stato.",
      loading: "Caricamento...",
      updated: "Prenotazione aggiornata",
      updateError: "Errore aggiornamento",
      confirm: "Conferma",
      reject: "Rifiuta",
      confirmBtn: "Conferma",
      cancelBtn: "Annulla",
      dateCol: "Data",
      packageCol: "Pacchetto",
      clientCol: "Cliente",
      statusCol: "Stato",
      actionsCol: "Azioni",
      notes: "Note",
      statusPending: "In attesa",
      statusConfirmed: "Confermata",
      statusCancelled: "Cancellata",
      statusCompleted: "Completata",
      participant: "partecipante",
      participants: "partecipanti",
      receivedOn: "Ricevuta il",
    },
    packages: {
      title: "Pacchetti Viaggio",
      subtitle: "Crea e gestisci i tuoi pacchetti diving",
      newPackage: "Nuovo Pacchetto",
      editPackage: "Modifica Pacchetto",
      noPackages: "Nessun pacchetto ancora. Crea il primo!",
      noAgency: "Devi prima creare il profilo della tua agenzia.",
      goToAgency: "Vai alla dashboard agenzia",
      managePackagesOf: "Gestisci i pacchetti di",
      created: "Pacchetto creato",
      updated: "Pacchetto aggiornato",
      deleted: "Pacchetto disattivato",
      createError: "Errore creazione pacchetto",
      updateError: "Errore aggiornamento",
      deleteError: "Errore eliminazione",
      confirmDelete: "Eliminare questo pacchetto?",
      includes: "Include",
      loading: "Caricamento...",
      active: "Attivo",
      inactive: "Disattivo",
      deactivate: "Disattiva",
      days: "giorni",
      perPerson: "persona",
      departure: "Partenza",
      saveChanges: "Salva modifiche",
      createPackage: "Crea pacchetto",
      required: "Campo obbligatorio",
      formTitle: "Titolo *",
      formCountry: "Paese destinazione *",
      formCity: "Città destinazione",
      formDescription: "Descrizione",
      formDuration: "Durata (giorni) *",
      formMaxParticipants: "Max partecipanti",
      formPrice: "Prezzo (€) *",
      formDeparture: "Data partenza",
      formDivesIncluded: "Immersioni incluse",
      formMinCert: "Cert. minima richiesta",
      formImage: "Immagine",
      uploadImage: "Carica immagine",
      imageUploadError: "Errore caricamento immagine",
      incFlights: "Voli",
      incHotel: "Hotel",
      incDives: "Immersioni",
      incEquipment: "Attrezzatura",
      incTransfer: "Transfer",
      incInstructor: "Istruttore",
      incMeals: "Pasti",
      titlePlaceholder: "Es. Settimana Maldive",
      countryPlaceholder: "MV",
      cityPlaceholder: "Malé",
      pricePlaceholder: "1500",
      divesIncludedPlaceholder: "10",
      minCertPlaceholder: "Es. PADI Open Water",
    },
    myAgency: {
      title: "La Mia Agenzia",
      noAgency: "Nessuna agenzia registrata ancora.",
      createAgency: "Crea Agenzia",
      editAgency: "Modifica Agenzia",
      agencyName: "Nome agenzia *",
      country: "Paese *",
      city: "Città",
      description: "Descrizione",
      website: "Sito web",
      phone: "Telefono",
      email: "Email",
      save: "Salva",
      saving: "Salvataggio...",
      cancel: "Annulla",
      created: "Agenzia creata",
      updated: "Agenzia aggiornata",
      createError: "Errore creazione agenzia",
      updateError: "Errore aggiornamento",
      required: "Campo obbligatorio",
      packagesLink: "Gestisci pacchetti",
      bookingsLink: "Vedi prenotazioni",
      stats: "Statistiche",
      subtitle: "Gestisci il profilo della tua agenzia di viaggi e i pacchetti",
      createYourAgency: "Crea la tua agenzia",
      saveChanges: "Salva modifiche",
      verified: "Verificata",
      activePackages: "Pacchetti attivi",
      noPackages: "Nessun pacchetto ancora",
      createFirstPackage: "Crea il primo pacchetto",
      days: "giorni",
      active: "Attivo",
      inactive: "Inattivo",
      seeAllPackages: "Vedi tutti i pacchetti",
      descriptionPlaceholder: "Breve descrizione della tua agenzia e specializzazioni...",
      namePlaceholder: "Es. Blu Profondo Travel",
      countryPlaceholder: "IT",
      cityPlaceholder: "Roma",
      websitePlaceholder: "https://...",
      legalName: "Ragione sociale",
      legalNamePlaceholder: "Es. Blu Profondo Travel S.r.l.",
      vatNumber: "Partita IVA",
      vatNumberPlaceholder: "IT12345678901",
      iban: "IBAN per gli incassi",
      ibanPlaceholder: "IT60X0542811101000000123456",
      ibanSet: "IBAN registrato",
      ibanHint: "Usato solo per accreditare gli incassi delle prenotazioni. Non viene mai mostrato dopo il salvataggio.",
      fiscalSectionTitle: "Dati fiscali e pagamento",
      statusPending: "In attesa di verifica",
      statusPendingDesc: "Un amministratore deve approvare la tua agenzia prima che i pacchetti compaiano nel catalogo pubblico. Puoi comunque prepararli fin da ora.",
      statusRejected: "Verifica rifiutata",
      statusRejectedReason: "Motivo",
      statusVerified: "Verificata",
      statsTitle: "Statistiche vendite",
      statsTotalRevenue: "Incassato totale",
      statsRevenue30d: "Incassato (30 giorni)",
      statsBookings30d: "Prenotazioni (30 giorni)",
      statsActivePackages: "Pacchetti attivi",
      statsByStatus: "Prenotazioni per stato",
    },
    myBookings: {
      title: "Le mie prenotazioni viaggio",
      subtitle: "Pacchetti prenotati presso i Tour Operator",
      empty: "Nessuna prenotazione ancora",
      participants: "partecipanti",
      paid: "Pagato",
      pay: "Paga ora",
      cancel: "Annulla",
      cancelled: "Prenotazione annullata",
      cancelError: "Errore durante l'annullamento",
      checkoutError: "Errore durante l'avvio del pagamento",
    },
  },
  agencyAdmin: {
    title: "Verifica Tour Operator",
    subtitle: "Approva o rifiuta le agenzie in attesa prima che possano vendere",
    tabPending: "In attesa",
    tabVerified: "Verificate",
    tabRejected: "Rifiutate",
    empty: "Nessuna agenzia in questa categoria",
    verify: "Approva",
    reject: "Rifiuta",
    verified: "Agenzia approvata",
    rejected: "Agenzia rifiutata",
    rejectPrompt: "Motivo del rifiuto",
    rejectPlaceholder: "Es. dati fiscali mancanti o incompleti",
    rejectConfirm: "Conferma rifiuto",
    cancel: "Annulla",
    requestedOn: "Richiesta il",
    vatNumber: "P.IVA",
    hasIban: "IBAN fornito",
    noIban: "IBAN mancante",
  },
  contatti: {
    badge: "Contatti",
    h1: "Parliamo",
    subtitle: "Hai domande, feedback o vuoi collaborare con noi? Siamo sempre disponibili.",
    info: "Informazioni",
    phone: "Telefono",
    hours: "Lun–Ven 9:00–18:00",
    office: "Sede",
    officeLocation: "Italia",
    supportHours: "Orari supporto",
    responseTime: "Risposta entro 24h",
    priorityTitle: "Supporto prioritario",
    priorityDesc: "Gli utenti Pro e Centro ricevono assistenza dedicata con risposta garantita entro 4 ore.",
    priorityLink: "Accedi all'app per il supporto prioritario →",
    name: "Nome",
    namePlaceholder: "Mario Rossi",
    topic: "Argomento",
    topicPlaceholder: "Seleziona argomento",
    message: "Messaggio",
    messagePlaceholder: "Descrivi la tua richiesta...",
    send: "Invia messaggio",
    sending: "Invio in corso...",
    privacyNote: "Inviando accetti la nostra",
    messageSent: "Messaggio inviato!",
    messageSentDesc: "Ti risponderemo entro 24 ore all'indirizzo email indicato.",
    sendError: "Invio non riuscito. Riprova o scrivi a support@edive.tech",
    topics: {
      techSupport: "Supporto tecnico",
      plans: "Informazioni sui piani",
      partnership: "Partnership",
      press: "Press e media",
      feedback: "Feedback e suggerimenti",
      bugReport: "Segnalazione bug",
      other: "Altro",
    },
  },
  public: {
    chiSiamo: {
      badge: "Chi siamo",
      h1a: "Nati sott'acqua,",
      h1b: "cresciuti nel digitale",
      subtitle: "eDive nasce dalla frustrazione di subacquei che cercavano uno strumento moderno, completo e bello per documentare le proprie immersioni. Non trovandolo, lo abbiamo costruito.",
      missionTitle: "La nostra missione",
      mission1: "Rendiamo l'esperienza subacquea più sicura, connessa e memorabile per ogni tipo di sub: dal principiante che fa il suo primo corso, al tecnico che esplora relitti a 90 metri, fino all'istruttore che forma la prossima generazione.",
      mission2: "Vogliamo costruire la piattaforma di riferimento per la community subacquea mondiale, partendo dall'Italia con una visione globale.",
      statYear: "Anno di fondazione",
      statHq: "Headquarter",
      statUsers: "Utenti attivi",
      statCountries: "Paesi raggiungibili",
      valuesTitle: "I nostri valori",
      valPassion: "Passione",
      valPassionDesc: "Siamo subacquei prima di essere sviluppatori. Ogni funzionalità nasce da un'esigenza reale vissuta sott'acqua.",
      valCommunity: "Community",
      valCommunityDesc: "Crediamo nel potere della condivisione. eDive esiste perché i subacquei si aiutano a vicenda.",
      valSafety: "Sicurezza",
      valSafetyDesc: "La sicurezza subacquea è al centro di ogni scelta progettuale. I tuoi dati e la tua incolumità vengono prima di tutto.",
      valInnovation: "Innovazione",
      valInnovationDesc: "Integriamo le tecnologie più avanzate — AI, IoT, blockchain — per portare il futuro nell'esperienza subacquea.",
      teamTitle: "Il team",
      ctaTitle: "Unisciti alla community eDive",
      ctaSubtitle: "Siamo in costante crescita e cerchiamo persone appassionate.",
      ctaRegister: "Registrati",
      ctaContact: "Contattaci",
    },
    funzionalita: {
      badge: "Tutto in un'unica piattaforma",
      h1a: "Ogni funzionalità che un",
      h1b: "subacqueo moderno",
      h1c: "ha bisogno",
      subtitle: "Dal logbook digitale all'AI assistant, dalla community globale alla gestione medica. eDive centralizza tutto il tuo mondo subacqueo in un ecosistema integrato.",
      startFree: "Inizia gratis",
      gridTitle: "16 moduli integrati",
      gridSubtitle: "Ogni funzione comunica con le altre. Un ecosistema coerente, non un insieme di app separate.",
      ctaTitle: "Pronto a immergerti?",
      ctaSubtitle: "Unisciti alla community. Gratuito, sempre.",
      ctaCreate: "Crea account gratuito",
      ctaInstructor: "Sei un istruttore?",
      features: {
        logbook: {
          title: "Logbook digitale",
          desc: "Registra ogni immersione con dati completi: profilo, temperatura, visibilità, gas, attrezzatura e note. Importa da Shearwater, UDDF, CSV e altri formati.",
        },
        map: {
          title: "Mappa siti globale",
          desc: "Scopri migliaia di siti in tutto il mondo con filtri per tipologia, difficoltà e profondità. Proponi nuovi siti e contribuisci alla community.",
        },
        courses: {
          title: "Corsi e certificazioni",
          desc: "Accedi al catalogo completo di corsi PADI, SSI, CMAS, TDI e molto altro. Tieni traccia delle tue certificazioni e progressi di apprendimento.",
        },
        ai: {
          title: "Assistente AI",
          desc: "Il tuo assistente personale per domande tecniche, pianificazione immersioni, meteo e consigli su attrezzatura. Alimentato dai modelli più avanzati.",
        },
        community: {
          title: "Community globale",
          desc: "Connettiti con subacquei da tutto il mondo. Segui altri appassionati, condividi immersioni, scopri buddy e partecipa a eventi locali.",
        },
        planning: {
          title: "Pianificazione",
          desc: "Organizza le tue uscite con il calendario integrato. Gestisci slot, invita amici, verifica le condizioni meteo e sincronizza con il tuo agenda.",
        },
        chat: {
          title: "Chat e notifiche",
          desc: "Comunicazione in tempo reale con messaggistica diretta, chat di gruppo e notifiche push per non perderti nessun aggiornamento.",
        },
        marketplace: {
          title: "Marketplace",
          desc: "Compra e vendi attrezzatura subacquea usata in sicurezza. Annunci verificati, messaggistica integrata e profili affidabili.",
        },
        insurance: {
          title: "Assicurazioni",
          desc: "Gestisci le tue polizze assicurative per le immersioni. Storico dei sinistri, rinnovi automatici e accesso alle condizioni in un click.",
        },
        media: {
          title: "Galleria media",
          desc: "Archivia foto e video delle tue immersioni con editor integrato. Filtri, crop, ottimizzazione e importazione diretta da GoPro.",
        },
        achievements: {
          title: "Achievement e badge",
          desc: "Sblocca traguardi, accumula punti e costruisci il tuo profilo da subacqueo esperto. Badge condivisibili e classifiche della community.",
        },
        medical: {
          title: "Gestione medica",
          desc: "Archivia in modo sicuro e conforme GDPR i tuoi dati sanitari rilevanti per le immersioni: certificati medici, idoneità, farmaci.",
        },
        tourism: {
          title: "Turismo subacqueo",
          desc: "Scopri destinazioni, pacchetti viaggio e resort specializzati. Prenotazioni direttamente dalla piattaforma con consulenza AI.",
        },
        kyc: {
          title: "KYC e identità",
          desc: "Verifica della tua identità per un ecosistema sicuro. Documenti protetti, certificazioni verificate e profilo affidabile per la community.",
        },
        associations: {
          title: "Associazioni e clubs",
          desc: "Iscriviti a club subacquei, associazioni locali e nazionali. Accedi a vantaggi esclusivi, eventi riservati e shop dei soci.",
        },
        analytics: {
          title: "Analytics personali",
          desc: "Dashboard con le tue statistiche: immersioni per mese, profondità media, paesi visitati, specie avvistate e molto altro.",
        },
      },
    },
    perCentri: {
      badge: "Per Centri Immersione",
      h1a: "Gestisci il tuo centro",
      h1b: "in modo intelligente",
      subtitle: "Da piccoli dive shop a grandi resort: eDive si adatta alle tue esigenze con strumenti professionali per prenotazioni, clienti, attrezzatura e molto altro.",
      startFree: "Inizia gratis",
      seePrices: "Vedi i prezzi",
      featuresTitle: "Tutto in un'unica piattaforma",
      featuresSubtitle: "Smetti di usare fogli Excel, calendari separati e software che non si parlano tra loro.",
      stat1value: "1.200+",
      stat1label: "Centri partner",
      stat2value: "-40%",
      stat2label: "No-show con booking online",
      stat3value: "3h",
      stat3label: "Risparmio admin/settimana",
      stat4value: "4.8/5",
      stat4label: "Soddisfazione centri",
      ctaTitle: "Pronto a digitalizzare il tuo centro?",
      ctaSubtitle: "Inizia con il piano gratuito. Nessuna carta di credito richiesta.",
      ctaRegister: "Registra il tuo centro",
    },
    perIstruttori: {
      badge: "Per Istruttori",
      h1a: "Strumenti professionali",
      h1b: "per istruttori subacquei",
      subtitle: "Gestisci i tuoi studenti, organizza corsi, tieni il registro didattico e fai crescere la tua attività professionale con eDive.",
      startFree: "Inizia gratis",
      seeFeatures: "Scopri tutte le funzionalità",
      benefitsTitle: "Tutto quello che ti serve come istruttore",
      benefitsSubtitle: "Una suite completa progettata con istruttori certificati di ogni ente per semplificare la tua attività.",
      certsTitle: "Compatibile con tutti gli enti di certificazione",
      certsSubtitle: "eDive supporta oltre 200 certificazioni da tutti i principali enti internazionali.",
      ctaTitle: "Porta la tua didattica al livello successivo",
      ctaSubtitle: "Registrati gratuitamente e inizia a gestire i tuoi studenti con eDive.",
      ctaStart: "Inizia gratis",
      benefits: {
        courses: {
          title: "Gestione corsi avanzata",
          desc: "Crea e gestisci corsi di ogni livello con materiale didattico integrato, progressioni automatiche e tracking delle competenze per ogni studente.",
        },
        students: {
          title: "Rubrica studenti",
          desc: "Profili completi per ogni studente con storico corsi, certificazioni, logbook e note personali. Monitora l'avanzamento in tempo reale.",
        },
        calendar: {
          title: "Calendario lezioni",
          desc: "Organizza sessioni teoriche e pratiche con il calendario integrato. Gestisci disponibilità, invita studenti e ricevi conferme automatiche.",
        },
        logbook: {
          title: "Registro di bordo digitale",
          desc: "Tieni traccia di ogni immersione didattica con firma digitale degli studenti, condizioni, obiettivi raggiunti e note di valutazione.",
        },
        analytics: {
          title: "Analytics didattici",
          desc: "Visualizza statistiche sui tuoi studenti, tasso di completamento corsi, immersioni per livello e progressi nel tempo.",
        },
        comms: {
          title: "Comunicazione integrata",
          desc: "Messaggia con studenti e colleghi direttamente in app. Canali dedicati per ogni corso con condivisione materiali e annunci.",
        },
        compliance: {
          title: "Documenti e conformità",
          desc: "Archivia liberatorie, referti medici e certificazioni in modo sicuro. Alert automatici per scadenze e rinnovi.",
        },
        reputation: {
          title: "Reputazione e recensioni",
          desc: "Costruisci il tuo profilo professionale con le recensioni dei tuoi studenti. Visibilità nella rete eDive per attrarre nuovi allievi.",
        },
      },
    },
    prezzi: {
      badge: "Prezzi",
      h1: "Semplice e trasparente",
      subtitle: "Nessuna sorpresa. Nessun costo nascosto. Inizia gratis, aggiorna quando vuoi.",
      currentPlan: "Piano attuale",
      managing: "Gestisci abbonamento",
      redirecting: "Reindirizzamento...",
      faqTitle: "Domande frequenti",
      ctaTitle: "Hai ancora dubbi?",
      ctaSubtitle: "Parla con il nostro team. Siamo qui per aiutarti a scegliere il piano giusto.",
      ctaContact: "Contattaci",
      checkoutError: "Errore durante il checkout. Riprova.",
      perSempre: "per sempre",
      alMese: "al mese",
      badgePro: "Più scelto",
      badgeCenterPro: "Per aziende",
      ctaFree: "Inizia gratis",
      ctaTrial: "Inizia 30 giorni gratis",
      planFreeDesc: "Per chi vuole esplorare eDive senza impegno.",
      planProDesc: "Per subacquei attivi che vogliono il massimo dalla piattaforma.",
      planCenterStarterDesc: "La suite base per centri immersioni e istruttori professionisti.",
      planCenterProDesc: "La suite completa per centri immersioni e dive resort.",
      freeF1: "Logbook fino a 50 immersioni",
      freeF2: "Mappa siti (solo lettura)",
      freeF3: "Profilo pubblico base",
      freeF4: "App mobile iOS e Android",
      freeF5: "1 GB storage media",
      proF1: "Logbook illimitato",
      proF2: "Pianificazione immersioni avanzata",
      proF3: "AI assistant illimitato",
      proF4: "Analytics e statistiche",
      proF5: "20 GB storage media",
      proF6: "Esportazione PDF e CSV",
      proF7: "Accesso prioritario al supporto",
      csF1: "Tutto di Pro",
      csF2: "Dashboard centro completa",
      csF3: "Booking online con widget",
      csF4: "Gestione attrezzatura",
      csF5: "CRM clienti",
      csF6: "5 utenti staff",
      cpF1: "Tutto di Center Starter",
      cpF2: "Reportistica e fatturazione avanzata",
      cpF3: "Visibilità premium su mappa",
      cpF4: "Staff illimitati",
      cpF5: "Supporto dedicato",
      cpF6: "Widget prenotazione",
      faq1q: "Posso cambiare piano in qualsiasi momento?",
      faq1a: "Sì, puoi passare a un piano superiore o inferiore in qualsiasi momento. Il cambio è immediato e il credito residuo viene proporzionalmente applicato.",
      faq2q: "Cosa succede dopo i 30 giorni di prova?",
      faq2a: "Al termine della prova, se non inserisci un metodo di pagamento, il tuo account torna automaticamente al piano Free senza perdere i dati.",
      faq3q: "Sono disponibili sconti annuali?",
      faq3a: "Sì, pagando annualmente risparmi il 20% rispetto al pagamento mensile. Contattaci per offerte personalizzate per enti di formazione e associazioni.",
      faq4q: "Come funziona la fatturazione per i centri?",
      faq4a: "I centri ricevono una fattura mensile con IVA. Accettiamo bonifico bancario, carta di credito e SEPA Direct Debit. Emissione fattura automatica.",
    },
    legal: {
      badge: "Legale",
      questions: "Domande sulla privacy?",
      contactUs: "Contattaci",
      orWriteTo: "oppure scrivi a",
      termsQuestions: "Domande sui termini?",
      privacyTitle: "Privacy Policy",
      privacySummary: "In sintesi: raccogliamo solo i dati necessari per erogare il servizio. Non vendiamo i tuoi dati. I dati sensibili (medici) sono sempre facoltativi e criptati. Puoi esportare o cancellare i tuoi dati in qualsiasi momento.",
      cookieTitle: "Cookie Policy",
      cookieSummary: "In sintesi: utilizziamo solo cookie tecnici necessari e analitici cookieless (Plausible). Nessun cookie di profilazione pubblicitaria. Nessun dato condiviso con reti advertising.",
      cookieWhat: "Cosa sono i cookie",
      cookieWhatDesc: "I cookie sono piccoli file di testo salvati sul dispositivo dell'utente quando visita un sito web. Vengono usati per far funzionare il sito, ricordare le preferenze e raccogliere statistiche di utilizzo in forma anonima.",
      cookieManagement: "Gestione dei cookie",
      cookieRevokeTitle: "Revoca del consenso",
      cookiePlausibleTitle: "Nota su Plausible Analytics",
      cookieDelete: "Per eliminare i cookie già salvati, utilizza le funzioni di pulizia del browser. Per ulteriori informazioni:",
      cookieRequired: "Necessari",
      cookieOptional: "Opzionali",
      cookieColName: "Nome",
      cookieColPurpose: "Finalità",
      cookieColDuration: "Durata",
      termsTitle: "Termini di Servizio",
      gdprTitle: "I tuoi diritti GDPR",
      gdprSubtitle: "Il Regolamento Generale sulla Protezione dei Dati (UE 2016/679) ti garantisce controllo completo sui tuoi dati personali. Ecco come esercitare questi diritti su eDive.",
      gdprPrinciplesTitle: "I principi GDPR che rispettiamo",
      gdprContactTitle: "Contatto Privacy",
      gdprContactDesc: "Per qualsiasi richiesta relativa ai tuoi dati personali o per esercitare i diritti GDPR:",
      gdprContactNote: "Risposta garantita entro 30 giorni (termine di legge)",
      gdprAuthorityTitle: "Garante Privacy Italiano",
      gdprAuthorityDesc: "Hai il diritto di presentare reclamo all'autorità di controllo nazionale:",
      gdprManageTitle: "Gestisci i tuoi dati ora",
      gdprManageSubtitle: "Accedi al tuo profilo eDive per esercitare i tuoi diritti in autonomia, senza dover contattare il supporto.",
      gdprLogin: "Accedi al tuo account",
      gdprReadPolicy: "Leggi la Privacy Policy",
      gdprHowTo: "Come fare:",
      dataDeletion: {
        title: "Cancellazione dei dati utente",
        subtitle: "Informazioni su come eDive gestisce le richieste di cancellazione dati provenienti da Facebook e come puoi verificare lo stato della tua richiesta.",
        howTitle: "Come funziona la cancellazione",
        checkTitle: "Verifica lo stato della tua richiesta",
        checkDesc: "Se hai ricevuto un codice di conferma via email o da Facebook, inseriscilo qui sotto per controllare l'avanzamento della cancellazione.",
        codePlaceholder: "Inserisci il codice di conferma",
        checkBtn: "Verifica",
        checking: "Verifica…",
        foundTitle: "Richiesta trovata",
        notFound: "Nessuna richiesta trovata con questo codice. Verifica di averlo copiato correttamente o contatta",
        errorFetch: "Errore nel recupero dello stato. Riprova più tardi.",
        errorConnect: "Impossibile contattare il server. Verifica la connessione.",
        deletedTitle: "Cosa viene cancellato",
        retainedTitle: "Cosa viene conservato per obbligo di legge",
        manualTitle: "Richiedere la cancellazione manualmente",
        manualDesc: "Puoi anche richiedere la cancellazione direttamente dall'app (Profilo → Privacy → \"Cancella account\") oppure contattando il nostro team Privacy:",
        writeTo: "Scrivi a support@edive.tech",
        stateLabels: {
          PENDING: "In attesa di elaborazione",
          IN_PROGRESS: "Cancellazione in corso",
          COMPLETED: "Cancellazione completata",
          FAILED: "Errore — contatta support@edive.tech",
        },
      },
    },
    blog: {
      badge: "Blog",
      h1a: "Storie e conoscenza",
      h1b: "dal mondo subacqueo",
      subtitle: "Guide tecniche, consigli di sicurezza, siti da visitare e novità dal team eDive.",
      readTime: "di lettura",
      newsletterTitle: "Non perdere nessun articolo",
      newsletterSubtitle: "Iscriviti alla newsletter per ricevere i migliori contenuti ogni settimana.",
      emailPlaceholder: "La tua email",
      subscribe: "Iscriviti",
      noSpam: "Nessuno spam. Cancella in qualsiasi momento.",
    },
    partner: {
      badge: "Partner",
      h1a: "Cresciamo insieme",
      h1b: "alla community subacquea",
      subtitle: "Unisciti all'ecosistema eDive e accedi a migliaia di subacquei attivi, istruttori e centri immersione in tutta Italia e nel mondo.",
      programsTitle: "Programmi partner",
      currentTitle: "I nostri partner",
      currentSubtitle: "Aziende e organizzazioni che hanno scelto eDive.",
      ctaTitle: "Interessato a diventare partner?",
      ctaSubtitle: "Compila il modulo di contatto e il nostro team partnership ti risponderà entro 48 ore.",
      ctaContact: "Contattaci",
      typeCentri: "Centri immersione",
      typeCentriDesc: "Aumenta la visibilità del tuo centro, accedi agli strumenti di gestione eDive e raggiungi subacquei di tutta Italia.",
      typeCentriB1: "Profilo verificato sulla mappa",
      typeCentriB2: "Sistema booking integrato",
      typeCentriB3: "Badge partner ufficiale",
      typeCentriB4: "Analytics visitatori",
      ctaCentri: "Diventa partner centro",
      typeEnti: "Enti di formazione",
      typeEntiDesc: "Integra il tuo catalogo corsi su eDive, gestisci iscrizioni e promuovi le tue certificazioni alla community.",
      typeEntiB1: "Catalogo corsi certificato",
      typeEntiB2: "Verifica certificazioni",
      typeEntiB3: "Materiale co-branded",
      typeEntiB4: "Dati iscrizioni in tempo reale",
      ctaEnti: "Diventa partner formazione",
      typeInsurance: "Assicurazioni",
      typeInsuranceDesc: "Offri i tuoi prodotti assicurativi ai subacquei eDive nel momento in cui ne hanno più bisogno.",
      typeInsuranceB1: "Widget assicurazioni integrato",
      typeInsuranceB2: "Lead qualificati",
      typeInsuranceB3: "Co-marketing",
      typeInsuranceB4: "Reportistica conversioni",
      ctaInsurance: "Diventa partner assicurativo",
      typeTour: "Tour operator e resort",
      typeTourDesc: "Promuovi i tuoi pacchetti diving ai clienti più motivati: subacquei attivi con logbook verificato.",
      typeTourB1: "Listing pacchetti viaggio",
      typeTourB2: "Integrazione calendario",
      typeTourB3: "Targeting per certificazione",
      typeTourB4: "Reviews verificate",
      ctaTour: "Diventa partner tourism",
    },
  },
  biocenter: {
    hub: {
      title: "Centro di Biologia Marina",
      subtitle: "Strumenti avanzati per l'identificazione, classificazione e analisi delle specie marine. Ricerca scientifica supportata da intelligenza artificiale e citizen science.",
      statsSpecies: "Specie nel database",
      statsMissions: "Missioni aperte",
      statsTools: "Strumenti disponibili",
      statsAiTools: "Strumenti con IA",
      toolsTitle: "Strumenti di ricerca",
      toolIdentifier: "Identificatore IA",
      toolIdentifierDesc: "Identifica specie marine da descrizione morfologica o URL immagine tramite intelligenza artificiale",
      toolAnalytics: "Analisi & Statistiche",
      toolAnalyticsDesc: "Trend temporali, distribuzione geografica e indici di biodiversità (Shannon, Simpson, Margalef)",
      toolTaxonomy: "Esplora Tassonomia",
      toolTaxonomyDesc: "Classificazione scientifica delle specie con filtro per stato IUCN e dettaglio morfologico",
      toolAssistant: "Assistente IA",
      toolAssistantDesc: "Esperto di ecologia marina, conservazione e metodologie di ricerca — chat multi-turn con Claude",
      toolReport: "Report Conservazione",
      toolReportDesc: "Genera report scientifici formati per qualsiasi specie marina con analisi AI e dati IUCN",
      toolJournal: "Diario di Campo",
      toolJournalDesc: "Registra osservazioni strutturate in campo: specie, condizioni ambientali, coordinate GPS",
      toolMissions: "Missioni di Monitoraggio",
      toolMissionsDesc: "Crea e gestisci missioni di ricerca con protocolli personalizzati e coordinamento volontari",
      toolResearch: "Progetti di Ricerca",
      toolResearchDesc: "Protocolli versionati, squadra con ruoli, immersioni scientifiche e validazione dei dati fra pari",
      toolAlerts: "Alert Ambientali",
      toolAlertsDesc: "Pubblica e monitora alert di conservazione: bleaching, specie invasive, inquinamento, anomalie",
      toolEditor: "Editor Specie",
      toolEditorDesc: "Curate descrizioni, immagini e tassonomia dell'enciclopedia marina eDive con review community",
      toolCitizenSci: "Citizen Science",
      toolCitizenSciDesc: "Dashboard aggregata degli avvistamenti con export Darwin Core e CSV per pubblicazioni scientifiche",
      toolEncyclopedia: "Enciclopedia Marina",
      toolEncyclopediaDesc: "Catalogo completo di specie marine, lifelist personale e storia degli avvistamenti",
      toolGallery: "Galleria Scientifica",
      toolGalleryDesc: "Immagini e video classificati per specie, habitat e profondità contribuiti dalla comunità",
      toolTraining: "Training Hub ML",
      toolTrainingDesc: "Contribuisci al training del modello IA per il riconoscimento automatico delle specie marine",
      workflowTitle: "Flusso di lavoro consigliato",
      step1Title: "Osserva e registra",
      step1Desc: "Usa il Diario di Campo per documentare avvistamenti in tempo reale con coordinate e condizioni ambientali.",
      step2Title: "Identifica e classifica",
      step2Desc: "Non sei sicuro della specie? Usa l'Identificatore IA o sfoglia la Tassonomia.",
      step3Title: "Analizza e pubblica",
      step3Desc: "Visualizza Statistiche e genera un Report di Conservazione AI per le tue pubblicazioni.",
    },
    alerts: {
      title: "Allerte Ambientali",
      subtitle: "Segnalazioni di specie invasive e anomalie marine",
      tabActive: "Allerte attive",
      tabManage: "Gestisci allerte",
      newAlert: "+ Nuova allerta",
      createTitle: "Crea allerta ambientale",
      titleLabel: "Titolo *",
      typeLabel: "Tipo allerta",
      severityLabel: "Severità",
      latLabel: "Latitudine",
      lngLabel: "Longitudine",
      radiusLabel: "Raggio (km)",
      descPlaceholder: "Descrizione",
      expiresLabel: "Scadenza (opzionale)",
      publishing: "Pubblicazione...",
      publishBtn: "Pubblica allerta",
      cancel: "Annulla",
      createError: "Errore durante la creazione.",
      loading: "Caricamento...",
      loadError: "Errore nel caricamento delle allerte.",
      found: "{{count}} allerte trovate",
      noAlerts: "Nessuna allerta trovata.",
      confirmBtn: "Conferma avvistamento",
      confirmed: "Avvistamento confermato ✓",
      alreadyConfirmed: "Già confermato o errore.",
      resolve: "Risolvi",
      radius: "Raggio: {{km}} km",
      confirmations: "{{n}} conferme",
      types: {
        INVASIVE_SPECIES: "Specie invasiva",
        THERMAL_ANOMALY: "Anomalia termica",
        BLEACHING: "Sbiancamento coralli",
        POLLUTION: "Inquinamento",
        MASS_MORTALITY: "Moria di massa",
        OIL_SPILL: "Fuoriuscita petrolio",
        FISHING_GEAR: "Attrezzatura da pesca",
      },
    },
    journal: {
      title: "Diario di Campo",
      subtitle: "Osservazioni strutturate sul campo",
      newObs: "Nuova osservazione",
      noObs: "Nessuna osservazione. Clicca + per aggiungere la prima.",
      export: "Esporta JSON",
      deleteConfirm: "Eliminare questa osservazione?",
      location: "Località",
      coordinates: "Coordinate",
      depth: "Profondità (m)",
      waterTemp: "Temp. acqua (°C)",
      salinity: "Salinità (PSU)",
      visibility: "Visibilità (m)",
      currentLabel: "Corrente",
      notesLabel: "Note generali",
      speciesSection: "Specie osservate",
      addSpecies: "+ Aggiungi specie",
      scientificName: "Nome scientifico *",
      commonName: "Nome comune",
      count: "Conteggio",
      behavior: "Comportamento",
      speciesNotes: "Note",
      save: "Salva osservazione",
      saving: "Salvataggio...",
      currentOptions: {
        none: "Assente",
        light: "Leggera",
        moderate: "Moderata",
        strong: "Forte",
      },
    },
    assistant: {
      title: "Assistente IA Biologia Marina",
      subtitle: "Esperto di ecologia marina, conservazione e metodologie di ricerca",
      suggestedTitle: "Domande suggerite",
      clearChat: "Pulisci chat",
      inputPlaceholder: "Fai una domanda sulla biologia marina...",
      thinking: "Elaborazione...",
      send: "Invia",
      newChat: "Nuova chat",
      settingsTitle: "Impostazioni",
      expertiseLabel: "Livello di competenza",
      langLabel: "Lingua delle risposte",
    },
    analytics: {
      title: "Analisi & Statistiche",
      subtitle: "Trend di avvistamento, distribuzione geografica e indici di biodiversità",
    },
    identifier: {
      title: "Identificatore Specie IA",
      subtitle: "Identifica specie marine tramite descrizione morfologica o URL immagine — powered by Claude AI",
    },
    report: {
      title: "Report di Conservazione IA",
      subtitle: "Genera report scientifici formattati per specie marine — powered by Claude AI",
    },
    taxonomy: {
      title: "Esplora Tassonomia",
      subtitle: "Classificazione scientifica delle specie marine — filtra per stato IUCN",
    },
    missions: {
      resultsSubtitle: "Aggregati scientifici raccolti dai volontari",
    },
  },
  diaries: {
    title: "Diari di Viaggio",
    subtitle: "Le tue spedizioni subacquee raccontate con foto e storie",
    newDiary: "Nuovo diario",
    createTitle: "Nuovo diario di viaggio",
    titleLabel: "Titolo *",
    titlePlaceholder: "es. Maldive 2026",
    titleRequired: "Campo obbligatorio",
    descLabel: "Descrizione",
    countryLabel: "Paese",
    countryPlaceholder: "Italia",
    locationLabel: "Luogo",
    locationPlaceholder: "Sicilia",
    startLabel: "Inizio",
    endLabel: "Fine",
    cancel: "Annulla",
    creating: "Creazione…",
    create: "Crea diario",
    statusDraft: "Bozza",
    statusPublished: "Pubblicato",
    statusArchived: "Archiviato",
    noResults: "Nessun diario trovato",
    noResultsDesc: "Crea il tuo primo diario di viaggio per documentare le tue spedizioni subacquee.",
    loading: "Caricamento diari...",
    loadError: "Errore nel caricamento dei diari.",
    dives: "{{n}} immersioni",
    memberCount: "{{n}} membri",
    likes: "{{n}} mi piace",
    views: "{{n}} visualizzazioni",
    createSuccess: "Diario creato",
    invite: {
      title: "Invito al diario",
      loading: "Caricamento invito...",
      loadError: "Impossibile caricare l'invito.",
      alreadyMember: "Sei già membro di questo diario.",
      accept: "Accetta invito",
      accepting: "Accettazione...",
      acceptError: "Errore nell'accettazione dell'invito.",
      accepted: "Invito accettato!",
      acceptedDesc: "Sei ora membro di questo diario.",
      openDiary: "Apri diario",
    },
    membersPanel: {
      title: "Membri",
      loading: "Caricamento membri...",
      loadError: "Errore nel caricamento dei membri.",
      noMembers: "Nessun membro trovato.",
      invite: "Invita membro",
      inviteTitle: "Invita un membro",
      emailLabel: "Email o ID utente",
      emailPlaceholder: "utente@esempio.com",
      sending: "Invio...",
      inviteBtn: "Invia invito",
      inviteSuccess: "Invito inviato",
      inviteError: "Errore nell'invio dell'invito",
      removeConfirm: "Rimuovere questo membro?",
      removeSuccess: "Membro rimosso",
      removeError: "Errore nella rimozione del membro",
      roleOwner: "Proprietario",
      roleEditor: "Editor",
      roleViewer: "Lettore",
    },
    detail: {
      loading: "Caricamento diario...",
      loadError: "Errore nel caricamento del diario.",
      notFound: "Diario non trovato.",
      addEntry: "Aggiungi voce",
      shareLink: "Condividi link",
      linkCopied: "Link copiato!",
      exportPdf: "Esporta PDF",
      noEntries: "Nessuna voce ancora. Aggiungi la prima voce per iniziare il tuo diario.",
      editDiary: "Modifica diario",
      deleteDiary: "Elimina diario",
      deleteConfirm: "Eliminare definitivamente questo diario e tutte le sue voci?",
      deleteSuccess: "Diario eliminato",
      deleteError: "Errore nell'eliminazione del diario",
      publishBtn: "Pubblica",
      archiveBtn: "Archivia",
      draftBtn: "Imposta come bozza",
      statusUpdated: "Stato aggiornato",
      statusError: "Errore nell'aggiornamento dello stato",
      commentError: "Errore nel salvataggio del commento",
      commentDeleteError: "Errore nell'eliminazione del commento",
      deleteCommentConfirm: "Eliminare questo commento?",
      replyingTo: "Rispondendo a {{name}}",
      writeComment: "Scrivi un commento...",
      sendComment: "Invia",
      loadingComments: "Caricamento commenti...",
      noComments: "Nessun commento ancora.",
      backToDiaries: "Torna ai diari",
      public: "Pubblico",
      private: "Privato",
      like: "Mi piace",
      views: "visualizzazioni",
      pages: "pagine",
      collaborators: "Collaboratori",
      confirmDelete: "Eliminare questo diario?",
      confirmDeletePage: "Eliminare questa pagina?",
      newPagePrompt: "Scrivi una nuova pagina del diario…",
      noPagesYet: "Nessuna pagina ancora",
      whatsappText: "Guarda il mio diario di viaggio su eDive: ",
    },
    entry: {
      newEntry: "Nuova voce",
      editEntry: "Modifica voce",
      titleLabel: "Titolo voce",
      titlePlaceholder: "es. Giorno 1 - Prima immersione",
      content: "Contenuto",
      contentPlaceholder: "Scrivi la tua storia subacquea...",
      diveLabel: "Immersione collegata",
      diveNone: "— Nessuna immersione —",
      photoLabel: "Foto",
      photoCaption: "Didascalia",
      save: "Salva",
      saving: "Salvataggio...",
      saveSuccess: "Voce salvata",
      saveError: "Errore nel salvataggio della voce",
      delete: "Elimina",
      deleteConfirm: "Eliminare questa voce?",
      deleteSuccess: "Voce eliminata",
      deleteError: "Errore nell'eliminazione della voce",
      addPhoto: "+ Aggiungi foto",
      newPage: "Nuova pagina",
      editPage: "Modifica pagina",
      dateLabel: "Data *",
      timeLabel: "Ora",
      locationLabel: "Luogo",
      locationPlaceholder: "es. Ras Mohamed",
      locationPlaceholderShort: "es. Ras Mohamed",
      locatingHint: "Rilevo la posizione…",
      contentLabel: "Contenuto *",
      contentRequired: "Campo obbligatorio",
      contentPlaceholderLong: "Scrivi la tua storia…",
      titleRequired: "Campo obbligatorio",
      titlePlaceholderLong: "es. Primo giorno a Sharm el-Sheikh",
      photosSection: "Foto e video",
      addPhotoBtn: "Aggiungi foto",
      dropZoneFormats: "JPG, PNG, GIF, MP4 — più file supportati",
      dropZoneMore: "Trascina altre foto per aggiungerle",
      captionPlaceholder: "Didascalia…",
      captionOptional: "Didascalia (opzionale)",
      photosToUpload: "{{n}} foto da caricare",
      linkedDives: "Immersioni collegate",
      linkBtn: "Collega",
      uploadError: "Errore caricamento \"{{name}}\"",
      uploadedPage: "Pagina salvata",
      uploadingPhotos: "Caricamento foto…",
      savingPage: "Salvataggio…",
      updateBtn: "Aggiorna",
      savePageBtn: "Salva pagina",
      linkAdded: "Collegamento aggiunto",
      removed: "Rimosso",
      linkTypeDive: "Immersione",
      linkTypePlanning: "Pianificazione",
      linkPlaceholderDive: "ID immersione dal logbook",
      linkPlaceholderPlanning: "ID sessione",
    },
  },
  diveCheckIn: {
    title: "Dive Check-In",
    subtitle: "Registra la tua uscita pre-immersione per la sicurezza",
    infoPara1: "Il check-in pre-immersione registra dove stai andando, la profondità e durata pianificate e il tuo buddy.",
    infoPara2: "Se non effettui il check-out entro il tempo previsto, il sistema invierà automaticamente un alert ai contatti di emergenza.",
    noActive: "Nessun check-in attivo",
    noActiveHint: "Registra un check-in prima di immergerti per la tua sicurezza.",
    newCheckInBtn: "+ Nuovo Check-in",
    activeCheckIn: "Check-in attivo",
    inWater: "IN ACQUA",
    site: "Sito",
    maxDepth: "Profondità max",
    buddy: "Buddy",
    emergency: "Emergenza",
    checkOut: "Check-out — Sono rientrato",
    cancelConfirm: "Annullare il check-in?",
    sendSos: "Invia SOS emergenza",
    sosActive: "SOS ATTIVO",
    sosMarkResolved: "✓ Segna come risolto (sono al sicuro)",
    sosConfirm: "⚠️ Stai per inviare un SOS di emergenza. Proseguire?",
    sosSent: "SOS inviato! I soccorsi sono stati allertati.",
    sosError: "Errore invio SOS — chiama il 118 o DAN direttamente",
    sosResolved: "SOS risolto.",
    sosMessage: "SOS da app eDive",
    cancelled: "Check-in annullato",
    checkOutSuccess: "Check-out completato! Bentornato in superficie.",
    registered: "Check-in registrato! Buona immersione.",
    newCheckIn: "Nuovo check-in pre-immersione",
    diveSite: "Sito di immersione",
    diveSitePlaceholder: "es. Blue Hole, Sharm el-Sheikh",
    maxDepthLabel: "Profondità max (m)",
    plannedDuration: "Durata prevista (min)",
    buddyName: "Nome buddy",
    buddyNamePlaceholder: "Nome e cognome del buddy",
    emergencyContact: "Contatto emergenza",
    emergencyContactPlaceholder: "Nome e numero — es. Mario Rossi +39 333 1234567",
    gpsPosition: "Posizione GPS",
    detectLocation: "Rileva posizione",
    locating: "Rilevamento…",
    locationDetected: "Posizione rilevata",
    gpsUnavailable: "GPS non disponibile",
    registerCheckIn: "Registra Check-in",
    registering: "Registrazione…",
    autoAlertNote: "Il sistema invierà un alert automatico se non effettui il check-out entro il tempo pianificato.",
    overdue: "SCADUTO",
    alertSent: "Alert automatico inviato",
    plannedReturn: "al rientro previsto",
    expectedReturn: "Rientro previsto",
  },
  certWallet: {
    title: "Portafoglio Certificazioni",
    subtitle: "Le tue certificazioni digitali verificate",
    backToProfile: "Torna al profilo",
    verifiedCerts: "Certificazioni verificate",
    certsInWallet: "{{n}} certificazioni nel portafoglio",
    noCerts: "Nessuna certificazione",
    noCertsDesc: "Aggiungi le tue certificazioni dalla pagina del profilo",
    goToProfile: "Vai al profilo",
    qrWallet: "QR Portafoglio",
    regenerateQr: "Rigenera QR",
    howItWorks: "Come funziona",
    howItWorksDesc: "Mostra il QR code ai centri diving per verificare istantaneamente le tue certificazioni",
    verified: "Verificata",
    issuedAt: "Rilasciata",
    expiresAt: "Scade",
    validFor: "Valido per {{n}} giorni",
    error: "Errore nel caricamento delle certificazioni",
  },
  emergencyQr: {
    title: "QR Emergenza",
    subtitle: "Dati medici per le emergenze",
    backToMedical: "Torna alla cartella medica",
    cardHeader: "Scheda Medica di Emergenza",
    bloodType: "Gruppo sanguigno",
    emergencyContact: "Contatto di emergenza",
    expiresIn: "Scade tra {{n}} ore",
    qrMedical: "QR Medico",
    regenerate: "Rigenera QR",
    print: "Stampa",
    howItWorks: "Come funziona",
    howItWorksDesc: "Il personale di soccorso scansiona questo QR per accedere alle informazioni mediche critiche",
    loadError: "Errore nel caricamento dei dati di emergenza",
    iceAlt: "Alt.",
    iceContact: "Contatto di emergenza (ICE)",
  },
  settings: {
    title: "Impostazioni",
    subtitle: "Gestisci le preferenze del tuo account",
    tabs: {
      notifications: "Notifiche",
      privacy: "Privacy",
      account: "Account",
      wallet: "Wallet",
    },
    wallet: {
      loginWallet: "Wallet di accesso",
      loginWalletDesc: "Collega il tuo wallet MetaMask per accedere senza password. I dati dell'account esistente vengono preservati.",
      noWallet: "Nessun wallet collegato",
      linkBtn: "Collega wallet MetaMask",
      unlinkBtn: "Scollega wallet",
      linked: "Wallet collegato con successo",
      unlinked: "Wallet scollegato",
      confirmUnlink: "Sei sicuro di voler scollegare il wallet? Non potrai più accedere con MetaMask.",
      alreadyLinked: "Questo wallet è già collegato a un altro account.",
      reconcileNote: "Se hai già un account wallet separato, collegarlo qui ti permetterà di accedere con entrambi i metodi usando lo stesso account.",
      paymentTitle: "Preferenza pagamento crypto",
      paymentDesc: "Scegli come vuoi ricevere pagamenti in crypto (corsi, prenotazioni, servizi).",
      clearNetwork: "Rimuovi selezione",
      receivingAddress: "Indirizzo di ricezione",
      receivingAddressHint: "Questo indirizzo viene usato per ricevere pagamenti. Può essere diverso dal wallet di accesso.",
      noAddress: "Non impostato",
      invalidAddress: "Indirizzo Ethereum non valido (deve iniziare con 0x seguito da 40 caratteri hex).",
    },
    categories: "Categorie",
    notif: {
      chat: "Messaggi chat",
      chatDesc: "Ricevi notifiche per i nuovi messaggi in chat",
      mentionsOnly: "Solo menzioni",
      mentionsOnlyDesc: "Notifica solo quando sei menzionato",
      achievements: "Traguardi",
      achievementsDesc: "Notifica quando sblocchi un nuovo badge",
      bookings: "Prenotazioni",
      bookingsDesc: "Conferme e aggiornamenti prenotazioni",
      courses: "Corsi",
      coursesDesc: "Aggiornamenti corsi e promemoria lezioni",
      buddy: "Richieste buddy",
      buddyDesc: "Nuove richieste buddy e risposte",
      insurance: "Assicurazione",
      insuranceDesc: "Promemoria scadenza assicurazione",
      loyalty: "Fedeltà",
      loyaltyDesc: "Aggiornamenti punti e premi",
      events: "Eventi",
      eventsDesc: "Eventi imminenti e promemoria",
      social: "Social",
      socialDesc: "Like, commenti e follow",
      safety: "Sicurezza",
      safetyDesc: "Avvisi di sicurezza e notifiche di emergenza",
    },
    quietHours: "Ore silenziose",
    quietHoursDesc: "Metti in pausa le notifiche durante queste ore",
    from: "Da",
    to: "A",
    profileVisibility: "Visibilità profilo",
    publicProfile: "Profilo pubblico",
    publicProfileDesc: "Gli altri subacquei possono visualizzare il tuo profilo",
    searchable: "Ricercabile",
    searchableDesc: "Appari nei risultati di ricerca",
    contactVisibility: "Visibilità contatti",
    contactVisibilityDesc: "Chi può vedere le tue informazioni di contatto",
    visibility: {
      public: "Pubblico",
      connections: "Solo connessioni",
      private: "Privato",
    },
    units: "Unità di misura",
    metric: "Metrico (m, kg)",
    imperial: "Imperiale (ft, lb)",
    accountInfo: "Informazioni account",
    email: "Email",
    status: "Stato",
    statusActive: "Attivo",
    roles: "Ruoli",
    memberSince: "Membro dal",
    changePassword: "Cambia password",
    currentPassword: "Password attuale",
    newPassword: "Nuova password",
    confirmPassword: "Conferma nuova password",
    passwordMismatch: "Le password non corrispondono",
    passwordUpdated: "Password aggiornata",
    minChars: "Minimo {{n}} caratteri",
    updatePassword: "Aggiorna password",
    yourData: "I tuoi dati",
    gdprDesc: "Scarica o elimina tutti i tuoi dati personali",
    gdprManage: "Gestisci dati",
    advancedSecurity: "Sicurezza avanzata",
    advancedSecurityDesc: "Gestisci codici di recupero, passkey WebAuthn e dispositivi fidati.",
    manage2fa: "Gestisci autenticazione a due fattori",
  },
  squads: {
    title: "Squadre Subacquee",
    subtitle: "Unisciti ai gruppi e compete insieme",
    exploreTab: "Esplora",
    leaderboardTab: "Classifica",
    mySquads: "Le mie squadre",
    allSquads: "Tutte le squadre",
    noneFound: "Nessuna squadra trovata",
    beFirst: "Sii il primo a crearne una!",
    searchPlaceholder: "Cerca squadre…",
    active: "Attive",
    public: "Pubblica",
    private: "Privata",
    members: "{{n}} membri",
    join: "Unisciti",
    leave: "Esci",
    joined: "Sei entrato in {{name}}",
    left: "Hai lasciato {{name}}",
    createTitle: "Crea squadra",
    nameLabel: "Nome squadra",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Di cosa si occupa questa squadra?",
    publicLabel: "Squadra pubblica",
    createBtn: "Crea",
    created: "Squadra creata",
    loadingLeaderboard: "Caricamento classifica…",
    noSquadsLeaderboard: "Nessuna squadra in classifica",
    leaderboardFor: "Classifica: {{category}}",
    inUnit: "in {{unit}}",
  },
  leaderboard: {
    title: "Classifica",
    subtitle: "Classifiche nella community eDive",
    individuals: "Individuali",
    squads: "Squadre",
    participants: "{{count}} partecipanti",
    squadsCount: "{{count}} squadre",
    noData: "Nessun dato ancora",
    noSquadsYet: "Nessuna squadra ha ancora gareggiato",
    notOnLeaderboard: "Non sei ancora in classifica",
    addDivesToAppear: "Registra più immersioni per apparire in classifica",
    myPosition: "La mia posizione",
    myScore: "Il mio punteggio",
    noSquads: "Non hai ancora unito nessuna squadra",
    joinGroupToCompete: "Unisciti a una squadra per gareggiare",
    mySquads: "Le mie squadre",
    squadScoreInfo: "Il punteggio squadra è la somma dei punteggi di tutti i membri",
    categories: {
      total_dives: "Immersioni Totali",
      max_depth: "Profondità Massima",
      species: "Specie",
      streak: "Serie",
    },
    info: {
      total_dives: "Numero totale di immersioni registrate",
      max_depth: "Profondità massima mai raggiunta",
      species: "Numero di specie uniche avvistate",
      streak: "Giorni consecutivi con un'immersione",
    },
  },
  community: {
    title: "Community",
    subtitle: "Connettiti con subacquei di tutto il mondo",
    // DV-11 onda 3: ChallengesPage (sostituito helper L).
    challenges: {
      title: "Sfide della community",
      subtitle: "Completa le sfide e guadagna badge esclusivi",
      leaderboard: "Classifica",
      inProgress: "In corso",
      completed: "Completate",
      notStarted: "Da iniziare",
      noneTitle: "Nessuna sfida disponibile",
      noneDesc: "Le sfide arrivano presto. Torna a controllare!",
      myBadges: "I miei badge",
    },
    searchPlaceholder: "Cerca subacquei…",
    filterAll: "Tutti",
    filterDiver: "Subacquei",
    filterInstructor: "Istruttori",
    filterDivemaster: "Divemaster",
    filterDiveDoctor: "Medici Subacquei",
    follow: "Segui",
    following: "Seguito",
    profile: "Vedi profilo",
    noResults: "Nessun utente trovato",
    noResultsHint: "Prova una ricerca o un filtro diverso",
    loadMore: "Carica altri",
    types: {
      diver: "Subacqueo",
      instructor: "Istruttore",
      divemaster: "Divemaster",
      diveDoctor: "Medico Subacqueo",
    },
  },
  apnea: {
    title: "Apnea",
    subtitle: "Allenamento, record personali e statistiche",
    syncBanner: "Sincronizza statistiche apnea con i tuoi medici",
    noRecordsYet: "Nessun record ancora. Registra le tue prime immersioni in apnea!",
    discipline: "Disciplina",
    depth: "Profondità",
    time: "Tempo",
    date: "Data",
    sessionDateLabel: "Data sessione *",
    warmUpLabel: "Riscaldamento (min)",
    siteLabel: "Sito",
    sitePlaceholder: "Nome sito o piscina",
    countryLabel: "Paese",
    selectPlaceholder: "— seleziona —",
    notesLabel: "Note",
    notesPlaceholder: "Condizioni, obiettivi, progressi...",
    cancel: "Annulla",
    saving: "Salvo...",
    save: "Salva",
    divesCount: "{{count}} tuffi",
    maxLabel: "max",
    timeLabel: "tempo",
    notes: "Note",
    noDivesLinked: "Nessun tuffo collegato a questa sessione.",
    noDoctorLinked: "Nessun medico collegato",
    statsNotLoaded: "Statistiche non ancora caricate",
    syncSuccess: "Statistiche sincronizzate con {{count}} medici",
    syncError: "Errore durante la sincronizzazione",
    sessionCreated: "Sessione creata",
    createError: "Errore nella creazione",
    sessionDeleted: "Sessione eliminata",
    deleteError: "Errore nella eliminazione",
    tabTraining: "Allenamento",
    tabStats: "Statistiche",
    tabSessions: "Sessioni",
    syncing: "Sincronizzazione...",
    syncDoctors: "Sync medici",
    loadingStats: "Caricamento statistiche...",
    totalDives: "Tuffi totali",
    sessionsCount: "{{count}} sessioni",
    bestDepth: "Miglior profondità",
    bestTime: "Miglior tempo",
    sambaBo: "Samba / BO",
    progression: "Progressione (ultimi 12 mesi)",
    maxDepthAxis: "Profondità max (m)",
    max: "Max",
    maxTimeAxis: "Tempo max (sec)",
    personalRecords: "Record personali per disciplina",
    divesByDiscipline: "Tuffi per disciplina",
    dives: "Tuffi",
    safetyTitle: "Attenzione — eventi di sicurezza registrati",
    safetyBody: "Hai registrato {{lcm}} evento/i LCM (perdita di controllo motorio) e {{bo}} blackout. Consulta un istruttore qualificato e rivedi le tue tavole di recupero.",
    allYears: "Tutti gli anni",
    newSession: "Nuova sessione",
    newTrainingSession: "Nuova sessione di allenamento",
    loadingSessions: "Caricamento sessioni...",
    noSessions: "Nessuna sessione registrata.",
    noSessionsHint: "Crea la prima sessione per iniziare a tracciare il tuo allenamento.",
    confirmDelete: "Eliminare questa sessione? I tuffi collegati rimarranno nel logbook.",
    showingCount: "Mostrando {{shown}} di {{total}} sessioni",
  },
  diverTraining: {
    title: "Allenamento del Subacqueo",
    subtitle: "Resta sempre pronto per il mare: cura respiro, skill e forma, un passo alla volta.",
    streak: "Serie",
    days: "giorni",
    record: "record",
    weeklyGoal: "Obiettivo settimanale",
    thisWeek: "questa settimana",
    sessions: "Sessioni",
    totalTime: "Tempo totale",
    tools: "I tuoi attrezzi",
    comingSoon: "In arrivo",
    hubSafety: "L'allenamento a secco è un ripasso: prepara mente e corpo, ma non sostituisce un corso o un refresh in acqua con un istruttore. Torna in immersione con calma e in sicurezza.",
    recent: "Attività recente",
    loading: "Caricamento…",
    emptyTitle: "Il tuo percorso inizia qui",
    emptyHint: "Presto potrai allenare respiro, skill ed emergenze: bastano pochi minuti per tornare in acqua più sicuro.",
    score: "punteggio",
    roundsShort: "round",
    card: {
      breathing: "Respirazione & consumo aria",
      breathingDesc: "Respiro lento e profondo per consumare meno aria e stare più a lungo sott'acqua",
      skill: "Ripasso skill",
      skillDesc: "Rivedi maschera, erogatore, assetto e aria di riserva, passo dopo passo",
      emergency: "Scenari di emergenza",
      emergencyDesc: "Allena la risposta giusta prima che serva: decidi con calma, non nel panico",
      theory: "Teoria & quiz",
      theoryDesc: "Tieni fresche fisica, fisiologia e procedure con quiz brevi",
      fitness: "Preparazione fisica",
      fitnessDesc: "Fiato, gambe e mobilità: la forma che rende ogni immersione più bella",
      equalization: "Equalizzazione",
      equalizationDesc: "Esercizi a secco per compensare meglio e scendere senza fastidi",
    },
    type: {
      breathing: "Respirazione & consumo aria",
      skill: "Ripasso skill",
      emergency: "Scenari di emergenza",
      theory: "Teoria & quiz",
      fitness: "Preparazione fisica",
      equalization: "Equalizzazione",
    },
    startTraining: "Inizia un allenamento",
    pause: "Pausa",
    resume: "Riprendi",
    finish: "Concludi",
    close: "Chiudi",
    breath: {
      title: "Respirazione & consumo aria",
      intro: "Segui il cerchio: si espande quando inspiri, si contrae quando espiri. Respira dalla pancia, lento e continuo — proprio come vuoi fare sott'acqua.",
      choosePattern: "Scegli il ritmo",
      duration: "Durata",
      deep: "Respiro profondo lento",
      deepDesc: "Inspira 4s, espira 6s: il respiro che fa durare l'aria e allunga l'immersione",
      relax: "Respiro rilassante",
      relaxDesc: "Espirazione lunga (4s / 8s): abbassa il battito e la tensione prima del tuffo",
      coherent: "Respiro coerente",
      coherentDesc: "5s e 5s, circa sei respiri al minuto: equilibrio e calma",
      inhale: "Inspira",
      exhale: "Espira",
      cyclesDone: "{{count}} respiri",
      start: "Inizia",
      safety: "In immersione non trattenere MAI il respiro: respira in modo lento e continuo. Questo esercizio allena proprio quel ritmo, a secco.",
    },
    drill: {
      title: "Ripasso skill",
      intro: "Rivedi e visualizza le skill fondamentali. Un ripasso mentale a secco che tiene i gesti pronti per quando servono.",
      chooseDrill: "Scegli una skill da ripassare",
      purposeLabel: "Perché conta",
      step: "Passo",
      of: "di",
      begin: "Inizia il ripasso",
      next: "Avanti",
      back: "Indietro",
      complete: "Completa",
      tipLabel: "Il consiglio",
      doneTitle: "Ripasso completato",
      doneSub: "Bel lavoro. Ogni ripasso rende il gesto più naturale in acqua.",
      logAndClose: "Salva e chiudi",
      safety: "È un ripasso mentale a secco: le skill vanno praticate in acqua con un istruttore. Non trattenere il respiro e non simulare risalite reali.",
    },
    quiz: {
      emergencyIntro: "Situazioni reali, decisioni rapide. Scegli cosa faresti e scopri subito il perché: così la risposta giusta diventa un riflesso.",
      theoryIntro: "Domande brevi per tenere fresca la teoria. Scegli il livello e mettiti alla prova.",
      chooseLevel: "Scegli il livello",
      levelBase: "Base",
      levelInter: "Intermedio",
      levelAdv: "Avanzato",
      begin: "Inizia",
      contextLabel: "La situazione",
      question: "Domanda",
      of: "di",
      correct: "Giusto!",
      wrong: "Da rivedere",
      whyLabel: "Perché",
      next: "Avanti",
      resultTitle: "Sessione completata",
      scoreLabel: "punti",
      resultGood: "Ottimo: sei pronto. Continua così.",
      resultMid: "Buon lavoro. Ancora un ripasso e sei a posto.",
      resultLow: "Nessun problema: ogni ripasso ti fa crescere. Riprova quando vuoi.",
      logAndClose: "Salva e chiudi",
    },
    readiness: {
      title: "Sei pronto per immergerti?",
      loading: "Calcolo la tua prontezza…",
      tierReady: "Pronto per il mare 🌊",
      tierAlmost: "Quasi pronto",
      tierWarmup: "Rimettiamoci in forma",
      tierRefresh: "Rispolveriamo insieme",
      dimRecency: "Freschezza",
      dimSkill: "Skill",
      dimKnowledge: "Teoria",
      dimFitness: "Forma",
      neverDived: "Nessuna immersione ancora",
      daysAgo: "Ultima immersione {{count}} gg fa",
      nudgeRefresh: "È passato un po' dall'ultima immersione: rispolveriamo insieme prima di tornare giù.",
      nudgeReady: "Sei in forma per il mare. Mantieni l'abitudine, un po' alla volta.",
      nudgeWarmup: "Un passo alla volta: prepariamoci insieme per la prossima immersione.",
      ctaOpen: "Apri il programma",
    },
    programs: {
      title: "Programmi guidati",
      stepsTitle: "Le tappe",
      doNow: "Fai ora",
    },
    fitness: {
      title: "Preparazione fisica",
      intro: "Poche routine a corpo libero per fiato, gambe e mobilità: la forma che rende ogni immersione più bella e sicura.",
      choose: "Scegli una routine",
      exercises: "esercizi",
      exercise: "Esercizio",
      rest: "Recupero",
      nextUp: "Prossimo",
      safety: "Fermati se senti dolore o affanno eccessivo. Adatta l'intensità alla tua forma; in caso di dubbi, senti un medico.",
    },
    equalize: {
      title: "Equalizzazione",
      intro: "Allena il ritmo giusto: compensa presto e spesso, sempre in modo gentile. A secco, per rendere automatico il gesto in acqua.",
      chooseTech: "Scegli la tecnica",
      valsalva: "Valsalva",
      valsalvaDesc: "Naso chiuso, soffi delicati: la tecnica più diffusa. Mai forzata.",
      frenzel: "Frenzel",
      frenzelDesc: "Usi la lingua come un pistone: più fine e delicata per l'orecchio.",
      cueNow: "Compensa ora",
      cueDescend: "Scendi piano",
      done: "{{count}} compensazioni",
      safety: "Mai forzare la compensazione: se senti dolore, fermati. È un esercizio a secco e gentile, non una manovra sotto sforzo.",
    },
    logged: "Sessione registrata! Sei un po' più pronto per il mare 🌊",
    logError: "Non è stato possibile salvare la sessione",
  },
  apneaTraining: {
    title: "Allenamento",
    logged: "Sessione di {{type}} completata! Un respiro alla volta 🌊",
    logError: "Non è stato possibile salvare la sessione",
    pause: "Pausa",
    resume: "Riprendi",
    skip: "Salta",
    stop: "Termina",
    finish: "Concludi",
    streak: "Serie",
    days: "giorni",
    record: "record",
    weeklyGoal: "Obiettivo settimanale",
    thisWeek: "questa settimana",
    bestHold: "Miglior tenuta",
    totalTime: "Tempo totale",
    sessionsCount: "{{count}} sessioni in totale",
    startTraining: "Inizia un allenamento",
    hubSafety: "Gli esercizi di apnea vanno praticati SOLO a secco, seduti o sdraiati in un luogo sicuro. Mai in acqua o vicino all'acqua senza un compagno addestrato: il rischio di svenimento (blackout) è reale.",
    recent: "Attività recente",
    loading: "Caricamento…",
    emptyTitle: "Il tuo allenamento inizia qui",
    emptyHint: "Scegli un esercizio qui sopra: bastano pochi minuti al giorno per sentire la differenza.",
    hold: "tenuta",
    roundsShort: "round",
    card: {
      breathing: "Respirazione guidata",
      breathingDesc: "Ritrova calma e controllo con un ritmo di respiro guidato",
      co2: "Tabella CO₂",
      co2Desc: "Allena la tolleranza all'anidride carbonica",
      o2: "Tabella O₂",
      o2Desc: "Allena la resistenza all'ipossia, con tenute crescenti",
      static: "Apnea statica",
      staticDesc: "Cronometra la tua tenuta con preparazione e recupero",
      focus: "Concentrazione",
      focusDesc: "Una pausa di calma e presenza, in stile Blue Mind",
    },
    type: {
      breathing: "Respirazione",
      co2: "Tabella CO₂",
      o2: "Tabella O₂",
      static: "Apnea statica",
      focus: "Concentrazione",
    },
    breath: {
      title: "Respirazione guidata",
      intro: "Segui il cerchio: si espande quando inspiri, si contrae quando espiri. Trova un ritmo comodo.",
      choosePattern: "Scegli il ritmo",
      duration: "Durata",
      start: "Inizia",
      box: "Respiro quadrato (4-4-4-4)",
      boxDesc: "Inspira, trattieni, espira, trattieni: equilibrio e concentrazione",
      coherent: "Respiro coerente (5,5-5,5)",
      coherentDesc: "Circa sei respiri al minuto: calma il sistema nervoso",
      relax: "Rilassamento pre-tuffo",
      relaxDesc: "Espirazione lunga: abbassa il battito prima di un'apnea",
      recovery: "Respiro di recupero",
      recoveryDesc: "Respiri pieni e ritmati per il recupero dopo la tenuta",
      inhale: "Inspira",
      holdFull: "Trattieni",
      exhale: "Espira",
      holdEmpty: "Vuoto",
      cyclesDone: "{{count}} cicli",
      safety: "Se avverti vertigini o formicolii, interrompi e respira normalmente.",
    },
    table: {
      co2Title: "Tabella CO₂",
      o2Title: "Tabella O₂",
      co2Intro: "Apnee di durata costante con riposo che si accorcia: alza la tua soglia alle contrazioni.",
      o2Intro: "Riposo costante e apnee sempre più lunghe: abitua il corpo a bassi livelli di ossigeno.",
      refStatic: "La tua apnea statica massima",
      refHint: "Serve a calibrare la tabella sui tuoi valori. Puoi cambiarla quando vuoi.",
      rounds: "Round",
      rest: "Riposo",
      hold: "Apnea",
      safety: "Solo a secco, seduto o sdraiato. Mai in acqua senza supervisione. Fermati appena vuoi.",
      begin: "Avvia la tabella",
      roundOf: "Round {{current}} di {{total}}",
      holdNow: "Apnea",
      breatheNow: "Respira",
      next: "Poi",
      holdCue: "Rilassati e resta immobile. Fermati se senti forti contrazioni o vertigini.",
      breatheCue: "Respira in modo lento e rilassato, senza iperventilare.",
    },
    static: {
      title: "Apnea statica",
      intro: "Preparati con qualche respiro calmo, poi cronometra la tua tenuta. A secco, in sicurezza.",
      prep: "Preparazione",
      safety: "Esegui l'esercizio a secco, seduto o sdraiato, mai in acqua. Idealmente con un compagno che ti osserva.",
      begin: "Inizia",
      startHold: "Inizia l'apnea",
      prepPhase: "Preparazione",
      prepCue: "Respira lentamente e profondamente. Rilassa spalle, viso e mascella.",
      stopHold: "Fermati",
      holding: "In apnea",
      contractionCue: "Le contrazioni sono normali: è il momento di restare calmo. Fermati quando vuoi.",
      relaxCue: "Resta immobile e rilassato. Lascia andare la tensione.",
      yourHold: "La tua tenuta",
      howFelt: "Come ti sei sentito?",
      retry: "Riprova",
      save: "Salva",
    },
    focus: {
      title: "Concentrazione",
      intro: "Qualche minuto di calma e presenza. Chiudi gli occhi, oppure lascia lo sguardo morbido sul cerchio.",
      duration: "Durata",
      soundHint: "Suono del mare",
      begin: "Inizia",
      cue1: "Porta l'attenzione al respiro. Non cambiarlo, solo osservalo.",
      cue2: "Rilassa le spalle a ogni espirazione. Lascia scendere le tensioni.",
      cue3: "Immagina l'acqua che ti sostiene, leggera e silenziosa.",
      cue4: "Se la mente si distrae, torna con gentilezza al respiro.",
      cue5: "Senti la calma diffondersi. Sei qui, adesso.",
    },
  },
  advisor: {
    title: "Assistente Diving AI",
    subtitle: "Consulente personale per le tue immersioni — chiedi qualsiasi cosa",
  },
  developer: {
    title: "Developer Portal",
    subtitle: "API key e webhook per integrare eDive nei tuoi sistemi",
  },
  photographer: {
    title: "Portale Fotografo Subacqueo",
    subtitle: "Contribuisci foto di specie marine alla banca dati eDive. Ogni foto è revisionata dal team di biologia marina prima di essere pubblicata.",
  },
  researchCenter: {
    title: "Centro di Ricerca",
    subtitle: "Gestione missioni di citizen science, volontari e osservazioni",
  },
  marineBiologist: {
    title: "Portale Biologi Marini",
    subtitle: "Contribuisci all'enciclopedia marina di eDive — invia proposte di aggiornamento, correzioni tassonomiche e nuove specie.",
  },
  trips: {
    title: "Viaggi & Avventure",
    subtitle: "Organizza i tuoi viaggi subacquei: pianifica le tappe, prepara la checklist dell'attrezzatura, collega le immersioni effettuate e ricevi un report AI al ritorno.",
  },
  excursions: {
    title: "Escursioni",
    certNone: "Nessuna",
    certOpenWater: "Open Water (≤18m)",
    certAdvanced: "Advanced (≤30m)",
    certRescueDm: "Rescue / DM (≤40m)",
    certTechnical: "Tecnico (illimitato)",
    typeTechnical: "Tecnica",
    typeRecreational: "Ricreativa",
    typeBoth: "Tecnica & Ricreativa",
    requestSent: "Richiesta inviata",
    error: "Errore",
    requestNewExcursion: "Richiedi nuova escursione",
    requestModalSubtitle: "Invia una proposta a un Diving Center o Istruttore. Riceverai una notifica con la risposta.",
    organizerType: "Tipo organizzatore",
    diveCenter: "Diving Center",
    instructor: "Istruttore",
    searchDiveCenterPlaceholder: "Cerca diving center…",
    searchInstructorPlaceholder: "Cerca istruttore…",
    noResults: "Nessun risultato",
    proposedSite: "Sito proposto",
    proposedSitePlaceholder: "es. Punta Campanella",
    proposedDate: "Data proposta",
    diveType: "Tipo immersione",
    anyDash: "— Qualsiasi —",
    maxDepthM: "Profondità max (m)",
    notes: "Note",
    notesPlaceholder: "Preferenze, esigenze particolari...",
    cancel: "Annulla",
    sending: "Invio...",
    sendRequest: "Invia richiesta",
    joinSent: "Iscrizione inviata",
    joinError: "Errore durante l'iscrizione",
    meeting: "Raduno",
    enrolled: "iscritti",
    full: "Completa",
    min: "Min",
    maxDepthValue: "Max {{depth}}m",
    cancellationWithin: "Cancellazione entro {{hours}}h",
    joining: "Iscrizione...",
    join: "Iscriviti",
    loading: "Caricamento...",
    noRequestsSent: "Nessuna richiesta inviata.",
    noRequestsHint: "Usa il pulsante \"Richiedi escursione\" per inviarne una.",
    statusAccepted: "Accettata",
    statusRejected: "Rifiutata",
    statusModified: "Modificata",
    statusPending: "In attesa",
    organizerNote: "Nota organizzatore",
    goToLinkedExcursion: "Vai all'escursione collegata",
    subtitle: "Trova escursioni compatibili con il tuo brevetto",
    requestExcursion: "Richiedi escursione",
    tabBrowse: "Cerca escursioni",
    tabMyRequests: "Le mie richieste",
    certLabel: "Brevetto",
    filters: "Filtri",
    any: "Qualsiasi",
    fromDate: "Da data",
    toDate: "A data",
    loadingExcursions: "Caricamento escursioni...",
    noExcursionsFound: "Nessuna escursione trovata",
    noExcursionsHint: "Prova a modificare il brevetto o i filtri, oppure richiedi una nuova escursione.",
    excursionsFound: "{{count}} escursioni trovate",
    emptyDesc: "Le escursioni pubblicate dagli operatori appariranno qui.",
    emptyTitle: "Nessuna escursione disponibile",
    info: "Esplora il catalogo di escursioni organizzate, le guide subacquee e le destinazioni più richieste.",
    noDest: "Nessuna destinazione",
    noDestDesc: "Le destinazioni popolari appariranno qui.",
    noGuides: "Nessuna guida disponibile",
    noGuidesDesc: "Le guide subacquee registrate appariranno qui.",
    tabDest: "Destinazioni",
    tabExcursions: "Escursioni",
    tabGuides: "Guide",
  },
  sportcenters: {
    myCenter: "Il mio Centro Sportivo",
    myCenterSubtitle: "Gestisci le informazioni e le sessioni in piscina",
  },
  academy: {
    pool: "Piscina {{length}}m",
    trainingCenter: "Centro didattico",
    kpiOpenSessions: "Sessioni aperte",
    kpiStudents: "Studenti totali",
    kpiInstructors: "Istruttori",
    kpiRevenue: "Fatturato (sessioni)",
    tabSessions: "Sessioni",
    tabInstructors: "Istruttori",
    noCenterTitle: "Nessuna struttura registrata",
    noCenterDesc: "Per usare il portale Academy devi prima registrare la tua struttura sportiva.",
    registerFacility: "Registra struttura",
    newSession: "Nuova sessione",
    noSessionsDesc: "Nessuna sessione pianificata.",
    createFirst: "Crea la prima sessione →",
    noInstructors: "Nessun istruttore registrato.",
    manageInstructors: "Gestisci istruttori →",
    statusOpen: "Aperta",
    statusFull: "Al completo",
    statusCancelled: "Annullata",
    statusCompleted: "Completata",
    free: "Gratuita",
    toastCreated: "Sessione creata",
    toastUpdated: "Sessione aggiornata",
    toastErrorCreate: "Errore nella creazione",
    toastValidation: "Compila titolo e data",
    modalTitle: "Nuova sessione",
    fieldTitle: "Titolo *",
    fieldType: "Tipo",
    fieldLevel: "Livello",
    fieldAgency: "Agenzia",
    noAgency: "— Nessuna —",
    fieldMaxStudents: "Max studenti",
    fieldPrice: "Prezzo (€)",
    fieldPricePlaceholder: "0 = gratuita",
    fieldDuration: "Durata (min)",
    fieldDateTime: "Data e ora *",
    fieldNotes: "Note",
    fieldNotesPlaceholder: "Materiale necessario, prerequisiti, ecc.",
    creating: "Creazione...",
    cancelSession: "Annulla",
    colSession: "Sessione",
    colDate: "Data",
    colTypeLevel: "Tipo / Livello",
    colStudents: "Studenti",
    colPrice: "Prezzo",
    colStatus: "Stato",
    onboarding: {
      wizardTitle: "Configura la tua academy / sport center",
      wizardSubtitle: "Crea il profilo della struttura e inizia ad accogliere i corsisti",
      stepAcademy: "L'academy",
      stepStructure: "Struttura",
      stepLocation: "Posizione",
      stepServices: "Servizi",
      finalLabel: "Crea academy",
      fieldName: "Nome struttura *",
      fieldDescription: "Descrizione",
      fieldDescPlaceholder: "Presentate la struttura: storia, programmi, punto di forza…",
      poolSpecsHint: "Specifiche tecniche delle vasche/piscine disponibili.",
      fieldPoolLength: "Lunghezza vasca (m)",
      fieldLanes: "Corsie",
      fieldMaxDepth: "Profondità max (m)",
      fieldPoolType: "Tipo vasca",
      poolIndoor: "🏊 Coperta",
      poolOutdoor: "☀️ All'aperto",
      fieldCountry: "Paese *",
      fieldCity: "Città *",
      fieldAddress: "Indirizzo",
      fieldPhone: "Telefono",
      fieldEmail: "Email",
      fieldWebsite: "Sito web",
      fieldAmenities: "Servizi e dotazioni",
      fieldAmenitiesHint: "Seleziona o aggiungi le dotazioni della struttura.",
      fieldAmenitiesPlaceholder: "Es. Aria compressa…",
      afterCreateHint: "Dopo la creazione puoi gestire sessioni, istruttori, prenotazioni e corsi dalla <strong>dashboard Academy</strong>.",
      toastCreated: "Academy creata!",
      toastError: "Errore nella creazione",
      amenityLocker: "Spogliatoi",
      amenityShower: "Docce",
      amenityParking: "Parcheggio",
      amenityRestaurant: "Ristorante/Bar",
      amenityRentalGear: "Attrezzatura noleggio",
      amenityCompressedAir: "Aria compressa",
      amenityNitrox: "Nitrox",
      amenityGearWorkshop: "Officina attrezzatura",
      amenityWifi: "Wi-Fi",
      amenityWheelchairAccess: "Accessibile disabili",
      amenityKidsArea: "Area bambini",
      amenityWetsuitStorage: "Deposito mute",
    },
  },
  pss: {
    pageTitle: "Corsi PSS",
    pageSubtitle: "Preparati all'esame per il Patent Subacqueo Sportivo",
    questions: "domande",
    startExam: "Avvia esame",
    resumeExam: "Riprendi esame",
    startError: "Impossibile avviare la simulazione",
    passed: "Superato",
    failed: "Non superato",
    inProgress: "In corso",
    lastAttempts: "Tentativi recenti",
    recentHistory: "Storico esami",
    noCourses: "Nessun corso disponibile al momento.",
    statAttempts: "Tentativi totali",
    statPassed: "Superati",
    statAvgScore: "Punteggio medio",
    colCourse: "Corso",
    colDate: "Data",
    colScore: "Punteggio",
    colResult: "Risultato",
  },
  consentResult: {
    confirmedTitle: "Consenso registrato",
    confirmedMessage: "Grazie! Hai acconsentito a ricevere comunicazioni da eDive. Puoi revocare il consenso in qualsiasi momento.",
    confirmedCta: "Scopri eDive",
    revokedTitle: "Consenso revocato",
    revokedMessage: "Hai revocato il consenso al trattamento dei dati per comunicazioni di marketing. Non riceverai più messaggi da eDive.",
    revokedCta: "Torna al sito",
    errorTitle: "Errore",
    errorMessage: "Si è verificato un problema durante la registrazione del consenso. Il link potrebbe essere scaduto o non valido.",
    errorCta: "Torna al sito",
    gdprNote: "eDive rispetta il Regolamento UE 2016/679 (GDPR). Titolare del trattamento: eDive SRL.",
    privacyPolicy: "Privacy Policy",
  },
  wishlist: {
    pageTitle: "Wishlist siti",
    savedCount_one: "{{count}} sito salvato",
    savedCount_other: "{{count}} siti salvati",
    difficulty: {
      BEGINNER: "Principiante",
      INTERMEDIATE: "Intermedio",
      ADVANCED: "Avanzato",
      EXPERT: "Esperto",
    },
    verified: "Verificato",
    savedOn: "Salvato",
    logDive: "Registra immersione",
    removeTooltip: "Rimuovi dalla wishlist",
    empty: "Nessun sito nella wishlist",
    emptyDesc: "Salva i siti di immersione che vuoi visitare. Troverai il pulsante \"Salva\" nel dettaglio di ogni sito.",
    exploreSites: "Esplora siti di immersione",
  },
  datalab: {
    title: "eDive Data Lab",
    subtitle: "Dataset marini per ricerca, analisi e innovazione",
  },
  findMedical: {
    title: "Trova il tuo Medico",
    subtitle: "Cerca specialisti medici per subacquei in tutta Europa. Filtra per specializzazione, località o distanza.",
    searchPlaceholder: "Cerca per nome, clinica o città…",
    filters: "Filtri",
    searchByDistance: "Cerca per distanza",
    cityPlaceholder: "Es. Roma, Milano, Napoli…",
    nearLabel: "Vicino a",
    radius: "Raggio",
    country: "Paese",
    allCountries: "Tutti i Paesi",
    onlineOnly: "Solo visite online",
    allSpecialties: "Tutte le specialità",
    resultsWithin: "Risultati entro",
    from: "da",
    searching: "Ricerca in corso…",
    noResults: "Nessun medico trovato con i filtri selezionati.",
    tryLargerRadius: "Prova ad aumentare il raggio di ricerca.",
    found: "{{count}} professionisti trovati",
    withinKm: "entro {{radius}} km da {{city}}",
    online: "Online",
    answersQuestions: "Risponde",
    book: "Prenota",
    email: "Email",
    ctaTitle: "Sei un medico?",
    ctaDesc: "Aggiungi il tuo studio alla directory eDive e raggiungi migliaia di subacquei italiani ed europei.",
    ctaBtn: "Iscriviti alla directory",
    specCardiology: "Cardiologo",
    specHyperbaric: "Medico Iperbarico",
    specPulmonology: "Pneumologo",
    specSports: "Medico dello Sport",
    specGeneral: "Medico di Base",
    specNeurology: "Neurologo",
    specOrthopedics: "Ortopedico",
    specDermatology: "Dermatologo",
    specEnt: "Otorinolaringoiatra",
    specOphthalmology: "Oculista",
    specEmergency: "Medicina d'Urgenza",
    specOccupational: "Medicina del Lavoro",
    specPsychiatry: "Psichiatra",
    specInternal: "Internista",
    specDietology: "Nutrizionista",
    specEndocrinology: "Endocrinologo",
    specRheumatology: "Reumatologo",
    specAnesthesiology: "Anestesista",
    specRadiology: "Radiologo",
    appointmentRequested: "Richiesta di appuntamento inviata",
    askQuestion: "Fai una domanda",
    questionSent: "Domanda inviata",
    questionTooShort: "La domanda deve avere almeno 10 caratteri",
    requestAppointment: "Richiedi appuntamento",
    requestSend: "Invia richiesta",
    send: "Invia",
    sendError: "Invio non riuscito",
    appointmentNotes: "Note (facoltative)",
    questionPlaceholder: "Scrivi la tua domanda (min. 10 caratteri)",
  },
  doctorProfile: {
    title: "Profilo Medico",
    subtitle: "Gestisci il tuo profilo da medico del sub e le valutazioni di idoneità",
    tabProfile: "Profilo",
    tabAssessments: "Valutazioni idoneità",
    editProfile: "Modifica profilo",
    createProfile: "Crea profilo medico",
    saveProfile: "Salva profilo",
    saved: "Profilo salvato",
    saveError: "Errore salvataggio",
    freelance: "Libero professionista",
    licenseNumber: "N. iscrizione albo",
    licenseCountry: "Paese albo",
    licenseExpiry: "Scadenza iscrizione",
    licenseLabel: "Albo",
    expiresLabel: "Scade",
    specializations: "Specializzazioni",
    specHyperbaric: "Medicina iperbarica",
    specDive: "Medicina subacquea",
    specSports: "Medicina sportiva",
    specEmergency: "Medicina d'urgenza",
    institution: "Struttura / Ospedale",
    institutionPlaceholder: "Ospedale San Giovanni...",
    city: "Città",
    country: "Paese",
    bio: "Bio professionale",
    bioPlaceholder: "Breve presentazione professionale...",
    acceptsNewPatients: "Accetto nuovi pazienti",
    acceptsYes: "Accetta nuovi pazienti",
    acceptsNo: "Non accetta nuovi pazienti",
    publicProfile: "Profilo pubblico",
    publicYes: "Profilo pubblico",
    publicNo: "Profilo privato",
    newAssessment: "Nuova valutazione",
    newAssessmentTitle: "Nuova valutazione idoneità",
    assessmentCreated: "Valutazione creata",
    assessmentError: "Errore creazione valutazione",
    noAssessments: "Nessuna valutazione ancora.",
    patientId: "ID paziente (UUID)",
    outcome: "Esito",
    outcomeFit: "Idoneo",
    outcomeFitConditions: "Idoneo con limitaz.",
    outcomeUnfit: "Non idoneo",
    outcomePending: "In valutazione",
    conditions: "Condizioni / Limitazioni",
    conditionsPlaceholder: "Es. Evitare profondità >20m per 6 mesi",
    validUntil: "Valida fino al",
    validUntilLabel: "Valida fino al",
    notes: "Note",
    confidential: "Confidenziale (non visibile al paziente)",
    confidentialBadge: "Confidenziale",
    createAssessment: "Crea valutazione",
    patient: "Paziente",
  },
  safety: {
    title: "Sicurezza & Emergenze",
    subtitle: "Camere iperbariche, numeri di emergenza e scheda personale",
    locating: "Localizzazione...",
    findNearest: "Trova più vicina a me",
    found: "trovate vicino a te",
    nearest: "Più vicina",
    tabs: {
      chambers: "Camere Iperbariche",
      emergency: "Emergenza",
      card: "Scheda Personale",
      sos: "SOS",
    },
    emergency: {
      title: "Numeri di Emergenza",
      sar: "Guardia Costiera",
      protocol: "Protocollo Emergenza Sub",
      step1: "Portare il subacqueo in superficie — risalita controllata",
      step2: "Somministrare ossigeno al 100% se disponibile",
      step3: "Chiamare il 118 e il DAN (+39 06 4211 5685)",
      step4: "Mantenere orizzontale, idratare se cosciente",
      step5: "NON somministrare aspirina o ibuprofene",
      step6: "Raggiungere la camera iperbarica più vicina",
    },
    dcs: {
      title: "Sintomi Malattia da Decompressione",
      joint: "Dolori articolari",
      skin: "Prurito / macchie cutanee",
      fatigue: "Stanchezza anomala",
      neuro: "Disturbi neurologici",
      breathing: "Difficoltà respiratorie",
      chest: "Dolore toracico",
    },
    card: {
      title: "Scheda Emergenza Personale",
      print: "Stampa / PDF",
      bloodType: "Gruppo Sanguigno",
      certLevel: "Brevetto più alto",
      allergies: "Allergie",
      medications: "Farmaci in corso",
      emergencyContact: "Contatto emergenza",
      emergencyPhone: "Telefono emergenza",
      insurance: "Assicurazione",
      insuranceNumber: "Numero polizza",
    },
    sos: {
      title: "SOS Emergenza Subacquea",
      description: "Questo sistema invia un segnale di emergenza al DAN (Diver Alert Network) e ai tuoi contatti di emergenza.",
      realEmergencyOnly: "Usa solo in caso di reale emergenza subacquea.",
      activate: "ATTIVA SOS",
      alternativeCall: "In alternativa chiama direttamente:",
      danContacts: "Contatti DAN diretti",
      aboutToSend: "Stai per inviare un SOS al DAN. Compila i dati disponibili.",
      gpsPosition: "Posizione GPS",
      detecting: "Rilevamento…",
      detectPosition: "Rileva posizione",
      diveSite: "Sito di immersione (se noto)",
      diveSitePlaceholder: "es. Blue Hole, Sharm el-Sheikh",
      danNumber: "Numero tessera DAN (se disponibile)",
      message: "Messaggio",
      messagePlaceholder: "Descrivi la situazione…",
      sending: "Invio…",
      send: "INVIA SOS",
      sent: "SOS Inviato",
      sentDesc: "Il segnale di emergenza è stato trasmesso al DAN.",
      contactDirect: "Contatta direttamente",
      dontClose: "Non chiudere questa pagina finché non hai stabilito il contatto con i soccorsi.",
      locationDetected: "Posizione rilevata",
      locationError: "Impossibile rilevare la posizione",
      sendError: "Errore invio SOS. Chiama il DAN direttamente.",
    },
    nofly: {
      ok: "Volo consentito",
      okSub: "Il periodo di attesa è terminato",
      title: "No-Fly Timer",
      remaining: "rimanenti",
      rule: "Regola {{hours}} h — attendi prima di prendere un volo dopo l'immersione.",
    },
    addIncident: "Registra incidente",
    description: "Descrizione",
    incidentCreated: "Incidente registrato",
    incidentsIntro: "Registro degli incidenti e near-miss del centro.",
    incidentTitle: "Titolo",
    info: "Registra e traccia incidenti, report di sicurezza e audit. Richiesto dalla normativa (INAIL, L.70/2026) per i centri diving.",
    noAudits: "Nessun audit",
    noAuditsDesc: "Gli audit di sicurezza programmati e completati appariranno qui.",
    noIncidents: "Nessun incidente registrato",
    noIncidentsDesc: "Ottimo! Registra qui eventuali incidenti o near-miss per la compliance.",
    noReports: "Nessun report di sicurezza",
    noReportsDesc: "I report di ispezione e valutazione del rischio appariranno qui.",
    reportedOn: "Segnalato il",
    severity: "Gravità",
    tabAudits: "Audit",
    tabIncidents: "Incidenti",
    tabReports: "Report",
  },
  doctor: {
    pageTitle: "Portale Medico",
    pageSubtitle: "Gestisci i tuoi pazienti, avvisi e valutazioni",
    loading: "Caricamento…",
    tabs: {
      dashboard: "Dashboard",
      profile: "Profilo",
      patients: "Pazienti",
      requests: "Richieste",
      alerts: "Avvisi",
      assessments: "Valutazioni",
      plans: "Piani",
      symptoms: "Sintomi",
    },
    spec: {
      HYPERBARIC_MEDICINE: "Medicina iperbarica",
      DIVE_MEDICINE: "Medicina subacquea",
      SPORTS_MEDICINE: "Medicina dello sport",
      EMERGENCY_MEDICINE: "Medicina d'urgenza",
      CARDIOLOGY: "Cardiologia",
      PULMONOLOGY: "Pneumologia",
      NEUROLOGY: "Neurologia",
      INTERNAL_MEDICINE: "Medicina interna",
    },
    outcome: {
      FIT: "Idoneo",
      FIT_WITH_CONDITIONS: "Idoneo con condizioni",
      UNFIT: "Non idoneo",
      PENDING: "In attesa",
    },
    alertType: {
      HIGH_FREQUENCY: "Alta frequenza immersioni",
      YO_YO_PROFILE: "Profilo yo-yo (scuba)",
      BO_EVENT: "Sincope apnoica (BO)",
      LCM_EVENT: "Loss of Motor Control (LCM)",
      HIGH_FREQ_APNEA: "Alta frequenza apnee",
      DEEP_APNEA: "Apnea profonda (>30m)",
    },
    profile: {
      noProfile: "Profilo medico non ancora configurato",
      create: "Crea profilo",
      edit: "Modifica",
      editTitle: "Modifica profilo medico",
      licenseNumber: "N. iscrizione albo",
      licenseCountry: "Paese iscrizione (es. IT)",
      licenseExpiry: "Scadenza licenza",
      institution: "Istituto / Studio medico",
      city: "Città",
      country: "Paese (es. IT)",
      specializations: "Specializzazioni",
      bio: "Bio",
      acceptsNew: "Accetta nuovi pazienti",
      notAcceptsNew: "Non accetta nuovi pazienti",
      isPublic: "Profilo pubblico",
      public: "Pubblico",
      private: "Privato",
      licenseLabel: "Albo",
      licenseExpires: "Scadenza licenza",
      saving: "Salvo…",
      save: "Salva",
      cancel: "Annulla",
      medicalProfile: "Profilo medico",
    },
    patients: {
      noPatients: "Nessun paziente collegato",
      inviteFromRequests: "Invita pazienti dalla scheda Richieste",
      connectedOn: "Connesso il",
      dives: "immersioni",
      updatedOn: "aggiornate",
      sharedStats: "Statistiche condivise",
      statsUpdated: "Aggiornate",
      revokeAccess: "Revoca accesso",
      revokeConfirm: "Revocare accesso a questo paziente?",
      statsNotShared: "Statistiche non ancora condivise",
    },
    stats: {
      totalDives: "Immersioni totali",
      totalTime: "Tempo totale",
      maxDepth: "Profondità max",
      avgDepth: "Profondità media",
      countriesVisited: "Paesi visitati",
      divesLast30: "Immersioni (30gg)",
      apneaMaxDepth: "Apnea max profondità",
      apneaMaxTime: "Apnea max durata",
      syncopeLabel: "Sincopi (90gg)",
      lcmLabel: "LCM (90gg)",
    },
    requests: {
      title: "Richieste e inviti in attesa",
      invitePatient: "Invita paziente",
      inviteTitle: "Invita paziente per ID",
      patientIdPlaceholder: "User ID del paziente (UUID)",
      optionalMessage: "Messaggio opzionale",
      sendInvite: "Invia invito",
      sending: "Invio…",
      cancel: "Annulla",
      fromPatients: "Richieste dai pazienti",
      sentInvites: "Inviti inviati",
      noPending: "Nessuna richiesta in attesa",
      connectionRequest: "Richiesta connessione",
      inviteSent: "Invito inviato",
      pending: "In attesa",
    },
    alerts: {
      title: "Avvisi clinici",
      markAllRead: "Segna tutti letti",
      showAll: "Mostra tutti",
      unreadOnly: "Solo non letti",
      noAlerts: "Nessun avviso",
      noUnreadAlerts: "Nessun avviso non letto",
      patient: "Paziente",
      markRead: "Segna come letto",
    },
    assessments: {
      title: "Valutazioni idoneità",
      newAssessment: "+ Nuova valutazione",
      patient: "Paziente",
      selectPatient: "Seleziona paziente",
      patientIdPlaceholder: "User ID paziente (UUID)",
      outcome: "Esito",
      conditions: "Condizioni (se idoneo con riserve)",
      notes: "Note",
      validUntil: "Valida fino al",
      confidential: "Riservata",
      saving: "Salvo…",
      create: "Crea valutazione",
      cancel: "Annulla",
      noAssessments: "Nessuna valutazione emessa",
      conditionsLabel: "Condizioni",
      validUntilLabel: "Valida fino al",
      downloadCert: "Scarica certificato PDF",
    },
    plans: {
      title: "Piani di idoneità subacquea",
      newPlan: "+ Nuovo piano",
      editPlanTitle: "Modifica piano",
      createPlanTitle: "Crea piano di idoneità",
      patientLabel: "Paziente *",
      selectPatient: "Seleziona paziente",
      maxDepth: "Profondità max (m)",
      maxDuration: "Durata max (min)",
      maxDivesPerDay: "Immersioni/giorno max",
      noLimit: "nessun limite",
      forbiddenEnvs: "Ambienti vietati",
      requiredBuddy: "Buddy obbligatorio",
      oxygenRequired: "O₂ di emergenza richiesto",
      restrictions: "Restrizioni",
      restrictionsPlaceholder: "Descrivi eventuali restrizioni specifiche…",
      clinicalNotes: "Note cliniche",
      validUntil: "Valido fino al",
      saving: "Salvo…",
      update: "Aggiorna piano",
      createBtn: "Crea piano",
      cancel: "Annulla",
      noPlans: "Nessun piano di idoneità attivo",
      activePlans: "Piani attivi",
      pastPlans: "Piani precedenti",
      revokeConfirm: "Revocare questo piano?",
      statusActive: "Attivo",
      statusExpired: "Scaduto",
      statusRevoked: "Revocato",
      validUntilLabel: "valido fino al",
      divePerDay: "imm/giorno",
      envOpen: "Mare aperto",
      envPool: "Piscina",
      envConfined: "Acque confinate",
      envCave: "Grotta",
      envWreck: "Relitto",
      envNight: "Notturna",
      envAltitude: "Quota",
      envIce: "Ghiaccio",
      envDrift: "Corrente",
    },
    symptoms: {
      title: "Sintomi post-immersione",
      alertOnly: "Solo allerte",
      selectPatient: "Seleziona paziente",
      choosePlaceholder: "— scegli un paziente —",
      noPatientSelected: "Seleziona un paziente per vedere i sintomi",
      noSymptoms: "Nessun check sintomi registrato",
      noAlertSymptoms: "Nessun check sintomi con allerta registrato",
      doctorNotified: "medico notificato",
      symptomsReported: "sintomi segnalati",
      noRelevantSymptoms: "Nessun sintomo rilevante",
      notesLabel: "Note",
      earPain: "Dolore orecchio",
      sinusPain: "Dolore seni nasali",
      headache: "Cefalea",
      jointPain: "Dolori articolari",
      musclePain: "Dolori muscolari",
      skinRash: "Manifestazioni cutanee",
      fatigue: "Affaticamento",
      breathingDiff: "Difficoltà respiratorie",
      chestPain: "Dolore toracico",
      dizziness: "Vertigini",
      vision: "Problemi visivi",
      numbness: "Formicolio/intorpidimento",
      nausea: "Nausea",
    },
    dashboard: {
      noPatients: "Collega i tuoi pazienti per visualizzare la dashboard",
      patientsLinked: "Pazienti collegati",
      withStats: "con statistiche",
      totalDives: "Immersioni totali",
      activePlans: "Piani idoneità attivi",
      unreadAlerts: "Allerte non lette",
      highAlerts: "allerte HIGH",
      boEvents: "Sincopi (BO) ultimi 90gg",
      lcmEvents: "LCM ultimi 90gg",
      alertDistribution: "Distribuzione allerte per tipo",
      topPatients: "Pazienti più attivi (ultimi 30gg)",
      recentAlerts: "Ultime allerte",
      patientSummary: "Riepilogo pazienti",
      colPatient: "Paziente",
      colDives: "Immersioni",
      colLast30: "Ultimi 30gg",
      colMaxDepth: "Profondità max",
      colBO: "BO 90gg",
      colPlan: "Piano",
      planActive: "Attivo",
    },
  },
  dcExcursions: {
    pageTitle: "Gestione Escursioni",
    pageSubtitle: "Calendario, partecipanti e noleggi attrezzatura",
    newExcursion: "Nuova escursione",
    loading: "Caricamento…",
    tabs: {
      calendar: "Calendario escursioni",
      requests: "Richieste ricevute",
      rentals: "Noleggi attrezzatura",
    },
    certLevel: {
      NONE: "Nessuna",
      OPEN_WATER: "Open Water",
      ADVANCED: "Advanced",
      RESCUE_DM: "Rescue / DM",
      TECHNICAL: "Tecnico",
    },
    excursionType: {
      TECHNICAL: "Tecnica",
      RECREATIONAL: "Ricreativa",
      BOTH: "Tecnica & Ricreativa",
    },
    rentalStatus: {
      RESERVED: "Prenotata",
      RENTED: "In uso",
      RETURNED: "Restituita",
      CANCELLED: "Annullata",
    },
    form: {
      title: "Nuova escursione",
      titleLabel: "Titolo *",
      description: "Descrizione",
      startDate: "Data inizio *",
      endDate: "Data fine",
      meetingTime: "Orario raduno",
      meetingPoint: "Punto di raduno",
      site: "Sito / Luogo",
      diveType: "Tipo immersione",
      selectDiveType: "— Seleziona —",
      minDepth: "Profondità min (m)",
      maxDepth: "Profondità max (m)",
      minCert: "Brevetto minimo",
      anyCert: "— Qualsiasi —",
      maxParticipants: "Posti max",
      cost: "Costo (€)",
      cancellationDeadline: "Termine cancellazione (ore prima)",
      isPublic: "Escursione pubblica (visibile a tutti)",
      cancel: "Annulla",
      creating: "Creazione…",
      create: "Crea escursione",
      created: "Escursione creata",
      error: "Errore",
    },
    card: {
      statusPublished: "Pubblicata",
      statusCancelled: "Annullata",
      statusCompleted: "Completata",
      statusDraft: "Bozza",
      publish: "Pubblica",
      published: "Escursione pubblicata",
      participants: "iscritti",
      certLabel: "Brevetto",
      maxLabel: "Max",
    },
    requests: {
      requester: "Richiedente",
      proposedDate: "Data proposta",
      site: "Sito",
      maxDepth: "Profondità max",
      statusAccepted: "Accettata",
      statusRejected: "Rifiutata",
      statusModified: "Modificata",
      statusPending: "In attesa",
      responsePlaceholder: "Note risposta (opzionale)",
      accept: "Accetta",
      reject: "Rifiuta",
      responseSent: "Risposta inviata",
      noRequests: "Nessuna richiesta ricevuta.",
      error: "Errore",
    },
    rentals: {
      selectExcursion: "Seleziona escursione",
      choosePlaceholder: "— Scegli escursione —",
      addRental: "Aggiungi noleggio",
      participantId: "ID Partecipante *",
      equipmentType: "Tipo attrezzatura",
      equipmentTypePlaceholder: "es. Muta, Bombola, GAV…",
      equipmentName: "Nome attrezzatura",
      price: "Prezzo (€)",
      adding: "Aggiunta…",
      add: "Aggiungi noleggio",
      added: "Noleggio aggiunto",
      statusUpdated: "Stato aggiornato",
      noRentals: "Nessun noleggio registrato per questa escursione.",
      colEquipment: "Attrezzatura",
      colParticipant: "Partecipante",
      colPrice: "Prezzo",
      colStatus: "Stato",
      error: "Errore",
    },
    calendar: {
      noExcursions: "Nessuna escursione ancora.",
      createFirst: "Crea la prima escursione",
    },
  },
  charter: {
    nav: {
      myCharter: "Il mio Charter",
      fleet: "Flotta",
      equipment: "Attrezzatura",
      bookings: "Prenotazioni",
      browse: "Trova Charter",
    },
    company: {
      title: "Azienda Charter",
      notRegistered: "Non hai ancora registrato un'azienda charter.",
      subtitle: "Gestisci la tua azienda di noleggio imbarcazioni per le immersioni.",
      registerBtn: "Registra azienda charter",
      editBtn: "Modifica",
      cancelBtn: "Annulla",
      saveBtn: "Salva",
      created: "Azienda charter registrata",
      createError: "Errore nella registrazione",
      saved: "Modifiche salvate",
      pendingVerification: "In attesa di verifica",
      saveError: "Errore nel salvataggio",
      verifiedBadge: "Verificata",
      register: "Registra azienda",
      save: "Salva",
      edit: "Modifica",
      name: "Nome azienda",
      legalName: "Ragione sociale",
      registrationNumber: "N. registrazione",
      vatNumber: "Partita IVA",
      homePort: "Porto base",
      country: "Paese",
      city: "Città",
      address: "Indirizzo",
      phone: "Telefono",
      email: "Email",
      website: "Sito web",
      description: "Descrizione",
      insurancePolicyNumber: "N. polizza assicurativa",
      insuranceExpiresAt: "Scadenza assicurazione",
      isVerified: "Verificato",
      fields: {
        name: "Nome azienda",
        legalName: "Ragione sociale",
        registrationNumber: "N. registrazione",
        vatNumber: "Partita IVA",
        homePort: "Porto base",
        country: "Paese",
        city: "Città",
        address: "Indirizzo",
        phone: "Telefono",
        email: "Email",
        website: "Sito web",
        description: "Descrizione",
        insurancePolicyNumber: "N. polizza assicurativa",
        insuranceExpiresAt: "Scadenza assicurazione",
      },
    },
    vessel: {
      title: "Imbarcazione",
      add: "Aggiungi imbarcazione",
      addBtn: "Aggiungi imbarcazione",
      editBtn: "Modifica",
      deleted: "Imbarcazione eliminata",
      saved: "Imbarcazione salvata",
      saveError: "Errore nel salvataggio",
      noVessels: "Nessuna imbarcazione",
      perPerson: "a persona",
      fields: {
        name: "Nome",
        vesselType: "Tipo di imbarcazione",
        registration: "Matricola",
        homePort: "Porto base",
        capacityPersons: "Capienza (persone)",
        yearBuilt: "Anno di costruzione",
        navigationLimit: "Limite di navigazione",
        requiresCaptain: "Richiede skipper",
        insurancePolicyNo: "N. polizza assicurativa",
        insuranceExpiresAt: "Scadenza assicurazione",
        description: "Descrizione",
      },
      edit: "Modifica",
      delete: "Elimina",
      name: "Nome",
      registration: "Matricola",
      type: "Tipo",
      capacity: "Capienza (persone)",
      pricePerDay: "Prezzo/giorno (€)",
      pricePerHalfDay: "Prezzo/mezza giornata (€)",
      includedItems: "Incluso nel prezzo",
      requiresCaptain: "Richiede skipper",
      insurance: "Assicurazione scafo",
      insuranceExpiry: "Scadenza assicurazione",
      types: {
        RIGID_INFLATABLE: "Gommone (RIB)",
        MOTOR_YACHT: "Motoryacht",
        SAILING_YACHT: "Barca a vela",
        CATAMARAN: "Catamarano",
        SPEEDBOAT: "Motoscafo",
        GULET: "Gulet",
        DIVING_TENDER: "Gommone sub",
        OTHER: "Altro",
      },
    },
    equipment: {
      title: "Attrezzatura",
      add: "Aggiungi attrezzatura",
      addBtn: "Aggiungi attrezzatura",
      deleted: "Attrezzatura eliminata",
      saved: "Attrezzatura salvata",
      saveError: "Errore nel salvataggio",
      noItems: "Nessuna attrezzatura",
      maintenanceNeeded: "Manutenzione necessaria",
      maintenanceOk: "Manutenzione in regola",
      fields: {
        name: "Nome",
        category: "Categoria",
        manufacturer: "Produttore",
        modelName: "Modello",
        serialNumber: "Numero seriale",
        quantity: "Quantità",
        maintenanceUpToDate: "Manutenzione in regola",
        description: "Descrizione",
      },
      serialNumber: "Numero seriale",
      manufacturer: "Produttore",
      model: "Modello",
      pricePerDay: "Prezzo/giorno",
      maintenanceUpToDate: "Manutenzione in regola",
      registrationDoc: "Doc. registrazione",
      insuranceDoc: "Doc. assicurazione",
      available: "Disponibile",
      categories: {
        CYLINDER: "Bombola",
        REGULATOR: "Erogatore",
        BCD: "GAV",
        WETSUIT: "Muta",
        DRYSUIT: "Stagna",
        DIVE_COMPUTER: "Computer",
        MASK_FIN_SNORKEL: "Maschera/Pinne/Boccaglio",
        SAFETY_GEAR: "Presidi sicurezza",
        LIFE_JACKET: "Giubbotto di salvataggio",
        KAYAK: "Kayak",
        PADDLEBOARD: "Stand-up paddle",
        SNORKELING_SET: "Set snorkeling",
        OTHER: "Altro",
      },
    },
    bookings: {
      title: "Prenotazioni",
      updated: "Prenotazione aggiornata",
      updateError: "Errore nell'aggiornamento",
      status: {
        PENDING: "In attesa",
        CONFIRMED: "Confermata",
        CANCELLED: "Annullata",
      },
      confirm: "Conferma",
      cancel: "Annulla",
      noBookings: "Nessuna prenotazione",
      startDate: "Data inizio",
      endDate: "Data fine",
      participants: "Partecipanti",
      total: "Totale",
      notes: "Note",
    },
    browse: {
      title: "Noleggio barche",
      subtitle: "Trova e prenota barche per le tue immersioni",
      searchPlaceholder: "Cerca per nome, città…",
      filterCountry: "Paese",
      filterPort: "Porto",
      filterType: "Tipo imbarcazione",
      noResults: "Nessuna azienda charter trovata.",
      bookBtn: "Prenota",
      viewDetails: "Dettagli",
      priceFrom: "Da",
      perDay: "/ giorno",
      vesselCount: "imbarcazioni",
      verifiedOnly: "Solo verificate",
    },
  },
  dcBoats: {
    title: "Gestione flotta",
    subtitle: "Barche, assicurazioni, presidi di sicurezza e manutenzione",
    addBoat: "Aggiungi imbarcazione",
    noBoats: "Nessuna imbarcazione registrata",
    tabs: {
      general: "Dati generali",
      insurance: "Assicurazione",
      safety: "Presidi sicurezza",
      maintenance: "Manutenzione",
      usage: "Utilizzo",
    },
    fields: {
      name: "Nome",
      registration: "Matricola",
      capacityPersons: "Capienza (persone)",
      engineType: "Tipo motore",
      fuelCapacityL: "Carburante (L)",
      boatType: "Tipo imbarcazione",
      lengthM: "Lunghezza (m)",
      beamM: "Baglio (m)",
      draftM: "Pescaggio (m)",
      maxSpeedKnots: "Velocità max (nodi)",
      navigationLimit: "Categoria navigazione",
      homePort: "Porto base",
      yearBuilt: "Anno costruzione",
      notes: "Note",
      isActive: "Attiva",
    },
    insurance: {
      title: "Polizze assicurative",
      addPolicy: "Aggiungi polizza",
      policyNumber: "N. polizza",
      insurer: "Compagnia",
      coverageType: "Tipo copertura",
      startDate: "Data inizio",
      expiryDate: "Scadenza",
      premium: "Premio annuo (€)",
      notes: "Note",
      noPolicies: "Nessuna polizza registrata",
      coverageTypes: {
        CIVIL_LIABILITY: "Responsabilità civile",
        HULL: "Corpo del natante",
        FULL: "Copertura completa",
      },
      status: {
        active: "Attiva",
        expired: "Scaduta",
        expiringSoon: "In scadenza",
      },
    },
    safety: {
      title: "Presidi di sicurezza",
      addItem: "Aggiungi presidio",
      name: "Nome",
      category: "Categoria",
      quantity: "Qtà",
      serialNumber: "Numero seriale",
      expiryDate: "Scadenza",
      lastChecked: "Ultimo controllo",
      notes: "Note",
      noItems: "Nessun presidio registrato",
      categories: {
        LIFE_RAFT: "Zattera di salvataggio",
        FIRE_EXT: "Estintore",
        FLARE: "Razzi",
        O2_KIT: "Kit ossigeno",
        FIRST_AID: "Pronto soccorso",
        LIFE_JACKET: "Giubbotti di salvataggio",
        EPIRB: "EPIRB",
        VHF: "Radio VHF",
        ANCHOR: "Ancora",
        OTHER: "Altro",
      },
    },
    maintenance: {
      title: "Storico manutenzione",
      addLog: "Registra intervento",
      type: "Tipo",
      performedAt: "Data",
      performedBy: "Eseguito da",
      cost: "Costo (€)",
      notes: "Note",
      nextDueDate: "Prossima scadenza",
      noLogs: "Nessun intervento registrato",
      types: {
        ENGINE_SERVICE: "Servizio motore",
        HULL_ANTIFOUL: "Antivegetativa scafo",
        SAFETY_CHECK: "Controllo sicurezza",
        BILGE_PUMP: "Servizio sentinella",
        ELECTRICAL: "Impianto elettrico",
        RIGGING: "Attrezzatura velica",
        HAUL_OUT: "Alaggio",
        OTHER: "Altro",
      },
    },
    usage: {
      title: "Log utilizzo",
      noLogs: "Nessuna uscita nel periodo",
      linkedTo: "Collegato a",
      date: "Data",
      captain: "Skipper",
      passengers: "Passeggeri",
      fuelUsed: "Carburante (L)",
      distance: "Distanza (nm)",
    },
    saving: "Salvataggio…",
    insuranceStepInsurer: "Assicuratore",
    insuranceStepCoverageDates: "Copertura e Date",
    insuranceStepConfirm: "Conferma",
    safetyStepItemCategory: "Articolo e Categoria",
    safetyStepSerialDates: "Seriale e Date",
    safetyStepNotesConfirm: "Note e Conferma",
    maintStepTypeDate: "Tipo e Data",
    maintStepResponsibleCost: "Responsabile e Costo",
    maintStepDueNotes: "Scadenza e Note",
    addStepData: "Dati Barca",
    addStepDetailsConfirm: "Dettagli e Conferma",
  },
  staffRequests: {
    title: "Staff nei Centri",
    subtitle: "Gestisci gli inviti ricevuti dai centri e le tue richieste di ingresso.",
    tabs: {
      invites: "Inviti ricevuti",
      requests: "Le mie richieste",
    },
    status: {
      PENDING: "In attesa",
      APPROVED: "Approvato",
      REJECTED: "Rifiutato",
      CANCELLED: "Annullato",
    },
    invite: {
      callout: "Un centro ti ha invitato nel team",
      proposedRole: "Ruolo proposto:",
      center: "Centro immersioni",
      centerCode: "ID Centro",
      note: "Messaggio dal centro:",
      receivedOn: "Ricevuto il {{date}}",
      pending: {
        title: "Inviti in attesa di risposta",
        empty: "Nessun invito in attesa",
        emptyHint: "Quando un centro ti invita nel team, lo trovi qui.",
      },
      history: "Storico inviti",
      accept: "Accetta e unisciti al team",
      reject: "Rifiuta",
      accepted: "Invito accettato! Sei ora membro dello staff del centro.",
      rejected: "Invito rifiutato.",
      errAccept: "Errore durante l'accettazione.",
      errReject: "Errore durante il rifiuto.",
    },
    request: {
      title: "Richiedi di entrare in un centro",
      subtitle: "Il manager riceverà la richiesta e potrà approvarla o rifiutarla.",
      new: "+ Nuova richiesta",
      cancel: "Annulla",
      step1: {
        label: "ID del centro di immersione",
        hint: "Trovalo sulla pagina pubblica del centro: Esplora Centri → [nome centro] → copia ID dalla URL",
      },
      step2: {
        label: "Che ruolo vorresti ricoprire?",
      },
      step3: {
        label: "Presentati al manager",
        optional: "(opzionale)",
        placeholder: "Ciao, sono un istruttore PADI con 5 anni di esperienza in acque tropicali…",
      },
      send: "Invia richiesta al centro",
      sending: "Invio in corso…",
      sent: "Richiesta inviata! Il manager del centro la valuterà.",
      errSend: "Errore durante l'invio della richiesta.",
      list: {
        title: "Le tue richieste ({{count}})",
        empty: "Non hai ancora inviato richieste",
        emptyHint: "Invia la tua prima richiesta →",
      },
      stat: {
        approved: "Richiesta approvata — sei nel team!",
        rejected: "Richiesta non accettata",
        pending: "Richiesta in attesa di risposta",
      },
      requestedRole: "Ruolo richiesto:",
      centreId: "Centro:",
      sentOn: "Inviata il {{date}}",
      resolvedOn: "· Risposta il {{date}}",
    },
  },
  catalogue: {
    title: "Catalogo attrezzatura subacquea",
    subtitle: "{{count}} prodotti dai migliori brand al mondo",
    search: "Cerca per modello o brand…",
    allBrands: "Tutti i brand",
    all: "Tutti",
    sport: "Sport:",
    sportAll: "Tutti",
    sportFreediving: "🌊 Apnea/Freediving",
    sportUwPhoto: "📷 Foto/Video",
    found: "{{count}} prodotto/i trovati",
    noResults: "Nessun prodotto trovato",
    noResultsHint: "Prova con una ricerca diversa",
    weight: "Peso:",
    specs: "Specifiche tecniche",
    maintenance: "Manutenzione consigliata",
    manufacturerSite: "Sito produttore",
    addToInventory: "Aggiungi all'inventario",
    noSpecs: "Nessuna specifica disponibile",
    modal: {
      title: "Aggiungi al mio inventario",
      addTo: "Aggiungi a",
      diver: "Il mio inventario personale",
      center: "Inventario centro ({{name}})",
      serial: "Numero di serie",
      serialPh: "es. SN-ABC-123456 (opzionale)",
      purchaseDate: "Data di acquisto",
      hint: "Verrà aggiunto alla tua pagina La mia attrezzatura con piano di manutenzione già impostato.",
      cancel: "Annulla",
      save: "Aggiungi",
      saving: "Salvataggio…",
      success: "Attrezzatura aggiunta e piani inizializzati!",
      error: "Errore durante il salvataggio",
    },
    maintenanceNotes: {
      CYLINDER: "Ispezione visiva ogni 30 mesi · Prova idrostatica ogni 5 anni (EN ISO 18119:2018)",
      REGULATOR: "Revisione completa ogni 12 mesi o 100 immersioni (EN 250:2014)",
      BCD: "Ispezione inflator e valvole ogni 12 mesi (EN 1809:2014)",
      DRYSUIT: "Revisione guarnizioni e cerniera ogni 24 mesi (EN 14225-2:2017)",
      DIVE_COMPUTER: "Sostituzione batteria ogni 24 mesi · Aggiornamento firmware periodico",
      TECHNICAL: "Revisione completa ogni 12 mesi / 50 immersioni · Sostituzione celle O₂ ogni 18 mesi (EN 14143:2013)",
      SAFETY_GEAR: "Ispezione annuale obbligatoria per legge",
      TORCH: "Sostituzione O-ring ogni 24 mesi",
    },
    boolYes: "Sì",
    boolNo: "No",
    from: "da",
    freedivingBadge: "Apnea",
    photoBadge: "Foto",
    spec: {
      capacityL: "Capacità (L)",
      capacityCF: "Capacità (CF)",
      pressureBar: "Pressione (bar)",
      material: "Materiale",
      valveType: "Valvola",
      threadType: "Filettatura",
      buoyancyFull: "Galleggiabilità piena (kg)",
      buoyancyEmpty: "Galleggiabilità vuota (kg)",
      firstStageType: "1° stadio",
      secondStageType: "2° stadio",
      portsDIN: "Porte HP (DIN)",
      portsLowPressure: "Porte BP",
      airflowLpm: "Portata aria (L/min)",
      coldWaterRated: "Acque fredde cert.",
      coldWaterCertified: "Norma acque fredde",
      nitroxReady: "Nitrox ready",
      titaniumConstruction: "Costruzione titanio",
      autoClosureDevice: "Auto-chiusura",
      secondStageMaterial: "Mat. 2° stadio",
      type: "Tipo",
      liftKg: "Portata (kg)",
      liftKgDoubleTank: "Portata doppia (kg)",
      liftKgSingleTank: "Portata singola (kg)",
      weightPockets: "Tasche pesi",
      ditchableWeight: "Pesi sgancio",
      bladder: "Bladder",
      trekLock: "Trek-Lock",
      SLS: "SLS",
      sizes: "Taglie",
      backplateMaterial: "Backplate",
      thicknessMm: "Spessore (mm)",
      tempRangeC: "Temperatura (°C)",
      eco: "Materiale eco",
      zipType: "Tipo zip",
      sealMaterial: "Guarnizioni",
      pValve: "Valvola P",
      ISS: "ISS",
      telescopicTorso: "Torso telescopico",
      algorithm: "Algoritmo",
      gasMixes: "Gas mix",
      maxDepthM: "Profondità max (m)",
      airIntegration: "Integrazione aria",
      display: "Display",
      battery: "Batteria",
      diveMode: "Modalità",
      bluetooth: "Bluetooth",
      wifi: "Wi-Fi",
      GPS: "GPS",
      logbook: "Logbook",
      formFactor: "Formato",
      smartwatchFeatures: "Funzioni smartwatch",
      heartRateMonitor: "Cardiofrequenzimetro",
      lumens: "Lumen",
      burnTime: "Autonomia max",
      burnTimeLow: "Autonomia min",
      depth: "Prof. max (m)",
      chargeTime: "Carica (h)",
      beamAngle: "Angolo fascio (°)",
      bladeMaterial: "Mat. lama",
      bladeLength: "Lunghezza lama (cm)",
      bladeType: "Taglio",
      sheathMount: "Porta-coltello",
      rustproof: "Inossidabile",
      clickLockRetainer: "Click-lock",
      lengthCm: "Lunghezza (cm)",
      diameterCm: "Diametro (cm)",
      color: "Colore",
      sealType: "Tenuta",
      visible: "Visibilità",
      inflationMethod: "Gonfiaggio",
      sealed: "Sigillata",
      liftKgSMB: "Portata SMB (kg)",
      includes: "Include",
      maxBar: "Pressione max (bar)",
      gaugeDiameterMm: "Diametro (mm)",
      caseMaterial: "Materiale",
      oxygenSensors: "Celle O₂",
      scrubberType: "Scrubber",
      diluent: "Diluente",
      certification: "Certificazione",
      certificationLevel: "Livello cert.",
      lensType: "Tipo lente",
      skirtMaterial: "Gonnellino",
      frameMaterial: "Telaio",
      antiReflective: "Anti-riflesso",
      tempered: "Temperato",
      lowVolume: "Basso volume",
      style: "Stile pinna",
      bladeMaterialFin: "Mat. lama",
      thrustType: "Propulsione",
      pocketMaterial: "Mat. scarpetta",
      split_pivot_compound: "Split-pivot",
      note: "Note",
      blade: "Lama pinna",
      stiffness: "Rigidità",
      footPocket: "Scarpetta",
      adjustableFoot: "Scarpetta regolabile",
      internalVolumeCl: "Vol. interno (cl)",
      frameless: "Frameless",
      noseEqualisation: "Compensazione nasale",
      massKg: "Massa (kg)",
      quickRelease: "Sgancio rapido",
      maxWeightKg: "Peso max (kg)",
      videoMax: "Video max",
      photoMp: "Foto (MP)",
      waterproofWithoutCaseM: "WP senza housing (m)",
      waterproofWithCaseM: "WP con housing (m)",
      stabilisation: "Stabilizzazione",
      displayFront: "Display frontale",
      displayRear: "Display posteriore",
      guideNumber: "N. guida",
      recylceTime: "T. riciclo",
      batteryAA: "Batterie AA",
      sync: "Sincronizzazione",
      dropProof: "Antiurto",
      freezeProof: "Antigelo",
      crushProofKgf: "Antiurto (kgf)",
      gps: "GPS",
      magnification: "Ingrandimento",
      fov: "Campo visivo",
      bayonetMount: "Attacco bayonetta",
      sport: "Sport",
    },
  },
  adminPromo: {
    title: "Promozioni Diving",
    subtitle: "Gestisci le promozioni mostrate nel carosello della homepage",
    new: "Nuova promozione",
    loading: "Caricamento…",
    empty: "Nessuna promozione ancora.",
    createFirst: "Crea la prima",
    active: "Attiva",
    inactive: "Inattiva",
    calendarCount: "{{count}} date nel calendario",
    edit: "Modifica",
    delete: "Elimina",
    deleteConfirm: "Eliminare questa promozione?",
    created: "Promozione creata",
    updated: "Promozione aggiornata",
    deleted: "Promozione eliminata",
    error: "Errore durante il salvataggio",
    errorUpdate: "Errore durante l'aggiornamento",
    errorDelete: "Errore durante l'eliminazione",
    form: {
      title: "Titolo *",
      subtitle: "Sottotitolo",
      divingName: "Nome del diving *",
      location: "Località *",
      price: "Prezzo *",
      sortOrder: "Ordine di visualizzazione",
      ctaUrl: "Link prenotazione (CTA)",
      ctaLabel: "Testo pulsante CTA",
      startsAt: "Attivo dal",
      endsAt: "Attivo fino al",
      active: "Promozione attiva (visibile in homepage)",
      photos: "Foto (URL)",
      calendar: "Calendario immersioni",
      cancel: "Annulla",
      save: "Salva",
      addDate: "Aggiungi data",
      addPhoto: "Aggiungi foto",
      spots: "Posti",
    },
  },
  myGear: {
    title: "La mia attrezzatura",
    subtitle: "Gestisci la tua attrezzatura subacquea",
    add: "Aggiungi attrezzatura",
    search: "Cerca attrezzatura…",
    filter: {
      all: "Tutta",
    },
    empty: {
      title: "Nessuna attrezzatura",
      desc: "Aggiungi la tua prima attrezzatura per tenere traccia di manutenzioni e scadenze",
    },
    status: {
      ok: "OK",
      expiring: "In scadenza",
      expired: "Scaduto",
    },
    alert: {
      expired: "{{count}} attrezzatura con manutenzione scaduta",
      expiring: "{{count}} in scadenza entro 30 giorni",
    },
    modal: {
      title: "Aggiungi attrezzatura",
      catalogueSearch: "Cerca nel catalogo (facoltativo)",
      catalogueHint: "Cerca marca o modello per compilare automaticamente",
      name: "Nome modello *",
      manufacturer: "Marca *",
      category: "Categoria *",
      serial: "Numero seriale",
      purchaseDate: "Data acquisto",
      notes: "Note",
      cancel: "Annulla",
      save: "Aggiungi attrezzatura",
      saving: "Aggiunta…",
      added: "Attrezzatura aggiunta e piano manutenzione inizializzato!",
      error: "Errore durante il salvataggio",
    },
    categories: {
      CYLINDER: "Bombola",
      REGULATOR: "Erogatore",
      BCD: "GAV",
      WETSUIT: "Muta umida",
      DRYSUIT: "Muta stagna",
      DIVE_COMPUTER: "Computer subacqueo",
      ANALOG_INSTRUMENT: "Strumenti",
      MASK_FIN_SNORKEL: "Maschera/Pinne",
      SAFETY_GEAR: "Sicurezza",
      TECHNICAL: "Tecnico/CCR",
      TORCH: "Torcia",
      KNIFE: "Coltello",
      SURFACE_MARKER: "Boa SMB",
      OTHER: "Altro",
    },
    lastService: "Ultima manutenzione",
    nextService: "Prossima manutenzione",
    viewDetail: "Vedi dettaglio",
    maintenanceTypes: {
      VISUAL_INSPECTION: "Ispezione visiva",
      FULL_SERVICE: "Revisione completa",
      HYDROSTATIC_TEST: "Test idrostatico",
      FUNCTIONAL_TEST: "Test funzionale",
      BATTERY_REPLACEMENT: "Sostituzione batteria",
      SEAL_REPLACEMENT: "Sostituzione guarnizioni",
      PARTS_REPLACEMENT: "Sostituzione parti",
      FIRMWARE_UPDATE: "Aggiornamento firmware",
      OTHER: "Altro",
    },
    performedBy: {
      AUTHORIZED_CENTER: "Centro autorizzato",
      CERTIFIED_TECHNICIAN: "Tecnico certificato",
      OWNER: "Proprietario",
    },
    plan: {
      mandatory: "Obbligatorio",
      everyMonths: "Ogni {{n}} mesi",
      orEveryDives: "o ogni {{n}} immersioni",
      count: "{{count}} piano/i di manutenzione",
      autoInit: "↺ Auto-inizializza da template",
      initing: "Inizializzazione…",
      empty: "Nessun piano impostato",
      emptyHint: "Clicca \"Auto-inizializza\" per aggiungere automaticamente i piani raccomandati",
      added: "{{count}} piani aggiunti automaticamente",
      errInit: "Errore durante l'inizializzazione",
    },
    tabs: {
      info: "Informazioni",
      plans: "Piano manutenzione",
      history: "Storico interventi",
      usage: "Utilizzi",
    },
    info: {
      category: "Categoria",
      brand: "Brand",
      model: "Modello",
      modelCode: "Codice modello",
      serial: "Numero di serie",
      purchaseDate: "Data acquisto",
      nextDue: "Prossima scadenza",
      notes: "Note",
      warranty: "Garanzia",
      warrantyExpired: "Scaduta il {{date}}",
      warrantyExpires: "Scade il {{date}} ({{days}} giorni)",
    },
    dangerZone: {
      title: "Zona pericolosa",
      retire: "Ritira dall'inventario",
      retireConfirm: "Ritirare questa attrezzatura dall'inventario?",
      retired: "Attrezzatura ritirata",
    },
    log: {
      title: "Registra intervento",
      type: "Tipo intervento *",
      date: "Data *",
      nextDue: "Prossima scadenza",
      by: "Eseguito da",
      techName: "Nome officina / tecnico",
      techNamePlaceholder: "Opzionale",
      cost: "Costo (€)",
      notes: "Note",
      notesPh: "Parti sostituite, osservazioni…",
      cancel: "Annulla",
      save: "Registra",
      saving: "Salvataggio…",
      success: "Intervento registrato!",
      error: "Errore durante il salvataggio",
    },
    history: {
      logButton: "Registra intervento",
      noEvents: "Nessun intervento registrato",
      noEventsHint: "Registra il primo intervento di manutenzione",
      next: "Prossima:",
    },
    usageLog: {
      noUsage: "Nessun utilizzo registrato",
      noUsageHint: "Gli utilizzi vengono registrati automaticamente quando assegni l'attrezzatura a un'immersione",
    },
    saved: "Salvato",
    notFound: "Attrezzatura non trovata.",
  },
  merch: {
    hero: {
      badge: "Merchandising Ufficiale",
      title: "Shop eDive",
      subtitle: "Prodotti brandizzati eDive · Pagamento in USDT (criptovaluta)",
    },
    categories: {
      all: "Tutti",
      CLOTHING: "Abbigliamento",
      ACCESSORIES: "Accessori",
      STICKERS: "Adesivi",
    },
    selectSize: "Seleziona taglia",
    format: "Formato",
    addToCart: "Aggiungi",
    addedToCart: "Aggiunto al carrello!",
    noProducts: "Nessun prodotto disponibile",
    cart: {
      title: "Carrello",
      empty: "Il carrello è vuoto",
      total: "Totale",
      disclaimer: "L'importo esatto (con decimali unici) verrà mostrato al checkout",
      checkout: "Procedi al pagamento",
    },
    checkout: {
      shipping: "Dati di spedizione",
      payment: "Pagamento USDT",
      confirmed: "Ordine confermato",
      orderSummary: "Riepilogo ordine",
      email: "Email *",
      fullName: "Nome completo *",
      address: "Indirizzo *",
      city: "Città *",
      zip: "CAP *",
      country: "Paese *",
      phone: "Telefono",
      continue: "Continua al pagamento",
      creating: "Creazione ordine…",
      sendExact: "Invia esattamente questo importo",
      uniqueDecimals: "L'importo include 3 cifre decimali univoche per identificare il tuo pagamento",
      walletAddress: "Indirizzo wallet",
      notConfigured: "Indirizzo non configurato",
      trc20Title: "Rete Tron (TRC20)",
      trc20Warning: "Usa USDT sulla rete Tron (TRC20). Non inviare ERC20 o BEP20 su questo indirizzo.",
      txHashLabel: "Hai già pagato? Inserisci il TX Hash (opzionale)",
      txHashPlaceholder: "Incolla l'hash della transazione...",
      confirm: "Conferma pagamento",
      verifying: "Verifica in corso…",
      orderExpiry: "Ordine #{{number}} · Scade tra 24h",
      closeReturn: "Puoi anche chiudere questa finestra e tornare in \"I miei ordini\" per aggiornare il pagamento",
      confirmedTitle: "Pagamento confermato!",
      processing: "Il tuo ordine è in elaborazione",
      close: "Chiudi",
    },
    validation: {
      required: "Obbligatorio",
      invalidEmail: "Email non valida",
      orderError: "Errore nella creazione dell'ordine",
      verifyError: "Errore nella verifica",
    },
    info: {
      crypto: {
        title: "Pagamento Crypto",
        desc: "Accettiamo USDT su rete TRC20 (Tron). Nessuna commissione bancaria.",
      },
      shipping: {
        title: "Spedizione Mondiale",
        desc: "Spediamo in tutto il mondo. Tempi: 5-10 giorni lavorativi in Italia.",
      },
      quality: {
        title: "Qualità Garantita",
        desc: "Prodotti premium con logo eDive. Sostituzione gratuita in caso di difetti.",
      },
    },
  },
  certPrerequisites: {
    title: "Prerequisiti certificazioni",
    subtitle: "Immersioni qualificanti per i prossimi brevetti",
    qualifiedSummary: "certificazioni per cui sei già qualificato",
    alreadyOwnedCount: "{{count}} già ottenuti",
    qualifiedMessage_one: "Hai già raggiunto i prerequisiti per {{count}} brevetto. Contatta il tuo centro sub per procedere con l'iscrizione!",
    qualifiedMessage_other: "Hai già raggiunto i prerequisiti per {{count}} brevetti. Contatta il tuo centro sub per procedere con l'iscrizione!",
    badgeAlreadyOwned: "Già ottenuto",
    badgeQualified: "Qualificato",
    recommendedLabel: "Prossimo passo consigliato",
    findCourse: "Trova corso",
    readyToEnroll: "Hai già tutti i prerequisiti — sei pronto per iscriverti a questo corso.",
    myQualifyingDives: "Le tue immersioni qualificanti",
    certRequirements: "Requisiti per brevetto",
    disclaimer: "I requisiti indicati sono orientativi e basati sulle linee guida PADI/SSI. Possono variare per agenzia e location. Consulta sempre il tuo istruttore per conferma.",
    noData: "Nessun dato disponibile. Registra alcune immersioni per vedere i prerequisiti.",
    countTotal: "Totale",
    countNight: "Notturne",
    count18m: "≥18 m",
    count30m: "≥30 m",
    count40m: "≥40 m",
    countDeco: "Deco",
    countCave: "Grotta",
    countWreck: "Relitto",
    countIce: "Ghiaccio",
    countDrysuit: "Muta stagna",
    countFreediving: "Apnea",
    countDrift: "Deriva",
    prereqTotalDives: "Immersioni totali",
    prereqNightDives: "Immersioni notturne",
    prereqDeepDives18: "Immersioni >18 m",
    prereqWreckDives: "Immersioni su relitto",
    prereqDriftDives: "Immersioni in deriva",
    prereqDrysuitDives: "Immersioni muta stagna",
    prereqIceDives: "Immersioni sub-ghiaccio",
    prereqCaveDives: "Immersioni in grotta",
    prereqDecoDives: "Immersioni decompressione",
    prereqDeepDives30: "Immersioni >30 m",
    prereqFreedivingDives: "Immersioni in apnea",
    descDeepDiver18m: "Almeno 4 immersioni a profondità ≥ 18 m",
    qualifiedMessage: "Hai già tutti i requisiti per iscriverti a {{count}} nuovi brevetti: è il momento perfetto per fare il prossimo passo!",
  },
  dcWidget: {
    customizationTitle: "Personalizzazione",
    primaryColorLabel: "Colore principale",
    langLabel: "Lingua",
    langIt: "Italiano",
    langEn: "English",
    howToTitle: "Come integrare il widget",
    step1Title: "Copia il codice HTML",
    step1Desc: "Copia lo snippet qui sotto e incollalo nel codice HTML del tuo sito, nel punto in cui vuoi mostrare il form di prenotazione.",
    step2Title: "Sostituisci il Center ID",
    step2Desc: "Sostituisci IL_TUO_CENTER_ID con il tuo ID centro. Puoi trovarlo nelle impostazioni del tuo profilo centro.",
    step3Title: "Pubblica e verifica",
    step3Desc: "Pubblica il sito e verifica che il widget appaia correttamente. Le prenotazioni ricevute arriveranno nella sezione Lead & Prenotazioni.",
    copied: "Copiato!",
    copy: "Copia",
    previewDesc: "Anteprima del widget con le impostazioni selezionate. Il form reale invierà le richieste al tuo centro.",
  },
  profileSetup: {
    title: "Configura il tuo profilo",
    subtitle: "Completa le informazioni di base in pochi minuti",
    finalLabel: "Salva profilo",
    saveSuccess: "Profilo salvato!",
    saveError: "Errore nel salvataggio",
    stepIdentity: "Chi sei",
    stepContacts: "Contatti",
    stepEmergency: "Emergenza",
    stepPreferences: "Preferenze",
    firstNameLabel: "Nome *",
    lastNameLabel: "Cognome *",
    displayNameLabel: "Nome visualizzato",
    displayNamePlaceholder: "Come vuoi apparire agli altri utenti",
    displayNameHint: "Se vuoto, verrà usato Nome + Cognome.",
    dateOfBirthLabel: "Data di nascita",
    genderLabel: "Genere",
    genderSelect: "— seleziona —",
    genderM: "Uomo",
    genderF: "Donna",
    genderX: "Non specificato",
    genderNA: "Preferisco non specificare",
    bioLabel: "Bio breve",
    bioPlaceholder: "Descriviti in poche parole — passioni, specializzazioni, dove ti immergi di solito…",
    phoneLabel: "Telefono *",
    phonePlaceholder: "+39 340 000 0000",
    whatsappLabel: "WhatsApp",
    cityLabel: "Città",
    cityPlaceholder: "Milano",
    provinceLabel: "Provincia",
    nationalityLabel: "Nazionalità",
    nationalityPlaceholder: "Italiana",
    visibilityLabel: "Visibilità profilo",
    visibilityPublic: "Pubblico — tutti possono vedermi",
    visibilityConnections: "Solo connessioni",
    visibilityPrivate: "Privato",
    iceTitle: "ICE — In Case of Emergency.",
    iceDesc: "Questa persona verrà contattata in caso di incidente durante un'immersione. Mantienila sempre aggiornata.",
    iceFirstName: "Nome *",
    iceLastName: "Cognome *",
    iceRelationship: "Relazione",
    iceRelationshipSelect: "— seleziona —",
    icePhone: "Telefono *",
    iceEmail: "Email",
    iceMedicalNotes: "Note mediche importanti",
    iceMedicalPlaceholder: "Es. allergie gravi, farmaci salvavita, gruppo sanguigno…",
    prefLangLabel: "Lingua preferita",
    prefUnitsLabel: "Unità di misura",
    prefMetric: "Metrico",
    prefMetricDesc: "metri, kg, °C",
    prefImperial: "Imperiale",
    prefImperialDesc: "piedi, lb, °F",
    prefSearchable: "Rendi il mio profilo ricercabile",
    prefSearchableDesc: "Altri utenti possono trovarti nella directory e suggerimenti buddy",
    prefMarketing: "Newsletter e offerte",
    prefMarketingDesc: "Ricevi aggiornamenti su nuove funzioni, offerte dai centri e notizie dal mondo sub",
  },
  instructorOnboarding: {
    title: "Configura profilo istruttore",
    subtitle: "Rendi visibile la tua esperienza alla community",
    finalLabel: "Pubblica profilo",
    saveSuccess: "Profilo istruttore configurato!",
    saveError: "Errore nel salvataggio",
    stepQualifications: "Qualifiche",
    stepSpecialties: "Specialità",
    stepAvailability: "Disponibilità",
    stepRcInsurance: "Assicurazione RC",
    stepPresentation: "Presentazione",
    rcLawLabel: "Legge 70/2026 Art. 11 — Assicurazione RC Obbligatoria",
    rcLawDesc: "Gli istruttori che esercitano attività subacquea ricreativa devono essere in possesso di un'assicurazione per la responsabilità civile professionale valida. Sanzione: €5.000–€12.000.",
    rcNumberLabel: "Numero polizza RC",
    rcNumberPlaceholder: "es. RC-2026-IT-123456",
    rcExpiryLabel: "Scadenza polizza",
    rcDocLabel: "Documento polizza RC (opzionale)",
    rcDocHint: "Clicca per allegare PDF o immagine della polizza RC (max 8 MB)",
    rcDocAlreadyUploaded: "Documento già caricato — clicca per sostituire",
    directoryHint: "Questi dati vengono mostrati nella directory istruttori e aiutano i subacquei a trovarti.",
    agenciesLabel: "Agenzie di certificazione *",
    agenciesHint: "Le agenzie con cui sei abilitato ad insegnare.",
    agenciesPlaceholder: "Es. PADI…",
    certLevelLabel: "Livello massimo di certificazione *",
    certLevelSelect: "— seleziona —",
    cityLabel: "Città",
    countryLabel: "Paese",
    cityPlaceholder: "Milano",
    specialtiesLabel: "Specialità di insegnamento",
    specialtiesHint: "Corsi e specialty che insegni.",
    specialtiesPlaceholder: "Es. Nitrox…",
    teachingLangsLabel: "Lingue di insegnamento",
    teachingLangsPlaceholder: "Es. Italiano…",
    availabilityLabel: "Disponibilità online",
    availableOnline: "Disponibile online",
    onlyInPerson: "Solo in presenza",
    dailyRateLabel: "Tariffa giornaliera indicativa (€)",
    dailyRatePlaceholder: "Es. 200",
    dailyRateHint: "Indicativo — concordato direttamente con lo studente.",
    directoryVisibilityLabel: "Visibilità nella directory istruttori",
    bioLabel: "Bio pubblica",
    bioPlaceholder: "Presentati: anni di esperienza, dove insegni, approccio didattico, perché ti differenzi…",
    publishHint: "Dopo il completamento il profilo sarà visibile nella directory istruttori e nei suggerimenti per corsi.",
  },
  excursion: {
    statusCancelled: "Annullata",
    statusCompleted: "Completata",
    statusPublished: "Pubblicata",
    statusDraft: "Bozza",
    typeTechnical: "Tecnica",
    typeRecreational: "Ricreativa",
    typeBoth: "Tecnica e Ricreativa",
    certNone: "Nessuna",
    certOpenWater: "Open Water (≤18m)",
    certAdvanced: "Advanced (≤30m)",
    certRescueDm: "Rescue / DM (≤40m)",
    certTechnical: "Tecnico (illimitato)",
    cancelWeather: "Maltempo",
    cancelBoat: "Barca non disponibile",
    cancelStaff: "Carenza di personale",
    cancelEquip: "Problema attrezzatura",
    cancelOther: "Altro motivo",
    back: "Indietro",
    notFound: "Escursione non trovata.",
    backToList: "Torna alla lista",
    organizer: "Organizzatore",
    cancelEventBtn: "Annulla escursione",
    joiningBtn: "Iscrizione...",
    joinBtn: "Iscriviti",
    participantConfirmed: "Confermato",
    participantRejected: "Rifiutato",
    participantAbsent: "Assente",
    participantPending: "In attesa",
    participantCancelled: "Cancellato",
    cancelRegistrationBtn: "Cancella iscrizione",
    cancellationReason: "Motivo annullamento",
    datesAndLocation: "Date e luogo",
    meetingLabel: "Raduno",
    startLabel: "Inizio",
    endLabel: "Fine",
    diveSiteLabel: "Punto di immersione",
    technicalDetails: "Dettagli tecnici",
    minCertLabel: "Brevetto minimo",
    depthLabel: "Profondità",
    costLabel: "Costo",
    availableSlotsLabel: "Posti disponibili",
    cancelDeadlineLabel: "Termine cancellazione",
    cancelDeadlineUnit: "h prima",
    participantActionsTitle: "Azioni partecipante",
    notifyAbsenceLabel: "Notifica assenza",
    reasonOptional: "Motivo (opzionale)",
    notifyBtn: "Notifica",
    linkLogbookLabel: "Collega al logbook",
    logbookIdPlaceholder: "ID immersione dal logbook",
    linkBtn: "Collega",
    linkedDiveText: "✓ Collegata a immersione",
    participantsTitle: "Partecipanti",
    cancelModalTitle: "Annulla escursione",
    cancelModalDesc: "Tutti i partecipanti riceveranno una notifica. Seleziona il motivo.",
    confirmCancelBtn: "Conferma annullamento",
    cancellingBtn: "Annullamento...",
    joinSuccess: "Iscrizione inviata",
    leaveSuccess: "Iscrizione annullata",
    absenceSuccess: "Assenza notificata",
    linkSuccess: "Immersione collegata",
    cancelSuccess: "Escursione annullata",
    statusUpdated: "Stato aggiornato",
  },
  speciesEncyclopedia: {
    pageTitle: "Enciclopedia Marina",
    pageSubtitle: "Flora e fauna dei mari — organizzata per biologia marina",
    contributePhoto: "Contribuisci foto",
    bulkUpload: "Carica in massa",
    myContributions: "Le mie contribuzioni",
    searchPlaceholder: "Cerca per nome scientifico o comune...",
    filters: "Filtri",
    speciesCount: "specie",
    filterClassLabel: "Classe tassonomica",
    filterClassAll: "Tutte le classi",
    filterHabitatLabel: "Habitat",
    filterHabitatAll: "Tutti gli habitat",
    filterIucnLabel: "Stato IUCN",
    filterTypeLabel: "Tipo",
    filterAll: "Tutti",
    fauna: "Fauna",
    flora: "Vegetale",
    clearFilters: "Cancella filtri",
    pagePrev: "Precedente",
    pageNext: "Successiva",
    pageOf: "Pagina {{page}} / {{total}}",
    registerSighting: "REGISTRA AVVISTAMENTO",
    siteSearchPlaceholder: "Cerca sito di immersione (obbligatorio)…",
    depthSightingPlaceholder: "Profondità avvistamento (m) — opzionale",
    registerSightingBtn: "Registra avvistamento",
    printCardTitle: "Stampa scheda specie",
    labelDepth: "Profondità",
    labelSize: "Dimensioni",
    upTo: "fino a",
    labelWaterTemp: "Temperatura acqua",
    labelDistribution: "Diffusione",
    labelBehavior: "Comportamento",
    labelDiet: "Alimentazione",
    biologicalData: "Dati biologici",
    labelMaxLength: "Lunghezza max",
    labelMaxWeight: "Peso max",
    labelMaxAge: "Età max",
    years: "anni",
    labelCommercialImportance: "Importanza commerciale",
    labelVulnerabilityIndex: "Indice di vulnerabilità",
    vulnerabilityHigh: "Alta vulnerabilità — specie sensibile alla pressione di pesca",
    vulnerabilityMedium: "Vulnerabilità moderata",
    vulnerabilityLow: "Bassa vulnerabilità — specie resiliente",
    labelFaoZones: "Zone FAO di distribuzione",
    fishbaseSource: "Fonte: FishBase / SeaLifeBase",
    printedOn: "Stampato il",
    iucnLC: "LC — Minor preoccupazione",
    iucnNT: "NT — Quasi minacciata",
    iucnVU: "VU — Vulnerabile",
    iucnEN: "EN — In pericolo",
    iucnCR: "CR — Critica",
    iucnEW: "EW — Estinta in natura",
    iucnEX: "EX — Estinta",
    toxNonToxic: "Non tossica",
    toxMild: "Lieve irritazione",
    toxVenomous: "⚠ Velenosa",
    toxToxic: "☠ Tossica",
    toxElectric: "⚡ Scarica elettrica",
    class_Actinopterygii: "Pesci ossei",
    class_Chondrichthyes: "Squali & razze",
    class_Cephalopoda: "Cefalopodi",
    class_Gastropoda: "Gasteropodi",
    class_Bivalvia: "Bivalvi",
    class_Malacostraca: "Crostacei",
    class_Echinoidea: "Ricci di mare",
    class_Asteroidea: "Stelle marine",
    class_Ophiuroidea: "Ofiuroidei",
    class_Holothuroidea: "Oloturoidi",
    class_Scyphozoa: "Meduse",
    class_Anthozoa: "Coralli & anemoni",
    class_Hydrozoa: "Idrozoi",
    class_Demospongiae: "Spugne",
    class_Polychaeta: "Policheti",
    class_Trematoda: "Vermi e parassiti",
    class_Reptilia: "Tartarughe",
    class_Mammalia: "Mammiferi",
    class_Liliopsida: "Fanerogame marine",
    class_Ulvophyceae: "Alghe verdi",
    class_Florideophyceae: "Alghe rosse",
    class_Phaeophyceae: "Alghe brune",
    class_Scaphopoda: "Molluschi minori",
    habitat_REEF: "Scogliera",
    habitat_PELAGIC: "Pelagico",
    habitat_BENTHIC: "Bentonico",
    habitat_ROCKY_BOTTOM: "Fondo roccioso",
    habitat_SANDY_BOTTOM: "Fondo sabbioso",
    habitat_CAVE: "Grotta",
    habitat_SEAGRASS: "Prateria",
    habitat_OPEN_WATER: "Mare aperto",
    gallerySearchPlaceholder: "Cerca per specie...",
    galleryEmpty: "Nessuna foto approvata ancora. Contribuisci la prima!",
    galleryCount: "foto nella galleria community",
    tabCatalog: "Catalogo Specie",
    tabGallery: "Galleria Community",
  },
  lifeList: {
    pageTitle: "La Mia Lista Fauna",
    pageSubtitle: "Catalogo specie marine — osserva, identifica, documenta",
    reportBtn: "Segnala",
    aiIdentifyBtn: "Identifica AI",
    mlBtn: "ML",
    encyclopediaLink: "Enciclopedia",
    searchPlaceholder: "Cerca per nome, famiglia…",
    allIucn: "Tutti IUCN",
    allHabitat: "Tutti habitat",
    resultsCount: "{{total}} specie · pagina {{page}}/{{totalPages}}",
    observedSuffix: "osservate",
    noResults: "Nessuna specie trovata per questa ricerca.",
    prevPage: "Precedente",
    nextPage: "Successiva",
    statsSpecieObserved: "specie osservate",
    statsDetail: "Hai osservato {{observed}} delle {{total}} specie presenti nel catalogo eDive. Aggiungi avvistamenti durante le tue immersioni per completare la lista!",
    mlModalTitle: "Identificazione ML",
    clickToUpload: "Clicca per caricare foto",
    mlModelUnavailable: "Modello ML non disponibile. Usa \"Identifica con AI\" per l'identificazione testuale.",
    mlNoSpecies: "Nessuna specie riconosciuta. Prova con una foto più nitida o usa l'identificazione AI.",
    mlIdentifyFailed: "Identificazione fallita. Verifica che il file sia un'immagine valida.",
    mlIdentifyBtn: "Identifica con ML",
    analyzing: "Analisi…",
    aiModalTitle: "Identifica con AI",
    photoOptional: "Foto (opzionale)",
    uploadFailed: "Upload fallito — usa solo descrizione",
    descriptionPlaceholder: "Descrizione (colori, forma, comportamento…)",
    depthPlaceholder: "Profondità (m)",
    locationPlaceholder: "Luogo",
    aiDescOrPhotoRequired: "Inserisci una descrizione o carica una foto",
    aiIdentifyFailed: "Identificazione fallita. Riprova.",
    aiIdentified: "Identificata",
    aiConfidence: "Confidenza",
    reportToCommunity: "Segnala alla community",
    reportModalTitle: "Segnala Avvistamento",
    reportSpeciesLabel: "Specie *",
    reportSpeciesPlaceholder: "Nome comune o scientifico...",
    confidenceLbl: "confidenza",
    reportSiteLabel: "Sito (opzionale)",
    reportSitePlaceholder: "Cerca sito...",
    reportDateLabel: "Data *",
    reportDepthLabel: "Profondità (m)",
    reportNotesLabel: "Note",
    reportPhotoLabel: "Foto (opzionale)",
    uploadPhoto: "Carica foto",
    reportError: "Errore nella segnalazione. Riprova.",
    sending: "Invio…",
    reportSightingBtn: "Segnala avvistamento",
    observedBadge: "Osservata ×{{count}}",
    sectionDescrizione: "Descrizione",
    sectionTassonomia: "Tassonomia e caratteristiche",
    yourSightings: "I tuoi avvistamenti",
    sightingsLbl: "avvistamenti",
    firstSeen: "prima osservazione",
    maxDepth: "profondità massima",
    maxDepthShort: "profondità max",
    printCardBtn: "Stampa scheda PDF",
    taxoClasse: "Classe",
    taxoOrdine: "Ordine",
    taxoFamiglia: "Famiglia",
    taxoHabitat: "Habitat",
    taxoProfondita: "Profondità",
    taxoDimensioni: "Dimensioni",
    taxoAlimentazione: "Alimentazione",
    taxoComportamento: "Comportamento",
    taxoTemperatura: "Temperatura",
    taxoDistribuzione: "Distribuzione",
    printTitle: "Scheda Specie",
    printFooterBrand: "eDive — Enciclopedia Marina",
    printFooterDate: "Stampato il",
    cat_all: "Tutti",
    cat_fish: "Pesci",
    cat_molluschi: "Molluschi",
    cat_crostacei: "Crostacei",
    cat_cnidari: "Cnidari",
    cat_vermi: "Vermi / Elminti",
    cat_echinodermi: "Echinodermi",
    cat_spugne: "Spugne",
    cat_mammiferi: "Mammiferi",
    cat_rettili: "Rettili",
    cat_flora: "Flora marina",
    cat_altro: "Altro",
  },
  safetyTab: {
    tabChambers: "Camere Iperbariche",
    tabChecklist: "Presidi Sicurezza",
    vitalTitle: "Perché conoscere la camera iperbarica più vicina è vitale",
    seasonal: "Solo stagionale",
    military: "Militare",
    emergencyPrefix: "Emergenza",
    locate3Desc: "Individua le 3 camere iperbariche più vicine alla tua posizione attuale.",
    locating: "Localizzazione in corso…",
    locateBtn: "Usa la mia posizione",
    geoUnavailable: "Geolocalizzazione non disponibile su questo browser.",
    geoError: "Impossibile ottenere la posizione. Controlla i permessi del browser.",
    nearest3Title: "Le 3 camere iperbariche più vicine alla tua posizione",
    updatePositionBtn: "Aggiorna posizione",
    emergencyNumbersTitle: "Numeri emergenza subacquea",
    criticalOk: "Presidi critici OK",
    criticalMissing: "Presidi critici mancanti",
    verified: "verificati",
    hideDetail: "Nascondi dettaglio ▲",
    showDetail: "Perché è importante ▼",
    criticalBadge: "critico",
    checklistFooter: "La checklist non viene salvata — ripetila prima di ogni immersione.",
    checklistHeading: "Verifica presidi di sicurezza prima di immergerti",
  },
  associationDetail: {
    tabCard: "Tessera",
    tabCommunications: "Comunicazioni",
    tabShop: "Shop",
    tabInvites: "Inviti",
    autoApproveLabel: "Auto-approva iscrizioni",
    eventType: {
      TRIP: "Viaggio",
      DIVE: "Immersione",
      FULL_DAY: "Giornata Intera",
      WEEKEND: "Weekend",
      CULTURAL: "Culturale",
      SOCIAL: "Sociale",
      WORKSHOP: "Workshop",
      THEMED_NIGHT: "Serata a Tema",
    },
    role: {
      PRESIDENT: "Presidente",
      VICE_PRESIDENT: "Vice Presidente",
      SECRETARY: "Segretario",
      COUNSELOR: "Consigliere",
      OTHER: "Membro",
    },
    badgeEvents: "Eventi",
    badgeMembers: "Soci",
    close: "Chiudi",
    edit: "Modifica",
    cancel: "Annulla",
    save: "Salva",
    roleLabel: "Ruolo",
    manageEvents: "Gestisci eventi",
    manageMembers: "Gestisci soci",
    manageCommunications: "Comunicazioni",
    managerUpdated: "Manager aggiornato",
    managerUpdateError: "Errore aggiornamento manager",
    membershipPending: "Iscrizione in attesa di approvazione",
    withdrawRequest: "Ritira richiesta",
    activeMember: "Sei membro attivo",
    reject: "Rifiuta",
    markFeePaid: "Segna pagata",
    feePaid: "Pagata",
    feeUnpaid: "Non pagata",
    feeMarkedPaid: "Quota segnata come pagata",
    feeUpdateError: "Errore aggiornamento quota",
    complianceAlert: "Compliance alert:",
    expiredCards: "{{count}} tessere scadute",
    expiredMedicals: "{{count}} visite mediche scadute",
    noCerts: "{{count}} senza brevetti registrati",
    allCompliant: "Tutti i membri sono in regola",
    feesPaid: "{{paid}}/{{total}} quote pagate",
    feesCollected: "Incassato: €{{amount}}",
    cardExpired: "Tessera scaduta",
    cardExpiringSoon: "Tessera in scadenza",
    medExpired: "Visita scaduta",
    medExpiringSoon: "Visita in scadenza",
    hasCerts: "Brevetti",
    sendInvite: "Invia invito",
    inviteNamePlaceholder: "Nome (opzionale)",
    sendInviteBtn: "Invia invito",
    importCsv: "Importa CSV",
    csvHint: "Il CSV deve avere le colonne: email, nome (con intestazione)",
    importing: "Importazione in corso...",
    sentInvites: "Inviti inviati",
    noInvites: "Nessun invito ancora",
    inviteSent: "Invito inviato ({{count}})",
    inviteError: "Errore invio invito",
    csvImported: "CSV importato: {{sent}} inviati, {{skipped}} saltati",
    csvError: "Errore importazione CSV",
    cardLoading: "Caricamento tessera...",
    membershipCard: "Tessera associativa",
    cardNumber: "Numero tessera",
    cardExpiry: "Scadenza",
    noExpiry: "Nessuna scadenza",
    linkCopied: "Link di verifica copiato!",
    copyVerifyLink: "Copia link verifica",
    printCard: "Stampa tessera",
    qrToken: "Token QR",
    newComm: "Nuova comunicazione",
    commSubjectPlaceholder: "Oggetto *",
    commBodyPlaceholder: "Corpo del messaggio *",
    filterActiveOnly: "Solo soci attivi",
    filterAll: "Tutti i soci (esclusi revocati)",
    sending: "Invio...",
    send: "Invia",
    commHistory: "Storico messaggi",
    commRecipients: "{{count}} dest.",
    noComms: "Nessuna comunicazione ancora",
    commSent: "Comunicazione inviata a {{count}} soci",
    commError: "Errore invio comunicazione",
    settingsUpdated: "Impostazioni aggiornate",
    settingsUpdateError: "Errore aggiornamento impostazioni",
    joinTitle: "Iscriviti a {{name}}",
    motivationLabel: "Motivazione (opzionale)",
    motivationPlaceholder: "Perché vuoi unirti a questa associazione?",
    acceptRules: "Accetto il regolamento dell'associazione",
    next: "Avanti",
    back: "Indietro",
    kycTitle: "Verifica identità",
    loading: "Caricamento...",
    kycVerified: "Identità verificata",
    kycNotVerified: "La tua identità non è ancora verificata. Completa il KYC per iscriverti ad un'associazione.",
    goToKyc: "Vai al KYC",
    confirmJoinTitle: "Conferma iscrizione",
    associationLabel: "Associazione",
    autoApproveMsg: "La richiesta sarà approvata automaticamente",
    manualApproveMsg: "La richiesta sarà esaminata dai gestori",
    submitRequest: "Invia richiesta",
    shopProducts: "Prodotti",
    newProduct: "Nuovo prodotto",
    productNamePlaceholder: "Nome prodotto",
    productTypeMerchandise: "Articolo",
    productTypeService: "Servizio",
    descriptionPlaceholder: "Descrizione (opzionale)",
    createProduct: "Crea prodotto",
    variantsCount: "{{count}} varianti",
    addVariant: "Aggiungi",
    addVariantBtn: "Variante",
    noProducts: "Nessun prodotto ancora",
    shopOrders: "Ordini",
    orderPreparing: "In lavorazione",
    orderShipped: "Spedito",
    orderDelivered: "Consegnato",
    noOrders: "Nessun ordine",
    qtyPlaceholder: "Qtà",
    pricePlaceholder: "Prezzo €",
  },
  divePlanPDF: {
    appSubtitle: "Sistema di Pianificazione Immersione",
    p1Sub: "Sintesi Operativa",
    p1bSub: "Sito di Immersione",
    p2Sub: "Piano di Risalita — Soste",
    p2bSub: "Piano di Risalita — Passo per Passo",
    p3Sub: "Linee Guida Operative",
    p3bSub: "Attrezzatura Consigliata",
    p4bSub: "Glossario Essenziale",
    p4Sub: "Teoria & Approfondimento",
    generatedOn: "Generato il",
    planningOnly: "Solo a scopo pianificativo",
    decoRequired: "DECOMPRESSIONE OBBLIGATORIA",
    withinNdl: "IMMERSIONE ENTRO NDL",
    ttsLabel: "TTS — risalita totale",
    ndlResidual: "NDL residuo",
    kpiMaxDepth: "Profondità max",
    kpiBottomTime: "Tempo di fondo",
    kpiFirstStop: "Primo stop",
    kpiGasReserve: "Scorta gas",
    chartTitle: "Profilo Profondità / Tempo",
    algoSectionTitle: "ALGORITMO DI DECOMPRESSIONE",
    algoConservatism: "Conservatismo",
    algoLastStop: "Ultima sosta",
    algoCompartments: "Compartimenti",
    algoPpO2Max: "ppO₂ max",
    algoGfLow: "GF Low",
    algoGfHigh: "GF High",
    algoR0N2: "r₀ N₂",
    algoR0He: "r₀ He",
    paramsTitle: "Parametri Immersione",
    paramDepth: "Profondità target",
    paramBottomTime: "Tempo di fondo",
    paramRmv: "RMV",
    paramDescentRate: "Velocità discesa",
    paramAscentRate: "Velocità risalita",
    paramAlgo: "Algoritmo",
    paramGf: "GF Low / High",
    paramPpO2: "ppO₂ limite",
    paramDeco: "Decompressione",
    paramDecoMandatory: "Obbligatoria",
    paramDecoNdl: "Entro NDL",
    paramFirstStop: "Primo stop",
    gasTitle: "Configurazione Gas",
    gasColGas: "Gas",
    gasColRole: "Ruolo",
    gasColVol: "Vol.",
    gasColPres: "Pres.",
    gasColRemaining: "Rimasto",
    gasColStatus: "Stato",
    gasConsumed: "consumo",
    gasReserve: "riserva",
    gasRoleBottom: "fondo",
    gasRoleDeco: "deco",
    gasRoleBailout: "bail.",
    gasOk: "✓ OK",
    gasFail: "✗ NO",
    decoTitle: "Soste di Decompressione e Cambi Gas",
    decoAscentTitle: "Profilo di Risalita",
    decoSafetyTitle: "Sosta di sicurezza consigliata — 5 m / 3 min",
    decoSafetyDesc: "Immersione entro NDL: nessuna sosta obbligatoria. Esegui comunque la sosta di sicurezza a 5 m per 3 minuti prima di emergere.",
    decoColDepth: "Profondità",
    decoColStop: "Sosta",
    decoColGas: "Gas",
    decoTotalRow: "Totale risalita",
    briefTitle: "Piano di risalita — passo per passo",
    briefMandatoryStop: "STOP OBBLIGATORIO",
    briefSafetyStop: "SOSTA SICUREZZA",
    briefGasNotesTitle: "Note sui cambi gas",
    briefO2Pure: "Zero azoto: nessun carico tissutale aggiuntivo durante le soste.",
    warningsTitle: "Avvisi",
    bpTitle: "Best Practice per questo tipo di immersione",
    bpPlanningTitle: "Pianificazione e briefing",
    bpDescentTitle: "Discesa e fondo",
    bpDecoTitle: "Decompressione",
    bpAscentTitle: "Risalita e sosta di sicurezza",
    bpNitroxTitle: "Nitrox — misure specifiche",
    bpEmergencyTitle: "Gestione delle emergenze",
    equipTitle: "Attrezzatura Consigliata",
    equipColItem: "Attrezzatura",
    equipColNote: "Note",
    equipColRequired: "Obbligatorio",
    equipReqYes: "✓ Sì",
    equipReqRec: "◎ Raccomandato",
    equipEssTitle: "Attrezzatura essenziale",
    equipDecoMandatoryTitle: "Attrezzatura deco obbligatoria",
    equipSafetyTitle: "Sicurezza",
    equipMultiTitle: "Multi-gas",
    equipTrimixTitle: "Trimix",
    theoryTitle: "Teoria della Decompressione",
    theoryPhysTitle: "Fisiologia della Decompressione",
    theoryBuhlTitle: "Il Modello Bühlmann ZH-L16C",
    theoryGfTitle: "Gradient Factors — Conservatismo Personalizzabile",
    theoryVpmTitle: "Il Modello VPM-B (Varying Permeability Model)",
    theoryVpmETitle: "VPM-B/E — Algoritmo del Volume Critico",
    theorySettingsTitle: "I Tuoi Parametri — Cosa Significano",
    theoryGlossaryTitle: "Glossario Essenziale",
    glossaryTerm: "Termine",
    glossaryDefinition: "Definizione",
    disclaimerTitle: "Nota legale e limitazione di responsabilità",
    air: "Aria",
    oxygen100: "O₂ 100%",
    chambersMedicalEmergency: "Emergenza medica",
    chambersCoastGuard: "Guardia Costiera",
    chambersNearest: "Camere Iperbariche più vicine",
    chambersEmerg: "Urg: ",
    chambersSeasonal: "stagionale",
    chambersDistNote: "Distanze in linea d'aria · Verificare disponibilità prima dell'immersione · Fonte: SIMSI / ANCIP",
    decoCompTitle: "Confronto Scenari Decompressione",
    decoCompSubtitle: "Tempo di fondo +1...+5 min  ·  Bühlmann 20/80  ·  tappe > 3 m  ·  tappa a 3 m non inclusa",
    decoCompStopGas: "Sosta  ·  Gas",
    decoCompBottom: "fondo",
    decoCompTotal: "Totale (excl. 3 m)",
    decoCompShort: "breve",
    decoCompModerate: "moderata",
    decoCompLong: "lunga",
    decoCompExtended: "estesa",
    decoCompDecoGas: "gas deco",
    divePlanTitle: "Piano di Immersione",
    divePlanTitleSite: "Piano — {{name}}",
    docSubject: "Documento di pianificazione immersione",
    siteCountry: "Paese",
    siteRegion: "Regione",
    siteMaxDepth: "Profondità max",
    siteMinDepth: "Profondità min",
    siteDifficulty: "Difficoltà",
    siteWater: "Acqua",
    siteRating: "Valutazione",
    siteDiveLabel: "Sito",
    siteDescription: "Descrizione",
    diffBeginner: "Principiante",
    diffIntermediate: "Intermedio",
    diffAdvanced: "Avanzato",
    diffTechnical: "Tecnico",
    waterSalt: "Acqua salata",
    waterFresh: "Acqua dolce",
    waterBrackish: "Salmastra",
    forecastHeader: "Meteo / Condizioni",
    forecastTemperature: "Temperatura",
    forecastWind: "Vento",
    forecastPrecipitation: "Precipitazioni",
    forecastWaveHeight: "Altezza onde",
    forecastSeaState: "Mare",
    forecastSeaNA: "n.d. (area interna)",
    forecastWaterTemp: "Temp. acqua",
    forecastSource: "Fonte: Open-Meteo · Previsione oraria — verificare prima della partenza",
    chambersHeader: "⚕ Camere Iperbariche Più Vicine",
    chambersDivingEmergency: "Emergenza subacquea: 118",
    chambersDistNoteShort: "Distanze in linea d'aria · Verificare disponibilità prima dell'immersione · Fonte: SIMSI / ANCIP",
    meteoPageSubtitle: "Condizioni Meteo-Marine",
    suitGood: "Condizioni adatte all'immersione",
    suitModerate: "Condizioni moderate — valutare in loco",
    suitAdverse: "Condizioni avverse — immersione sconsigliata",
    suitWind: "Vento",
    suitWaves: "Onde",
    suitRain: "Pioggia",
    meteoAtmosphere: "Atmosfera",
    meteoCondition: "Condizione",
    meteoWindSpeed: "Vento",
    meteoWindDir: "Dir. vento",
    meteoPressure: "Pressione",
    meteoMarine: "Marine",
    meteoWavePeriod: "Periodo",
    meteoWaveDir: "Dir. onde",
    meteoSeaState: "Stato del mare",
    meteoSeaOptimal: "Ottimale",
    meteoSeaGood: "Buono",
    meteoSeaModerate: "Moderato",
    meteoSeaPoor: "Avverso",
    meteoNoMarine: "Dati marini non disponibili (area interna).",
    hourlyTitle: "Tendenza Oraria",
    hourlyHour: "Ora",
    hourlySky: "Cielo",
    hourlyTempCol: "Temp °C",
    hourlyWindCol: "Vento",
    hourlyDir: "Dir.",
    hourlyRain: "Pioggia",
    hourlyWave: "Onde m",
    hourlyWaterTemp: "Acqua °C",
    hourlyPressure: "hPa",
    hourlyTrends: "Tendenze: ↑ in aumento  ↓ in calo  → stabile  ◀ ora immersione",
    legendOptimal: "■ Ottimale",
    legendModerate: "■ Moderato",
    legendCaution: "■ Attenzione",
    legendAdverse: "■ Avverso",
    meteoSourceFull: "Fonte: Open-Meteo (open-meteo.com) · Previsione oraria, fuso orario automatico · API Marina dove disponibile. Verificare sempre le condizioni locali prima della partenza.",
    engineNote: "eDive engine v1.0. I risultati sono deterministici per gli input forniti. Il carico tissutale residuo, le immersioni ripetitive e la variabilità fisiologica individuale non sono considerati se non esplicitamente inclusi nel piano.",
  },
  medicalPage: {
    tagsInputPlaceholder: "Aggiungi e premi Invio",
    expired: "Scaduto",
    expiresDays: "Scade tra {{days}}gg",
    expiresWeeks: "Scade tra {{weeks}}sett.",
    emergencyCardTitle: "Scheda Emergenza Subacquea",
    medicalConditions: "Condizioni mediche",
    emergencyCardFooter: "In caso di emergenza subacquea chiamare il 118 · Centro Iperbarico più vicino",
    print: "Stampa",
    emergencyCard: "Scheda emergenza",
    emergencyContactPlaceholder: "Nome — +39 …",
    alertNoBloodType: "Gruppo sanguigno non inserito",
    alertNoEmergencyContact: "Contatto di emergenza mancante",
    alertCertExpired: "Certificato medico \"{{type}}\" scaduto il {{date}}",
    alertCertExpiring: "Certificato \"{{type}}\" scade tra {{days}} giorni",
    alertVaccineExpired: "Vaccino {{name}} scaduto",
    alertVaccineExpiring: "Vaccino {{name}}: richiamo tra {{days}} giorni",
    loadingValues: "Caricamento valori…",
    noValuesExtracted: "Nessun valore estratto per questo documento.",
    colAnalysis: "Analisi",
    colValue: "Valore",
    colRef: "Ref.",
    colDate: "Data",
    colLab: "Laboratorio",
    selectAnalysis: "Seleziona analisi",
    chooseParameter: "scegli un parametro",
    measurements: "misurazioni",
    uploadReportsHint: "Carica dei referti per visualizzare l'andamento nel tempo.",
    loadingData: "Caricamento dati…",
    noNumericData: "Nessun dato numerico disponibile per questa analisi.",
    subTabDocuments: "Documenti",
    subTabStatistics: "Statistiche",
    uploadExam: "Carica Esame",
    uploadLabReport: "Carica referto di laboratorio",
    dropFileHint: "Trascina qui il file oppure",
    clickToBrowse: "clicca per sfogliare",
    titleAutoFromFile: "Titolo (auto da nome file)",
    titlePlaceholder: "Es. Emocromo completo",
    labNamePlaceholder: "Es. Laboratorio Rossi",
    uploading: "Caricamento…",
    uploadAndAnalyzeAI: "Carica e analizza con AI",
    statusAnalyzing: "In analisi",
    statusAnalyzed: "Analizzato",
    statusAIError: "Errore AI",
    confirmDeleteReport: "Eliminare questo referto?",
    aiAnalyzingDoc: "L'AI sta analizzando il documento. Ricarica tra qualche minuto.",
    aiAnalysisFailed: "Analisi AI non riuscita. Il documento è comunque salvato.",
    reportUploadedAI: "Referto caricato — analisi AI in corso…",
    reportUploadError: "Errore nel caricamento del referto",
    fitToDiveFit: "Idoneo",
    fitToDiveUnfit: "Non idoneo",
    reportTypePlaceholder: "Visita medica di idoneità subacquea",
    modality: "Modalità",
    bodyPart: "Parte del corpo",
    bodyPartPlaceholder: "Polmoni, colonna...",
    studyDate: "Data studio",
    radiologistNotes: "Note radiologo",
    aiAnalysis: "Analisi AI",
    vaccinationAdded: "Vaccinazione aggiunta",
    savingError: "Errore nel salvataggio",
    removed: "Rimosso",
    vaccinationsHint: "Tieni traccia delle vaccinazioni richieste per viaggi subacquei.",
    add: "Aggiungi",
    vaccineLabel: "Vaccino",
    startTyping: "Inizia a digitare...",
    administeredDate: "Data somministrazione",
    expiryOrBooster: "Scadenza / prossimo richiamo",
    batchNumber: "Lotto",
    vaccineNotesPlaceholder: "Centro vaccinale, reazioni...",
    saving: "Salvo...",
    noVaccinations: "Nessuna vaccinazione registrata. Aggiungi le vaccinazioni richieste per i tuoi viaggi.",
    administered: "Somministrato",
    booster: "Richiamo",
    valid: "Valido",
    measurementAdded: "Misurazione aggiunta",
    vitalsHint: "Monitora pressione, frequenza cardiaca e SpO₂ nel tempo.",
    measurement: "Misurazione",
    measurementDate: "Data misurazione",
    systolicBp: "Pressione sistolica (mmHg)",
    diastolicBp: "Pressione diastolica (mmHg)",
    restingHeartRate: "Freq. cardiaca a riposo (bpm)",
    weight: "Peso (kg)",
    vitalsNotesPlaceholder: "Condizioni, post-immersione...",
    noVitals: "Nessuna misurazione registrata. Aggiungi la prima misurazione per iniziare il monitoraggio.",
    bloodPressure: "Pressione arteriosa",
    systolicBpShort: "Sistolica",
    diastolicBpShort: "Diastolica",
    heartRate: "Frequenza cardiaca",
    heartRateShort: "FC",
    weightKg: "Peso (kg)",
    weightShort: "Peso",
    height: "Altezza (cm)",
    bmi: "BMI",
    bmiUnderweight: "Sottopeso",
    bmiNormal: "Normopeso",
    bmiOverweight: "Sovrappeso",
    bmiObese: "Obesità",
    bloodPressureShort: "PA",
    latestReadings: "Ultime misurazioni",
    scopeClearances: "Idoneità subacquea",
    scopeReports: "Referti medici",
    specHyperbaric: "Medicina iperbarica",
    specDive: "Medicina subacquea",
    specSports: "Medicina dello sport",
    specEmergency: "Medicina d'urgenza",
    outcomeFit: "Idoneo",
    outcomeFitConditions: "Idoneo con riserve",
    outcomeUnfit: "Non idoneo",
    outcomePending: "In attesa",
    connectionAccepted: "Connessione accettata",
    acceptError: "Errore durante l'accettazione",
    inviteRejected: "Invito rifiutato",
    requestCancelled: "Richiesta annullata",
    connectionRequestSent: "Richiesta di connessione inviata",
    requestError: "Errore durante la richiesta",
    statsShared: "Statistiche condivise con successo",
    statsShareError: "Errore durante la condivisione delle statistiche",
    pendingInvites: "Inviti in attesa ({{count}})",
    divingDoctor: "Medico subacqueo",
    receivedOn: "Ricevuto il",
    reject: "Rifiuta",
    accept: "Accetta",
    sentRequests: "Richieste inviate ({{count}})",
    awaitingApproval: "In attesa di approvazione",
    myDoctors: "I miei medici ({{count}})",
    noDoctors: "Nessun medico collegato. Cercane uno qui sotto.",
    connectedSince: "Connesso dal",
    sharedDives: "imm. condivise",
    updatedShort: "agg.",
    active: "Attivo",
    syncStats: "Sincronizza stats",
    fitnessAssessments: "Valutazioni idoneità",
    validUntilShort: "valida fino al",
    searchDivingDoctors: "Cerca medici subacquei",
    searchInstitutionOrCity: "Istituto o città…",
    searchCountry: "Paese (IT, FR…)",
    allSpecializations: "Tutte le specializzazioni",
    searching: "Ricerca in corso…",
    noDoctorsFound: "Nessun medico trovato con questi criteri",
    enterSearchCriteria: "Inserisci almeno un criterio di ricerca",
    acceptsPatients: "Accetta pazienti",
    notAvailable: "Non disponibile",
    alreadyConnected: "Già connesso",
    requestSent: "Richiesta inviata",
    messagePlaceholder: "Messaggio…",
    connect: "Connetti",
    diveDataDisclaimer: "I dati di immersione vengono condivisi volontariamente con i medici collegati per il monitoraggio dell'idoneità.",
    fseTitle: "Fascicolo Sanitario Elettronico",
    fseDescription: "Il tuo FSE è il tuo fascicolo sanitario digitale. Puoi esportare tutti i tuoi dati sanitari in formato HL7 FHIR R4 — lo standard internazionale per l'interoperabilità medica — oppure importare dati da un altro sistema compatibile.",
    fseExportTitle: "Esporta al FSE",
    fseExportDescription: "Genera un pacchetto FHIR R4 con tutti i tuoi dati: cartella medica, referti, esami, immagini diagnostiche, vaccini e parametri vitali. Il file può essere caricato su qualsiasi sistema compatibile FSE/FHIR.",
    fseLastExport: "Ultimo export",
    fseGenerating: "Generazione bundle…",
    fseDownloadBundle: "Scarica FHIR Bundle (JSON)",
    fseExportSuccess: "Bundle FHIR R4 scaricato con successo",
    fseConsentRequired: "Attiva il consenso per il trattamento dati sanitari prima di esportare.",
    fseExportError: "Errore durante l'esportazione. Riprova.",
    fseImportTitle: "Importa da FSE",
    fseImportDescription: "Carica un file FHIR Bundle JSON proveniente da un FSE regionale o da un'altra piattaforma medica. Le risorse compatibili (condizioni, allergie, farmaci, vaccini) verranno aggiunte alla tua cartella.",
    fseImporting: "Importazione in corso…",
    fseSelectFile: "Seleziona file FHIR Bundle (.json)",
    fseImportResult: "Importati: {{created}} nuovi · {{updated}} aggiornati · {{skipped}} ignorati",
    fseImportSuccess: "Importazione completata",
    fseImportError: "File non valido o errore di rete",
    fseConsentTitle: "Consenso trattamento dati sanitari",
    fseConsentDescription: "Per esportare i dati al FSE è richiesto il consenso al trattamento dei dati sanitari (GDPR Art. 9). Il consenso è necessario per ogni accesso esterno ai tuoi dati sensibili.",
    fseConsentCheck: "Verifica consenso nelle impostazioni privacy",
    fseWebhookTitle: "Integrazione FSE Nazionale",
    fseWebhookStatus: "In attesa di integrazione FSE nazionale (disponibile quando il gateway regionale sarà attivo)",
    fseWebhookDescription: "Attualmente è disponibile solo l'esportazione/importazione manuale. L'integrazione automatica con il Fascicolo Sanitario Elettronico regionale sarà abilitata automaticamente appena disponibile.",
    tabVaccines: "Vaccini",
    tabVitals: "Parametri",
    tabMyDoctors: "I miei medici",
    wizardBannerTitle: "Configura il tuo fascicolo sanitario",
    wizardBannerDesc: "Inserisci gruppo sanguigno, allergie, condizioni e certificato medico subacqueo con il wizard guidato.",
    startWizard: "Carica certificato di idoneità",
    fitnessAssessmentWizard: "Prenota visita con un medico",
    searchAnalytics: "Cerca analisi, laboratorio, data...",
    parameters: "Parametri",
    reports: "Referti",
    selectHint: "Seleziona un parametro o un referto",
    values: "valori",
    abnormal: "fuori range",
    autoExtractHint: "Laboratorio, data e valori verranno estratti automaticamente dal documento",
    extractingMetadata: "Estrazione metadati in corso...",
    setEmergencyContact: "Aggiungi nel profilo",
  },
  dcEquipItem: {
    statusExpired: "Scaduto",
    statusExpiringSoon: "In scadenza",
    eventLogged: "Intervento registrato",
    saveError: "Errore durante il salvataggio",
    logMaintenanceTitle: "Registra intervento di manutenzione",
    eventDetailsStep: "Dettagli Intervento",
    save: "Salva",
    eventTypeLabel: "Tipo intervento *",
    dateLabel: "Data *",
    performedByLabel: "Eseguito da",
    technicianCenterNameLabel: "Nome tecnico / centro",
    costLabel: "Costo (€)",
    costPlaceholder: "es. 120.00",
    nextDueDateLabel: "Prossima scadenza",
    notesLabel: "Note",
    saved: "Salvato",
    saveErrorShort: "Errore salvataggio",
    edit: "Modifica",
    fieldManufacturer: "Produttore",
    fieldModel: "Modello",
    fieldModelCode: "Codice modello",
    fieldCategory: "Categoria",
    fieldSerialNumber: "Numero seriale",
    fieldYearOfManufacture: "Anno produzione",
    fieldPurchaseDate: "Data acquisto",
    fieldPurchaseCost: "Costo acquisto",
    fieldWeight: "Peso (kg)",
    fieldCurrency: "Valuta",
    fieldStatus: "Stato",
    fieldNextDueDate: "Prossima scadenza",
    manufacturerRequiredLabel: "Produttore *",
    modelRequiredLabel: "Modello *",
    modelCodeLabel: "Codice modello",
    categoryRequiredLabel: "Categoria *",
    serialNumberLabel: "Numero seriale",
    yearOfManufactureLabel: "Anno produzione",
    purchaseDateLabel: "Data acquisto",
    purchaseCostLabel: "Costo acquisto (€)",
    weightLabel: "Peso (kg)",
    saving: "Salvataggio…",
    cancel: "Annulla",
    planSaved: "Piano salvato",
    planDeleted: "Piano eliminato",
    errorGeneric: "Errore",
    plansInitialized: "{{count}} piani inizializzati dal template",
    templateInitError: "Errore inizializzazione template",
    initializing: "Inizializzazione…",
    initFromTemplate: "Inizializza da template",
    addPlan: "Aggiungi piano",
    noPlans: "Nessun piano di manutenzione",
    noPlansHint: "Aggiungi piani manualmente o inizializza dai template",
    mandatory: "Obbligatorio",
    inactive: "Inattivo",
    everyMonthsRecommended: "Ogni {{months}} mesi (raccomandato)",
    legalMinMonths: "Min. legale: {{months}} mesi",
    standardRef: "Norma: {{standard}}",
    delete: "Elimina",
    deletePlanConfirm: "Eliminare questo piano?",
    editPlanTitle: "Modifica piano",
    newPlanTitle: "Nuovo piano di manutenzione",
    editPlanStep: "Modifica piano",
    newPlanStep: "Nuovo piano",
    maintenanceTypeLabel: "Tipo manutenzione *",
    sourceLabel: "Fonte *",
    descriptionLabel: "Descrizione *",
    recommendedIntervalLabel: "Intervallo raccomandato (mesi)",
    legalMinimumLabel: "Minimo legale (mesi)",
    referenceStandardLabel: "Norma di riferimento",
    referenceStandardPlaceholder: "es. EN 250",
    referenceUrlLabel: "URL riferimento",
    mandatoryByLaw: "Obbligatorio per legge",
    logEvent: "Registra intervento",
    noEvents: "Nessun intervento registrato",
    performedByPrefix: "Eseguito da:",
    nextPrefix: "Prossimo:",
    noUsage: "Nessun utilizzo registrato",
    tableDate: "Data",
    tableLinkedTo: "Collegato a",
    tableLocation: "Luogo",
    tableNotes: "Note",
    tabGeneral: "Dati generali",
    tabPlans: "Piano manutenzione",
    tabHistory: "Storico interventi",
    tabUsage: "Utilizzi",
    notFound: "Attrezzatura non trovata.",
    backToEquipment: "Attrezzature",
    serialPrefix: "S/N:",
  },
  researchCtr: {
    missionCreated: "Missione creata!",
    createError: "Errore nella creazione",
    statusUpdated: "Stato aggiornato",
    error: "Errore",
    responseSent: "Risposta inviata",
    statusDraft: "Bozza",
    statusOpen: "Aperta",
    statusActive: "Attiva",
    statusClosed: "Chiusa",
    statusArchived: "Archiviata",
    newMission: "Nuova missione",
    kpiActiveMissions: "Missioni attive",
    kpiOpenMissions: "Missioni aperte",
    kpiTotalVolunteers: "Volontari totali",
    kpiTotalMissions: "Missioni totali",
    tabMyMissions: "Le mie missioni",
    tabApplicationsFor: "Candidature — {{title}}…",
    tabApplications: "Candidature",
    tabNewMission: "+ Nuova missione",
    loading: "Caricamento...",
    noMissions: "Nessuna missione creata.",
    createFirstMission: "Crea la prima missione →",
    volunteersCount: "{{count}} volontari",
    start: "Inizio",
    end: "Fine",
    maxVolunteers: "Max {{count}} volontari",
    applicationsCount: "Candidature ({{count}})",
    results: "Risultati →",
    publish: "Pubblica",
    startBtn: "Avvia",
    close: "Chiudi",
    archive: "Archivia",
    selectMissionHint: "Seleziona una missione dalla tab \"Le mie missioni\" per vedere le candidature.",
    noApplications: "Nessuna candidatura per questa missione.",
    applicationsForTitle: "Candidature — {{title}}",
    colVolunteer: "Volontario",
    colApplication: "Candidatura",
    colStatus: "Stato",
    statusApproved: "Approvato",
    statusRejected: "Rifiutato",
    statusPending: "In attesa",
    approve: "Approva",
    reject: "Rifiuta",
    missionDetails: "Dettagli missione",
    titleLabel: "Titolo *",
    titlePlaceholder: "es. Monitoraggio Posidonia — Arcipelago Toscano 2026",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Obiettivi della missione, metodi, risultati attesi...",
    startDateLabel: "Data inizio",
    endDateLabel: "Data fine",
    maxVolunteersLabel: "Max volontari",
    unlimited: "Illimitati",
    protocolTitle: "Protocollo di raccolta dati",
    protocolDescription: "Definisci i campi che i volontari dovranno compilare per ogni osservazione.",
    fieldKeyLabel: "Chiave",
    fieldLabelLabel: "Etichetta",
    fieldLabelPlaceholder: "Profondità (m)",
    fieldTypeLabel: "Tipo",
    typeText: "Testo",
    typeNumber: "Numero",
    typeBoolean: "Sì/No",
    typeSelect: "Selezione",
    addField: "+ Aggiungi",
    cancel: "Annulla",
    creating: "Creazione...",
    createMissionDraft: "Crea missione (come bozza)",
  },
  marineProjects: {
    title: "Progetti di ricerca",
    subtitle: "Protocolli, squadra, immersioni scientifiche e validazione dei dati",
    new: "Nuovo progetto",
    all: "Tutti",
    created: "Progetto creato",
    createError: "Non e stato possibile creare il progetto",
    statusChanged: "Stato aggiornato",
    statusError: "Non riuscito",
    loadError: "Non e stato possibile caricare i progetti.",
    empty: "Nessun progetto di ricerca. Creane uno per iniziare.",
    emptyFiltered: "Nessun progetto in questo stato.",
    dives: "immersioni",
    yourRole: "il tuo ruolo",
    changeStatus: "Cambia stato",
    open: "Apri",
    fieldTitle: "Titolo",
    fieldDescription: "Descrizione",
    fieldFrom: "Dal",
    fieldTo: "Al",
    notFound: "Progetto non trovato.",
    tabDives: "Immersioni",
    tabProtocols: "Protocolli",
    tabTeam: "Squadra",
    newDive: "Pianifica immersione",
    noDives: "Nessuna immersione pianificata per questo progetto.",
    untitledDive: "Immersione senza titolo",
    newProtocol: "Nuovo protocollo",
    noProtocols: "Nessun protocollo. Un protocollo dice quali campi una raccolta dati deve contenere.",
    protocolCreated: "Protocollo aggiunto",
    protocolRemoved: "Protocollo rimosso",
    protocolError: "Non riuscito",
    protocolType: "Tipo",
    protocolFields: "Campi richiesti, separati da virgola",
    addMember: "Aggiungi membro",
    memberAdded: "Membro aggiunto",
    memberRemoved: "Membro rimosso",
    memberError: "Non riuscito: controlla l identificativo",
    memberId: "Identificativo utente",
    memberRole: "Ruolo nel progetto",
    fieldWhen: "Data e ora",
    fieldDepth: "Profondita massima (m)",
    fieldObjectives: "Obiettivi",
    diveCreated: "Immersione pianificata",
    diveError: "Non riuscito",
  },
  marineDive: {
    status: "Stato",
    statusChanged: "Stato aggiornato",
    statusError: "Non riuscito",
    notFound: "Immersione non trovata.",
    checklist: "Lista di controllo",
    completed: "Completata",
    checklistSaved: "Lista di controllo salvata",
    checklistDone: "Lista completata",
    checklistError: "Non riuscito",
    completeAllFirst: "Spunta tutte le voci prima di completare",
    markComplete: "Segna completata",
    data: "Dati raccolti",
    addData: "Registra dato",
    noData: "Nessun dato registrato per questa immersione.",
    dataAdded: "Dato registrato",
    dataError: "Non riuscito",
    dataType: "Tipo di dato",
    dataPayload: "Contenuto",
    payloadHint: "Se non e in formato JSON viene salvato come nota, cosi il dato non si perde.",
    validations: "Validazioni fra pari",
    validateAs: "Valida come",
    validated: "Validazione registrata",
    validateError: "Non riuscito",
  },
  sportCenter: {
    centerUpdated: "Centro aggiornato",
    centerCreated: "Centro creato",
    centerName: "Nome centro *",
    requiredField: "Campo obbligatorio",
    country: "Paese *",
    city: "Città *",
    address: "Indirizzo",
    phone: "Telefono",
    email: "Email",
    website: "Sito web",
    description: "Descrizione",
    poolSpecs: "Specifiche piscina",
    lengthM: "Lunghezza (m)",
    lanes: "Corsie",
    maxDepthM: "Profondità max (m)",
    indoorPool: "Piscina coperta",
    outdoorPool: "Piscina scoperta",
    updateCenter: "Aggiorna centro",
    createSportCenter: "Crea centro sportivo",
    sessionUpdated: "Sessione aggiornata",
    sessionCreated: "Sessione creata",
    title: "Titolo *",
    sessionType: "Tipo sessione *",
    level: "Livello *",
    certAgency: "Agenzia cert.",
    certAgencyPlaceholder: "PADI, SSI…",
    maxStudents: "Max studenti *",
    priceEuro: "Prezzo (€) *",
    durationMin: "Durata (min) *",
    dateTime: "Data e ora *",
    cancel: "Annulla",
    saving: "Salvataggio…",
    update: "Aggiorna",
    createSession: "Crea sessione",
    sessionCancelled: "Sessione annullata",
    edit: "Modifica",
    editCenter: "Modifica centro",
    createYourSportCenter: "Crea il tuo centro sportivo",
    poolLength: "Piscina {{length}}m",
    poolLanesCount: "{{lanes}} corsie",
    maxDepthValue: "Max {{depth}}m",
    indoor: "Coperta",
    outdoor: "Scoperta",
    sessions: "Sessioni",
    newSession: "Nuova sessione",
    editSession: "Modifica sessione",
    confirmCancelSession: "Annullare questa sessione?",
    noSessions: "Nessuna sessione",
    createFirstSession: "Crea la tua prima sessione in piscina",
  },
  collabTrips: {
    planUpdated: "Piano aggiornato!",
    planCreated: "Piano collaborativo creato!",
    saveError: "Errore nel salvataggio",
    editPlan: "Modifica piano",
    newCollabPlan: "Nuovo piano collaborativo",
    planNameLabel: "Nome piano *",
    planNamePlaceholder: "es. Maldive con amici 2027",
    destinationLabel: "Destinazione",
    destinationPlaceholder: "es. Sharm el-Sheikh, Egitto",
    departureDateLabel: "Data partenza",
    returnDateLabel: "Data ritorno",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Note, obiettivi, idee…",
    publicPlanLabel: "Piano pubblico (visibile a chiunque con il link)",
    cancel: "Annulla",
    saving: "Salvataggio…",
    save: "Salva",
    createPlan: "Crea piano",
    planDeleted: "Piano eliminato",
    deleteError: "Errore eliminazione",
    memberRemoved: "Membro rimosso",
    genericError: "Errore",
    inviteCreated: "Invito creato!",
    inviteError: "Errore nell'invio dell'invito",
    roleOwner: "Proprietario",
    roleEditor: "Editor",
    roleViewer: "Visualizzatore",
    collabPlan: "Piano collaborativo",
    public: "Pubblico",
    confirmDelete: "Eliminare questo piano?",
    daysUntil: "tra {{count}} giorni",
    participantsCount: "{{count}} partecipanti",
    checklist: "Checklist",
    tabOverview: "Panoramica",
    tabSites: "Siti ({{count}})",
    tabChecklist: "Checklist",
    tabMembers: "Collaboratori ({{count}})",
    plannedSitesMap: "Mappa siti pianificati",
    plannedSites: "Siti pianificati",
    participants: "Partecipanti",
    notes: "Note",
    includedSites: "Siti inclusi",
    readOnlySites: "Hai permesso di sola lettura — solo il proprietario e gli editor possono modificare i siti.",
    noSitesAdded: "Nessun sito aggiunto",
    completedCount: "{{done}} di {{total}} completati",
    readOnlyChecklist: "Hai permesso di sola lettura sulla checklist.",
    otherMember: "altro",
    addItemPlaceholder: "Aggiungi elemento…",
    you: "Tu",
    planOwner: "Proprietario del piano",
    joinedOn: "Unito il {{date}}",
    leavePlan: "Lascia il piano",
    removeMember: "Rimuovi membro",
    inviteCollaborators: "Invita collaboratori",
    inviteeEmailLabel: "Email dell'invitato",
    inviteeEmailPlaceholder: "amico@email.com",
    sending: "Invio…",
    generateInviteLink: "Genera link invito",
    inviteLinkValid: "Link invito (valido 7 giorni)",
    linkCopied: "Link copiato!",
    copy: "Copia",
    sendLinkHint: "Invia questo link a {{email}}. L'utente deve essere registrato su eDive per accettare.",
    filterOwned: "Miei ({{count}})",
    filterShared: "Condivisi ({{count}})",
    new: "Nuovo",
    noPlansCreated: "Nessun piano creato",
    noPlansShared: "Nessun piano condiviso con te",
    createFirst: "Crea il primo →",
    shared: "Condiviso",
    selectPlan: "Seleziona un piano",
    or: "oppure",
    createCollabPlan: "Crea piano collaborativo",
  },
  dcEquipMaint: {
    statusExpired: "Scaduto",
    statusExpiringSoon: "In scadenza",
    categoryCylinder: "Bombola",
    categoryRegulator: "Erogatore",
    categoryBcd: "GAV",
    categoryWetsuit: "Muta umida",
    categoryDrysuit: "Muta stagna",
    categoryDiveComputer: "Computer subacqueo",
    categoryAnalogInstrument: "Strumento analogico",
    categoryMaskFinSnorkel: "Maschera/Pinne/Snorkel",
    categorySafetyGear: "Presidio sicurezza",
    categoryTechnical: "Tecnico",
    categoryTorch: "Torcia",
    categoryKnife: "Coltello",
    categorySurfaceMarker: "Boa di segnalazione",
    categoryOther: "Altro",
    maintVisualInspection: "Ispezione visiva",
    maintFullService: "Revisione completa",
    maintHydrostaticTest: "Test idrostatico",
    maintFunctionalTest: "Test funzionale",
    maintBatteryReplacement: "Sostituzione batteria",
    maintSealReplacement: "Sostituzione guarnizioni",
    maintPartsReplacement: "Sostituzione parti",
    maintFirmwareUpdate: "Aggiornamento firmware",
    maintOther: "Altro",
    performedAuthorizedCenter: "Centro autorizzato",
    performedCertifiedTechnician: "Tecnico certificato",
    performedOwner: "Proprietario",
    addStepCatalogue: "Cerca nel catalogo",
    addStepDetails: "Dettagli attrezzatura",
    addStepSerialDate: "Seriale e Data",
    toastEquipmentAdded: "Attrezzatura aggiunta e piani inizializzati",
    toastSaveError: "Errore durante il salvataggio",
    addModalTitle: "Aggiungi attrezzatura",
    addModalSubtitle: "Registra un nuovo pezzo di attrezzatura nel centro",
    addModalFinalLabel: "Aggiungi attrezzatura",
    catalogueHint: "Cerca nel catalogo per compilare automaticamente i dettagli, oppure continua per inserirli manualmente.",
    cataloguePlaceholder: "es. Apeks XTX, Scubapro MK25…",
    searching: "Ricerca…",
    noCatalogueResult: "Nessun risultato — compila i dettagli manualmente al prossimo step.",
    catalogueSelectHint: "seleziona un risultato per auto-compilare, oppure clicca Avanti.",
    fieldManufacturerReq: "Produttore *",
    fieldModelReq: "Modello *",
    fieldModelCode: "Codice modello",
    optional: "(opzionale)",
    fieldCategoryReq: "Categoria *",
    summaryManufacturer: "Produttore",
    summaryModel: "Modello",
    fieldSerialNumber: "Numero seriale",
    serialPlaceholder: "es. SN-ABC-123456",
    fieldPurchaseDate: "Data acquisto",
    fieldNotes: "Note",
    logStepTypeDate: "Tipo e Data",
    logStepPerformerCost: "Esecutore e Costo",
    logStepDueNotes: "Scadenza e Note",
    toastMaintenanceLogged: "Intervento registrato",
    logModalTitle: "Registra intervento",
    logModalFinalLabel: "Salva intervento",
    logTypeDateHint: "Specifica il tipo di intervento eseguito e la data.",
    fieldMaintDateReq: "Data intervento *",
    logPerformerCostHint: "Chi ha eseguito l'intervento e il costo sostenuto.",
    fieldTechnicianName: "Nome tecnico / centro",
    technicianNamePlaceholder: "es. Centro assistenza Scubapro Milano",
    fieldCost: "Costo (€)",
    costPlaceholder: "es. 120.00",
    summaryMaintenance: "Intervento",
    summaryDate: "Data",
    summaryPerformedBy: "Eseguito da",
    summaryCost: "Costo",
    fieldNextDueDate: "Prossima scadenza",
    maintNotesPlaceholder: "Dettagli dell'intervento, parti sostituite...",
    csvCategory: "Categoria",
    csvManufacturer: "Produttore",
    csvModel: "Modello",
    csvCode: "Codice",
    csvSerialNumber: "Numero seriale",
    csvPurchaseDate: "Data acquisto",
    csvStatus: "Stato",
    csvNextDueDate: "Prossima scadenza",
    csvNotes: "Note",
    filterSearch: "Cerca",
    searchPlaceholder: "Produttore, modello, seriale…",
    filterCategory: "Categoria",
    allCategories: "Tutte le categorie",
    filterStatus: "Stato",
    exportCsvTitle: "Esporta lista in CSV",
    exportCsv: "Esporta CSV",
    addEquipment: "Aggiungi attrezzatura",
    emptyAddFirst: "Aggiungi la prima attrezzatura del centro",
    nextDueLabel: "Prossima scadenza:",
    logMaintenance: "Registra intervento",
    alreadyExpired: "Già scadute",
    expiringWithin60Days: "In scadenza entro 60 giorni",
    dataUnavailable: "Dati non disponibili",
    statTotal: "Totale attrezzature",
    statExpiringSoon: "In scadenza",
    statExpired: "Scadute",
    tableCategory: "Categoria",
    tableExpiringSoon: "In scadenza",
    tableExpired: "Scadute",
    tabEquipment: "Attrezzature",
    tabAlerts: "Scadenze",
    tabSummary: "Riepilogo",
    pageTitle: "Manutenzione attrezzatura",
    pageSubtitle: "Gestisci l'attrezzatura del centro e i piani di manutenzione",
    noCenterAssociated: "Nessun centro associato al tuo account.",
  },
  wizDcOnboard: {
    stepCenter: "Il centro",
    stepLocation: "Posizione",
    stepContacts: "Contatti",
    stepServices: "Servizi",
    stepSummary: "Riepilogo",
    countryIt: "Italia",
    countryEg: "Egitto",
    countryMv: "Maldive",
    countryTh: "Thailandia",
    countryId: "Indonesia",
    countryPh: "Filippine",
    countryHr: "Croazia",
    countryGr: "Grecia",
    countryEs: "Spagna",
    countryPt: "Portogallo",
    countryMt: "Malta",
    countryCy: "Cipro",
    countryMx: "Messico",
    countryBz: "Belize",
    countryAu: "Australia",
    countryZa: "Sudafrica",
    countryTr: "Turchia",
    countryFr: "Francia",
    countryDe: "Germania",
    countryGb: "UK",
    svcEquipmentRental: "Noleggio attrezzatura",
    svcGuidedDives: "Immersioni guidate",
    svcCourses: "Corsi certificati",
    svcBoatDiving: "Boat diving",
    svcShoreDiving: "Shore diving",
    svcNitrox: "Nitrox / EAN",
    svcTrimix: "Trimix / Gas tecnici",
    svcRebreather: "Rebreather (CCR/SCR)",
    svcFreediving: "Apnea / Freediving",
    svcSnorkeling: "Snorkeling",
    svcPhotography: "Fotografia subacquea",
    svcNightDiving: "Immersioni notturne",
    svcLiveaboard: "Liveaboard",
    svcDivemasterProgram: "Programma Divemaster",
    svcRescueDiving: "Rescue Diving",
    svcTransfer: "Transfer e navette",
    svcAccommodation: "Alloggio",
    svcPool: "Piscina interna",
    nameLabel: "Nome del centro *",
    namePlaceholder: "Es. Blue Abyss Dive Center",
    structureTypeLabel: "Tipo struttura",
    typeDiveCenter: "Dive Center",
    typeDiveCenterDesc: "Centro con sede fissa, noleggio, corsi",
    typeDiveResort: "Dive Resort",
    typeDiveResortDesc: "Resort con servizi sub integrati",
    typeAssociation: "Associazione",
    typeAssociationDesc: "ASD/APS/ODV con gestione soci",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Racconta il tuo centro: esperienza, punti di forza, cosa vi distingue dagli altri…",
    associationTypeLabel: "Tipo associazione",
    selectOption: "Seleziona…",
    assocAsd: "ASD — Sportiva Dilettantistica",
    assocAps: "APS — Promozione Sociale",
    assocOdv: "ODV — Volontariato",
    assocOther: "Altra forma associativa",
    fiscalCodeLabel: "Codice Fiscale associazione",
    membershipFeeLabel: "Quota associativa annua (€)",
    membershipFeePlaceholder: "es. 30.00",
    foundedYearLabel: "Anno fondazione",
    foundedYearPlaceholder: "es. 1985",
    licenseLabel: "Numero licenza / PIVA (opzionale)",
    countryLabel: "Paese *",
    selectDash: "— seleziona —",
    countryOther: "Altro",
    cityLabel: "Città *",
    cityPlaceholder: "Es. Sharm el Sheikh",
    addressLabel: "Indirizzo",
    addressPlaceholder: "Via / Street, numero civico",
    latitudeLabel: "Latitudine",
    longitudeLabel: "Longitudine",
    coordsHint: "Le coordinate permettono ai subacquei di trovare il centro sulla mappa. Puoi lasciarle vuote e aggiungerle in seguito.",
    phoneLabel: "Telefono *",
    whatsappLabel: "WhatsApp",
    emailLabel: "Email di contatto",
    websiteLabel: "Sito web",
    contactsHint: "Il telefono è l'unico campo obbligatorio — gli altri puoi completarli in seguito dalla dashboard del centro.",
    servicesHint: "Seleziona i servizi che il tuo centro offre. Verranno mostrati nel profilo pubblico e usati nei filtri di ricerca.",
    summaryName: "Nome",
    summaryType: "Tipo",
    summaryLocation: "Posizione",
    summaryAddress: "Indirizzo",
    summaryPhone: "Telefono",
    summaryEmail: "Email",
    summaryWebsite: "Sito web",
    notSpecifiedM: "Non specificato",
    notSpecifiedF: "Non specificata",
    servicesSelected: "Servizi selezionati ({{count}})",
    successHintPre: "Dopo la creazione avrai accesso alla",
    successHintBold: "dashboard completa",
    successHintPost: "del centro con gestione prenotazioni, corsi, staff, attrezzatura e clienti.",
    toastCreated: "Centro creato! Benvenuto nella dashboard.",
    toastError: "Errore nella creazione del centro",
    title: "Configura il tuo centro diving",
    subtitle: "Crea il profilo del centro e inizia ad accogliere i subacquei",
    finalLabel: "Crea il centro",
  },
  dcEvents: {
    statusDraft: "Bozza",
    statusPublished: "Pubblicato",
    statusCancelled: "Annullato",
    statusCompleted: "Concluso",
    toastEventUpdated: "Evento aggiornato",
    toastEventCreated: "Evento creato",
    toastSaveError: "Errore nel salvataggio",
    toastUploadFailed: "Upload fallito",
    editEvent: "Modifica evento",
    newEvent: "Nuovo evento",
    labelTitle: "Titolo *",
    labelType: "Tipo *",
    labelLocation: "Luogo",
    placeholderLocation: "Es. Porto di Mergellina",
    labelStart: "Inizio *",
    labelEnd: "Fine",
    labelMaxParticipants: "Max partecipanti",
    placeholderUnlimited: "Illimitato",
    labelFee: "Quota (€)",
    placeholderFree: "Gratuito",
    labelShortDescription: "Breve descrizione",
    placeholderShortDescription: "Riepilogo per la lista eventi…",
    labelHtmlBody: "Corpo HTML",
    edit: "Modifica",
    preview: "Anteprima",
    noContent: "Nessun contenuto",
    placeholderHtmlBody: "<p>Descrizione dettagliata in HTML…</p>",
    labelCoverImage: "Immagine di copertina",
    remove: "Rimuovi",
    uploading: "Caricamento…",
    uploadImage: "Carica immagine",
    publiclyVisible: "Visibile pubblicamente",
    cancel: "Annulla",
    saving: "Salvataggio…",
    update: "Aggiorna",
    createEvent: "Crea evento",
    toastFeedbackSent: "Feedback inviato",
    toastFeedbackError: "Errore invio feedback",
    ratings: "Valutazioni",
    ratingsAverage: "· media {{avg}}/5 ({{total}})",
    leaveRating: "Lascia una valutazione",
    placeholderOptionalComment: "Commento opzionale…",
    sending: "Invio…",
    send: "Invia",
    toastEventPublished: "Evento pubblicato — email ai soci inviata",
    toastPublishError: "Errore nella pubblicazione",
    toastEventCancelled: "Evento annullato",
    toastCancelError: "Errore annullamento",
    toastEventDeleted: "Evento eliminato",
    toastDeleteError: "Errore eliminazione",
    maxCount: "max {{count}}",
    confirmPublish: "Pubblicare l'evento? Verrà inviata un'email ai soci.",
    publish: "Pubblica",
    confirmDelete: "Eliminare questo evento?",
    delete: "Elimina",
    confirmCancel: "Annullare questo evento?",
    cancelEvent: "Annulla evento",
    lessDetails: "Meno dettagli",
    readMore: "Leggi di più",
    past: "Passati",
    upcoming: "Prossimi",
    noPastEvents: "Nessun evento passato",
    noUpcomingEvents: "Nessun evento in programma",
    createFirstEvent: "Crea il primo evento",
  },
  bioMissions: {
    statusDraft: "Bozza",
    statusOpen: "Aperta",
    statusActive: "Attiva",
    statusClosed: "Chiusa",
    statusArchived: "Archiviata",
    startLabel: "Inizio: {{date}}",
    endLabel: "Fine: {{date}}",
    volunteersLabel: "Volontari: {{count}}{{max}}",
    detail: "Dettaglio",
    results: "Risultati",
    newMission: "Nuova missione",
    newMonitoringMission: "Nuova missione di monitoraggio",
    titlePlaceholder: "Titolo *",
    descriptionPlaceholder: "Descrizione",
    startDate: "Data inizio",
    endDate: "Data fine",
    maxVolunteers: "Max volontari",
    protocolFields: "Campi protocollo",
    addField: "Aggiungi campo",
    keyPlaceholder: "Chiave",
    labelPlaceholder: "Etichetta",
    typeText: "Testo",
    typeNumber: "Numero",
    typeSelect: "Selezione",
    typeBoolean: "Sì/No",
    saving: "Salvataggio...",
    createMission: "Crea missione",
    cancel: "Annulla",
    createError: "Errore durante la creazione.",
    pageTitle: "Missioni di Monitoraggio",
    pageSubtitle: "Partecipa a ricerche scientifiche sui fondali marini",
    guidedJoin: "Partecipa guidato",
    browseMissions: "Sfoglia missioni",
    myMissions: "Le mie missioni",
    loading: "Caricamento...",
    loadError: "Errore nel caricamento delle missioni. Controlla la connessione e riprova.",
    missionsFound: "{{total}} missioni trovate",
    emptyBrowseTitle: "Nessuna missione aperta al momento",
    emptyBrowseBody: "Le missioni di monitoraggio vengono pubblicate dagli istituti accademici certificati su eDive. Torna a controllare presto o iscriviti a un istituto per partecipare.",
    reload: "Ricarica",
    emptyMineTitle: "Non hai ancora creato missioni",
    emptyMineBody: "Usa il form qui sopra per creare la tua prima missione di monitoraggio scientifico.",
  },
  wizDoctor: {
    stepDatiProfessionali: "Dati professionali",
    stepSpecializzazioni: "Specializzazioni",
    stepStudioSede: "Studio e sede",
    stepDisponibilita: "Disponibilità",
    dataIntro1: "Questi dati vengono mostrati nella",
    dataIntroStrong: "directory medici subacquei",
    dataIntro2: "di eDive e servono a verificare la tua qualifica professionale.",
    licenseNumberLabel: "Numero iscrizione Albo / Licenza *",
    licenseNumberPlaceholder: "Es. RM-12345 / FMF-98765",
    licenseCountryLabel: "Paese dell'Albo *",
    selectPlaceholder: "— seleziona —",
    otherOption: "Altro",
    licenseExpiresLabel: "Scadenza licenza",
    institutionLabel: "Struttura / Istituzione",
    institutionPlaceholder: "Es. Ospedale San Raffaele, Studio Medico Rossi…",
    specializationsLabel: "Specializzazioni mediche",
    specializationsHint: "Aggiungi le tue aree di competenza rilevanti per la medicina subacquea.",
    specializationsPlaceholder: "Es. Medicina iperbarica…",
    bioLabel: "Presentazione professionale",
    bioPlaceholder: "Descrivi la tua esperienza e approccio — apparirà nella tua scheda sulla directory medici. Es. anni di esperienza, approccio clinico, lingue parlate…",
    bioCharCount: "{{n}}/1000 caratteri",
    cityLabel: "Città *",
    cityPlaceholder: "Roma",
    countryLabel: "Paese *",
    addressLabel: "Indirizzo studio (opzionale)",
    addressPlaceholder: "Via Roma 1, Milano",
    addressHint: "Mostrato solo ai pazienti che hai accettato.",
    comingSoonStrong: "Prossimamente:",
    comingSoonText: "potrai caricare il logo dello studio e la foto del profilo professionale direttamente da qui.",
    visibilityLabel: "Visibilità nella directory",
    visiblePublicLabel: "Visibile a tutti",
    visiblePublicDesc: "Appari nella directory medici pubblica di eDive — i subacquei possono trovarti e richiedere una visita.",
    visiblePrivateLabel: "Profilo non pubblico",
    visiblePrivateDesc: "Non appari nella directory. Puoi comunque accettare pazienti tramite invito diretto.",
    acceptPatientsLabel: "Accettazione nuovi pazienti",
    acceptYesLabel: "Accetto nuovi pazienti",
    acceptNoLabel: "Non disponibile",
    acceptPatientsHint: "Puoi cambiare questa impostazione in qualsiasi momento dal tuo pannello medico.",
    afterCompletionStrong: "Dopo il completamento",
    afterCompletionText: "il tuo profilo sarà visibile nella directory e riceverai richieste di visite di idoneità da subacquei nella tua area.",
    title: "Configura il profilo medico",
    subtitle: "Rendi visibile la tua specializzazione alla community subacquea",
    finalLabel: "Pubblica profilo medico",
    saveSuccess: "Profilo medico configurato!",
    saveError: "Errore nel salvataggio",
  },
  bulkUpload: {
    stepDone: "Completato",
    statusQueued: "In coda",
    statusProcessing: "Elaborazione",
    statusEnriched: "Arricchito",
    statusPublished: "Pubblicato",
    statusFailed: "Fallito",
    dropzoneTitle: "Trascina le foto qui, o clicca per selezionarle",
    dropzoneHint: "JPEG, PNG, WebP — fino a 100 immagini per sessione",
    locationLabel: "Luogo (opzionale)",
    locationPlaceholder: "es. Reef Maldive Atollo Sud",
    depthLabel: "Profondità m (opzionale)",
    depthPlaceholder: "es. 18",
    notesLabel: "Note (opzionale)",
    notesPlaceholder: "Condizioni, comportamento, ecc.",
    photosSelected: "{{count}} foto selezionate",
    removeAll: "Rimuovi tutte",
    startRecognition: "Avvia riconoscimento su {{count}} foto",
    uploading: "Caricamento in corso…",
    uploadProgress: "{{progress}} / {{total}} foto caricate",
    drawerSubtitle: "Dati estratti dalla pipeline",
    loadingData: "Caricamento dati…",
    noCandidates: "Nessun candidato rilevato",
    taxonomy: "Tassonomia",
    noSpeciesData: "Dati non disponibili per questa specie",
    fieldCommonName: "Nome comune",
    fieldFamily: "Famiglia",
    fieldOrder: "Ordine",
    fieldClass: "Classe",
    fieldMaxLength: "Lunghezza max",
    fieldDepth: "Profondità",
    fieldHabitat: "Habitat",
    fieldCommercialImportance: "Importanza comm.",
    fieldVulnerability: "Vulnerabilità",
    fieldMaxAge: "Età max",
    yearsValue: "{{count}} anni",
    noIucnStatus: "Status IUCN non disponibile",
    populationTrend: "TENDENZA POPOLAZIONE",
    iucnId: "ID IUCN",
    submissionMetadata: "Metadati invio",
    metaLocation: "Luogo",
    metaDepth: "Profondità",
    metaSource: "Sorgente",
    metaCompleted: "Completato",
    metaNotes: "Note",
    duplicateImage: "Immagine duplicata",
    duplicateImageBody: "Questa foto è già presente nell'enciclopedia (pHash / SHA-256 corrispondente). Non verrà aggiunta di nuovo per evitare duplicati.",
    duplicateOriginal: "Originale: {{id}}",
    imagePreview: "Anteprima immagine",
    imageNotAvailable: "Immagine non ancora disponibile",
    identifiedSpecies: "Specie identificata",
    speciesNotIdentified: "Specie non ancora identificata",
    inatConfidence: "Confidenza iNat",
    statusLabel: "Stato",
    duplicateLabel: "Duplicata",
    duplicateYes: "Sì — già presente",
    duplicateNo: "No",
    errorLabel: "Errore",
    discard: "Scarta",
    duplicateInEncyclopedia: "Duplicata — già nell'enciclopedia",
    includeInEncyclopedia: "Includi nell'enciclopedia",
    clickToPreview: "Clicca per anteprima",
    duplicateBadge: "Duplicata",
    viewPipelineData: "Vedi dati estratti dalla pipeline",
    details: "Dettagli",
    preview: "Anteprima",
    alreadyPresent: "Già presente",
    include: "Includi",
    included: "Inclusa",
    summaryTotal: "Totale",
    summaryQueued: "In coda",
    summaryProcessing: "Elaborazione",
    summaryEnriched: "Arricchiti",
    summaryPublished: "Pubblicati",
    summaryFailed: "Falliti",
    percentComplete: "{{pct}}% completato",
    errorLoadDetails: "Impossibile caricare i dettagli",
    errorUpload: "Errore nel caricamento",
    errorConnectionLost: "Connessione interrotta — ricarica la pagina se il problema persiste",
    errorPublish: "Errore nella pubblicazione",
    errorGeneric: "Errore",
    noNewImages: "Nessuna immagine nuova da includere",
    photosIncluded: "{{count}} foto incluse nell'enciclopedia",
    pageTitle: "Caricamento Massivo Foto",
    pageSubtitle: "Contribuisci all'Enciclopedia Marina — carica molte immagini e lascia che l'AI le identifichi",
    step1: "1. Carica",
    step2: "2. Invio",
    step3: "3. Console",
    step4: "4. Pubblica",
    filterAll: "Tutti",
    filterQueued: "In coda",
    filterProcessing: "Elaborazione",
    filterEnriched: "Arricchiti",
    filterPublished: "Pubblicati",
    filterFailed: "Falliti",
    autoRefresh: "Aggiornamento automatico",
    includeAll: "Includi tutti ({{count}})",
    colFileSpecies: "File / Specie identificata",
    colAction: "Azione",
    noJobsFound: "Nessun job trovato — il batch è ancora in caricamento…",
    noJobsWithStatus: "Nessun job con stato \"{{status}}\"",
    processingComplete: "Elaborazione completata",
    processingSummary: "{{published}} foto incluse nell'enciclopedia · {{failed}} fallite · {{enriched}} in attesa di conferma",
    goToEncyclopedia: "Vai all'enciclopedia",
    newUpload: "Nuovo caricamento",
  },
  speciesId: {
    iucnExDesc: "Estinto",
    iucnExExpl: "La specie non esiste più in natura.",
    iucnCrDesc: "Criticamente in pericolo",
    iucnCrExpl: "Rischio di estinzione estremamente elevato.",
    iucnEnDesc: "In pericolo",
    iucnEnExpl: "Rischio di estinzione molto elevato in natura.",
    iucnVuDesc: "Vulnerabile",
    iucnVuExpl: "Rischio elevato se le condizioni non migliorano.",
    iucnNtDesc: "Quasi minacciato",
    iucnNtExpl: "Vicino alla soglia di rischio, ma attualmente stabile.",
    iucnLcDesc: "Minor preoccupazione",
    iucnLcExpl: "Specie abbondante con ampia distribuzione.",
    iucnDdDesc: "Dati insufficienti",
    iucnDdExpl: "Non ci sono dati sufficienti per valutarne il rischio.",
    iucnNeDesc: "Non valutato",
    iucnNeExpl: "La specie non è ancora stata valutata dall'IUCN.",
    confHigh: "Alta",
    confMedium: "Media",
    confLow: "Bassa",
    morphShape: "Forma",
    morphShapeElongated: "corpo allungato",
    morphShapeFlattened: "corpo appiattito",
    morphShapeOval: "corpo ovale",
    morphShapeSerpentine: "forma serpentiforme",
    morphShapeStocky: "corpo tozzo",
    morphColors: "Colori",
    morphColorRedOrange: "rosso/arancio",
    morphColorBlue: "blu/azzurro",
    morphColorGrayWhite: "grigio/bianco",
    morphColorCamouflage: "mimetico/maculato",
    morphColorStriped: "a strisce",
    morphSize: "Dimensioni",
    morphSizeUnder10: "meno di 10 cm",
    morphSize10to30: "10-30 cm",
    morphSize30to60: "30-60 cm",
    morphSizeOver60: "oltre 60 cm",
    morphFeatures: "Caratteristiche",
    morphFeatureFanFins: "pinne a ventaglio",
    morphFeatureVenomousSpines: "spine velenose",
    morphFeatureVisibleSuckers: "ventose visibili",
    morphFeatureShell: "guscio",
    morphFeatureTentacles: "tentacoli",
    morphFeatureBigEyes: "occhi grandi",
    morphHabitat: "Habitat",
    morphHabitatSandy: "fondale sabbioso",
    morphHabitatRockCave: "roccia e grotta",
    morphHabitatPosidonia: "prateria posidonia",
    morphHabitatWaterColumn: "colonna d'acqua",
    morphHabitatCoral: "corallo",
    morphBehavior: "Comportamento",
    morphBehaviorSolitary: "solitario",
    morphBehaviorLargeSchool: "in banco numeroso",
    morphBehaviorHides: "si nasconde",
    morphBehaviorSwimsFast: "nuota veloce",
    morphBehaviorStillOnBottom: "immobile sul fondo",
    zoneLittoral: "Litoranea",
    zonePhotic: "Fotica",
    zoneMesophotic: "Mesofotica",
    zoneBathyal: "Batiale",
    stepWhatSeen: "Cosa hai visto",
    stepWhereWhen: "Dove e quando",
    stepResult: "Risultato",
    errSelectImage: "Seleziona un file immagine (JPG, PNG, WEBP)",
    errImageTooLarge: "Immagine troppo grande (max 20 MB)",
    errUploadFailedUseText: "Caricamento fallito — usa la descrizione testuale",
    errGeoUnavailable: "Geolocalizzazione non disponibile",
    errPositionUnavailable: "Posizione non disponibile",
    errSpeciesNotRecognized: "Specie non riconosciuta. Prova con una descrizione testuale.",
    errIdentFailedRetry: "Identificazione fallita. Riprova.",
    pageTitle: "Identifica una specie",
    pageSubtitle: "Scatta una foto o descrivi ciò che hai visto — l'AI fa il resto",
    modeUploadPhoto: "Carica foto",
    modeDescribeWords: "Descrivi a parole",
    dropzoneText: "Trascina qui la foto o clicca per sfogliare",
    dropzoneHint: "JPG, PNG, WEBP · max 20 MB",
    previewAlt: "Anteprima",
    uploadingInProgress: "Caricamento in corso…",
    photoReady: "Foto pronta",
    uploadFailed: "Caricamento fallito",
    photoSavedNote: "La tua foto viene salvata nella libreria personale e potrà contribuire all'enciclopedia eDive",
    descPlaceholder: "Es. Pesce con corpo appiattito, colorazione rossastra, pinne pettorali a ventaglio, circa 30 cm…",
    charCount: "{{count}} caratteri",
    charMinHint: "(minimo 10)",
    guideToggle: "Guida: cosa osservare e descrivere",
    guideClickHint: "Clicca un termine per aggiungerlo alla descrizione:",
    nextAddContext: "Avanti: aggiungi contesto",
    locationLabel: "Luogo dell'avvistamento",
    optional: "(opzionale)",
    locationPlaceholder: "Es. Mar Adriatico, Canale di Sicilia, Capri…",
    useCurrentPosition: "Usa posizione attuale",
    positionBtn: "Posizione",
    diveDateLabel: "Data dell'immersione",
    estimatedDepth: "Profondità stimata",
    zonePrefix: "Zona",
    zoneDescBathyal: "scarsa luce solare, specie adattate al buio",
    zoneDescMesophotic: "luce ridotta, alta biodiversità",
    zoneDescPhotic: "zona fotosintetica, ricca di vita",
    zoneDescLittoral: "zona costiera superficiale",
    back: "Indietro",
    waitingPhotoUpload: "Attendo caricamento foto…",
    identifyWithAI: "Identifica con AI",
    skipContextHint: "Puoi anche saltare il contesto — aiuta l'AI a essere più precisa",
    analysisInProgress: "Analisi in corso…",
    analysisPhotoNote: "Confronto la foto con il database iNaturalist (Computer Vision)",
    analysisTextNote: "Sto analizzando la descrizione con il modello AI locale (Ollama)",
    speciesNotIdentified: "Specie non identificata",
    errRetryMoreDetail: "Riprova con una descrizione più dettagliata o un'immagine più nitida.",
    restart: "Ricomincia",
    tryWithText: "Prova con testo",
    tryWithPhoto: "Prova con foto",
    identifiedSpecies: "Specie identificata",
    identConfidence: "Confidenza identificazione",
    sightingsInEdive: "Avvistamenti in eDive",
    last5Years: "ultimi 5 anni",
    mainFeatures: "Caratteristiche principali",
    inatSourceNote: "Identificazione tramite iNaturalist Computer Vision · Aggiunge informazioni all'enciclopedia della comunità",
    youMightHaveSeen: "Potresti aver visto anche",
    encyclopedia: "Enciclopedia",
    askAI: "Chiedi all'AI",
    recordSighting: "Registra avvistamento",
    newIdentification: "Nuova identificazione",
    contributeToEncyclopedia: "Contribuisci all'enciclopedia scientifica",
    newBadge: "NUOVO",
    recentIdentifications: "Ultime identificazioni",
    photoContribution: "Contributo foto",
  },
  cylinders: {
    add: "Nuova certificazione",
    certifiedAt: "Data collaudo",
    certifiedOn: "Collaudata",
    emptyDesc: "Aggiungi i collaudi delle tue bombole per non perdere le scadenze.",
    emptyTitle: "Nessuna certificazione registrata",
    expires: "scade",
    expiresAt: "Scadenza",
    info: "Tieni traccia delle scadenze di collaudo delle tue bombole. La legge richiede collaudi periodici obbligatori.",
    saved: "Certificazione salvata",
    serial: "Matricola bombola",
    subtitle: "Collaudi e ispezioni con le relative scadenze",
    testingBody: "Ente collaudatore",
    title: "Certificazioni bombole",
    type: "Tipo",
  },
  gasDeco: {
    addGas: "Nuova miscela",
    avgBottom: "media/immersione",
    byMonth: "Per mese",
    computersEmptyDesc: "Collega il tuo dive computer per importare automaticamente le immersioni.",
    computersEmptyTitle: "Nessun computer collegato",
    computersIntro: "I tuoi dive computer collegati per la sincronizzazione automatica delle immersioni.",
    decoEmptyDesc: "I profili di decompressione appariranno qui dopo la sincronizzazione dei tuoi computer subacquei.",
    decoEmptyTitle: "Nessun profilo deco",
    decoIntro: "Profili di decompressione derivati dalle tue immersioni o configurati manualmente.",
    diveCount: "immersioni",
    gasEmptyDesc: "Aggiungi le tue miscele nitrox o trimix per riusarle rapidamente.",
    gasEmptyTitle: "Nessuna miscela salvata",
    gasIntro: "Le tue miscele riutilizzabili nella pianificazione e nella registrazione delle immersioni.",
    gasName: "Nome",
    gasSaved: "Miscela salvata",
    gasType: "Tipo",
    info: "Gestisci le miscele riutilizzabili, i profili di decompressione e i dispositivi collegati al tuo logbook.",
    lastSync: "ultimo sync",
    maxBottom: "più lunga",
    neverSynced: "mai sincronizzato",
    statsEmptyDesc: "Registra le tue immersioni per vedere le statistiche del tempo di fondo.",
    statsEmptyTitle: "Ancora nessun dato",
    statsIntro: "Il tempo totale trascorso sott'acqua, aggregato dalle tue immersioni.",
    subtitle: "Miscele gas, profili di decompressione e computer subacquei",
    sync: "Sincronizza",
    syncStarted: "Sincronizzazione avviata",
    tabComputers: "Computer",
    tabDeco: "Profili deco",
    tabGas: "Miscele gas",
    tabStats: "Statistiche",
    title: "Attrezzatura tecnica",
    totalHours: "ore totali",
  },
  twofa: {
    codesRemaining: "codici disponibili",
    deviceRevoked: "Dispositivo revocato",
    enable: "Attiva",
    enabled: "Attivo",
    info: "Il secondo fattore aggiunge un livello di sicurezza: anche se qualcuno conosce la tua password, non potrà accedere senza il tuo dispositivo.",
    lastUsed: "ultimo uso",
    neverUsed: "mai usata",
    newCodesTitle: "Nuovi codici di recupero",
    newCodesWarn: "Conserva questi codici in un luogo sicuro. Non saranno più mostrati.",
    noPasskeys: "Nessuna passkey registrata.",
    noTrusted: "Nessun dispositivo fidato.",
    otpauthUri: "URI otpauth",
    passkey: "Passkey",
    passkeys: "Passkey (WebAuthn)",
    passkeysDesc: "Accesso con impronta, volto o chiave di sicurezza",
    recoveryCodes: "Codici di recupero",
    regenerate: "Rigenera",
    savedCodes: "Li ho salvati",
    setupError: "Errore durante il setup",
    setupStep1: "Apri la tua app di autenticazione e aggiungi un nuovo account usando questo codice:",
    setupStep2: "Poi inserisci il codice a 6 cifre generato dall'app nella schermata di verifica per completare l'attivazione.",
    setupTitle: "Configura l'app di autenticazione",
    subtitle: "Proteggi il tuo account con un secondo fattore",
    title: "Autenticazione a due fattori",
    totp: "App di autenticazione (TOTP)",
    totpDesc: "Google Authenticator, Authy, ecc.",
    trustedDevices: "Dispositivi fidati",
  },
  fitnessPage: {
    apneaFitness: "Idoneità apnea",
    assessedOn: "Valutata il",
    emergency: "Emergenza",
    emptyApnea: "Nessuna valutazione apnea",
    emptyApneaDesc: "Le valutazioni di idoneità all'apnea appariranno qui.",
    emptyFitness: "Nessuna valutazione di idoneità",
    emptyFitnessDesc: "Le valutazioni di idoneità subacquea emesse dal tuo medico appariranno qui.",
    emptyHyper: "Nessun referral iperbarico",
    emptyHyperDesc: "Eventuali invii a camera iperbarica appariranno qui.",
    expired: "Scaduta",
    info: "Qui trovi le valutazioni di idoneità emesse dal tuo medico subacqueo. Solo un professionista sanitario può crearle.",
    nonUrgent: "Non urgente",
    referral: "Referral iperbarico",
    scuba: "Idoneità subacquea",
    subtitle: "Valutazioni di idoneità subacquea, apnea e referral iperbarici",
    tabApnea: "Apnea",
    tabFitness: "Idoneità subacquea",
    tabHyper: "Iperbarico",
    targetDepth: "profondità obiettivo",
    title: "Idoneità medica",
    urgent: "Urgente",
    validUntil: "valida fino al",
  },
  medCerts: {
    add: "Carica certificato",
    attach: "Foto o PDF del certificato",
    attachHint: "JPEG, PNG, WebP o PDF, max 8 MB.",
    confirmBody: "Stai per eliminare il certificato del",
    confirmIrreversible: "L'operazione non è reversibile.",
    confirmTitle: "Eliminare il certificato?",
    deleted: "Certificato eliminato",
    deleteError: "Errore durante l'eliminazione",
    empty: "Nessun certificato caricato.",
    emptyHint: "Carica il tuo certificato di idoneità per averlo sempre a portata di mano.",
    expires: "scade",
    intro: "Carica qui il certificato che attesta la tua idoneità all'attività subacquea. Puoi allegare la foto o il PDF, tenerne lo storico e mostrarlo al centro immersioni quando serve.",
    issued: "Rilasciato",
    noDoc: "Nessun documento",
    saved: "Certificato salvato",
    saveError: "Errore nel salvataggio",
    statusExpired: "Scaduto",
    statusExpiring: "In scadenza",
    statusValid: "Valido",
    title: "Certificato medico di idoneità",
    view: "Vedi",
    viewError: "Impossibile aprire il documento",
  },
  polls: {
    emptyDesc: "Al momento non ci sono sondaggi. Torna presto!",
    emptyTitle: "Nessun sondaggio attivo",
    info: "Partecipa ai sondaggi della community: il tuo voto conta e i risultati sono in tempo reale.",
    subtitle: "Vota e scopri cosa pensa la community subacquea",
    title: "Sondaggi della community",
    voted: "Voto registrato",
    votes: "voti",
  },
  buddyPicker: {
    searchPlaceholder: "Cerca un subacqueo o scrivi un nome…",
    addAsName: "Aggiungi \"{{name}}\"",
  },
  dcExc: {
    book: "Prenota",
    bookCancelled: "Prenotazione annullata",
    bookError: "Prenotazione non riuscita",
    booked: "Prenotazione effettuata",
    bookingsCount: "prenotazioni",
    cancel: "Annulla escursione",
    cancelBooking: "Annulla prenotazione",
    cancelReason: "Motivo dell'annullamento?",
    cancelReasonDefault: "Annullata dal centro",
    cancelled: "Escursione annullata",
    duration: "Durata",
    equipIncluded: "Attrezzatura inclusa",
    free: "Gratis",
    isPublished: "Pubblicata: visibile e prenotabile dai subacquei.",
    manage: "Gestione centro",
    maxDivers: "Posti",
    minCert: "Brevetto min.",
    notBookable: "Non ancora disponibile per la prenotazione.",
    notFound: "Escursione non trovata o non più disponibile.",
    price: "Prezzo",
    publish: "Pubblica escursione",
    publishError: "Pubblicazione non riuscita",
    published: "Escursione pubblicata",
    site: "Sito",
    when: "Quando",
    youBooked: "Sei prenotato per questa escursione",
  },
  mediaDropzone: {
    label: "Trascina qui o clicca per scegliere",
  },
  mediaUpload: {
    errFailed: "Caricamento fallito. Riprova.",
    errType: "Tipo di file non supportato.",
    errSize: "File troppo grande (max {{mb}} MB).",
  },
  quickLog: {
    repeatLast: "Ripeti ultima",
  },
  status: {
    running: "In esecuzione",
    done: "Completata",
    imported: "Importata",
    sent: "Inviata",
    queued: "In coda",
    bounced: "Rimbalzata",
    skipped: "Saltata",
    revoked: "Revocata",
    verified: "Verificata",
    pending_email_verification: "Email da verificare",
    minor: "Lieve",
    moderate: "Moderata",
    serious: "Grave",
    major: "Maggiore",
    critical: "Critica",
    low: "Bassa",
    medium: "Media",
    high: "Alta",
    pending: "In attesa",
    requested: "Richiesta",
    confirmed: "Confermata",
    accepted: "Accettata",
    approved: "Approvata",
    active: "Attiva",
    open: "Aperta",
    published: "Pubblicata",
    paid: "Pagata",
    completed: "Completata",
    in_progress: "In corso",
    refunded: "Rimborsata",
    full: "Al completo",
    draft: "Bozza",
    closed: "Chiusa",
    withdrawn: "Ritirata",
    archived: "Archiviata",
    cancelled: "Annullata",
    canceled: "Annullata",
    declined: "Rifiutata",
    rejected: "Rifiutata",
    expired: "Scaduta",
    failed: "Fallita",
    pending_review: "In revisione",
    m: {
      done: "Completato",
      imported: "Importato",
      sent: "Inviato",
      bounced: "Rimbalzato",
      skipped: "Saltato",
      revoked: "Revocato",
      verified: "Verificato",
      requested: "Richiesto",
      confirmed: "Confermato",
      accepted: "Accettato",
      approved: "Approvato",
      active: "Attivo",
      open: "Aperto",
      published: "Pubblicato",
      paid: "Pagato",
      completed: "Completato",
      refunded: "Rimborsato",
      closed: "Chiuso",
      withdrawn: "Ritirato",
      archived: "Archiviato",
      cancelled: "Annullato",
      canceled: "Annullato",
      declined: "Rifiutato",
      rejected: "Rifiutato",
      expired: "Scaduto",
      failed: "Fallito",
      suspended: "Sospeso",
      resolved: "Risolto",
      sold: "Venduto",
      shipped: "Spedito",
      delivered: "Consegnato",
      enrolled: "Iscritto",
      retired: "Dismesso",
      reconciled: "Riconciliato",
    },
    under_review: "In revisione",
    suspended: "Sospesa",
    resolved: "Risolta",
    sold: "Venduta",
    shipped: "Spedita",
    delivered: "Consegnata",
    enrolled: "Iscritta",
    available: "Disponibile",
    maintenance: "In manutenzione",
    retired: "Dismessa",
    reconciled: "Riconciliata",
  },
  dcW3: {
    save: "Salva",
    saved: "Salvato",
    error: "Operazione non riuscita",
    remove: "Rimuovi",
    showDetails: "Dettagli",
    hideDetails: "Nascondi",
    rolesTitle: "Ruoli in acqua",
    rolesHint: "Assegna controllore e safety diver a chi è in uscita. Gli avvisi indicano cosa le regole segnalerebbero: non bloccano.",
    rolesNone: "Nessun controllore o safety diver assegnato.",
    rolesPerson: "Persona",
    rolesOther: "Altra persona (nome libero)",
    rolesFreeName: "Nome",
    rolesRole: "Ruolo",
    rolesAssign: "Assegna",
    rolesRemove: "Togli",
    roleAssigned: "Ruolo assegnato",
    role_CONTROLLER: "Controllore",
    role_SAFETY_DIVER: "Safety diver",
    warn_CONTROLLER_AND_GUIDE: "Una persona non può essere controllore e guida nella stessa immersione.",
    warn_STAFF_BELOW_MINIMUM: "Un gruppo con più di un partecipante richiede almeno due persone di staff.",
    warn_SAFETY_DIVER_RESCUE_MISSING: "Il safety diver non risulta avere un brevetto Rescue valido.",
    warn_CHECK_DIVE_MISSING: "Cliente da verificare con un check dive: non ne risulta uno registrato.",
    warn_unknown: "Avviso su una regola di sicurezza.",
    colExperience: "Esperienza e check dive",
    classesTitle: "Classi di esperienza",
    classesCount: "{{count}} classi",
    classesHint: "Le classi le definisci tu (codice, nome, se richiedono un check dive). Servono a segnalare i clienti da verificare sulle uscite profonde.",
    classCode: "Codice",
    classLabel: "Nome",
    classRequiresCheckDive: "Richiede check dive",
    classAdd: "Aggiungi classe",
    customerClass: "Classe di esperienza",
    classNone: "Nessuna classe",
    checkDiveRequired: "Da verificare con check dive",
    checkDivePending: "Check dive da fare",
    checkDiveRecord: "Registra check dive",
    checkDiveUndo: "Annulla",
    checkDiveDone: "Check dive fatto il {{date}}",
    incidentKind: "Tipo",
    kindIncident: "Incidente",
    kindNearMiss: "Quasi-incidente",
    nearMissHint: "Un quasi-incidente non ha gravità né obblighi di denuncia.",
    protocolTitle: "Primi passi dopo l’incidente",
    protocolHint: "Spunta ciò che è stato fatto: preservare le prove e non rilasciare dichiarazioni.",
    protocolMissing: "Voci ancora da completare: {{count}}",
    protocol_witnesses_recorded: "Testimoni annotati",
    protocol_equipment_not_disassembled: "Attrezzatura non smontata",
    protocol_cylinder_sealed: "Bombola sigillata",
    protocol_computer_untouched: "Computer non toccato",
    protocol_no_statements_given: "Nessuna dichiarazione rilasciata",
    linksTitle: "Riferimenti",
    linksHint: "Facoltativi: si salva solo l’identificativo, nulla viene copiato.",
    linkQaType: "Registro qualità",
    linkQaId: "ID nel registro qualità",
    linkSosId: "ID allarme SOS",
    linkEntry: "Uscita collegata",
    linkEntryNone: "— nessuna uscita —",
    linkEntryOpen: "Apri il foglio barca: {{name}}",
    entryIncidentsTitle: "Incidenti di questa uscita",
    entryIncidentsNone: "Nessun incidente collegato a questa uscita.",
    qaSafetyIncident: "Incidente (qualità)",
    qaNearMiss: "Quasi-incidente (qualità)",
    missingOpen: "Subacqueo disperso",
    missingOpenProcedure: "Procedura subacqueo disperso",
    missingBadge: "Subacqueo disperso",
    missingIncidentTitle: "Subacqueo disperso: {{name}}",
    missingIncidentDescription: "{{name}} non risulta rientrato all’appello.",
    missingTitle: "Procedura subacqueo disperso",
    missingDraftNotice: "Procedura in bozza, in attesa di revisione di un istruttore: usala come promemoria, non sostituisce il piano di emergenza.",
    missingSosLinked: "Allarme SOS collegato: {{id}}",
    missingName: "Nome del subacqueo",
    missingStart: "Avvia procedura",
    missingStarted: "Avviata il {{time}}",
    missingLastSeenAt: "Ultimo avvistamento",
    missingLastSeenNote: "Dove / note",
    missingSaveLastSeen: "Registra avvistamento",
    missingLastSeen: "Ultimo avvistamento: {{time}} {{note}}",
    missingStep_roll_call_repeated: "Appello nominale ripetuto",
    missingStep_last_seen_collected: "Ultimo avvistamento raccolto",
    missingStep_search_started: "Ricerca avviata",
    missingStep_emergency_services_alerted: "Soccorsi allertati",
    missingStep_other_boats_informed: "Altre imbarcazioni informate",
    missingStep_diver_located_or_handed_over: "Subacqueo ritrovato o ricerca affidata ai soccorsi",
    missingOutcome: "Esito",
    missingClose: "Chiudi procedura",
    missingClosed: "Chiusa il {{time}}: {{outcome}}",
    onboardTitle: "Sicurezza a bordo",
    onboardUpdated: "Aggiornato alle {{time}}",
    tanksSummary: "Bombole assegnate: {{total}} · collaudo scaduto: {{expired}} · in scadenza: {{dueSoon}}",
    hydro_EXPIRED: "collaudo scaduto",
    hydro_DUE_SOON: "collaudo in scadenza",
    hydro_OK: "collaudo in regola",
    hydro_UNKNOWN: "collaudo non registrato",
    kitOxygen: "Kit ossigeno",
    kitFirstAid: "Kit di primo soccorso",
    kitNever: "mai verificato",
    kitOverdue: "verifica scaduta (era entro il {{date}})",
    kitOk: "verificato, prossima entro il {{date}}",
    alarm_TANK_HYDRO_EXPIRED: "Una o più bombole assegnate hanno il collaudo scaduto.",
    alarm_OXYGEN_KIT_OVERDUE: "La verifica del kit ossigeno è scaduta.",
    alarm_OXYGEN_KIT_NEVER_CHECKED: "Il kit ossigeno non risulta mai verificato.",
    alarm_FIRST_AID_KIT_OVERDUE: "La verifica del kit di primo soccorso è scaduta.",
  },
  planCalc: {
    tab: "Calcolatori",
    disclaimer: "I risultati sono un semplice ausilio di pianificazione: non sostituiscono formazione, istruttore o computer subacqueo.",
    altitudeTitle: "Correzione per altitudine",
    bestMixTitle: "Miscela migliore (O2 massimo)",
    modEndTitle: "MOD ed END",
    groupTitle: "Gruppo con nitrox diversi",
    overheadTitle: "Grotta, relitto, ghiaccio",
    altitudeM: "Altitudine (m)",
    depthM: "Profondità (m)",
    o2Percent: "O2 (%)",
    hePercent: "He (%)",
    ppO2Limits: "Limiti di PO2 (bar, separati da virgola)",
    targetEnd: "END obiettivo (m)",
    calculate: "Calcola",
    mixName: "Nome miscela",
    addMix: "Aggiungi miscela",
    surfacePressure: "Pressione in superficie (bar)",
    equivalentDepth: "Profondità equivalente a livello del mare (m)",
    ndlSea: "NDL a livello del mare",
    ndlAlt: "NDL in quota",
    minutes: "min",
    modLabel: "MOD",
    endLabel: "END",
    bestO2: "O2 massimo",
    bestHe: "He",
    bestN2: "N2",
    notReachable: "END non raggiungibile con questi parametri",
    groupMod: "MOD del gruppo (la più bassa)",
    groupNdl: "NDL del gruppo (la più breve)",
    limitedBy: "Limitato da",
    exceedsMod: "Miscele oltre la propria MOD",
    environment: "Ambiente",
    envCave: "Grotta",
    envWreck: "Relitto",
    envIce: "Ghiaccio",
    penetration: "Penetrazione (m)",
    reserve: "Riserva di gas (%)",
    ppO2: "PO2 (bar)",
    pendingReview: "In attesa di revisione esperta",
    advisoryOnly: "Solo avvisi: nessun blocco",
    limitPending: "Limite non ancora fissato (in attesa di revisione esperta)",
    profile: "Standard di riferimento",
    profileNone: "Nessuno (limiti non impostati)",
    profileUnverified: "Valori non verificati sul testo ufficiale: controllarli sugli Standard in vigore prima di usarli.",
    profileSource: "Fonte",
    profileDefaultTitle: "Standard di riferimento predefinito",
    profileDefaultHint: "Lo staff del centro vede questo standard già selezionato nei calcolatori dei limiti per grotta, relitto e ghiaccio. Può cambiarlo caso per caso.",
    profileDefaultSaved: "Standard predefinito salvato",
    profileDefaultError: "Impossibile salvare lo standard predefinito",
    wDepth: "Profondità oltre il limite",
    wPenetration: "Penetrazione oltre il limite",
    wReserve: "Riserva sotto il limite",
    wPpO2: "PO2 oltre il limite",
    roundedNote: "Valori arrotondati per difetto al punto percentuale: verificare con l'analizzatore.",
    error: "Calcolo non riuscito. Controlla i valori inseriti.",
  },
  iucn: {
    lc: "Minima preoccupazione",
    nt: "Quasi minacciata",
    vu: "Vulnerabile",
    en: "In pericolo",
    cr: "In pericolo critico",
    dd: "Dati insufficienti",
    ew: "Estinta in natura",
    ex: "Estinta",
    ne: "Non valutata",
  },
}
